// @ts-nocheck
import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  Cursor: { input: any; output: any }
  Time: { input: any; output: any }
  UUID: { input: any; output: any }
}

export type ArAgingBucketsAmountResponse = {
  __typename: 'ARAgingBucketsAmountResponse'
  data: Array<BucketAmountData>
}

export type ArAgingBucketsCountResponse = {
  __typename: 'ARAgingBucketsCountResponse'
  data: Array<BucketCountData>
}

export type Account = {
  __typename: 'Account'
  companyName?: Maybe<Scalars['String']['output']>
  disconnectedAt?: Maybe<Scalars['String']['output']>
  hasAchAccountNumber?: Maybe<Scalars['Boolean']['output']>
  hasAchRoutingNumber?: Maybe<Scalars['Boolean']['output']>
  hasWireRoutingNumber?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  institution?: Maybe<Institution>
  mask?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  officialName?: Maybe<Scalars['String']['output']>
  provider?: Maybe<Scalars['String']['output']>
  subtype?: Maybe<Scalars['String']['output']>
  systemDeactivatedAt?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
}

export type AccountingPreferences = {
  __typename: 'AccountingPreferences'
  archiveZeroedInvoices: Scalars['Boolean']['output']
  contactsFromPrimary: Scalars['Boolean']['output']
  pdfFromPrimary: Scalars['Boolean']['output']
  pushPaymentsTo: PushPaymentsTo
  useIntegrationPDF: Scalars['Boolean']['output']
}

export type AccountingPreferencesUpdateInput = {
  archiveZeroedInvoices?: InputMaybe<Scalars['Boolean']['input']>
  contactsFromPrimary?: InputMaybe<Scalars['Boolean']['input']>
  pdfFromPrimary?: InputMaybe<Scalars['Boolean']['input']>
  pushPaymentsTo?: InputMaybe<PushPaymentsTo>
  useIntegrationPDF?: InputMaybe<Scalars['Boolean']['input']>
}

export type AccountingSyncBatch = {
  __typename: 'AccountingSyncBatch'
  createdAt: Scalars['String']['output']
  externalID: Scalars['String']['output']
  id: Scalars['ID']['output']
  numberOfInvoices: Scalars['Int']['output']
  platform: PlatformName
  status: AccountingSyncBatchStatus
}

export type AccountingSyncBatchCreateInput = {
  invoiceRelationIDs?: InputMaybe<Array<Scalars['String']['input']>>
  platformName: PlatformName
  platformNameTarget: PlatformName
}

export type AccountingSyncBatchCreateReply = {
  __typename: 'AccountingSyncBatchCreateReply'
  batch?: Maybe<AccountingSyncBatch>
  notSyncedInvoiceNumbers?: Maybe<Array<Scalars['String']['output']>>
}

export type AccountingSyncBatchEdge = {
  __typename: 'AccountingSyncBatchEdge'
  cursor: Scalars['Cursor']['output']
  node: AccountingSyncBatch
}

export enum AccountingSyncBatchStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING'
}

export type AccountingSyncJob = {
  __typename: 'AccountingSyncJob'
  billingTermData?: Maybe<AccountingSyncJobBillingTermData>
  customerData?: Maybe<AccountingSyncJobCustomerData>
  internalEntityID: Scalars['ID']['output']
  invoiceData?: Maybe<AccountingSyncJobInvoiceData>
  lineItemData?: Maybe<AccountingSyncJobLineItemData>
  paymentData?: Maybe<AccountingSyncJobPaymentData>
  status: AccountingSyncJobStatus
  type: AccountingSyncJobType
}

export type AccountingSyncJobBillingTermData = {
  __typename: 'AccountingSyncJobBillingTermData'
  billingTermName: Scalars['String']['output']
}

export type AccountingSyncJobCustomerData = {
  __typename: 'AccountingSyncJobCustomerData'
  customerName: Scalars['String']['output']
}

export type AccountingSyncJobInvoiceData = {
  __typename: 'AccountingSyncJobInvoiceData'
  amount: Scalars['Float']['output']
  customerName: Scalars['String']['output']
  dueDate: Scalars['String']['output']
  invoiceDate: Scalars['String']['output']
  invoiceNumber: Scalars['String']['output']
}

export type AccountingSyncJobLineItemData = {
  __typename: 'AccountingSyncJobLineItemData'
  lineItemName: Scalars['String']['output']
}

export type AccountingSyncJobPaymentData = {
  __typename: 'AccountingSyncJobPaymentData'
  amount: Scalars['Float']['output']
}

export enum AccountingSyncJobStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processed = 'PROCESSED'
}

export enum AccountingSyncJobType {
  BillingTermCreate = 'BILLING_TERM_CREATE',
  BillingTermUpdate = 'BILLING_TERM_UPDATE',
  CustomerCreate = 'CUSTOMER_CREATE',
  CustomerUpdate = 'CUSTOMER_UPDATE',
  InvoiceCreate = 'INVOICE_CREATE',
  InvoiceUpdate = 'INVOICE_UPDATE',
  ItemCreate = 'ITEM_CREATE',
  ItemUpdate = 'ITEM_UPDATE',
  PaymentCreate = 'PAYMENT_CREATE'
}

export type ActivationRateInvoiceVolumeByMonthData = {
  __typename: 'ActivationRateInvoiceVolumeByMonthData'
  month: Scalars['String']['output']
  value: Scalars['Float']['output']
}

export type ActivationRateInvoiceVolumeByMonthResponse = {
  __typename: 'ActivationRateInvoiceVolumeByMonthResponse'
  average: Scalars['Float']['output']
  data: Array<ActivationRateInvoiceVolumeByMonthData>
}

export type ActivationRatesByMonthResponse = {
  __typename: 'ActivationRatesByMonthResponse'
  average: Scalars['Float']['output']
  data: Array<DataPoint>
}

export type Address = AddressInterface & {
  __typename: 'Address'
  city?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  postalCode?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  streetAddress?: Maybe<Scalars['String']['output']>
  subPremise?: Maybe<Scalars['String']['output']>
}

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  countryISO?: InputMaybe<Scalars['String']['input']>
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  stateCode?: InputMaybe<Scalars['String']['input']>
  streetAddress?: InputMaybe<Scalars['String']['input']>
  subPremise?: InputMaybe<Scalars['String']['input']>
}

export type AddressInterface = {
  city?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  postalCode?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  streetAddress?: Maybe<Scalars['String']['output']>
  subPremise?: Maybe<Scalars['String']['output']>
}

export enum AdyenBusinessSetup {
  Organization = 'ORGANIZATION',
  SoleProprietorship = 'SOLE_PROPRIETORSHIP'
}

export enum AdyenCompanyType {
  AssociationIncorporated = 'ASSOCIATION_INCORPORATED',
  GovernmentalOrganization = 'GOVERNMENTAL_ORGANIZATION',
  ListedPublicCompany = 'LISTED_PUBLIC_COMPANY',
  NonProfit = 'NON_PROFIT',
  PartnershipIncorporated = 'PARTNERSHIP_INCORPORATED',
  PrivateCompany = 'PRIVATE_COMPANY'
}

export type AdyenOnboardingStatus = {
  __typename: 'AdyenOnboardingStatus'
  pciFormsSigned: Scalars['Boolean']['output']
  termsOfServiceAccepted: Scalars['Boolean']['output']
  tosAndPciEntitiesCreated: Scalars['Boolean']['output']
}

export enum AdyenOnboardingStatusStep {
  Concluded = 'CONCLUDED',
  None = 'NONE',
  Pending = 'PENDING'
}

export enum AdyenOwnerType {
  BankAccount = 'BANK_ACCOUNT',
  Individual = 'INDIVIDUAL',
  Partner = 'PARTNER'
}

export type AdyenPciForms = {
  __typename: 'AdyenPciForms'
  document: Scalars['String']['output']
  pciIds: Array<Scalars['String']['output']>
}

export enum AdyenRemediationActionType {
  AdyenRemediationActionTypeGenericMissingType = 'ADYEN_REMEDIATION_ACTION_TYPE_GENERIC_MISSING_TYPE',
  AdyenRemediationActionTypeUpdateBankAccountDetails = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_BANK_ACCOUNT_DETAILS',
  AdyenRemediationActionTypeUpdateIdNumberToSsn = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_ID_NUMBER_TO_SSN',
  AdyenRemediationActionTypeUpdateIndividualDetails = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_INDIVIDUAL_DETAILS',
  AdyenRemediationActionTypeUpdateIndustry = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_INDUSTRY',
  AdyenRemediationActionTypeUpdateMissingBankAccount = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_BANK_ACCOUNT',
  AdyenRemediationActionTypeUpdateMissingIndividualBirthData = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_INDIVIDUAL_BIRTH_DATA',
  AdyenRemediationActionTypeUpdateMissingIndividualCity = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_INDIVIDUAL_CITY',
  AdyenRemediationActionTypeUpdateMissingIndividualDateOfBirth = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_INDIVIDUAL_DATE_OF_BIRTH',
  AdyenRemediationActionTypeUpdateMissingIndividualEmail = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_INDIVIDUAL_EMAIL',
  AdyenRemediationActionTypeUpdateMissingIndividualIdentificationData = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_INDIVIDUAL_IDENTIFICATION_DATA',
  AdyenRemediationActionTypeUpdateMissingIndividualPostalCode = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_INDIVIDUAL_POSTAL_CODE',
  AdyenRemediationActionTypeUpdateMissingIndividualStateOrProvince = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_INDIVIDUAL_STATE_OR_PROVINCE',
  AdyenRemediationActionTypeUpdateMissingIndividualStreet = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_INDIVIDUAL_STREET',
  AdyenRemediationActionTypeUpdateMissingOrganizationRegistrationNumber = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_ORGANIZATION_REGISTRATION_NUMBER',
  AdyenRemediationActionTypeUpdateMissingOrganizationTaxId = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_ORGANIZATION_TAX_ID',
  AdyenRemediationActionTypeUpdateMissingOrganizationTaxInfo = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_ORGANIZATION_TAX_INFO',
  AdyenRemediationActionTypeUpdateMissingOrganizationType = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_ORGANIZATION_TYPE',
  AdyenRemediationActionTypeUpdateMissingPhoneNumber = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_PHONE_NUMBER',
  AdyenRemediationActionTypeUpdateMissingSignatory = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_SIGNATORY',
  AdyenRemediationActionTypeUpdateMissingUboThroughControl = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_MISSING_UBO_THROUGH_CONTROL',
  AdyenRemediationActionTypeUpdateOrganizationDetails = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_ORGANIZATION_DETAILS',
  AdyenRemediationActionTypeUpdateOrganizationLegalName = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_ORGANIZATION_LEGAL_NAME',
  AdyenRemediationActionTypeUpdateSignatoryDetails = 'ADYEN_REMEDIATION_ACTION_TYPE_UPDATE_SIGNATORY_DETAILS',
  AdyenRemediationActionTypeUploadBankStatement = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_BANK_STATEMENT',
  AdyenRemediationActionTypeUploadConstitutionalDocument = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_CONSTITUTIONAL_DOCUMENT',
  AdyenRemediationActionTypeUploadDifferentBankStatement = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_DIFFERENT_BANK_STATEMENT',
  AdyenRemediationActionTypeUploadDifferentIdDocument = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_DIFFERENT_ID_DOCUMENT',
  AdyenRemediationActionTypeUploadDifferentImageOfTheIdDocument = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_DIFFERENT_IMAGE_OF_THE_ID_DOCUMENT',
  AdyenRemediationActionTypeUploadDifferentImageProofOfNationalIdnumber = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_DIFFERENT_IMAGE_PROOF_OF_NATIONAL_IDNUMBER',
  AdyenRemediationActionTypeUploadDifferentProofOfIndividualTaxId = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_DIFFERENT_PROOF_OF_INDIVIDUAL_TAX_ID',
  AdyenRemediationActionTypeUploadDifferentProofOfIndustry = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_DIFFERENT_PROOF_OF_INDUSTRY',
  AdyenRemediationActionTypeUploadDifferentProofOfNationalIdnumber = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_DIFFERENT_PROOF_OF_NATIONAL_IDNUMBER',
  AdyenRemediationActionTypeUploadDifferentProofOfOrganizationAddress = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_DIFFERENT_PROOF_OF_ORGANIZATION_ADDRESS',
  AdyenRemediationActionTypeUploadDifferentProofOfOrganizationTaxInfo = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_DIFFERENT_PROOF_OF_ORGANIZATION_TAX_INFO',
  AdyenRemediationActionTypeUploadDifferentProofOfResidency = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_DIFFERENT_PROOF_OF_RESIDENCY',
  AdyenRemediationActionTypeUploadDifferentProofOfSignatory = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_DIFFERENT_PROOF_OF_SIGNATORY',
  AdyenRemediationActionTypeUploadDifferentRegistrationDocument = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_DIFFERENT_REGISTRATION_DOCUMENT',
  AdyenRemediationActionTypeUploadIdDocument = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_ID_DOCUMENT',
  AdyenRemediationActionTypeUploadMissingProofOfOwnership = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_MISSING_PROOF_OF_OWNERSHIP',
  AdyenRemediationActionTypeUploadOfficialBankStatement = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_OFFICIAL_BANK_STATEMENT',
  AdyenRemediationActionTypeUploadProofOfIndividualTaxId = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_PROOF_OF_INDIVIDUAL_TAX_ID',
  AdyenRemediationActionTypeUploadProofOfIndustry = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_PROOF_OF_INDUSTRY',
  AdyenRemediationActionTypeUploadProofOfNationalIdnumber = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_PROOF_OF_NATIONAL_IDNUMBER',
  AdyenRemediationActionTypeUploadProofOfOrganizationAddress = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_PROOF_OF_ORGANIZATION_ADDRESS',
  AdyenRemediationActionTypeUploadProofOfOrganizationTaxInfo = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_PROOF_OF_ORGANIZATION_TAX_INFO',
  AdyenRemediationActionTypeUploadProofOfOwnership = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_PROOF_OF_OWNERSHIP',
  AdyenRemediationActionTypeUploadProofOfResidency = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_PROOF_OF_RESIDENCY',
  AdyenRemediationActionTypeUploadProofOfSignatory = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_PROOF_OF_SIGNATORY',
  AdyenRemediationActionTypeUploadProofOfSigningRightsDocument = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_PROOF_OF_SIGNING_RIGHTS_DOCUMENT',
  AdyenRemediationActionTypeUploadProofPayoutAffiliation = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_PROOF_PAYOUT_AFFILIATION',
  AdyenRemediationActionTypeUploadRegistrationDocument = 'ADYEN_REMEDIATION_ACTION_TYPE_UPLOAD_REGISTRATION_DOCUMENT',
  AdyenRemediationActionTypeUseDifferentBankAccount = 'ADYEN_REMEDIATION_ACTION_TYPE_USE_DIFFERENT_BANK_ACCOUNT'
}

export type AdyenTermsOfServiceDocument = {
  __typename: 'AdyenTermsOfServiceDocument'
  document: Scalars['String']['output']
  tosID: Scalars['String']['output']
  tosType: Scalars['String']['output']
}

export enum AdyenUploadDocumentType {
  AdyenUploadDocumentTypeBankStatement = 'ADYEN_UPLOAD_DOCUMENT_TYPE_BANK_STATEMENT',
  AdyenUploadDocumentTypeDriversLicense = 'ADYEN_UPLOAD_DOCUMENT_TYPE_DRIVERS_LICENSE',
  AdyenUploadDocumentTypeIdentityCard = 'ADYEN_UPLOAD_DOCUMENT_TYPE_IDENTITY_CARD',
  AdyenUploadDocumentTypePassport = 'ADYEN_UPLOAD_DOCUMENT_TYPE_PASSPORT',
  AdyenUploadDocumentTypeProofOfAddress = 'ADYEN_UPLOAD_DOCUMENT_TYPE_PROOF_OF_ADDRESS',
  AdyenUploadDocumentTypeProofOfFundingOrWealthSource = 'ADYEN_UPLOAD_DOCUMENT_TYPE_PROOF_OF_FUNDING_OR_WEALTH_SOURCE',
  AdyenUploadDocumentTypeProofOfIndividualTaxId = 'ADYEN_UPLOAD_DOCUMENT_TYPE_PROOF_OF_INDIVIDUAL_TAX_ID',
  AdyenUploadDocumentTypeProofOfIndustry = 'ADYEN_UPLOAD_DOCUMENT_TYPE_PROOF_OF_INDUSTRY',
  AdyenUploadDocumentTypeProofOfNationalIdNumber = 'ADYEN_UPLOAD_DOCUMENT_TYPE_PROOF_OF_NATIONAL_ID_NUMBER',
  AdyenUploadDocumentTypeProofOfOrganizationTaxInfo = 'ADYEN_UPLOAD_DOCUMENT_TYPE_PROOF_OF_ORGANIZATION_TAX_INFO',
  AdyenUploadDocumentTypeProofOfOwnership = 'ADYEN_UPLOAD_DOCUMENT_TYPE_PROOF_OF_OWNERSHIP',
  AdyenUploadDocumentTypeProofOfRelationship = 'ADYEN_UPLOAD_DOCUMENT_TYPE_PROOF_OF_RELATIONSHIP',
  AdyenUploadDocumentTypeProofOfResidency = 'ADYEN_UPLOAD_DOCUMENT_TYPE_PROOF_OF_RESIDENCY',
  AdyenUploadDocumentTypeProofOfSignatory = 'ADYEN_UPLOAD_DOCUMENT_TYPE_PROOF_OF_SIGNATORY',
  AdyenUploadDocumentTypeRegistrationDocument = 'ADYEN_UPLOAD_DOCUMENT_TYPE_REGISTRATION_DOCUMENT',
  AdyenUploadDocumentTypeVatDocument = 'ADYEN_UPLOAD_DOCUMENT_TYPE_VAT_DOCUMENT'
}

export type AgreementTypeConnection = {
  __typename: 'AgreementTypeConnection'
  edges?: Maybe<Array<Maybe<AgreementTypeEdge>>>
  pageInfo: PageInfo
}

export type AgreementTypeEdge = {
  __typename: 'AgreementTypeEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<ConnectwiseAgreementType>
}

export type AgreementTypeFilter = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type AgreementTypeInput = {
  autotaskIDs?: InputMaybe<Array<Scalars['String']['input']>>
  connectwiseIDs?: InputMaybe<Array<Scalars['String']['input']>>
  haloPSAIDs?: InputMaybe<Array<Scalars['String']['input']>>
  quickbooksIDs?: InputMaybe<Array<Scalars['String']['input']>>
}

export type AgreementTypeOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<AgreementTypeOrderByField>
}

export enum AgreementTypeOrderByField {
  CreatedDate = 'CREATED_DATE',
  Name = 'NAME'
}

export type ApiKey = {
  __typename: 'ApiKey'
  clientID: Scalars['ID']['output']
  createdAt: Scalars['String']['output']
  createdBy?: Maybe<PartnerUser>
  id: Scalars['ID']['output']
  keyName: Scalars['String']['output']
  lastDigits: Scalars['String']['output']
  revokedAt?: Maybe<Scalars['String']['output']>
  revokedBy?: Maybe<PartnerUser>
  status: ApiKeyStatus
}

export type ApiKeyConnection = {
  __typename: 'ApiKeyConnection'
  edges?: Maybe<Array<Maybe<ApiKeyEdge>>>
  pageInfo: PageInfo
}

export type ApiKeyEdge = {
  __typename: 'ApiKeyEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<ApiKey>
}

export type ApiKeyFilter = {
  status?: InputMaybe<ApiKeyStatus>
}

export type ApiKeyOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<ApiKeyOrderByField>
}

export enum ApiKeyOrderByField {
  CreatedAt = 'CREATED_AT'
}

export enum ApiKeyStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type AutomatedPaymentVolumePercentByMonthResponse = {
  __typename: 'AutomatedPaymentVolumePercentByMonthResponse'
  average: Scalars['Float']['output']
  data: Array<AutomatedPaymentVolumePercentMonth>
}

export type AutomatedPaymentVolumePercentMonth = {
  __typename: 'AutomatedPaymentVolumePercentMonth'
  month: Scalars['String']['output']
  percent: Scalars['Float']['output']
}

export type AutomatedPaymentVolumePercentageResponse = {
  __typename: 'AutomatedPaymentVolumePercentageResponse'
  value: Scalars['Float']['output']
}

export type AutomatedPaymentsByMonthResponse = {
  __typename: 'AutomatedPaymentsByMonthResponse'
  average: Scalars['Float']['output']
  data: Array<DataPoint>
}

export type AutomatedPaymentsResponse = {
  __typename: 'AutomatedPaymentsResponse'
  value: Scalars['Float']['output']
}

export type AutomatedTransactionCountResponse = {
  __typename: 'AutomatedTransactionCountResponse'
  count: Scalars['Int']['output']
}

export type AutopayCustomMethod = {
  __typename: 'AutopayCustomMethod'
  card?: Maybe<Card>
  customerID: Scalars['ID']['output']
  fallbackCharge?: Maybe<Scalars['Boolean']['output']>
  institution?: Maybe<Institution>
  method: TransferPaymentMethodInputEnum
  methodID: Scalars['ID']['output']
}

export type AutopayCustomMethodInput = {
  customerID: Scalars['ID']['input']
  method: TransferPaymentMethodInputEnum
  methodID: Scalars['ID']['input']
}

export type AutopayExcludedCustomer = {
  __typename: 'AutopayExcludedCustomer'
  createdAt: Scalars['String']['output']
  createdByCustomer: Scalars['Boolean']['output']
  customer: Customer
  id: Scalars['ID']['output']
  partnerID: Scalars['ID']['output']
}

/** A connection to a list of items. */
export type AutopayExcludedCustomerConnection = {
  __typename: 'AutopayExcludedCustomerConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AutopayExcludedCustomerEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type AutopayExcludedCustomerEdge = {
  __typename: 'AutopayExcludedCustomerEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output']
  /** The item at the end of the edge. */
  node?: Maybe<AutopayExcludedCustomer>
}

export type AutopayExcludedCustomerFilter = {
  customerID?: InputMaybe<Scalars['ID']['input']>
  customerName?: InputMaybe<Scalars['String']['input']>
}

export type AutopayExcludedCustomerOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<AutopayExcludedCustomerOrderByField>
}

export enum AutopayExcludedCustomerOrderByField {
  CreatedAt = 'CREATED_AT'
}

export type AutopayExcludedCustomerTotals = {
  __typename: 'AutopayExcludedCustomerTotals'
  count: Scalars['Int']['output']
}

export type AutopayExcludedInvoice = {
  __typename: 'AutopayExcludedInvoice'
  excludedBy: ExcludedFromAutopayBy
  invoiceID: Scalars['ID']['output']
}

export type AutopayExcludedInvoiceCreateInput = {
  customerID: Scalars['ID']['input']
  invoiceID: Scalars['ID']['input']
}

export type AutopayRule = {
  __typename: 'AutopayRule'
  amount?: Maybe<Scalars['Float']['output']>
  amountOperator?: Maybe<RuleOperator>
  autotaskContractNames?: Maybe<Array<Scalars['String']['output']>>
  autotaskContractTypes?: Maybe<Array<AutotaskContractType>>
  connectWiseContractNames?: Maybe<Array<Scalars['String']['output']>>
  connectwiseAgreementTypes?: Maybe<Array<ConnectwiseAgreementType>>
  connectwiseBillingTerms?: Maybe<Array<ConnectwiseBillingTerms>>
  createdAt: Scalars['String']['output']
  createdByCustomer: Scalars['Boolean']['output']
  customMethods?: Maybe<Array<Maybe<AutopayCustomMethod>>>
  customers?: Maybe<Array<Maybe<Customer>>>
  daysBeforeDue?: Maybe<Scalars['Int']['output']>
  daysPastCreation?: Maybe<Scalars['Int']['output']>
  daysPastDue?: Maybe<Scalars['Int']['output']>
  haloPSAContractSubtypes?: Maybe<Array<HaloPsaContractSubtype>>
  halopsaRecurringInvoices?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  partnerID: Scalars['ID']['output']
  quickbooksRecurringTransactions?: Maybe<Array<QuickbooksRecurringTransaction>>
  rutterNetsuitePaymentTerms?: Maybe<Array<RutterPaymentTerms>>
  rutterQbdPaymentTerms?: Maybe<Array<RutterPaymentTerms>>
  tagIDs?: Maybe<Array<Maybe<Scalars['ID']['output']>>>
  version: Scalars['Int']['output']
}

/** A connection to a list of items. */
export type AutopayRuleConnection = {
  __typename: 'AutopayRuleConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AutopayRuleEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type AutopayRuleEdge = {
  __typename: 'AutopayRuleEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output']
  /** The item at the end of the edge. */
  node?: Maybe<AutopayRule>
}

export type AutopayRuleFilter = {
  customerID?: InputMaybe<Scalars['ID']['input']>
  customerName?: InputMaybe<Scalars['String']['input']>
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type AutopayRuleOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<AutopayRuleOrderByField>
}

export enum AutopayRuleOrderByField {
  DaysPastDue = 'DAYS_PAST_DUE'
}

export type AutopayRuleTotals = {
  __typename: 'AutopayRuleTotals'
  count: Scalars['Int']['output']
}

export type AutotaskContract = {
  __typename: 'AutotaskContract'
  externalID: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type AutotaskContractConnection = {
  __typename: 'AutotaskContractConnection'
  contracts?: Maybe<Array<Scalars['String']['output']>>
}

export type AutotaskContractEdge = {
  __typename: 'AutotaskContractEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<AutotaskContract>
}

export type AutotaskContractFilter = {
  customerNames?: InputMaybe<Array<Scalars['String']['input']>>
  name?: InputMaybe<Scalars['String']['input']>
}

export type AutotaskContractOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<AutotaskContractOrderByField>
}

export enum AutotaskContractOrderByField {
  ContractName = 'CONTRACT_NAME'
}

export type AutotaskContractType = {
  __typename: 'AutotaskContractType'
  externalID: Scalars['String']['output']
  name: Scalars['String']['output']
  partnerID: Scalars['String']['output']
}

export type AutotaskField = {
  __typename: 'AutotaskField'
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type AutotaskFieldInput = {
  name: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type AutotaskFilter = {
  __typename: 'AutotaskFilter'
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type AutotaskFilterInput = {
  id: Scalars['String']['input']
  name: Scalars['String']['input']
}

export type AutotaskIntegration = IntegrationInterface & {
  __typename: 'AutotaskIntegration'
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  integrationType: IntegrationType
  partnerID: Scalars['ID']['output']
  platformName: Scalars['String']['output']
  status: ConnectionStatus
}

export enum AutotaskInvoiceNumberField {
  AutotaskId = 'AutotaskID',
  InvoiceNumber = 'InvoiceNumber'
}

export type AutotaskQueryFilters = {
  __typename: 'AutotaskQueryFilters'
  companyClassifications: Array<AutotaskFilter>
  companyTerritoryIDs: Array<AutotaskFilter>
  companyTypes: Array<AutotaskFilter>
  companyUserDefinedFields: Array<Maybe<AutotaskUserDefinedField>>
  contactUserDefinedFields: Array<Maybe<AutotaskUserDefinedField>>
}

export type AutotaskUserDefinedField = {
  __typename: 'AutotaskUserDefinedField'
  isPickList?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<Scalars['String']['output']>
  picklistValues: Array<AutotaskField>
  type?: Maybe<Scalars['String']['output']>
}

export type AutotaskUserDefinedFieldInput = {
  dataType: Scalars['String']['input']
  inputs?: InputMaybe<Array<Scalars['String']['input']>>
  isPickList: Scalars['Boolean']['input']
  name: Scalars['String']['input']
  picklistValues?: InputMaybe<Array<InputMaybe<AutotaskFieldInput>>>
}

export type AverageDaysOverdueResponse = {
  __typename: 'AverageDaysOverdueResponse'
  value: Scalars['Float']['output']
}

export type AverageInvoiceAmountResponse = {
  __typename: 'AverageInvoiceAmountResponse'
  value: Scalars['Float']['output']
}

export type AverageOverdueAmountResponse = {
  __typename: 'AverageOverdueAmountResponse'
  value: Scalars['Float']['output']
}

export type AveragePaymentSizeResponse = {
  __typename: 'AveragePaymentSizeResponse'
  value: Scalars['Float']['output']
}

export type AverageTimeToPayAutopayResponse = {
  __typename: 'AverageTimeToPayAutopayResponse'
  value: Scalars['Float']['output']
}

export type AverageTimeToPayByMonthResponse = {
  __typename: 'AverageTimeToPayByMonthResponse'
  average: Scalars['Float']['output']
  data: Array<DataPoint>
}

export type AverageTimeToPayExternalResponse = {
  __typename: 'AverageTimeToPayExternalResponse'
  value: Scalars['Float']['output']
}

export type AverageTimeToPayExternalVsInternalByMonthData = {
  __typename: 'AverageTimeToPayExternalVsInternalByMonthData'
  average: Scalars['Float']['output']
  isInternal: Scalars['Boolean']['output']
  month: Scalars['String']['output']
}

export type AverageTimeToPayExternalVsInternalByMonthResponse = {
  __typename: 'AverageTimeToPayExternalVsInternalByMonthResponse'
  data: Array<AverageTimeToPayExternalVsInternalByMonthData>
  externalAvg: Scalars['Float']['output']
  internalAvg: Scalars['Float']['output']
}

export type AverageTimeToPayResponse = {
  __typename: 'AverageTimeToPayResponse'
  value: Scalars['Float']['output']
}

export type BnplOffer = {
  __typename: 'BNPLOffer'
  amount: Scalars['Float']['output']
  approved: Scalars['Boolean']['output']
  approvedBy?: Maybe<SuperAdminUser>
  createdAt: Scalars['String']['output']
  customer?: Maybe<Customer>
  fees: Scalars['Float']['output']
  id: Scalars['ID']['output']
  invoiceID: Scalars['ID']['output']
  lending?: Maybe<Lending>
  netAmount: Scalars['Float']['output']
  partner?: Maybe<Partner>
  partnerConfirmed: Scalars['Boolean']['output']
  rate: Scalars['Float']['output']
  remainingBalance: Scalars['Float']['output']
  status: BnplStatus
  terms: Scalars['Int']['output']
}

export enum BnplStatus {
  Creating = 'CREATING',
  Failed = 'FAILED',
  Inprocess = 'INPROCESS',
  Inreview = 'INREVIEW',
  Rejected = 'REJECTED'
}

export type BillingTermsInput = {
  connectwiseIDs?: InputMaybe<Array<Scalars['String']['input']>>
  rutterNetsuiteIDs?: InputMaybe<Array<Scalars['String']['input']>>
  rutterQbdIDs?: InputMaybe<Array<Scalars['String']['input']>>
}

export type BnplFilter = {
  approved?: InputMaybe<Scalars['Boolean']['input']>
  createdAtEnd?: InputMaybe<Scalars['String']['input']>
  createdAtStart?: InputMaybe<Scalars['String']['input']>
  customerID?: InputMaybe<Scalars['ID']['input']>
  partnerID?: InputMaybe<Scalars['ID']['input']>
  status?: InputMaybe<Array<BnplStatus>>
}

export type BreakdownFilter = {
  CompanyID?: InputMaybe<Scalars['ID']['input']>
  CompanyType?: InputMaybe<CompanyType>
  ID?: InputMaybe<Scalars['ID']['input']>
  PaymentMethodID?: InputMaybe<Scalars['ID']['input']>
  PayoutID?: InputMaybe<Scalars['ID']['input']>
  ProductID?: InputMaybe<Scalars['ID']['input']>
  ProductType?: InputMaybe<BreakdownProductType>
  TransactionDateFrom?: InputMaybe<Scalars['Time']['input']>
  TransactionDateTo?: InputMaybe<Scalars['Time']['input']>
  TransactionID?: InputMaybe<Scalars['ID']['input']>
}

export type BreakdownListItem = {
  __typename: 'BreakdownListItem'
  companyType: CompanyType
  createdAt: Scalars['Time']['output']
  customer?: Maybe<Customer>
  fee: Scalars['Float']['output']
  grossAmount: Scalars['Float']['output']
  id: Scalars['ID']['output']
  partner?: Maybe<Partner>
  paymentMethod?: Maybe<PaymentMethodEntity>
  payout: Payout
  product?: Maybe<Product>
  transaction?: Maybe<Transaction>
  transactionDate?: Maybe<Scalars['Time']['output']>
  transactionType: BreakdownProductType
}

export type BreakdownListItemConnection = {
  __typename: 'BreakdownListItemConnection'
  edges?: Maybe<Array<Maybe<BreakdownListItemEdge>>>
  pageInfo: PageInfo
}

export type BreakdownListItemEdge = {
  __typename: 'BreakdownListItemEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<BreakdownListItem>
}

export enum BreakdownProductType {
  Chargeback = 'CHARGEBACK',
  Payment = 'PAYMENT',
  Referral = 'REFERRAL',
  ReferralBonus = 'REFERRAL_BONUS',
  Refund = 'REFUND'
}

export type BucketAmountData = {
  __typename: 'BucketAmountData'
  bucket: Scalars['String']['output']
  value: Scalars['Float']['output']
}

export type BucketCountData = {
  __typename: 'BucketCountData'
  bucket: Scalars['String']['output']
  value: Scalars['Int']['output']
}

export enum BulkChargeRequestStatusEnum {
  Processed = 'PROCESSED',
  Processing = 'PROCESSING'
}

export type BulkToggleArchiveCustomersInput = {
  archive: Scalars['Boolean']['input']
  filters: CustomerFilter
}

export type CwBillingTermsFilter = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type CwBillingTermsOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<CwBillingTermsOrderByField>
}

export enum CwBillingTermsOrderByField {
  CreatedDate = 'CREATED_DATE',
  Name = 'NAME'
}

export type CancelSubscriptionInput = {
  subscriptionId: Scalars['ID']['input']
}

export type Card = {
  __typename: 'Card'
  cardNetWork: CardNetwork
  expirationDate: Scalars['String']['output']
  fundingSource: FundingSource
  id: Scalars['ID']['output']
  last4: Scalars['String']['output']
  systemDeactivatedAt?: Maybe<Scalars['String']['output']>
}

export type CardCreationInput = {
  billingAddress?: InputMaybe<AddressInput>
  cardProviderToken: Scalars['String']['input']
  provider: CardProvider
}

export type CardDeletionInput = {
  id: Scalars['ID']['input']
}

export type CardFeeAmount = {
  __typename: 'CardFeeAmount'
  feeAmount: Scalars['Float']['output']
  fundingSource?: Maybe<FundingSource>
  percentage: Scalars['Float']['output']
}

export enum CardNetwork {
  AmericanExpress = 'AMERICAN_EXPRESS',
  DinersClub = 'DINERS_CLUB',
  Discover = 'DISCOVER',
  Mastercard = 'MASTERCARD',
  Other = 'OTHER',
  Visa = 'VISA'
}

export enum CardProvider {
  Checkout = 'CHECKOUT',
  Modernbanc = 'MODERNBANC'
}

export type CardSerializationInput = {
  cardHolderNameSecretID: Scalars['String']['input']
  expirationDateSecretID: Scalars['String']['input']
  panSecretID: Scalars['String']['input']
}

export type CashFlowDistributionData = {
  __typename: 'CashFlowDistributionData'
  date: Scalars['String']['output']
  isInternal: Scalars['Boolean']['output']
  value: Scalars['Float']['output']
}

export type CashFlowDistributionLastThirtyDaysReponse = {
  __typename: 'CashFlowDistributionLastThirtyDaysReponse'
  data: Array<CashFlowDistributionData>
}

export type Collection = {
  __typename: 'Collection'
  collectionFeePaymentAmount: Scalars['Float']['output']
  collectionInstruction: Scalars['String']['output']
  collectionOutstandingAmount: Scalars['Float']['output']
  collectionPayment?: Maybe<Payment>
  createdAt: Scalars['String']['output']
  customerInfo: CollectionCustomerInfo
  customerType: CollectionCustomerType
  id: Scalars['ID']['output']
  interest: Scalars['Float']['output']
  invoice: Invoice
  lastContactDate: Scalars['String']['output']
  notes: Array<CollectionNote>
  partner: Partner
  status: Array<CollectionStatus>
  updatedAt: Scalars['String']['output']
  upfrontFeePayment?: Maybe<Payment>
}

export type CollectionConnection = {
  __typename: 'CollectionConnection'
  edges?: Maybe<Array<Maybe<CollectionEdge>>>
  pageInfo: PageInfo
}

export type CollectionCreateInput = {
  collectionInstruction: Scalars['String']['input']
  customerInfo: CollectionCreationCustomerInfoInput
  customerType?: InputMaybe<CollectionCustomerType>
  interest?: InputMaybe<Scalars['Float']['input']>
  invoiceID: Scalars['ID']['input']
  lastContactDate: Scalars['String']['input']
}

export type CollectionCreationCustomerInfoInput = {
  city: Scalars['String']['input']
  country: Scalars['String']['input']
  email: Scalars['String']['input']
  name: Scalars['String']['input']
  phone: Scalars['String']['input']
  postalCode: Scalars['String']['input']
  state: Scalars['String']['input']
  streetAddress: Scalars['String']['input']
  subPremise?: InputMaybe<Scalars['String']['input']>
}

export type CollectionCustomerInfo = AddressInterface & {
  __typename: 'CollectionCustomerInfo'
  city: Scalars['String']['output']
  country: Scalars['String']['output']
  customer: Customer
  email: Scalars['String']['output']
  name: Scalars['String']['output']
  phone: Scalars['String']['output']
  postalCode: Scalars['String']['output']
  state: Scalars['String']['output']
  streetAddress: Scalars['String']['output']
  subPremise?: Maybe<Scalars['String']['output']>
}

export enum CollectionCustomerType {
  B2B = 'B2B',
  B2C = 'B2C',
  B2G = 'B2G',
  NotInformed = 'NOT_INFORMED'
}

export type CollectionEdge = {
  __typename: 'CollectionEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<Collection>
}

export type CollectionFeeRates = {
  __typename: 'CollectionFeeRates'
  collectionFeeAmount: Scalars['Float']['output']
  upfrontFeeAmount: Scalars['Float']['output']
}

export type CollectionFilter = {
  creationDateEnd?: InputMaybe<Scalars['String']['input']>
  creationDateStart?: InputMaybe<Scalars['String']['input']>
  customerIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  dueDateEnd?: InputMaybe<Scalars['String']['input']>
  dueDateStart?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  invoiceIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  status?: InputMaybe<Array<InputMaybe<CollectionStatusEnum>>>
}

export type CollectionNote = {
  __typename: 'CollectionNote'
  createdAt: Scalars['String']['output']
  note: Scalars['String']['output']
}

export type CollectionOrder = {
  direction?: OrderDirection
  field?: CollectionOrderField
}

export enum CollectionOrderField {
  CreatedAt = 'CREATED_AT',
  CustomerName = 'CUSTOMER_NAME',
  InvoiceAmount = 'INVOICE_AMOUNT',
  InvoiceDueDate = 'INVOICE_DUE_DATE'
}

export type CollectionStatus = {
  __typename: 'CollectionStatus'
  createdAt: Scalars['String']['output']
  status: CollectionStatusEnum
}

export enum CollectionStatusEnum {
  Canceled = 'CANCELED',
  Collected = 'COLLECTED',
  InProgress = 'IN_PROGRESS',
  Requesting = 'REQUESTING',
  Uncollectable = 'UNCOLLECTABLE',
  WaitingUpfrontFee = 'WAITING_UPFRONT_FEE'
}

export enum CollectionStatusInputEnum {
  Canceled = 'CANCELED',
  Collected = 'COLLECTED',
  InProgress = 'IN_PROGRESS',
  Uncollectable = 'UNCOLLECTABLE'
}

export type CollectionTotals = {
  __typename: 'CollectionTotals'
  amount: Scalars['Float']['output']
  count: Scalars['Int']['output']
  netAmount: Scalars['Float']['output']
}

export type Company = {
  __typename: 'Company'
  id: Scalars['ID']['output']
}

export type CompanyDocument = {
  __typename: 'CompanyDocument'
  createdAt: Scalars['String']['output']
  filename?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  partnerID: Scalars['ID']['output']
  type: PartnerDocumentType
  url: Scalars['String']['output']
}

export type CompanyIndividual = {
  __typename: 'CompanyIndividual'
  city: Scalars['String']['output']
  controllingPerson: Scalars['Boolean']['output']
  country: Scalars['String']['output']
  countryCode: Scalars['String']['output']
  dateOfBirth: Scalars['String']['output']
  email: Scalars['String']['output']
  firstName: Scalars['String']['output']
  hasSSN: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  jobTitle: Scalars['String']['output']
  lastName: Scalars['String']['output']
  owner: Scalars['Boolean']['output']
  partnerID: Scalars['ID']['output']
  phone: Scalars['String']['output']
  postalCode: Scalars['String']['output']
  signatory: Scalars['Boolean']['output']
  state: Scalars['String']['output']
  stateCode: Scalars['String']['output']
  streetAddress: Scalars['String']['output']
  subPremise: Scalars['String']['output']
}

export type CompanyPayoutTimingConfigs = {
  __typename: 'CompanyPayoutTimingConfigs'
  activeConfig?: Maybe<PayoutTimingCompanyConfig>
  upcomingConfig?: Maybe<PayoutTimingCompanyConfig>
}

export enum CompanyType {
  Alternative = 'ALTERNATIVE',
  Customer = 'CUSTOMER',
  Partner = 'PARTNER'
}

export type CompanyUnion = Customer | Partner

export type ConnectWiseAgreementConnection = {
  __typename: 'ConnectWiseAgreementConnection'
  agreements?: Maybe<Array<Scalars['String']['output']>>
}

export type ConnectWiseAgreementEdge = {
  __typename: 'ConnectWiseAgreementEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<ConnectwiseAgreement>
}

export type ConnectWiseAgreementFilter = {
  customerNames?: InputMaybe<Array<Scalars['String']['input']>>
  name?: InputMaybe<Scalars['String']['input']>
}

export type ConnectWiseAgreementOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<ConnectWiseAgreementOrderByField>
}

export enum ConnectWiseAgreementOrderByField {
  AgreementName = 'AGREEMENT_NAME'
}

export type ConnectWiseBillingTermsConnection = {
  __typename: 'ConnectWiseBillingTermsConnection'
  edges?: Maybe<Array<Maybe<ConnectWiseBillingTermsEdge>>>
  pageInfo: PageInfo
}

export type ConnectWiseBillingTermsEdge = {
  __typename: 'ConnectWiseBillingTermsEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<ConnectwiseBillingTerms>
}

export type ConnectWiseConnection = {
  __typename: 'ConnectWiseConnection'
  partnerID: Scalars['String']['output']
  queryFilters: ConnectWiseQueryFilters
}

export type ConnectWiseFilterValue = {
  __typename: 'ConnectWiseFilterValue'
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
}

export type ConnectWiseFilterValueInput = {
  id: Scalars['Int']['input']
  name: Scalars['String']['input']
}

export type ConnectWiseFilters = {
  __typename: 'ConnectWiseFilters'
  createdSince?: Maybe<Scalars['String']['output']>
  locations?: Maybe<Array<ConnectWiseFilterValue>>
  status?: Maybe<Array<ConnectWiseFilterValue>>
  territories?: Maybe<Array<ConnectWiseFilterValue>>
  types?: Maybe<Array<ConnectWiseFilterValue>>
}

export type ConnectWiseFiltersInput = {
  createdSince?: InputMaybe<Scalars['String']['input']>
  locations?: InputMaybe<Array<ConnectWiseFilterValueInput>>
  status?: InputMaybe<Array<ConnectWiseFilterValueInput>>
  territories?: InputMaybe<Array<ConnectWiseFilterValueInput>>
  types?: InputMaybe<Array<ConnectWiseFilterValueInput>>
}

export type ConnectWiseQueryFilters = {
  __typename: 'ConnectWiseQueryFilters'
  customerFilters: ConnectWiseFilters
  invoiceFilters: ConnectWiseFilters
}

export type ConnectWiseQueryFiltersInput = {
  customerFilters?: InputMaybe<ConnectWiseFiltersInput>
  invoiceFilters?: InputMaybe<ConnectWiseFiltersInput>
}

export type ConnectionCreateInput = {
  integrationType: IntegrationType
  publicToken: Scalars['String']['input']
}

export enum ConnectionStatus {
  Connected = 'CONNECTED',
  Disconnected = 'DISCONNECTED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type ConnectionUpdateInput = {
  integrationType: IntegrationType
  platform: RutterPlatform
}

export type ConnectwiseAgreement = {
  __typename: 'ConnectwiseAgreement'
  externalID?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
}

export type ConnectwiseAgreementType = {
  __typename: 'ConnectwiseAgreementType'
  externalID: Scalars['String']['output']
  name: Scalars['String']['output']
  partnerID: Scalars['String']['output']
}

export type ConnectwiseBillingTerms = {
  __typename: 'ConnectwiseBillingTerms'
  externalID: Scalars['String']['output']
  name: Scalars['String']['output']
  partnerID: Scalars['String']['output']
}

export type ConnectwiseIntegration = IntegrationInterface & {
  __typename: 'ConnectwiseIntegration'
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  integrationType: IntegrationType
  partnerID: Scalars['ID']['output']
  platformName: Scalars['String']['output']
  status: ConnectionStatus
}

export type ContractNamesInput = {
  autotaskNames?: InputMaybe<Array<Scalars['String']['input']>>
  connectwiseNames?: InputMaybe<Array<Scalars['String']['input']>>
}

export type ContractSubtypeConnection = {
  __typename: 'ContractSubtypeConnection'
  edges?: Maybe<Array<Maybe<ContractSubtypeEdge>>>
  pageInfo: PageInfo
}

export type ContractSubtypeEdge = {
  __typename: 'ContractSubtypeEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<HaloPsaContractSubtype>
}

export type ContractSubtypeFilter = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type ContractSubtypeOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<ContractSubtypeOrderByField>
}

export enum ContractSubtypeOrderByField {
  CreatedDate = 'CREATED_DATE',
  Name = 'NAME'
}

export type ContractTypeConnection = {
  __typename: 'ContractTypeConnection'
  edges?: Maybe<Array<Maybe<ContractTypeEdge>>>
  pageInfo: PageInfo
}

export type ContractTypeEdge = {
  __typename: 'ContractTypeEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<AutotaskContractType>
}

export type ContractTypeFilter = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type ContractTypeOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<ContractTypeOrderByField>
}

export enum ContractTypeOrderByField {
  CreatedDate = 'CREATED_DATE',
  Name = 'NAME'
}

export type CoverFeeConfig = {
  __typename: 'CoverFeeConfig'
  coverACHMethodFee?: Maybe<Scalars['Boolean']['output']>
  coverCardMethodFee?: Maybe<Scalars['Boolean']['output']>
  coverOtherMethodFee?: Maybe<Scalars['Boolean']['output']>
  coverWireMethodFee?: Maybe<Scalars['Boolean']['output']>
}

export type CreateApiKeyInput = {
  keyName: Scalars['String']['input']
}

export type CreateApiKeyResponse = {
  __typename: 'CreateApiKeyResponse'
  key: Scalars['String']['output']
}

export type CreateCompanyIndividualInput = {
  city: Scalars['String']['input']
  controllingPerson: Scalars['Boolean']['input']
  country: Scalars['String']['input']
  countryCode: Scalars['String']['input']
  dateOfBirth: Scalars['String']['input']
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  jobTitle: Scalars['String']['input']
  lastName: Scalars['String']['input']
  owner: Scalars['Boolean']['input']
  partnerID: Scalars['ID']['input']
  phone: Scalars['String']['input']
  postalCode: Scalars['String']['input']
  signatory: Scalars['Boolean']['input']
  ssn?: InputMaybe<Scalars['String']['input']>
  state: Scalars['String']['input']
  stateCode: Scalars['String']['input']
  streetAddress: Scalars['String']['input']
  subPremise: Scalars['String']['input']
}

export type CreateEmailTemplateInput = {
  name: Scalars['String']['input']
  section1?: InputMaybe<Scalars['String']['input']>
  section2?: InputMaybe<Scalars['String']['input']>
  section3?: InputMaybe<Scalars['String']['input']>
  subject: Scalars['String']['input']
  type: TemplateType
}

export type CreateReferralInput = {
  email: Scalars['String']['input']
  name: Scalars['String']['input']
}

export type CreateUserAndPartnerReply = {
  __typename: 'CreateUserAndPartnerReply'
  partnerId: Scalars['ID']['output']
  userId: Scalars['ID']['output']
}

export type CustomPartnerFeeConfig = {
  __typename: 'CustomPartnerFeeConfig'
  coverFeeConfig?: Maybe<CoverFeeConfig>
  id: Scalars['ID']['output']
  partner: Partner
  paymentExecutorType: PaymentExecutorType
  paymentOriginService: PaymentAlternativeService
}

export type CustomPartnerFeeConfigUpsertInput = {
  coverFeeConfig?: InputMaybe<PartnerCoverFeeConfigInput>
  paymentExecutorType: PaymentExecutorType
  paymentOriginService: PaymentAlternativeService
}

export type CustomPartnerFeeConfigs = {
  __typename: 'CustomPartnerFeeConfigs'
  customPartnerFeeConfigs?: Maybe<Array<CustomPartnerFeeConfig>>
}

export type CustomPartnerFeeConfigsFilter = {
  paymentExecutorType?: InputMaybe<PaymentExecutorType>
  paymentOriginService?: InputMaybe<PaymentAlternativeService>
}

export type Customer = AddressInterface & {
  __typename: 'Customer'
  archivedBy?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  companyType?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['String']['output']
  defaultPaymentMethod?: Maybe<CustomerDefaultPaymentMethod>
  description?: Maybe<Scalars['String']['output']>
  ein?: Maybe<Scalars['String']['output']>
  feeConfig?: Maybe<Array<Maybe<CustomerFeeConfig>>>
  id: Scalars['ID']['output']
  industry?: Maybe<Scalars['String']['output']>
  isArchived: Scalars['Boolean']['output']
  isOnboarded: Scalars['Boolean']['output']
  legalName?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  outstandingInvoicesData?: Maybe<CustomerOutstandingInvoicesData>
  partner?: Maybe<Partner>
  postalCode?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  streetAddress?: Maybe<Scalars['String']['output']>
  subPremise?: Maybe<Scalars['String']['output']>
  tagIDs?: Maybe<Array<Scalars['ID']['output']>>
}

export type CustomerAutopayConfig = {
  __typename: 'CustomerAutopayConfig'
  ID: Scalars['ID']['output']
  chargeDefaultFallback: Scalars['Boolean']['output']
  customerID: Scalars['ID']['output']
  partnerID: Scalars['ID']['output']
}

/** A connection to a list of items. */
export type CustomerConnection = {
  __typename: 'CustomerConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CustomerEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type CustomerDefaultPaymentMethod = {
  __typename: 'CustomerDefaultPaymentMethod'
  card?: Maybe<Card>
  institution?: Maybe<Institution>
  method: TransferPaymentMethodInputEnum
  methodID: Scalars['ID']['output']
}

/** An edge in a connection. */
export type CustomerEdge = {
  __typename: 'CustomerEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Customer>
}

export type CustomerFeeConfig = {
  __typename: 'CustomerFeeConfig'
  customer: Customer
  feeType: FeeExceptionType
  id: Scalars['UUID']['output']
  partner: Partner
}

export enum CustomerFeeConfigAction {
  Add = 'ADD',
  Remove = 'REMOVE'
}

export type CustomerFilter = {
  createdAtEnd?: InputMaybe<Scalars['String']['input']>
  createdAtStart?: InputMaybe<Scalars['String']['input']>
  customerID?: InputMaybe<Scalars['ID']['input']>
  customerIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  customerIDsNotIn?: InputMaybe<Array<Scalars['ID']['input']>>
  name?: InputMaybe<Scalars['String']['input']>
  onboarded?: InputMaybe<Scalars['Boolean']['input']>
  onlyArchived?: InputMaybe<Scalars['Boolean']['input']>
  tagIdIn?: InputMaybe<Array<Scalars['ID']['input']>>
  tagIdNotIn?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type CustomerOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<CustomerOrderByField>
}

export enum CustomerOrderByField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export type CustomerOutstandingInvoicesData = {
  __typename: 'CustomerOutstandingInvoicesData'
  longestDaysOverdue?: Maybe<Scalars['String']['output']>
  outstandingInvoicesCount?: Maybe<Scalars['Int']['output']>
  outstandingInvoicesTotal?: Maybe<Scalars['Float']['output']>
}

export type CustomerTag = {
  __typename: 'CustomerTag'
  ID: Scalars['ID']['output']
  color?: Maybe<TagColor>
  customerIDs: Array<Scalars['ID']['output']>
  description?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  type?: Maybe<TagType>
}

export type CustomerUser = {
  __typename: 'CustomerUser'
  approvedBy?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['String']['output']
  customer?: Maybe<Customer>
  email: Scalars['String']['output']
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  jobTitle?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  role: CustomerUserRole
}

/** A connection to a list of items. */
export type CustomerUserConnection = {
  __typename: 'CustomerUserConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CustomerUserEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CustomerUserEdge = {
  __typename: 'CustomerUserEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output']
  /** The item at the end of the edge. */
  node?: Maybe<CustomerUser>
}

export type CustomerUserFilter = {
  companyName?: InputMaybe<Scalars['String']['input']>
  customerID?: InputMaybe<Scalars['ID']['input']>
  firstCreatedUserOnly?: InputMaybe<Scalars['Boolean']['input']>
  hasApprovedBy?: InputMaybe<Scalars['Boolean']['input']>
}

export type CustomerUserOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<CustomerUserOrderByField>
}

export enum CustomerUserOrderByField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export enum CustomerUserRole {
  Customer = 'CUSTOMER'
}

export type DataPoint = {
  __typename: 'DataPoint'
  month: Scalars['String']['output']
  value: Scalars['Float']['output']
}

export type DatagateConnectionCreateInput = {
  apiToken: Scalars['String']['input']
}

export type DatagateIntegration = IntegrationInterface & {
  __typename: 'DatagateIntegration'
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  integrationType: IntegrationType
  partnerID: Scalars['ID']['output']
  platformName: Scalars['String']['output']
  status: ConnectionStatus
}

export type DeleteEmailTemplateInput = {
  id: Scalars['ID']['input']
}

export type DownloadableInvoiceLink = {
  __typename: 'DownloadableInvoiceLink'
  expires_at?: Maybe<Scalars['String']['output']>
  invoiceId: Scalars['String']['output']
  status: DownloadableInvoiceStatus
  url?: Maybe<Scalars['String']['output']>
}

export enum DownloadableInvoiceStatus {
  Available = 'AVAILABLE',
  Expired = 'EXPIRED',
  Initialized = 'INITIALIZED',
  Pending = 'PENDING',
  Unavailable = 'UNAVAILABLE'
}

export type EmailActivity = {
  __typename: 'EmailActivity'
  customer?: Maybe<Customer>
  invoice?: Maybe<Invoice>
  sentAt: Scalars['String']['output']
  status?: Maybe<EmailStatus>
  subject: Scalars['String']['output']
  user: Scalars['String']['output']
}

export type EmailActivityConnection = {
  __typename: 'EmailActivityConnection'
  edges: Array<EmailActivityEdge>
  pageInfo: PageInfo
}

export type EmailActivityEdge = {
  __typename: 'EmailActivityEdge'
  cursor: Scalars['Cursor']['output']
  node: EmailActivity
}

export type EmailActivityFilter = {
  customerID?: InputMaybe<Scalars['String']['input']>
  invoiceID?: InputMaybe<Scalars['String']['input']>
  partnerID?: InputMaybe<Scalars['String']['input']>
  sentAtEnd?: InputMaybe<Scalars['String']['input']>
  sentAtStart?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<EmailStatus>
  user?: InputMaybe<Scalars['String']['input']>
}

export enum EmailStatus {
  Bounced = 'BOUNCED',
  Clicked = 'CLICKED',
  Delivered = 'DELIVERED',
  Opened = 'OPENED',
  Pending = 'PENDING'
}

export type EmailTemplate = {
  __typename: 'EmailTemplate'
  favorite?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  partnerID: Scalars['ID']['output']
  section1?: Maybe<Scalars['String']['output']>
  section2?: Maybe<Scalars['String']['output']>
  section3?: Maybe<Scalars['String']['output']>
  subject: Scalars['String']['output']
  type: TemplateType
}

export enum ExcludedFromAutopayBy {
  System = 'SYSTEM',
  User = 'USER'
}

export enum FeeExceptionType {
  Ach = 'ACH',
  Card = 'CARD',
  Directpayment = 'DIRECTPAYMENT',
  Other = 'OTHER',
  Wire = 'WIRE'
}

export enum FeeType {
  LatePayment = 'LATE_PAYMENT',
  Method = 'METHOD',
  Product = 'PRODUCT'
}

export enum Frequency {
  Annually = 'ANNUALLY',
  Bimonthly = 'BIMONTHLY',
  Biweekly = 'BIWEEKLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Semiannually = 'SEMIANNUALLY',
  Weekly = 'WEEKLY'
}

export enum FundingSource {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  Prepaid = 'PREPAID'
}

export type GetAccountingSyncBatchReply = {
  __typename: 'GetAccountingSyncBatchReply'
  batch: AccountingSyncBatch
  invoiceJobs?: Maybe<Array<AccountingSyncJob>>
}

export type GetAdyenHostedOnboardingLinkResponse = {
  __typename: 'GetAdyenHostedOnboardingLinkResponse'
  url: Scalars['String']['output']
}

export type GetAdyenRemediationActionsGrouping = {
  __typename: 'GetAdyenRemediationActionsGrouping'
  actions: Array<GetAdyenRemediationActionsItem>
  errorCode: Scalars['String']['output']
  errorMessage: Scalars['String']['output']
  ownerID: Scalars['String']['output']
  ownerType: AdyenOwnerType
}

export type GetAdyenRemediationActionsItem = {
  __typename: 'GetAdyenRemediationActionsItem'
  actionID: Scalars['String']['output']
  actionType: AdyenRemediationActionType
  unmappedRemediationActionCode?: Maybe<Scalars['String']['output']>
}

export type GetAdyenRemediationActionsReply = {
  __typename: 'GetAdyenRemediationActionsReply'
  groupings: Array<GetAdyenRemediationActionsGrouping>
}

export type GetCardFeeInput = {
  Amount: Scalars['Float']['input']
  CardID?: InputMaybe<Scalars['ID']['input']>
}

export type GetCardPubKey = {
  provider: CardProvider
}

export type GetCustomerAutopayConfigInput = {
  customerID: Scalars['ID']['input']
}

export type GetCustomerAutopayConfigReply = {
  __typename: 'GetCustomerAutopayConfigReply'
  customerAutopayConfig?: Maybe<CustomerAutopayConfig>
}

export type GetCustomerCardFeeInput = {
  Amount: Scalars['Float']['input']
  CardID?: InputMaybe<Scalars['ID']['input']>
  CustomerID: Scalars['ID']['input']
}

export type GetFeeRatesInput = {
  amount: Scalars['Float']['input']
  interest?: InputMaybe<Scalars['Float']['input']>
  invoiceOverdueDate: Scalars['String']['input']
}

export type GetPartnerInvoiceBulkChargesFilter = {
  bulkChargeId?: InputMaybe<Scalars['ID']['input']>
  bulkChargeRequestStatuses?: InputMaybe<Array<BulkChargeRequestStatusEnum>>
  createdAtEnd?: InputMaybe<Scalars['String']['input']>
  createdAtStart?: InputMaybe<Scalars['String']['input']>
  paymentDateEnd?: InputMaybe<Scalars['String']['input']>
  paymentDateStart?: InputMaybe<Scalars['String']['input']>
  requesterId?: InputMaybe<Scalars['ID']['input']>
}

export type GetPartnerInvoiceBulkChargesOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<PartnerInvoiceBulkChargeOrderByField>
}

export type GetReferralDataInput = {
  period: ReferralComparisonPeriod
}

export type GetReferralDataReply = {
  __typename: 'GetReferralDataReply'
  previous: Scalars['Float']['output']
  total: Scalars['Float']['output']
}

export type HaloPsaContractSubtype = {
  __typename: 'HaloPSAContractSubtype'
  externalID: Scalars['String']['output']
  name: Scalars['String']['output']
  partnerID: Scalars['String']['output']
}

export type HaloPsaIntegration = IntegrationInterface & {
  __typename: 'HaloPSAIntegration'
  applicationDomain: Scalars['String']['output']
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  integrationType: IntegrationType
  partnerID: Scalars['ID']['output']
  platformName: Scalars['String']['output']
  status: ConnectionStatus
}

export type Installment = {
  __typename: 'Installment'
  amount: Scalars['Float']['output']
  dueDate: Scalars['String']['output']
  fees: Array<Maybe<InstallmentFee>>
  id: Scalars['ID']['output']
  netAmount: Scalars['Float']['output']
  payments: Array<Maybe<Payment>>
  status: InstallmentStatus
}

export type InstallmentFee = {
  __typename: 'InstallmentFee'
  amount: Scalars['Float']['output']
  name: Scalars['String']['output']
  type: FeeType
}

export enum InstallmentStatus {
  Canceled = 'CANCELED',
  Overdue = 'OVERDUE',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Scheduled = 'SCHEDULED',
  Succeeded = 'SUCCEEDED'
}

export type InstantPayment = {
  __typename: 'InstantPayment'
  id: Scalars['ID']['output']
}

export type Institution = {
  __typename: 'Institution'
  accounts?: Maybe<Array<Maybe<Account>>>
  externalId?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  logo?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  plaidConnection?: Maybe<PlaidInstitutionConnectionStatus>
  url?: Maybe<Scalars['String']['output']>
}

export type IntegrationDisconnectInput = {
  partnerID: Scalars['ID']['input']
  platform: PlatformName
}

export type IntegrationInterface = {
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  integrationType: IntegrationType
  partnerID: Scalars['ID']['output']
  platformName: Scalars['String']['output']
}

export type IntegrationSyncInput = {
  platform: PlatformName
  syncType: SyncType
}

export type IntegrationSyncReply = {
  __typename: 'IntegrationSyncReply'
  message: Scalars['String']['output']
  success: Scalars['Boolean']['output']
}

export enum IntegrationType {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  Tertiary = 'TERTIARY'
}

export type Invoice = {
  __typename: 'Invoice'
  amount: Scalars['Float']['output']
  autopaidAt?: Maybe<Scalars['String']['output']>
  collection?: Maybe<Collection>
  createdAt: Scalars['String']['output']
  createdByCustomer: Scalars['Boolean']['output']
  customer?: Maybe<Customer>
  dueDate?: Maybe<Scalars['String']['output']>
  externalId?: Maybe<Scalars['String']['output']>
  externalInvoiceNumber?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  invoiceNumber: Scalars['String']['output']
  lastRemindedAt?: Maybe<Scalars['String']['output']>
  lineItems?: Maybe<Array<Maybe<LineItem>>>
  offer?: Maybe<BnplOffer>
  outstandingAmount: Scalars['Float']['output']
  partner?: Maybe<Partner>
  payments?: Maybe<Array<Maybe<InvoicePayment>>>
  platformName: Scalars['String']['output']
  productName?: Maybe<Scalars['String']['output']>
  purchaseOrder?: Maybe<Scalars['String']['output']>
  recurringpayment: Scalars['Boolean']['output']
  recurringpaymentID?: Maybe<Scalars['String']['output']>
  sourceCreatedAt: Scalars['String']['output']
  status: InvoiceStatusEnum
  statuses: Array<Maybe<InvoiceStatus>>
  totalDiscountAmount: Scalars['Float']['output']
  totalTaxAmount: Scalars['Float']['output']
  transferPayments?: Maybe<Array<Maybe<Payment>>>
}

export type InvoiceAmountByStatusMonthResponse = {
  __typename: 'InvoiceAmountByStatusMonthResponse'
  average: Scalars['Float']['output']
  data: Array<InvoiceAmountMonth>
}

export type InvoiceAmountMonth = {
  __typename: 'InvoiceAmountMonth'
  data: Array<InvoiceAmountMonthStatus>
  month: Scalars['String']['output']
}

export type InvoiceAmountMonthStatus = {
  __typename: 'InvoiceAmountMonthStatus'
  status: Scalars['String']['output']
  value: Scalars['Float']['output']
}

export type InvoiceBnplConnection = {
  __typename: 'InvoiceBnplConnection'
  edges?: Maybe<Array<Maybe<InvoiceBnplEdge>>>
  pageInfo: PageInfo
}

export type InvoiceBnplEdge = {
  __typename: 'InvoiceBnplEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<Invoice>
}

/** A connection to a list of items. */
export type InvoiceConnection = {
  __typename: 'InvoiceConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InvoiceEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type InvoiceCountByStatusMonthResponse = {
  __typename: 'InvoiceCountByStatusMonthResponse'
  average: Scalars['Float']['output']
  data: Array<InvoiceCountMonth>
}

export type InvoiceCountMonth = {
  __typename: 'InvoiceCountMonth'
  data: Array<InvoiceCountMonthStatus>
  month: Scalars['String']['output']
}

export type InvoiceCountMonthStatus = {
  __typename: 'InvoiceCountMonthStatus'
  count: Scalars['Int']['output']
  status: Scalars['String']['output']
}

export type InvoiceCountResponse = {
  __typename: 'InvoiceCountResponse'
  value: Scalars['Int']['output']
}

/** An edge in a connection. */
export type InvoiceEdge = {
  __typename: 'InvoiceEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Invoice>
}

export type InvoiceFilter = {
  amountEnd?: InputMaybe<Scalars['Float']['input']>
  amountStart?: InputMaybe<Scalars['Float']['input']>
  createdDateEnd?: InputMaybe<Scalars['String']['input']>
  createdDateStart?: InputMaybe<Scalars['String']['input']>
  customerID?: InputMaybe<Scalars['String']['input']>
  dueDateEnd?: InputMaybe<Scalars['String']['input']>
  dueDateStart?: InputMaybe<Scalars['String']['input']>
  emailUnsent?: InputMaybe<Scalars['Boolean']['input']>
  invoiceNumber?: InputMaybe<Scalars['String']['input']>
  recurring?: InputMaybe<Scalars['Boolean']['input']>
  recurringpaymentID?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Array<InputMaybe<InvoiceStatusEnum>>>
}

export type InvoiceInput = {
  amount: Scalars['Float']['input']
  customerId: Scalars['String']['input']
  dueDate?: InputMaybe<Scalars['String']['input']>
  productName?: InputMaybe<Scalars['String']['input']>
}

export enum InvoiceNumberField {
  ExternalId = 'EXTERNAL_ID',
  ExternalInvoiceNumber = 'EXTERNAL_INVOICE_NUMBER'
}

export enum InvoiceNumberFields {
  HaloPsaId = 'HaloPsaID',
  ThirdPartyInvoiceNumber = 'ThirdPartyInvoiceNumber'
}

export type InvoiceOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<InvoiceOrderByField>
}

export enum InvoiceOrderByField {
  Amount = 'AMOUNT',
  CreatedDate = 'CREATED_DATE',
  DueDate = 'DUE_DATE',
  ProductName = 'PRODUCT_NAME'
}

export enum InvoicePdfStatus {
  Expired = 'EXPIRED',
  Failure = 'FAILURE',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type InvoicePayment = {
  __typename: 'InvoicePayment'
  Amount: Scalars['Float']['output']
  NetAmount: Scalars['Float']['output']
  id: Scalars['ID']['output']
  payoutCreationForecastDate?: Maybe<Scalars['String']['output']>
  status: PaymentStatusEnum
}

export enum InvoicePayoutMethodEnum {
  SameDayAch = 'SAME_DAY_ACH',
  StandardAch = 'STANDARD_ACH'
}

export type InvoicePdfLink = {
  __typename: 'InvoicePdfLink'
  expiresAt: Scalars['String']['output']
  status: InvoicePdfStatus
  url: Scalars['String']['output']
}

export type InvoicePreferences = {
  __typename: 'InvoicePreferences'
  invoiceNumberField: InvoiceNumberField
}

export type InvoiceRelation = {
  __typename: 'InvoiceRelation'
  amount: Scalars['Float']['output']
  createdAt: Scalars['String']['output']
  customer: Customer
  dueDate: Scalars['String']['output']
  id: Scalars['ID']['output']
  invoiceID?: Maybe<Scalars['String']['output']>
  invoiceNumber: Scalars['String']['output']
}

export type InvoiceReminder = {
  __typename: 'InvoiceReminder'
  createdAt?: Maybe<Scalars['String']['output']>
  daysOffset: Scalars['Int']['output']
  id: Scalars['ID']['output']
  template?: Maybe<EmailTemplate>
  type: InvoiceReminderType
}

export type InvoiceReminderExcludedCustomer = {
  __typename: 'InvoiceReminderExcludedCustomer'
  createdAt: Scalars['String']['output']
  customer: Customer
  id: Scalars['ID']['output']
}

export enum InvoiceReminderPreview {
  After = 'AFTER',
  Before = 'BEFORE',
  On = 'ON',
  OnCreation = 'ON_CREATION'
}

export type InvoiceReminderPreviewInput = {
  reminderID?: InputMaybe<Scalars['String']['input']>
  reminderPreview: InvoiceReminderPreview
}

export enum InvoiceReminderType {
  CreationDate = 'CREATION_DATE',
  DueDate = 'DUE_DATE'
}

export type InvoiceStatus = {
  __typename: 'InvoiceStatus'
  createdAt: Scalars['Time']['output']
  status: InvoiceStatusEnum
}

export enum InvoiceStatusEnum {
  Archived = 'ARCHIVED',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Received = 'RECEIVED',
  Upcoming = 'UPCOMING'
}

export type InvoiceSummary = {
  __typename: 'InvoiceSummary'
  createdAt?: Maybe<Scalars['String']['output']>
  customDay?: Maybe<Scalars['Int']['output']>
  frequency: InvoiceSummaryFrequency
  id: Scalars['ID']['output']
  lastSentAt?: Maybe<Scalars['String']['output']>
  startAt?: Maybe<Scalars['String']['output']>
  template?: Maybe<EmailTemplate>
}

export type InvoiceSummaryExcludedCustomer = {
  __typename: 'InvoiceSummaryExcludedCustomer'
  createdAt: Scalars['String']['output']
  customer: Customer
  id: Scalars['ID']['output']
}

export enum InvoiceSummaryFrequency {
  MonthlyCustomDay = 'MONTHLY_CUSTOM_DAY',
  MonthlyFirstDay = 'MONTHLY_FIRST_DAY',
  MonthlyLastDay = 'MONTHLY_LAST_DAY',
  Weekly = 'WEEKLY'
}

export type InvoiceSummaryPreviewInput = {
  summaryID?: InputMaybe<Scalars['String']['input']>
}

export type InvoiceTotals = {
  __typename: 'InvoiceTotals'
  amount: Scalars['Float']['output']
  count: Scalars['Int']['output']
  outstandingAmount: Scalars['Float']['output']
}

export type InvoiceVolumeResponse = {
  __typename: 'InvoiceVolumeResponse'
  value: Scalars['Float']['output']
}

export type LedgerMovementResult = {
  __typename: 'LedgerMovementResult'
  ledgerBalance: Scalars['Float']['output']
  movements: Array<MovementEntry>
}

export enum LedgerMovementType {
  AlternativeManualChange = 'ALTERNATIVE_MANUAL_CHANGE',
  AlternativePayment = 'ALTERNATIVE_PAYMENT',
  ExternalChange = 'EXTERNAL_CHANGE',
  ExternalCredit = 'EXTERNAL_CREDIT',
  ExternalPayment = 'EXTERNAL_PAYMENT'
}

export type Lending = {
  __typename: 'Lending'
  amount: Scalars['Float']['output']
  creationDate: Scalars['String']['output']
  customer: Customer
  id: Scalars['ID']['output']
  installments?: Maybe<Array<Maybe<Installment>>>
  netAmount: Scalars['Float']['output']
  partner: Partner
  payerEntity: CompanyType
  product: Product
}

export enum LendingPaymentMethodEnum {
  Ach = 'ACH',
  Card = 'CARD',
  Manual = 'MANUAL',
  SameDayAch = 'SAME_DAY_ACH'
}

export type LendingPaymentMethodInput = {
  method: LendingPaymentMethodEnum
  methodReferenceID: Scalars['String']['input']
}

export type LineItem = {
  __typename: 'LineItem'
  category?: Maybe<Scalars['String']['output']>
  code?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  extendedAmountPerItem?: Maybe<Scalars['Float']['output']>
  quantity?: Maybe<Scalars['Float']['output']>
}

export type ListAccountingSyncBatchesFilter = {
  PlatformName?: InputMaybe<PlatformName>
}

export type ListAccountingSyncBatchesReply = {
  __typename: 'ListAccountingSyncBatchesReply'
  edges?: Maybe<Array<Maybe<AccountingSyncBatchEdge>>>
  pageInfo: PageInfo
}

export type ListAccountingSyncJobsReply = {
  __typename: 'ListAccountingSyncJobsReply'
  jobs?: Maybe<Array<AccountingSyncJob>>
}

export type ListCardsFilterInput = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export enum ManualAccountSubtypes {
  Checking = 'CHECKING',
  Savings = 'SAVINGS'
}

export enum ManualAccountTypes {
  Depository = 'DEPOSITORY'
}

export type ManualBankingAccountInformationInput = {
  accountNumber: Scalars['String']['input']
  institutionName: Scalars['String']['input']
  receiverName: Scalars['String']['input']
  routingNumber: Scalars['String']['input']
  subType: ManualAccountSubtypes
  type: ManualAccountTypes
  wireRoutingNumber?: InputMaybe<Scalars['String']['input']>
}

export enum MethodEnum {
  Card = 'CARD',
  Manual = 'MANUAL',
  SameDayAch = 'SAME_DAY_ACH',
  StandardAch = 'STANDARD_ACH'
}

export type MovementEntry = {
  __typename: 'MovementEntry'
  balance: Scalars['Float']['output']
  movementType: LedgerMovementType
  movements: Array<Scalars['Float']['output']>
}

export type Mutation = {
  __typename: 'Mutation'
  ActivatePartnerPaymentsPortal?: Maybe<Partner>
  BNPLOfferConfirmByToken?: Maybe<Scalars['String']['output']>
  CreateCompanyIndividual: CompanyIndividual
  DeleteCompanyIndividual: Scalars['String']['output']
  OAuth2Exchange: TokenExchange
  OAuth2Refresh: TokenExchange
  PartnerAccountingPreferencesUpdate?: Maybe<AccountingPreferences>
  PartnerAccountingSyncBatchCreate?: Maybe<AccountingSyncBatchCreateReply>
  PartnerAccountingSyncConfigCreate: SyncConfig
  PartnerAccountingSyncConfigUpdate: SyncConfig
  PartnerAddCustomerManualBankingConnection?: Maybe<Scalars['String']['output']>
  PartnerAddManualBankingConnection?: Maybe<Scalars['String']['output']>
  PartnerApprovePendingCustomerUser?: Maybe<CustomerUser>
  PartnerArchiveAccount: Scalars['String']['output']
  PartnerArchiveCustomer?: Maybe<Customer>
  PartnerArchiveCustomerAccount: Scalars['String']['output']
  PartnerAutopayExcludedCustomerCreate?: Maybe<AutopayExcludedCustomer>
  PartnerAutopayExcludedCustomerDelete?: Maybe<Scalars['String']['output']>
  PartnerAutopayExcludedCustomerUpdate?: Maybe<
    Array<Maybe<AutopayExcludedCustomer>>
  >
  PartnerAutopayExcludedInvoiceBatchCreate?: Maybe<Scalars['String']['output']>
  PartnerAutopayExcludedInvoiceCreate?: Maybe<Scalars['String']['output']>
  PartnerAutopayExcludedInvoiceDelete?: Maybe<Scalars['String']['output']>
  PartnerAutotaskConnectionCreate?: Maybe<AutotaskQueryFilters>
  PartnerAutotaskConnectionUpdate?: Maybe<Scalars['String']['output']>
  PartnerBNPLOfferConfirm?: Maybe<Scalars['String']['output']>
  PartnerBatchTagCustomers: Scalars['String']['output']
  PartnerBulkToggleArchiveCustomers: Scalars['String']['output']
  PartnerCancelCollection?: Maybe<Scalars['String']['output']>
  PartnerCancelScheduledPayment?: Maybe<Scalars['String']['output']>
  PartnerCancelSubscription?: Maybe<PartnerSubscription>
  PartnerChangeBulkCustomerFeeConfig?: Maybe<Scalars['String']['output']>
  PartnerChangeCustomPartnerFeeConfig?: Maybe<Scalars['String']['output']>
  PartnerChangeCustomerFeeConfig?: Maybe<Scalars['String']['output']>
  PartnerChangeCustomerPaymentConfig?: Maybe<Scalars['String']['output']>
  PartnerChangeDefaultPayoutBankingAccount?: Maybe<Scalars['String']['output']>
  PartnerChangePartnerAutopayConfig?: Maybe<Scalars['String']['output']>
  PartnerChangePartnerFeeConfig?: Maybe<Scalars['String']['output']>
  PartnerChangePaymentConfig?: Maybe<Scalars['String']['output']>
  PartnerChangeReferralPayoutBankingAccount?: Maybe<Scalars['String']['output']>
  PartnerConnectWiseConnectionCreate?: Maybe<ConnectWiseQueryFilters>
  PartnerConnectWiseConnectionUpdate?: Maybe<Scalars['String']['output']>
  PartnerCreateApiKey?: Maybe<CreateApiKeyResponse>
  PartnerCreateAutopayRule?: Maybe<AutopayRule>
  PartnerCreateCard?: Maybe<Scalars['String']['output']>
  PartnerCreateCollection?: Maybe<Scalars['String']['output']>
  PartnerCreateCustomer?: Maybe<Customer>
  PartnerCreateCustomerCard?: Maybe<Scalars['String']['output']>
  PartnerCreateCustomerTag: Scalars['String']['output']
  PartnerCreateCustomerUser?: Maybe<CustomerUser>
  PartnerCreateEmailTemplate: EmailTemplate
  PartnerCreateInvoiceReminder?: Maybe<InvoiceReminder>
  PartnerCreateInvoiceReminderExcludedCustomer?: Maybe<InvoiceReminderExcludedCustomer>
  PartnerCreateInvoiceSummary?: Maybe<InvoiceSummary>
  PartnerCreateInvoiceSummaryExcludedCustomer?: Maybe<InvoiceSummaryExcludedCustomer>
  PartnerCreateReferral: Scalars['String']['output']
  PartnerDatagateConnectionCreate?: Maybe<Scalars['String']['output']>
  PartnerDeleteAutopayRule?: Maybe<Scalars['String']['output']>
  PartnerDeleteCard?: Maybe<Scalars['String']['output']>
  PartnerDeleteCustomerCard?: Maybe<Scalars['String']['output']>
  PartnerDeleteCustomerTag: Scalars['String']['output']
  PartnerDeleteCustomerUser?: Maybe<Scalars['String']['output']>
  PartnerDeleteEmailTemplate: Scalars['String']['output']
  PartnerDeleteInvoiceReminder?: Maybe<Scalars['String']['output']>
  PartnerDeleteInvoiceReminderExcludedCustomer?: Maybe<
    Scalars['String']['output']
  >
  PartnerDeleteInvoiceSummary?: Maybe<Scalars['String']['output']>
  PartnerDeleteInvoiceSummaryExcludedCustomer?: Maybe<
    Scalars['String']['output']
  >
  PartnerDeleteUser?: Maybe<Scalars['String']['output']>
  PartnerFinishOnboarding?: Maybe<Partner>
  PartnerHaloPSAConnectionCreate?: Maybe<PartnerHaloPsaConnectionCreateReply>
  PartnerIntegrationDisconnect?: Maybe<Scalars['String']['output']>
  PartnerIntegrationSync?: Maybe<IntegrationSyncReply>
  PartnerInviteUser?: Maybe<PartnerUser>
  PartnerInvoiceArchive?: Maybe<Invoice>
  PartnerInvoiceBulkChargeOnDate?: Maybe<Scalars['String']['output']>
  PartnerInvoiceBulkChargeOnDueDate?: Maybe<Scalars['String']['output']>
  PartnerInvoiceCreate?: Maybe<Invoice>
  PartnerInvoicePaidUpdate?: Maybe<Invoice>
  PartnerInvoiceRemind?: Maybe<Scalars['String']['output']>
  PartnerInvoiceUnarchive?: Maybe<Invoice>
  PartnerLinkPendingCustomerUser?: Maybe<PendingCustomerUser>
  PartnerModernBancGenerateSerializedToken?: Maybe<Scalars['String']['output']>
  PartnerPayInvoice?: Maybe<Scalars['String']['output']>
  PartnerPayOverdueInstallment?: Maybe<Scalars['String']['output']>
  PartnerPayoutTimingUpsertCompanyConfig?: Maybe<Scalars['String']['output']>
  PartnerQuickbooksAccountUpdate?: Maybe<Scalars['String']['output']>
  PartnerQuickbooksConnectionCreate?: Maybe<Scalars['String']['output']>
  PartnerQuickbooksConnectionUpdate?: Maybe<Scalars['String']['output']>
  PartnerRecurringPaymentCreate?: Maybe<RecurringPayment>
  PartnerRecurringPaymentDeactivate?: Maybe<Scalars['String']['output']>
  PartnerRecurringPaymentUpdate?: Maybe<Scalars['String']['output']>
  PartnerRejectPendingCustomerUser?: Maybe<PendingCustomerUser>
  PartnerReschedulePayment?: Maybe<Scalars['String']['output']>
  PartnerRevokeApiKey: Scalars['String']['output']
  PartnerRutterAccountUnset?: Maybe<Scalars['String']['output']>
  PartnerRutterAccountUpsert?: Maybe<Scalars['String']['output']>
  PartnerRutterAccountUpsertMany?: Maybe<Scalars['String']['output']>
  PartnerRutterConnectionCreate?: Maybe<RutterConnection>
  PartnerRutterConnectionUpdate?: Maybe<RutterConnection>
  PartnerSecondaryIntegrationDelete?: Maybe<Scalars['String']['output']>
  PartnerSendInvoiceReminderPreview?: Maybe<Scalars['String']['output']>
  PartnerSendInvoiceSummaryPreview?: Maybe<Scalars['String']['output']>
  PartnerSendReferral: Scalars['String']['output']
  PartnerSendReport: Scalars['String']['output']
  PartnerSuperopsConnectionCreate?: Maybe<Scalars['String']['output']>
  PartnerTagCustomer: Scalars['String']['output']
  PartnerToggleEmailTemplateFavorite: Scalars['String']['output']
  PartnerTogglePaymentsPortalCustomInvoices?: Maybe<Partner>
  PartnerToggleRequiresMFA?: Maybe<Partner>
  PartnerUnarchiveCustomer?: Maybe<Customer>
  PartnerUnlinkPendingCustomerUser?: Maybe<PendingCustomerUser>
  PartnerUntagCustomer: Scalars['String']['output']
  PartnerUpdateAddress?: Maybe<Partner>
  PartnerUpdateApiKey: Scalars['String']['output']
  PartnerUpdateAutopayRule?: Maybe<AutopayRule>
  PartnerUpdateCustomer?: Maybe<Customer>
  PartnerUpdateCustomerTag: Scalars['String']['output']
  PartnerUpdateCustomerUser?: Maybe<CustomerUser>
  PartnerUpdateDetails?: Maybe<Partner>
  PartnerUpdateEmailTemplate: Scalars['String']['output']
  PartnerUpdateInvoiceReminderExcludedCustomer?: Maybe<
    Array<Maybe<InvoiceReminderExcludedCustomer>>
  >
  PartnerUpdateInvoiceSummaryExcludedCustomer?: Maybe<
    Array<Maybe<InvoiceSummaryExcludedCustomer>>
  >
  PartnerUpdateMyUser?: Maybe<PartnerUser>
  PartnerUpdateName?: Maybe<Partner>
  PartnerUpdateNotificationsEnabled: NotificationsEnabled
  PartnerUpdatePaymentsPortalCustomization?: Maybe<Partner>
  PartnerUpdatePaymentsPortalMethods?: Maybe<Partner>
  PartnerUpdateReferral: Scalars['String']['output']
  PartnerUpdateReminderTemplate?: Maybe<Scalars['String']['output']>
  PartnerUpdateSummaryTemplate?: Maybe<Scalars['String']['output']>
  PartnerUpdateUser?: Maybe<PartnerUser>
  PartnerUpsertInvoicePreferences?: Maybe<Scalars['String']['output']>
  SetCustomerAutopayConfig?: Maybe<Scalars['Boolean']['output']>
  SolveAdyenRemediationActions: Scalars['String']['output']
  SolveRemediationActionsByIDs: Scalars['String']['output']
  StagingEnablePartnerPaymentsPortal?: Maybe<Partner>
  StagingStartAdyenOnboarding?: Maybe<StartAdyenOnboardingReply>
  UpdateCompanyIndividual: Scalars['String']['output']
  UploadAdyenDocument: UploadAdyenDocumentResponse
  UploadPartnerDocument: Scalars['String']['output']
  UpsertSupportPreferences?: Maybe<SupportPreferences>
  createRefund: Scalars['Boolean']['output']
}

export type MutationBnplOfferConfirmByTokenArgs = {
  confirmationToken: Scalars['String']['input']
}

export type MutationCreateCompanyIndividualArgs = {
  input: CreateCompanyIndividualInput
}

export type MutationDeleteCompanyIndividualArgs = {
  id: Scalars['ID']['input']
}

export type MutationOAuth2ExchangeArgs = {
  code: Scalars['String']['input']
  state: Scalars['String']['input']
}

export type MutationOAuth2RefreshArgs = {
  refreshToken: Scalars['String']['input']
}

export type MutationPartnerAccountingPreferencesUpdateArgs = {
  input?: InputMaybe<AccountingPreferencesUpdateInput>
}

export type MutationPartnerAccountingSyncBatchCreateArgs = {
  input?: InputMaybe<AccountingSyncBatchCreateInput>
}

export type MutationPartnerAccountingSyncConfigCreateArgs = {
  input: SyncConfigCreateInput
}

export type MutationPartnerAccountingSyncConfigUpdateArgs = {
  input: SyncConfigUpdateInput
}

export type MutationPartnerAddCustomerManualBankingConnectionArgs = {
  accountInformation: ManualBankingAccountInformationInput
  customerID: Scalars['String']['input']
}

export type MutationPartnerAddManualBankingConnectionArgs = {
  accountInformation: ManualBankingAccountInformationInput
}

export type MutationPartnerApprovePendingCustomerUserArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerArchiveAccountArgs = {
  accountID: Scalars['ID']['input']
}

export type MutationPartnerArchiveCustomerArgs = {
  input: PartnerArchiveCustomerInput
}

export type MutationPartnerArchiveCustomerAccountArgs = {
  accountID: Scalars['ID']['input']
  customerID: Scalars['ID']['input']
}

export type MutationPartnerAutopayExcludedCustomerCreateArgs = {
  customerID: Scalars['ID']['input']
}

export type MutationPartnerAutopayExcludedCustomerDeleteArgs = {
  customerID: Scalars['ID']['input']
}

export type MutationPartnerAutopayExcludedCustomerUpdateArgs = {
  customerIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type MutationPartnerAutopayExcludedInvoiceBatchCreateArgs = {
  excludeInvoices: Array<AutopayExcludedInvoiceCreateInput>
}

export type MutationPartnerAutopayExcludedInvoiceCreateArgs = {
  customerID: Scalars['ID']['input']
  invoiceID: Scalars['ID']['input']
}

export type MutationPartnerAutopayExcludedInvoiceDeleteArgs = {
  invoiceID: Scalars['ID']['input']
}

export type MutationPartnerAutotaskConnectionCreateArgs = {
  input?: InputMaybe<PartnerAutotaskConnectionCreateInput>
}

export type MutationPartnerAutotaskConnectionUpdateArgs = {
  input?: InputMaybe<PartnerAutotaskConnectionUpdateInput>
}

export type MutationPartnerBnplOfferConfirmArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerBatchTagCustomersArgs = {
  customerIDs: Array<Scalars['ID']['input']>
  tagID: Scalars['ID']['input']
}

export type MutationPartnerBulkToggleArchiveCustomersArgs = {
  input: BulkToggleArchiveCustomersInput
}

export type MutationPartnerCancelCollectionArgs = {
  collectionID: Scalars['String']['input']
  reason: Scalars['String']['input']
}

export type MutationPartnerCancelScheduledPaymentArgs = {
  paymentID: Scalars['UUID']['input']
}

export type MutationPartnerCancelSubscriptionArgs = {
  input: CancelSubscriptionInput
}

export type MutationPartnerChangeBulkCustomerFeeConfigArgs = {
  customerFeeConfig: PartnerChangeBulkCustomerFeeConfigInput
}

export type MutationPartnerChangeCustomPartnerFeeConfigArgs = {
  customPartnerFeeConfig: CustomPartnerFeeConfigUpsertInput
}

export type MutationPartnerChangeCustomerFeeConfigArgs = {
  customerFeeConfig: PartnerChangeCustomerFeeConfigInput
}

export type MutationPartnerChangeCustomerPaymentConfigArgs = {
  customerID: Scalars['ID']['input']
  paymentConfig: PaymentCompanyConfigUpdateInput
}

export type MutationPartnerChangeDefaultPayoutBankingAccountArgs = {
  input: PartnerDefaultPayoutBankingAccountUpdateInput
}

export type MutationPartnerChangePartnerAutopayConfigArgs = {
  partnerAutopayConfig: PartnerAutopayConfigUpdateInput
}

export type MutationPartnerChangePartnerFeeConfigArgs = {
  partnerFeeConfig: PartnerFeeConfigUpdateInput
}

export type MutationPartnerChangePaymentConfigArgs = {
  paymentConfig: PaymentCompanyConfigUpdateInput
}

export type MutationPartnerChangeReferralPayoutBankingAccountArgs = {
  input: PartnerDefaultPayoutBankingAccountUpdateInput
}

export type MutationPartnerConnectWiseConnectionCreateArgs = {
  input?: InputMaybe<PartnerConnectWiseConnectionCreateInput>
}

export type MutationPartnerConnectWiseConnectionUpdateArgs = {
  input?: InputMaybe<ConnectWiseQueryFiltersInput>
}

export type MutationPartnerCreateApiKeyArgs = {
  input: CreateApiKeyInput
}

export type MutationPartnerCreateAutopayRuleArgs = {
  input: PartnerCreateAutopayRuleInput
}

export type MutationPartnerCreateCardArgs = {
  input: CardCreationInput
}

export type MutationPartnerCreateCollectionArgs = {
  createInput: CollectionCreateInput
}

export type MutationPartnerCreateCustomerArgs = {
  input?: InputMaybe<PartnerCreateCustomerInput>
}

export type MutationPartnerCreateCustomerCardArgs = {
  customerID: Scalars['ID']['input']
  input: CardCreationInput
}

export type MutationPartnerCreateCustomerTagArgs = {
  input: PartnerCreateCustomerTagInput
}

export type MutationPartnerCreateCustomerUserArgs = {
  input?: InputMaybe<PartnerCreateCustomerUserInput>
}

export type MutationPartnerCreateEmailTemplateArgs = {
  input: CreateEmailTemplateInput
}

export type MutationPartnerCreateInvoiceReminderArgs = {
  daysOffset: Scalars['Int']['input']
  templateID?: InputMaybe<Scalars['ID']['input']>
  type: InvoiceReminderType
}

export type MutationPartnerCreateInvoiceReminderExcludedCustomerArgs = {
  customerID: Scalars['ID']['input']
}

export type MutationPartnerCreateInvoiceSummaryArgs = {
  input?: InputMaybe<PartnerCreateInvoiceSummaryInput>
}

export type MutationPartnerCreateInvoiceSummaryExcludedCustomerArgs = {
  customerID: Scalars['ID']['input']
}

export type MutationPartnerCreateReferralArgs = {
  input: CreateReferralInput
}

export type MutationPartnerDatagateConnectionCreateArgs = {
  input?: InputMaybe<DatagateConnectionCreateInput>
}

export type MutationPartnerDeleteAutopayRuleArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerDeleteCardArgs = {
  input: CardDeletionInput
}

export type MutationPartnerDeleteCustomerCardArgs = {
  customerID: Scalars['ID']['input']
  input: CardDeletionInput
}

export type MutationPartnerDeleteCustomerTagArgs = {
  ID: Scalars['ID']['input']
}

export type MutationPartnerDeleteCustomerUserArgs = {
  id: Scalars['String']['input']
}

export type MutationPartnerDeleteEmailTemplateArgs = {
  input: DeleteEmailTemplateInput
}

export type MutationPartnerDeleteInvoiceReminderArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerDeleteInvoiceReminderExcludedCustomerArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerDeleteInvoiceSummaryArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerDeleteInvoiceSummaryExcludedCustomerArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerDeleteUserArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerHaloPsaConnectionCreateArgs = {
  input?: InputMaybe<PartnerHaloPsaConnectionCreateInput>
}

export type MutationPartnerIntegrationDisconnectArgs = {
  input?: InputMaybe<IntegrationDisconnectInput>
}

export type MutationPartnerIntegrationSyncArgs = {
  input?: InputMaybe<IntegrationSyncInput>
}

export type MutationPartnerInviteUserArgs = {
  input?: InputMaybe<PartnerInviteUserInput>
}

export type MutationPartnerInvoiceArchiveArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerInvoiceBulkChargeOnDateArgs = {
  invoiceIds?: InputMaybe<Array<Scalars['ID']['input']>>
  paymentDate?: InputMaybe<Scalars['String']['input']>
}

export type MutationPartnerInvoiceBulkChargeOnDueDateArgs = {
  invoiceIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type MutationPartnerInvoiceCreateArgs = {
  input?: InputMaybe<InvoiceInput>
}

export type MutationPartnerInvoicePaidUpdateArgs = {
  input?: InputMaybe<PartnerInvoicePaidUpdateInput>
}

export type MutationPartnerInvoiceRemindArgs = {
  invoiceID: Scalars['String']['input']
}

export type MutationPartnerInvoiceUnarchiveArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerLinkPendingCustomerUserArgs = {
  customerId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationPartnerModernBancGenerateSerializedTokenArgs = {
  input: CardSerializationInput
}

export type MutationPartnerPayInvoiceArgs = {
  amount: Scalars['Float']['input']
  customerID: Scalars['String']['input']
  idempotencyKey?: InputMaybe<Scalars['String']['input']>
  invoiceID: Scalars['String']['input']
  paymentDate?: InputMaybe<Scalars['String']['input']>
  paymentMethod: PayInvoicePaymentMethodInput
}

export type MutationPartnerPayOverdueInstallmentArgs = {
  installmentID: Scalars['String']['input']
  newPaymentMethod?: InputMaybe<LendingPaymentMethodInput>
  retryLastPaymentMethod: Scalars['Boolean']['input']
}

export type MutationPartnerPayoutTimingUpsertCompanyConfigArgs = {
  planId: Scalars['ID']['input']
}

export type MutationPartnerQuickbooksAccountUpdateArgs = {
  input?: InputMaybe<QuickbooksAccountUpdateInput>
}

export type MutationPartnerQuickbooksConnectionCreateArgs = {
  code: Scalars['String']['input']
  integrationType: IntegrationType
  realmId: Scalars['String']['input']
  state: Scalars['String']['input']
}

export type MutationPartnerQuickbooksConnectionUpdateArgs = {
  createDeposits?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationPartnerRecurringPaymentCreateArgs = {
  input: RecurringPaymentCreateInput
}

export type MutationPartnerRecurringPaymentDeactivateArgs = {
  input: RecurringPaymentDeactivateInput
}

export type MutationPartnerRecurringPaymentUpdateArgs = {
  input: RecurringPaymentUpdateInput
}

export type MutationPartnerRejectPendingCustomerUserArgs = {
  id: Scalars['ID']['input']
}

export type MutationPartnerReschedulePaymentArgs = {
  newDueDate: Scalars['Time']['input']
  paymentID: Scalars['UUID']['input']
}

export type MutationPartnerRevokeApiKeyArgs = {
  keyID: Scalars['String']['input']
}

export type MutationPartnerRutterAccountUnsetArgs = {
  input?: InputMaybe<RutterAccountUnsetInput>
}

export type MutationPartnerRutterAccountUpsertArgs = {
  input?: InputMaybe<RutterAccountUpsertInput>
}

export type MutationPartnerRutterAccountUpsertManyArgs = {
  input?: InputMaybe<RutterAccountUpsertManyInput>
}

export type MutationPartnerRutterConnectionCreateArgs = {
  input?: InputMaybe<ConnectionCreateInput>
}

export type MutationPartnerRutterConnectionUpdateArgs = {
  input?: InputMaybe<ConnectionUpdateInput>
}

export type MutationPartnerSecondaryIntegrationDeleteArgs = {
  input: SecondaryIntegrationDeleteInput
}

export type MutationPartnerSendInvoiceReminderPreviewArgs = {
  input?: InputMaybe<InvoiceReminderPreviewInput>
}

export type MutationPartnerSendInvoiceSummaryPreviewArgs = {
  input?: InputMaybe<InvoiceSummaryPreviewInput>
}

export type MutationPartnerSendReferralArgs = {
  input: SendPartnerReferralInput
}

export type MutationPartnerSendReportArgs = {
  dateFrom?: InputMaybe<Scalars['String']['input']>
  dateTo?: InputMaybe<Scalars['String']['input']>
  reportType: ReportType
  timezone?: InputMaybe<Scalars['String']['input']>
}

export type MutationPartnerSuperopsConnectionCreateArgs = {
  input?: InputMaybe<SuperopsConnectionCreateInput>
}

export type MutationPartnerTagCustomerArgs = {
  customerID: Scalars['ID']['input']
  tagID: Scalars['ID']['input']
}

export type MutationPartnerToggleEmailTemplateFavoriteArgs = {
  templateID: Scalars['ID']['input']
}

export type MutationPartnerTogglePaymentsPortalCustomInvoicesArgs = {
  paymentsPortalCustomInvoices: Scalars['Boolean']['input']
}

export type MutationPartnerToggleRequiresMfaArgs = {
  requiresMFA: Scalars['Boolean']['input']
}

export type MutationPartnerUnarchiveCustomerArgs = {
  input: PartnerUnarchiveCustomerInput
}

export type MutationPartnerUnlinkPendingCustomerUserArgs = {
  customerId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationPartnerUntagCustomerArgs = {
  customerID: Scalars['ID']['input']
  tagID: Scalars['ID']['input']
}

export type MutationPartnerUpdateAddressArgs = {
  input?: InputMaybe<PartnerUpdateAddressInput>
}

export type MutationPartnerUpdateApiKeyArgs = {
  input: UpdateApiKeyInput
}

export type MutationPartnerUpdateAutopayRuleArgs = {
  input: PartnerUpdateAutopayRuleInput
}

export type MutationPartnerUpdateCustomerArgs = {
  input?: InputMaybe<PartnerUpdateCustomerInput>
}

export type MutationPartnerUpdateCustomerTagArgs = {
  input: PartnerUpdateCustomerTagInput
}

export type MutationPartnerUpdateCustomerUserArgs = {
  input?: InputMaybe<PartnerUpdateCustomerUserInput>
}

export type MutationPartnerUpdateDetailsArgs = {
  input?: InputMaybe<PartnerUpdateDetailsInput>
}

export type MutationPartnerUpdateEmailTemplateArgs = {
  input: UpdateEmailTemplateInput
}

export type MutationPartnerUpdateInvoiceReminderExcludedCustomerArgs = {
  customerIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type MutationPartnerUpdateInvoiceSummaryExcludedCustomerArgs = {
  customerIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type MutationPartnerUpdateMyUserArgs = {
  input?: InputMaybe<PartnerUpdateMyUserInput>
}

export type MutationPartnerUpdateNameArgs = {
  input: UpdatePartnerNameInput
}

export type MutationPartnerUpdateNotificationsEnabledArgs = {
  notificationsEnabled: Scalars['Boolean']['input']
}

export type MutationPartnerUpdatePaymentsPortalCustomizationArgs = {
  input?: InputMaybe<PartnerPaymentsPortalCustomizationInput>
}

export type MutationPartnerUpdatePaymentsPortalMethodsArgs = {
  methods: Array<PartnerPaymentsPortalMethod>
}

export type MutationPartnerUpdateReferralArgs = {
  input: UpdateReferralInput
}

export type MutationPartnerUpdateReminderTemplateArgs = {
  id: Scalars['ID']['input']
  templateID?: InputMaybe<Scalars['ID']['input']>
}

export type MutationPartnerUpdateSummaryTemplateArgs = {
  id: Scalars['ID']['input']
  templateID?: InputMaybe<Scalars['ID']['input']>
}

export type MutationPartnerUpdateUserArgs = {
  input?: InputMaybe<PartnerUpdateUserInput>
}

export type MutationPartnerUpsertInvoicePreferencesArgs = {
  input?: InputMaybe<UpsertInvoicePreferencesInput>
}

export type MutationSetCustomerAutopayConfigArgs = {
  input: UpsertCustomerAutopayConfigInput
}

export type MutationSolveRemediationActionsByIDsArgs = {
  actionIDs: Array<Scalars['String']['input']>
}

export type MutationStagingEnablePartnerPaymentsPortalArgs = {
  url: Scalars['String']['input']
}

export type MutationUpdateCompanyIndividualArgs = {
  input: UpdateCompanyIndividualInput
}

export type MutationUploadAdyenDocumentArgs = {
  document: UploadAdyenDocumentInput
}

export type MutationUploadPartnerDocumentArgs = {
  input: UploadPartnerDocumentInput
}

export type MutationUpsertSupportPreferencesArgs = {
  input: UpsertSupportPreferencesInput
}

export type MutationCreateRefundArgs = {
  input: RefundCreateInput
}

export type NotificationsEnabled = {
  __typename: 'NotificationsEnabled'
  id: Scalars['ID']['output']
  notificationsEnabled: Scalars['Boolean']['output']
}

export type NumberOfOverdueInvoicesThirtyDaysResponse = {
  __typename: 'NumberOfOverdueInvoicesThirtyDaysResponse'
  value: Scalars['Int']['output']
}

export type NumberOfPaymentsResponse = {
  __typename: 'NumberOfPaymentsResponse'
  value: Scalars['Int']['output']
}

export type Offer = {
  __typename: 'Offer'
  accepted: Scalars['Boolean']['output']
  acceptedAmount?: Maybe<Scalars['Float']['output']>
  acceptedRate?: Maybe<Scalars['Float']['output']>
  acceptedTerm?: Maybe<Scalars['Int']['output']>
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  lending?: Maybe<Lending>
  maxAmount: Scalars['Float']['output']
  maxRate: Scalars['Float']['output']
  maxTerm: Scalars['Int']['output']
  minAmount: Scalars['Float']['output']
  minRate: Scalars['Float']['output']
  minTerm: Scalars['Int']['output']
  status: OfferStatus
}

export enum OfferPayoutMethodEnum {
  Manual = 'MANUAL'
}

export enum OfferStatus {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Review = 'REVIEW'
}

/** Possible directions in which to order a list of items when provided an `orderBy` argument. */
export enum OrderDirection {
  /** Specifies an ascending order for a given `orderBy` argument. */
  Asc = 'ASC',
  /** Specifies a descending order for a given `orderBy` argument. */
  Desc = 'DESC'
}

export type OverdueInvoiceCountResponse = {
  __typename: 'OverdueInvoiceCountResponse'
  value: Scalars['Int']['output']
}

export type OverdueInvoicePercentageResponse = {
  __typename: 'OverdueInvoicePercentageResponse'
  value: Scalars['Float']['output']
}

export type OverdueInvoiceVolumeResponse = {
  __typename: 'OverdueInvoiceVolumeResponse'
  value: Scalars['Float']['output']
}

export type OverdueInvoicesVolumeThirtyDaysResponse = {
  __typename: 'OverdueInvoicesVolumeThirtyDaysResponse'
  value: Scalars['Float']['output']
}

/**
 * Information about pagination in a connection.
 * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
 */
export type PageInfo = {
  __typename: 'PageInfo'
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output']
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>
}

export type Pagination = {
  limit?: Scalars['Int']['input']
  page?: Scalars['Int']['input']
}

export type Partner = AddressInterface & {
  __typename: 'Partner'
  adyenBusinessSetup?: Maybe<AdyenBusinessSetup>
  adyenCompanyType?: Maybe<AdyenCompanyType>
  adyenIndustryCode?: Maybe<Scalars['String']['output']>
  adyenOnboardingStatus: AdyenOnboardingStatusStep
  city?: Maybe<Scalars['String']['output']>
  companyType?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  countryCode?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['String']['output']
  description?: Maybe<Scalars['String']['output']>
  ein?: Maybe<Scalars['String']['output']>
  hasBankStatementUploaded: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  industry?: Maybe<Scalars['String']['output']>
  insightsEnabled: Scalars['Boolean']['output']
  isDeactivated: Scalars['Boolean']['output']
  isOnboarded: Scalars['Boolean']['output']
  isValidToOnboarding: Scalars['Boolean']['output']
  legalName?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  paymentsPortalCustomInvoices?: Maybe<Scalars['Boolean']['output']>
  paymentsPortalCustomUrl?: Maybe<Scalars['String']['output']>
  paymentsPortalCustomization: PartnerPaymentsPortalCustomization
  paymentsPortalDefaultUrl?: Maybe<Scalars['String']['output']>
  paymentsPortalEnabled: Scalars['Boolean']['output']
  paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
  paymentsPortalUrl?: Maybe<Scalars['String']['output']>
  paymentsPortalUseCustomUrl?: Maybe<Scalars['Boolean']['output']>
  phone?: Maybe<Scalars['String']['output']>
  postalCode?: Maybe<Scalars['String']['output']>
  requiresMFA: Scalars['Boolean']['output']
  state?: Maybe<Scalars['String']['output']>
  stateCode?: Maybe<Scalars['String']['output']>
  streetAddress?: Maybe<Scalars['String']['output']>
  subPremise?: Maybe<Scalars['String']['output']>
  tosAndPciAccepted: Scalars['Boolean']['output']
  website?: Maybe<Scalars['String']['output']>
}

export type PartnerArchiveCustomerInput = {
  id: Scalars['ID']['input']
}

export type PartnerAutopayConfig = {
  __typename: 'PartnerAutopayConfig'
  allowCustomerEdit?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  partner: Partner
}

export type PartnerAutopayConfigUpdateInput = {
  allowCustomerEdit?: InputMaybe<Scalars['Boolean']['input']>
}

export type PartnerAutotaskConnectionCreateInput = {
  email: Scalars['String']['input']
  integrationType: IntegrationType
  invoiceNumberField: AutotaskInvoiceNumberField
  secret: Scalars['String']['input']
  username: Scalars['String']['input']
}

export type PartnerAutotaskConnectionUpdateInput = {
  companyClassifications?: InputMaybe<Array<InputMaybe<AutotaskFilterInput>>>
  companyTerritoryIDs?: InputMaybe<Array<InputMaybe<AutotaskFilterInput>>>
  companyTypes?: InputMaybe<Array<InputMaybe<AutotaskFilterInput>>>
  companyUserDefinedFields?: InputMaybe<
    Array<InputMaybe<AutotaskUserDefinedFieldInput>>
  >
  contactUserDefinedFields?: InputMaybe<
    Array<InputMaybe<AutotaskUserDefinedFieldInput>>
  >
  invoiceCreatedSince?: InputMaybe<Scalars['String']['input']>
}

export type PartnerChangeBulkCustomerFeeConfigInput = {
  customerIDs: Array<Scalars['UUID']['input']>
  feeType: FeeExceptionType
}

export type PartnerChangeCustomerFeeConfigInput = {
  action: CustomerFeeConfigAction
  customerID?: InputMaybe<Scalars['UUID']['input']>
  feeType?: InputMaybe<FeeExceptionType>
  id?: InputMaybe<Scalars['UUID']['input']>
}

export type PartnerCompanyConfigUpdateInput = {
  invoicePayoutMethod?: InputMaybe<InvoicePayoutMethodEnum>
  offerPayoutMethod?: InputMaybe<OfferPayoutMethodEnum>
  referralPayoutMethod?: InputMaybe<ReferralPayoutMethodEnum>
}

export type PartnerConnectWiseConnectionCreateInput = {
  CompanyID: Scalars['String']['input']
  IntegrationType: IntegrationType
  PrivateKey: Scalars['String']['input']
  PublicKey: Scalars['String']['input']
  SiteURL?: InputMaybe<Scalars['String']['input']>
}

export type PartnerConnection = {
  __typename: 'PartnerConnection'
  edges?: Maybe<Array<Maybe<PartnerEdge>>>
  pageInfo: PageInfo
}

export type PartnerCoverFeeConfigInput = {
  coverACHMethodFee?: InputMaybe<Scalars['Boolean']['input']>
  coverCardMethodFee?: InputMaybe<Scalars['Boolean']['input']>
  coverOtherMethodFee?: InputMaybe<Scalars['Boolean']['input']>
  coverWireMethodFee?: InputMaybe<Scalars['Boolean']['input']>
}

export type PartnerCreateAutopayRuleInput = {
  agreementTypeIDs?: InputMaybe<AgreementTypeInput>
  amount?: InputMaybe<Scalars['Float']['input']>
  amountOperator?: InputMaybe<RuleOperator>
  billingTermsIDs?: InputMaybe<BillingTermsInput>
  contractNames?: InputMaybe<ContractNamesInput>
  customMethods?: InputMaybe<Array<InputMaybe<AutopayCustomMethodInput>>>
  customerIDs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  daysBeforeDue?: InputMaybe<Scalars['Int']['input']>
  daysPastCreation?: InputMaybe<Scalars['Int']['input']>
  daysPastDue?: InputMaybe<Scalars['Int']['input']>
  recurringInvoices?: InputMaybe<RecurringInvoicesInput>
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type PartnerCreateCustomerInput = {
  city?: InputMaybe<Scalars['String']['input']>
  companyType?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  ein?: InputMaybe<Scalars['String']['input']>
  industry?: InputMaybe<Scalars['String']['input']>
  legalName?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  streetAddress?: InputMaybe<Scalars['String']['input']>
  subPremise?: InputMaybe<Scalars['String']['input']>
}

export type PartnerCreateCustomerTagInput = {
  color?: InputMaybe<TagColor>
  customerIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  description?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
}

export type PartnerCreateCustomerUserInput = {
  customerId: Scalars['String']['input']
  email: Scalars['String']['input']
  firstName?: InputMaybe<Scalars['String']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
}

export type PartnerCreateInvoiceSummaryInput = {
  customDay?: InputMaybe<Scalars['Int']['input']>
  frequency: InvoiceSummaryFrequency
  startAt?: InputMaybe<Scalars['String']['input']>
  templateID?: InputMaybe<Scalars['ID']['input']>
}

export type PartnerCustomerTotals = {
  __typename: 'PartnerCustomerTotals'
  count: Scalars['Int']['output']
}

export type PartnerDefaultPayoutBankingAccountUpdateInput = {
  accountID: Scalars['ID']['input']
}

export enum PartnerDocumentType {
  BankStatement = 'BANK_STATEMENT',
  Id = 'ID',
  Registration = 'REGISTRATION'
}

export type PartnerEdge = {
  __typename: 'PartnerEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<Partner>
}

export type PartnerFeeConfig = {
  __typename: 'PartnerFeeConfig'
  coverDirectPaymentFees: Scalars['Boolean']['output']
  coverFeeConfig?: Maybe<CoverFeeConfig>
  id: Scalars['ID']['output']
  partner: Partner
}

export type PartnerFeeConfigUpdateInput = {
  coverDirectPaymentFees?: InputMaybe<Scalars['Boolean']['input']>
  coverFeeConfig?: InputMaybe<PartnerCoverFeeConfigInput>
}

export type PartnerFilter = {
  createdAtEnd?: InputMaybe<Scalars['String']['input']>
  createdAtStart?: InputMaybe<Scalars['String']['input']>
  isOnboarded?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  partnerID?: InputMaybe<Scalars['ID']['input']>
  paymentsPortalEnabled?: InputMaybe<Scalars['Boolean']['input']>
}

export type PartnerGetCoveredInvoicesForRuleInput = {
  agreementTypeIDs?: InputMaybe<AgreementTypeInput>
  amount?: InputMaybe<Scalars['Float']['input']>
  amountOperator?: InputMaybe<RuleOperator>
  billingTermsIDs?: InputMaybe<BillingTermsInput>
  contractNames?: InputMaybe<ContractNamesInput>
  customerIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  daysBeforeDue?: InputMaybe<Scalars['Int']['input']>
  daysPastCreation?: InputMaybe<Scalars['Int']['input']>
  daysPastDue?: InputMaybe<Scalars['Int']['input']>
  recurringInvoices?: InputMaybe<RecurringInvoicesInput>
  tagIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type PartnerGetUserInfoReply = {
  __typename: 'PartnerGetUserInfoReply'
  id: Scalars['ID']['output']
  userType: UserType
  users?: Maybe<Array<PartnerUserInfo>>
}

export type PartnerHaloPsaConnectionCreateInput = {
  applicationDomain: Scalars['String']['input']
  clientID: Scalars['String']['input']
  clientSecret: Scalars['String']['input']
  integrationType: IntegrationType
  invoiceCreatedSince?: InputMaybe<Scalars['String']['input']>
  invoiceNumberField: InvoiceNumberFields
}

export type PartnerHaloPsaConnectionCreateReply = {
  __typename: 'PartnerHaloPSAConnectionCreateReply'
  errorMessage?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type PartnerInviteUserInput = {
  email: Scalars['String']['input']
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  role: PartnerUserRole
}

export type PartnerInvoiceBulkCharge = {
  __typename: 'PartnerInvoiceBulkCharge'
  bulkChargeRequestStatus?: Maybe<BulkChargeRequestStatusEnum>
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  invoiceCount: Scalars['Int']['output']
  partner: Partner
  paymentDate?: Maybe<Scalars['String']['output']>
  paymentRequests?: Maybe<Array<Maybe<PaymentRequest>>>
  requester?: Maybe<PartnerUser>
}

/** A connection to a list of items. */
export type PartnerInvoiceBulkChargeConnection = {
  __typename: 'PartnerInvoiceBulkChargeConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PartnerInvoiceBulkChargeEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type PartnerInvoiceBulkChargeEdge = {
  __typename: 'PartnerInvoiceBulkChargeEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output']
  /** The item at the end of the edge. */
  node?: Maybe<PartnerInvoiceBulkCharge>
}

export enum PartnerInvoiceBulkChargeOrderByField {
  CreatedDate = 'CREATED_DATE',
  PaymentDate = 'PAYMENT_DATE'
}

export type PartnerInvoicePaidUpdateInput = {
  invoiceID: Scalars['String']['input']
  paid: Scalars['Boolean']['input']
}

export type PartnerListCustomerFeeExceptionsInput = {
  customerIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  feeType?: InputMaybe<FeeExceptionType>
}

export type PartnerLogoUploadUrl = {
  __typename: 'PartnerLogoUploadUrl'
  uploadCDNURL: Scalars['String']['output']
  uploadURL: Scalars['String']['output']
  uploadURLExpirationUTC: Scalars['String']['output']
}

export type PartnerOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<PartnerOrderByField>
}

export enum PartnerOrderByField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export type PartnerPaymentsPortalCustomization = {
  __typename: 'PartnerPaymentsPortalCustomization'
  color?: Maybe<Scalars['String']['output']>
  logoUrl?: Maybe<Scalars['String']['output']>
}

export type PartnerPaymentsPortalCustomizationInput = {
  color?: InputMaybe<Scalars['String']['input']>
  logoUrl?: InputMaybe<Scalars['String']['input']>
}

export enum PartnerPaymentsPortalMethod {
  Ach = 'ACH',
  Bnpl = 'BNPL',
  Card = 'CARD'
}

export type PartnerSubscription = {
  __typename: 'PartnerSubscription'
  amount: Scalars['Float']['output']
  billingCyclesCovered: Scalars['Int']['output']
  billingCyclesUnit: Scalars['String']['output']
  createdDate: Scalars['String']['output']
  duration?: Maybe<Scalars['Int']['output']>
  firstBillingDate: Scalars['String']['output']
  frequency: SubscriptionFrequency
  id: Scalars['ID']['output']
  lastStatus: SubscriptionStatus
  nextBillingDate: Scalars['String']['output']
  partner: Partner
  type: Scalars['String']['output']
}

export type PartnerUnarchiveCustomerInput = {
  id: Scalars['ID']['input']
}

export type PartnerUpdateAddressInput = {
  city: Scalars['String']['input']
  country: Scalars['String']['input']
  countryCode: Scalars['String']['input']
  postalCode: Scalars['String']['input']
  state: Scalars['String']['input']
  stateCode: Scalars['String']['input']
  streetAddress: Scalars['String']['input']
  subPremise?: InputMaybe<Scalars['String']['input']>
}

export type PartnerUpdateAutopayRuleInput = {
  agreementTypeIDs?: InputMaybe<AgreementTypeInput>
  amount?: InputMaybe<Scalars['Float']['input']>
  amountOperator?: InputMaybe<RuleOperator>
  billingTermsIDs?: InputMaybe<BillingTermsInput>
  contractNames?: InputMaybe<ContractNamesInput>
  customMethods?: InputMaybe<Array<InputMaybe<AutopayCustomMethodInput>>>
  customerIDs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  daysBeforeDue?: InputMaybe<Scalars['Int']['input']>
  daysPastCreation?: InputMaybe<Scalars['Int']['input']>
  daysPastDue?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['ID']['input']
  recurringInvoices?: InputMaybe<RecurringInvoicesInput>
  tagIDs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  version?: InputMaybe<Scalars['Int']['input']>
}

export type PartnerUpdateCustomerInput = {
  city?: InputMaybe<Scalars['String']['input']>
  companyType?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  ein?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  industry?: InputMaybe<Scalars['String']['input']>
  legalName?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  streetAddress?: InputMaybe<Scalars['String']['input']>
  subPremise?: InputMaybe<Scalars['String']['input']>
}

export type PartnerUpdateCustomerTagInput = {
  ID: Scalars['ID']['input']
  color?: InputMaybe<TagColor>
  description?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type PartnerUpdateCustomerUserInput = {
  firstName?: InputMaybe<Scalars['String']['input']>
  id: Scalars['String']['input']
  jobTitle?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
}

export type PartnerUpdateDetailsInput = {
  adyenBusinessSetup?: InputMaybe<AdyenBusinessSetup>
  adyenCompanyType?: InputMaybe<AdyenCompanyType>
  adyenIndustryCode?: InputMaybe<Scalars['String']['input']>
  companyType?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  ein?: InputMaybe<Scalars['String']['input']>
  industry?: InputMaybe<Scalars['String']['input']>
  legalName: Scalars['String']['input']
  name: Scalars['String']['input']
  phone?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
}

export type PartnerUpdateMyUserInput = {
  firstName?: InputMaybe<Scalars['String']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
}

export type PartnerUpdateUserInput = {
  firstName?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  jobTitle?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  role: PartnerUserRole
}

export type PartnerUser = {
  __typename: 'PartnerUser'
  createdAt: Scalars['String']['output']
  email: Scalars['String']['output']
  firstName?: Maybe<Scalars['String']['output']>
  hasMFA?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  jobTitle?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  role: PartnerUserRole
}

export type PartnerUserConnection = {
  __typename: 'PartnerUserConnection'
  edges?: Maybe<Array<Maybe<PartnerUserEdge>>>
  pageInfo: PageInfo
}

export type PartnerUserEdge = {
  __typename: 'PartnerUserEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<PartnerUser>
}

export type PartnerUserInfo = {
  __typename: 'PartnerUserInfo'
  createdAt: Scalars['String']['output']
  email: Scalars['String']['output']
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  jobTitle?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  partner?: Maybe<Partner>
  permissions: Array<PartnerUserPermissions>
  phone?: Maybe<Scalars['String']['output']>
  role: Scalars['String']['output']
}

export type PartnerUserOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<PartnerUserOrderByField>
}

export enum PartnerUserOrderByField {
  Name = 'NAME',
  Role = 'ROLE'
}

export enum PartnerUserPermissions {
  AccountingIntegrationSync = 'ACCOUNTING_INTEGRATION_SYNC',
  AccountingPreferencesRead = 'ACCOUNTING_PREFERENCES_READ',
  AccountingPreferencesUpdate = 'ACCOUNTING_PREFERENCES_UPDATE',
  AccountingSyncBatchCreate = 'ACCOUNTING_SYNC_BATCH_CREATE',
  AccountingSyncBatchRead = 'ACCOUNTING_SYNC_BATCH_READ',
  AccountingSyncConfigCreate = 'ACCOUNTING_SYNC_CONFIG_CREATE',
  AccountingSyncConfigRead = 'ACCOUNTING_SYNC_CONFIG_READ',
  AdyenOnboardingStatusGet = 'ADYEN_ONBOARDING_STATUS_GET',
  AdyenRemediationActionsGet = 'ADYEN_REMEDIATION_ACTIONS_GET',
  AdyenRemediationActionsUpdate = 'ADYEN_REMEDIATION_ACTIONS_UPDATE',
  AdyenTermsAccept = 'ADYEN_TERMS_ACCEPT',
  AdyenTermsGet = 'ADYEN_TERMS_GET',
  AgreementTypeList = 'AGREEMENT_TYPE_LIST',
  ApiKeyCreate = 'API_KEY_CREATE',
  ApiKeyList = 'API_KEY_LIST',
  ApiKeyUpdate = 'API_KEY_UPDATE',
  AutopayConfigList = 'AUTOPAY_CONFIG_LIST',
  AutopayConfigUpdate = 'AUTOPAY_CONFIG_UPDATE',
  AutopayRuleCreate = 'AUTOPAY_RULE_CREATE',
  AutopayRuleDelete = 'AUTOPAY_RULE_DELETE',
  AutopayRuleList = 'AUTOPAY_RULE_LIST',
  AutopayRuleUpdate = 'AUTOPAY_RULE_UPDATE',
  AutotaskConnectionCreate = 'AUTOTASK_CONNECTION_CREATE',
  AutotaskConnectionRead = 'AUTOTASK_CONNECTION_READ',
  AutotaskContractList = 'AUTOTASK_CONTRACT_LIST',
  AutotaskContractTypeList = 'AUTOTASK_CONTRACT_TYPE_LIST',
  BankingDelete = 'BANKING_DELETE',
  BankingGetintegration = 'BANKING_GETINTEGRATION',
  BankingNew = 'BANKING_NEW',
  BankingUpdate = 'BANKING_UPDATE',
  BillingHistoryList = 'BILLING_HISTORY_LIST',
  BnplConfirm = 'BNPL_CONFIRM',
  CardtransferList = 'CARDTRANSFER_LIST',
  CardList = 'CARD_LIST',
  CardManage = 'CARD_MANAGE',
  CollectionCreate = 'COLLECTION_CREATE',
  CollectionList = 'COLLECTION_LIST',
  CollectionUpdate = 'COLLECTION_UPDATE',
  CompanyDocumentsList = 'COMPANY_DOCUMENTS_LIST',
  CompanyIndividualCreate = 'COMPANY_INDIVIDUAL_CREATE',
  CompanyIndividualDelete = 'COMPANY_INDIVIDUAL_DELETE',
  CompanyIndividualList = 'COMPANY_INDIVIDUAL_LIST',
  CompanyOwnerCreate = 'COMPANY_OWNER_CREATE',
  CompanyOwnerDelete = 'COMPANY_OWNER_DELETE',
  CompanyOwnerList = 'COMPANY_OWNER_LIST',
  CompanyRepresentativeCreate = 'COMPANY_REPRESENTATIVE_CREATE',
  CompanyRepresentativeList = 'COMPANY_REPRESENTATIVE_LIST',
  ConnectwiseAgreementList = 'CONNECTWISE_AGREEMENT_LIST',
  ConnectwiseAgreementTypeList = 'CONNECTWISE_AGREEMENT_TYPE_LIST',
  ConnectwiseBillingTermsList = 'CONNECTWISE_BILLING_TERMS_LIST',
  ConnectwiseConnectionCreate = 'CONNECTWISE_CONNECTION_CREATE',
  ConnectwiseConnectionRead = 'CONNECTWISE_CONNECTION_READ',
  CustomeruserCreate = 'CUSTOMERUSER_CREATE',
  CustomeruserDelete = 'CUSTOMERUSER_DELETE',
  CustomeruserList = 'CUSTOMERUSER_LIST',
  CustomeruserUpdate = 'CUSTOMERUSER_UPDATE',
  CustomerCreate = 'CUSTOMER_CREATE',
  CustomerList = 'CUSTOMER_LIST',
  CustomerTagCreate = 'CUSTOMER_TAG_CREATE',
  CustomerTagDelete = 'CUSTOMER_TAG_DELETE',
  CustomerTagList = 'CUSTOMER_TAG_LIST',
  CustomerTagUpdate = 'CUSTOMER_TAG_UPDATE',
  CustomerUpdate = 'CUSTOMER_UPDATE',
  DatagateConnectionCreate = 'DATAGATE_CONNECTION_CREATE',
  EmailActivityList = 'EMAIL_ACTIVITY_LIST',
  EmailTemplateCreate = 'EMAIL_TEMPLATE_CREATE',
  EmailTemplateDelete = 'EMAIL_TEMPLATE_DELETE',
  EmailTemplateList = 'EMAIL_TEMPLATE_LIST',
  EmailTemplateUpdate = 'EMAIL_TEMPLATE_UPDATE',
  GetInvoiceBulkCharges = 'GET_INVOICE_BULK_CHARGES',
  HalopsaConnectionCreate = 'HALOPSA_CONNECTION_CREATE',
  HalopsaContractSubtypeList = 'HALOPSA_CONTRACT_SUBTYPE_LIST',
  InsightsGet = 'INSIGHTS_GET',
  IntegrationDelete = 'INTEGRATION_DELETE',
  IntegrationDisconnect = 'INTEGRATION_DISCONNECT',
  IntegrationList = 'INTEGRATION_LIST',
  InvoiceArchive = 'INVOICE_ARCHIVE',
  InvoiceBulkCharge = 'INVOICE_BULK_CHARGE',
  InvoiceConfirm = 'INVOICE_CONFIRM',
  InvoiceCreate = 'INVOICE_CREATE',
  InvoiceDownload = 'INVOICE_DOWNLOAD',
  InvoiceList = 'INVOICE_LIST',
  InvoicePaidUpdate = 'INVOICE_PAID_UPDATE',
  InvoicePay = 'INVOICE_PAY',
  InvoicePreferencesUpsert = 'INVOICE_PREFERENCES_UPSERT',
  InvoiceRemind = 'INVOICE_REMIND',
  InvoiceReminderCreate = 'INVOICE_REMINDER_CREATE',
  InvoiceReminderList = 'INVOICE_REMINDER_LIST',
  InvoiceReminderSendPreview = 'INVOICE_REMINDER_SEND_PREVIEW',
  LendingPay = 'LENDING_PAY',
  NotificationsRead = 'NOTIFICATIONS_READ',
  NotificationsUpdate = 'NOTIFICATIONS_UPDATE',
  OfferCreate = 'OFFER_CREATE',
  OfferList = 'OFFER_LIST',
  OfferUpdate = 'OFFER_UPDATE',
  PartneruserCreate = 'PARTNERUSER_CREATE',
  PartneruserDelete = 'PARTNERUSER_DELETE',
  PartneruserList = 'PARTNERUSER_LIST',
  PartneruserUpdate = 'PARTNERUSER_UPDATE',
  PartneruserUpdateMyself = 'PARTNERUSER_UPDATE_MYSELF',
  PartnerCreate = 'PARTNER_CREATE',
  PartnerUpdate = 'PARTNER_UPDATE',
  PaymentcompanyconfigList = 'PAYMENTCOMPANYCONFIG_LIST',
  PaymentcompanyconfigUpdate = 'PAYMENTCOMPANYCONFIG_UPDATE',
  PaymentList = 'PAYMENT_LIST',
  PaymentUpdate = 'PAYMENT_UPDATE',
  PayoutcompanyconfigList = 'PAYOUTCOMPANYCONFIG_LIST',
  PayoutcompanyconfigUpdate = 'PAYOUTCOMPANYCONFIG_UPDATE',
  PayouttimingcompanyconfigList = 'PAYOUTTIMINGCOMPANYCONFIG_LIST',
  PayouttimingcompanyconfigUpsert = 'PAYOUTTIMINGCOMPANYCONFIG_UPSERT',
  PayouttimingplanList = 'PAYOUTTIMINGPLAN_LIST',
  PayoutList = 'PAYOUT_LIST',
  QuickbooksAccountList = 'QUICKBOOKS_ACCOUNT_LIST',
  QuickbooksAccountUpdate = 'QUICKBOOKS_ACCOUNT_UPDATE',
  QuickbooksConnectionCreate = 'QUICKBOOKS_CONNECTION_CREATE',
  QuickbooksConnectionRead = 'QUICKBOOKS_CONNECTION_READ',
  QuickbooksConnectionUrl = 'QUICKBOOKS_CONNECTION_URL',
  QuickbooksRecurringTransactionList = 'QUICKBOOKS_RECURRING_TRANSACTION_LIST',
  RecurringpaymentCreate = 'RECURRINGPAYMENT_CREATE',
  RecurringpaymentDeactivate = 'RECURRINGPAYMENT_DEACTIVATE',
  RecurringpaymentList = 'RECURRINGPAYMENT_LIST',
  RecurringpaymentUpdate = 'RECURRINGPAYMENT_UPDATE',
  ReferralCreate = 'REFERRAL_CREATE',
  ReferralList = 'REFERRAL_LIST',
  ReferralPayoutList = 'REFERRAL_PAYOUT_LIST',
  ReferralSend = 'REFERRAL_SEND',
  ReferralUpdate = 'REFERRAL_UPDATE',
  ReportSend = 'REPORT_SEND',
  RutterAccountList = 'RUTTER_ACCOUNT_LIST',
  RutterAccountUpsert = 'RUTTER_ACCOUNT_UPSERT',
  RutterConnectionCreate = 'RUTTER_CONNECTION_CREATE',
  RutterConnectionRead = 'RUTTER_CONNECTION_READ',
  RutterPaymentTermsList = 'RUTTER_PAYMENT_TERMS_LIST',
  SubscriptionCancel = 'SUBSCRIPTION_CANCEL',
  SubscriptionList = 'SUBSCRIPTION_LIST',
  SubscriptionPaymentList = 'SUBSCRIPTION_PAYMENT_LIST',
  SuperopsConnectionCreate = 'SUPEROPS_CONNECTION_CREATE',
  SupportPreferencesGet = 'SUPPORT_PREFERENCES_GET',
  SupportPreferencesUpsert = 'SUPPORT_PREFERENCES_UPSERT'
}

export enum PartnerUserRole {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Readonly = 'READONLY',
  Subadmin = 'SUBADMIN'
}

export type PayInvoicePaymentMethodInput = {
  method: TransferPaymentMethodInputEnum
  methodID: Scalars['ID']['input']
}

export type Payment = {
  __typename: 'Payment'
  amount: Scalars['Float']['output']
  creationDate: Scalars['String']['output']
  /** @deprecated Use currentPaymentMethodEntity instead */
  currentPaymentMethod?: Maybe<MethodEnum>
  currentPaymentMethodEntity?: Maybe<PaymentMethodEntity>
  customer?: Maybe<Customer>
  dueDate?: Maybe<Scalars['String']['output']>
  executorType: PaymentExecutorType
  id: Scalars['ID']['output']
  netAmount: Scalars['Float']['output']
  originService: PaymentAlternativeService
  partner: Partner
  payerCompanyType: CompanyType
  paymentCompletionForecastDate?: Maybe<Scalars['String']['output']>
  paymentFees: Array<Maybe<PaymentFee>>
  payoutEstimation: PaymentPayoutEstimation
  product: Product
  refunds?: Maybe<Array<Maybe<Refund>>>
  statuses: Array<Maybe<PaymentStatus>>
  transaction?: Maybe<Transaction>
}

export enum PaymentAlternativeService {
  Autopay = 'AUTOPAY',
  BatchPayments = 'BATCH_PAYMENTS',
  Bnpl = 'BNPL',
  Collection = 'COLLECTION',
  Invoice = 'INVOICE',
  Offer = 'OFFER',
  RecurringPayment = 'RECURRING_PAYMENT',
  Subscription = 'SUBSCRIPTION'
}

export type PaymentCompanyConfig = {
  __typename: 'PaymentCompanyConfig'
  company: CompanyUnion
  id?: Maybe<Scalars['ID']['output']>
  paymentMethod?: Maybe<MethodEnum>
  paymentMethodEntity?: Maybe<PaymentMethodEntity>
}

export type PaymentCompanyConfigUpdateInput = {
  paymentMethod?: InputMaybe<TransferPaymentMethodInputEnum>
  paymentMethodID: Scalars['ID']['input']
}

/** A connection to a list of items. */
export type PaymentConnection = {
  __typename: 'PaymentConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PaymentEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type PaymentCountByTrigger = {
  __typename: 'PaymentCountByTrigger'
  count: Scalars['Int']['output']
  trigger: Scalars['String']['output']
}

export type PaymentCountByTriggerLastMonthResponse = {
  __typename: 'PaymentCountByTriggerLastMonthResponse'
  data: Array<PaymentCountByTrigger>
}

/** An edge in a connection. */
export type PaymentEdge = {
  __typename: 'PaymentEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Payment>
}

export enum PaymentExecutorType {
  Alternative = 'ALTERNATIVE',
  Customer = 'CUSTOMER',
  GuestCustomer = 'GUEST_CUSTOMER',
  Partner = 'PARTNER',
  System = 'SYSTEM'
}

export type PaymentFee = {
  __typename: 'PaymentFee'
  amount: Scalars['Float']['output']
  forwarded: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  type: FeeType
}

export type PaymentFilter = {
  amountEnd?: InputMaybe<Scalars['Float']['input']>
  amountStart?: InputMaybe<Scalars['Float']['input']>
  creationDateEnd?: InputMaybe<Scalars['String']['input']>
  creationDateStart?: InputMaybe<Scalars['String']['input']>
  customerId?: InputMaybe<Scalars['ID']['input']>
  dueDateEnd?: InputMaybe<Scalars['String']['input']>
  dueDateStart?: InputMaybe<Scalars['String']['input']>
  excludeBNPL?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  payerEntity?: InputMaybe<CompanyType>
  paymentCompletionForecastDateFrom?: InputMaybe<Scalars['String']['input']>
  paymentCompletionForecastDateTo?: InputMaybe<Scalars['String']['input']>
  paymentMethod?: InputMaybe<MethodEnum>
  productId?: InputMaybe<Scalars['ID']['input']>
  productType?: InputMaybe<ProductType>
  productTypeIn?: InputMaybe<Array<InputMaybe<ProductType>>>
  status?: InputMaybe<Array<InputMaybe<PaymentStatusEnum>>>
}

export type PaymentMethodEntity = Account | Card

export type PaymentOrder = {
  direction?: OrderDirection
  field?: PaymentOrderField
}

export enum PaymentOrderField {
  CreatedAt = 'CREATED_AT'
}

export type PaymentPage = {
  __typename: 'PaymentPage'
  data: Array<Maybe<Payment>>
  limit: Scalars['Int']['output']
  page: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

export type PaymentPayoutEstimation = {
  __typename: 'PaymentPayoutEstimation'
  estimatedPayoutCreationDate?: Maybe<Scalars['String']['output']>
}

export type PaymentRequest = {
  __typename: 'PaymentRequest'
  id: Scalars['ID']['output']
  lastStatus: PaymentStatusEnum
  payment?: Maybe<Payment>
  paymentDate?: Maybe<Scalars['String']['output']>
  product: Product
}

export type PaymentStatus = {
  __typename: 'PaymentStatus'
  createdAt: Scalars['String']['output']
  status?: Maybe<PaymentStatusEnum>
}

export enum PaymentStatusEnum {
  Canceled = 'CANCELED',
  Chargeback = 'CHARGEBACK',
  Creating = 'CREATING',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED',
  Scheduled = 'SCHEDULED',
  Succeeded = 'SUCCEEDED'
}

export type PaymentTotals = {
  __typename: 'PaymentTotals'
  amount: Scalars['Float']['output']
  count: Scalars['Int']['output']
  netAmount: Scalars['Float']['output']
}

export type PaymentVolumeAutomatedResponse = {
  __typename: 'PaymentVolumeAutomatedResponse'
  value: Scalars['Float']['output']
}

export type PaymentVolumeByMonthResponse = {
  __typename: 'PaymentVolumeByMonthResponse'
  average: Scalars['Float']['output']
  data: Array<DataPoint>
}

export type PaymentVolumeByTrigger = {
  __typename: 'PaymentVolumeByTrigger'
  trigger: Scalars['String']['output']
  volume: Scalars['Float']['output']
}

export type PaymentVolumeByTriggerLastMonthResponse = {
  __typename: 'PaymentVolumeByTriggerLastMonthResponse'
  data: Array<PaymentVolumeByTrigger>
}

export type PaymentVolumeResponse = {
  __typename: 'PaymentVolumeResponse'
  value: Scalars['Float']['output']
}

export type PaymentsCountByMethodMonthData = {
  __typename: 'PaymentsCountByMethodMonthData'
  count: Scalars['Int']['output']
  method: Scalars['String']['output']
  month: Scalars['String']['output']
}

export type PaymentsCountByMethodMonthResponse = {
  __typename: 'PaymentsCountByMethodMonthResponse'
  average: Scalars['Float']['output']
  data: Array<PaymentsCountByMethodMonthData>
}

export type PaymentsVolumeByMethodMonthData = {
  __typename: 'PaymentsVolumeByMethodMonthData'
  method: Scalars['String']['output']
  month: Scalars['String']['output']
  volume: Scalars['Float']['output']
}

export type PaymentsVolumeByMethodMonthResponse = {
  __typename: 'PaymentsVolumeByMethodMonthResponse'
  average: Scalars['Float']['output']
  data: Array<PaymentsVolumeByMethodMonthData>
}

export type Payout = {
  __typename: 'Payout'
  account?: Maybe<Account>
  amount: Scalars['Float']['output']
  creationDate: Scalars['String']['output']
  customer?: Maybe<Customer>
  fees: Array<Maybe<PayoutFee>>
  id: Scalars['ID']['output']
  netAmount: Scalars['Float']['output']
  partner: Partner
  payoutBreakdownTotals?: Maybe<Array<Maybe<PayoutBreakdownTotals>>>
  payoutCompletionForecastDate?: Maybe<Scalars['String']['output']>
  payoutType: PayoutType
  product: Product
  publicNumber: Scalars['String']['output']
  receiverCompanyType: CompanyType
  statuses: Array<Maybe<PayoutStatus>>
  totalFeeAmount: Scalars['Float']['output']
  transactions: Array<Maybe<Transaction>>
}

export type PayoutBreakdownTotals = {
  __typename: 'PayoutBreakdownTotals'
  feesGreaterThanZeroCount: Scalars['Int']['output']
  productType: BreakdownProductType
  productTypeCount: Scalars['Int']['output']
  sumFees: Scalars['Float']['output']
  sumGrossAmount: Scalars['Float']['output']
}

export type PayoutCompanyConfig = {
  __typename: 'PayoutCompanyConfig'
  company: Partner
  defaultBankingAccount?: Maybe<Account>
  id: Scalars['ID']['output']
  invoicePayoutMethod: InvoicePayoutMethodEnum
  offerPayoutMethod: OfferPayoutMethodEnum
  referralBankingAccount?: Maybe<Account>
  referralPayoutMethod: ReferralPayoutMethodEnum
}

/** A connection to a list of items. */
export type PayoutConnection = {
  __typename: 'PayoutConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PayoutEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type PayoutDetails = {
  __typename: 'PayoutDetails'
  account?: Maybe<Account>
  amount: Scalars['Float']['output']
  creationDate: Scalars['String']['output']
  fees: Array<Maybe<PayoutFee>>
  id: Scalars['ID']['output']
  netAmount: Scalars['Float']['output']
  payoutBreakdownTotals?: Maybe<Array<Maybe<PayoutBreakdownTotals>>>
  payoutCompletionForecastDate?: Maybe<Scalars['String']['output']>
  payoutType: PayoutType
  product: Product
  publicNumber: Scalars['String']['output']
  statuses: Array<Maybe<PayoutStatus>>
  totalFeeAmount: Scalars['Float']['output']
  transactions: Array<Maybe<Transaction>>
}

/** An edge in a connection. */
export type PayoutEdge = {
  __typename: 'PayoutEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Payout>
}

export type PayoutFee = {
  __typename: 'PayoutFee'
  amount: Scalars['Float']['output']
  forwarded: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  type: FeeType
}

export type PayoutFilter = {
  amountEnd?: InputMaybe<Scalars['Float']['input']>
  amountStart?: InputMaybe<Scalars['Float']['input']>
  approved?: InputMaybe<Scalars['Boolean']['input']>
  completed?: InputMaybe<Scalars['Boolean']['input']>
  customerId?: InputMaybe<Scalars['ID']['input']>
  dateFrom?: InputMaybe<Scalars['String']['input']>
  dateTo?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  netAmountEnd?: InputMaybe<Scalars['Float']['input']>
  netAmountStart?: InputMaybe<Scalars['Float']['input']>
  payoutCompletionForecastDateFrom?: InputMaybe<Scalars['String']['input']>
  payoutCompletionForecastDateTo?: InputMaybe<Scalars['String']['input']>
  payoutType?: InputMaybe<PayoutType>
  productID?: InputMaybe<Scalars['ID']['input']>
  /** @deprecated Use productTypes instead */
  productType?: InputMaybe<ProductType>
  productTypes?: InputMaybe<Array<InputMaybe<ProductType>>>
  publicNumber?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Array<PayoutStatusEnum>>
}

export enum PayoutMethodEnum {
  Manual = 'MANUAL',
  SameDayAch = 'SAME_DAY_ACH',
  StandardAch = 'STANDARD_ACH'
}

export type PayoutOrder = {
  direction?: OrderDirection
  field?: PayoutOrderField
}

export enum PayoutOrderField {
  CreatedAt = 'CREATED_AT'
}

export type PayoutStatus = {
  __typename: 'PayoutStatus'
  createdAt: Scalars['String']['output']
  status?: Maybe<PayoutStatusEnum>
}

export enum PayoutStatusEnum {
  Analyzing = 'ANALYZING',
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Creating = 'CREATING',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Scheduled = 'SCHEDULED',
  Succeeded = 'SUCCEEDED'
}

export type PayoutTimingCompanyConfig = {
  __typename: 'PayoutTimingCompanyConfig'
  activatedAt?: Maybe<Scalars['String']['output']>
  aggregateID: Scalars['ID']['output']
  businessDaysToHold: Scalars['Int']['output']
  canCompanyChange: Scalars['Boolean']['output']
  company: Partner
  effectiveAt: Scalars['String']['output']
  payoutTimingFee?: Maybe<PayoutTimingFee>
  payoutTimingPlanID: Scalars['ID']['output']
}

export type PayoutTimingFee = {
  __typename: 'PayoutTimingFee'
  capFee: Scalars['Float']['output']
  fixedFee: Scalars['Float']['output']
  percentageFee: Scalars['Float']['output']
}

export type PayoutTimingPlan = {
  __typename: 'PayoutTimingPlan'
  businessDaysToHold: Scalars['Int']['output']
  id: Scalars['ID']['output']
  payoutTimingFee: PayoutTimingFee
}

export type PayoutTotals = {
  __typename: 'PayoutTotals'
  amount: Scalars['Float']['output']
  count: Scalars['Int']['output']
}

export enum PayoutType {
  AccountsReceivable = 'ACCOUNTS_RECEIVABLE',
  Referral = 'REFERRAL'
}

export type PendingCustomerUser = {
  __typename: 'PendingCustomerUser'
  createdAt: Scalars['String']['output']
  customer?: Maybe<Customer>
  email: Scalars['String']['output']
  id: Scalars['ID']['output']
  partnerId: Scalars['String']['output']
}

export type PendingCustomerUserConnection = {
  __typename: 'PendingCustomerUserConnection'
  edges?: Maybe<Array<Maybe<PendingCustomerUserEdge>>>
  pageInfo: PageInfo
}

export type PendingCustomerUserEdge = {
  __typename: 'PendingCustomerUserEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<PendingCustomerUser>
}

export type PendingCustomerUserFilters = {
  createdAtEnd?: InputMaybe<Scalars['String']['input']>
  createdAtStart?: InputMaybe<Scalars['String']['input']>
  customerId?: InputMaybe<Scalars['ID']['input']>
  email?: InputMaybe<Scalars['String']['input']>
}

export type PendingCustomerUserOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<PendingCustomerUserOrderByField>
}

export enum PendingCustomerUserOrderByField {
  CreatedAt = 'CREATED_AT',
  Email = 'EMAIL'
}

export type PendingCustomerUsersTotals = {
  __typename: 'PendingCustomerUsersTotals'
  count: Scalars['Int']['output']
}

export type PlaidInstitutionConnectionStatus = {
  __typename: 'PlaidInstitutionConnectionStatus'
  connectionId: Scalars['ID']['output']
  needsUpdate: Scalars['Boolean']['output']
}

export enum PlatformName {
  Autotask = 'AUTOTASK',
  Connectwise = 'CONNECTWISE',
  Datagate = 'DATAGATE',
  Halopsa = 'HALOPSA',
  Quickbooks = 'QUICKBOOKS',
  RutterDynamics365 = 'RUTTER_DYNAMICS365',
  RutterFreshbooks = 'RUTTER_FRESHBOOKS',
  RutterNetsuite = 'RUTTER_NETSUITE',
  RutterQbd = 'RUTTER_QBD',
  RutterSageIntacct = 'RUTTER_SAGE_INTACCT',
  RutterXero = 'RUTTER_XERO',
  RutterZohoBooks = 'RUTTER_ZOHO_BOOKS',
  Superops = 'SUPEROPS'
}

export type Product =
  | InstantPayment
  | Invoice
  | Offer
  | Referral
  | ReferralBonus
  | Refund
  | SubscriptionPayment

export enum ProductType {
  Chargeback = 'CHARGEBACK',
  InstantPayment = 'INSTANT_PAYMENT',
  Invoice = 'INVOICE',
  Offer = 'OFFER',
  Referral = 'REFERRAL',
  ReferralBonus = 'REFERRAL_BONUS',
  Refund = 'REFUND',
  Subscription = 'SUBSCRIPTION'
}

export enum PushPaymentsTo {
  Both = 'BOTH',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

export type Query = {
  __typename: 'Query'
  CreateUserAndPartner?: Maybe<CreateUserAndPartnerReply>
  FindAutopayRule?: Maybe<AutopayRule>
  FindInvoice?: Maybe<Invoice>
  GetAdyenDocumentTypes: Array<AdyenUploadDocumentType>
  GetAdyenHostedOnboardingLink?: Maybe<GetAdyenHostedOnboardingLinkResponse>
  GetAdyenOnboardingStatus: AdyenOnboardingStatus
  GetAdyenPciForms: AdyenPciForms
  GetAdyenRemediationActions: GetAdyenRemediationActionsReply
  GetAdyenTermsOfService: Array<AdyenTermsOfServiceDocument>
  GetCompanyIndividuals: Array<CompanyIndividual>
  GetCustomerAutopayConfig?: Maybe<GetCustomerAutopayConfigReply>
  GetPartnerDocuments: Array<CompanyDocument>
  GetSupportPreferences?: Maybe<SupportPreferences>
  GetUserInfo?: Maybe<PartnerGetUserInfoReply>
  GetUserPartners: Array<Maybe<Partner>>
  OAuth2Url: Scalars['String']['output']
  PartnerAccountingSyncConfigGet?: Maybe<SyncConfig>
  PartnerAgreementTypeConnection: AgreementTypeConnection
  PartnerApiKeyConnection?: Maybe<ApiKeyConnection>
  PartnerAutopayExcludedCustomerConnection?: Maybe<AutopayExcludedCustomerConnection>
  PartnerAutopayExcludedCustomerListTotals: AutopayExcludedCustomerTotals
  PartnerAutotaskContractConnection: AutotaskContractConnection
  PartnerAutotaskGetFilters?: Maybe<AutotaskQueryFilters>
  PartnerCollectionConnection?: Maybe<CollectionConnection>
  PartnerCollectionTotals: CollectionTotals
  PartnerConnectWiseAgreementConnection: ConnectWiseAgreementConnection
  PartnerConnectWiseBillingTermsConnection?: Maybe<ConnectWiseBillingTermsConnection>
  PartnerConnectWiseGetConnection?: Maybe<ConnectWiseConnection>
  PartnerConnectWiseGetFilters?: Maybe<ConnectWiseQueryFilters>
  PartnerContractSubtypeConnection: ContractSubtypeConnection
  PartnerContractTypeConnection: ContractTypeConnection
  PartnerCustomerAutopayRuleConnection?: Maybe<AutopayRuleConnection>
  PartnerCustomerConnection?: Maybe<CustomerConnection>
  PartnerCustomerTagsAutopayRuleConnection?: Maybe<AutopayRuleConnection>
  PartnerCustomerUserConnection?: Maybe<CustomerUserConnection>
  PartnerEmailActivityConnection?: Maybe<EmailActivityConnection>
  PartnerGetARAgingBucketsAmountInsight?: Maybe<ArAgingBucketsAmountResponse>
  PartnerGetARAgingBucketsCountInsight?: Maybe<ArAgingBucketsCountResponse>
  PartnerGetAccountingPreferences?: Maybe<AccountingPreferences>
  PartnerGetAccountingSyncBatch?: Maybe<GetAccountingSyncBatchReply>
  PartnerGetActivationRateInvoiceVolumeByMonthInsight?: Maybe<ActivationRateInvoiceVolumeByMonthResponse>
  PartnerGetActivationRatesByMonthInsight?: Maybe<ActivationRatesByMonthResponse>
  PartnerGetAutomatedPaymentVolumePercentByMonthCustomerInsight?: Maybe<AutomatedPaymentVolumePercentByMonthResponse>
  PartnerGetAutomatedPaymentVolumePercentByMonthInsight?: Maybe<AutomatedPaymentVolumePercentByMonthResponse>
  PartnerGetAutomatedPaymentVolumePercentageInsight?: Maybe<AutomatedPaymentVolumePercentageResponse>
  PartnerGetAutomatedPaymentsByMonthInsight?: Maybe<AutomatedPaymentsByMonthResponse>
  PartnerGetAutomatedPaymentsCustomerInsight?: Maybe<AutomatedPaymentsResponse>
  PartnerGetAutomatedPaymentsInsight?: Maybe<AutomatedPaymentsResponse>
  PartnerGetAutomatedTransactionCountInsight?: Maybe<AutomatedTransactionCountResponse>
  PartnerGetAverageDaysOverdueInsight?: Maybe<AverageDaysOverdueResponse>
  PartnerGetAverageInvoiceAmountInsight?: Maybe<AverageInvoiceAmountResponse>
  PartnerGetAverageOverdueAmountInsight?: Maybe<AverageOverdueAmountResponse>
  PartnerGetAveragePaymentSizeInsight?: Maybe<AveragePaymentSizeResponse>
  PartnerGetAverageTimeToPayAutopayInsight?: Maybe<AverageTimeToPayAutopayResponse>
  PartnerGetAverageTimeToPayByMonthCustomerInsight?: Maybe<AverageTimeToPayByMonthResponse>
  PartnerGetAverageTimeToPayByMonthInsight?: Maybe<AverageTimeToPayByMonthResponse>
  PartnerGetAverageTimeToPayCustomerInsight?: Maybe<AverageTimeToPayResponse>
  PartnerGetAverageTimeToPayExternalInsight?: Maybe<AverageTimeToPayExternalResponse>
  PartnerGetAverageTimeToPayExternalVsInternalByMonthInsight?: Maybe<AverageTimeToPayExternalVsInternalByMonthResponse>
  PartnerGetAverageTimeToPayInsight?: Maybe<AverageTimeToPayResponse>
  PartnerGetCardFee?: Maybe<CardFeeAmount>
  PartnerGetCardPubKey?: Maybe<Scalars['String']['output']>
  PartnerGetCashFlowDistributionLastThirtyDaysInsight?: Maybe<CashFlowDistributionLastThirtyDaysReponse>
  PartnerGetCoveredInvoicesForRule: Array<Invoice>
  PartnerGetCustomPartnerFeeConfigs?: Maybe<CustomPartnerFeeConfigs>
  PartnerGetCustomerCardFee?: Maybe<CardFeeAmount>
  PartnerGetCustomerPaymentConfig?: Maybe<PaymentCompanyConfig>
  PartnerGetCustomersPaymentConfig?: Maybe<Array<Maybe<PaymentCompanyConfig>>>
  PartnerGetFeeRates?: Maybe<CollectionFeeRates>
  PartnerGetInvoiceAmountByStatusMonthCustomerInsight?: Maybe<InvoiceAmountByStatusMonthResponse>
  PartnerGetInvoiceAmountByStatusMonthInsight?: Maybe<InvoiceAmountByStatusMonthResponse>
  PartnerGetInvoiceBulkCharges?: Maybe<PartnerInvoiceBulkChargeConnection>
  PartnerGetInvoiceCountByStatusMonthInsight?: Maybe<InvoiceCountByStatusMonthResponse>
  PartnerGetInvoiceCountInsight?: Maybe<InvoiceCountResponse>
  PartnerGetInvoiceLedgerMovements?: Maybe<LedgerMovementResult>
  PartnerGetInvoicePdfLink: InvoicePdfLink
  PartnerGetInvoicePreferences?: Maybe<InvoicePreferences>
  PartnerGetInvoiceVolumeCustomerInsight?: Maybe<InvoiceVolumeResponse>
  PartnerGetInvoiceVolumeInsight?: Maybe<InvoiceVolumeResponse>
  PartnerGetNotificationsEnabled: NotificationsEnabled
  PartnerGetNumberOfOverdueInvoicesThirtyDaysInsight?: Maybe<NumberOfOverdueInvoicesThirtyDaysResponse>
  PartnerGetNumberOfPaymentsCustomerInsight?: Maybe<NumberOfPaymentsResponse>
  PartnerGetNumberOfPaymentsInsight?: Maybe<NumberOfPaymentsResponse>
  PartnerGetOverdueInvoiceCountInsight?: Maybe<OverdueInvoiceCountResponse>
  PartnerGetOverdueInvoicePercentageInsight?: Maybe<OverdueInvoicePercentageResponse>
  PartnerGetOverdueInvoiceVolumeInsight?: Maybe<OverdueInvoiceVolumeResponse>
  PartnerGetOverdueInvoicesVolumeThirtyDaysCustomerInsight?: Maybe<OverdueInvoicesVolumeThirtyDaysResponse>
  PartnerGetOverdueInvoicesVolumeThirtyDaysInsight?: Maybe<OverdueInvoicesVolumeThirtyDaysResponse>
  PartnerGetPartnerAutopayConfig?: Maybe<PartnerAutopayConfig>
  PartnerGetPartnerFeeConfig?: Maybe<PartnerFeeConfig>
  PartnerGetPaymentConfig?: Maybe<PaymentCompanyConfig>
  PartnerGetPaymentCountByTriggerLastMonthInsight?: Maybe<PaymentCountByTriggerLastMonthResponse>
  PartnerGetPaymentVolumeAutomatedInsight?: Maybe<PaymentVolumeAutomatedResponse>
  PartnerGetPaymentVolumeByMonthCustomerInsight?: Maybe<PaymentVolumeByMonthResponse>
  PartnerGetPaymentVolumeByMonthInsight?: Maybe<PaymentVolumeByMonthResponse>
  PartnerGetPaymentVolumeByTriggerLastMonthInsight?: Maybe<PaymentVolumeByTriggerLastMonthResponse>
  PartnerGetPaymentVolumeCustomerInsight?: Maybe<PaymentVolumeResponse>
  PartnerGetPaymentVolumeInsight?: Maybe<PaymentVolumeResponse>
  PartnerGetPaymentsCountByMethodMonthInsight?: Maybe<PaymentsCountByMethodMonthResponse>
  PartnerGetPaymentsVolumeByMethodMonthInsight?: Maybe<PaymentsVolumeByMethodMonthResponse>
  PartnerGetPayoutConfig?: Maybe<PayoutCompanyConfig>
  PartnerGetPayoutTimingCompanyConfig?: Maybe<CompanyPayoutTimingConfigs>
  PartnerGetPayoutTimingPlans?: Maybe<Array<Maybe<PayoutTimingPlan>>>
  PartnerGetReferralLink: Scalars['String']['output']
  PartnerGetReferralPayoutByPayoutID?: Maybe<ReferralPayout>
  PartnerGetUnsyncedInvoiceTotals?: Maybe<UnsyncedInvoiceTotals>
  PartnerGlobalAutopayRuleConnection?: Maybe<AutopayRuleConnection>
  PartnerInvoiceBnplConnection?: Maybe<InvoiceBnplConnection>
  PartnerInvoiceConnection: InvoiceConnection
  PartnerInvoiceListTotals?: Maybe<InvoiceTotals>
  PartnerListAccountingSyncBatches?: Maybe<ListAccountingSyncBatchesReply>
  PartnerListAccountingSyncJobs?: Maybe<ListAccountingSyncJobsReply>
  PartnerListActiveSubscriptions: Array<PartnerSubscription>
  PartnerListAutopayExcludedInvoices: Array<AutopayExcludedInvoice>
  PartnerListBankingIntegrations: Array<Maybe<Institution>>
  PartnerListCards?: Maybe<Array<Maybe<Card>>>
  PartnerListCustomerBankingIntegrations: Array<Maybe<Institution>>
  PartnerListCustomerCards?: Maybe<Array<Maybe<Card>>>
  PartnerListCustomerFeeExceptions?: Maybe<Array<CustomerFeeConfig>>
  PartnerListCustomerRulesTotals?: Maybe<AutopayRuleTotals>
  PartnerListCustomerTags?: Maybe<Array<CustomerTag>>
  PartnerListCustomersTotals?: Maybe<PartnerCustomerTotals>
  PartnerListEmailTemplates?: Maybe<Array<EmailTemplate>>
  PartnerListIntegrations?: Maybe<Array<Maybe<IntegrationInterface>>>
  PartnerListInvoiceReminderExcludedCustomers?: Maybe<
    Array<Maybe<InvoiceReminderExcludedCustomer>>
  >
  PartnerListInvoiceReminders?: Maybe<Array<Maybe<InvoiceReminder>>>
  PartnerListInvoiceSummaries?: Maybe<Array<Maybe<InvoiceSummary>>>
  PartnerListInvoiceSummaryExcludedCustomers?: Maybe<
    Array<Maybe<InvoiceSummaryExcludedCustomer>>
  >
  PartnerListPayments?: Maybe<PaymentPage>
  PartnerListPendingCustomerUsersTotals?: Maybe<PendingCustomerUsersTotals>
  PartnerListSubscriptionPaymentsTotals: SubscriptionPaymentsTotals
  PartnerListUnsyncedInvoices?: Maybe<UnsyncedInvoices>
  PartnerLogoUploadURL?: Maybe<PartnerLogoUploadUrl>
  PartnerPaymentConnection?: Maybe<PaymentConnection>
  PartnerPaymentTotals?: Maybe<PaymentTotals>
  PartnerPayoutBreakdownListItemConnection?: Maybe<BreakdownListItemConnection>
  PartnerPayoutConnection?: Maybe<PayoutConnection>
  PartnerPayoutDetails?: Maybe<PayoutDetails>
  PartnerPayoutTotals?: Maybe<PayoutTotals>
  PartnerPendingCustomerUserConnection?: Maybe<PendingCustomerUserConnection>
  PartnerQuickbooksAccountList?: Maybe<Array<Maybe<QuickbooksAccount>>>
  PartnerQuickbooksAccountRetrieve?: Maybe<QuickbooksAccount>
  PartnerQuickbooksConnectionRead?: Maybe<QuickbooksConnection>
  PartnerQuickbooksConnectionURL?: Maybe<Scalars['String']['output']>
  PartnerRecurringPaymentConnection: RecurringPaymentConnection
  PartnerRecurringPaymentTotals?: Maybe<RecurringPaymentTotals>
  PartnerRecurringTransactionConnection: RecurringTransactionConnection
  PartnerReferralConnection?: Maybe<ReferralConnection>
  PartnerReferralGetAvailableForPayoutData: GetReferralDataReply
  PartnerReferralGetAvgQuarterlyFeesData: GetReferralDataReply
  PartnerReferralGetQuarterlyEarningsData: GetReferralDataReply
  PartnerReferralGetTotalReferralFeesData: GetReferralDataReply
  PartnerRutterAccountList?: Maybe<Array<Maybe<RutterAccount>>>
  PartnerRutterAccountRead?: Maybe<RutterSelectedAccounts>
  PartnerRutterConnectionRead?: Maybe<RutterConnection>
  PartnerRutterPaymentTermsConnection?: Maybe<RutterPaymentTermsConnection>
  PartnerSubscriptionsPaymentsConnection: SubscriptionPaymentConnection
  PartnerUserConnection?: Maybe<PartnerUserConnection>
  SuperAdminPartnerConnection?: Maybe<PartnerConnection>
}

export type QueryCreateUserAndPartnerArgs = {
  referralID?: InputMaybe<Scalars['String']['input']>
}

export type QueryFindAutopayRuleArgs = {
  id: Scalars['ID']['input']
}

export type QueryFindInvoiceArgs = {
  id: Scalars['String']['input']
}

export type QueryGetAdyenDocumentTypesArgs = {
  ownerType: AdyenOwnerType
}

export type QueryGetCustomerAutopayConfigArgs = {
  input: GetCustomerAutopayConfigInput
}

export type QueryOAuth2UrlArgs = {
  referralID?: InputMaybe<Scalars['ID']['input']>
}

export type QueryPartnerAccountingSyncConfigGetArgs = {
  input: SyncConfigGetInput
}

export type QueryPartnerAgreementTypeConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<AgreementTypeFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<AgreementTypeOrderBy>
}

export type QueryPartnerApiKeyConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<ApiKeyFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ApiKeyOrderBy>
}

export type QueryPartnerAutopayExcludedCustomerConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<AutopayExcludedCustomerFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<AutopayExcludedCustomerOrderBy>
}

export type QueryPartnerAutopayExcludedCustomerListTotalsArgs = {
  filters?: InputMaybe<AutopayExcludedCustomerFilter>
}

export type QueryPartnerAutotaskContractConnectionArgs = {
  filter?: InputMaybe<AutotaskContractFilter>
}

export type QueryPartnerCollectionConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  collectionFilter?: InputMaybe<CollectionFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<CollectionOrder>
}

export type QueryPartnerCollectionTotalsArgs = {
  collectionFilter?: InputMaybe<CollectionFilter>
}

export type QueryPartnerConnectWiseAgreementConnectionArgs = {
  filter?: InputMaybe<ConnectWiseAgreementFilter>
}

export type QueryPartnerConnectWiseBillingTermsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<CwBillingTermsFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<CwBillingTermsOrderBy>
}

export type QueryPartnerContractSubtypeConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<ContractSubtypeFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ContractSubtypeOrderBy>
}

export type QueryPartnerContractTypeConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<ContractTypeFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ContractTypeOrderBy>
}

export type QueryPartnerCustomerAutopayRuleConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<AutopayRuleFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<AutopayRuleOrderBy>
}

export type QueryPartnerCustomerConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<CustomerFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<CustomerOrderBy>
}

export type QueryPartnerCustomerTagsAutopayRuleConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<AutopayRuleFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<AutopayRuleOrderBy>
}

export type QueryPartnerCustomerUserConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<CustomerUserFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<CustomerUserOrderBy>
}

export type QueryPartnerEmailActivityConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<EmailActivityFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPartnerGetArAgingBucketsAmountInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetArAgingBucketsCountInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAccountingSyncBatchArgs = {
  batchID: Scalars['ID']['input']
}

export type QueryPartnerGetActivationRateInvoiceVolumeByMonthInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetActivationRatesByMonthInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAutomatedPaymentVolumePercentByMonthCustomerInsightArgs =
  {
    customerID: Scalars['String']['input']
    dateFrom: Scalars['String']['input']
    dateTo: Scalars['String']['input']
  }

export type QueryPartnerGetAutomatedPaymentVolumePercentByMonthInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAutomatedPaymentVolumePercentageInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAutomatedPaymentsByMonthInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAutomatedPaymentsCustomerInsightArgs = {
  customerID: Scalars['String']['input']
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAutomatedPaymentsInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAutomatedTransactionCountInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAverageDaysOverdueInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAverageInvoiceAmountInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAverageOverdueAmountInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAveragePaymentSizeInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAverageTimeToPayAutopayInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAverageTimeToPayByMonthCustomerInsightArgs = {
  customerID: Scalars['String']['input']
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAverageTimeToPayByMonthInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAverageTimeToPayCustomerInsightArgs = {
  customerID: Scalars['String']['input']
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAverageTimeToPayExternalInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetAverageTimeToPayExternalVsInternalByMonthInsightArgs =
  {
    dateFrom: Scalars['String']['input']
    dateTo: Scalars['String']['input']
  }

export type QueryPartnerGetAverageTimeToPayInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetCardFeeArgs = {
  input: GetCardFeeInput
}

export type QueryPartnerGetCardPubKeyArgs = {
  input: GetCardPubKey
}

export type QueryPartnerGetCoveredInvoicesForRuleArgs = {
  input: PartnerGetCoveredInvoicesForRuleInput
}

export type QueryPartnerGetCustomPartnerFeeConfigsArgs = {
  customPartnerFeeConfigsFilter?: InputMaybe<CustomPartnerFeeConfigsFilter>
}

export type QueryPartnerGetCustomerCardFeeArgs = {
  input: GetCustomerCardFeeInput
}

export type QueryPartnerGetCustomerPaymentConfigArgs = {
  customerID: Scalars['ID']['input']
}

export type QueryPartnerGetCustomersPaymentConfigArgs = {
  customerIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type QueryPartnerGetFeeRatesArgs = {
  input: GetFeeRatesInput
}

export type QueryPartnerGetInvoiceAmountByStatusMonthCustomerInsightArgs = {
  customerID: Scalars['String']['input']
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetInvoiceAmountByStatusMonthInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetInvoiceBulkChargesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  getPartnerInvoiceBulkChargesFilter?: InputMaybe<GetPartnerInvoiceBulkChargesFilter>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<GetPartnerInvoiceBulkChargesOrderBy>
}

export type QueryPartnerGetInvoiceCountByStatusMonthInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetInvoiceCountInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetInvoiceLedgerMovementsArgs = {
  invoiceID: Scalars['String']['input']
}

export type QueryPartnerGetInvoicePdfLinkArgs = {
  invoiceID: Scalars['String']['input']
}

export type QueryPartnerGetInvoiceVolumeCustomerInsightArgs = {
  customerID: Scalars['String']['input']
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetInvoiceVolumeInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetNumberOfOverdueInvoicesThirtyDaysInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetNumberOfPaymentsCustomerInsightArgs = {
  customerID: Scalars['String']['input']
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetNumberOfPaymentsInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetOverdueInvoiceCountInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetOverdueInvoicePercentageInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetOverdueInvoiceVolumeInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetOverdueInvoicesVolumeThirtyDaysCustomerInsightArgs =
  {
    customerID: Scalars['String']['input']
    dateFrom: Scalars['String']['input']
    dateTo: Scalars['String']['input']
  }

export type QueryPartnerGetOverdueInvoicesVolumeThirtyDaysInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetPaymentVolumeAutomatedInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetPaymentVolumeByMonthCustomerInsightArgs = {
  customerID: Scalars['String']['input']
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetPaymentVolumeByMonthInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetPaymentVolumeCustomerInsightArgs = {
  customerID: Scalars['String']['input']
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetPaymentVolumeInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetPaymentsCountByMethodMonthInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetPaymentsVolumeByMethodMonthInsightArgs = {
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}

export type QueryPartnerGetReferralPayoutByPayoutIdArgs = {
  payoutID: Scalars['ID']['input']
}

export type QueryPartnerGetUnsyncedInvoiceTotalsArgs = {
  filters?: InputMaybe<UnsyncedInvoicesFilter>
}

export type QueryPartnerGlobalAutopayRuleConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<AutopayRuleOrderBy>
}

export type QueryPartnerInvoiceBnplConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<BnplFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPartnerInvoiceConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<InvoiceFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<InvoiceOrderBy>
}

export type QueryPartnerInvoiceListTotalsArgs = {
  filters?: InputMaybe<InvoiceFilter>
}

export type QueryPartnerListAccountingSyncBatchesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<ListAccountingSyncBatchesFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPartnerListAccountingSyncJobsArgs = {
  batchID: Scalars['ID']['input']
  parentID: Scalars['ID']['input']
}

export type QueryPartnerListAutopayExcludedInvoicesArgs = {
  invoiceIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type QueryPartnerListCardsArgs = {
  filter?: InputMaybe<ListCardsFilterInput>
}

export type QueryPartnerListCustomerBankingIntegrationsArgs = {
  customerID: Scalars['String']['input']
}

export type QueryPartnerListCustomerCardsArgs = {
  customerID: Scalars['ID']['input']
  filter?: InputMaybe<ListCardsFilterInput>
}

export type QueryPartnerListCustomerFeeExceptionsArgs = {
  input?: InputMaybe<PartnerListCustomerFeeExceptionsInput>
}

export type QueryPartnerListCustomerRulesTotalsArgs = {
  customerID?: InputMaybe<Scalars['ID']['input']>
}

export type QueryPartnerListCustomerTagsArgs = {
  filter?: InputMaybe<TagFilter>
}

export type QueryPartnerListCustomersTotalsArgs = {
  filter?: InputMaybe<CustomerFilter>
}

export type QueryPartnerListEmailTemplatesArgs = {
  favoritesOnly?: InputMaybe<Scalars['Boolean']['input']>
  templateID?: InputMaybe<Scalars['ID']['input']>
  templateType: TemplateType
}

export type QueryPartnerListPaymentsArgs = {
  orderBy?: InputMaybe<PaymentOrder>
  pagination: Pagination
  paymentFilter?: InputMaybe<PaymentFilter>
}

export type QueryPartnerListUnsyncedInvoicesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<UnsyncedInvoicesFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<UnsyncedInvoicesOrderBy>
}

export type QueryPartnerPaymentConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<PaymentOrder>
  paymentFilter?: InputMaybe<PaymentFilter>
}

export type QueryPartnerPaymentTotalsArgs = {
  paymentFilter?: InputMaybe<PaymentFilter>
}

export type QueryPartnerPayoutBreakdownListItemConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  breakdownFilter?: InputMaybe<BreakdownFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPartnerPayoutConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<PayoutOrder>
  payoutFilter?: InputMaybe<PayoutFilter>
}

export type QueryPartnerPayoutDetailsArgs = {
  payoutID: Scalars['ID']['input']
}

export type QueryPartnerPayoutTotalsArgs = {
  payoutFilter?: InputMaybe<PayoutFilter>
}

export type QueryPartnerPendingCustomerUserConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<PendingCustomerUserFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<PendingCustomerUserOrderBy>
}

export type QueryPartnerQuickbooksConnectionUrlArgs = {
  redirectURI: Scalars['String']['input']
}

export type QueryPartnerRecurringPaymentConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<RecurringPaymentFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<RecurringPaymentOrderBy>
}

export type QueryPartnerRecurringPaymentTotalsArgs = {
  filters?: InputMaybe<RecurringPaymentFilter>
}

export type QueryPartnerRecurringTransactionConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<RecurringTransactionFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<RecurringTransactionOrderBy>
}

export type QueryPartnerReferralConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<ReferralFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ReferralOrderBy>
}

export type QueryPartnerReferralGetAvailableForPayoutDataArgs = {
  input: GetReferralDataInput
}

export type QueryPartnerReferralGetAvgQuarterlyFeesDataArgs = {
  input: GetReferralDataInput
}

export type QueryPartnerReferralGetQuarterlyEarningsDataArgs = {
  input: GetReferralDataInput
}

export type QueryPartnerReferralGetTotalReferralFeesDataArgs = {
  input: GetReferralDataInput
}

export type QueryPartnerRutterAccountListArgs = {
  input?: InputMaybe<RutterAccountListInput>
}

export type QueryPartnerRutterAccountReadArgs = {
  platform?: InputMaybe<RutterPlatform>
}

export type QueryPartnerRutterConnectionReadArgs = {
  platform?: InputMaybe<RutterPlatform>
}

export type QueryPartnerRutterPaymentTermsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<RutterPaymentTermsFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<RutterPaymentTermsOrderBy>
}

export type QueryPartnerSubscriptionsPaymentsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<SubscriptionPaymentFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<SubscriptionPaymentOrderBy>
}

export type QueryPartnerUserConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<PartnerUserOrderBy>
}

export type QuerySuperAdminPartnerConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filters?: InputMaybe<PartnerFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<PartnerOrderBy>
}

export type QuickbooksAccount = {
  __typename: 'QuickbooksAccount'
  fullyQualifiedName: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  type: Scalars['String']['output']
}

export type QuickbooksAccountUpdateInput = {
  fullyQualifiedName: Scalars['String']['input']
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
  type: Scalars['String']['input']
}

export type QuickbooksConnection = {
  __typename: 'QuickbooksConnection'
  createDeposits: Scalars['Boolean']['output']
}

export type QuickbooksIntegration = IntegrationInterface & {
  __typename: 'QuickbooksIntegration'
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  integrationType: IntegrationType
  partnerID: Scalars['ID']['output']
  platformName: Scalars['String']['output']
  status: ConnectionStatus
}

export type QuickbooksRecurringTransaction = {
  __typename: 'QuickbooksRecurringTransaction'
  externalID: Scalars['String']['output']
  name: Scalars['String']['output']
  partnerID: Scalars['String']['output']
}

export type RecurringInvoicesInput = {
  halopsa?: InputMaybe<Scalars['Boolean']['input']>
}

export type RecurringPayment = {
  __typename: 'RecurringPayment'
  amount: Scalars['Float']['output']
  autoCharge: Scalars['Boolean']['output']
  createdAt: Scalars['String']['output']
  customer: Customer
  dateFirstCharge: Scalars['String']['output']
  dateLastCharge?: Maybe<Scalars['String']['output']>
  frequency: Frequency
  id: Scalars['ID']['output']
  productName?: Maybe<Scalars['String']['output']>
  status: RecurringPaymentStatus
  updatedAt: Scalars['String']['output']
}

/** A connection to a list of items. */
export type RecurringPaymentConnection = {
  __typename: 'RecurringPaymentConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RecurringPaymentEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type RecurringPaymentCreateInput = {
  amount: Scalars['Float']['input']
  autoCharge?: InputMaybe<Scalars['Boolean']['input']>
  customerID: Scalars['String']['input']
  dateFirstCharge: Scalars['String']['input']
  dateLastCharge?: InputMaybe<Scalars['String']['input']>
  frequency: Frequency
  productName?: InputMaybe<Scalars['String']['input']>
}

export type RecurringPaymentDeactivateInput = {
  id: Scalars['ID']['input']
}

/** An edge in a connection. */
export type RecurringPaymentEdge = {
  __typename: 'RecurringPaymentEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output']
  /** The item at the end of the edge. */
  node?: Maybe<RecurringPayment>
}

export type RecurringPaymentFilter = {
  amountEnd?: InputMaybe<Scalars['Float']['input']>
  amountStart?: InputMaybe<Scalars['Float']['input']>
  customerID?: InputMaybe<Scalars['ID']['input']>
  dateFirstChargedEnd?: InputMaybe<Scalars['String']['input']>
  dateFirstChargedStart?: InputMaybe<Scalars['String']['input']>
  dateLastChargedEnd?: InputMaybe<Scalars['String']['input']>
  dateLastChargedStart?: InputMaybe<Scalars['String']['input']>
  frequency?: InputMaybe<Frequency>
  status?: InputMaybe<Array<RecurringPaymentStatus>>
}

export type RecurringPaymentOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<RecurringPaymentOrderByField>
}

export enum RecurringPaymentOrderByField {
  Amount = 'AMOUNT',
  DateFirstCharged = 'DATE_FIRST_CHARGED',
  DateLastCharged = 'DATE_LAST_CHARGED'
}

export enum RecurringPaymentStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Overdue = 'OVERDUE'
}

export type RecurringPaymentTotals = {
  __typename: 'RecurringPaymentTotals'
  amount: Scalars['Float']['output']
  count: Scalars['Int']['output']
}

export type RecurringPaymentUpdateInput = {
  amount?: InputMaybe<Scalars['Float']['input']>
  autoCharge?: InputMaybe<Scalars['Boolean']['input']>
  dateLastCharge?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  productName?: InputMaybe<Scalars['String']['input']>
}

export type RecurringTransactionConnection = {
  __typename: 'RecurringTransactionConnection'
  edges?: Maybe<Array<Maybe<RecurringTransactionEdge>>>
  pageInfo: PageInfo
}

export type RecurringTransactionEdge = {
  __typename: 'RecurringTransactionEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<QuickbooksRecurringTransaction>
}

export type RecurringTransactionFilter = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type RecurringTransactionOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<RecurringTransactionOrderByField>
}

export enum RecurringTransactionOrderByField {
  CreatedDate = 'CREATED_DATE',
  Name = 'NAME'
}

export type Referral = {
  __typename: 'Referral'
  avgQuarterlyFees?: Maybe<Scalars['Float']['output']>
  companyName?: Maybe<Scalars['String']['output']>
  customerID?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  processingVolume?: Maybe<Scalars['Float']['output']>
  referralDate?: Maybe<Scalars['String']['output']>
  referralFees?: Maybe<Scalars['Float']['output']>
  referredPartner?: Maybe<Partner>
  status: ReferralStatus
}

export type ReferralBonus = {
  __typename: 'ReferralBonus'
  amount: Scalars['Float']['output']
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  referralPayoutID: Scalars['ID']['output']
}

export enum ReferralComparisonPeriod {
  ReferralPeriodAllTime = 'REFERRAL_PERIOD_ALL_TIME',
  ReferralPeriodLastQuarter = 'REFERRAL_PERIOD_LAST_QUARTER',
  ReferralPeriodLastSixMonths = 'REFERRAL_PERIOD_LAST_SIX_MONTHS',
  ReferralPeriodLastYear = 'REFERRAL_PERIOD_LAST_YEAR'
}

export type ReferralConnection = {
  __typename: 'ReferralConnection'
  edges?: Maybe<Array<Maybe<ReferralEdge>>>
  pageInfo: PageInfo
}

export type ReferralEdge = {
  __typename: 'ReferralEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<Referral>
}

export type ReferralFilter = {
  companyName?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  partnerID?: InputMaybe<Scalars['ID']['input']>
  referralIDs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  statusIn?: InputMaybe<Array<InputMaybe<ReferralStatus>>>
  statusNotIn?: InputMaybe<Array<InputMaybe<ReferralStatus>>>
}

export type ReferralInput = {
  customerID?: InputMaybe<Scalars['ID']['input']>
  customerName?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  referralID?: InputMaybe<Scalars['ID']['input']>
  userID?: InputMaybe<Scalars['ID']['input']>
}

export type ReferralOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<ReferralOrderByField>
}

export enum ReferralOrderByField {
  CompanyName = 'COMPANY_NAME'
}

export type ReferralPayout = {
  __typename: 'ReferralPayout'
  amount: Scalars['Float']['output']
  id: Scalars['ID']['output']
  partnerID: Scalars['ID']['output']
  payoutDate?: Maybe<Scalars['String']['output']>
  payoutID?: Maybe<Scalars['ID']['output']>
  period: Scalars['String']['output']
  referralCount: Scalars['Int']['output']
  referredPartnersRevenue?: Maybe<Array<Maybe<ReferredPartnerRevenue>>>
  status: ReferralPayoutStatus
}

export enum ReferralPayoutMethodEnum {
  SameDayAch = 'SAME_DAY_ACH',
  StandardAch = 'STANDARD_ACH'
}

export enum ReferralPayoutStatus {
  Approved = 'APPROVED',
  Failed = 'FAILED',
  Paid = 'PAID',
  PendingApproval = 'PENDING_APPROVAL',
  Unspecified = 'UNSPECIFIED'
}

export enum ReferralStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Converted = 'CONVERTED',
  Demo = 'DEMO',
  NotSent = 'NOT_SENT',
  Referred = 'REFERRED'
}

export type ReferredPartnerRevenue = {
  __typename: 'ReferredPartnerRevenue'
  lastQuarterRevenue?: Maybe<Scalars['Float']['output']>
  referredPartnerID?: Maybe<Scalars['ID']['output']>
}

export type Refund = {
  __typename: 'Refund'
  amount: Scalars['Float']['output']
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  lastStatus: RefundStatusEnum
  originalPayer: Company
  originalReceiver: Company
  paymentID: Scalars['String']['output']
  status?: Maybe<Array<RefundStatus>>
}

export type RefundCreateInput = {
  amount?: InputMaybe<Scalars['Float']['input']>
  idempotencyKey: Scalars['String']['input']
  paymentID: Scalars['String']['input']
  reason: Scalars['String']['input']
}

export type RefundStatus = {
  __typename: 'RefundStatus'
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  status: RefundStatusEnum
}

export enum RefundStatusEnum {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Scheduled = 'SCHEDULED',
  Success = 'SUCCESS'
}

export enum ReportType {
  Payment = 'PAYMENT',
  Payout = 'PAYOUT'
}

export enum RuleOperator {
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  LessThan = 'LESS_THAN'
}

export type RutterAccount = {
  __typename: 'RutterAccount'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  nominalCode: Scalars['String']['output']
  type: Scalars['String']['output']
}

export enum RutterAccountFor {
  Deposits = 'DEPOSITS',
  Fees = 'FEES',
  Funds = 'FUNDS',
  Payments = 'PAYMENTS'
}

export type RutterAccountListInput = {
  accountsFor?: InputMaybe<Array<RutterAccountFor>>
  platform: RutterPlatform
}

export type RutterAccountUnsetInput = {
  accountFor: RutterAccountFor
  platform: RutterPlatform
}

export type RutterAccountUpsert = {
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
  type: Scalars['String']['input']
}

export type RutterAccountUpsertInput = {
  accountFor: RutterAccountFor
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
  platform?: InputMaybe<RutterPlatform>
  type: Scalars['String']['input']
}

export type RutterAccountUpsertManyInput = {
  accountForDeposits?: InputMaybe<RutterAccountUpsert>
  accountForFees?: InputMaybe<RutterAccountUpsert>
  accountForPayments?: InputMaybe<RutterAccountUpsert>
  platform: RutterPlatform
}

export type RutterConnection = {
  __typename: 'RutterConnection'
  platform: Scalars['String']['output']
  rutterConnectionID: Scalars['String']['output']
  status: ConnectionStatus
}

export type RutterIntegration = IntegrationInterface & {
  __typename: 'RutterIntegration'
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  integrationType: IntegrationType
  partnerID: Scalars['ID']['output']
  platformName: Scalars['String']['output']
  status: ConnectionStatus
}

export type RutterPaymentTerms = {
  __typename: 'RutterPaymentTerms'
  externalID: Scalars['String']['output']
  name: Scalars['String']['output']
  partnerID: Scalars['String']['output']
}

export type RutterPaymentTermsConnection = {
  __typename: 'RutterPaymentTermsConnection'
  edges?: Maybe<Array<Maybe<RutterPaymentTermsEdge>>>
  pageInfo: PageInfo
}

export type RutterPaymentTermsEdge = {
  __typename: 'RutterPaymentTermsEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<RutterPaymentTerms>
}

export type RutterPaymentTermsFilter = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type RutterPaymentTermsOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<RutterPaymentTermsOrderByField>
}

export enum RutterPaymentTermsOrderByField {
  CreatedDate = 'CREATED_DATE',
  Name = 'NAME'
}

export enum RutterPlatform {
  Dynamics_365 = 'DYNAMICS_365',
  Freshbooks = 'FRESHBOOKS',
  Netsuite = 'NETSUITE',
  QuickbooksDesktop = 'QUICKBOOKS_DESKTOP',
  SageIntacct = 'SAGE_INTACCT',
  Xero = 'XERO',
  ZohoBooks = 'ZOHO_BOOKS'
}

export type RutterSelectedAccounts = {
  __typename: 'RutterSelectedAccounts'
  AccountForDeposits?: Maybe<RutterAccount>
  AccountForFees?: Maybe<RutterAccount>
  AccountForFunds?: Maybe<RutterAccount>
  AccountForPayments?: Maybe<RutterAccount>
}

export type SecondaryIntegrationDeleteInput = {
  platform: PlatformName
}

export type SendPartnerReferralInput = {
  inputs?: InputMaybe<Array<ReferralInput>>
  templateID?: InputMaybe<Scalars['ID']['input']>
}

export type StartAdyenOnboardingReply = {
  __typename: 'StartAdyenOnboardingReply'
  validations: Array<Scalars['String']['output']>
}

export enum SubscriptionFrequency {
  Annual = 'ANNUAL',
  Custom = 'CUSTOM',
  Monthly = 'MONTHLY',
  OneShot = 'ONE_SHOT'
}

export type SubscriptionPayment = {
  __typename: 'SubscriptionPayment'
  amount: Scalars['Float']['output']
  id: Scalars['ID']['output']
  payment?: Maybe<Payment>
  paymentDate: Scalars['String']['output']
  status: SubscriptionPaymentStatus
  subscription: PartnerSubscription
}

export type SubscriptionPaymentConnection = {
  __typename: 'SubscriptionPaymentConnection'
  edges?: Maybe<Array<Maybe<SubscriptionPaymentEdge>>>
  pageInfo: PageInfo
}

export type SubscriptionPaymentEdge = {
  __typename: 'SubscriptionPaymentEdge'
  cursor: Scalars['Cursor']['output']
  node?: Maybe<SubscriptionPayment>
}

export type SubscriptionPaymentFilter = {
  amountEnd?: InputMaybe<Scalars['Float']['input']>
  amountStart?: InputMaybe<Scalars['Float']['input']>
  paymentDateEnd?: InputMaybe<Scalars['String']['input']>
  paymentDateStart?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Array<SubscriptionPaymentStatus>>
  subscriptionID?: InputMaybe<Scalars['ID']['input']>
}

export type SubscriptionPaymentOrderBy = {
  direction?: InputMaybe<OrderDirection>
  field?: InputMaybe<SubscriptionPaymentOrderByField>
}

export enum SubscriptionPaymentOrderByField {
  Amount = 'AMOUNT',
  PaymentDate = 'PAYMENT_DATE',
  Status = 'STATUS'
}

export enum SubscriptionPaymentStatus {
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Processing = 'PROCESSING',
  Scheduled = 'SCHEDULED'
}

export type SubscriptionPaymentsTotals = {
  __typename: 'SubscriptionPaymentsTotals'
  count: Scalars['Int']['output']
}

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type SuperAdminUser = {
  __typename: 'SuperAdminUser'
  createdAt: Scalars['String']['output']
  email: Scalars['String']['output']
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  lastName?: Maybe<Scalars['String']['output']>
  role: SuperAdminUserRole
}

export enum SuperAdminUserRole {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

export type SuperOpsIntegration = IntegrationInterface & {
  __typename: 'SuperOpsIntegration'
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  integrationType: IntegrationType
  partnerID: Scalars['ID']['output']
  platformName: Scalars['String']['output']
  status: ConnectionStatus
}

export type SuperopsConnectionCreateInput = {
  apiToken: Scalars['String']['input']
  integrationType: IntegrationType
  subdomain: Scalars['String']['input']
}

export type SupportPreferences = {
  __typename: 'SupportPreferences'
  email: Scalars['String']['output']
  firstLine: Scalars['String']['output']
  name: Scalars['String']['output']
  partnerID: Scalars['ID']['output']
  phone?: Maybe<Scalars['String']['output']>
  secondLine?: Maybe<Scalars['String']['output']>
}

export type SyncConfig = {
  __typename: 'SyncConfig'
  lastAutomaticSync?: Maybe<Scalars['String']['output']>
  mappings?: Maybe<Array<SyncConfigMapping>>
  options: Array<SyncConfigOption>
  partnerID: Scalars['ID']['output']
  sourcePlatformName: PlatformName
  targetPlatformName: PlatformName
}

export type SyncConfigCreateInput = {
  sourcePlatformName: PlatformName
  targetPlatformName: PlatformName
}

export type SyncConfigGetInput = {
  sourcePlatformName: PlatformName
  targetPlatformName: PlatformName
}

export type SyncConfigMapping = {
  __typename: 'SyncConfigMapping'
  mappingType: SyncConfigMappingType
  sourceID: Scalars['ID']['output']
  sourceName: Scalars['String']['output']
  targetID: Scalars['ID']['output']
  targetName: Scalars['String']['output']
}

export type SyncConfigMappingInput = {
  mappingType: SyncConfigMappingType
  sourceID: Scalars['ID']['input']
  sourceName: Scalars['String']['input']
  targetID: Scalars['ID']['input']
  targetName: Scalars['String']['input']
}

export enum SyncConfigMappingType {
  MappingTypeUnspecified = 'MAPPING_TYPE_UNSPECIFIED',
  TaxCode = 'TAX_CODE'
}

export type SyncConfigOption = {
  __typename: 'SyncConfigOption'
  customValue?: Maybe<Scalars['String']['output']>
  enumValue?: Maybe<SyncConfigOptionValue>
  optionKey: SyncConfigOptionKey
  optionType: SyncConfigOptionType
}

export type SyncConfigOptionInput = {
  customValue?: InputMaybe<Scalars['String']['input']>
  enumValue?: InputMaybe<SyncConfigOptionValue>
  optionKey: SyncConfigOptionKey
  optionType: SyncConfigOptionType
}

export enum SyncConfigOptionKey {
  LineItemMappingKey = 'LINE_ITEM_MAPPING_KEY',
  OptionKeyUnspecified = 'OPTION_KEY_UNSPECIFIED',
  SyncFrequencyDailyTime = 'SYNC_FREQUENCY_DAILY_TIME',
  SyncFrequencyHoursInterval = 'SYNC_FREQUENCY_HOURS_INTERVAL',
  SyncFrequencyMode = 'SYNC_FREQUENCY_MODE',
  SyncFrequencyType = 'SYNC_FREQUENCY_TYPE'
}

export enum SyncConfigOptionType {
  OptionTypeBoolean = 'OPTION_TYPE_BOOLEAN',
  OptionTypeFloat = 'OPTION_TYPE_FLOAT',
  OptionTypeInteger = 'OPTION_TYPE_INTEGER',
  OptionTypeString = 'OPTION_TYPE_STRING',
  OptionTypeUnspecified = 'OPTION_TYPE_UNSPECIFIED'
}

export enum SyncConfigOptionValue {
  LineItemMappingProductDescription = 'LINE_ITEM_MAPPING_PRODUCT_DESCRIPTION',
  LineItemMappingProductId = 'LINE_ITEM_MAPPING_PRODUCT_ID',
  OptionValueUnspecified = 'OPTION_VALUE_UNSPECIFIED',
  SyncFrequencyModeDaily = 'SYNC_FREQUENCY_MODE_DAILY',
  SyncFrequencyModeEveryXHours = 'SYNC_FREQUENCY_MODE_EVERY_X_HOURS',
  SyncFrequencyTypeAutomatic = 'SYNC_FREQUENCY_TYPE_AUTOMATIC',
  SyncFrequencyTypeManual = 'SYNC_FREQUENCY_TYPE_MANUAL'
}

export type SyncConfigUpdateInput = {
  mappings?: InputMaybe<Array<SyncConfigMappingInput>>
  options: Array<SyncConfigOptionInput>
  sourcePlatformName: PlatformName
  targetPlatformName: PlatformName
}

export enum SyncType {
  FetchNew = 'FETCH_NEW',
  FetchUnpaid = 'FETCH_UNPAID'
}

export enum TagColor {
  AquaBlue = 'AQUA_BLUE',
  DarkGrey = 'DARK_GREY',
  Green = 'GREEN',
  Grey = 'GREY',
  Orange = 'ORANGE',
  Purple = 'PURPLE',
  Red = 'RED',
  Yellow = 'YELLOW'
}

export type TagFilter = {
  customerID?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export enum TagType {
  AutopayEnabled = 'AUTOPAY_ENABLED',
  Custom = 'CUSTOM',
  NoPaymentMethod = 'NO_PAYMENT_METHOD'
}

export enum TemplateType {
  Referral = 'REFERRAL',
  Reminder = 'REMINDER',
  Summary = 'SUMMARY'
}

export type TokenExchange = {
  __typename: 'TokenExchange'
  access_token: Scalars['String']['output']
  expiry: Scalars['String']['output']
  id_token: Scalars['String']['output']
  refresh_token: Scalars['String']['output']
}

export type Transaction = {
  __typename: 'Transaction'
  amount: Scalars['Float']['output']
  companyType: CompanyType
  customer: Customer
  description: Scalars['String']['output']
  direction: TransactionDirection
  failureReason?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  netAmount: Scalars['Float']['output']
  partner: Partner
  status: TransactionStatus
  transactionMethod: TransactionMethod
}

export enum TransactionDirection {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export enum TransactionMethod {
  Ach = 'ACH',
  Card = 'CARD',
  Manual = 'MANUAL',
  Rtp = 'RTP',
  SameDayAch = 'SAME_DAY_ACH',
  Wire = 'WIRE'
}

export enum TransactionStatus {
  Canceled = 'CANCELED',
  Chargeback = 'CHARGEBACK',
  Charged = 'CHARGED',
  Created = 'CREATED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED',
  Succeeded = 'SUCCEEDED'
}

export enum TransferPaymentMethodInputEnum {
  Card = 'CARD',
  StandardAch = 'STANDARD_ACH'
}

export type UnsyncedInvoiceEdge = {
  __typename: 'UnsyncedInvoiceEdge'
  cursor: Scalars['Cursor']['output']
  node: InvoiceRelation
}

export type UnsyncedInvoiceTotals = {
  __typename: 'UnsyncedInvoiceTotals'
  amount: Scalars['Float']['output']
  count: Scalars['Int']['output']
}

export type UnsyncedInvoices = {
  __typename: 'UnsyncedInvoices'
  edges?: Maybe<Array<Maybe<UnsyncedInvoiceEdge>>>
  pageInfo: PageInfo
}

export type UnsyncedInvoicesFilter = {
  createdDateEnd?: InputMaybe<Scalars['String']['input']>
  createdDateStart?: InputMaybe<Scalars['String']['input']>
  platformName: PlatformName
}

export type UnsyncedInvoicesOrderBy = {
  direction: OrderDirection
  field: UnsyncedInvoicesOrderByField
}

export enum UnsyncedInvoicesOrderByField {
  CreatedDate = 'CREATED_DATE'
}

export type UpdateApiKeyInput = {
  keyID: Scalars['String']['input']
  keyName: Scalars['String']['input']
}

export type UpdateCompanyIndividualInput = {
  city: Scalars['String']['input']
  controllingPerson: Scalars['Boolean']['input']
  country: Scalars['String']['input']
  countryCode: Scalars['String']['input']
  dateOfBirth: Scalars['String']['input']
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  id: Scalars['ID']['input']
  jobTitle: Scalars['String']['input']
  lastName: Scalars['String']['input']
  owner: Scalars['Boolean']['input']
  partnerID: Scalars['ID']['input']
  phone: Scalars['String']['input']
  postalCode: Scalars['String']['input']
  signatory: Scalars['Boolean']['input']
  ssn?: InputMaybe<Scalars['String']['input']>
  state: Scalars['String']['input']
  stateCode: Scalars['String']['input']
  streetAddress: Scalars['String']['input']
  subPremise: Scalars['String']['input']
}

export type UpdateEmailTemplateInput = {
  id: Scalars['ID']['input']
  name?: InputMaybe<Scalars['String']['input']>
  section1?: InputMaybe<Scalars['String']['input']>
  section2?: InputMaybe<Scalars['String']['input']>
  section3?: InputMaybe<Scalars['String']['input']>
  subject?: InputMaybe<Scalars['String']['input']>
}

export type UpdatePartnerNameInput = {
  name: Scalars['String']['input']
}

export type UpdateReferralInput = {
  email?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  name?: InputMaybe<Scalars['String']['input']>
}

export type UploadAdyenDocumentInput = {
  content: Scalars['String']['input']
  documentType: AdyenUploadDocumentType
  filename?: InputMaybe<Scalars['String']['input']>
  ownerID: Scalars['String']['input']
  ownerType: AdyenOwnerType
}

export type UploadAdyenDocumentResponse = {
  __typename: 'UploadAdyenDocumentResponse'
  details?: Maybe<Scalars['String']['output']>
  failed: Scalars['Boolean']['output']
}

export type UploadPartnerDocumentInput = {
  content: Scalars['String']['input']
  filename?: InputMaybe<Scalars['String']['input']>
  type: PartnerDocumentType
}

export type UpsertCustomerAutopayConfigInput = {
  chargeDefaultFallback: Scalars['Boolean']['input']
  customerID: Scalars['ID']['input']
}

export type UpsertInvoicePreferencesInput = {
  invoiceNumberField: InvoiceNumberField
}

export type UpsertSupportPreferencesInput = {
  email: Scalars['String']['input']
  firstLine: Scalars['String']['input']
  name: Scalars['String']['input']
  phone?: InputMaybe<Scalars['String']['input']>
  secondLine?: InputMaybe<Scalars['String']['input']>
}

export enum UserType {
  Customer = 'CUSTOMER',
  Partner = 'PARTNER',
  Superadmin = 'SUPERADMIN'
}

export type SolveRemediationActionsByIDsMutationVariables = Exact<{
  actionIDs: Array<Scalars['String']['input']> | Scalars['String']['input']
}>

export type SolveRemediationActionsByIDsMutation = {
  __typename: 'Mutation'
  SolveRemediationActionsByIDs: string
}

export type GetAdyenDocumentTypesQueryVariables = Exact<{
  ownerType: AdyenOwnerType
}>

export type GetAdyenDocumentTypesQuery = {
  __typename: 'Query'
  GetAdyenDocumentTypes: Array<AdyenUploadDocumentType>
}

export type SolveAdyenRemediationActionsMutationVariables = Exact<{
  [key: string]: never
}>

export type SolveAdyenRemediationActionsMutation = {
  __typename: 'Mutation'
  SolveAdyenRemediationActions: string
}

export type UploadAdyenDocumentMutationVariables = Exact<{
  input: UploadAdyenDocumentInput
}>

export type UploadAdyenDocumentMutation = {
  __typename: 'Mutation'
  UploadAdyenDocument: {
    __typename: 'UploadAdyenDocumentResponse'
    failed: boolean
    details?: string | null
  }
}

export type GetAdyenRemediationActionsQueryVariables = Exact<{
  [key: string]: never
}>

export type GetAdyenRemediationActionsQuery = {
  __typename: 'Query'
  GetAdyenRemediationActions: {
    __typename: 'GetAdyenRemediationActionsReply'
    groupings: Array<{
      __typename: 'GetAdyenRemediationActionsGrouping'
      errorCode: string
      errorMessage: string
      ownerID: string
      ownerType: AdyenOwnerType
      actions: Array<{
        __typename: 'GetAdyenRemediationActionsItem'
        actionID: string
        actionType: AdyenRemediationActionType
        unmappedRemediationActionCode?: string | null
      }>
    }>
  }
}

export type GetAdyenHostedOnboardingLinkQueryVariables = Exact<{
  [key: string]: never
}>

export type GetAdyenHostedOnboardingLinkQuery = {
  __typename: 'Query'
  GetAdyenHostedOnboardingLink?: {
    __typename: 'GetAdyenHostedOnboardingLinkResponse'
    url: string
  } | null
}

export type StagingStartAdyenOnboardingMutationVariables = Exact<{
  [key: string]: never
}>

export type StagingStartAdyenOnboardingMutation = {
  __typename: 'Mutation'
  StagingStartAdyenOnboarding?: {
    __typename: 'StartAdyenOnboardingReply'
    validations: Array<string>
  } | null
}

export type GetAdyenPciFormsQueryVariables = Exact<{ [key: string]: never }>

export type GetAdyenPciFormsQuery = {
  __typename: 'Query'
  GetAdyenPciForms: {
    __typename: 'AdyenPciForms'
    pciIds: Array<string>
    document: string
  }
}

export type GetAdyenTermsOfServiceQueryVariables = Exact<{
  [key: string]: never
}>

export type GetAdyenTermsOfServiceQuery = {
  __typename: 'Query'
  GetAdyenTermsOfService: Array<{
    __typename: 'AdyenTermsOfServiceDocument'
    tosID: string
    tosType: string
    document: string
  }>
}

export type GetAdyenOnboardingStatusQueryVariables = Exact<{
  [key: string]: never
}>

export type GetAdyenOnboardingStatusQuery = {
  __typename: 'Query'
  GetAdyenOnboardingStatus: {
    __typename: 'AdyenOnboardingStatus'
    termsOfServiceAccepted: boolean
    pciFormsSigned: boolean
    tosAndPciEntitiesCreated: boolean
  }
}

export type PartnerCreateApiKeyMutationVariables = Exact<{
  input: CreateApiKeyInput
}>

export type PartnerCreateApiKeyMutation = {
  __typename: 'Mutation'
  PartnerCreateApiKey?: {
    __typename: 'CreateApiKeyResponse'
    key: string
  } | null
}

export type PartnerUpdateApiKeyMutationVariables = Exact<{
  input: UpdateApiKeyInput
}>

export type PartnerUpdateApiKeyMutation = {
  __typename: 'Mutation'
  PartnerUpdateApiKey: string
}

export type PartnerRevokeApiKeyMutationVariables = Exact<{
  keyID: Scalars['String']['input']
}>

export type PartnerRevokeApiKeyMutation = {
  __typename: 'Mutation'
  PartnerRevokeApiKey: string
}

export type PartnerApiKeyConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<ApiKeyFilter>
  orderBy?: InputMaybe<ApiKeyOrderBy>
}>

export type PartnerApiKeyConnectionQuery = {
  __typename: 'Query'
  PartnerApiKeyConnection?: {
    __typename: 'ApiKeyConnection'
    edges?: Array<{
      __typename: 'ApiKeyEdge'
      cursor: any
      node?: {
        __typename: 'ApiKey'
        id: string
        clientID: string
        lastDigits: string
        keyName: string
        createdAt: string
        status: ApiKeyStatus
        revokedAt?: string | null
        createdBy?: {
          __typename: 'PartnerUser'
          id: string
          firstName?: string | null
          lastName?: string | null
        } | null
        revokedBy?: {
          __typename: 'PartnerUser'
          id: string
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type ApiKeyFragment = {
  __typename: 'ApiKey'
  id: string
  clientID: string
  lastDigits: string
  keyName: string
  createdAt: string
  status: ApiKeyStatus
  revokedAt?: string | null
  createdBy?: {
    __typename: 'PartnerUser'
    id: string
    firstName?: string | null
    lastName?: string | null
  } | null
  revokedBy?: {
    __typename: 'PartnerUser'
    id: string
    firstName?: string | null
    lastName?: string | null
  } | null
}

export type OAuth2UrlQueryVariables = Exact<{
  referralID?: InputMaybe<Scalars['ID']['input']>
}>

export type OAuth2UrlQuery = { __typename: 'Query'; OAuth2Url: string }

export type OAuth2ExchangeMutationVariables = Exact<{
  code: Scalars['String']['input']
  state: Scalars['String']['input']
}>

export type OAuth2ExchangeMutation = {
  __typename: 'Mutation'
  OAuth2Exchange: {
    __typename: 'TokenExchange'
    access_token: string
    refresh_token: string
    expiry: string
    id_token: string
  }
}

export type OAuth2RefreshMutationVariables = Exact<{
  refreshToken: Scalars['String']['input']
}>

export type OAuth2RefreshMutation = {
  __typename: 'Mutation'
  OAuth2Refresh: {
    __typename: 'TokenExchange'
    access_token: string
    refresh_token: string
    expiry: string
    id_token: string
  }
}

export type TokenFragment = {
  __typename: 'TokenExchange'
  access_token: string
  refresh_token: string
  expiry: string
  id_token: string
}

export type PartnerListAutopayExcludedInvoicesQueryVariables = Exact<{
  invoiceIDs?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >
}>

export type PartnerListAutopayExcludedInvoicesQuery = {
  __typename: 'Query'
  PartnerListAutopayExcludedInvoices: Array<{
    __typename: 'AutopayExcludedInvoice'
    invoiceID: string
    excludedBy: ExcludedFromAutopayBy
  }>
}

export type FindAutopayRuleQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type FindAutopayRuleQuery = {
  __typename: 'Query'
  FindAutopayRule?: {
    __typename: 'AutopayRule'
    tagIDs?: Array<string | null> | null
    id: string
    daysPastCreation?: number | null
    daysPastDue?: number | null
    daysBeforeDue?: number | null
    amountOperator?: RuleOperator | null
    amount?: number | null
    version: number
    halopsaRecurringInvoices?: boolean | null
    connectWiseContractNames?: Array<string> | null
    autotaskContractNames?: Array<string> | null
    createdByCustomer: boolean
    createdAt: string
    customers?: Array<{
      __typename: 'Customer'
      id: string
      name?: string | null
      tagIDs?: Array<string> | null
      legalName?: string | null
      ein?: string | null
      createdAt: string
      isOnboarded: boolean
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      postalCode?: string | null
      state?: string | null
      country?: string | null
      outstandingInvoicesData?: {
        __typename: 'CustomerOutstandingInvoicesData'
        outstandingInvoicesCount?: number | null
        outstandingInvoicesTotal?: number | null
        longestDaysOverdue?: string | null
      } | null
      defaultPaymentMethod?: {
        __typename: 'CustomerDefaultPaymentMethod'
        methodID: string
        method: TransferPaymentMethodInputEnum
        institution?: {
          __typename: 'Institution'
          id: string
          externalId?: string | null
          name?: string | null
          url?: string | null
          logo?: string | null
          accounts?: Array<{
            __typename: 'Account'
            id: string
            mask?: string | null
            name?: string | null
            type?: string | null
            subtype?: string | null
            hasAchAccountNumber?: boolean | null
            hasAchRoutingNumber?: boolean | null
            hasWireRoutingNumber?: boolean | null
            provider?: string | null
            disconnectedAt?: string | null
            systemDeactivatedAt?: string | null
            companyName?: string | null
            institution?: {
              __typename: 'Institution'
              name?: string | null
              id: string
              logo?: string | null
            } | null
          } | null> | null
        } | null
        card?: {
          __typename: 'Card'
          id: string
          last4: string
          expirationDate: string
          cardNetWork: CardNetwork
          fundingSource: FundingSource
        } | null
      } | null
      partner?: {
        __typename: 'Partner'
        id: string
        paymentsPortalUrl?: string | null
      } | null
    } | null> | null
    customMethods?: Array<{
      __typename: 'AutopayCustomMethod'
      customerID: string
      methodID: string
      method: TransferPaymentMethodInputEnum
    } | null> | null
    autotaskContractTypes?: Array<{
      __typename: 'AutotaskContractType'
      externalID: string
      partnerID: string
      name: string
    }> | null
    connectwiseAgreementTypes?: Array<{
      __typename: 'ConnectwiseAgreementType'
      externalID: string
      partnerID: string
      name: string
    }> | null
    haloPSAContractSubtypes?: Array<{
      __typename: 'HaloPSAContractSubtype'
      externalID: string
      partnerID: string
      name: string
    }> | null
    quickbooksRecurringTransactions?: Array<{
      __typename: 'QuickbooksRecurringTransaction'
      externalID: string
      partnerID: string
      name: string
    }> | null
    connectwiseBillingTerms?: Array<{
      __typename: 'ConnectwiseBillingTerms'
      externalID: string
      partnerID: string
      name: string
    }> | null
    rutterQbdPaymentTerms?: Array<{
      __typename: 'RutterPaymentTerms'
      externalID: string
      partnerID: string
      name: string
    }> | null
    rutterNetsuitePaymentTerms?: Array<{
      __typename: 'RutterPaymentTerms'
      externalID: string
      partnerID: string
      name: string
    }> | null
  } | null
}

export type PartnerAutopayExcludedInvoiceDeleteMutationVariables = Exact<{
  invoiceID: Scalars['ID']['input']
}>

export type PartnerAutopayExcludedInvoiceDeleteMutation = {
  __typename: 'Mutation'
  PartnerAutopayExcludedInvoiceDelete?: string | null
}

export type PartnerAutopayExcludedInvoiceCreateMutationVariables = Exact<{
  customerID: Scalars['ID']['input']
  invoiceID: Scalars['ID']['input']
}>

export type PartnerAutopayExcludedInvoiceCreateMutation = {
  __typename: 'Mutation'
  PartnerAutopayExcludedInvoiceCreate?: string | null
}

export type PartnerAutopayExcludedInvoiceBatchCreateMutationVariables = Exact<{
  invoices:
    | Array<AutopayExcludedInvoiceCreateInput>
    | AutopayExcludedInvoiceCreateInput
}>

export type PartnerAutopayExcludedInvoiceBatchCreateMutation = {
  __typename: 'Mutation'
  PartnerAutopayExcludedInvoiceBatchCreate?: string | null
}

export type PartnerGetCoveredInvoicesForRuleQueryVariables = Exact<{
  input: PartnerGetCoveredInvoicesForRuleInput
}>

export type PartnerGetCoveredInvoicesForRuleQuery = {
  __typename: 'Query'
  PartnerGetCoveredInvoicesForRule: Array<{
    __typename: 'Invoice'
    id: string
    invoiceNumber: string
    createdAt: string
    dueDate?: string | null
    amount: number
    status: InvoiceStatusEnum
    recurringpayment: boolean
    externalId?: string | null
    externalInvoiceNumber?: string | null
    autopaidAt?: string | null
    customer?: {
      __typename: 'Customer'
      id: string
      name?: string | null
      tagIDs?: Array<string> | null
    } | null
  }>
}

export type PartnerGlobalAutopayRuleConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<AutopayRuleOrderBy>
}>

export type PartnerGlobalAutopayRuleConnectionQuery = {
  __typename: 'Query'
  PartnerGlobalAutopayRuleConnection?: {
    __typename: 'AutopayRuleConnection'
    edges?: Array<{
      __typename: 'AutopayRuleEdge'
      node?: {
        __typename: 'AutopayRule'
        id: string
        daysPastCreation?: number | null
        daysPastDue?: number | null
        daysBeforeDue?: number | null
        amountOperator?: RuleOperator | null
        amount?: number | null
        version: number
        halopsaRecurringInvoices?: boolean | null
        connectWiseContractNames?: Array<string> | null
        autotaskContractNames?: Array<string> | null
        createdByCustomer: boolean
        createdAt: string
        customMethods?: Array<{
          __typename: 'AutopayCustomMethod'
          customerID: string
          methodID: string
          method: TransferPaymentMethodInputEnum
        } | null> | null
        autotaskContractTypes?: Array<{
          __typename: 'AutotaskContractType'
          externalID: string
          partnerID: string
          name: string
        }> | null
        connectwiseAgreementTypes?: Array<{
          __typename: 'ConnectwiseAgreementType'
          externalID: string
          partnerID: string
          name: string
        }> | null
        haloPSAContractSubtypes?: Array<{
          __typename: 'HaloPSAContractSubtype'
          externalID: string
          partnerID: string
          name: string
        }> | null
        quickbooksRecurringTransactions?: Array<{
          __typename: 'QuickbooksRecurringTransaction'
          externalID: string
          partnerID: string
          name: string
        }> | null
        connectwiseBillingTerms?: Array<{
          __typename: 'ConnectwiseBillingTerms'
          externalID: string
          partnerID: string
          name: string
        }> | null
        rutterQbdPaymentTerms?: Array<{
          __typename: 'RutterPaymentTerms'
          externalID: string
          partnerID: string
          name: string
        }> | null
        rutterNetsuitePaymentTerms?: Array<{
          __typename: 'RutterPaymentTerms'
          externalID: string
          partnerID: string
          name: string
        }> | null
        customers?: Array<{
          __typename: 'Customer'
          id: string
          name?: string | null
        } | null> | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerCustomerAutopayRuleWithBankingAndCardConnectionQueryVariables =
  Exact<{
    after?: InputMaybe<Scalars['Cursor']['input']>
    first?: InputMaybe<Scalars['Int']['input']>
    before?: InputMaybe<Scalars['Cursor']['input']>
    last?: InputMaybe<Scalars['Int']['input']>
    filters?: InputMaybe<AutopayRuleFilter>
    orderBy?: InputMaybe<AutopayRuleOrderBy>
  }>

export type PartnerCustomerAutopayRuleWithBankingAndCardConnectionQuery = {
  __typename: 'Query'
  PartnerCustomerAutopayRuleConnection?: {
    __typename: 'AutopayRuleConnection'
    edges?: Array<{
      __typename: 'AutopayRuleEdge'
      node?: {
        __typename: 'AutopayRule'
        id: string
        daysPastCreation?: number | null
        daysPastDue?: number | null
        daysBeforeDue?: number | null
        amountOperator?: RuleOperator | null
        amount?: number | null
        version: number
        halopsaRecurringInvoices?: boolean | null
        connectWiseContractNames?: Array<string> | null
        autotaskContractNames?: Array<string> | null
        createdByCustomer: boolean
        createdAt: string
        customMethods?: Array<{
          __typename: 'AutopayCustomMethod'
          customerID: string
          methodID: string
          method: TransferPaymentMethodInputEnum
          fallbackCharge?: boolean | null
          institution?: {
            __typename: 'Institution'
            id: string
            externalId?: string | null
            name?: string | null
            url?: string | null
            logo?: string | null
            accounts?: Array<{
              __typename: 'Account'
              id: string
              mask?: string | null
              name?: string | null
              type?: string | null
              subtype?: string | null
              hasAchAccountNumber?: boolean | null
              hasAchRoutingNumber?: boolean | null
              hasWireRoutingNumber?: boolean | null
              provider?: string | null
              disconnectedAt?: string | null
              systemDeactivatedAt?: string | null
              companyName?: string | null
              institution?: {
                __typename: 'Institution'
                name?: string | null
                id: string
                logo?: string | null
              } | null
            } | null> | null
          } | null
          card?: {
            __typename: 'Card'
            id: string
            last4: string
            expirationDate: string
            cardNetWork: CardNetwork
            fundingSource: FundingSource
          } | null
        } | null> | null
        autotaskContractTypes?: Array<{
          __typename: 'AutotaskContractType'
          externalID: string
          partnerID: string
          name: string
        }> | null
        connectwiseAgreementTypes?: Array<{
          __typename: 'ConnectwiseAgreementType'
          externalID: string
          partnerID: string
          name: string
        }> | null
        haloPSAContractSubtypes?: Array<{
          __typename: 'HaloPSAContractSubtype'
          externalID: string
          partnerID: string
          name: string
        }> | null
        quickbooksRecurringTransactions?: Array<{
          __typename: 'QuickbooksRecurringTransaction'
          externalID: string
          partnerID: string
          name: string
        }> | null
        connectwiseBillingTerms?: Array<{
          __typename: 'ConnectwiseBillingTerms'
          externalID: string
          partnerID: string
          name: string
        }> | null
        rutterQbdPaymentTerms?: Array<{
          __typename: 'RutterPaymentTerms'
          externalID: string
          partnerID: string
          name: string
        }> | null
        rutterNetsuitePaymentTerms?: Array<{
          __typename: 'RutterPaymentTerms'
          externalID: string
          partnerID: string
          name: string
        }> | null
        customers?: Array<{
          __typename: 'Customer'
          id: string
          name?: string | null
        } | null> | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerCustomerAutopayRuleConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<AutopayRuleFilter>
  orderBy?: InputMaybe<AutopayRuleOrderBy>
}>

export type PartnerCustomerAutopayRuleConnectionQuery = {
  __typename: 'Query'
  PartnerCustomerAutopayRuleConnection?: {
    __typename: 'AutopayRuleConnection'
    edges?: Array<{
      __typename: 'AutopayRuleEdge'
      node?: {
        __typename: 'AutopayRule'
        id: string
        daysPastCreation?: number | null
        daysPastDue?: number | null
        daysBeforeDue?: number | null
        amountOperator?: RuleOperator | null
        amount?: number | null
        version: number
        halopsaRecurringInvoices?: boolean | null
        connectWiseContractNames?: Array<string> | null
        autotaskContractNames?: Array<string> | null
        createdByCustomer: boolean
        createdAt: string
        customMethods?: Array<{
          __typename: 'AutopayCustomMethod'
          customerID: string
          methodID: string
          method: TransferPaymentMethodInputEnum
        } | null> | null
        autotaskContractTypes?: Array<{
          __typename: 'AutotaskContractType'
          externalID: string
          partnerID: string
          name: string
        }> | null
        connectwiseAgreementTypes?: Array<{
          __typename: 'ConnectwiseAgreementType'
          externalID: string
          partnerID: string
          name: string
        }> | null
        haloPSAContractSubtypes?: Array<{
          __typename: 'HaloPSAContractSubtype'
          externalID: string
          partnerID: string
          name: string
        }> | null
        quickbooksRecurringTransactions?: Array<{
          __typename: 'QuickbooksRecurringTransaction'
          externalID: string
          partnerID: string
          name: string
        }> | null
        connectwiseBillingTerms?: Array<{
          __typename: 'ConnectwiseBillingTerms'
          externalID: string
          partnerID: string
          name: string
        }> | null
        rutterQbdPaymentTerms?: Array<{
          __typename: 'RutterPaymentTerms'
          externalID: string
          partnerID: string
          name: string
        }> | null
        rutterNetsuitePaymentTerms?: Array<{
          __typename: 'RutterPaymentTerms'
          externalID: string
          partnerID: string
          name: string
        }> | null
        customers?: Array<{
          __typename: 'Customer'
          id: string
          name?: string | null
        } | null> | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerCustomerTagsAutopayRuleConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<AutopayRuleFilter>
  orderBy?: InputMaybe<AutopayRuleOrderBy>
}>

export type PartnerCustomerTagsAutopayRuleConnectionQuery = {
  __typename: 'Query'
  PartnerCustomerTagsAutopayRuleConnection?: {
    __typename: 'AutopayRuleConnection'
    edges?: Array<{
      __typename: 'AutopayRuleEdge'
      node?: {
        __typename: 'AutopayRule'
        tagIDs?: Array<string | null> | null
        id: string
        daysPastCreation?: number | null
        daysPastDue?: number | null
        daysBeforeDue?: number | null
        amountOperator?: RuleOperator | null
        amount?: number | null
        version: number
        halopsaRecurringInvoices?: boolean | null
        connectWiseContractNames?: Array<string> | null
        autotaskContractNames?: Array<string> | null
        createdByCustomer: boolean
        createdAt: string
        customMethods?: Array<{
          __typename: 'AutopayCustomMethod'
          customerID: string
          methodID: string
          method: TransferPaymentMethodInputEnum
        } | null> | null
        autotaskContractTypes?: Array<{
          __typename: 'AutotaskContractType'
          externalID: string
          partnerID: string
          name: string
        }> | null
        connectwiseAgreementTypes?: Array<{
          __typename: 'ConnectwiseAgreementType'
          externalID: string
          partnerID: string
          name: string
        }> | null
        haloPSAContractSubtypes?: Array<{
          __typename: 'HaloPSAContractSubtype'
          externalID: string
          partnerID: string
          name: string
        }> | null
        quickbooksRecurringTransactions?: Array<{
          __typename: 'QuickbooksRecurringTransaction'
          externalID: string
          partnerID: string
          name: string
        }> | null
        connectwiseBillingTerms?: Array<{
          __typename: 'ConnectwiseBillingTerms'
          externalID: string
          partnerID: string
          name: string
        }> | null
        rutterQbdPaymentTerms?: Array<{
          __typename: 'RutterPaymentTerms'
          externalID: string
          partnerID: string
          name: string
        }> | null
        rutterNetsuitePaymentTerms?: Array<{
          __typename: 'RutterPaymentTerms'
          externalID: string
          partnerID: string
          name: string
        }> | null
        customers?: Array<{
          __typename: 'Customer'
          id: string
          name?: string | null
        } | null> | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerListCustomerRulesTotalsQueryVariables = Exact<{
  customerID?: InputMaybe<Scalars['ID']['input']>
}>

export type PartnerListCustomerRulesTotalsQuery = {
  __typename: 'Query'
  PartnerListCustomerRulesTotals?: {
    __typename: 'AutopayRuleTotals'
    count: number
  } | null
}

export type PartnerAutopayExcludedCustomerConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<AutopayExcludedCustomerFilter>
  orderBy?: InputMaybe<AutopayExcludedCustomerOrderBy>
}>

export type PartnerAutopayExcludedCustomerConnectionQuery = {
  __typename: 'Query'
  PartnerAutopayExcludedCustomerConnection?: {
    __typename: 'AutopayExcludedCustomerConnection'
    edges?: Array<{
      __typename: 'AutopayExcludedCustomerEdge'
      node?: {
        __typename: 'AutopayExcludedCustomer'
        id: string
        createdByCustomer: boolean
        createdAt: string
        customer: {
          __typename: 'Customer'
          id: string
          name?: string | null
          city?: string | null
          state?: string | null
          tagIDs?: Array<string> | null
        }
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerAutopayExcludedCustomerListTotalsQueryVariables = Exact<{
  filters?: InputMaybe<AutopayExcludedCustomerFilter>
}>

export type PartnerAutopayExcludedCustomerListTotalsQuery = {
  __typename: 'Query'
  PartnerAutopayExcludedCustomerListTotals: {
    __typename: 'AutopayExcludedCustomerTotals'
    count: number
  }
}

export type PartnerCreateAutopayRuleMutationVariables = Exact<{
  input: PartnerCreateAutopayRuleInput
}>

export type PartnerCreateAutopayRuleMutation = {
  __typename: 'Mutation'
  PartnerCreateAutopayRule?: {
    __typename: 'AutopayRule'
    id: string
    daysPastCreation?: number | null
    daysPastDue?: number | null
    daysBeforeDue?: number | null
    amountOperator?: RuleOperator | null
    amount?: number | null
    version: number
    halopsaRecurringInvoices?: boolean | null
    connectWiseContractNames?: Array<string> | null
    autotaskContractNames?: Array<string> | null
    createdByCustomer: boolean
    createdAt: string
    customMethods?: Array<{
      __typename: 'AutopayCustomMethod'
      customerID: string
      methodID: string
      method: TransferPaymentMethodInputEnum
    } | null> | null
    autotaskContractTypes?: Array<{
      __typename: 'AutotaskContractType'
      externalID: string
      partnerID: string
      name: string
    }> | null
    connectwiseAgreementTypes?: Array<{
      __typename: 'ConnectwiseAgreementType'
      externalID: string
      partnerID: string
      name: string
    }> | null
    haloPSAContractSubtypes?: Array<{
      __typename: 'HaloPSAContractSubtype'
      externalID: string
      partnerID: string
      name: string
    }> | null
    quickbooksRecurringTransactions?: Array<{
      __typename: 'QuickbooksRecurringTransaction'
      externalID: string
      partnerID: string
      name: string
    }> | null
    connectwiseBillingTerms?: Array<{
      __typename: 'ConnectwiseBillingTerms'
      externalID: string
      partnerID: string
      name: string
    }> | null
    rutterQbdPaymentTerms?: Array<{
      __typename: 'RutterPaymentTerms'
      externalID: string
      partnerID: string
      name: string
    }> | null
    rutterNetsuitePaymentTerms?: Array<{
      __typename: 'RutterPaymentTerms'
      externalID: string
      partnerID: string
      name: string
    }> | null
    customers?: Array<{
      __typename: 'Customer'
      id: string
      name?: string | null
    } | null> | null
  } | null
}

export type PartnerUpdateAutopayRuleMutationVariables = Exact<{
  input: PartnerUpdateAutopayRuleInput
}>

export type PartnerUpdateAutopayRuleMutation = {
  __typename: 'Mutation'
  PartnerUpdateAutopayRule?: {
    __typename: 'AutopayRule'
    id: string
    daysPastCreation?: number | null
    daysPastDue?: number | null
    daysBeforeDue?: number | null
    amountOperator?: RuleOperator | null
    amount?: number | null
    version: number
    halopsaRecurringInvoices?: boolean | null
    connectWiseContractNames?: Array<string> | null
    autotaskContractNames?: Array<string> | null
    createdByCustomer: boolean
    createdAt: string
    customMethods?: Array<{
      __typename: 'AutopayCustomMethod'
      customerID: string
      methodID: string
      method: TransferPaymentMethodInputEnum
    } | null> | null
    autotaskContractTypes?: Array<{
      __typename: 'AutotaskContractType'
      externalID: string
      partnerID: string
      name: string
    }> | null
    connectwiseAgreementTypes?: Array<{
      __typename: 'ConnectwiseAgreementType'
      externalID: string
      partnerID: string
      name: string
    }> | null
    haloPSAContractSubtypes?: Array<{
      __typename: 'HaloPSAContractSubtype'
      externalID: string
      partnerID: string
      name: string
    }> | null
    quickbooksRecurringTransactions?: Array<{
      __typename: 'QuickbooksRecurringTransaction'
      externalID: string
      partnerID: string
      name: string
    }> | null
    connectwiseBillingTerms?: Array<{
      __typename: 'ConnectwiseBillingTerms'
      externalID: string
      partnerID: string
      name: string
    }> | null
    rutterQbdPaymentTerms?: Array<{
      __typename: 'RutterPaymentTerms'
      externalID: string
      partnerID: string
      name: string
    }> | null
    rutterNetsuitePaymentTerms?: Array<{
      __typename: 'RutterPaymentTerms'
      externalID: string
      partnerID: string
      name: string
    }> | null
    customers?: Array<{
      __typename: 'Customer'
      id: string
      name?: string | null
    } | null> | null
  } | null
}

export type PartnerDeleteAutopayRuleMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerDeleteAutopayRuleMutation = {
  __typename: 'Mutation'
  PartnerDeleteAutopayRule?: string | null
}

export type PartnerAutopayExcludedCustomerCreateMutationVariables = Exact<{
  customerID: Scalars['ID']['input']
}>

export type PartnerAutopayExcludedCustomerCreateMutation = {
  __typename: 'Mutation'
  PartnerAutopayExcludedCustomerCreate?: {
    __typename: 'AutopayExcludedCustomer'
    id: string
    customer: { __typename: 'Customer'; id: string; name?: string | null }
  } | null
}

export type PartnerAutopayExcludedCustomerUpdateMutationVariables = Exact<{
  customerIDs?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >
}>

export type PartnerAutopayExcludedCustomerUpdateMutation = {
  __typename: 'Mutation'
  PartnerAutopayExcludedCustomerUpdate?: Array<{
    __typename: 'AutopayExcludedCustomer'
    id: string
    customer: { __typename: 'Customer'; id: string; name?: string | null }
  } | null> | null
}

export type PartnerAutopayExcludedCustomerDeleteMutationVariables = Exact<{
  customerID: Scalars['ID']['input']
}>

export type PartnerAutopayExcludedCustomerDeleteMutation = {
  __typename: 'Mutation'
  PartnerAutopayExcludedCustomerDelete?: string | null
}

export type AutopayExcludedListFragment = {
  __typename: 'AutopayExcludedCustomer'
  id: string
  createdByCustomer: boolean
  createdAt: string
  customer: {
    __typename: 'Customer'
    id: string
    name?: string | null
    city?: string | null
    state?: string | null
    tagIDs?: Array<string> | null
  }
}

export type AutopayRulesWithBankingAndCardFragment = {
  __typename: 'AutopayRule'
  id: string
  daysPastCreation?: number | null
  daysPastDue?: number | null
  daysBeforeDue?: number | null
  amountOperator?: RuleOperator | null
  amount?: number | null
  version: number
  halopsaRecurringInvoices?: boolean | null
  connectWiseContractNames?: Array<string> | null
  autotaskContractNames?: Array<string> | null
  createdByCustomer: boolean
  createdAt: string
  customMethods?: Array<{
    __typename: 'AutopayCustomMethod'
    customerID: string
    methodID: string
    method: TransferPaymentMethodInputEnum
    fallbackCharge?: boolean | null
    institution?: {
      __typename: 'Institution'
      id: string
      externalId?: string | null
      name?: string | null
      url?: string | null
      logo?: string | null
      accounts?: Array<{
        __typename: 'Account'
        id: string
        mask?: string | null
        name?: string | null
        type?: string | null
        subtype?: string | null
        hasAchAccountNumber?: boolean | null
        hasAchRoutingNumber?: boolean | null
        hasWireRoutingNumber?: boolean | null
        provider?: string | null
        disconnectedAt?: string | null
        systemDeactivatedAt?: string | null
        companyName?: string | null
        institution?: {
          __typename: 'Institution'
          name?: string | null
          id: string
          logo?: string | null
        } | null
      } | null> | null
    } | null
    card?: {
      __typename: 'Card'
      id: string
      last4: string
      expirationDate: string
      cardNetWork: CardNetwork
      fundingSource: FundingSource
    } | null
  } | null> | null
  autotaskContractTypes?: Array<{
    __typename: 'AutotaskContractType'
    externalID: string
    partnerID: string
    name: string
  }> | null
  connectwiseAgreementTypes?: Array<{
    __typename: 'ConnectwiseAgreementType'
    externalID: string
    partnerID: string
    name: string
  }> | null
  haloPSAContractSubtypes?: Array<{
    __typename: 'HaloPSAContractSubtype'
    externalID: string
    partnerID: string
    name: string
  }> | null
  quickbooksRecurringTransactions?: Array<{
    __typename: 'QuickbooksRecurringTransaction'
    externalID: string
    partnerID: string
    name: string
  }> | null
  connectwiseBillingTerms?: Array<{
    __typename: 'ConnectwiseBillingTerms'
    externalID: string
    partnerID: string
    name: string
  }> | null
  rutterQbdPaymentTerms?: Array<{
    __typename: 'RutterPaymentTerms'
    externalID: string
    partnerID: string
    name: string
  }> | null
  rutterNetsuitePaymentTerms?: Array<{
    __typename: 'RutterPaymentTerms'
    externalID: string
    partnerID: string
    name: string
  }> | null
  customers?: Array<{
    __typename: 'Customer'
    id: string
    name?: string | null
  } | null> | null
}

export type AutopayRulesWithCustomerTagsFragment = {
  __typename: 'AutopayRule'
  tagIDs?: Array<string | null> | null
  id: string
  daysPastCreation?: number | null
  daysPastDue?: number | null
  daysBeforeDue?: number | null
  amountOperator?: RuleOperator | null
  amount?: number | null
  version: number
  halopsaRecurringInvoices?: boolean | null
  connectWiseContractNames?: Array<string> | null
  autotaskContractNames?: Array<string> | null
  createdByCustomer: boolean
  createdAt: string
  customMethods?: Array<{
    __typename: 'AutopayCustomMethod'
    customerID: string
    methodID: string
    method: TransferPaymentMethodInputEnum
  } | null> | null
  autotaskContractTypes?: Array<{
    __typename: 'AutotaskContractType'
    externalID: string
    partnerID: string
    name: string
  }> | null
  connectwiseAgreementTypes?: Array<{
    __typename: 'ConnectwiseAgreementType'
    externalID: string
    partnerID: string
    name: string
  }> | null
  haloPSAContractSubtypes?: Array<{
    __typename: 'HaloPSAContractSubtype'
    externalID: string
    partnerID: string
    name: string
  }> | null
  quickbooksRecurringTransactions?: Array<{
    __typename: 'QuickbooksRecurringTransaction'
    externalID: string
    partnerID: string
    name: string
  }> | null
  connectwiseBillingTerms?: Array<{
    __typename: 'ConnectwiseBillingTerms'
    externalID: string
    partnerID: string
    name: string
  }> | null
  rutterQbdPaymentTerms?: Array<{
    __typename: 'RutterPaymentTerms'
    externalID: string
    partnerID: string
    name: string
  }> | null
  rutterNetsuitePaymentTerms?: Array<{
    __typename: 'RutterPaymentTerms'
    externalID: string
    partnerID: string
    name: string
  }> | null
  customers?: Array<{
    __typename: 'Customer'
    id: string
    name?: string | null
  } | null> | null
}

export type AutopayRulesFragment = {
  __typename: 'AutopayRule'
  id: string
  daysPastCreation?: number | null
  daysPastDue?: number | null
  daysBeforeDue?: number | null
  amountOperator?: RuleOperator | null
  amount?: number | null
  version: number
  halopsaRecurringInvoices?: boolean | null
  connectWiseContractNames?: Array<string> | null
  autotaskContractNames?: Array<string> | null
  createdByCustomer: boolean
  createdAt: string
  customMethods?: Array<{
    __typename: 'AutopayCustomMethod'
    customerID: string
    methodID: string
    method: TransferPaymentMethodInputEnum
  } | null> | null
  autotaskContractTypes?: Array<{
    __typename: 'AutotaskContractType'
    externalID: string
    partnerID: string
    name: string
  }> | null
  connectwiseAgreementTypes?: Array<{
    __typename: 'ConnectwiseAgreementType'
    externalID: string
    partnerID: string
    name: string
  }> | null
  haloPSAContractSubtypes?: Array<{
    __typename: 'HaloPSAContractSubtype'
    externalID: string
    partnerID: string
    name: string
  }> | null
  quickbooksRecurringTransactions?: Array<{
    __typename: 'QuickbooksRecurringTransaction'
    externalID: string
    partnerID: string
    name: string
  }> | null
  connectwiseBillingTerms?: Array<{
    __typename: 'ConnectwiseBillingTerms'
    externalID: string
    partnerID: string
    name: string
  }> | null
  rutterQbdPaymentTerms?: Array<{
    __typename: 'RutterPaymentTerms'
    externalID: string
    partnerID: string
    name: string
  }> | null
  rutterNetsuitePaymentTerms?: Array<{
    __typename: 'RutterPaymentTerms'
    externalID: string
    partnerID: string
    name: string
  }> | null
  customers?: Array<{
    __typename: 'Customer'
    id: string
    name?: string | null
  } | null> | null
}

export type CustomerAutopayConfigFragment = {
  __typename: 'GetCustomerAutopayConfigReply'
  customerAutopayConfig?: {
    __typename: 'CustomerAutopayConfig'
    customerID: string
    partnerID: string
    chargeDefaultFallback: boolean
  } | null
}

export type InvoiceCoveredFragment = {
  __typename: 'Invoice'
  id: string
  invoiceNumber: string
  createdAt: string
  dueDate?: string | null
  amount: number
  status: InvoiceStatusEnum
  recurringpayment: boolean
  externalId?: string | null
  externalInvoiceNumber?: string | null
  autopaidAt?: string | null
  customer?: {
    __typename: 'Customer'
    id: string
    name?: string | null
    tagIDs?: Array<string> | null
  } | null
}

export type FindAutopayRuleFragment = {
  __typename: 'AutopayRule'
  tagIDs?: Array<string | null> | null
  id: string
  daysPastCreation?: number | null
  daysPastDue?: number | null
  daysBeforeDue?: number | null
  amountOperator?: RuleOperator | null
  amount?: number | null
  version: number
  halopsaRecurringInvoices?: boolean | null
  connectWiseContractNames?: Array<string> | null
  autotaskContractNames?: Array<string> | null
  createdByCustomer: boolean
  createdAt: string
  customers?: Array<{
    __typename: 'Customer'
    id: string
    name?: string | null
    tagIDs?: Array<string> | null
    legalName?: string | null
    ein?: string | null
    createdAt: string
    isOnboarded: boolean
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
    outstandingInvoicesData?: {
      __typename: 'CustomerOutstandingInvoicesData'
      outstandingInvoicesCount?: number | null
      outstandingInvoicesTotal?: number | null
      longestDaysOverdue?: string | null
    } | null
    defaultPaymentMethod?: {
      __typename: 'CustomerDefaultPaymentMethod'
      methodID: string
      method: TransferPaymentMethodInputEnum
      institution?: {
        __typename: 'Institution'
        id: string
        externalId?: string | null
        name?: string | null
        url?: string | null
        logo?: string | null
        accounts?: Array<{
          __typename: 'Account'
          id: string
          mask?: string | null
          name?: string | null
          type?: string | null
          subtype?: string | null
          hasAchAccountNumber?: boolean | null
          hasAchRoutingNumber?: boolean | null
          hasWireRoutingNumber?: boolean | null
          provider?: string | null
          disconnectedAt?: string | null
          systemDeactivatedAt?: string | null
          companyName?: string | null
          institution?: {
            __typename: 'Institution'
            name?: string | null
            id: string
            logo?: string | null
          } | null
        } | null> | null
      } | null
      card?: {
        __typename: 'Card'
        id: string
        last4: string
        expirationDate: string
        cardNetWork: CardNetwork
        fundingSource: FundingSource
      } | null
    } | null
    partner?: {
      __typename: 'Partner'
      id: string
      paymentsPortalUrl?: string | null
    } | null
  } | null> | null
  customMethods?: Array<{
    __typename: 'AutopayCustomMethod'
    customerID: string
    methodID: string
    method: TransferPaymentMethodInputEnum
  } | null> | null
  autotaskContractTypes?: Array<{
    __typename: 'AutotaskContractType'
    externalID: string
    partnerID: string
    name: string
  }> | null
  connectwiseAgreementTypes?: Array<{
    __typename: 'ConnectwiseAgreementType'
    externalID: string
    partnerID: string
    name: string
  }> | null
  haloPSAContractSubtypes?: Array<{
    __typename: 'HaloPSAContractSubtype'
    externalID: string
    partnerID: string
    name: string
  }> | null
  quickbooksRecurringTransactions?: Array<{
    __typename: 'QuickbooksRecurringTransaction'
    externalID: string
    partnerID: string
    name: string
  }> | null
  connectwiseBillingTerms?: Array<{
    __typename: 'ConnectwiseBillingTerms'
    externalID: string
    partnerID: string
    name: string
  }> | null
  rutterQbdPaymentTerms?: Array<{
    __typename: 'RutterPaymentTerms'
    externalID: string
    partnerID: string
    name: string
  }> | null
  rutterNetsuitePaymentTerms?: Array<{
    __typename: 'RutterPaymentTerms'
    externalID: string
    partnerID: string
    name: string
  }> | null
}

export type GetCustomerAutopayConfigQueryVariables = Exact<{
  input: GetCustomerAutopayConfigInput
}>

export type GetCustomerAutopayConfigQuery = {
  __typename: 'Query'
  GetCustomerAutopayConfig?: {
    __typename: 'GetCustomerAutopayConfigReply'
    customerAutopayConfig?: {
      __typename: 'CustomerAutopayConfig'
      customerID: string
      partnerID: string
      chargeDefaultFallback: boolean
    } | null
  } | null
}

export type SetCustomerAutopayConfigMutationVariables = Exact<{
  input: UpsertCustomerAutopayConfigInput
}>

export type SetCustomerAutopayConfigMutation = {
  __typename: 'Mutation'
  SetCustomerAutopayConfig?: boolean | null
}

export type PartnerInvoiceBnplConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<BnplFilter>
}>

export type PartnerInvoiceBnplConnectionQuery = {
  __typename: 'Query'
  PartnerInvoiceBnplConnection?: {
    __typename: 'InvoiceBnplConnection'
    edges?: Array<{
      __typename: 'InvoiceBnplEdge'
      cursor: any
      node?: {
        __typename: 'Invoice'
        amount: number
        createdAt: string
        dueDate?: string | null
        id: string
        invoiceNumber: string
        productName?: string | null
        status: InvoiceStatusEnum
        outstandingAmount: number
        platformName: string
        totalDiscountAmount: number
        customer?: {
          __typename: 'Customer'
          createdAt: string
          id: string
          name?: string | null
          legalName?: string | null
          isOnboarded: boolean
          streetAddress?: string | null
          subPremise?: string | null
          city?: string | null
          postalCode?: string | null
          state?: string | null
          country?: string | null
        } | null
        partner?: {
          __typename: 'Partner'
          id: string
          name?: string | null
          legalName?: string | null
          isOnboarded: boolean
          adyenOnboardingStatus: AdyenOnboardingStatusStep
          insightsEnabled: boolean
        } | null
        offer?: {
          __typename: 'BNPLOffer'
          createdAt: string
          status: BnplStatus
          amount: number
          fees: number
          netAmount: number
          remainingBalance: number
          terms: number
          lending?: {
            __typename: 'Lending'
            id: string
            amount: number
            netAmount: number
            installments?: Array<{
              __typename: 'Installment'
              id: string
              amount: number
              dueDate: string
              netAmount: number
              status: InstallmentStatus
              payments: Array<{
                __typename: 'Payment'
                id: string
                amount: number
                netAmount: number
                creationDate: string
                currentPaymentMethod?: MethodEnum | null
                dueDate?: string | null
                paymentCompletionForecastDate?: string | null
                originService: PaymentAlternativeService
                executorType: PaymentExecutorType
                paymentFees: Array<{
                  __typename: 'PaymentFee'
                  forwarded: boolean
                  type: FeeType
                  amount: number
                  name: string
                } | null>
                currentPaymentMethodEntity?:
                  | {
                      __typename: 'Account'
                      id: string
                      name?: string | null
                      mask?: string | null
                      type?: string | null
                    }
                  | {
                      __typename: 'Card'
                      id: string
                      cardNetWork: CardNetwork
                      last4: string
                    }
                  | null
                customer?: {
                  __typename: 'Customer'
                  id: string
                  name?: string | null
                  streetAddress?: string | null
                  subPremise?: string | null
                  city?: string | null
                  postalCode?: string | null
                  state?: string | null
                  country?: string | null
                } | null
                product:
                  | { __typename: 'InstantPayment' }
                  | {
                      __typename: 'Invoice'
                      id: string
                      invoiceNumber: string
                      productName?: string | null
                      status: InvoiceStatusEnum
                      amount: number
                      dueDate?: string | null
                      outstandingAmount: number
                      platformName: string
                      totalDiscountAmount: number
                      statuses: Array<{
                        __typename: 'InvoiceStatus'
                        status: InvoiceStatusEnum
                        createdAt: any
                      } | null>
                      payments?: Array<{
                        __typename: 'InvoicePayment'
                        id: string
                        status: PaymentStatusEnum
                        payoutCreationForecastDate?: string | null
                      } | null> | null
                    }
                  | { __typename: 'Offer' }
                  | { __typename: 'Referral' }
                  | { __typename: 'ReferralBonus' }
                  | { __typename: 'Refund' }
                  | {
                      __typename: 'SubscriptionPayment'
                      id: string
                      paymentDate: string
                      amount: number
                      subscriptionStatus: SubscriptionPaymentStatus
                      subscription: {
                        __typename: 'PartnerSubscription'
                        id: string
                        type: string
                        frequency: SubscriptionFrequency
                      }
                    }
                transaction?: {
                  __typename: 'Transaction'
                  failureReason?: string | null
                  status: TransactionStatus
                } | null
                statuses: Array<{
                  __typename: 'PaymentStatus'
                  status?: PaymentStatusEnum | null
                  createdAt: string
                } | null>
                refunds?: Array<{
                  __typename: 'Refund'
                  amount: number
                  createdAt: string
                  lastStatus: RefundStatusEnum
                  status?: Array<{
                    __typename: 'RefundStatus'
                    id: string
                    status: RefundStatusEnum
                    createdAt: string
                  }> | null
                } | null> | null
                payoutEstimation: {
                  __typename: 'PaymentPayoutEstimation'
                  estimatedPayoutCreationDate?: string | null
                }
              } | null>
            } | null> | null
          } | null
        } | null
        statuses: Array<{
          __typename: 'InvoiceStatus'
          status: InvoiceStatusEnum
          createdAt: any
        } | null>
        payments?: Array<{
          __typename: 'InvoicePayment'
          id: string
          status: PaymentStatusEnum
          payoutCreationForecastDate?: string | null
        } | null> | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type BnplOfferConfirmByTokenMutationVariables = Exact<{
  confirmationToken: Scalars['String']['input']
}>

export type BnplOfferConfirmByTokenMutation = {
  __typename: 'Mutation'
  BNPLOfferConfirmByToken?: string | null
}

export type PartnerBnplOfferConfirmMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerBnplOfferConfirmMutation = {
  __typename: 'Mutation'
  PartnerBNPLOfferConfirm?: string | null
}

export type PartnerCustomerBnplFragment = {
  __typename: 'Invoice'
  amount: number
  createdAt: string
  dueDate?: string | null
  id: string
  invoiceNumber: string
  productName?: string | null
  status: InvoiceStatusEnum
  outstandingAmount: number
  platformName: string
  totalDiscountAmount: number
  customer?: {
    __typename: 'Customer'
    createdAt: string
    id: string
    name?: string | null
    legalName?: string | null
    isOnboarded: boolean
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
  } | null
  partner?: {
    __typename: 'Partner'
    id: string
    name?: string | null
    legalName?: string | null
    isOnboarded: boolean
    adyenOnboardingStatus: AdyenOnboardingStatusStep
    insightsEnabled: boolean
  } | null
  offer?: {
    __typename: 'BNPLOffer'
    createdAt: string
    status: BnplStatus
    amount: number
    fees: number
    netAmount: number
    remainingBalance: number
    terms: number
    lending?: {
      __typename: 'Lending'
      id: string
      amount: number
      netAmount: number
      installments?: Array<{
        __typename: 'Installment'
        id: string
        amount: number
        dueDate: string
        netAmount: number
        status: InstallmentStatus
        payments: Array<{
          __typename: 'Payment'
          id: string
          amount: number
          netAmount: number
          creationDate: string
          currentPaymentMethod?: MethodEnum | null
          dueDate?: string | null
          paymentCompletionForecastDate?: string | null
          originService: PaymentAlternativeService
          executorType: PaymentExecutorType
          paymentFees: Array<{
            __typename: 'PaymentFee'
            forwarded: boolean
            type: FeeType
            amount: number
            name: string
          } | null>
          currentPaymentMethodEntity?:
            | {
                __typename: 'Account'
                id: string
                name?: string | null
                mask?: string | null
                type?: string | null
              }
            | {
                __typename: 'Card'
                id: string
                cardNetWork: CardNetwork
                last4: string
              }
            | null
          customer?: {
            __typename: 'Customer'
            id: string
            name?: string | null
            streetAddress?: string | null
            subPremise?: string | null
            city?: string | null
            postalCode?: string | null
            state?: string | null
            country?: string | null
          } | null
          product:
            | { __typename: 'InstantPayment' }
            | {
                __typename: 'Invoice'
                id: string
                invoiceNumber: string
                productName?: string | null
                status: InvoiceStatusEnum
                amount: number
                dueDate?: string | null
                outstandingAmount: number
                platformName: string
                totalDiscountAmount: number
                statuses: Array<{
                  __typename: 'InvoiceStatus'
                  status: InvoiceStatusEnum
                  createdAt: any
                } | null>
                payments?: Array<{
                  __typename: 'InvoicePayment'
                  id: string
                  status: PaymentStatusEnum
                  payoutCreationForecastDate?: string | null
                } | null> | null
              }
            | { __typename: 'Offer' }
            | { __typename: 'Referral' }
            | { __typename: 'ReferralBonus' }
            | { __typename: 'Refund' }
            | {
                __typename: 'SubscriptionPayment'
                id: string
                paymentDate: string
                amount: number
                subscriptionStatus: SubscriptionPaymentStatus
                subscription: {
                  __typename: 'PartnerSubscription'
                  id: string
                  type: string
                  frequency: SubscriptionFrequency
                }
              }
          transaction?: {
            __typename: 'Transaction'
            failureReason?: string | null
            status: TransactionStatus
          } | null
          statuses: Array<{
            __typename: 'PaymentStatus'
            status?: PaymentStatusEnum | null
            createdAt: string
          } | null>
          refunds?: Array<{
            __typename: 'Refund'
            amount: number
            createdAt: string
            lastStatus: RefundStatusEnum
            status?: Array<{
              __typename: 'RefundStatus'
              id: string
              status: RefundStatusEnum
              createdAt: string
            }> | null
          } | null> | null
          payoutEstimation: {
            __typename: 'PaymentPayoutEstimation'
            estimatedPayoutCreationDate?: string | null
          }
        } | null>
      } | null> | null
    } | null
  } | null
  statuses: Array<{
    __typename: 'InvoiceStatus'
    status: InvoiceStatusEnum
    createdAt: any
  } | null>
  payments?: Array<{
    __typename: 'InvoicePayment'
    id: string
    status: PaymentStatusEnum
    payoutCreationForecastDate?: string | null
  } | null> | null
}

export type PartnerCustomerOfferFragment = {
  __typename: 'BNPLOffer'
  createdAt: string
  status: BnplStatus
  amount: number
  fees: number
  netAmount: number
  remainingBalance: number
  terms: number
  lending?: {
    __typename: 'Lending'
    id: string
    amount: number
    netAmount: number
    installments?: Array<{
      __typename: 'Installment'
      id: string
      amount: number
      dueDate: string
      netAmount: number
      status: InstallmentStatus
      payments: Array<{
        __typename: 'Payment'
        id: string
        amount: number
        netAmount: number
        creationDate: string
        currentPaymentMethod?: MethodEnum | null
        dueDate?: string | null
        paymentCompletionForecastDate?: string | null
        originService: PaymentAlternativeService
        executorType: PaymentExecutorType
        paymentFees: Array<{
          __typename: 'PaymentFee'
          forwarded: boolean
          type: FeeType
          amount: number
          name: string
        } | null>
        currentPaymentMethodEntity?:
          | {
              __typename: 'Account'
              id: string
              name?: string | null
              mask?: string | null
              type?: string | null
            }
          | {
              __typename: 'Card'
              id: string
              cardNetWork: CardNetwork
              last4: string
            }
          | null
        customer?: {
          __typename: 'Customer'
          id: string
          name?: string | null
          streetAddress?: string | null
          subPremise?: string | null
          city?: string | null
          postalCode?: string | null
          state?: string | null
          country?: string | null
        } | null
        product:
          | { __typename: 'InstantPayment' }
          | {
              __typename: 'Invoice'
              id: string
              invoiceNumber: string
              productName?: string | null
              status: InvoiceStatusEnum
              amount: number
              dueDate?: string | null
              outstandingAmount: number
              platformName: string
              totalDiscountAmount: number
              statuses: Array<{
                __typename: 'InvoiceStatus'
                status: InvoiceStatusEnum
                createdAt: any
              } | null>
              payments?: Array<{
                __typename: 'InvoicePayment'
                id: string
                status: PaymentStatusEnum
                payoutCreationForecastDate?: string | null
              } | null> | null
            }
          | { __typename: 'Offer' }
          | { __typename: 'Referral' }
          | { __typename: 'ReferralBonus' }
          | { __typename: 'Refund' }
          | {
              __typename: 'SubscriptionPayment'
              id: string
              paymentDate: string
              amount: number
              subscriptionStatus: SubscriptionPaymentStatus
              subscription: {
                __typename: 'PartnerSubscription'
                id: string
                type: string
                frequency: SubscriptionFrequency
              }
            }
        transaction?: {
          __typename: 'Transaction'
          failureReason?: string | null
          status: TransactionStatus
        } | null
        statuses: Array<{
          __typename: 'PaymentStatus'
          status?: PaymentStatusEnum | null
          createdAt: string
        } | null>
        refunds?: Array<{
          __typename: 'Refund'
          amount: number
          createdAt: string
          lastStatus: RefundStatusEnum
          status?: Array<{
            __typename: 'RefundStatus'
            id: string
            status: RefundStatusEnum
            createdAt: string
          }> | null
        } | null> | null
        payoutEstimation: {
          __typename: 'PaymentPayoutEstimation'
          estimatedPayoutCreationDate?: string | null
        }
      } | null>
    } | null> | null
  } | null
}

export type PartnerCustomerScheduleFragment = {
  __typename: 'Lending'
  id: string
  amount: number
  netAmount: number
  installments?: Array<{
    __typename: 'Installment'
    id: string
    amount: number
    dueDate: string
    netAmount: number
    status: InstallmentStatus
    payments: Array<{
      __typename: 'Payment'
      id: string
      amount: number
      netAmount: number
      creationDate: string
      currentPaymentMethod?: MethodEnum | null
      dueDate?: string | null
      paymentCompletionForecastDate?: string | null
      originService: PaymentAlternativeService
      executorType: PaymentExecutorType
      paymentFees: Array<{
        __typename: 'PaymentFee'
        forwarded: boolean
        type: FeeType
        amount: number
        name: string
      } | null>
      currentPaymentMethodEntity?:
        | {
            __typename: 'Account'
            id: string
            name?: string | null
            mask?: string | null
            type?: string | null
          }
        | {
            __typename: 'Card'
            id: string
            cardNetWork: CardNetwork
            last4: string
          }
        | null
      customer?: {
        __typename: 'Customer'
        id: string
        name?: string | null
        streetAddress?: string | null
        subPremise?: string | null
        city?: string | null
        postalCode?: string | null
        state?: string | null
        country?: string | null
      } | null
      product:
        | { __typename: 'InstantPayment' }
        | {
            __typename: 'Invoice'
            id: string
            invoiceNumber: string
            productName?: string | null
            status: InvoiceStatusEnum
            amount: number
            dueDate?: string | null
            outstandingAmount: number
            platformName: string
            totalDiscountAmount: number
            statuses: Array<{
              __typename: 'InvoiceStatus'
              status: InvoiceStatusEnum
              createdAt: any
            } | null>
            payments?: Array<{
              __typename: 'InvoicePayment'
              id: string
              status: PaymentStatusEnum
              payoutCreationForecastDate?: string | null
            } | null> | null
          }
        | { __typename: 'Offer' }
        | { __typename: 'Referral' }
        | { __typename: 'ReferralBonus' }
        | { __typename: 'Refund' }
        | {
            __typename: 'SubscriptionPayment'
            id: string
            paymentDate: string
            amount: number
            subscriptionStatus: SubscriptionPaymentStatus
            subscription: {
              __typename: 'PartnerSubscription'
              id: string
              type: string
              frequency: SubscriptionFrequency
            }
          }
      transaction?: {
        __typename: 'Transaction'
        failureReason?: string | null
        status: TransactionStatus
      } | null
      statuses: Array<{
        __typename: 'PaymentStatus'
        status?: PaymentStatusEnum | null
        createdAt: string
      } | null>
      refunds?: Array<{
        __typename: 'Refund'
        amount: number
        createdAt: string
        lastStatus: RefundStatusEnum
        status?: Array<{
          __typename: 'RefundStatus'
          id: string
          status: RefundStatusEnum
          createdAt: string
        }> | null
      } | null> | null
      payoutEstimation: {
        __typename: 'PaymentPayoutEstimation'
        estimatedPayoutCreationDate?: string | null
      }
    } | null>
  } | null> | null
}

export type PartnerCustomerInstallmentFragment = {
  __typename: 'Installment'
  id: string
  amount: number
  dueDate: string
  netAmount: number
  status: InstallmentStatus
  payments: Array<{
    __typename: 'Payment'
    id: string
    amount: number
    netAmount: number
    creationDate: string
    currentPaymentMethod?: MethodEnum | null
    dueDate?: string | null
    paymentCompletionForecastDate?: string | null
    originService: PaymentAlternativeService
    executorType: PaymentExecutorType
    paymentFees: Array<{
      __typename: 'PaymentFee'
      forwarded: boolean
      type: FeeType
      amount: number
      name: string
    } | null>
    currentPaymentMethodEntity?:
      | {
          __typename: 'Account'
          id: string
          name?: string | null
          mask?: string | null
          type?: string | null
        }
      | {
          __typename: 'Card'
          id: string
          cardNetWork: CardNetwork
          last4: string
        }
      | null
    customer?: {
      __typename: 'Customer'
      id: string
      name?: string | null
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      postalCode?: string | null
      state?: string | null
      country?: string | null
    } | null
    product:
      | { __typename: 'InstantPayment' }
      | {
          __typename: 'Invoice'
          id: string
          invoiceNumber: string
          productName?: string | null
          status: InvoiceStatusEnum
          amount: number
          dueDate?: string | null
          outstandingAmount: number
          platformName: string
          totalDiscountAmount: number
          statuses: Array<{
            __typename: 'InvoiceStatus'
            status: InvoiceStatusEnum
            createdAt: any
          } | null>
          payments?: Array<{
            __typename: 'InvoicePayment'
            id: string
            status: PaymentStatusEnum
            payoutCreationForecastDate?: string | null
          } | null> | null
        }
      | { __typename: 'Offer' }
      | { __typename: 'Referral' }
      | { __typename: 'ReferralBonus' }
      | { __typename: 'Refund' }
      | {
          __typename: 'SubscriptionPayment'
          id: string
          paymentDate: string
          amount: number
          subscriptionStatus: SubscriptionPaymentStatus
          subscription: {
            __typename: 'PartnerSubscription'
            id: string
            type: string
            frequency: SubscriptionFrequency
          }
        }
    transaction?: {
      __typename: 'Transaction'
      failureReason?: string | null
      status: TransactionStatus
    } | null
    statuses: Array<{
      __typename: 'PaymentStatus'
      status?: PaymentStatusEnum | null
      createdAt: string
    } | null>
    refunds?: Array<{
      __typename: 'Refund'
      amount: number
      createdAt: string
      lastStatus: RefundStatusEnum
      status?: Array<{
        __typename: 'RefundStatus'
        id: string
        status: RefundStatusEnum
        createdAt: string
      }> | null
    } | null> | null
    payoutEstimation: {
      __typename: 'PaymentPayoutEstimation'
      estimatedPayoutCreationDate?: string | null
    }
  } | null>
}

export type PartnerChangeReferralPayoutBankingAccountMutationVariables = Exact<{
  input: PartnerDefaultPayoutBankingAccountUpdateInput
}>

export type PartnerChangeReferralPayoutBankingAccountMutation = {
  __typename: 'Mutation'
  PartnerChangeReferralPayoutBankingAccount?: string | null
}

export type PartnerListBankingIntegrationsQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerListBankingIntegrationsQuery = {
  __typename: 'Query'
  PartnerListBankingIntegrations: Array<{
    __typename: 'Institution'
    id: string
    externalId?: string | null
    name?: string | null
    url?: string | null
    logo?: string | null
    accounts?: Array<{
      __typename: 'Account'
      id: string
      mask?: string | null
      name?: string | null
      type?: string | null
      subtype?: string | null
      hasAchAccountNumber?: boolean | null
      hasAchRoutingNumber?: boolean | null
      hasWireRoutingNumber?: boolean | null
      provider?: string | null
      disconnectedAt?: string | null
      systemDeactivatedAt?: string | null
      companyName?: string | null
      institution?: {
        __typename: 'Institution'
        name?: string | null
        id: string
        logo?: string | null
      } | null
    } | null> | null
  } | null>
}

export type PartnerListCustomerBankingIntegrationsQueryVariables = Exact<{
  customerID: Scalars['String']['input']
}>

export type PartnerListCustomerBankingIntegrationsQuery = {
  __typename: 'Query'
  PartnerListCustomerBankingIntegrations: Array<{
    __typename: 'Institution'
    id: string
    externalId?: string | null
    name?: string | null
    url?: string | null
    logo?: string | null
    accounts?: Array<{
      __typename: 'Account'
      id: string
      mask?: string | null
      name?: string | null
      type?: string | null
      subtype?: string | null
      hasAchAccountNumber?: boolean | null
      hasAchRoutingNumber?: boolean | null
      hasWireRoutingNumber?: boolean | null
      provider?: string | null
      disconnectedAt?: string | null
      systemDeactivatedAt?: string | null
      companyName?: string | null
      institution?: {
        __typename: 'Institution'
        name?: string | null
        id: string
        logo?: string | null
      } | null
    } | null> | null
  } | null>
}

export type PartnerArchiveAccountMutationVariables = Exact<{
  accountID: Scalars['ID']['input']
}>

export type PartnerArchiveAccountMutation = {
  __typename: 'Mutation'
  PartnerArchiveAccount: string
}

export type PartnerAddManualBankingConnectionMutationVariables = Exact<{
  accountInformation: ManualBankingAccountInformationInput
}>

export type PartnerAddManualBankingConnectionMutation = {
  __typename: 'Mutation'
  PartnerAddManualBankingConnection?: string | null
}

export type PartnerAddCustomerBankingConnectionMutationVariables = Exact<{
  customerID: Scalars['String']['input']
  accountInformation: ManualBankingAccountInformationInput
}>

export type PartnerAddCustomerBankingConnectionMutation = {
  __typename: 'Mutation'
  PartnerAddCustomerManualBankingConnection?: string | null
}

export type PartnerChangeDefaultPayoutBankingAccountMutationVariables = Exact<{
  input: PartnerDefaultPayoutBankingAccountUpdateInput
}>

export type PartnerChangeDefaultPayoutBankingAccountMutation = {
  __typename: 'Mutation'
  PartnerChangeDefaultPayoutBankingAccount?: string | null
}

export type BankFragment = {
  __typename: 'Institution'
  id: string
  externalId?: string | null
  name?: string | null
  url?: string | null
  logo?: string | null
  accounts?: Array<{
    __typename: 'Account'
    id: string
    mask?: string | null
    name?: string | null
    type?: string | null
    subtype?: string | null
    hasAchAccountNumber?: boolean | null
    hasAchRoutingNumber?: boolean | null
    hasWireRoutingNumber?: boolean | null
    provider?: string | null
    disconnectedAt?: string | null
    systemDeactivatedAt?: string | null
    companyName?: string | null
    institution?: {
      __typename: 'Institution'
      name?: string | null
      id: string
      logo?: string | null
    } | null
  } | null> | null
}

export type BankAccountFragment = {
  __typename: 'Account'
  id: string
  mask?: string | null
  name?: string | null
  type?: string | null
  subtype?: string | null
  hasAchAccountNumber?: boolean | null
  hasAchRoutingNumber?: boolean | null
  hasWireRoutingNumber?: boolean | null
  provider?: string | null
  disconnectedAt?: string | null
  systemDeactivatedAt?: string | null
  companyName?: string | null
  institution?: {
    __typename: 'Institution'
    name?: string | null
    id: string
    logo?: string | null
  } | null
}

export type PartnerGetInvoiceBulkChargesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  getPartnerInvoiceBulkChargesFilter?: InputMaybe<GetPartnerInvoiceBulkChargesFilter>
  getPartnerInvoiceBulkChargesOrderBy?: InputMaybe<GetPartnerInvoiceBulkChargesOrderBy>
}>

export type PartnerGetInvoiceBulkChargesQuery = {
  __typename: 'Query'
  PartnerGetInvoiceBulkCharges?: {
    __typename: 'PartnerInvoiceBulkChargeConnection'
    edges?: Array<{
      __typename: 'PartnerInvoiceBulkChargeEdge'
      cursor: any
      node?: {
        __typename: 'PartnerInvoiceBulkCharge'
        id: string
        bulkChargeRequestStatus?: BulkChargeRequestStatusEnum | null
        invoiceCount: number
        paymentDate?: string | null
        createdAt: string
        partner: { __typename: 'Partner'; id: string; name?: string | null }
        requester?: {
          __typename: 'PartnerUser'
          id: string
          email: string
        } | null
        paymentRequests?: Array<{
          __typename: 'PaymentRequest'
          id: string
          lastStatus: PaymentStatusEnum
          paymentDate?: string | null
          payment?: {
            __typename: 'Payment'
            amount: number
            netAmount: number
            paymentCompletionForecastDate?: string | null
            paymentFees: Array<{
              __typename: 'PaymentFee'
              forwarded: boolean
              amount: number
            } | null>
            transaction?: {
              __typename: 'Transaction'
              failureReason?: string | null
            } | null
          } | null
          product:
            | { __typename: 'InstantPayment' }
            | {
                __typename: 'Invoice'
                id: string
                invoiceNumber: string
                productName?: string | null
                amount: number
                status: InvoiceStatusEnum
                customer?: {
                  __typename: 'Customer'
                  id: string
                  name?: string | null
                } | null
              }
            | { __typename: 'Offer' }
            | { __typename: 'Referral' }
            | { __typename: 'ReferralBonus' }
            | { __typename: 'Refund' }
            | { __typename: 'SubscriptionPayment' }
        } | null> | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerInvoiceBulkChargeOnDateMutationVariables = Exact<{
  invoiceIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >
  paymentDate?: InputMaybe<Scalars['String']['input']>
}>

export type PartnerInvoiceBulkChargeOnDateMutation = {
  __typename: 'Mutation'
  PartnerInvoiceBulkChargeOnDate?: string | null
}

export type PartnerInvoiceBulkChargeOnDueDateMutationVariables = Exact<{
  invoiceIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >
}>

export type PartnerInvoiceBulkChargeOnDueDateMutation = {
  __typename: 'Mutation'
  PartnerInvoiceBulkChargeOnDueDate?: string | null
}

export type PartnerInvoiceBulkChargeFragment = {
  __typename: 'PartnerInvoiceBulkCharge'
  id: string
  bulkChargeRequestStatus?: BulkChargeRequestStatusEnum | null
  invoiceCount: number
  paymentDate?: string | null
  createdAt: string
  partner: { __typename: 'Partner'; id: string; name?: string | null }
  requester?: { __typename: 'PartnerUser'; id: string; email: string } | null
  paymentRequests?: Array<{
    __typename: 'PaymentRequest'
    id: string
    lastStatus: PaymentStatusEnum
    paymentDate?: string | null
    payment?: {
      __typename: 'Payment'
      amount: number
      netAmount: number
      paymentCompletionForecastDate?: string | null
      paymentFees: Array<{
        __typename: 'PaymentFee'
        forwarded: boolean
        amount: number
      } | null>
      transaction?: {
        __typename: 'Transaction'
        failureReason?: string | null
      } | null
    } | null
    product:
      | { __typename: 'InstantPayment' }
      | {
          __typename: 'Invoice'
          id: string
          invoiceNumber: string
          productName?: string | null
          amount: number
          status: InvoiceStatusEnum
          customer?: {
            __typename: 'Customer'
            id: string
            name?: string | null
          } | null
        }
      | { __typename: 'Offer' }
      | { __typename: 'Referral' }
      | { __typename: 'ReferralBonus' }
      | { __typename: 'Refund' }
      | { __typename: 'SubscriptionPayment' }
  } | null> | null
}

export type PaymentRequestFragment = {
  __typename: 'PaymentRequest'
  id: string
  lastStatus: PaymentStatusEnum
  paymentDate?: string | null
  payment?: {
    __typename: 'Payment'
    amount: number
    netAmount: number
    paymentCompletionForecastDate?: string | null
    paymentFees: Array<{
      __typename: 'PaymentFee'
      forwarded: boolean
      amount: number
    } | null>
    transaction?: {
      __typename: 'Transaction'
      failureReason?: string | null
    } | null
  } | null
  product:
    | { __typename: 'InstantPayment' }
    | {
        __typename: 'Invoice'
        id: string
        invoiceNumber: string
        productName?: string | null
        amount: number
        status: InvoiceStatusEnum
        customer?: {
          __typename: 'Customer'
          id: string
          name?: string | null
        } | null
      }
    | { __typename: 'Offer' }
    | { __typename: 'Referral' }
    | { __typename: 'ReferralBonus' }
    | { __typename: 'Refund' }
    | { __typename: 'SubscriptionPayment' }
}

export type FindOverdueInvoiceDetailQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type FindOverdueInvoiceDetailQuery = {
  __typename: 'Query'
  FindInvoice?: {
    __typename: 'Invoice'
    id: string
    amount: number
    outstandingAmount: number
    createdAt: string
    dueDate?: string | null
    invoiceNumber: string
    status: InvoiceStatusEnum
    customer?: {
      __typename: 'Customer'
      createdAt: string
      id: string
      name?: string | null
      legalName?: string | null
      isOnboarded: boolean
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      postalCode?: string | null
      state?: string | null
      country?: string | null
    } | null
    collection?: {
      __typename: 'Collection'
      id: string
      status: Array<{
        __typename: 'CollectionStatus'
        status: CollectionStatusEnum
        createdAt: string
      }>
    } | null
  } | null
}

export type FindOverdueInvoicesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<InvoiceFilter>
  orderBy?: InputMaybe<InvoiceOrderBy>
}>

export type FindOverdueInvoicesQuery = {
  __typename: 'Query'
  PartnerInvoiceConnection: {
    __typename: 'InvoiceConnection'
    edges?: Array<{
      __typename: 'InvoiceEdge'
      cursor: any
      node?: {
        __typename: 'Invoice'
        id: string
        amount: number
        outstandingAmount: number
        createdAt: string
        dueDate?: string | null
        invoiceNumber: string
        status: InvoiceStatusEnum
        collection?: {
          __typename: 'Collection'
          id: string
          status: Array<{
            __typename: 'CollectionStatus'
            status: CollectionStatusEnum
            createdAt: string
          }>
        } | null
        customer?: {
          __typename: 'Customer'
          createdAt: string
          id: string
          name?: string | null
          legalName?: string | null
          isOnboarded: boolean
          streetAddress?: string | null
          subPremise?: string | null
          city?: string | null
          postalCode?: string | null
          state?: string | null
          country?: string | null
        } | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  }
}

export type PartnerCollectionConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  collectionFilter?: InputMaybe<CollectionFilter>
  orderBy?: InputMaybe<CollectionOrder>
}>

export type PartnerCollectionConnectionQuery = {
  __typename: 'Query'
  PartnerCollectionConnection?: {
    __typename: 'CollectionConnection'
    edges?: Array<{
      __typename: 'CollectionEdge'
      cursor: any
      node?: {
        __typename: 'Collection'
        id: string
        createdAt: string
        collectionOutstandingAmount: number
        collectionFeePaymentAmount: number
        interest: number
        collectionPayment?: {
          __typename: 'Payment'
          id: string
          amount: number
          creationDate: string
        } | null
        invoice: {
          __typename: 'Invoice'
          id: string
          amount: number
          dueDate?: string | null
          invoiceNumber: string
          productName?: string | null
        }
        customerInfo: {
          __typename: 'CollectionCustomerInfo'
          customer: {
            __typename: 'Customer'
            createdAt: string
            id: string
            name?: string | null
            legalName?: string | null
            isOnboarded: boolean
            streetAddress?: string | null
            subPremise?: string | null
            city?: string | null
            postalCode?: string | null
            state?: string | null
            country?: string | null
          }
        }
        upfrontFeePayment?: {
          __typename: 'Payment'
          id: string
          amount: number
          netAmount: number
          dueDate?: string | null
          paymentCompletionForecastDate?: string | null
          currentPaymentMethodEntity?:
            | { __typename: 'Account'; id: string; name?: string | null }
            | { __typename: 'Card'; id: string; cardNetWork: CardNetwork }
            | null
          paymentFees: Array<{
            __typename: 'PaymentFee'
            amount: number
            forwarded: boolean
            name: string
          } | null>
          statuses: Array<{
            __typename: 'PaymentStatus'
            status?: PaymentStatusEnum | null
            createdAt: string
          } | null>
        } | null
        status: Array<{
          __typename: 'CollectionStatus'
          status: CollectionStatusEnum
          createdAt: string
        }>
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type FindCollectionDetailQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  collectionFilter?: InputMaybe<CollectionFilter>
  orderBy?: InputMaybe<CollectionOrder>
}>

export type FindCollectionDetailQuery = {
  __typename: 'Query'
  PartnerCollectionConnection?: {
    __typename: 'CollectionConnection'
    edges?: Array<{
      __typename: 'CollectionEdge'
      cursor: any
      node?: {
        __typename: 'Collection'
        id: string
        collectionInstruction: string
        collectionOutstandingAmount: number
        collectionFeePaymentAmount: number
        interest: number
        lastContactDate: string
        customerType: CollectionCustomerType
        createdAt: string
        updatedAt: string
        collectionPayment?: {
          __typename: 'Payment'
          id: string
          amount: number
          netAmount: number
          paymentCompletionForecastDate?: string | null
          currentPaymentMethodEntity?:
            | { __typename: 'Account'; id: string; name?: string | null }
            | { __typename: 'Card'; id: string; cardNetWork: CardNetwork }
            | null
          paymentFees: Array<{
            __typename: 'PaymentFee'
            amount: number
            forwarded: boolean
            name: string
          } | null>
          statuses: Array<{
            __typename: 'PaymentStatus'
            status?: PaymentStatusEnum | null
            createdAt: string
          } | null>
        } | null
        customerInfo: {
          __typename: 'CollectionCustomerInfo'
          name: string
          phone: string
          email: string
          streetAddress: string
          subPremise?: string | null
          city: string
          state: string
          postalCode: string
          country: string
          customer: { __typename: 'Customer'; name?: string | null; id: string }
        }
        invoice: {
          __typename: 'Invoice'
          id: string
          amount: number
          dueDate?: string | null
          invoiceNumber: string
          productName?: string | null
        }
        notes: Array<{
          __typename: 'CollectionNote'
          note: string
          createdAt: string
        }>
        status: Array<{
          __typename: 'CollectionStatus'
          status: CollectionStatusEnum
          createdAt: string
        }>
        upfrontFeePayment?: {
          __typename: 'Payment'
          id: string
          amount: number
          netAmount: number
          dueDate?: string | null
          paymentCompletionForecastDate?: string | null
          currentPaymentMethodEntity?:
            | { __typename: 'Account'; id: string; name?: string | null }
            | { __typename: 'Card'; id: string; cardNetWork: CardNetwork }
            | null
          paymentFees: Array<{
            __typename: 'PaymentFee'
            amount: number
            forwarded: boolean
            name: string
          } | null>
          statuses: Array<{
            __typename: 'PaymentStatus'
            status?: PaymentStatusEnum | null
            createdAt: string
          } | null>
        } | null
      } | null
    } | null> | null
  } | null
}

export type PartnerCollectionTotalsQueryVariables = Exact<{
  collectionFilter?: InputMaybe<CollectionFilter>
}>

export type PartnerCollectionTotalsQuery = {
  __typename: 'Query'
  PartnerCollectionTotals: {
    __typename: 'CollectionTotals'
    netAmount: number
    amount: number
    count: number
  }
}

export type PartnerGetFeeRatesQueryVariables = Exact<{
  input: GetFeeRatesInput
}>

export type PartnerGetFeeRatesQuery = {
  __typename: 'Query'
  PartnerGetFeeRates?: {
    __typename: 'CollectionFeeRates'
    upfrontFeeAmount: number
    collectionFeeAmount: number
  } | null
}

export type PartnerCreateCollectionMutationVariables = Exact<{
  createInput: CollectionCreateInput
}>

export type PartnerCreateCollectionMutation = {
  __typename: 'Mutation'
  PartnerCreateCollection?: string | null
}

export type PartnerCancelCollectionMutationVariables = Exact<{
  collectionID: Scalars['String']['input']
  reason: Scalars['String']['input']
}>

export type PartnerCancelCollectionMutation = {
  __typename: 'Mutation'
  PartnerCancelCollection?: string | null
}

export type PartnerCollectionInvoiceFragment = {
  __typename: 'Invoice'
  id: string
  amount: number
  outstandingAmount: number
  createdAt: string
  dueDate?: string | null
  invoiceNumber: string
  status: InvoiceStatusEnum
  collection?: {
    __typename: 'Collection'
    id: string
    status: Array<{
      __typename: 'CollectionStatus'
      status: CollectionStatusEnum
      createdAt: string
    }>
  } | null
  customer?: {
    __typename: 'Customer'
    createdAt: string
    id: string
    name?: string | null
    legalName?: string | null
    isOnboarded: boolean
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
  } | null
}

export type UpfrontFeePaymentFragment = {
  __typename: 'Payment'
  id: string
  amount: number
  netAmount: number
  dueDate?: string | null
  paymentCompletionForecastDate?: string | null
  currentPaymentMethodEntity?:
    | { __typename: 'Account'; id: string; name?: string | null }
    | { __typename: 'Card'; id: string; cardNetWork: CardNetwork }
    | null
  paymentFees: Array<{
    __typename: 'PaymentFee'
    amount: number
    forwarded: boolean
    name: string
  } | null>
  statuses: Array<{
    __typename: 'PaymentStatus'
    status?: PaymentStatusEnum | null
    createdAt: string
  } | null>
}

export type PartnerCollectionListingFragment = {
  __typename: 'Collection'
  id: string
  createdAt: string
  collectionOutstandingAmount: number
  collectionFeePaymentAmount: number
  interest: number
  collectionPayment?: {
    __typename: 'Payment'
    id: string
    amount: number
    creationDate: string
  } | null
  invoice: {
    __typename: 'Invoice'
    id: string
    amount: number
    dueDate?: string | null
    invoiceNumber: string
    productName?: string | null
  }
  customerInfo: {
    __typename: 'CollectionCustomerInfo'
    customer: {
      __typename: 'Customer'
      createdAt: string
      id: string
      name?: string | null
      legalName?: string | null
      isOnboarded: boolean
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      postalCode?: string | null
      state?: string | null
      country?: string | null
    }
  }
  upfrontFeePayment?: {
    __typename: 'Payment'
    id: string
    amount: number
    netAmount: number
    dueDate?: string | null
    paymentCompletionForecastDate?: string | null
    currentPaymentMethodEntity?:
      | { __typename: 'Account'; id: string; name?: string | null }
      | { __typename: 'Card'; id: string; cardNetWork: CardNetwork }
      | null
    paymentFees: Array<{
      __typename: 'PaymentFee'
      amount: number
      forwarded: boolean
      name: string
    } | null>
    statuses: Array<{
      __typename: 'PaymentStatus'
      status?: PaymentStatusEnum | null
      createdAt: string
    } | null>
  } | null
  status: Array<{
    __typename: 'CollectionStatus'
    status: CollectionStatusEnum
    createdAt: string
  }>
}

export type PartnerCollectionDetailFragment = {
  __typename: 'Collection'
  id: string
  collectionInstruction: string
  collectionOutstandingAmount: number
  collectionFeePaymentAmount: number
  interest: number
  lastContactDate: string
  customerType: CollectionCustomerType
  createdAt: string
  updatedAt: string
  collectionPayment?: {
    __typename: 'Payment'
    id: string
    amount: number
    netAmount: number
    paymentCompletionForecastDate?: string | null
    currentPaymentMethodEntity?:
      | { __typename: 'Account'; id: string; name?: string | null }
      | { __typename: 'Card'; id: string; cardNetWork: CardNetwork }
      | null
    paymentFees: Array<{
      __typename: 'PaymentFee'
      amount: number
      forwarded: boolean
      name: string
    } | null>
    statuses: Array<{
      __typename: 'PaymentStatus'
      status?: PaymentStatusEnum | null
      createdAt: string
    } | null>
  } | null
  customerInfo: {
    __typename: 'CollectionCustomerInfo'
    name: string
    phone: string
    email: string
    streetAddress: string
    subPremise?: string | null
    city: string
    state: string
    postalCode: string
    country: string
    customer: { __typename: 'Customer'; name?: string | null; id: string }
  }
  invoice: {
    __typename: 'Invoice'
    id: string
    amount: number
    dueDate?: string | null
    invoiceNumber: string
    productName?: string | null
  }
  notes: Array<{
    __typename: 'CollectionNote'
    note: string
    createdAt: string
  }>
  status: Array<{
    __typename: 'CollectionStatus'
    status: CollectionStatusEnum
    createdAt: string
  }>
  upfrontFeePayment?: {
    __typename: 'Payment'
    id: string
    amount: number
    netAmount: number
    dueDate?: string | null
    paymentCompletionForecastDate?: string | null
    currentPaymentMethodEntity?:
      | { __typename: 'Account'; id: string; name?: string | null }
      | { __typename: 'Card'; id: string; cardNetWork: CardNetwork }
      | null
    paymentFees: Array<{
      __typename: 'PaymentFee'
      amount: number
      forwarded: boolean
      name: string
    } | null>
    statuses: Array<{
      __typename: 'PaymentStatus'
      status?: PaymentStatusEnum | null
      createdAt: string
    } | null>
  } | null
}

export type PartnerOverdueInvoiceFragment = {
  __typename: 'Invoice'
  id: string
  amount: number
  outstandingAmount: number
  createdAt: string
  dueDate?: string | null
  invoiceNumber: string
  status: InvoiceStatusEnum
  customer?: {
    __typename: 'Customer'
    createdAt: string
    id: string
    name?: string | null
    legalName?: string | null
    isOnboarded: boolean
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
  } | null
  collection?: {
    __typename: 'Collection'
    id: string
    status: Array<{
      __typename: 'CollectionStatus'
      status: CollectionStatusEnum
      createdAt: string
    }>
  } | null
}

export type PartnerListCardsQueryVariables = Exact<{
  filter?: InputMaybe<ListCardsFilterInput>
}>

export type PartnerListCardsQuery = {
  __typename: 'Query'
  PartnerListCards?: Array<{
    __typename: 'Card'
    id: string
    last4: string
    expirationDate: string
    cardNetWork: CardNetwork
    fundingSource: FundingSource
  } | null> | null
}

export type PartnerListCustomerCardsQueryVariables = Exact<{
  filter?: InputMaybe<ListCardsFilterInput>
  customerID: Scalars['ID']['input']
}>

export type PartnerListCustomerCardsQuery = {
  __typename: 'Query'
  PartnerListCustomerCards?: Array<{
    __typename: 'Card'
    id: string
    last4: string
    expirationDate: string
    cardNetWork: CardNetwork
    fundingSource: FundingSource
  } | null> | null
}

export type PartnerGetCardFeeQueryVariables = Exact<{
  input: GetCardFeeInput
}>

export type PartnerGetCardFeeQuery = {
  __typename: 'Query'
  PartnerGetCardFee?: {
    __typename: 'CardFeeAmount'
    percentage: number
    feeAmount: number
  } | null
}

export type PartnerGetCustomerCardFeeQueryVariables = Exact<{
  input: GetCustomerCardFeeInput
}>

export type PartnerGetCustomerCardFeeQuery = {
  __typename: 'Query'
  PartnerGetCustomerCardFee?: {
    __typename: 'CardFeeAmount'
    percentage: number
    feeAmount: number
  } | null
}

export type PartnerCreateCardMutationVariables = Exact<{
  input: CardCreationInput
}>

export type PartnerCreateCardMutation = {
  __typename: 'Mutation'
  PartnerCreateCard?: string | null
}

export type PartnerCreateCustomerCardMutationVariables = Exact<{
  input: CardCreationInput
  customerID: Scalars['ID']['input']
}>

export type PartnerCreateCustomerCardMutation = {
  __typename: 'Mutation'
  PartnerCreateCustomerCard?: string | null
}

export type PartnerDeleteCardMutationVariables = Exact<{
  input: CardDeletionInput
}>

export type PartnerDeleteCardMutation = {
  __typename: 'Mutation'
  PartnerDeleteCard?: string | null
}

export type PartnerDeleteCustomerCardMutationVariables = Exact<{
  input: CardDeletionInput
  customerID: Scalars['ID']['input']
}>

export type PartnerDeleteCustomerCardMutation = {
  __typename: 'Mutation'
  PartnerDeleteCustomerCard?: string | null
}

export type PartnerModernBancGenerateSerializedTokenMutationVariables = Exact<{
  input: CardSerializationInput
}>

export type PartnerModernBancGenerateSerializedTokenMutation = {
  __typename: 'Mutation'
  PartnerModernBancGenerateSerializedToken?: string | null
}

export type CreditCardFragment = {
  __typename: 'Card'
  id: string
  last4: string
  expirationDate: string
  cardNetWork: CardNetwork
  fundingSource: FundingSource
}

export type PartnerBatchTagCustomersMutationVariables = Exact<{
  customerIDs: Array<Scalars['ID']['input']> | Scalars['ID']['input']
  tagID: Scalars['ID']['input']
}>

export type PartnerBatchTagCustomersMutation = {
  __typename: 'Mutation'
  PartnerBatchTagCustomers: string
}

export type PartnerDeleteCustomerTagMutationVariables = Exact<{
  ID: Scalars['ID']['input']
}>

export type PartnerDeleteCustomerTagMutation = {
  __typename: 'Mutation'
  PartnerDeleteCustomerTag: string
}

export type PartnerUpdateCustomerTagMutationVariables = Exact<{
  input: PartnerUpdateCustomerTagInput
}>

export type PartnerUpdateCustomerTagMutation = {
  __typename: 'Mutation'
  PartnerUpdateCustomerTag: string
}

export type PartnerTagCustomerMutationVariables = Exact<{
  customerID: Scalars['ID']['input']
  tagID: Scalars['ID']['input']
}>

export type PartnerTagCustomerMutation = {
  __typename: 'Mutation'
  PartnerTagCustomer: string
}

export type PartnerUntagCustomerMutationVariables = Exact<{
  customerID: Scalars['ID']['input']
  tagID: Scalars['ID']['input']
}>

export type PartnerUntagCustomerMutation = {
  __typename: 'Mutation'
  PartnerUntagCustomer: string
}

export type PartnerListCustomerTagsQueryVariables = Exact<{
  filter?: InputMaybe<TagFilter>
}>

export type PartnerListCustomerTagsQuery = {
  __typename: 'Query'
  PartnerListCustomerTags?: Array<{
    __typename: 'CustomerTag'
    ID: string
    name: string
    description?: string | null
    color?: TagColor | null
    customerIDs: Array<string>
    type?: TagType | null
  }> | null
}

export type PartnerCreateCustomerTagMutationVariables = Exact<{
  input: PartnerCreateCustomerTagInput
}>

export type PartnerCreateCustomerTagMutation = {
  __typename: 'Mutation'
  PartnerCreateCustomerTag: string
}

export type PartnerCustomerWithInvoicesDataConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<CustomerFilter>
  orderBy?: InputMaybe<CustomerOrderBy>
}>

export type PartnerCustomerWithInvoicesDataConnectionQuery = {
  __typename: 'Query'
  PartnerCustomerConnection?: {
    __typename: 'CustomerConnection'
    edges?: Array<{
      __typename: 'CustomerEdge'
      node?: {
        __typename: 'Customer'
        tagIDs?: Array<string> | null
        legalName?: string | null
        ein?: string | null
        createdAt: string
        isOnboarded: boolean
        id: string
        name?: string | null
        streetAddress?: string | null
        subPremise?: string | null
        city?: string | null
        postalCode?: string | null
        state?: string | null
        country?: string | null
        outstandingInvoicesData?: {
          __typename: 'CustomerOutstandingInvoicesData'
          outstandingInvoicesCount?: number | null
          outstandingInvoicesTotal?: number | null
          longestDaysOverdue?: string | null
        } | null
        defaultPaymentMethod?: {
          __typename: 'CustomerDefaultPaymentMethod'
          methodID: string
          method: TransferPaymentMethodInputEnum
          institution?: {
            __typename: 'Institution'
            id: string
            externalId?: string | null
            name?: string | null
            url?: string | null
            logo?: string | null
            accounts?: Array<{
              __typename: 'Account'
              id: string
              mask?: string | null
              name?: string | null
              type?: string | null
              subtype?: string | null
              hasAchAccountNumber?: boolean | null
              hasAchRoutingNumber?: boolean | null
              hasWireRoutingNumber?: boolean | null
              provider?: string | null
              disconnectedAt?: string | null
              systemDeactivatedAt?: string | null
              companyName?: string | null
              institution?: {
                __typename: 'Institution'
                name?: string | null
                id: string
                logo?: string | null
              } | null
            } | null> | null
          } | null
          card?: {
            __typename: 'Card'
            id: string
            last4: string
            expirationDate: string
            cardNetWork: CardNetwork
            fundingSource: FundingSource
          } | null
        } | null
        partner?: {
          __typename: 'Partner'
          id: string
          paymentsPortalUrl?: string | null
        } | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerCustomerConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<CustomerFilter>
  orderBy?: InputMaybe<CustomerOrderBy>
}>

export type PartnerCustomerConnectionQuery = {
  __typename: 'Query'
  PartnerCustomerConnection?: {
    __typename: 'CustomerConnection'
    edges?: Array<{
      __typename: 'CustomerEdge'
      node?: {
        __typename: 'Customer'
        legalName?: string | null
        ein?: string | null
        createdAt: string
        isOnboarded: boolean
        tagIDs?: Array<string> | null
        id: string
        name?: string | null
        streetAddress?: string | null
        subPremise?: string | null
        city?: string | null
        postalCode?: string | null
        state?: string | null
        country?: string | null
        partner?: {
          __typename: 'Partner'
          id: string
          paymentsPortalUrl?: string | null
        } | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasPreviousPage: boolean
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerListCustomersTotalsQueryVariables = Exact<{
  filter?: InputMaybe<CustomerFilter>
}>

export type PartnerListCustomersTotalsQuery = {
  __typename: 'Query'
  PartnerListCustomersTotals?: {
    __typename: 'PartnerCustomerTotals'
    count: number
  } | null
}

export type PartnerCustomerSearchQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>
}>

export type PartnerCustomerSearchQuery = {
  __typename: 'Query'
  PartnerCustomerConnection?: {
    __typename: 'CustomerConnection'
    edges?: Array<{
      __typename: 'CustomerEdge'
      node?: { __typename: 'Customer'; id: string; name?: string | null } | null
    } | null> | null
  } | null
}

export type PartnerArchiveCustomerMutationVariables = Exact<{
  input: PartnerArchiveCustomerInput
}>

export type PartnerArchiveCustomerMutation = {
  __typename: 'Mutation'
  PartnerArchiveCustomer?: {
    __typename: 'Customer'
    legalName?: string | null
    ein?: string | null
    createdAt: string
    isOnboarded: boolean
    tagIDs?: Array<string> | null
    id: string
    name?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
    partner?: {
      __typename: 'Partner'
      id: string
      paymentsPortalUrl?: string | null
    } | null
  } | null
}

export type PartnerUnarchiveCustomerMutationVariables = Exact<{
  input: PartnerUnarchiveCustomerInput
}>

export type PartnerUnarchiveCustomerMutation = {
  __typename: 'Mutation'
  PartnerUnarchiveCustomer?: {
    __typename: 'Customer'
    legalName?: string | null
    ein?: string | null
    createdAt: string
    isOnboarded: boolean
    tagIDs?: Array<string> | null
    id: string
    name?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
    partner?: {
      __typename: 'Partner'
      id: string
      paymentsPortalUrl?: string | null
    } | null
  } | null
}

export type PartnerCreateCustomerMutationVariables = Exact<{
  input?: InputMaybe<PartnerCreateCustomerInput>
}>

export type PartnerCreateCustomerMutation = {
  __typename: 'Mutation'
  PartnerCreateCustomer?: {
    __typename: 'Customer'
    legalName?: string | null
    ein?: string | null
    createdAt: string
    isOnboarded: boolean
    tagIDs?: Array<string> | null
    id: string
    name?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
    partner?: {
      __typename: 'Partner'
      id: string
      paymentsPortalUrl?: string | null
    } | null
  } | null
}

export type UpdateCustomerMutationVariables = Exact<{
  input?: InputMaybe<PartnerUpdateCustomerInput>
}>

export type UpdateCustomerMutation = {
  __typename: 'Mutation'
  PartnerUpdateCustomer?: {
    __typename: 'Customer'
    legalName?: string | null
    ein?: string | null
    createdAt: string
    isOnboarded: boolean
    tagIDs?: Array<string> | null
    id: string
    name?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
    partner?: {
      __typename: 'Partner'
      id: string
      paymentsPortalUrl?: string | null
    } | null
  } | null
}

export type PartnerCustomerAddressFragment = {
  __typename: 'Customer'
  streetAddress?: string | null
  subPremise?: string | null
  city?: string | null
  postalCode?: string | null
  state?: string | null
  country?: string | null
}

export type PartnerCustomerBasicFragment = {
  __typename: 'Customer'
  createdAt: string
  id: string
  name?: string | null
  legalName?: string | null
  isOnboarded: boolean
  streetAddress?: string | null
  subPremise?: string | null
  city?: string | null
  postalCode?: string | null
  state?: string | null
  country?: string | null
}

export type PartnerCustomerFragment = {
  __typename: 'Customer'
  ein?: string | null
  companyType?: string | null
  industry?: string | null
  description?: string | null
  isArchived: boolean
  archivedBy?: string | null
  createdAt: string
  id: string
  name?: string | null
  legalName?: string | null
  isOnboarded: boolean
  streetAddress?: string | null
  subPremise?: string | null
  city?: string | null
  postalCode?: string | null
  state?: string | null
  country?: string | null
}

export type PartnerCustomerListWithInvoicesDataFragment = {
  __typename: 'Customer'
  tagIDs?: Array<string> | null
  legalName?: string | null
  ein?: string | null
  createdAt: string
  isOnboarded: boolean
  id: string
  name?: string | null
  streetAddress?: string | null
  subPremise?: string | null
  city?: string | null
  postalCode?: string | null
  state?: string | null
  country?: string | null
  outstandingInvoicesData?: {
    __typename: 'CustomerOutstandingInvoicesData'
    outstandingInvoicesCount?: number | null
    outstandingInvoicesTotal?: number | null
    longestDaysOverdue?: string | null
  } | null
  defaultPaymentMethod?: {
    __typename: 'CustomerDefaultPaymentMethod'
    methodID: string
    method: TransferPaymentMethodInputEnum
    institution?: {
      __typename: 'Institution'
      id: string
      externalId?: string | null
      name?: string | null
      url?: string | null
      logo?: string | null
      accounts?: Array<{
        __typename: 'Account'
        id: string
        mask?: string | null
        name?: string | null
        type?: string | null
        subtype?: string | null
        hasAchAccountNumber?: boolean | null
        hasAchRoutingNumber?: boolean | null
        hasWireRoutingNumber?: boolean | null
        provider?: string | null
        disconnectedAt?: string | null
        systemDeactivatedAt?: string | null
        companyName?: string | null
        institution?: {
          __typename: 'Institution'
          name?: string | null
          id: string
          logo?: string | null
        } | null
      } | null> | null
    } | null
    card?: {
      __typename: 'Card'
      id: string
      last4: string
      expirationDate: string
      cardNetWork: CardNetwork
      fundingSource: FundingSource
    } | null
  } | null
  partner?: {
    __typename: 'Partner'
    id: string
    paymentsPortalUrl?: string | null
  } | null
}

export type PartnerCustomerListFragment = {
  __typename: 'Customer'
  legalName?: string | null
  ein?: string | null
  createdAt: string
  isOnboarded: boolean
  tagIDs?: Array<string> | null
  id: string
  name?: string | null
  streetAddress?: string | null
  subPremise?: string | null
  city?: string | null
  postalCode?: string | null
  state?: string | null
  country?: string | null
  partner?: {
    __typename: 'Partner'
    id: string
    paymentsPortalUrl?: string | null
  } | null
}

export type PartnerCustomerSearchFragment = {
  __typename: 'Customer'
  id: string
  name?: string | null
}

export type PartnerBulkToggleArchiveCustomersMutationVariables = Exact<{
  input: BulkToggleArchiveCustomersInput
}>

export type PartnerBulkToggleArchiveCustomersMutation = {
  __typename: 'Mutation'
  PartnerBulkToggleArchiveCustomers: string
}

export type PartnerCustomerUserConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<CustomerUserFilter>
  orderBy?: InputMaybe<CustomerUserOrderBy>
}>

export type PartnerCustomerUserConnectionQuery = {
  __typename: 'Query'
  PartnerCustomerUserConnection?: {
    __typename: 'CustomerUserConnection'
    edges?: Array<{
      __typename: 'CustomerUserEdge'
      node?: {
        __typename: 'CustomerUser'
        id: string
        email: string
        firstName?: string | null
        lastName?: string | null
        approvedBy?: string | null
        createdAt: string
        customer?: {
          __typename: 'Customer'
          id: string
          name?: string | null
        } | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerArchiveCustomerAccountMutationVariables = Exact<{
  accountID: Scalars['ID']['input']
  customerID: Scalars['ID']['input']
}>

export type PartnerArchiveCustomerAccountMutation = {
  __typename: 'Mutation'
  PartnerArchiveCustomerAccount: string
}

export type PartnerCreateCustomerUserMutationVariables = Exact<{
  input?: InputMaybe<PartnerCreateCustomerUserInput>
}>

export type PartnerCreateCustomerUserMutation = {
  __typename: 'Mutation'
  PartnerCreateCustomerUser?: {
    __typename: 'CustomerUser'
    id: string
    email: string
    firstName?: string | null
    lastName?: string | null
  } | null
}

export type PartnerDeleteCustomerUserMutationVariables = Exact<{
  id: Scalars['String']['input']
}>

export type PartnerDeleteCustomerUserMutation = {
  __typename: 'Mutation'
  PartnerDeleteCustomerUser?: string | null
}

export type UpdateCustomerUserMutationVariables = Exact<{
  input?: InputMaybe<PartnerUpdateCustomerUserInput>
}>

export type UpdateCustomerUserMutation = {
  __typename: 'Mutation'
  PartnerUpdateCustomerUser?: {
    __typename: 'CustomerUser'
    id: string
    email: string
    firstName?: string | null
    lastName?: string | null
    approvedBy?: string | null
    createdAt: string
    customer?: {
      __typename: 'Customer'
      id: string
      name?: string | null
    } | null
  } | null
}

export type PartnerListCustomerUsersFragment = {
  __typename: 'CustomerUser'
  id: string
  email: string
  firstName?: string | null
  lastName?: string | null
  approvedBy?: string | null
  createdAt: string
  customer?: { __typename: 'Customer'; id: string; name?: string | null } | null
}

export type PartnerCustomerUserCreationFragment = {
  __typename: 'CustomerUser'
  id: string
  email: string
  firstName?: string | null
  lastName?: string | null
}

export type PartnerCreateEmailTemplateMutationVariables = Exact<{
  input: CreateEmailTemplateInput
}>

export type PartnerCreateEmailTemplateMutation = {
  __typename: 'Mutation'
  PartnerCreateEmailTemplate: {
    __typename: 'EmailTemplate'
    id: string
    partnerID: string
    name: string
    subject: string
    section1?: string | null
    section2?: string | null
    section3?: string | null
    type: TemplateType
    favorite?: boolean | null
  }
}

export type PartnerUpdateEmailTemplateMutationVariables = Exact<{
  input: UpdateEmailTemplateInput
}>

export type PartnerUpdateEmailTemplateMutation = {
  __typename: 'Mutation'
  PartnerUpdateEmailTemplate: string
}

export type PartnerDeleteEmailTemplateMutationVariables = Exact<{
  input: DeleteEmailTemplateInput
}>

export type PartnerDeleteEmailTemplateMutation = {
  __typename: 'Mutation'
  PartnerDeleteEmailTemplate: string
}

export type PartnerToggleEmailTemplateFavoriteMutationVariables = Exact<{
  templateID: Scalars['ID']['input']
}>

export type PartnerToggleEmailTemplateFavoriteMutation = {
  __typename: 'Mutation'
  PartnerToggleEmailTemplateFavorite: string
}

export type PartnerEmailActivityConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<EmailActivityFilter>
}>

export type PartnerEmailActivityConnectionQuery = {
  __typename: 'Query'
  PartnerEmailActivityConnection?: {
    __typename: 'EmailActivityConnection'
    edges: Array<{
      __typename: 'EmailActivityEdge'
      node: {
        __typename: 'EmailActivity'
        sentAt: string
        user: string
        subject: string
        status?: EmailStatus | null
        invoice?: {
          __typename: 'Invoice'
          id: string
          invoiceNumber: string
        } | null
        customer?: {
          __typename: 'Customer'
          legalName?: string | null
          ein?: string | null
          createdAt: string
          isOnboarded: boolean
          tagIDs?: Array<string> | null
          id: string
          name?: string | null
          streetAddress?: string | null
          subPremise?: string | null
          city?: string | null
          postalCode?: string | null
          state?: string | null
          country?: string | null
          partner?: {
            __typename: 'Partner'
            id: string
            paymentsPortalUrl?: string | null
          } | null
        } | null
      }
    }>
    pageInfo: {
      __typename: 'PageInfo'
      endCursor?: any | null
      hasNextPage: boolean
    }
  } | null
}

export type PartnerListEmailTemplatesQueryVariables = Exact<{
  templateType: TemplateType
  favoritesOnly?: InputMaybe<Scalars['Boolean']['input']>
  templateID?: InputMaybe<Scalars['ID']['input']>
}>

export type PartnerListEmailTemplatesQuery = {
  __typename: 'Query'
  PartnerListEmailTemplates?: Array<{
    __typename: 'EmailTemplate'
    id: string
    partnerID: string
    name: string
    subject: string
    section1?: string | null
    section2?: string | null
    section3?: string | null
    type: TemplateType
    favorite?: boolean | null
  }> | null
}

export type PartnerEmailActivityFragment = {
  __typename: 'EmailActivity'
  sentAt: string
  user: string
  subject: string
  status?: EmailStatus | null
  invoice?: { __typename: 'Invoice'; id: string; invoiceNumber: string } | null
  customer?: {
    __typename: 'Customer'
    legalName?: string | null
    ein?: string | null
    createdAt: string
    isOnboarded: boolean
    tagIDs?: Array<string> | null
    id: string
    name?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
    partner?: {
      __typename: 'Partner'
      id: string
      paymentsPortalUrl?: string | null
    } | null
  } | null
}

export type EmailTemplateFragment = {
  __typename: 'EmailTemplate'
  id: string
  partnerID: string
  name: string
  subject: string
  section1?: string | null
  section2?: string | null
  section3?: string | null
  type: TemplateType
  favorite?: boolean | null
}

export type PartnerGetPartnerFeeConfigQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerGetPartnerFeeConfigQuery = {
  __typename: 'Query'
  PartnerGetPartnerFeeConfig?: {
    __typename: 'PartnerFeeConfig'
    coverDirectPaymentFees: boolean
    coverFeeConfig?: {
      __typename: 'CoverFeeConfig'
      coverCardMethodFee?: boolean | null
    } | null
  } | null
}

export type PartnerGetCustomPartnerFeeConfigsQueryVariables = Exact<{
  customPartnerFeeConfigsFilter?: InputMaybe<CustomPartnerFeeConfigsFilter>
}>

export type PartnerGetCustomPartnerFeeConfigsQuery = {
  __typename: 'Query'
  PartnerGetCustomPartnerFeeConfigs?: {
    __typename: 'CustomPartnerFeeConfigs'
    customPartnerFeeConfigs?: Array<{
      __typename: 'CustomPartnerFeeConfig'
      paymentOriginService: PaymentAlternativeService
      paymentExecutorType: PaymentExecutorType
      coverFeeConfig?: {
        __typename: 'CoverFeeConfig'
        coverACHMethodFee?: boolean | null
        coverCardMethodFee?: boolean | null
        coverWireMethodFee?: boolean | null
        coverOtherMethodFee?: boolean | null
      } | null
    }> | null
  } | null
}

export type PartnerListCustomerFeeExceptionsQueryVariables = Exact<{
  input?: InputMaybe<PartnerListCustomerFeeExceptionsInput>
}>

export type PartnerListCustomerFeeExceptionsQuery = {
  __typename: 'Query'
  PartnerListCustomerFeeExceptions?: Array<{
    __typename: 'CustomerFeeConfig'
    id: any
    feeType: FeeExceptionType
    customer: { __typename: 'Customer'; id: string; name?: string | null }
  }> | null
}

export type PartnerChangeCustomPartnerFeeConfigMutationVariables = Exact<{
  customPartnerFeeConfig: CustomPartnerFeeConfigUpsertInput
}>

export type PartnerChangeCustomPartnerFeeConfigMutation = {
  __typename: 'Mutation'
  PartnerChangeCustomPartnerFeeConfig?: string | null
}

export type PartnerChangeCustomerFeeConfigMutationVariables = Exact<{
  customerFeeConfig: PartnerChangeCustomerFeeConfigInput
}>

export type PartnerChangeCustomerFeeConfigMutation = {
  __typename: 'Mutation'
  PartnerChangeCustomerFeeConfig?: string | null
}

export type PartnerChangePartnerFeeConfigMutationVariables = Exact<{
  partnerFeeConfig: PartnerFeeConfigUpdateInput
}>

export type PartnerChangePartnerFeeConfigMutation = {
  __typename: 'Mutation'
  PartnerChangePartnerFeeConfig?: string | null
}

export type PartnerChangeBulkCustomerFeeConfigMutationVariables = Exact<{
  customerFeeConfig: PartnerChangeBulkCustomerFeeConfigInput
}>

export type PartnerChangeBulkCustomerFeeConfigMutation = {
  __typename: 'Mutation'
  PartnerChangeBulkCustomerFeeConfig?: string | null
}

export type PartnerCustomerFeeConfigFragment = {
  __typename: 'CustomerFeeConfig'
  id: any
  feeType: FeeExceptionType
  customer: { __typename: 'Customer'; id: string; name?: string | null }
}

export type GetCustomerInsightsGraphsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
  customerID: Scalars['String']['input']
}>

export type GetCustomerInsightsGraphsQuery = {
  __typename: 'Query'
  PartnerGetInvoiceAmountByStatusMonthCustomerInsight?: {
    __typename: 'InvoiceAmountByStatusMonthResponse'
    average: number
    data: Array<{
      __typename: 'InvoiceAmountMonth'
      month: string
      data: Array<{
        __typename: 'InvoiceAmountMonthStatus'
        status: string
        value: number
      }>
    }>
  } | null
  PartnerGetAverageTimeToPayByMonthCustomerInsight?: {
    __typename: 'AverageTimeToPayByMonthResponse'
    average: number
    data: Array<{ __typename: 'DataPoint'; month: string; value: number }>
  } | null
  PartnerGetPaymentVolumeByMonthCustomerInsight?: {
    __typename: 'PaymentVolumeByMonthResponse'
    average: number
    data: Array<{ __typename: 'DataPoint'; month: string; value: number }>
  } | null
  PartnerGetAutomatedPaymentVolumePercentByMonthCustomerInsight?: {
    __typename: 'AutomatedPaymentVolumePercentByMonthResponse'
    average: number
    data: Array<{
      __typename: 'AutomatedPaymentVolumePercentMonth'
      month: string
      percent: number
    }>
  } | null
}

export type GetCustomerInsightsMetricsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
  customerID: Scalars['String']['input']
}>

export type GetCustomerInsightsMetricsQuery = {
  __typename: 'Query'
  PartnerGetPaymentVolumeCustomerInsight?: {
    __typename: 'PaymentVolumeResponse'
    value: number
  } | null
  PartnerGetNumberOfPaymentsCustomerInsight?: {
    __typename: 'NumberOfPaymentsResponse'
    value: number
  } | null
  PartnerGetAverageTimeToPayCustomerInsight?: {
    __typename: 'AverageTimeToPayResponse'
    value: number
  } | null
  PartnerGetAutomatedPaymentsCustomerInsight?: {
    __typename: 'AutomatedPaymentsResponse'
    value: number
  } | null
  PartnerGetInvoiceVolumeCustomerInsight?: {
    __typename: 'InvoiceVolumeResponse'
    value: number
  } | null
  PartnerGetOverdueInvoicesVolumeThirtyDaysCustomerInsight?: {
    __typename: 'OverdueInvoicesVolumeThirtyDaysResponse'
    value: number
  } | null
}

export type GetInsightOverviewMetricsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}>

export type GetInsightOverviewMetricsQuery = {
  __typename: 'Query'
  PartnerGetNumberOfOverdueInvoicesThirtyDaysInsight?: {
    __typename: 'NumberOfOverdueInvoicesThirtyDaysResponse'
    value: number
  } | null
  PartnerGetNumberOfPaymentsInsight?: {
    __typename: 'NumberOfPaymentsResponse'
    value: number
  } | null
  PartnerGetPaymentVolumeInsight?: {
    __typename: 'PaymentVolumeResponse'
    value: number
  } | null
  PartnerGetAverageTimeToPayInsight?: {
    __typename: 'AverageTimeToPayResponse'
    value: number
  } | null
  PartnerGetAutomatedPaymentsInsight?: {
    __typename: 'AutomatedPaymentsResponse'
    value: number
  } | null
  PartnerGetOverdueInvoicesVolumeThirtyDaysInsight?: {
    __typename: 'OverdueInvoicesVolumeThirtyDaysResponse'
    value: number
  } | null
}

export type GetInsightOverviewGraphsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}>

export type GetInsightOverviewGraphsQuery = {
  __typename: 'Query'
  PartnerGetPaymentVolumeByMonthInsight?: {
    __typename: 'PaymentVolumeByMonthResponse'
    average: number
    data: Array<{ __typename: 'DataPoint'; month: string; value: number }>
  } | null
  PartnerGetAverageTimeToPayByMonthInsight?: {
    __typename: 'AverageTimeToPayByMonthResponse'
    average: number
    data: Array<{ __typename: 'DataPoint'; month: string; value: number }>
  } | null
  PartnerGetAutomatedPaymentsByMonthInsight?: {
    __typename: 'AutomatedPaymentsByMonthResponse'
    average: number
    data: Array<{ __typename: 'DataPoint'; month: string; value: number }>
  } | null
  PartnerGetActivationRatesByMonthInsight?: {
    __typename: 'ActivationRatesByMonthResponse'
    average: number
    data: Array<{ __typename: 'DataPoint'; month: string; value: number }>
  } | null
}

export type GetInvoicesInsightsMetricsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}>

export type GetInvoicesInsightsMetricsQuery = {
  __typename: 'Query'
  PartnerGetInvoiceVolumeInsight?: {
    __typename: 'InvoiceVolumeResponse'
    value: number
  } | null
  PartnerGetInvoiceCountInsight?: {
    __typename: 'InvoiceCountResponse'
    value: number
  } | null
  PartnerGetAverageInvoiceAmountInsight?: {
    __typename: 'AverageInvoiceAmountResponse'
    value: number
  } | null
  PartnerGetOverdueInvoicePercentageInsight?: {
    __typename: 'OverdueInvoicePercentageResponse'
    value: number
  } | null
}

export type GetInvoicesInsightsArMetricsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}>

export type GetInvoicesInsightsArMetricsQuery = {
  __typename: 'Query'
  PartnerGetOverdueInvoiceVolumeInsight?: {
    __typename: 'OverdueInvoiceVolumeResponse'
    value: number
  } | null
  PartnerGetOverdueInvoiceCountInsight?: {
    __typename: 'OverdueInvoiceCountResponse'
    value: number
  } | null
  PartnerGetAverageOverdueAmountInsight?: {
    __typename: 'AverageOverdueAmountResponse'
    value: number
  } | null
  PartnerGetAverageDaysOverdueInsight?: {
    __typename: 'AverageDaysOverdueResponse'
    value: number
  } | null
}

export type GetInvoicesInsightsGraphsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}>

export type GetInvoicesInsightsGraphsQuery = {
  __typename: 'Query'
  PartnerGetInvoiceAmountByStatusMonthInsight?: {
    __typename: 'InvoiceAmountByStatusMonthResponse'
    average: number
    data: Array<{
      __typename: 'InvoiceAmountMonth'
      month: string
      data: Array<{
        __typename: 'InvoiceAmountMonthStatus'
        status: string
        value: number
      }>
    }>
  } | null
  PartnerGetInvoiceCountByStatusMonthInsight?: {
    __typename: 'InvoiceCountByStatusMonthResponse'
    average: number
    data: Array<{
      __typename: 'InvoiceCountMonth'
      month: string
      data: Array<{
        __typename: 'InvoiceCountMonthStatus'
        status: string
        count: number
      }>
    }>
  } | null
}

export type GetInvoicesInsightsArGraphsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}>

export type GetInvoicesInsightsArGraphsQuery = {
  __typename: 'Query'
  PartnerGetARAgingBucketsAmountInsight?: {
    __typename: 'ARAgingBucketsAmountResponse'
    data: Array<{
      __typename: 'BucketAmountData'
      bucket: string
      value: number
    }>
  } | null
  PartnerGetARAgingBucketsCountInsight?: {
    __typename: 'ARAgingBucketsCountResponse'
    data: Array<{
      __typename: 'BucketCountData'
      bucket: string
      value: number
    }>
  } | null
}

export type GetPaymentsInsightsMetricsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}>

export type GetPaymentsInsightsMetricsQuery = {
  __typename: 'Query'
  PartnerGetPaymentVolumeInsight?: {
    __typename: 'PaymentVolumeResponse'
    value: number
  } | null
  PartnerGetNumberOfPaymentsInsight?: {
    __typename: 'NumberOfPaymentsResponse'
    value: number
  } | null
  PartnerGetAveragePaymentSizeInsight?: {
    __typename: 'AveragePaymentSizeResponse'
    value: number
  } | null
}

export type GetPaymentsInsightsGraphsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}>

export type GetPaymentsInsightsGraphsQuery = {
  __typename: 'Query'
  PartnerGetPaymentsCountByMethodMonthInsight?: {
    __typename: 'PaymentsCountByMethodMonthResponse'
    average: number
    data: Array<{
      __typename: 'PaymentsCountByMethodMonthData'
      month: string
      method: string
      count: number
    }>
  } | null
  PartnerGetPaymentsVolumeByMethodMonthInsight?: {
    __typename: 'PaymentsVolumeByMethodMonthResponse'
    average: number
    data: Array<{
      __typename: 'PaymentsVolumeByMethodMonthData'
      month: string
      method: string
      volume: number
    }>
  } | null
  PartnerGetActivationRatesByMonthInsight?: {
    __typename: 'ActivationRatesByMonthResponse'
    average: number
    data: Array<{ __typename: 'DataPoint'; month: string; value: number }>
  } | null
  PartnerGetActivationRateInvoiceVolumeByMonthInsight?: {
    __typename: 'ActivationRateInvoiceVolumeByMonthResponse'
    average: number
    data: Array<{
      __typename: 'ActivationRateInvoiceVolumeByMonthData'
      month: string
      value: number
    }>
  } | null
}

export type GetCollectionsInsightsMetricsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}>

export type GetCollectionsInsightsMetricsQuery = {
  __typename: 'Query'
  PartnerGetAverageTimeToPayExternalInsight?: {
    __typename: 'AverageTimeToPayExternalResponse'
    value: number
  } | null
  PartnerGetAverageTimeToPayInsight?: {
    __typename: 'AverageTimeToPayResponse'
    value: number
  } | null
  PartnerGetAverageTimeToPayAutopayInsight?: {
    __typename: 'AverageTimeToPayAutopayResponse'
    value: number
  } | null
}

export type GetCollectionsInsightsGraphsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}>

export type GetCollectionsInsightsGraphsQuery = {
  __typename: 'Query'
  PartnerGetCashFlowDistributionLastThirtyDaysInsight?: {
    __typename: 'CashFlowDistributionLastThirtyDaysReponse'
    data: Array<{
      __typename: 'CashFlowDistributionData'
      date: string
      value: number
      isInternal: boolean
    }>
  } | null
  PartnerGetAverageTimeToPayExternalVsInternalByMonthInsight?: {
    __typename: 'AverageTimeToPayExternalVsInternalByMonthResponse'
    internalAvg: number
    externalAvg: number
    data: Array<{
      __typename: 'AverageTimeToPayExternalVsInternalByMonthData'
      month: string
      average: number
      isInternal: boolean
    }>
  } | null
}

export type GetAutomationsInsightsMetricsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}>

export type GetAutomationsInsightsMetricsQuery = {
  __typename: 'Query'
  PartnerGetAutomatedPaymentsInsight?: {
    __typename: 'AutomatedPaymentsResponse'
    value: number
  } | null
  PartnerGetAutomatedPaymentVolumePercentageInsight?: {
    __typename: 'AutomatedPaymentVolumePercentageResponse'
    value: number
  } | null
  PartnerGetAutomatedTransactionCountInsight?: {
    __typename: 'AutomatedTransactionCountResponse'
    count: number
  } | null
  PartnerGetPaymentVolumeAutomatedInsight?: {
    __typename: 'PaymentVolumeAutomatedResponse'
    value: number
  } | null
}

export type GetAutomationsInsightsGraphsQueryVariables = Exact<{
  dateFrom: Scalars['String']['input']
  dateTo: Scalars['String']['input']
}>

export type GetAutomationsInsightsGraphsQuery = {
  __typename: 'Query'
  PartnerGetAutomatedPaymentsByMonthInsight?: {
    __typename: 'AutomatedPaymentsByMonthResponse'
    average: number
    data: Array<{ __typename: 'DataPoint'; month: string; value: number }>
  } | null
  PartnerGetAutomatedPaymentVolumePercentByMonthInsight?: {
    __typename: 'AutomatedPaymentVolumePercentByMonthResponse'
    average: number
    data: Array<{
      __typename: 'AutomatedPaymentVolumePercentMonth'
      month: string
      percent: number
    }>
  } | null
}

export type GetAutomationsLastMonthInsightsGraphsQueryVariables = Exact<{
  [key: string]: never
}>

export type GetAutomationsLastMonthInsightsGraphsQuery = {
  __typename: 'Query'
  PartnerGetPaymentCountByTriggerLastMonthInsight?: {
    __typename: 'PaymentCountByTriggerLastMonthResponse'
    data: Array<{
      __typename: 'PaymentCountByTrigger'
      trigger: string
      count: number
    }>
  } | null
  PartnerGetPaymentVolumeByTriggerLastMonthInsight?: {
    __typename: 'PaymentVolumeByTriggerLastMonthResponse'
    data: Array<{
      __typename: 'PaymentVolumeByTrigger'
      trigger: string
      volume: number
    }>
  } | null
}

export type BucketCountDataFragment = {
  __typename: 'BucketCountData'
  bucket: string
  value: number
}

export type BucketAmountDataFragment = {
  __typename: 'BucketAmountData'
  bucket: string
  value: number
}

export type DataPointFragment = {
  __typename: 'DataPoint'
  month: string
  value: number
}

export type InvoiceCountMonthFragment = {
  __typename: 'InvoiceCountMonth'
  month: string
  data: Array<{
    __typename: 'InvoiceCountMonthStatus'
    status: string
    count: number
  }>
}

export type InvoiceAmountMonthFragment = {
  __typename: 'InvoiceAmountMonth'
  month: string
  data: Array<{
    __typename: 'InvoiceAmountMonthStatus'
    status: string
    value: number
  }>
}

export type PartnerAutotaskConnectionCreateMutationVariables = Exact<{
  input?: InputMaybe<PartnerAutotaskConnectionCreateInput>
}>

export type PartnerAutotaskConnectionCreateMutation = {
  __typename: 'Mutation'
  PartnerAutotaskConnectionCreate?: {
    __typename: 'AutotaskQueryFilters'
    companyTypes: Array<{
      __typename: 'AutotaskFilter'
      id?: string | null
      name?: string | null
    }>
    companyClassifications: Array<{
      __typename: 'AutotaskFilter'
      id?: string | null
      name?: string | null
    }>
    companyTerritoryIDs: Array<{
      __typename: 'AutotaskFilter'
      id?: string | null
      name?: string | null
    }>
    companyUserDefinedFields: Array<{
      __typename: 'AutotaskUserDefinedField'
      name?: string | null
      type?: string | null
      isPickList?: boolean | null
      picklistValues: Array<{
        __typename: 'AutotaskField'
        id?: string | null
        name?: string | null
      }>
    } | null>
    contactUserDefinedFields: Array<{
      __typename: 'AutotaskUserDefinedField'
      name?: string | null
      type?: string | null
      isPickList?: boolean | null
      picklistValues: Array<{
        __typename: 'AutotaskField'
        id?: string | null
        name?: string | null
      }>
    } | null>
  } | null
}

export type PartnerAutotaskConnectionUpdateMutationVariables = Exact<{
  input?: InputMaybe<PartnerAutotaskConnectionUpdateInput>
}>

export type PartnerAutotaskConnectionUpdateMutation = {
  __typename: 'Mutation'
  PartnerAutotaskConnectionUpdate?: string | null
}

export type PartnerAutotaskGetFiltersQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerAutotaskGetFiltersQuery = {
  __typename: 'Query'
  PartnerAutotaskGetFilters?: {
    __typename: 'AutotaskQueryFilters'
    companyTypes: Array<{
      __typename: 'AutotaskFilter'
      id?: string | null
      name?: string | null
    }>
    companyClassifications: Array<{
      __typename: 'AutotaskFilter'
      id?: string | null
      name?: string | null
    }>
    companyTerritoryIDs: Array<{
      __typename: 'AutotaskFilter'
      id?: string | null
      name?: string | null
    }>
    companyUserDefinedFields: Array<{
      __typename: 'AutotaskUserDefinedField'
      name?: string | null
      type?: string | null
      isPickList?: boolean | null
      picklistValues: Array<{
        __typename: 'AutotaskField'
        id?: string | null
        name?: string | null
      }>
    } | null>
    contactUserDefinedFields: Array<{
      __typename: 'AutotaskUserDefinedField'
      name?: string | null
      type?: string | null
      isPickList?: boolean | null
      picklistValues: Array<{
        __typename: 'AutotaskField'
        id?: string | null
        name?: string | null
      }>
    } | null>
  } | null
}

export type PartnerContractTypeConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ContractTypeOrderBy>
  filter?: InputMaybe<ContractTypeFilter>
}>

export type PartnerContractTypeConnectionQuery = {
  __typename: 'Query'
  PartnerContractTypeConnection: {
    __typename: 'ContractTypeConnection'
    edges?: Array<{
      __typename: 'ContractTypeEdge'
      node?: {
        __typename: 'AutotaskContractType'
        externalID: string
        name: string
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  }
}

export type PartnerAutotaskContractConnectionQueryVariables = Exact<{
  filter?: InputMaybe<AutotaskContractFilter>
}>

export type PartnerAutotaskContractConnectionQuery = {
  __typename: 'Query'
  PartnerAutotaskContractConnection: {
    __typename: 'AutotaskContractConnection'
    contracts?: Array<string> | null
  }
}

export type PartnerConnectWiseConnectionCreateMutationVariables = Exact<{
  input?: InputMaybe<PartnerConnectWiseConnectionCreateInput>
}>

export type PartnerConnectWiseConnectionCreateMutation = {
  __typename: 'Mutation'
  PartnerConnectWiseConnectionCreate?: {
    __typename: 'ConnectWiseQueryFilters'
    invoiceFilters: {
      __typename: 'ConnectWiseFilters'
      createdSince?: string | null
      locations?: Array<{
        __typename: 'ConnectWiseFilterValue'
        id: number
        name: string
      }> | null
      status?: Array<{
        __typename: 'ConnectWiseFilterValue'
        id: number
        name: string
      }> | null
    }
    customerFilters: {
      __typename: 'ConnectWiseFilters'
      status?: Array<{
        __typename: 'ConnectWiseFilterValue'
        id: number
        name: string
      }> | null
      territories?: Array<{
        __typename: 'ConnectWiseFilterValue'
        id: number
        name: string
      }> | null
      types?: Array<{
        __typename: 'ConnectWiseFilterValue'
        id: number
        name: string
      }> | null
    }
  } | null
}

export type PartnerConnectWiseConnectionUpdateMutationVariables = Exact<{
  input?: InputMaybe<ConnectWiseQueryFiltersInput>
}>

export type PartnerConnectWiseConnectionUpdateMutation = {
  __typename: 'Mutation'
  PartnerConnectWiseConnectionUpdate?: string | null
}

export type PartnerConnectWiseGetConnectionQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerConnectWiseGetConnectionQuery = {
  __typename: 'Query'
  PartnerConnectWiseGetConnection?: {
    __typename: 'ConnectWiseConnection'
    partnerID: string
    queryFilters: {
      __typename: 'ConnectWiseQueryFilters'
      invoiceFilters: {
        __typename: 'ConnectWiseFilters'
        createdSince?: string | null
        locations?: Array<{
          __typename: 'ConnectWiseFilterValue'
          id: number
          name: string
        }> | null
        status?: Array<{
          __typename: 'ConnectWiseFilterValue'
          id: number
          name: string
        }> | null
      }
      customerFilters: {
        __typename: 'ConnectWiseFilters'
        status?: Array<{
          __typename: 'ConnectWiseFilterValue'
          id: number
          name: string
        }> | null
        territories?: Array<{
          __typename: 'ConnectWiseFilterValue'
          id: number
          name: string
        }> | null
        types?: Array<{
          __typename: 'ConnectWiseFilterValue'
          id: number
          name: string
        }> | null
      }
    }
  } | null
}

export type PartnerConnectWiseGetFiltersQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerConnectWiseGetFiltersQuery = {
  __typename: 'Query'
  PartnerConnectWiseGetFilters?: {
    __typename: 'ConnectWiseQueryFilters'
    invoiceFilters: {
      __typename: 'ConnectWiseFilters'
      createdSince?: string | null
      locations?: Array<{
        __typename: 'ConnectWiseFilterValue'
        id: number
        name: string
      }> | null
      status?: Array<{
        __typename: 'ConnectWiseFilterValue'
        id: number
        name: string
      }> | null
    }
    customerFilters: {
      __typename: 'ConnectWiseFilters'
      status?: Array<{
        __typename: 'ConnectWiseFilterValue'
        id: number
        name: string
      }> | null
      territories?: Array<{
        __typename: 'ConnectWiseFilterValue'
        id: number
        name: string
      }> | null
      types?: Array<{
        __typename: 'ConnectWiseFilterValue'
        id: number
        name: string
      }> | null
    }
  } | null
}

export type CwQueryFiltersFragment = {
  __typename: 'ConnectWiseQueryFilters'
  invoiceFilters: {
    __typename: 'ConnectWiseFilters'
    createdSince?: string | null
    locations?: Array<{
      __typename: 'ConnectWiseFilterValue'
      id: number
      name: string
    }> | null
    status?: Array<{
      __typename: 'ConnectWiseFilterValue'
      id: number
      name: string
    }> | null
  }
  customerFilters: {
    __typename: 'ConnectWiseFilters'
    status?: Array<{
      __typename: 'ConnectWiseFilterValue'
      id: number
      name: string
    }> | null
    territories?: Array<{
      __typename: 'ConnectWiseFilterValue'
      id: number
      name: string
    }> | null
    types?: Array<{
      __typename: 'ConnectWiseFilterValue'
      id: number
      name: string
    }> | null
  }
}

export type PartnerAgreementTypeConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<AgreementTypeOrderBy>
  filter?: InputMaybe<AgreementTypeFilter>
}>

export type PartnerAgreementTypeConnectionQuery = {
  __typename: 'Query'
  PartnerAgreementTypeConnection: {
    __typename: 'AgreementTypeConnection'
    edges?: Array<{
      __typename: 'AgreementTypeEdge'
      node?: {
        __typename: 'ConnectwiseAgreementType'
        externalID: string
        name: string
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  }
}

export type PartnerConnectWiseBillingTermsConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<CwBillingTermsOrderBy>
  filter?: InputMaybe<CwBillingTermsFilter>
}>

export type PartnerConnectWiseBillingTermsConnectionQuery = {
  __typename: 'Query'
  PartnerConnectWiseBillingTermsConnection?: {
    __typename: 'ConnectWiseBillingTermsConnection'
    edges?: Array<{
      __typename: 'ConnectWiseBillingTermsEdge'
      node?: {
        __typename: 'ConnectwiseBillingTerms'
        externalID: string
        name: string
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerConnectWiseAgreementConnectionQueryVariables = Exact<{
  filter?: InputMaybe<ConnectWiseAgreementFilter>
}>

export type PartnerConnectWiseAgreementConnectionQuery = {
  __typename: 'Query'
  PartnerConnectWiseAgreementConnection: {
    __typename: 'ConnectWiseAgreementConnection'
    agreements?: Array<string> | null
  }
}

export type PartnerDatagateConnectionCreateMutationVariables = Exact<{
  input?: InputMaybe<DatagateConnectionCreateInput>
}>

export type PartnerDatagateConnectionCreateMutation = {
  __typename: 'Mutation'
  PartnerDatagateConnectionCreate?: string | null
}

export type PartnerHaloPsaConnectionCreateMutationVariables = Exact<{
  input?: InputMaybe<PartnerHaloPsaConnectionCreateInput>
}>

export type PartnerHaloPsaConnectionCreateMutation = {
  __typename: 'Mutation'
  PartnerHaloPSAConnectionCreate?: {
    __typename: 'PartnerHaloPSAConnectionCreateReply'
    success: boolean
    errorMessage?: string | null
  } | null
}

export type PartnerContractSubtypeConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<ContractSubtypeOrderBy>
  filter?: InputMaybe<ContractSubtypeFilter>
}>

export type PartnerContractSubtypeConnectionQuery = {
  __typename: 'Query'
  PartnerContractSubtypeConnection: {
    __typename: 'ContractSubtypeConnection'
    edges?: Array<{
      __typename: 'ContractSubtypeEdge'
      node?: {
        __typename: 'HaloPSAContractSubtype'
        externalID: string
        name: string
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  }
}

export type PartnerListIntegrationsQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerListIntegrationsQuery = {
  __typename: 'Query'
  PartnerListIntegrations?: Array<
    | {
        __typename: 'AutotaskIntegration'
        status: ConnectionStatus
        id: string
        partnerID: string
        platformName: string
        createdAt: string
        integrationType: IntegrationType
      }
    | {
        __typename: 'ConnectwiseIntegration'
        status: ConnectionStatus
        id: string
        partnerID: string
        platformName: string
        createdAt: string
        integrationType: IntegrationType
      }
    | {
        __typename: 'DatagateIntegration'
        status: ConnectionStatus
        id: string
        partnerID: string
        platformName: string
        createdAt: string
        integrationType: IntegrationType
      }
    | {
        __typename: 'HaloPSAIntegration'
        status: ConnectionStatus
        id: string
        partnerID: string
        platformName: string
        createdAt: string
        integrationType: IntegrationType
      }
    | {
        __typename: 'QuickbooksIntegration'
        status: ConnectionStatus
        id: string
        partnerID: string
        platformName: string
        createdAt: string
        integrationType: IntegrationType
      }
    | {
        __typename: 'RutterIntegration'
        status: ConnectionStatus
        id: string
        partnerID: string
        platformName: string
        createdAt: string
        integrationType: IntegrationType
      }
    | {
        __typename: 'SuperOpsIntegration'
        status: ConnectionStatus
        id: string
        partnerID: string
        platformName: string
        createdAt: string
        integrationType: IntegrationType
      }
    | null
  > | null
}

export type PartnerIntegrationDisconnectMutationVariables = Exact<{
  input?: InputMaybe<IntegrationDisconnectInput>
}>

export type PartnerIntegrationDisconnectMutation = {
  __typename: 'Mutation'
  PartnerIntegrationDisconnect?: string | null
}

type PartnerIntegration_AutotaskIntegration_Fragment = {
  __typename: 'AutotaskIntegration'
  status: ConnectionStatus
  id: string
  partnerID: string
  platformName: string
  createdAt: string
  integrationType: IntegrationType
}

type PartnerIntegration_ConnectwiseIntegration_Fragment = {
  __typename: 'ConnectwiseIntegration'
  status: ConnectionStatus
  id: string
  partnerID: string
  platformName: string
  createdAt: string
  integrationType: IntegrationType
}

type PartnerIntegration_DatagateIntegration_Fragment = {
  __typename: 'DatagateIntegration'
  status: ConnectionStatus
  id: string
  partnerID: string
  platformName: string
  createdAt: string
  integrationType: IntegrationType
}

type PartnerIntegration_HaloPsaIntegration_Fragment = {
  __typename: 'HaloPSAIntegration'
  status: ConnectionStatus
  id: string
  partnerID: string
  platformName: string
  createdAt: string
  integrationType: IntegrationType
}

type PartnerIntegration_QuickbooksIntegration_Fragment = {
  __typename: 'QuickbooksIntegration'
  status: ConnectionStatus
  id: string
  partnerID: string
  platformName: string
  createdAt: string
  integrationType: IntegrationType
}

type PartnerIntegration_RutterIntegration_Fragment = {
  __typename: 'RutterIntegration'
  status: ConnectionStatus
  id: string
  partnerID: string
  platformName: string
  createdAt: string
  integrationType: IntegrationType
}

type PartnerIntegration_SuperOpsIntegration_Fragment = {
  __typename: 'SuperOpsIntegration'
  status: ConnectionStatus
  id: string
  partnerID: string
  platformName: string
  createdAt: string
  integrationType: IntegrationType
}

export type PartnerIntegrationFragment =
  | PartnerIntegration_AutotaskIntegration_Fragment
  | PartnerIntegration_ConnectwiseIntegration_Fragment
  | PartnerIntegration_DatagateIntegration_Fragment
  | PartnerIntegration_HaloPsaIntegration_Fragment
  | PartnerIntegration_QuickbooksIntegration_Fragment
  | PartnerIntegration_RutterIntegration_Fragment
  | PartnerIntegration_SuperOpsIntegration_Fragment

export type PartnerIntegrationSyncMutationVariables = Exact<{
  input?: InputMaybe<IntegrationSyncInput>
}>

export type PartnerIntegrationSyncMutation = {
  __typename: 'Mutation'
  PartnerIntegrationSync?: {
    __typename: 'IntegrationSyncReply'
    success: boolean
    message: string
  } | null
}

export type PartnerListUnsyncedInvoicesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<UnsyncedInvoicesOrderBy>
  filters?: InputMaybe<UnsyncedInvoicesFilter>
}>

export type PartnerListUnsyncedInvoicesQuery = {
  __typename: 'Query'
  PartnerListUnsyncedInvoices?: {
    __typename: 'UnsyncedInvoices'
    edges?: Array<{
      __typename: 'UnsyncedInvoiceEdge'
      cursor: any
      node: {
        __typename: 'InvoiceRelation'
        id: string
        invoiceNumber: string
        createdAt: string
        dueDate: string
        amount: number
        invoiceID?: string | null
        customer: { __typename: 'Customer'; id: string; name?: string | null }
      }
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      hasPreviousPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerUnsyncedInvoiceFragment = {
  __typename: 'InvoiceRelation'
  id: string
  invoiceNumber: string
  createdAt: string
  dueDate: string
  amount: number
  invoiceID?: string | null
  customer: { __typename: 'Customer'; id: string; name?: string | null }
}

export type PartnerGetUnsyncedInvoiceTotalsQueryVariables = Exact<{
  filters?: InputMaybe<UnsyncedInvoicesFilter>
}>

export type PartnerGetUnsyncedInvoiceTotalsQuery = {
  __typename: 'Query'
  PartnerGetUnsyncedInvoiceTotals?: {
    __typename: 'UnsyncedInvoiceTotals'
    count: number
    amount: number
  } | null
}

export type PartnerAccountingSyncBatchCreateMutationVariables = Exact<{
  input?: InputMaybe<AccountingSyncBatchCreateInput>
}>

export type PartnerAccountingSyncBatchCreateMutation = {
  __typename: 'Mutation'
  PartnerAccountingSyncBatchCreate?: {
    __typename: 'AccountingSyncBatchCreateReply'
    notSyncedInvoiceNumbers?: Array<string> | null
    batch?: { __typename: 'AccountingSyncBatch'; id: string } | null
  } | null
}

export type AccountingSyncBatchFragment = {
  __typename: 'AccountingSyncBatch'
  id: string
  createdAt: string
  externalID: string
  status: AccountingSyncBatchStatus
  platform: PlatformName
  numberOfInvoices: number
}

export type PartnerGetAccountingSyncBatchQueryVariables = Exact<{
  batchID: Scalars['ID']['input']
}>

export type PartnerGetAccountingSyncBatchQuery = {
  __typename: 'Query'
  PartnerGetAccountingSyncBatch?: {
    __typename: 'GetAccountingSyncBatchReply'
    batch: {
      __typename: 'AccountingSyncBatch'
      id: string
      createdAt: string
      externalID: string
      status: AccountingSyncBatchStatus
      platform: PlatformName
      numberOfInvoices: number
    }
    invoiceJobs?: Array<{
      __typename: 'AccountingSyncJob'
      internalEntityID: string
      type: AccountingSyncJobType
      status: AccountingSyncJobStatus
      invoiceData?: {
        __typename: 'AccountingSyncJobInvoiceData'
        invoiceNumber: string
        invoiceDate: string
        dueDate: string
        amount: number
        customerName: string
      } | null
    }> | null
  } | null
}

export type PartnerListAccountingSyncBatchesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<ListAccountingSyncBatchesFilter>
}>

export type PartnerListAccountingSyncBatchesQuery = {
  __typename: 'Query'
  PartnerListAccountingSyncBatches?: {
    __typename: 'ListAccountingSyncBatchesReply'
    edges?: Array<{
      __typename: 'AccountingSyncBatchEdge'
      cursor: any
      node: {
        __typename: 'AccountingSyncBatch'
        id: string
        createdAt: string
        externalID: string
        status: AccountingSyncBatchStatus
        platform: PlatformName
        numberOfInvoices: number
      }
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      hasPreviousPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerListAccountingSyncJobsQueryVariables = Exact<{
  batchID: Scalars['ID']['input']
  parentID: Scalars['ID']['input']
}>

export type PartnerListAccountingSyncJobsQuery = {
  __typename: 'Query'
  PartnerListAccountingSyncJobs?: {
    __typename: 'ListAccountingSyncJobsReply'
    jobs?: Array<{
      __typename: 'AccountingSyncJob'
      status: AccountingSyncJobStatus
      type: AccountingSyncJobType
      invoiceData?: {
        __typename: 'AccountingSyncJobInvoiceData'
        invoiceNumber: string
        invoiceDate: string
        dueDate: string
        amount: number
        customerName: string
      } | null
      customerData?: {
        __typename: 'AccountingSyncJobCustomerData'
        customerName: string
      } | null
      lineItemData?: {
        __typename: 'AccountingSyncJobLineItemData'
        lineItemName: string
      } | null
      billingTermData?: {
        __typename: 'AccountingSyncJobBillingTermData'
        billingTermName: string
      } | null
      paymentData?: {
        __typename: 'AccountingSyncJobPaymentData'
        amount: number
      } | null
    }> | null
  } | null
}

export type PartnerSecondaryIntegrationDeleteMutationVariables = Exact<{
  input: SecondaryIntegrationDeleteInput
}>

export type PartnerSecondaryIntegrationDeleteMutation = {
  __typename: 'Mutation'
  PartnerSecondaryIntegrationDelete?: string | null
}

export type PartnerGetAccountingPreferencesQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerGetAccountingPreferencesQuery = {
  __typename: 'Query'
  PartnerGetAccountingPreferences?: {
    __typename: 'AccountingPreferences'
    pdfFromPrimary: boolean
    pushPaymentsTo: PushPaymentsTo
    contactsFromPrimary: boolean
    archiveZeroedInvoices: boolean
    useIntegrationPDF: boolean
  } | null
}

export type PartnerAccountingPreferencesUpdateMutationVariables = Exact<{
  input?: InputMaybe<AccountingPreferencesUpdateInput>
}>

export type PartnerAccountingPreferencesUpdateMutation = {
  __typename: 'Mutation'
  PartnerAccountingPreferencesUpdate?: {
    __typename: 'AccountingPreferences'
    pdfFromPrimary: boolean
    pushPaymentsTo: PushPaymentsTo
    contactsFromPrimary: boolean
  } | null
}

export type PartnerQuickbooksConnectionUrlQueryVariables = Exact<{
  redirectURI: Scalars['String']['input']
}>

export type PartnerQuickbooksConnectionUrlQuery = {
  __typename: 'Query'
  PartnerQuickbooksConnectionURL?: string | null
}

export type PartnerQuickbooksAccountListQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerQuickbooksAccountListQuery = {
  __typename: 'Query'
  PartnerQuickbooksAccountList?: Array<{
    __typename: 'QuickbooksAccount'
    id: string
    type: string
    name: string
    fullyQualifiedName: string
  } | null> | null
}

export type PartnerQuickbooksAccountRetrieveQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerQuickbooksAccountRetrieveQuery = {
  __typename: 'Query'
  PartnerQuickbooksAccountRetrieve?: {
    __typename: 'QuickbooksAccount'
    id: string
    type: string
    name: string
    fullyQualifiedName: string
  } | null
}

export type PartnerQuickbooksAccountUpdateMutationVariables = Exact<{
  input?: InputMaybe<QuickbooksAccountUpdateInput>
}>

export type PartnerQuickbooksAccountUpdateMutation = {
  __typename: 'Mutation'
  PartnerQuickbooksAccountUpdate?: string | null
}

export type PartnerQuickbooksConnectionCreateMutationVariables = Exact<{
  code: Scalars['String']['input']
  state: Scalars['String']['input']
  realmId: Scalars['String']['input']
  integrationType: IntegrationType
}>

export type PartnerQuickbooksConnectionCreateMutation = {
  __typename: 'Mutation'
  PartnerQuickbooksConnectionCreate?: string | null
}

export type QuickbooksAccountFragment = {
  __typename: 'QuickbooksAccount'
  id: string
  type: string
  name: string
  fullyQualifiedName: string
}

export type PartnerQuickbooksConnectionUpdateMutationVariables = Exact<{
  createDeposits?: InputMaybe<Scalars['Boolean']['input']>
}>

export type PartnerQuickbooksConnectionUpdateMutation = {
  __typename: 'Mutation'
  PartnerQuickbooksConnectionUpdate?: string | null
}

export type PartnerQuickbooksConnectionReadQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerQuickbooksConnectionReadQuery = {
  __typename: 'Query'
  PartnerQuickbooksConnectionRead?: {
    __typename: 'QuickbooksConnection'
    createDeposits: boolean
  } | null
}

export type PartnerRecurringTransactionConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<RecurringTransactionOrderBy>
  filter?: InputMaybe<RecurringTransactionFilter>
}>

export type PartnerRecurringTransactionConnectionQuery = {
  __typename: 'Query'
  PartnerRecurringTransactionConnection: {
    __typename: 'RecurringTransactionConnection'
    edges?: Array<{
      __typename: 'RecurringTransactionEdge'
      node?: {
        __typename: 'QuickbooksRecurringTransaction'
        externalID: string
        name: string
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  }
}

export type PartnerRutterConnectionCreateMutationVariables = Exact<{
  input?: InputMaybe<ConnectionCreateInput>
}>

export type PartnerRutterConnectionCreateMutation = {
  __typename: 'Mutation'
  PartnerRutterConnectionCreate?: {
    __typename: 'RutterConnection'
    platform: string
    status: ConnectionStatus
  } | null
}

export type PartnerRutterAccountListQueryVariables = Exact<{
  input?: InputMaybe<RutterAccountListInput>
}>

export type PartnerRutterAccountListQuery = {
  __typename: 'Query'
  PartnerRutterAccountList?: Array<{
    __typename: 'RutterAccount'
    id: string
    type: string
    name: string
    nominalCode: string
  } | null> | null
}

export type RutterAccountListFragment = {
  __typename: 'RutterAccount'
  id: string
  type: string
  name: string
  nominalCode: string
}

export type PartnerRutterAccountUpsertMutationVariables = Exact<{
  input?: InputMaybe<RutterAccountUpsertInput>
}>

export type PartnerRutterAccountUpsertMutation = {
  __typename: 'Mutation'
  PartnerRutterAccountUpsert?: string | null
}

export type PartnerRutterAccountReadQueryVariables = Exact<{
  platform?: InputMaybe<RutterPlatform>
}>

export type PartnerRutterAccountReadQuery = {
  __typename: 'Query'
  PartnerRutterAccountRead?: {
    __typename: 'RutterSelectedAccounts'
    AccountForDeposits?: { __typename: 'RutterAccount'; id: string } | null
    AccountForPayments?: { __typename: 'RutterAccount'; id: string } | null
    AccountForFunds?: { __typename: 'RutterAccount'; id: string } | null
    AccountForFees?: { __typename: 'RutterAccount'; id: string } | null
  } | null
}

export type PartnerRutterConnectionReadQueryVariables = Exact<{
  platform?: InputMaybe<RutterPlatform>
}>

export type PartnerRutterConnectionReadQuery = {
  __typename: 'Query'
  PartnerRutterConnectionRead?: {
    __typename: 'RutterConnection'
    rutterConnectionID: string
  } | null
}

export type PartnerRutterConnectionUpdateMutationVariables = Exact<{
  input?: InputMaybe<ConnectionUpdateInput>
}>

export type PartnerRutterConnectionUpdateMutation = {
  __typename: 'Mutation'
  PartnerRutterConnectionUpdate?: {
    __typename: 'RutterConnection'
    status: ConnectionStatus
  } | null
}

export type PartnerRutterAccountUnsetMutationVariables = Exact<{
  input?: InputMaybe<RutterAccountUnsetInput>
}>

export type PartnerRutterAccountUnsetMutation = {
  __typename: 'Mutation'
  PartnerRutterAccountUnset?: string | null
}

export type PartnerRutterAccountUpsertManyMutationVariables = Exact<{
  input?: InputMaybe<RutterAccountUpsertManyInput>
}>

export type PartnerRutterAccountUpsertManyMutation = {
  __typename: 'Mutation'
  PartnerRutterAccountUpsertMany?: string | null
}

export type PartnerRutterPaymentTermsConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<RutterPaymentTermsOrderBy>
  filter?: InputMaybe<RutterPaymentTermsFilter>
}>

export type PartnerRutterPaymentTermsConnectionQuery = {
  __typename: 'Query'
  PartnerRutterPaymentTermsConnection?: {
    __typename: 'RutterPaymentTermsConnection'
    edges?: Array<{
      __typename: 'RutterPaymentTermsEdge'
      node?: {
        __typename: 'RutterPaymentTerms'
        externalID: string
        name: string
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerSuperopsConnectionCreateMutationVariables = Exact<{
  input?: InputMaybe<SuperopsConnectionCreateInput>
}>

export type PartnerSuperopsConnectionCreateMutation = {
  __typename: 'Mutation'
  PartnerSuperopsConnectionCreate?: string | null
}

export type PartnerGetInvoiceLedgerMovementsQueryVariables = Exact<{
  invoiceID: Scalars['String']['input']
}>

export type PartnerGetInvoiceLedgerMovementsQuery = {
  __typename: 'Query'
  PartnerGetInvoiceLedgerMovements?: {
    __typename: 'LedgerMovementResult'
    ledgerBalance: number
    movements: Array<{
      __typename: 'MovementEntry'
      movementType: LedgerMovementType
      movements: Array<number>
      balance: number
    }>
  } | null
}

export type PartnerFindInvoiceQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type PartnerFindInvoiceQuery = {
  __typename: 'Query'
  FindInvoice?: {
    __typename: 'Invoice'
    amount: number
    outstandingAmount: number
    createdAt: string
    createdByCustomer: boolean
    dueDate?: string | null
    recurringpayment: boolean
    recurringpaymentID?: string | null
    lastRemindedAt?: string | null
    externalId?: string | null
    externalInvoiceNumber?: string | null
    totalTaxAmount: number
    purchaseOrder?: string | null
    id: string
    invoiceNumber: string
    productName?: string | null
    status: InvoiceStatusEnum
    platformName: string
    totalDiscountAmount: number
    customer?: {
      __typename: 'Customer'
      createdAt: string
      id: string
      name?: string | null
      legalName?: string | null
      isOnboarded: boolean
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      postalCode?: string | null
      state?: string | null
      country?: string | null
    } | null
    partner?: {
      __typename: 'Partner'
      id: string
      name?: string | null
      legalName?: string | null
      isOnboarded: boolean
      adyenOnboardingStatus: AdyenOnboardingStatusStep
      insightsEnabled: boolean
      paymentsPortalEnabled: boolean
      paymentsPortalUrl?: string | null
      paymentsPortalCustomUrl?: string | null
      paymentsPortalUseCustomUrl?: boolean | null
      paymentsPortalDefaultUrl?: string | null
      paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
      city?: string | null
      state?: string | null
      stateCode?: string | null
      country?: string | null
      countryCode?: string | null
      postalCode?: string | null
      streetAddress?: string | null
      subPremise?: string | null
      paymentsPortalCustomization: {
        __typename: 'PartnerPaymentsPortalCustomization'
        color?: string | null
        logoUrl?: string | null
      }
    } | null
    offer?: {
      __typename: 'BNPLOffer'
      id: string
      partnerConfirmed: boolean
      status: BnplStatus
      createdAt: string
      terms: number
      amount: number
      netAmount: number
      lending?: {
        __typename: 'Lending'
        id: string
        amount: number
        netAmount: number
        installments?: Array<{
          __typename: 'Installment'
          id: string
          amount: number
          dueDate: string
          netAmount: number
          status: InstallmentStatus
          payments: Array<{
            __typename: 'Payment'
            id: string
            amount: number
            netAmount: number
            creationDate: string
            currentPaymentMethod?: MethodEnum | null
            dueDate?: string | null
            paymentCompletionForecastDate?: string | null
            originService: PaymentAlternativeService
            executorType: PaymentExecutorType
            paymentFees: Array<{
              __typename: 'PaymentFee'
              forwarded: boolean
              type: FeeType
              amount: number
              name: string
            } | null>
            currentPaymentMethodEntity?:
              | {
                  __typename: 'Account'
                  id: string
                  name?: string | null
                  mask?: string | null
                  type?: string | null
                }
              | {
                  __typename: 'Card'
                  id: string
                  cardNetWork: CardNetwork
                  last4: string
                }
              | null
            customer?: {
              __typename: 'Customer'
              id: string
              name?: string | null
              streetAddress?: string | null
              subPremise?: string | null
              city?: string | null
              postalCode?: string | null
              state?: string | null
              country?: string | null
            } | null
            product:
              | { __typename: 'InstantPayment' }
              | {
                  __typename: 'Invoice'
                  id: string
                  invoiceNumber: string
                  productName?: string | null
                  status: InvoiceStatusEnum
                  amount: number
                  dueDate?: string | null
                  outstandingAmount: number
                  platformName: string
                  totalDiscountAmount: number
                  statuses: Array<{
                    __typename: 'InvoiceStatus'
                    status: InvoiceStatusEnum
                    createdAt: any
                  } | null>
                  payments?: Array<{
                    __typename: 'InvoicePayment'
                    id: string
                    status: PaymentStatusEnum
                    payoutCreationForecastDate?: string | null
                  } | null> | null
                }
              | { __typename: 'Offer' }
              | { __typename: 'Referral' }
              | { __typename: 'ReferralBonus' }
              | { __typename: 'Refund' }
              | {
                  __typename: 'SubscriptionPayment'
                  id: string
                  paymentDate: string
                  amount: number
                  subscriptionStatus: SubscriptionPaymentStatus
                  subscription: {
                    __typename: 'PartnerSubscription'
                    id: string
                    type: string
                    frequency: SubscriptionFrequency
                  }
                }
            transaction?: {
              __typename: 'Transaction'
              failureReason?: string | null
              status: TransactionStatus
            } | null
            statuses: Array<{
              __typename: 'PaymentStatus'
              status?: PaymentStatusEnum | null
              createdAt: string
            } | null>
            refunds?: Array<{
              __typename: 'Refund'
              amount: number
              createdAt: string
              lastStatus: RefundStatusEnum
              status?: Array<{
                __typename: 'RefundStatus'
                id: string
                status: RefundStatusEnum
                createdAt: string
              }> | null
            } | null> | null
            payoutEstimation: {
              __typename: 'PaymentPayoutEstimation'
              estimatedPayoutCreationDate?: string | null
            }
          } | null>
        } | null> | null
      } | null
    } | null
    transferPayments?: Array<{
      __typename: 'Payment'
      id: string
      statuses: Array<{
        __typename: 'PaymentStatus'
        status?: PaymentStatusEnum | null
      } | null>
      transaction?: {
        __typename: 'Transaction'
        failureReason?: string | null
      } | null
    } | null> | null
    lineItems?: Array<{
      __typename: 'LineItem'
      code?: string | null
      category?: string | null
      description?: string | null
      quantity?: number | null
      extendedAmountPerItem?: number | null
    } | null> | null
    statuses: Array<{
      __typename: 'InvoiceStatus'
      status: InvoiceStatusEnum
      createdAt: any
    } | null>
    payments?: Array<{
      __typename: 'InvoicePayment'
      id: string
      status: PaymentStatusEnum
      payoutCreationForecastDate?: string | null
    } | null> | null
  } | null
}

export type PartnerGetInvoicePdfLinkQueryVariables = Exact<{
  invoiceID: Scalars['String']['input']
}>

export type PartnerGetInvoicePdfLinkQuery = {
  __typename: 'Query'
  PartnerGetInvoicePdfLink: {
    __typename: 'InvoicePdfLink'
    url: string
    expiresAt: string
    status: InvoicePdfStatus
  }
}

export type PartnerInvoiceListTotalsQueryVariables = Exact<{
  filters?: InputMaybe<InvoiceFilter>
}>

export type PartnerInvoiceListTotalsQuery = {
  __typename: 'Query'
  PartnerInvoiceListTotals?: {
    __typename: 'InvoiceTotals'
    count: number
    amount: number
    outstandingAmount: number
  } | null
}

export type PartnerInvoiceSearchQueryVariables = Exact<{
  invoiceNumber?: InputMaybe<Scalars['String']['input']>
}>

export type PartnerInvoiceSearchQuery = {
  __typename: 'Query'
  PartnerInvoiceConnection: {
    __typename: 'InvoiceConnection'
    edges?: Array<{
      __typename: 'InvoiceEdge'
      cursor: any
      node?: {
        __typename: 'Invoice'
        id: string
        invoiceNumber: string
        productName?: string | null
      } | null
    } | null> | null
  }
}

export type PartnerInvoiceConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<InvoiceFilter>
  orderBy?: InputMaybe<InvoiceOrderBy>
}>

export type PartnerInvoiceConnectionQuery = {
  __typename: 'Query'
  PartnerInvoiceConnection: {
    __typename: 'InvoiceConnection'
    edges?: Array<{
      __typename: 'InvoiceEdge'
      cursor: any
      node?: {
        __typename: 'Invoice'
        id: string
        amount: number
        outstandingAmount: number
        createdAt: string
        createdByCustomer: boolean
        dueDate?: string | null
        invoiceNumber: string
        lastRemindedAt?: string | null
        productName?: string | null
        status: InvoiceStatusEnum
        recurringpayment: boolean
        externalId?: string | null
        externalInvoiceNumber?: string | null
        autopaidAt?: string | null
        customer?: {
          __typename: 'Customer'
          name?: string | null
          id: string
        } | null
        offer?: {
          __typename: 'BNPLOffer'
          id: string
          partnerConfirmed: boolean
          status: BnplStatus
          createdAt: string
          terms: number
          amount: number
          netAmount: number
          lending?: {
            __typename: 'Lending'
            id: string
            amount: number
            netAmount: number
            installments?: Array<{
              __typename: 'Installment'
              id: string
              amount: number
              dueDate: string
              netAmount: number
              status: InstallmentStatus
              payments: Array<{
                __typename: 'Payment'
                id: string
                amount: number
                netAmount: number
                creationDate: string
                currentPaymentMethod?: MethodEnum | null
                dueDate?: string | null
                paymentCompletionForecastDate?: string | null
                originService: PaymentAlternativeService
                executorType: PaymentExecutorType
                paymentFees: Array<{
                  __typename: 'PaymentFee'
                  forwarded: boolean
                  type: FeeType
                  amount: number
                  name: string
                } | null>
                currentPaymentMethodEntity?:
                  | {
                      __typename: 'Account'
                      id: string
                      name?: string | null
                      mask?: string | null
                      type?: string | null
                    }
                  | {
                      __typename: 'Card'
                      id: string
                      cardNetWork: CardNetwork
                      last4: string
                    }
                  | null
                customer?: {
                  __typename: 'Customer'
                  id: string
                  name?: string | null
                  streetAddress?: string | null
                  subPremise?: string | null
                  city?: string | null
                  postalCode?: string | null
                  state?: string | null
                  country?: string | null
                } | null
                product:
                  | { __typename: 'InstantPayment' }
                  | {
                      __typename: 'Invoice'
                      id: string
                      invoiceNumber: string
                      productName?: string | null
                      status: InvoiceStatusEnum
                      amount: number
                      dueDate?: string | null
                      outstandingAmount: number
                      platformName: string
                      totalDiscountAmount: number
                      statuses: Array<{
                        __typename: 'InvoiceStatus'
                        status: InvoiceStatusEnum
                        createdAt: any
                      } | null>
                      payments?: Array<{
                        __typename: 'InvoicePayment'
                        id: string
                        status: PaymentStatusEnum
                        payoutCreationForecastDate?: string | null
                      } | null> | null
                    }
                  | { __typename: 'Offer' }
                  | { __typename: 'Referral' }
                  | { __typename: 'ReferralBonus' }
                  | { __typename: 'Refund' }
                  | {
                      __typename: 'SubscriptionPayment'
                      id: string
                      paymentDate: string
                      amount: number
                      subscriptionStatus: SubscriptionPaymentStatus
                      subscription: {
                        __typename: 'PartnerSubscription'
                        id: string
                        type: string
                        frequency: SubscriptionFrequency
                      }
                    }
                transaction?: {
                  __typename: 'Transaction'
                  failureReason?: string | null
                  status: TransactionStatus
                } | null
                statuses: Array<{
                  __typename: 'PaymentStatus'
                  status?: PaymentStatusEnum | null
                  createdAt: string
                } | null>
                refunds?: Array<{
                  __typename: 'Refund'
                  amount: number
                  createdAt: string
                  lastStatus: RefundStatusEnum
                  status?: Array<{
                    __typename: 'RefundStatus'
                    id: string
                    status: RefundStatusEnum
                    createdAt: string
                  }> | null
                } | null> | null
                payoutEstimation: {
                  __typename: 'PaymentPayoutEstimation'
                  estimatedPayoutCreationDate?: string | null
                }
              } | null>
            } | null> | null
          } | null
        } | null
        payments?: Array<{
          __typename: 'InvoicePayment'
          id: string
          status: PaymentStatusEnum
          payoutCreationForecastDate?: string | null
        } | null> | null
        transferPayments?: Array<{
          __typename: 'Payment'
          id: string
          statuses: Array<{
            __typename: 'PaymentStatus'
            status?: PaymentStatusEnum | null
          } | null>
          transaction?: {
            __typename: 'Transaction'
            failureReason?: string | null
          } | null
        } | null> | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  }
}

export type PartnerGetInvoicePreferencesQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerGetInvoicePreferencesQuery = {
  __typename: 'Query'
  PartnerGetInvoicePreferences?: {
    __typename: 'InvoicePreferences'
    invoiceNumberField: InvoiceNumberField
  } | null
}

export type PartnerInvoiceArchiveMutationVariables = Exact<{
  archiveInvoiceId: Scalars['ID']['input']
}>

export type PartnerInvoiceArchiveMutation = {
  __typename: 'Mutation'
  PartnerInvoiceArchive?: {
    __typename: 'Invoice'
    id: string
    amount: number
    outstandingAmount: number
    createdAt: string
    createdByCustomer: boolean
    dueDate?: string | null
    invoiceNumber: string
    lastRemindedAt?: string | null
    productName?: string | null
    status: InvoiceStatusEnum
    recurringpayment: boolean
    externalId?: string | null
    externalInvoiceNumber?: string | null
    autopaidAt?: string | null
    customer?: {
      __typename: 'Customer'
      name?: string | null
      id: string
    } | null
    offer?: {
      __typename: 'BNPLOffer'
      id: string
      partnerConfirmed: boolean
      status: BnplStatus
      createdAt: string
      terms: number
      amount: number
      netAmount: number
      lending?: {
        __typename: 'Lending'
        id: string
        amount: number
        netAmount: number
        installments?: Array<{
          __typename: 'Installment'
          id: string
          amount: number
          dueDate: string
          netAmount: number
          status: InstallmentStatus
          payments: Array<{
            __typename: 'Payment'
            id: string
            amount: number
            netAmount: number
            creationDate: string
            currentPaymentMethod?: MethodEnum | null
            dueDate?: string | null
            paymentCompletionForecastDate?: string | null
            originService: PaymentAlternativeService
            executorType: PaymentExecutorType
            paymentFees: Array<{
              __typename: 'PaymentFee'
              forwarded: boolean
              type: FeeType
              amount: number
              name: string
            } | null>
            currentPaymentMethodEntity?:
              | {
                  __typename: 'Account'
                  id: string
                  name?: string | null
                  mask?: string | null
                  type?: string | null
                }
              | {
                  __typename: 'Card'
                  id: string
                  cardNetWork: CardNetwork
                  last4: string
                }
              | null
            customer?: {
              __typename: 'Customer'
              id: string
              name?: string | null
              streetAddress?: string | null
              subPremise?: string | null
              city?: string | null
              postalCode?: string | null
              state?: string | null
              country?: string | null
            } | null
            product:
              | { __typename: 'InstantPayment' }
              | {
                  __typename: 'Invoice'
                  id: string
                  invoiceNumber: string
                  productName?: string | null
                  status: InvoiceStatusEnum
                  amount: number
                  dueDate?: string | null
                  outstandingAmount: number
                  platformName: string
                  totalDiscountAmount: number
                  statuses: Array<{
                    __typename: 'InvoiceStatus'
                    status: InvoiceStatusEnum
                    createdAt: any
                  } | null>
                  payments?: Array<{
                    __typename: 'InvoicePayment'
                    id: string
                    status: PaymentStatusEnum
                    payoutCreationForecastDate?: string | null
                  } | null> | null
                }
              | { __typename: 'Offer' }
              | { __typename: 'Referral' }
              | { __typename: 'ReferralBonus' }
              | { __typename: 'Refund' }
              | {
                  __typename: 'SubscriptionPayment'
                  id: string
                  paymentDate: string
                  amount: number
                  subscriptionStatus: SubscriptionPaymentStatus
                  subscription: {
                    __typename: 'PartnerSubscription'
                    id: string
                    type: string
                    frequency: SubscriptionFrequency
                  }
                }
            transaction?: {
              __typename: 'Transaction'
              failureReason?: string | null
              status: TransactionStatus
            } | null
            statuses: Array<{
              __typename: 'PaymentStatus'
              status?: PaymentStatusEnum | null
              createdAt: string
            } | null>
            refunds?: Array<{
              __typename: 'Refund'
              amount: number
              createdAt: string
              lastStatus: RefundStatusEnum
              status?: Array<{
                __typename: 'RefundStatus'
                id: string
                status: RefundStatusEnum
                createdAt: string
              }> | null
            } | null> | null
            payoutEstimation: {
              __typename: 'PaymentPayoutEstimation'
              estimatedPayoutCreationDate?: string | null
            }
          } | null>
        } | null> | null
      } | null
    } | null
    payments?: Array<{
      __typename: 'InvoicePayment'
      id: string
      status: PaymentStatusEnum
      payoutCreationForecastDate?: string | null
    } | null> | null
    transferPayments?: Array<{
      __typename: 'Payment'
      id: string
      statuses: Array<{
        __typename: 'PaymentStatus'
        status?: PaymentStatusEnum | null
      } | null>
      transaction?: {
        __typename: 'Transaction'
        failureReason?: string | null
      } | null
    } | null> | null
  } | null
}

export type PartnerInvoiceUnarchiveMutationVariables = Exact<{
  archivedInvoiceId: Scalars['ID']['input']
}>

export type PartnerInvoiceUnarchiveMutation = {
  __typename: 'Mutation'
  PartnerInvoiceUnarchive?: {
    __typename: 'Invoice'
    id: string
    amount: number
    outstandingAmount: number
    createdAt: string
    createdByCustomer: boolean
    dueDate?: string | null
    invoiceNumber: string
    lastRemindedAt?: string | null
    productName?: string | null
    status: InvoiceStatusEnum
    recurringpayment: boolean
    externalId?: string | null
    externalInvoiceNumber?: string | null
    autopaidAt?: string | null
    customer?: {
      __typename: 'Customer'
      name?: string | null
      id: string
    } | null
    offer?: {
      __typename: 'BNPLOffer'
      id: string
      partnerConfirmed: boolean
      status: BnplStatus
      createdAt: string
      terms: number
      amount: number
      netAmount: number
      lending?: {
        __typename: 'Lending'
        id: string
        amount: number
        netAmount: number
        installments?: Array<{
          __typename: 'Installment'
          id: string
          amount: number
          dueDate: string
          netAmount: number
          status: InstallmentStatus
          payments: Array<{
            __typename: 'Payment'
            id: string
            amount: number
            netAmount: number
            creationDate: string
            currentPaymentMethod?: MethodEnum | null
            dueDate?: string | null
            paymentCompletionForecastDate?: string | null
            originService: PaymentAlternativeService
            executorType: PaymentExecutorType
            paymentFees: Array<{
              __typename: 'PaymentFee'
              forwarded: boolean
              type: FeeType
              amount: number
              name: string
            } | null>
            currentPaymentMethodEntity?:
              | {
                  __typename: 'Account'
                  id: string
                  name?: string | null
                  mask?: string | null
                  type?: string | null
                }
              | {
                  __typename: 'Card'
                  id: string
                  cardNetWork: CardNetwork
                  last4: string
                }
              | null
            customer?: {
              __typename: 'Customer'
              id: string
              name?: string | null
              streetAddress?: string | null
              subPremise?: string | null
              city?: string | null
              postalCode?: string | null
              state?: string | null
              country?: string | null
            } | null
            product:
              | { __typename: 'InstantPayment' }
              | {
                  __typename: 'Invoice'
                  id: string
                  invoiceNumber: string
                  productName?: string | null
                  status: InvoiceStatusEnum
                  amount: number
                  dueDate?: string | null
                  outstandingAmount: number
                  platformName: string
                  totalDiscountAmount: number
                  statuses: Array<{
                    __typename: 'InvoiceStatus'
                    status: InvoiceStatusEnum
                    createdAt: any
                  } | null>
                  payments?: Array<{
                    __typename: 'InvoicePayment'
                    id: string
                    status: PaymentStatusEnum
                    payoutCreationForecastDate?: string | null
                  } | null> | null
                }
              | { __typename: 'Offer' }
              | { __typename: 'Referral' }
              | { __typename: 'ReferralBonus' }
              | { __typename: 'Refund' }
              | {
                  __typename: 'SubscriptionPayment'
                  id: string
                  paymentDate: string
                  amount: number
                  subscriptionStatus: SubscriptionPaymentStatus
                  subscription: {
                    __typename: 'PartnerSubscription'
                    id: string
                    type: string
                    frequency: SubscriptionFrequency
                  }
                }
            transaction?: {
              __typename: 'Transaction'
              failureReason?: string | null
              status: TransactionStatus
            } | null
            statuses: Array<{
              __typename: 'PaymentStatus'
              status?: PaymentStatusEnum | null
              createdAt: string
            } | null>
            refunds?: Array<{
              __typename: 'Refund'
              amount: number
              createdAt: string
              lastStatus: RefundStatusEnum
              status?: Array<{
                __typename: 'RefundStatus'
                id: string
                status: RefundStatusEnum
                createdAt: string
              }> | null
            } | null> | null
            payoutEstimation: {
              __typename: 'PaymentPayoutEstimation'
              estimatedPayoutCreationDate?: string | null
            }
          } | null>
        } | null> | null
      } | null
    } | null
    payments?: Array<{
      __typename: 'InvoicePayment'
      id: string
      status: PaymentStatusEnum
      payoutCreationForecastDate?: string | null
    } | null> | null
    transferPayments?: Array<{
      __typename: 'Payment'
      id: string
      statuses: Array<{
        __typename: 'PaymentStatus'
        status?: PaymentStatusEnum | null
      } | null>
      transaction?: {
        __typename: 'Transaction'
        failureReason?: string | null
      } | null
    } | null> | null
  } | null
}

export type PartnerInvoiceCreateMutationVariables = Exact<{
  input?: InputMaybe<InvoiceInput>
}>

export type PartnerInvoiceCreateMutation = {
  __typename: 'Mutation'
  PartnerInvoiceCreate?: {
    __typename: 'Invoice'
    id: string
    amount: number
    outstandingAmount: number
    createdAt: string
    createdByCustomer: boolean
    dueDate?: string | null
    invoiceNumber: string
    lastRemindedAt?: string | null
    productName?: string | null
    status: InvoiceStatusEnum
    recurringpayment: boolean
    externalId?: string | null
    externalInvoiceNumber?: string | null
    autopaidAt?: string | null
    customer?: {
      __typename: 'Customer'
      name?: string | null
      id: string
    } | null
    offer?: {
      __typename: 'BNPLOffer'
      id: string
      partnerConfirmed: boolean
      status: BnplStatus
      createdAt: string
      terms: number
      amount: number
      netAmount: number
      lending?: {
        __typename: 'Lending'
        id: string
        amount: number
        netAmount: number
        installments?: Array<{
          __typename: 'Installment'
          id: string
          amount: number
          dueDate: string
          netAmount: number
          status: InstallmentStatus
          payments: Array<{
            __typename: 'Payment'
            id: string
            amount: number
            netAmount: number
            creationDate: string
            currentPaymentMethod?: MethodEnum | null
            dueDate?: string | null
            paymentCompletionForecastDate?: string | null
            originService: PaymentAlternativeService
            executorType: PaymentExecutorType
            paymentFees: Array<{
              __typename: 'PaymentFee'
              forwarded: boolean
              type: FeeType
              amount: number
              name: string
            } | null>
            currentPaymentMethodEntity?:
              | {
                  __typename: 'Account'
                  id: string
                  name?: string | null
                  mask?: string | null
                  type?: string | null
                }
              | {
                  __typename: 'Card'
                  id: string
                  cardNetWork: CardNetwork
                  last4: string
                }
              | null
            customer?: {
              __typename: 'Customer'
              id: string
              name?: string | null
              streetAddress?: string | null
              subPremise?: string | null
              city?: string | null
              postalCode?: string | null
              state?: string | null
              country?: string | null
            } | null
            product:
              | { __typename: 'InstantPayment' }
              | {
                  __typename: 'Invoice'
                  id: string
                  invoiceNumber: string
                  productName?: string | null
                  status: InvoiceStatusEnum
                  amount: number
                  dueDate?: string | null
                  outstandingAmount: number
                  platformName: string
                  totalDiscountAmount: number
                  statuses: Array<{
                    __typename: 'InvoiceStatus'
                    status: InvoiceStatusEnum
                    createdAt: any
                  } | null>
                  payments?: Array<{
                    __typename: 'InvoicePayment'
                    id: string
                    status: PaymentStatusEnum
                    payoutCreationForecastDate?: string | null
                  } | null> | null
                }
              | { __typename: 'Offer' }
              | { __typename: 'Referral' }
              | { __typename: 'ReferralBonus' }
              | { __typename: 'Refund' }
              | {
                  __typename: 'SubscriptionPayment'
                  id: string
                  paymentDate: string
                  amount: number
                  subscriptionStatus: SubscriptionPaymentStatus
                  subscription: {
                    __typename: 'PartnerSubscription'
                    id: string
                    type: string
                    frequency: SubscriptionFrequency
                  }
                }
            transaction?: {
              __typename: 'Transaction'
              failureReason?: string | null
              status: TransactionStatus
            } | null
            statuses: Array<{
              __typename: 'PaymentStatus'
              status?: PaymentStatusEnum | null
              createdAt: string
            } | null>
            refunds?: Array<{
              __typename: 'Refund'
              amount: number
              createdAt: string
              lastStatus: RefundStatusEnum
              status?: Array<{
                __typename: 'RefundStatus'
                id: string
                status: RefundStatusEnum
                createdAt: string
              }> | null
            } | null> | null
            payoutEstimation: {
              __typename: 'PaymentPayoutEstimation'
              estimatedPayoutCreationDate?: string | null
            }
          } | null>
        } | null> | null
      } | null
    } | null
    payments?: Array<{
      __typename: 'InvoicePayment'
      id: string
      status: PaymentStatusEnum
      payoutCreationForecastDate?: string | null
    } | null> | null
    transferPayments?: Array<{
      __typename: 'Payment'
      id: string
      statuses: Array<{
        __typename: 'PaymentStatus'
        status?: PaymentStatusEnum | null
      } | null>
      transaction?: {
        __typename: 'Transaction'
        failureReason?: string | null
      } | null
    } | null> | null
  } | null
}

export type PartnerInvoicePaidUpdateMutationVariables = Exact<{
  input?: InputMaybe<PartnerInvoicePaidUpdateInput>
}>

export type PartnerInvoicePaidUpdateMutation = {
  __typename: 'Mutation'
  PartnerInvoicePaidUpdate?: {
    __typename: 'Invoice'
    id: string
    amount: number
    outstandingAmount: number
    createdAt: string
    createdByCustomer: boolean
    dueDate?: string | null
    invoiceNumber: string
    lastRemindedAt?: string | null
    productName?: string | null
    status: InvoiceStatusEnum
    recurringpayment: boolean
    externalId?: string | null
    externalInvoiceNumber?: string | null
    autopaidAt?: string | null
    customer?: {
      __typename: 'Customer'
      name?: string | null
      id: string
    } | null
    offer?: {
      __typename: 'BNPLOffer'
      id: string
      partnerConfirmed: boolean
      status: BnplStatus
      createdAt: string
      terms: number
      amount: number
      netAmount: number
      lending?: {
        __typename: 'Lending'
        id: string
        amount: number
        netAmount: number
        installments?: Array<{
          __typename: 'Installment'
          id: string
          amount: number
          dueDate: string
          netAmount: number
          status: InstallmentStatus
          payments: Array<{
            __typename: 'Payment'
            id: string
            amount: number
            netAmount: number
            creationDate: string
            currentPaymentMethod?: MethodEnum | null
            dueDate?: string | null
            paymentCompletionForecastDate?: string | null
            originService: PaymentAlternativeService
            executorType: PaymentExecutorType
            paymentFees: Array<{
              __typename: 'PaymentFee'
              forwarded: boolean
              type: FeeType
              amount: number
              name: string
            } | null>
            currentPaymentMethodEntity?:
              | {
                  __typename: 'Account'
                  id: string
                  name?: string | null
                  mask?: string | null
                  type?: string | null
                }
              | {
                  __typename: 'Card'
                  id: string
                  cardNetWork: CardNetwork
                  last4: string
                }
              | null
            customer?: {
              __typename: 'Customer'
              id: string
              name?: string | null
              streetAddress?: string | null
              subPremise?: string | null
              city?: string | null
              postalCode?: string | null
              state?: string | null
              country?: string | null
            } | null
            product:
              | { __typename: 'InstantPayment' }
              | {
                  __typename: 'Invoice'
                  id: string
                  invoiceNumber: string
                  productName?: string | null
                  status: InvoiceStatusEnum
                  amount: number
                  dueDate?: string | null
                  outstandingAmount: number
                  platformName: string
                  totalDiscountAmount: number
                  statuses: Array<{
                    __typename: 'InvoiceStatus'
                    status: InvoiceStatusEnum
                    createdAt: any
                  } | null>
                  payments?: Array<{
                    __typename: 'InvoicePayment'
                    id: string
                    status: PaymentStatusEnum
                    payoutCreationForecastDate?: string | null
                  } | null> | null
                }
              | { __typename: 'Offer' }
              | { __typename: 'Referral' }
              | { __typename: 'ReferralBonus' }
              | { __typename: 'Refund' }
              | {
                  __typename: 'SubscriptionPayment'
                  id: string
                  paymentDate: string
                  amount: number
                  subscriptionStatus: SubscriptionPaymentStatus
                  subscription: {
                    __typename: 'PartnerSubscription'
                    id: string
                    type: string
                    frequency: SubscriptionFrequency
                  }
                }
            transaction?: {
              __typename: 'Transaction'
              failureReason?: string | null
              status: TransactionStatus
            } | null
            statuses: Array<{
              __typename: 'PaymentStatus'
              status?: PaymentStatusEnum | null
              createdAt: string
            } | null>
            refunds?: Array<{
              __typename: 'Refund'
              amount: number
              createdAt: string
              lastStatus: RefundStatusEnum
              status?: Array<{
                __typename: 'RefundStatus'
                id: string
                status: RefundStatusEnum
                createdAt: string
              }> | null
            } | null> | null
            payoutEstimation: {
              __typename: 'PaymentPayoutEstimation'
              estimatedPayoutCreationDate?: string | null
            }
          } | null>
        } | null> | null
      } | null
    } | null
    payments?: Array<{
      __typename: 'InvoicePayment'
      id: string
      status: PaymentStatusEnum
      payoutCreationForecastDate?: string | null
    } | null> | null
    transferPayments?: Array<{
      __typename: 'Payment'
      id: string
      statuses: Array<{
        __typename: 'PaymentStatus'
        status?: PaymentStatusEnum | null
      } | null>
      transaction?: {
        __typename: 'Transaction'
        failureReason?: string | null
      } | null
    } | null> | null
  } | null
}

export type PartnerInvoiceRemindMutationVariables = Exact<{
  invoiceID: Scalars['String']['input']
}>

export type PartnerInvoiceRemindMutation = {
  __typename: 'Mutation'
  PartnerInvoiceRemind?: string | null
}

export type PartnerPayInvoiceMutationVariables = Exact<{
  invoiceID: Scalars['String']['input']
  customerID: Scalars['String']['input']
  paymentDate?: InputMaybe<Scalars['String']['input']>
  paymentMethod: PayInvoicePaymentMethodInput
  amount: Scalars['Float']['input']
  idempotencyKey?: InputMaybe<Scalars['String']['input']>
}>

export type PartnerPayInvoiceMutation = {
  __typename: 'Mutation'
  PartnerPayInvoice?: string | null
}

export type PartnerUpsertInvoicePreferencesMutationVariables = Exact<{
  input?: InputMaybe<UpsertInvoicePreferencesInput>
}>

export type PartnerUpsertInvoicePreferencesMutation = {
  __typename: 'Mutation'
  PartnerUpsertInvoicePreferences?: string | null
}

export type PartnerInvoiceSearchFragment = {
  __typename: 'Invoice'
  id: string
  invoiceNumber: string
  productName?: string | null
}

export type PartnerInvoiceEmailActivityFragment = {
  __typename: 'Invoice'
  id: string
  invoiceNumber: string
}

export type PartnerInvoiceBasicFragment = {
  __typename: 'Invoice'
  id: string
  invoiceNumber: string
  productName?: string | null
  status: InvoiceStatusEnum
  amount: number
  dueDate?: string | null
  outstandingAmount: number
  platformName: string
  totalDiscountAmount: number
  statuses: Array<{
    __typename: 'InvoiceStatus'
    status: InvoiceStatusEnum
    createdAt: any
  } | null>
  payments?: Array<{
    __typename: 'InvoicePayment'
    id: string
    status: PaymentStatusEnum
    payoutCreationForecastDate?: string | null
  } | null> | null
}

export type PartnerInvoiceListingFragment = {
  __typename: 'Invoice'
  id: string
  amount: number
  outstandingAmount: number
  createdAt: string
  createdByCustomer: boolean
  dueDate?: string | null
  invoiceNumber: string
  lastRemindedAt?: string | null
  productName?: string | null
  status: InvoiceStatusEnum
  recurringpayment: boolean
  externalId?: string | null
  externalInvoiceNumber?: string | null
  autopaidAt?: string | null
  customer?: { __typename: 'Customer'; name?: string | null; id: string } | null
  offer?: {
    __typename: 'BNPLOffer'
    id: string
    partnerConfirmed: boolean
    status: BnplStatus
    createdAt: string
    terms: number
    amount: number
    netAmount: number
    lending?: {
      __typename: 'Lending'
      id: string
      amount: number
      netAmount: number
      installments?: Array<{
        __typename: 'Installment'
        id: string
        amount: number
        dueDate: string
        netAmount: number
        status: InstallmentStatus
        payments: Array<{
          __typename: 'Payment'
          id: string
          amount: number
          netAmount: number
          creationDate: string
          currentPaymentMethod?: MethodEnum | null
          dueDate?: string | null
          paymentCompletionForecastDate?: string | null
          originService: PaymentAlternativeService
          executorType: PaymentExecutorType
          paymentFees: Array<{
            __typename: 'PaymentFee'
            forwarded: boolean
            type: FeeType
            amount: number
            name: string
          } | null>
          currentPaymentMethodEntity?:
            | {
                __typename: 'Account'
                id: string
                name?: string | null
                mask?: string | null
                type?: string | null
              }
            | {
                __typename: 'Card'
                id: string
                cardNetWork: CardNetwork
                last4: string
              }
            | null
          customer?: {
            __typename: 'Customer'
            id: string
            name?: string | null
            streetAddress?: string | null
            subPremise?: string | null
            city?: string | null
            postalCode?: string | null
            state?: string | null
            country?: string | null
          } | null
          product:
            | { __typename: 'InstantPayment' }
            | {
                __typename: 'Invoice'
                id: string
                invoiceNumber: string
                productName?: string | null
                status: InvoiceStatusEnum
                amount: number
                dueDate?: string | null
                outstandingAmount: number
                platformName: string
                totalDiscountAmount: number
                statuses: Array<{
                  __typename: 'InvoiceStatus'
                  status: InvoiceStatusEnum
                  createdAt: any
                } | null>
                payments?: Array<{
                  __typename: 'InvoicePayment'
                  id: string
                  status: PaymentStatusEnum
                  payoutCreationForecastDate?: string | null
                } | null> | null
              }
            | { __typename: 'Offer' }
            | { __typename: 'Referral' }
            | { __typename: 'ReferralBonus' }
            | { __typename: 'Refund' }
            | {
                __typename: 'SubscriptionPayment'
                id: string
                paymentDate: string
                amount: number
                subscriptionStatus: SubscriptionPaymentStatus
                subscription: {
                  __typename: 'PartnerSubscription'
                  id: string
                  type: string
                  frequency: SubscriptionFrequency
                }
              }
          transaction?: {
            __typename: 'Transaction'
            failureReason?: string | null
            status: TransactionStatus
          } | null
          statuses: Array<{
            __typename: 'PaymentStatus'
            status?: PaymentStatusEnum | null
            createdAt: string
          } | null>
          refunds?: Array<{
            __typename: 'Refund'
            amount: number
            createdAt: string
            lastStatus: RefundStatusEnum
            status?: Array<{
              __typename: 'RefundStatus'
              id: string
              status: RefundStatusEnum
              createdAt: string
            }> | null
          } | null> | null
          payoutEstimation: {
            __typename: 'PaymentPayoutEstimation'
            estimatedPayoutCreationDate?: string | null
          }
        } | null>
      } | null> | null
    } | null
  } | null
  payments?: Array<{
    __typename: 'InvoicePayment'
    id: string
    status: PaymentStatusEnum
    payoutCreationForecastDate?: string | null
  } | null> | null
  transferPayments?: Array<{
    __typename: 'Payment'
    id: string
    statuses: Array<{
      __typename: 'PaymentStatus'
      status?: PaymentStatusEnum | null
    } | null>
    transaction?: {
      __typename: 'Transaction'
      failureReason?: string | null
    } | null
  } | null> | null
}

export type PartnerInvoiceFragment = {
  __typename: 'Invoice'
  amount: number
  outstandingAmount: number
  createdAt: string
  createdByCustomer: boolean
  dueDate?: string | null
  recurringpayment: boolean
  recurringpaymentID?: string | null
  lastRemindedAt?: string | null
  externalId?: string | null
  externalInvoiceNumber?: string | null
  totalTaxAmount: number
  purchaseOrder?: string | null
  id: string
  invoiceNumber: string
  productName?: string | null
  status: InvoiceStatusEnum
  platformName: string
  totalDiscountAmount: number
  customer?: {
    __typename: 'Customer'
    createdAt: string
    id: string
    name?: string | null
    legalName?: string | null
    isOnboarded: boolean
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
  } | null
  partner?: {
    __typename: 'Partner'
    id: string
    name?: string | null
    legalName?: string | null
    isOnboarded: boolean
    adyenOnboardingStatus: AdyenOnboardingStatusStep
    insightsEnabled: boolean
    paymentsPortalEnabled: boolean
    paymentsPortalUrl?: string | null
    paymentsPortalCustomUrl?: string | null
    paymentsPortalUseCustomUrl?: boolean | null
    paymentsPortalDefaultUrl?: string | null
    paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
    city?: string | null
    state?: string | null
    stateCode?: string | null
    country?: string | null
    countryCode?: string | null
    postalCode?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    paymentsPortalCustomization: {
      __typename: 'PartnerPaymentsPortalCustomization'
      color?: string | null
      logoUrl?: string | null
    }
  } | null
  offer?: {
    __typename: 'BNPLOffer'
    id: string
    partnerConfirmed: boolean
    status: BnplStatus
    createdAt: string
    terms: number
    amount: number
    netAmount: number
    lending?: {
      __typename: 'Lending'
      id: string
      amount: number
      netAmount: number
      installments?: Array<{
        __typename: 'Installment'
        id: string
        amount: number
        dueDate: string
        netAmount: number
        status: InstallmentStatus
        payments: Array<{
          __typename: 'Payment'
          id: string
          amount: number
          netAmount: number
          creationDate: string
          currentPaymentMethod?: MethodEnum | null
          dueDate?: string | null
          paymentCompletionForecastDate?: string | null
          originService: PaymentAlternativeService
          executorType: PaymentExecutorType
          paymentFees: Array<{
            __typename: 'PaymentFee'
            forwarded: boolean
            type: FeeType
            amount: number
            name: string
          } | null>
          currentPaymentMethodEntity?:
            | {
                __typename: 'Account'
                id: string
                name?: string | null
                mask?: string | null
                type?: string | null
              }
            | {
                __typename: 'Card'
                id: string
                cardNetWork: CardNetwork
                last4: string
              }
            | null
          customer?: {
            __typename: 'Customer'
            id: string
            name?: string | null
            streetAddress?: string | null
            subPremise?: string | null
            city?: string | null
            postalCode?: string | null
            state?: string | null
            country?: string | null
          } | null
          product:
            | { __typename: 'InstantPayment' }
            | {
                __typename: 'Invoice'
                id: string
                invoiceNumber: string
                productName?: string | null
                status: InvoiceStatusEnum
                amount: number
                dueDate?: string | null
                outstandingAmount: number
                platformName: string
                totalDiscountAmount: number
                statuses: Array<{
                  __typename: 'InvoiceStatus'
                  status: InvoiceStatusEnum
                  createdAt: any
                } | null>
                payments?: Array<{
                  __typename: 'InvoicePayment'
                  id: string
                  status: PaymentStatusEnum
                  payoutCreationForecastDate?: string | null
                } | null> | null
              }
            | { __typename: 'Offer' }
            | { __typename: 'Referral' }
            | { __typename: 'ReferralBonus' }
            | { __typename: 'Refund' }
            | {
                __typename: 'SubscriptionPayment'
                id: string
                paymentDate: string
                amount: number
                subscriptionStatus: SubscriptionPaymentStatus
                subscription: {
                  __typename: 'PartnerSubscription'
                  id: string
                  type: string
                  frequency: SubscriptionFrequency
                }
              }
          transaction?: {
            __typename: 'Transaction'
            failureReason?: string | null
            status: TransactionStatus
          } | null
          statuses: Array<{
            __typename: 'PaymentStatus'
            status?: PaymentStatusEnum | null
            createdAt: string
          } | null>
          refunds?: Array<{
            __typename: 'Refund'
            amount: number
            createdAt: string
            lastStatus: RefundStatusEnum
            status?: Array<{
              __typename: 'RefundStatus'
              id: string
              status: RefundStatusEnum
              createdAt: string
            }> | null
          } | null> | null
          payoutEstimation: {
            __typename: 'PaymentPayoutEstimation'
            estimatedPayoutCreationDate?: string | null
          }
        } | null>
      } | null> | null
    } | null
  } | null
  transferPayments?: Array<{
    __typename: 'Payment'
    id: string
    statuses: Array<{
      __typename: 'PaymentStatus'
      status?: PaymentStatusEnum | null
    } | null>
    transaction?: {
      __typename: 'Transaction'
      failureReason?: string | null
    } | null
  } | null> | null
  lineItems?: Array<{
    __typename: 'LineItem'
    code?: string | null
    category?: string | null
    description?: string | null
    quantity?: number | null
    extendedAmountPerItem?: number | null
  } | null> | null
  statuses: Array<{
    __typename: 'InvoiceStatus'
    status: InvoiceStatusEnum
    createdAt: any
  } | null>
  payments?: Array<{
    __typename: 'InvoicePayment'
    id: string
    status: PaymentStatusEnum
    payoutCreationForecastDate?: string | null
  } | null> | null
}

export type PartnerInvoiceOfferFragment = {
  __typename: 'BNPLOffer'
  id: string
  partnerConfirmed: boolean
  status: BnplStatus
  createdAt: string
  terms: number
  amount: number
  netAmount: number
  lending?: {
    __typename: 'Lending'
    id: string
    amount: number
    netAmount: number
    installments?: Array<{
      __typename: 'Installment'
      id: string
      amount: number
      dueDate: string
      netAmount: number
      status: InstallmentStatus
      payments: Array<{
        __typename: 'Payment'
        id: string
        amount: number
        netAmount: number
        creationDate: string
        currentPaymentMethod?: MethodEnum | null
        dueDate?: string | null
        paymentCompletionForecastDate?: string | null
        originService: PaymentAlternativeService
        executorType: PaymentExecutorType
        paymentFees: Array<{
          __typename: 'PaymentFee'
          forwarded: boolean
          type: FeeType
          amount: number
          name: string
        } | null>
        currentPaymentMethodEntity?:
          | {
              __typename: 'Account'
              id: string
              name?: string | null
              mask?: string | null
              type?: string | null
            }
          | {
              __typename: 'Card'
              id: string
              cardNetWork: CardNetwork
              last4: string
            }
          | null
        customer?: {
          __typename: 'Customer'
          id: string
          name?: string | null
          streetAddress?: string | null
          subPremise?: string | null
          city?: string | null
          postalCode?: string | null
          state?: string | null
          country?: string | null
        } | null
        product:
          | { __typename: 'InstantPayment' }
          | {
              __typename: 'Invoice'
              id: string
              invoiceNumber: string
              productName?: string | null
              status: InvoiceStatusEnum
              amount: number
              dueDate?: string | null
              outstandingAmount: number
              platformName: string
              totalDiscountAmount: number
              statuses: Array<{
                __typename: 'InvoiceStatus'
                status: InvoiceStatusEnum
                createdAt: any
              } | null>
              payments?: Array<{
                __typename: 'InvoicePayment'
                id: string
                status: PaymentStatusEnum
                payoutCreationForecastDate?: string | null
              } | null> | null
            }
          | { __typename: 'Offer' }
          | { __typename: 'Referral' }
          | { __typename: 'ReferralBonus' }
          | { __typename: 'Refund' }
          | {
              __typename: 'SubscriptionPayment'
              id: string
              paymentDate: string
              amount: number
              subscriptionStatus: SubscriptionPaymentStatus
              subscription: {
                __typename: 'PartnerSubscription'
                id: string
                type: string
                frequency: SubscriptionFrequency
              }
            }
        transaction?: {
          __typename: 'Transaction'
          failureReason?: string | null
          status: TransactionStatus
        } | null
        statuses: Array<{
          __typename: 'PaymentStatus'
          status?: PaymentStatusEnum | null
          createdAt: string
        } | null>
        refunds?: Array<{
          __typename: 'Refund'
          amount: number
          createdAt: string
          lastStatus: RefundStatusEnum
          status?: Array<{
            __typename: 'RefundStatus'
            id: string
            status: RefundStatusEnum
            createdAt: string
          }> | null
        } | null> | null
        payoutEstimation: {
          __typename: 'PaymentPayoutEstimation'
          estimatedPayoutCreationDate?: string | null
        }
      } | null>
    } | null> | null
  } | null
}

export type PartnerUpdateReminderTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input']
  templateID?: InputMaybe<Scalars['ID']['input']>
}>

export type PartnerUpdateReminderTemplateMutation = {
  __typename: 'Mutation'
  PartnerUpdateReminderTemplate?: string | null
}

export type PartnerListInvoiceRemindersQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerListInvoiceRemindersQuery = {
  __typename: 'Query'
  PartnerListInvoiceReminders?: Array<{
    __typename: 'InvoiceReminder'
    id: string
    daysOffset: number
    type: InvoiceReminderType
    createdAt?: string | null
    template?: {
      __typename: 'EmailTemplate'
      id: string
      partnerID: string
      name: string
      subject: string
      section1?: string | null
      section2?: string | null
      section3?: string | null
      type: TemplateType
      favorite?: boolean | null
    } | null
  } | null> | null
}

export type PartnerListInvoiceReminderExcludedCustomersQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerListInvoiceReminderExcludedCustomersQuery = {
  __typename: 'Query'
  PartnerListInvoiceReminderExcludedCustomers?: Array<{
    __typename: 'InvoiceReminderExcludedCustomer'
    id: string
    createdAt: string
    customer: {
      __typename: 'Customer'
      legalName?: string | null
      ein?: string | null
      createdAt: string
      isOnboarded: boolean
      tagIDs?: Array<string> | null
      id: string
      name?: string | null
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      postalCode?: string | null
      state?: string | null
      country?: string | null
      partner?: {
        __typename: 'Partner'
        id: string
        paymentsPortalUrl?: string | null
      } | null
    }
  } | null> | null
}

export type PartnerCreateInvoiceReminderMutationVariables = Exact<{
  daysOffset: Scalars['Int']['input']
  type: InvoiceReminderType
  templateID?: InputMaybe<Scalars['ID']['input']>
}>

export type PartnerCreateInvoiceReminderMutation = {
  __typename: 'Mutation'
  PartnerCreateInvoiceReminder?: {
    __typename: 'InvoiceReminder'
    id: string
    daysOffset: number
    type: InvoiceReminderType
    createdAt?: string | null
    template?: {
      __typename: 'EmailTemplate'
      id: string
      partnerID: string
      name: string
      subject: string
      section1?: string | null
      section2?: string | null
      section3?: string | null
      type: TemplateType
      favorite?: boolean | null
    } | null
  } | null
}

export type PartnerDeleteInvoiceReminderMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerDeleteInvoiceReminderMutation = {
  __typename: 'Mutation'
  PartnerDeleteInvoiceReminder?: string | null
}

export type PartnerCreateInvoiceReminderExcludedCustomerMutationVariables =
  Exact<{
    customerID: Scalars['ID']['input']
  }>

export type PartnerCreateInvoiceReminderExcludedCustomerMutation = {
  __typename: 'Mutation'
  PartnerCreateInvoiceReminderExcludedCustomer?: {
    __typename: 'InvoiceReminderExcludedCustomer'
    id: string
    createdAt: string
    customer: {
      __typename: 'Customer'
      legalName?: string | null
      ein?: string | null
      createdAt: string
      isOnboarded: boolean
      tagIDs?: Array<string> | null
      id: string
      name?: string | null
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      postalCode?: string | null
      state?: string | null
      country?: string | null
      partner?: {
        __typename: 'Partner'
        id: string
        paymentsPortalUrl?: string | null
      } | null
    }
  } | null
}

export type PartnerUpdateInvoiceReminderExcludedCustomerMutationVariables =
  Exact<{
    customerIDs?: InputMaybe<
      Array<Scalars['ID']['input']> | Scalars['ID']['input']
    >
  }>

export type PartnerUpdateInvoiceReminderExcludedCustomerMutation = {
  __typename: 'Mutation'
  PartnerUpdateInvoiceReminderExcludedCustomer?: Array<{
    __typename: 'InvoiceReminderExcludedCustomer'
    id: string
    createdAt: string
    customer: {
      __typename: 'Customer'
      legalName?: string | null
      ein?: string | null
      createdAt: string
      isOnboarded: boolean
      tagIDs?: Array<string> | null
      id: string
      name?: string | null
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      postalCode?: string | null
      state?: string | null
      country?: string | null
      partner?: {
        __typename: 'Partner'
        id: string
        paymentsPortalUrl?: string | null
      } | null
    }
  } | null> | null
}

export type PartnerDeleteInvoiceReminderExcludedCustomerMutationVariables =
  Exact<{
    id: Scalars['ID']['input']
  }>

export type PartnerDeleteInvoiceReminderExcludedCustomerMutation = {
  __typename: 'Mutation'
  PartnerDeleteInvoiceReminderExcludedCustomer?: string | null
}

export type PartnerSendInvoiceReminderPreviewMutationVariables = Exact<{
  input?: InputMaybe<InvoiceReminderPreviewInput>
}>

export type PartnerSendInvoiceReminderPreviewMutation = {
  __typename: 'Mutation'
  PartnerSendInvoiceReminderPreview?: string | null
}

export type PartnerInvoiceReminderFragment = {
  __typename: 'InvoiceReminder'
  id: string
  daysOffset: number
  type: InvoiceReminderType
  createdAt?: string | null
  template?: {
    __typename: 'EmailTemplate'
    id: string
    partnerID: string
    name: string
    subject: string
    section1?: string | null
    section2?: string | null
    section3?: string | null
    type: TemplateType
    favorite?: boolean | null
  } | null
}

export type PartnerInvoiceReminderExcludedCustomerFragment = {
  __typename: 'InvoiceReminderExcludedCustomer'
  id: string
  createdAt: string
  customer: {
    __typename: 'Customer'
    legalName?: string | null
    ein?: string | null
    createdAt: string
    isOnboarded: boolean
    tagIDs?: Array<string> | null
    id: string
    name?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
    partner?: {
      __typename: 'Partner'
      id: string
      paymentsPortalUrl?: string | null
    } | null
  }
}

export type PartnerUpdateSummaryTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input']
  templateID?: InputMaybe<Scalars['ID']['input']>
}>

export type PartnerUpdateSummaryTemplateMutation = {
  __typename: 'Mutation'
  PartnerUpdateSummaryTemplate?: string | null
}

export type PartnerListInvoiceSummariesQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerListInvoiceSummariesQuery = {
  __typename: 'Query'
  PartnerListInvoiceSummaries?: Array<{
    __typename: 'InvoiceSummary'
    id: string
    frequency: InvoiceSummaryFrequency
    customDay?: number | null
    startAt?: string | null
    createdAt?: string | null
    template?: {
      __typename: 'EmailTemplate'
      id: string
      partnerID: string
      name: string
      subject: string
      section1?: string | null
      section2?: string | null
      section3?: string | null
      type: TemplateType
      favorite?: boolean | null
    } | null
  } | null> | null
}

export type PartnerListInvoiceSummaryExcludedCustomersQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerListInvoiceSummaryExcludedCustomersQuery = {
  __typename: 'Query'
  PartnerListInvoiceSummaryExcludedCustomers?: Array<{
    __typename: 'InvoiceSummaryExcludedCustomer'
    id: string
    createdAt: string
    customer: {
      __typename: 'Customer'
      legalName?: string | null
      ein?: string | null
      createdAt: string
      isOnboarded: boolean
      tagIDs?: Array<string> | null
      id: string
      name?: string | null
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      postalCode?: string | null
      state?: string | null
      country?: string | null
      partner?: {
        __typename: 'Partner'
        id: string
        paymentsPortalUrl?: string | null
      } | null
    }
  } | null> | null
}

export type PartnerCreateInvoiceSummaryMutationVariables = Exact<{
  input?: InputMaybe<PartnerCreateInvoiceSummaryInput>
}>

export type PartnerCreateInvoiceSummaryMutation = {
  __typename: 'Mutation'
  PartnerCreateInvoiceSummary?: {
    __typename: 'InvoiceSummary'
    id: string
    frequency: InvoiceSummaryFrequency
    customDay?: number | null
    startAt?: string | null
    createdAt?: string | null
    template?: {
      __typename: 'EmailTemplate'
      id: string
      partnerID: string
      name: string
      subject: string
      section1?: string | null
      section2?: string | null
      section3?: string | null
      type: TemplateType
      favorite?: boolean | null
    } | null
  } | null
}

export type PartnerDeleteInvoiceSummaryMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerDeleteInvoiceSummaryMutation = {
  __typename: 'Mutation'
  PartnerDeleteInvoiceSummary?: string | null
}

export type PartnerCreateInvoiceSummaryExcludedCustomerMutationVariables =
  Exact<{
    customerID: Scalars['ID']['input']
  }>

export type PartnerCreateInvoiceSummaryExcludedCustomerMutation = {
  __typename: 'Mutation'
  PartnerCreateInvoiceSummaryExcludedCustomer?: {
    __typename: 'InvoiceSummaryExcludedCustomer'
    id: string
    createdAt: string
    customer: {
      __typename: 'Customer'
      legalName?: string | null
      ein?: string | null
      createdAt: string
      isOnboarded: boolean
      tagIDs?: Array<string> | null
      id: string
      name?: string | null
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      postalCode?: string | null
      state?: string | null
      country?: string | null
      partner?: {
        __typename: 'Partner'
        id: string
        paymentsPortalUrl?: string | null
      } | null
    }
  } | null
}

export type PartnerUpdateInvoiceSummaryExcludedCustomerMutationVariables =
  Exact<{
    customerIDs?: InputMaybe<
      Array<Scalars['ID']['input']> | Scalars['ID']['input']
    >
  }>

export type PartnerUpdateInvoiceSummaryExcludedCustomerMutation = {
  __typename: 'Mutation'
  PartnerUpdateInvoiceSummaryExcludedCustomer?: Array<{
    __typename: 'InvoiceSummaryExcludedCustomer'
    id: string
    createdAt: string
    customer: {
      __typename: 'Customer'
      legalName?: string | null
      ein?: string | null
      createdAt: string
      isOnboarded: boolean
      tagIDs?: Array<string> | null
      id: string
      name?: string | null
      streetAddress?: string | null
      subPremise?: string | null
      city?: string | null
      postalCode?: string | null
      state?: string | null
      country?: string | null
      partner?: {
        __typename: 'Partner'
        id: string
        paymentsPortalUrl?: string | null
      } | null
    }
  } | null> | null
}

export type PartnerDeleteInvoiceSummaryExcludedCustomerMutationVariables =
  Exact<{
    id: Scalars['ID']['input']
  }>

export type PartnerDeleteInvoiceSummaryExcludedCustomerMutation = {
  __typename: 'Mutation'
  PartnerDeleteInvoiceSummaryExcludedCustomer?: string | null
}

export type PartnerSendInvoiceSummaryPreviewMutationVariables = Exact<{
  input: InvoiceSummaryPreviewInput
}>

export type PartnerSendInvoiceSummaryPreviewMutation = {
  __typename: 'Mutation'
  PartnerSendInvoiceSummaryPreview?: string | null
}

export type PartnerInvoiceSummaryFragment = {
  __typename: 'InvoiceSummary'
  id: string
  frequency: InvoiceSummaryFrequency
  customDay?: number | null
  startAt?: string | null
  createdAt?: string | null
  template?: {
    __typename: 'EmailTemplate'
    id: string
    partnerID: string
    name: string
    subject: string
    section1?: string | null
    section2?: string | null
    section3?: string | null
    type: TemplateType
    favorite?: boolean | null
  } | null
}

export type PartnerInvoiceSummaryExcludedCustomerFragment = {
  __typename: 'InvoiceSummaryExcludedCustomer'
  id: string
  createdAt: string
  customer: {
    __typename: 'Customer'
    legalName?: string | null
    ein?: string | null
    createdAt: string
    isOnboarded: boolean
    tagIDs?: Array<string> | null
    id: string
    name?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
    partner?: {
      __typename: 'Partner'
      id: string
      paymentsPortalUrl?: string | null
    } | null
  }
}

export type PartnerGetNotificationsEnabledQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerGetNotificationsEnabledQuery = {
  __typename: 'Query'
  PartnerGetNotificationsEnabled: {
    __typename: 'NotificationsEnabled'
    id: string
    notificationsEnabled: boolean
  }
}

export type PartnerUpdateNotificationsEnabledMutationVariables = Exact<{
  notificationsEnabled: Scalars['Boolean']['input']
}>

export type PartnerUpdateNotificationsEnabledMutation = {
  __typename: 'Mutation'
  PartnerUpdateNotificationsEnabled: {
    __typename: 'NotificationsEnabled'
    id: string
    notificationsEnabled: boolean
  }
}

export type GetPartnerDocumentsQueryVariables = Exact<{ [key: string]: never }>

export type GetPartnerDocumentsQuery = {
  __typename: 'Query'
  GetPartnerDocuments: Array<{
    __typename: 'CompanyDocument'
    id: string
    partnerID: string
    type: PartnerDocumentType
    filename?: string | null
    createdAt: string
  }>
}

export type PartnerUpdateInformationMutationVariables = Exact<{
  detailsInput?: InputMaybe<PartnerUpdateDetailsInput>
  addressInput?: InputMaybe<PartnerUpdateAddressInput>
}>

export type PartnerUpdateInformationMutation = {
  __typename: 'Mutation'
  PartnerUpdateAddress?: {
    __typename: 'Partner'
    id: string
    city?: string | null
    state?: string | null
    stateCode?: string | null
    country?: string | null
    countryCode?: string | null
    postalCode?: string | null
    streetAddress?: string | null
    subPremise?: string | null
  } | null
  PartnerUpdateDetails?: {
    __typename: 'Partner'
    id: string
    name?: string | null
    legalName?: string | null
    isOnboarded: boolean
    adyenOnboardingStatus: AdyenOnboardingStatusStep
    insightsEnabled: boolean
    ein?: string | null
    companyType?: string | null
    industry?: string | null
    description?: string | null
  } | null
}

export type ActivatePartnerPaymentsPortalMutationVariables = Exact<{
  [key: string]: never
}>

export type ActivatePartnerPaymentsPortalMutation = {
  __typename: 'Mutation'
  ActivatePartnerPaymentsPortal?: {
    __typename: 'Partner'
    id: string
    name?: string | null
    paymentsPortalEnabled: boolean
    paymentsPortalUrl?: string | null
  } | null
}

export type GetCompanyIndividualsQueryVariables = Exact<{
  [key: string]: never
}>

export type GetCompanyIndividualsQuery = {
  __typename: 'Query'
  GetCompanyIndividuals: Array<{
    __typename: 'CompanyIndividual'
    id: string
    partnerID: string
    firstName: string
    lastName: string
    email: string
    phone: string
    dateOfBirth: string
    jobTitle: string
    country: string
    countryCode: string
    streetAddress: string
    subPremise: string
    postalCode: string
    state: string
    stateCode: string
    city: string
    hasSSN: boolean
    owner: boolean
    signatory: boolean
    controllingPerson: boolean
  }>
}

export type CreateCompanyIndividualMutationVariables = Exact<{
  input: CreateCompanyIndividualInput
}>

export type CreateCompanyIndividualMutation = {
  __typename: 'Mutation'
  CreateCompanyIndividual: {
    __typename: 'CompanyIndividual'
    id: string
    partnerID: string
    firstName: string
    lastName: string
    email: string
    phone: string
    dateOfBirth: string
    jobTitle: string
    country: string
    countryCode: string
    streetAddress: string
    subPremise: string
    postalCode: string
    state: string
    stateCode: string
    city: string
    hasSSN: boolean
    owner: boolean
    signatory: boolean
    controllingPerson: boolean
  }
}

export type UpdateCompanyIndividualMutationVariables = Exact<{
  input: UpdateCompanyIndividualInput
}>

export type UpdateCompanyIndividualMutation = {
  __typename: 'Mutation'
  UpdateCompanyIndividual: string
}

export type DeleteCompanyIndividualMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteCompanyIndividualMutation = {
  __typename: 'Mutation'
  DeleteCompanyIndividual: string
}

export type UploadPartnerDocumentMutationVariables = Exact<{
  input: UploadPartnerDocumentInput
}>

export type UploadPartnerDocumentMutation = {
  __typename: 'Mutation'
  UploadPartnerDocument: string
}

export type UpsertSupportPreferencesMutationVariables = Exact<{
  input: UpsertSupportPreferencesInput
}>

export type UpsertSupportPreferencesMutation = {
  __typename: 'Mutation'
  UpsertSupportPreferences?: {
    __typename: 'SupportPreferences'
    partnerID: string
    name: string
    email: string
    phone?: string | null
    firstLine: string
    secondLine?: string | null
  } | null
}

export type GetSupportPreferencesQueryVariables = Exact<{
  [key: string]: never
}>

export type GetSupportPreferencesQuery = {
  __typename: 'Query'
  GetSupportPreferences?: {
    __typename: 'SupportPreferences'
    partnerID: string
    name: string
    email: string
    phone?: string | null
    firstLine: string
    secondLine?: string | null
  } | null
}

export type GetUserPartnersQueryVariables = Exact<{ [key: string]: never }>

export type GetUserPartnersQuery = {
  __typename: 'Query'
  GetUserPartners: Array<{
    __typename: 'Partner'
    id: string
    name?: string | null
    legalName?: string | null
    isOnboarded: boolean
    adyenOnboardingStatus: AdyenOnboardingStatusStep
    insightsEnabled: boolean
  } | null>
}

export type PartnerFinishOnboardingMutationVariables = Exact<{
  [key: string]: never
}>

export type PartnerFinishOnboardingMutation = {
  __typename: 'Mutation'
  PartnerFinishOnboarding?: {
    __typename: 'Partner'
    id: string
    isOnboarded: boolean
  } | null
}

export type PartnerUpdateDetailsMutationVariables = Exact<{
  input?: InputMaybe<PartnerUpdateDetailsInput>
}>

export type PartnerUpdateDetailsMutation = {
  __typename: 'Mutation'
  PartnerUpdateDetails?: {
    __typename: 'Partner'
    id: string
    name?: string | null
    legalName?: string | null
    isOnboarded: boolean
    adyenOnboardingStatus: AdyenOnboardingStatusStep
    insightsEnabled: boolean
    ein?: string | null
    companyType?: string | null
    industry?: string | null
    description?: string | null
  } | null
}

export type PartnerUpdateAddressMutationVariables = Exact<{
  input?: InputMaybe<PartnerUpdateAddressInput>
}>

export type PartnerUpdateAddressMutation = {
  __typename: 'Mutation'
  PartnerUpdateAddress?: {
    __typename: 'Partner'
    id: string
    city?: string | null
    state?: string | null
    stateCode?: string | null
    country?: string | null
    countryCode?: string | null
    postalCode?: string | null
    streetAddress?: string | null
    subPremise?: string | null
  } | null
}

export type PartnerTogglePaymentsPortalCustomInvoicesMutationVariables = Exact<{
  paymentsPortalCustomInvoices: Scalars['Boolean']['input']
}>

export type PartnerTogglePaymentsPortalCustomInvoicesMutation = {
  __typename: 'Mutation'
  PartnerTogglePaymentsPortalCustomInvoices?: {
    __typename: 'Partner'
    paymentsPortalCustomInvoices?: boolean | null
  } | null
}

export type PartnerToggleRequiresMfaMutationVariables = Exact<{
  requiresMFA: Scalars['Boolean']['input']
}>

export type PartnerToggleRequiresMfaMutation = {
  __typename: 'Mutation'
  PartnerToggleRequiresMFA?: {
    __typename: 'Partner'
    id: string
    requiresMFA: boolean
  } | null
}

export type PartnerUpdateNameMutationVariables = Exact<{
  input: UpdatePartnerNameInput
}>

export type PartnerUpdateNameMutation = {
  __typename: 'Mutation'
  PartnerUpdateName?: {
    __typename: 'Partner'
    id: string
    name?: string | null
    legalName?: string | null
    isOnboarded: boolean
    adyenOnboardingStatus: AdyenOnboardingStatusStep
    insightsEnabled: boolean
    ein?: string | null
    companyType?: string | null
    industry?: string | null
    description?: string | null
  } | null
}

export type CompanyIndividualFragment = {
  __typename: 'CompanyIndividual'
  id: string
  partnerID: string
  firstName: string
  lastName: string
  email: string
  phone: string
  dateOfBirth: string
  jobTitle: string
  country: string
  countryCode: string
  streetAddress: string
  subPremise: string
  postalCode: string
  state: string
  stateCode: string
  city: string
  hasSSN: boolean
  owner: boolean
  signatory: boolean
  controllingPerson: boolean
}

export type PartnerBaseFragment = {
  __typename: 'Partner'
  id: string
  name?: string | null
  legalName?: string | null
  isOnboarded: boolean
  adyenOnboardingStatus: AdyenOnboardingStatusStep
  insightsEnabled: boolean
}

export type PartnerDetailsFragment = {
  __typename: 'Partner'
  ein?: string | null
  companyType?: string | null
  industry?: string | null
  description?: string | null
}

export type PartnerConfigFragment = {
  __typename: 'Partner'
  paymentsPortalEnabled: boolean
  paymentsPortalUrl?: string | null
  paymentsPortalCustomUrl?: string | null
  paymentsPortalUseCustomUrl?: boolean | null
  paymentsPortalDefaultUrl?: string | null
  paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
  paymentsPortalCustomization: {
    __typename: 'PartnerPaymentsPortalCustomization'
    color?: string | null
    logoUrl?: string | null
  }
}

export type PartnerAddressDetailsFragment = {
  __typename: 'Partner'
  city?: string | null
  state?: string | null
  stateCode?: string | null
  country?: string | null
  countryCode?: string | null
  postalCode?: string | null
  streetAddress?: string | null
  subPremise?: string | null
}

export type SupportPreferencesFragment = {
  __typename: 'SupportPreferences'
  partnerID: string
  name: string
  email: string
  phone?: string | null
  firstLine: string
  secondLine?: string | null
}

export type PartnerGetPartnerAutopayConfigQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerGetPartnerAutopayConfigQuery = {
  __typename: 'Query'
  PartnerGetPartnerAutopayConfig?: {
    __typename: 'PartnerAutopayConfig'
    id: string
    allowCustomerEdit?: boolean | null
  } | null
}

export type PartnerChangePartnerAutopayConfigMutationVariables = Exact<{
  partnerAutopayConfig: PartnerAutopayConfigUpdateInput
}>

export type PartnerChangePartnerAutopayConfigMutation = {
  __typename: 'Mutation'
  PartnerChangePartnerAutopayConfig?: string | null
}

export type PartnerCancelScheduledPaymentMutationVariables = Exact<{
  paymentID: Scalars['UUID']['input']
}>

export type PartnerCancelScheduledPaymentMutation = {
  __typename: 'Mutation'
  PartnerCancelScheduledPayment?: string | null
}

export type PartnerReschedulePaymentMutationVariables = Exact<{
  paymentID: Scalars['UUID']['input']
  newDueDate: Scalars['Time']['input']
}>

export type PartnerReschedulePaymentMutation = {
  __typename: 'Mutation'
  PartnerReschedulePayment?: string | null
}

export type PartnerPaymentConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  paymentFilter?: InputMaybe<PaymentFilter>
  orderBy?: InputMaybe<PaymentOrder>
}>

export type PartnerPaymentConnectionQuery = {
  __typename: 'Query'
  PartnerPaymentConnection?: {
    __typename: 'PaymentConnection'
    edges?: Array<{
      __typename: 'PaymentEdge'
      node?: {
        __typename: 'Payment'
        id: string
        amount: number
        netAmount: number
        creationDate: string
        currentPaymentMethod?: MethodEnum | null
        dueDate?: string | null
        paymentCompletionForecastDate?: string | null
        originService: PaymentAlternativeService
        executorType: PaymentExecutorType
        paymentFees: Array<{
          __typename: 'PaymentFee'
          forwarded: boolean
          type: FeeType
          amount: number
          name: string
        } | null>
        currentPaymentMethodEntity?:
          | {
              __typename: 'Account'
              id: string
              name?: string | null
              mask?: string | null
              type?: string | null
            }
          | {
              __typename: 'Card'
              id: string
              cardNetWork: CardNetwork
              last4: string
            }
          | null
        customer?: {
          __typename: 'Customer'
          id: string
          name?: string | null
          streetAddress?: string | null
          subPremise?: string | null
          city?: string | null
          postalCode?: string | null
          state?: string | null
          country?: string | null
        } | null
        product:
          | { __typename: 'InstantPayment' }
          | {
              __typename: 'Invoice'
              id: string
              invoiceNumber: string
              productName?: string | null
              status: InvoiceStatusEnum
              amount: number
              dueDate?: string | null
              outstandingAmount: number
              platformName: string
              totalDiscountAmount: number
              statuses: Array<{
                __typename: 'InvoiceStatus'
                status: InvoiceStatusEnum
                createdAt: any
              } | null>
              payments?: Array<{
                __typename: 'InvoicePayment'
                id: string
                status: PaymentStatusEnum
                payoutCreationForecastDate?: string | null
              } | null> | null
            }
          | { __typename: 'Offer' }
          | { __typename: 'Referral' }
          | { __typename: 'ReferralBonus' }
          | { __typename: 'Refund' }
          | {
              __typename: 'SubscriptionPayment'
              id: string
              paymentDate: string
              amount: number
              subscriptionStatus: SubscriptionPaymentStatus
              subscription: {
                __typename: 'PartnerSubscription'
                id: string
                type: string
                frequency: SubscriptionFrequency
              }
            }
        transaction?: {
          __typename: 'Transaction'
          failureReason?: string | null
          status: TransactionStatus
        } | null
        statuses: Array<{
          __typename: 'PaymentStatus'
          status?: PaymentStatusEnum | null
          createdAt: string
        } | null>
        refunds?: Array<{
          __typename: 'Refund'
          amount: number
          createdAt: string
          lastStatus: RefundStatusEnum
          status?: Array<{
            __typename: 'RefundStatus'
            id: string
            status: RefundStatusEnum
            createdAt: string
          }> | null
        } | null> | null
        payoutEstimation: {
          __typename: 'PaymentPayoutEstimation'
          estimatedPayoutCreationDate?: string | null
        }
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      hasPreviousPage: boolean
      startCursor?: any | null
      endCursor?: any | null
    }
  } | null
}

export type PartnerPaymentTotalsQueryVariables = Exact<{
  paymentFilter?: InputMaybe<PaymentFilter>
}>

export type PartnerPaymentTotalsQuery = {
  __typename: 'Query'
  PartnerPaymentTotals?: {
    __typename: 'PaymentTotals'
    count: number
    amount: number
    netAmount: number
  } | null
}

export type PartnerPaymentFragment = {
  __typename: 'Payment'
  id: string
  amount: number
  netAmount: number
  creationDate: string
  currentPaymentMethod?: MethodEnum | null
  dueDate?: string | null
  paymentCompletionForecastDate?: string | null
  originService: PaymentAlternativeService
  executorType: PaymentExecutorType
  paymentFees: Array<{
    __typename: 'PaymentFee'
    forwarded: boolean
    type: FeeType
    amount: number
    name: string
  } | null>
  currentPaymentMethodEntity?:
    | {
        __typename: 'Account'
        id: string
        name?: string | null
        mask?: string | null
        type?: string | null
      }
    | {
        __typename: 'Card'
        id: string
        cardNetWork: CardNetwork
        last4: string
      }
    | null
  customer?: {
    __typename: 'Customer'
    id: string
    name?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
  } | null
  product:
    | { __typename: 'InstantPayment' }
    | {
        __typename: 'Invoice'
        id: string
        invoiceNumber: string
        productName?: string | null
        status: InvoiceStatusEnum
        amount: number
        dueDate?: string | null
        outstandingAmount: number
        platformName: string
        totalDiscountAmount: number
        statuses: Array<{
          __typename: 'InvoiceStatus'
          status: InvoiceStatusEnum
          createdAt: any
        } | null>
        payments?: Array<{
          __typename: 'InvoicePayment'
          id: string
          status: PaymentStatusEnum
          payoutCreationForecastDate?: string | null
        } | null> | null
      }
    | { __typename: 'Offer' }
    | { __typename: 'Referral' }
    | { __typename: 'ReferralBonus' }
    | { __typename: 'Refund' }
    | {
        __typename: 'SubscriptionPayment'
        id: string
        paymentDate: string
        amount: number
        subscriptionStatus: SubscriptionPaymentStatus
        subscription: {
          __typename: 'PartnerSubscription'
          id: string
          type: string
          frequency: SubscriptionFrequency
        }
      }
  transaction?: {
    __typename: 'Transaction'
    failureReason?: string | null
    status: TransactionStatus
  } | null
  statuses: Array<{
    __typename: 'PaymentStatus'
    status?: PaymentStatusEnum | null
    createdAt: string
  } | null>
  refunds?: Array<{
    __typename: 'Refund'
    amount: number
    createdAt: string
    lastStatus: RefundStatusEnum
    status?: Array<{
      __typename: 'RefundStatus'
      id: string
      status: RefundStatusEnum
      createdAt: string
    }> | null
  } | null> | null
  payoutEstimation: {
    __typename: 'PaymentPayoutEstimation'
    estimatedPayoutCreationDate?: string | null
  }
}

export type PartnerGetCustomerPaymentConfigQueryVariables = Exact<{
  customerID: Scalars['ID']['input']
}>

export type PartnerGetCustomerPaymentConfigQuery = {
  __typename: 'Query'
  PartnerGetCustomerPaymentConfig?: {
    __typename: 'PaymentCompanyConfig'
    id?: string | null
    paymentMethod?: MethodEnum | null
    company:
      | { __typename: 'Customer'; id: string; name?: string | null }
      | { __typename: 'Partner' }
    paymentMethodEntity?:
      | {
          __typename: 'Account'
          id: string
          mask?: string | null
          name?: string | null
          type?: string | null
          subtype?: string | null
          hasAchAccountNumber?: boolean | null
          hasAchRoutingNumber?: boolean | null
          hasWireRoutingNumber?: boolean | null
          provider?: string | null
          disconnectedAt?: string | null
          systemDeactivatedAt?: string | null
          companyName?: string | null
          institution?: {
            __typename: 'Institution'
            name?: string | null
            id: string
            logo?: string | null
          } | null
        }
      | {
          __typename: 'Card'
          id: string
          last4: string
          expirationDate: string
          cardNetWork: CardNetwork
          fundingSource: FundingSource
        }
      | null
  } | null
}

export type PartnerGetCustomersPaymentConfigQueryVariables = Exact<{
  customerIDs?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >
}>

export type PartnerGetCustomersPaymentConfigQuery = {
  __typename: 'Query'
  PartnerGetCustomersPaymentConfig?: Array<{
    __typename: 'PaymentCompanyConfig'
    id?: string | null
    paymentMethod?: MethodEnum | null
    company:
      | { __typename: 'Customer'; id: string; name?: string | null }
      | { __typename: 'Partner' }
  } | null> | null
}

export type PartnerGetPaymentConfigQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerGetPaymentConfigQuery = {
  __typename: 'Query'
  PartnerGetPaymentConfig?: {
    __typename: 'PaymentCompanyConfig'
    id?: string | null
    paymentMethod?: MethodEnum | null
    paymentMethodEntity?:
      | {
          __typename: 'Account'
          id: string
          mask?: string | null
          name?: string | null
          institution?: {
            __typename: 'Institution'
            id: string
            logo?: string | null
          } | null
        }
      | {
          __typename: 'Card'
          id: string
          last4: string
          expirationDate: string
          cardNetWork: CardNetwork
        }
      | null
  } | null
}

export type PartnerChangePaymentConfigMutationVariables = Exact<{
  paymentConfig: PaymentCompanyConfigUpdateInput
}>

export type PartnerChangePaymentConfigMutation = {
  __typename: 'Mutation'
  PartnerChangePaymentConfig?: string | null
}

export type PartnerChangeCustomerPaymentConfigMutationVariables = Exact<{
  paymentConfig: PaymentCompanyConfigUpdateInput
  customerID: Scalars['ID']['input']
}>

export type PartnerChangeCustomerPaymentConfigMutation = {
  __typename: 'Mutation'
  PartnerChangeCustomerPaymentConfig?: string | null
}

export type PaymentConfigFragment = {
  __typename: 'PaymentCompanyConfig'
  id?: string | null
  paymentMethod?: MethodEnum | null
  paymentMethodEntity?:
    | {
        __typename: 'Account'
        id: string
        mask?: string | null
        name?: string | null
        institution?: {
          __typename: 'Institution'
          id: string
          logo?: string | null
        } | null
      }
    | {
        __typename: 'Card'
        id: string
        last4: string
        expirationDate: string
        cardNetWork: CardNetwork
      }
    | null
}

export type CustomerPaymentMethodFragment = {
  __typename: 'PaymentCompanyConfig'
  id?: string | null
  paymentMethod?: MethodEnum | null
  company:
    | { __typename: 'Customer'; id: string; name?: string | null }
    | { __typename: 'Partner' }
  paymentMethodEntity?:
    | {
        __typename: 'Account'
        id: string
        mask?: string | null
        name?: string | null
        type?: string | null
        subtype?: string | null
        hasAchAccountNumber?: boolean | null
        hasAchRoutingNumber?: boolean | null
        hasWireRoutingNumber?: boolean | null
        provider?: string | null
        disconnectedAt?: string | null
        systemDeactivatedAt?: string | null
        companyName?: string | null
        institution?: {
          __typename: 'Institution'
          name?: string | null
          id: string
          logo?: string | null
        } | null
      }
    | {
        __typename: 'Card'
        id: string
        last4: string
        expirationDate: string
        cardNetWork: CardNetwork
        fundingSource: FundingSource
      }
    | null
}

export type CustomersPaymentMethodFragment = {
  __typename: 'PaymentCompanyConfig'
  id?: string | null
  paymentMethod?: MethodEnum | null
  company:
    | { __typename: 'Customer'; id: string; name?: string | null }
    | { __typename: 'Partner' }
}

export type GetLogoUploadUrlQueryVariables = Exact<{ [key: string]: never }>

export type GetLogoUploadUrlQuery = {
  __typename: 'Query'
  PartnerLogoUploadURL?: {
    __typename: 'PartnerLogoUploadUrl'
    uploadURL: string
    uploadCDNURL: string
    uploadURLExpirationUTC: string
  } | null
}

export type PartnerUpdatePaymentsPortalMethodsMutationVariables = Exact<{
  methods: Array<PartnerPaymentsPortalMethod> | PartnerPaymentsPortalMethod
}>

export type PartnerUpdatePaymentsPortalMethodsMutation = {
  __typename: 'Mutation'
  PartnerUpdatePaymentsPortalMethods?: {
    __typename: 'Partner'
    id: string
    paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
  } | null
}

export type PartnerUpdatePaymentsPortalCustomizationMutationVariables = Exact<{
  input?: InputMaybe<PartnerPaymentsPortalCustomizationInput>
}>

export type PartnerUpdatePaymentsPortalCustomizationMutation = {
  __typename: 'Mutation'
  PartnerUpdatePaymentsPortalCustomization?: {
    __typename: 'Partner'
    id: string
    paymentsPortalCustomization: {
      __typename: 'PartnerPaymentsPortalCustomization'
      color?: string | null
      logoUrl?: string | null
    }
  } | null
}

export type StagingEnablePartnerPaymentsPortalMutationVariables = Exact<{
  url: Scalars['String']['input']
}>

export type StagingEnablePartnerPaymentsPortalMutation = {
  __typename: 'Mutation'
  StagingEnablePartnerPaymentsPortal?: {
    __typename: 'Partner'
    id: string
    name?: string | null
    paymentsPortalEnabled: boolean
    paymentsPortalUrl?: string | null
  } | null
}

export type PartnerPayoutConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  payoutFilter?: InputMaybe<PayoutFilter>
  orderBy?: InputMaybe<PayoutOrder>
}>

export type PartnerPayoutConnectionQuery = {
  __typename: 'Query'
  PartnerPayoutConnection?: {
    __typename: 'PayoutConnection'
    edges?: Array<{
      __typename: 'PayoutEdge'
      cursor: any
      node?: {
        __typename: 'Payout'
        id: string
        amount: number
        netAmount: number
        publicNumber: string
        creationDate: string
        payoutCompletionForecastDate?: string | null
        fees: Array<{
          __typename: 'PayoutFee'
          forwarded: boolean
          type: FeeType
          amount: number
          name: string
        } | null>
        customer?: {
          __typename: 'Customer'
          id: string
          name?: string | null
          streetAddress?: string | null
          subPremise?: string | null
          city?: string | null
          postalCode?: string | null
          state?: string | null
          country?: string | null
        } | null
        product:
          | { __typename: 'InstantPayment' }
          | {
              __typename: 'Invoice'
              id: string
              invoiceNumber: string
              productName?: string | null
              status: InvoiceStatusEnum
              amount: number
              dueDate?: string | null
              outstandingAmount: number
              platformName: string
              totalDiscountAmount: number
              statuses: Array<{
                __typename: 'InvoiceStatus'
                status: InvoiceStatusEnum
                createdAt: any
              } | null>
              payments?: Array<{
                __typename: 'InvoicePayment'
                id: string
                status: PaymentStatusEnum
                payoutCreationForecastDate?: string | null
              } | null> | null
            }
          | { __typename: 'Offer' }
          | { __typename: 'Referral' }
          | { __typename: 'ReferralBonus' }
          | { __typename: 'Refund' }
          | { __typename: 'SubscriptionPayment' }
        statuses: Array<{
          __typename: 'PayoutStatus'
          status?: PayoutStatusEnum | null
          createdAt: string
        } | null>
        transactions: Array<{
          __typename: 'Transaction'
          failureReason?: string | null
          transactionMethod: TransactionMethod
          status: TransactionStatus
        } | null>
        account?: {
          __typename: 'Account'
          name?: string | null
          mask?: string | null
          institution?: {
            __typename: 'Institution'
            name?: string | null
          } | null
        } | null
        payoutBreakdownTotals?: Array<{
          __typename: 'PayoutBreakdownTotals'
          productType: BreakdownProductType
          productTypeCount: number
          sumFees: number
          sumGrossAmount: number
          feesGreaterThanZeroCount: number
        } | null> | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerPayoutTotalsQueryVariables = Exact<{
  payoutFilter?: InputMaybe<PayoutFilter>
}>

export type PartnerPayoutTotalsQuery = {
  __typename: 'Query'
  PartnerPayoutTotals?: {
    __typename: 'PayoutTotals'
    count: number
    amount: number
  } | null
}

export type PartnerPayoutDetailsQueryVariables = Exact<{
  payoutID: Scalars['ID']['input']
}>

export type PartnerPayoutDetailsQuery = {
  __typename: 'Query'
  PartnerPayoutDetails?: {
    __typename: 'PayoutDetails'
    id: string
    amount: number
    netAmount: number
    publicNumber: string
    payoutType: PayoutType
    creationDate: string
    payoutCompletionForecastDate?: string | null
    statuses: Array<{
      __typename: 'PayoutStatus'
      status?: PayoutStatusEnum | null
      createdAt: string
    } | null>
    payoutBreakdownTotals?: Array<{
      __typename: 'PayoutBreakdownTotals'
      productType: BreakdownProductType
      productTypeCount: number
      sumFees: number
      sumGrossAmount: number
      feesGreaterThanZeroCount: number
    } | null> | null
    product:
      | { __typename: 'InstantPayment' }
      | {
          __typename: 'Invoice'
          id: string
          invoiceNumber: string
          productName?: string | null
          status: InvoiceStatusEnum
          amount: number
          dueDate?: string | null
          outstandingAmount: number
          platformName: string
          totalDiscountAmount: number
          statuses: Array<{
            __typename: 'InvoiceStatus'
            status: InvoiceStatusEnum
            createdAt: any
          } | null>
          payments?: Array<{
            __typename: 'InvoicePayment'
            id: string
            status: PaymentStatusEnum
            payoutCreationForecastDate?: string | null
          } | null> | null
        }
      | { __typename: 'Offer' }
      | { __typename: 'Referral' }
      | { __typename: 'ReferralBonus' }
      | { __typename: 'Refund' }
      | { __typename: 'SubscriptionPayment' }
    account?: {
      __typename: 'Account'
      name?: string | null
      mask?: string | null
      institution?: { __typename: 'Institution'; name?: string | null } | null
    } | null
    transactions: Array<{
      __typename: 'Transaction'
      failureReason?: string | null
      transactionMethod: TransactionMethod
      status: TransactionStatus
    } | null>
    fees: Array<{
      __typename: 'PayoutFee'
      name: string
      amount: number
    } | null>
  } | null
}

export type PayoutBreakdownTotalsFragment = {
  __typename: 'PayoutBreakdownTotals'
  productType: BreakdownProductType
  productTypeCount: number
  sumFees: number
  sumGrossAmount: number
  feesGreaterThanZeroCount: number
}

export type PartnerPayoutDetailsFragment = {
  __typename: 'PayoutDetails'
  id: string
  amount: number
  netAmount: number
  publicNumber: string
  payoutType: PayoutType
  creationDate: string
  payoutCompletionForecastDate?: string | null
  statuses: Array<{
    __typename: 'PayoutStatus'
    status?: PayoutStatusEnum | null
    createdAt: string
  } | null>
  payoutBreakdownTotals?: Array<{
    __typename: 'PayoutBreakdownTotals'
    productType: BreakdownProductType
    productTypeCount: number
    sumFees: number
    sumGrossAmount: number
    feesGreaterThanZeroCount: number
  } | null> | null
  product:
    | { __typename: 'InstantPayment' }
    | {
        __typename: 'Invoice'
        id: string
        invoiceNumber: string
        productName?: string | null
        status: InvoiceStatusEnum
        amount: number
        dueDate?: string | null
        outstandingAmount: number
        platformName: string
        totalDiscountAmount: number
        statuses: Array<{
          __typename: 'InvoiceStatus'
          status: InvoiceStatusEnum
          createdAt: any
        } | null>
        payments?: Array<{
          __typename: 'InvoicePayment'
          id: string
          status: PaymentStatusEnum
          payoutCreationForecastDate?: string | null
        } | null> | null
      }
    | { __typename: 'Offer' }
    | { __typename: 'Referral' }
    | { __typename: 'ReferralBonus' }
    | { __typename: 'Refund' }
    | { __typename: 'SubscriptionPayment' }
  account?: {
    __typename: 'Account'
    name?: string | null
    mask?: string | null
    institution?: { __typename: 'Institution'; name?: string | null } | null
  } | null
  transactions: Array<{
    __typename: 'Transaction'
    failureReason?: string | null
    transactionMethod: TransactionMethod
    status: TransactionStatus
  } | null>
  fees: Array<{ __typename: 'PayoutFee'; name: string; amount: number } | null>
}

export type TransactionFragment = {
  __typename: 'Transaction'
  failureReason?: string | null
  transactionMethod: TransactionMethod
  status: TransactionStatus
}

export type PartnerPayoutFragment = {
  __typename: 'Payout'
  id: string
  amount: number
  netAmount: number
  publicNumber: string
  creationDate: string
  payoutCompletionForecastDate?: string | null
  fees: Array<{
    __typename: 'PayoutFee'
    forwarded: boolean
    type: FeeType
    amount: number
    name: string
  } | null>
  customer?: {
    __typename: 'Customer'
    id: string
    name?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
  } | null
  product:
    | { __typename: 'InstantPayment' }
    | {
        __typename: 'Invoice'
        id: string
        invoiceNumber: string
        productName?: string | null
        status: InvoiceStatusEnum
        amount: number
        dueDate?: string | null
        outstandingAmount: number
        platformName: string
        totalDiscountAmount: number
        statuses: Array<{
          __typename: 'InvoiceStatus'
          status: InvoiceStatusEnum
          createdAt: any
        } | null>
        payments?: Array<{
          __typename: 'InvoicePayment'
          id: string
          status: PaymentStatusEnum
          payoutCreationForecastDate?: string | null
        } | null> | null
      }
    | { __typename: 'Offer' }
    | { __typename: 'Referral' }
    | { __typename: 'ReferralBonus' }
    | { __typename: 'Refund' }
    | { __typename: 'SubscriptionPayment' }
  statuses: Array<{
    __typename: 'PayoutStatus'
    status?: PayoutStatusEnum | null
    createdAt: string
  } | null>
  transactions: Array<{
    __typename: 'Transaction'
    failureReason?: string | null
    transactionMethod: TransactionMethod
    status: TransactionStatus
  } | null>
  account?: {
    __typename: 'Account'
    name?: string | null
    mask?: string | null
    institution?: { __typename: 'Institution'; name?: string | null } | null
  } | null
  payoutBreakdownTotals?: Array<{
    __typename: 'PayoutBreakdownTotals'
    productType: BreakdownProductType
    productTypeCount: number
    sumFees: number
    sumGrossAmount: number
    feesGreaterThanZeroCount: number
  } | null> | null
}

export type PartnerBreakdownListItemConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  breakdownFilter?: InputMaybe<BreakdownFilter>
}>

export type PartnerBreakdownListItemConnectionQuery = {
  __typename: 'Query'
  PartnerPayoutBreakdownListItemConnection?: {
    __typename: 'BreakdownListItemConnection'
    edges?: Array<{
      __typename: 'BreakdownListItemEdge'
      cursor: any
      node?: {
        __typename: 'BreakdownListItem'
        id: string
        createdAt: any
        transactionDate?: any | null
        transactionType: BreakdownProductType
        fee: number
        grossAmount: number
        companyType: CompanyType
        transaction?: { __typename: 'Transaction'; id: string } | null
        product?:
          | { __typename: 'InstantPayment' }
          | {
              __typename: 'Invoice'
              id: string
              invoiceNumber: string
              productName?: string | null
              status: InvoiceStatusEnum
              amount: number
              dueDate?: string | null
              outstandingAmount: number
              statuses: Array<{
                __typename: 'InvoiceStatus'
                status: InvoiceStatusEnum
                createdAt: any
              } | null>
              customer?: {
                __typename: 'Customer'
                id: string
                name?: string | null
              } | null
              payments?: Array<{
                __typename: 'InvoicePayment'
                payoutCreationForecastDate?: string | null
              } | null> | null
            }
          | { __typename: 'Offer' }
          | {
              __typename: 'Referral'
              id: string
              referralDate?: string | null
              referredPartner?: {
                __typename: 'Partner'
                id: string
                name?: string | null
              } | null
            }
          | {
              __typename: 'ReferralBonus'
              id: string
              description: string
              referralPayoutID: string
              amount: number
            }
          | { __typename: 'Refund' }
          | { __typename: 'SubscriptionPayment' }
          | null
        customer?: {
          __typename: 'Customer'
          id: string
          name?: string | null
          streetAddress?: string | null
          subPremise?: string | null
          city?: string | null
          postalCode?: string | null
          state?: string | null
          country?: string | null
        } | null
        partner?: {
          __typename: 'Partner'
          id: string
          name?: string | null
        } | null
        paymentMethod?:
          | { __typename: 'Account'; id: string; name?: string | null }
          | { __typename: 'Card'; id: string; cardNetWork: CardNetwork }
          | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerBreakdownListItemFragment = {
  __typename: 'BreakdownListItem'
  id: string
  createdAt: any
  transactionDate?: any | null
  transactionType: BreakdownProductType
  fee: number
  grossAmount: number
  companyType: CompanyType
  transaction?: { __typename: 'Transaction'; id: string } | null
  product?:
    | { __typename: 'InstantPayment' }
    | {
        __typename: 'Invoice'
        id: string
        invoiceNumber: string
        productName?: string | null
        status: InvoiceStatusEnum
        amount: number
        dueDate?: string | null
        outstandingAmount: number
        statuses: Array<{
          __typename: 'InvoiceStatus'
          status: InvoiceStatusEnum
          createdAt: any
        } | null>
        customer?: {
          __typename: 'Customer'
          id: string
          name?: string | null
        } | null
        payments?: Array<{
          __typename: 'InvoicePayment'
          payoutCreationForecastDate?: string | null
        } | null> | null
      }
    | { __typename: 'Offer' }
    | {
        __typename: 'Referral'
        id: string
        referralDate?: string | null
        referredPartner?: {
          __typename: 'Partner'
          id: string
          name?: string | null
        } | null
      }
    | {
        __typename: 'ReferralBonus'
        id: string
        description: string
        referralPayoutID: string
        amount: number
      }
    | { __typename: 'Refund' }
    | { __typename: 'SubscriptionPayment' }
    | null
  customer?: {
    __typename: 'Customer'
    id: string
    name?: string | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    country?: string | null
  } | null
  partner?: { __typename: 'Partner'; id: string; name?: string | null } | null
  paymentMethod?:
    | { __typename: 'Account'; id: string; name?: string | null }
    | { __typename: 'Card'; id: string; cardNetWork: CardNetwork }
    | null
}

export type GetPayoutConfigQueryVariables = Exact<{ [key: string]: never }>

export type GetPayoutConfigQuery = {
  __typename: 'Query'
  PartnerGetPayoutConfig?: {
    __typename: 'PayoutCompanyConfig'
    id: string
    defaultBankingAccount?: { __typename: 'Account'; id: string } | null
  } | null
}

export type GetReferralPayoutConfigQueryVariables = Exact<{
  [key: string]: never
}>

export type GetReferralPayoutConfigQuery = {
  __typename: 'Query'
  PartnerGetPayoutConfig?: {
    __typename: 'PayoutCompanyConfig'
    id: string
    referralBankingAccount?: { __typename: 'Account'; id: string } | null
    defaultBankingAccount?: { __typename: 'Account'; id: string } | null
  } | null
}

export type GetPayoutTimingConfigQueryVariables = Exact<{
  [key: string]: never
}>

export type GetPayoutTimingConfigQuery = {
  __typename: 'Query'
  PartnerGetPayoutTimingCompanyConfig?: {
    __typename: 'CompanyPayoutTimingConfigs'
    activeConfig?: {
      __typename: 'PayoutTimingCompanyConfig'
      canCompanyChange: boolean
      effectiveAt: string
      activatedAt?: string | null
      payoutTimingPlanID: string
      businessDaysToHold: number
      payoutTimingFee?: {
        __typename: 'PayoutTimingFee'
        fixedFee: number
        percentageFee: number
        capFee: number
      } | null
    } | null
    upcomingConfig?: {
      __typename: 'PayoutTimingCompanyConfig'
      canCompanyChange: boolean
      effectiveAt: string
      activatedAt?: string | null
      payoutTimingPlanID: string
      businessDaysToHold: number
      payoutTimingFee?: {
        __typename: 'PayoutTimingFee'
        fixedFee: number
        percentageFee: number
        capFee: number
      } | null
    } | null
  } | null
  PartnerGetPayoutTimingPlans?: Array<{
    __typename: 'PayoutTimingPlan'
    id: string
    businessDaysToHold: number
    payoutTimingFee: {
      __typename: 'PayoutTimingFee'
      fixedFee: number
      percentageFee: number
      capFee: number
    }
  } | null> | null
}

export type UpdatePayoutTimingConfigMutationVariables = Exact<{
  planID: Scalars['ID']['input']
}>

export type UpdatePayoutTimingConfigMutation = {
  __typename: 'Mutation'
  PartnerPayoutTimingUpsertCompanyConfig?: string | null
}

export type PartnerListPendingCustomerUsersTotalsQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerListPendingCustomerUsersTotalsQuery = {
  __typename: 'Query'
  PartnerListPendingCustomerUsersTotals?: {
    __typename: 'PendingCustomerUsersTotals'
    count: number
  } | null
}

export type PartnerPendingCustomerUserConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<PendingCustomerUserFilters>
  orderBy?: InputMaybe<PendingCustomerUserOrderBy>
}>

export type PartnerPendingCustomerUserConnectionQuery = {
  __typename: 'Query'
  PartnerPendingCustomerUserConnection?: {
    __typename: 'PendingCustomerUserConnection'
    edges?: Array<{
      __typename: 'PendingCustomerUserEdge'
      node?: {
        __typename: 'PendingCustomerUser'
        id: string
        email: string
        partnerId: string
        createdAt: string
        customer?: {
          __typename: 'Customer'
          id: string
          name?: string | null
        } | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerRejectPendingCustomerUserMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerRejectPendingCustomerUserMutation = {
  __typename: 'Mutation'
  PartnerRejectPendingCustomerUser?: {
    __typename: 'PendingCustomerUser'
    id: string
    email: string
    partnerId: string
    createdAt: string
    customer?: {
      __typename: 'Customer'
      id: string
      name?: string | null
    } | null
  } | null
}

export type PartnerApprovePendingCustomerUserMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerApprovePendingCustomerUserMutation = {
  __typename: 'Mutation'
  PartnerApprovePendingCustomerUser?: {
    __typename: 'CustomerUser'
    id: string
  } | null
}

export type PartnerLinkPendingCustomerUserMutationVariables = Exact<{
  id: Scalars['ID']['input']
  customerId: Scalars['ID']['input']
}>

export type PartnerLinkPendingCustomerUserMutation = {
  __typename: 'Mutation'
  PartnerLinkPendingCustomerUser?: {
    __typename: 'PendingCustomerUser'
    id: string
    email: string
    partnerId: string
    createdAt: string
    customer?: {
      __typename: 'Customer'
      id: string
      name?: string | null
    } | null
  } | null
}

export type PartnerUnlinkPendingCustomerUserMutationVariables = Exact<{
  id: Scalars['ID']['input']
  customerId: Scalars['ID']['input']
}>

export type PartnerUnlinkPendingCustomerUserMutation = {
  __typename: 'Mutation'
  PartnerUnlinkPendingCustomerUser?: {
    __typename: 'PendingCustomerUser'
    id: string
    email: string
    partnerId: string
    createdAt: string
    customer?: {
      __typename: 'Customer'
      id: string
      name?: string | null
    } | null
  } | null
}

export type PartnerListPendingCustomerUserFragment = {
  __typename: 'PendingCustomerUser'
  id: string
  email: string
  partnerId: string
  createdAt: string
  customer?: { __typename: 'Customer'; id: string; name?: string | null } | null
}

export type PartnerListPendingCustomerFragment = {
  __typename: 'Customer'
  id: string
  name?: string | null
}

export type PartnerRecurringPaymentConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<RecurringPaymentFilter>
  orderBy?: InputMaybe<RecurringPaymentOrderBy>
}>

export type PartnerRecurringPaymentConnectionQuery = {
  __typename: 'Query'
  PartnerRecurringPaymentConnection: {
    __typename: 'RecurringPaymentConnection'
    edges?: Array<{
      __typename: 'RecurringPaymentEdge'
      node?: {
        __typename: 'RecurringPayment'
        id: string
        productName?: string | null
        amount: number
        frequency: Frequency
        status: RecurringPaymentStatus
        dateFirstCharge: string
        dateLastCharge?: string | null
        autoCharge: boolean
        customer: { __typename: 'Customer'; id: string; name?: string | null }
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  }
}

export type PartnerRecurringPaymentTotalsQueryVariables = Exact<{
  filters?: InputMaybe<RecurringPaymentFilter>
}>

export type PartnerRecurringPaymentTotalsQuery = {
  __typename: 'Query'
  PartnerRecurringPaymentTotals?: {
    __typename: 'RecurringPaymentTotals'
    count: number
    amount: number
  } | null
}

export type RecurringPaymentCreateMutationVariables = Exact<{
  input: RecurringPaymentCreateInput
}>

export type RecurringPaymentCreateMutation = {
  __typename: 'Mutation'
  PartnerRecurringPaymentCreate?: {
    __typename: 'RecurringPayment'
    id: string
    productName?: string | null
    amount: number
    frequency: Frequency
    status: RecurringPaymentStatus
    dateFirstCharge: string
    dateLastCharge?: string | null
    autoCharge: boolean
    customer: { __typename: 'Customer'; id: string; name?: string | null }
  } | null
}

export type RecurringPaymentDeactivateMutationVariables = Exact<{
  input: RecurringPaymentDeactivateInput
}>

export type RecurringPaymentDeactivateMutation = {
  __typename: 'Mutation'
  PartnerRecurringPaymentDeactivate?: string | null
}

export type RecurringPaymentUpdateMutationVariables = Exact<{
  input: RecurringPaymentUpdateInput
}>

export type RecurringPaymentUpdateMutation = {
  __typename: 'Mutation'
  PartnerRecurringPaymentUpdate?: string | null
}

export type PartnerRecurringPaymentFragment = {
  __typename: 'RecurringPayment'
  id: string
  productName?: string | null
  amount: number
  frequency: Frequency
  status: RecurringPaymentStatus
  dateFirstCharge: string
  dateLastCharge?: string | null
  autoCharge: boolean
  customer: { __typename: 'Customer'; id: string; name?: string | null }
}

export type PartnerReferralGetQuarterlyEarningsDataQueryVariables = Exact<{
  input: GetReferralDataInput
}>

export type PartnerReferralGetQuarterlyEarningsDataQuery = {
  __typename: 'Query'
  PartnerReferralGetQuarterlyEarningsData: {
    __typename: 'GetReferralDataReply'
    total: number
    previous: number
  }
}

export type PartnerReferralGetAvailableForPayoutDataQueryVariables = Exact<{
  input: GetReferralDataInput
}>

export type PartnerReferralGetAvailableForPayoutDataQuery = {
  __typename: 'Query'
  PartnerReferralGetAvailableForPayoutData: {
    __typename: 'GetReferralDataReply'
    total: number
    previous: number
  }
}

export type PartnerReferralGetTotalReferralFeesDataQueryVariables = Exact<{
  input: GetReferralDataInput
}>

export type PartnerReferralGetTotalReferralFeesDataQuery = {
  __typename: 'Query'
  PartnerReferralGetTotalReferralFeesData: {
    __typename: 'GetReferralDataReply'
    total: number
    previous: number
  }
}

export type PartnerReferralGetAvgQuarterlyFeesDataQueryVariables = Exact<{
  input: GetReferralDataInput
}>

export type PartnerReferralGetAvgQuarterlyFeesDataQuery = {
  __typename: 'Query'
  PartnerReferralGetAvgQuarterlyFeesData: {
    __typename: 'GetReferralDataReply'
    total: number
    previous: number
  }
}

export type PartnerGetReferralLinkQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerGetReferralLinkQuery = {
  __typename: 'Query'
  PartnerGetReferralLink: string
}

export type PartnerGetReferralPayoutByPayoutIdQueryVariables = Exact<{
  payoutID: Scalars['ID']['input']
}>

export type PartnerGetReferralPayoutByPayoutIdQuery = {
  __typename: 'Query'
  PartnerGetReferralPayoutByPayoutID?: {
    __typename: 'ReferralPayout'
    id: string
    payoutID?: string | null
    referralCount: number
    amount: number
    period: string
    partnerID: string
    status: ReferralPayoutStatus
    payoutDate?: string | null
    referredPartnersRevenue?: Array<{
      __typename: 'ReferredPartnerRevenue'
      referredPartnerID?: string | null
      lastQuarterRevenue?: number | null
    } | null> | null
  } | null
}

export type PartnerReferralConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<ReferralFilter>
  orderBy?: InputMaybe<ReferralOrderBy>
}>

export type PartnerReferralConnectionQuery = {
  __typename: 'Query'
  PartnerReferralConnection?: {
    __typename: 'ReferralConnection'
    edges?: Array<{
      __typename: 'ReferralEdge'
      cursor: any
      node?: {
        __typename: 'Referral'
        id: string
        companyName?: string | null
        referralDate?: string | null
        processingVolume?: number | null
        referralFees?: number | null
        avgQuarterlyFees?: number | null
        status: ReferralStatus
        email?: string | null
        customerID?: string | null
        referredPartner?: {
          __typename: 'Partner'
          id: string
          name?: string | null
        } | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerCreateReferralMutationVariables = Exact<{
  input: CreateReferralInput
}>

export type PartnerCreateReferralMutation = {
  __typename: 'Mutation'
  PartnerCreateReferral: string
}

export type PartnerUpdateReferralMutationVariables = Exact<{
  input: UpdateReferralInput
}>

export type PartnerUpdateReferralMutation = {
  __typename: 'Mutation'
  PartnerUpdateReferral: string
}

export type PartnerSendReferralMutationVariables = Exact<{
  input: SendPartnerReferralInput
}>

export type PartnerSendReferralMutation = {
  __typename: 'Mutation'
  PartnerSendReferral: string
}

export type GetReferralDataReplyFragment = {
  __typename: 'GetReferralDataReply'
  total: number
  previous: number
}

export type ReferralFragment = {
  __typename: 'Referral'
  id: string
  companyName?: string | null
  referralDate?: string | null
  processingVolume?: number | null
  referralFees?: number | null
  avgQuarterlyFees?: number | null
  status: ReferralStatus
  email?: string | null
  customerID?: string | null
  referredPartner?: {
    __typename: 'Partner'
    id: string
    name?: string | null
  } | null
}

export type ReferralPayoutFragment = {
  __typename: 'ReferralPayout'
  id: string
  payoutID?: string | null
  referralCount: number
  amount: number
  period: string
  partnerID: string
  status: ReferralPayoutStatus
  payoutDate?: string | null
  referredPartnersRevenue?: Array<{
    __typename: 'ReferredPartnerRevenue'
    referredPartnerID?: string | null
    lastQuarterRevenue?: number | null
  } | null> | null
}

export type ReferralBonusFragment = {
  __typename: 'ReferralBonus'
  id: string
  description: string
  referralPayoutID: string
  amount: number
}

export type CreateRefundMutationVariables = Exact<{
  input: RefundCreateInput
}>

export type CreateRefundMutation = {
  __typename: 'Mutation'
  createRefund: boolean
}

export type PartnerSendReportMutationVariables = Exact<{
  reportType: ReportType
  dateFrom?: InputMaybe<Scalars['String']['input']>
  dateTo?: InputMaybe<Scalars['String']['input']>
  timezone?: InputMaybe<Scalars['String']['input']>
}>

export type PartnerSendReportMutation = {
  __typename: 'Mutation'
  PartnerSendReport: string
}

export type PartnerListActiveSubscriptionsQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerListActiveSubscriptionsQuery = {
  __typename: 'Query'
  PartnerListActiveSubscriptions: Array<{
    __typename: 'PartnerSubscription'
    id: string
    type: string
    amount: number
    frequency: SubscriptionFrequency
    nextBillingDate: string
    billingCyclesCovered: number
    billingCyclesUnit: string
  }>
}

export type PartnerSubscriptionsPaymentsConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<SubscriptionPaymentFilter>
  orderBy?: InputMaybe<SubscriptionPaymentOrderBy>
}>

export type PartnerSubscriptionsPaymentsConnectionQuery = {
  __typename: 'Query'
  PartnerSubscriptionsPaymentsConnection: {
    __typename: 'SubscriptionPaymentConnection'
    edges?: Array<{
      __typename: 'SubscriptionPaymentEdge'
      node?: {
        __typename: 'SubscriptionPayment'
        id: string
        paymentDate: string
        amount: number
        status: SubscriptionPaymentStatus
        subscription: {
          __typename: 'PartnerSubscription'
          id: string
          type: string
          frequency: SubscriptionFrequency
          billingCyclesCovered: number
          billingCyclesUnit: string
        }
        payment?: {
          __typename: 'Payment'
          id: string
          paymentFees: Array<{
            __typename: 'PaymentFee'
            amount: number
          } | null>
        } | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  }
}

export type PartnerListSubscriptionPaymentsTotalsQueryVariables = Exact<{
  [key: string]: never
}>

export type PartnerListSubscriptionPaymentsTotalsQuery = {
  __typename: 'Query'
  PartnerListSubscriptionPaymentsTotals: {
    __typename: 'SubscriptionPaymentsTotals'
    count: number
  }
}

export type PartnerCancelSubscriptionMutationVariables = Exact<{
  input: CancelSubscriptionInput
}>

export type PartnerCancelSubscriptionMutation = {
  __typename: 'Mutation'
  PartnerCancelSubscription?: {
    __typename: 'PartnerSubscription'
    id: string
    type: string
    amount: number
    frequency: SubscriptionFrequency
    nextBillingDate: string
    billingCyclesCovered: number
    billingCyclesUnit: string
  } | null
}

export type SubscriptionPaymentFragment = {
  __typename: 'SubscriptionPayment'
  id: string
  paymentDate: string
  amount: number
  status: SubscriptionPaymentStatus
  subscription: {
    __typename: 'PartnerSubscription'
    id: string
    type: string
    frequency: SubscriptionFrequency
    billingCyclesCovered: number
    billingCyclesUnit: string
  }
  payment?: {
    __typename: 'Payment'
    id: string
    paymentFees: Array<{ __typename: 'PaymentFee'; amount: number } | null>
  } | null
}

export type PartnerSubscriptionFragment = {
  __typename: 'PartnerSubscription'
  id: string
  type: string
  amount: number
  frequency: SubscriptionFrequency
  nextBillingDate: string
  billingCyclesCovered: number
  billingCyclesUnit: string
}

export type PartnerSubscriptionPaymentBasicFragment = {
  __typename: 'SubscriptionPayment'
  id: string
  paymentDate: string
  amount: number
  subscriptionStatus: SubscriptionPaymentStatus
  subscription: {
    __typename: 'PartnerSubscription'
    id: string
    type: string
    frequency: SubscriptionFrequency
  }
}

export type PartnerAccountingSyncConfigGetQueryVariables = Exact<{
  input: SyncConfigGetInput
}>

export type PartnerAccountingSyncConfigGetQuery = {
  __typename: 'Query'
  PartnerAccountingSyncConfigGet?: {
    __typename: 'SyncConfig'
    partnerID: string
    sourcePlatformName: PlatformName
    targetPlatformName: PlatformName
    lastAutomaticSync?: string | null
    options: Array<{
      __typename: 'SyncConfigOption'
      optionKey: SyncConfigOptionKey
      optionType: SyncConfigOptionType
      enumValue?: SyncConfigOptionValue | null
      customValue?: string | null
    }>
    mappings?: Array<{
      __typename: 'SyncConfigMapping'
      sourceID: string
      sourceName: string
      targetID: string
      targetName: string
      mappingType: SyncConfigMappingType
    }> | null
  } | null
}

export type PartnerAccountingSyncConfigCreateMutationVariables = Exact<{
  input: SyncConfigCreateInput
}>

export type PartnerAccountingSyncConfigCreateMutation = {
  __typename: 'Mutation'
  PartnerAccountingSyncConfigCreate: {
    __typename: 'SyncConfig'
    lastAutomaticSync?: string | null
  }
}

export type PartnerAccountingSyncConfigUpdateMutationVariables = Exact<{
  input: SyncConfigUpdateInput
}>

export type PartnerAccountingSyncConfigUpdateMutation = {
  __typename: 'Mutation'
  PartnerAccountingSyncConfigUpdate: {
    __typename: 'SyncConfig'
    lastAutomaticSync?: string | null
  }
}

export type GetUserInfoQueryVariables = Exact<{ [key: string]: never }>

export type GetUserInfoQuery = {
  __typename: 'Query'
  GetUserInfo?: {
    __typename: 'PartnerGetUserInfoReply'
    id: string
    userType: UserType
    users?: Array<{
      __typename: 'PartnerUserInfo'
      createdAt: string
      id: string
      email: string
      firstName?: string | null
      lastName?: string | null
      phone?: string | null
      jobTitle?: string | null
      role: string
      permissions: Array<PartnerUserPermissions>
      partner?: {
        __typename: 'Partner'
        createdAt: string
        id: string
        isOnboarded: boolean
        isDeactivated: boolean
        adyenOnboardingStatus: AdyenOnboardingStatusStep
        name?: string | null
        ein?: string | null
        paymentsPortalEnabled: boolean
        insightsEnabled: boolean
        hasBankStatementUploaded: boolean
        country?: string | null
        countryCode?: string | null
        tosAndPciAccepted: boolean
        isValidToOnboarding: boolean
        adyenBusinessSetup?: AdyenBusinessSetup | null
        paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
        paymentsPortalUrl?: string | null
        paymentsPortalCustomInvoices?: boolean | null
        requiresMFA: boolean
        paymentsPortalCustomization: {
          __typename: 'PartnerPaymentsPortalCustomization'
          color?: string | null
          logoUrl?: string | null
        }
      } | null
    }> | null
  } | null
}

export type GetUserInfoDetailsQueryVariables = Exact<{ [key: string]: never }>

export type GetUserInfoDetailsQuery = {
  __typename: 'Query'
  GetUserInfo?: {
    __typename: 'PartnerGetUserInfoReply'
    id: string
    users?: Array<{
      __typename: 'PartnerUserInfo'
      createdAt: string
      id: string
      email: string
      firstName?: string | null
      lastName?: string | null
      phone?: string | null
      jobTitle?: string | null
      role: string
      permissions: Array<PartnerUserPermissions>
      partner?: {
        __typename: 'Partner'
        createdAt: string
        id: string
        isOnboarded: boolean
        isDeactivated: boolean
        adyenOnboardingStatus: AdyenOnboardingStatusStep
        name?: string | null
        ein?: string | null
        paymentsPortalEnabled: boolean
        insightsEnabled: boolean
        hasBankStatementUploaded: boolean
        country?: string | null
        countryCode?: string | null
        tosAndPciAccepted: boolean
        isValidToOnboarding: boolean
        adyenBusinessSetup?: AdyenBusinessSetup | null
        streetAddress?: string | null
        subPremise?: string | null
        city?: string | null
        postalCode?: string | null
        state?: string | null
        stateCode?: string | null
        legalName?: string | null
        companyType?: string | null
        industry?: string | null
        description?: string | null
        website?: string | null
        phone?: string | null
        adyenCompanyType?: AdyenCompanyType | null
        adyenIndustryCode?: string | null
        paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
        paymentsPortalUrl?: string | null
        paymentsPortalCustomInvoices?: boolean | null
        requiresMFA: boolean
        paymentsPortalCustomization: {
          __typename: 'PartnerPaymentsPortalCustomization'
          color?: string | null
          logoUrl?: string | null
        }
      } | null
    }> | null
  } | null
}

export type GetUserPartnerConfigQueryVariables = Exact<{ [key: string]: never }>

export type GetUserPartnerConfigQuery = {
  __typename: 'Query'
  GetUserInfo?: {
    __typename: 'PartnerGetUserInfoReply'
    id: string
    users?: Array<{
      __typename: 'PartnerUserInfo'
      createdAt: string
      id: string
      email: string
      firstName?: string | null
      lastName?: string | null
      phone?: string | null
      jobTitle?: string | null
      role: string
      permissions: Array<PartnerUserPermissions>
      partner?: {
        __typename: 'Partner'
        createdAt: string
        id: string
        isOnboarded: boolean
        isDeactivated: boolean
        adyenOnboardingStatus: AdyenOnboardingStatusStep
        name?: string | null
        ein?: string | null
        paymentsPortalEnabled: boolean
        insightsEnabled: boolean
        hasBankStatementUploaded: boolean
        country?: string | null
        countryCode?: string | null
        tosAndPciAccepted: boolean
        isValidToOnboarding: boolean
        adyenBusinessSetup?: AdyenBusinessSetup | null
        paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
        paymentsPortalUrl?: string | null
        paymentsPortalCustomInvoices?: boolean | null
        requiresMFA: boolean
        paymentsPortalCustomization: {
          __typename: 'PartnerPaymentsPortalCustomization'
          color?: string | null
          logoUrl?: string | null
        }
      } | null
    }> | null
  } | null
}

export type CreateUserAndPartnerQueryVariables = Exact<{ [key: string]: never }>

export type CreateUserAndPartnerQuery = {
  __typename: 'Query'
  CreateUserAndPartner?: {
    __typename: 'CreateUserAndPartnerReply'
    userId: string
    partnerId: string
  } | null
}

export type PartnerUserConnectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<PartnerUserOrderBy>
}>

export type PartnerUserConnectionQuery = {
  __typename: 'Query'
  PartnerUserConnection?: {
    __typename: 'PartnerUserConnection'
    edges?: Array<{
      __typename: 'PartnerUserEdge'
      cursor: any
      node?: {
        __typename: 'PartnerUser'
        createdAt: string
        id: string
        email: string
        firstName?: string | null
        lastName?: string | null
        role: PartnerUserRole
        hasMFA?: boolean | null
      } | null
    } | null> | null
    pageInfo: {
      __typename: 'PageInfo'
      hasNextPage: boolean
      endCursor?: any | null
    }
  } | null
}

export type PartnerUpdateMyUserMutationVariables = Exact<{
  input?: InputMaybe<PartnerUpdateMyUserInput>
}>

export type PartnerUpdateMyUserMutation = {
  __typename: 'Mutation'
  PartnerUpdateMyUser?: {
    __typename: 'PartnerUser'
    id: string
    firstName?: string | null
    lastName?: string | null
    phone?: string | null
    jobTitle?: string | null
  } | null
}

export type PartnerInviteUserMutationVariables = Exact<{
  input: PartnerInviteUserInput
}>

export type PartnerInviteUserMutation = {
  __typename: 'Mutation'
  PartnerInviteUser?: {
    __typename: 'PartnerUser'
    createdAt: string
    id: string
    email: string
    firstName?: string | null
    lastName?: string | null
    role: PartnerUserRole
    hasMFA?: boolean | null
  } | null
}

export type PartnerUpdateUserMutationVariables = Exact<{
  input?: InputMaybe<PartnerUpdateUserInput>
}>

export type PartnerUpdateUserMutation = {
  __typename: 'Mutation'
  PartnerUpdateUser?: {
    __typename: 'PartnerUser'
    createdAt: string
    id: string
    email: string
    firstName?: string | null
    lastName?: string | null
    role: PartnerUserRole
    hasMFA?: boolean | null
  } | null
}

export type PartnerDeleteUserMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type PartnerDeleteUserMutation = {
  __typename: 'Mutation'
  PartnerDeleteUser?: string | null
}

export type PartnerUserListFragment = {
  __typename: 'PartnerUser'
  createdAt: string
  id: string
  email: string
  firstName?: string | null
  lastName?: string | null
  role: PartnerUserRole
  hasMFA?: boolean | null
}

export type BasicUserInfoFragment = {
  __typename: 'PartnerUserInfo'
  createdAt: string
  id: string
  email: string
  firstName?: string | null
  lastName?: string | null
  phone?: string | null
  jobTitle?: string | null
  role: string
  permissions: Array<PartnerUserPermissions>
}

export type BasicPartnerUserInfoFragment = {
  __typename: 'PartnerUserInfo'
  partner?: {
    __typename: 'Partner'
    createdAt: string
    id: string
    isOnboarded: boolean
    isDeactivated: boolean
    adyenOnboardingStatus: AdyenOnboardingStatusStep
    name?: string | null
    ein?: string | null
    paymentsPortalEnabled: boolean
    insightsEnabled: boolean
    hasBankStatementUploaded: boolean
    country?: string | null
    countryCode?: string | null
    tosAndPciAccepted: boolean
    isValidToOnboarding: boolean
    adyenBusinessSetup?: AdyenBusinessSetup | null
  } | null
}

export type PartnerUserConfigDetailsFragment = {
  __typename: 'PartnerUserInfo'
  partner?: {
    __typename: 'Partner'
    paymentsPortalEnabled: boolean
    paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
    paymentsPortalUrl?: string | null
    paymentsPortalCustomInvoices?: boolean | null
    requiresMFA: boolean
    paymentsPortalCustomization: {
      __typename: 'PartnerPaymentsPortalCustomization'
      color?: string | null
      logoUrl?: string | null
    }
  } | null
}

export type PartnerUserInfoDetailsFragment = {
  __typename: 'PartnerUserInfo'
  partner?: {
    __typename: 'Partner'
    legalName?: string | null
    ein?: string | null
    companyType?: string | null
    industry?: string | null
    description?: string | null
    website?: string | null
    phone?: string | null
    adyenCompanyType?: AdyenCompanyType | null
    adyenIndustryCode?: string | null
    adyenBusinessSetup?: AdyenBusinessSetup | null
  } | null
}

export type PartnerAddressInfoFragment = {
  __typename: 'PartnerUserInfo'
  partner?: {
    __typename: 'Partner'
    id: string
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    country?: string | null
    countryCode?: string | null
    postalCode?: string | null
    state?: string | null
    stateCode?: string | null
  } | null
}

export type UserInfoFragment = {
  __typename: 'PartnerUserInfo'
  createdAt: string
  id: string
  email: string
  firstName?: string | null
  lastName?: string | null
  phone?: string | null
  jobTitle?: string | null
  role: string
  permissions: Array<PartnerUserPermissions>
  partner?: {
    __typename: 'Partner'
    createdAt: string
    id: string
    isOnboarded: boolean
    isDeactivated: boolean
    adyenOnboardingStatus: AdyenOnboardingStatusStep
    name?: string | null
    ein?: string | null
    paymentsPortalEnabled: boolean
    insightsEnabled: boolean
    hasBankStatementUploaded: boolean
    country?: string | null
    countryCode?: string | null
    tosAndPciAccepted: boolean
    isValidToOnboarding: boolean
    adyenBusinessSetup?: AdyenBusinessSetup | null
    paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
    paymentsPortalUrl?: string | null
    paymentsPortalCustomInvoices?: boolean | null
    requiresMFA: boolean
    paymentsPortalCustomization: {
      __typename: 'PartnerPaymentsPortalCustomization'
      color?: string | null
      logoUrl?: string | null
    }
  } | null
}

export type UserPartnerConfigFragment = {
  __typename: 'PartnerUserInfo'
  createdAt: string
  id: string
  email: string
  firstName?: string | null
  lastName?: string | null
  phone?: string | null
  jobTitle?: string | null
  role: string
  permissions: Array<PartnerUserPermissions>
  partner?: {
    __typename: 'Partner'
    createdAt: string
    id: string
    isOnboarded: boolean
    isDeactivated: boolean
    adyenOnboardingStatus: AdyenOnboardingStatusStep
    name?: string | null
    ein?: string | null
    paymentsPortalEnabled: boolean
    insightsEnabled: boolean
    hasBankStatementUploaded: boolean
    country?: string | null
    countryCode?: string | null
    tosAndPciAccepted: boolean
    isValidToOnboarding: boolean
    adyenBusinessSetup?: AdyenBusinessSetup | null
    paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
    paymentsPortalUrl?: string | null
    paymentsPortalCustomInvoices?: boolean | null
    requiresMFA: boolean
    paymentsPortalCustomization: {
      __typename: 'PartnerPaymentsPortalCustomization'
      color?: string | null
      logoUrl?: string | null
    }
  } | null
}

export type UserInfoDetailsFragment = {
  __typename: 'PartnerUserInfo'
  createdAt: string
  id: string
  email: string
  firstName?: string | null
  lastName?: string | null
  phone?: string | null
  jobTitle?: string | null
  role: string
  permissions: Array<PartnerUserPermissions>
  partner?: {
    __typename: 'Partner'
    createdAt: string
    id: string
    isOnboarded: boolean
    isDeactivated: boolean
    adyenOnboardingStatus: AdyenOnboardingStatusStep
    name?: string | null
    ein?: string | null
    paymentsPortalEnabled: boolean
    insightsEnabled: boolean
    hasBankStatementUploaded: boolean
    country?: string | null
    countryCode?: string | null
    tosAndPciAccepted: boolean
    isValidToOnboarding: boolean
    adyenBusinessSetup?: AdyenBusinessSetup | null
    streetAddress?: string | null
    subPremise?: string | null
    city?: string | null
    postalCode?: string | null
    state?: string | null
    stateCode?: string | null
    legalName?: string | null
    companyType?: string | null
    industry?: string | null
    description?: string | null
    website?: string | null
    phone?: string | null
    adyenCompanyType?: AdyenCompanyType | null
    adyenIndustryCode?: string | null
    paymentsPortalMethods: Array<PartnerPaymentsPortalMethod>
    paymentsPortalUrl?: string | null
    paymentsPortalCustomInvoices?: boolean | null
    requiresMFA: boolean
    paymentsPortalCustomization: {
      __typename: 'PartnerPaymentsPortalCustomization'
      color?: string | null
      logoUrl?: string | null
    }
  } | null
}

export type PartnerBaseUserFragment = {
  __typename: 'PartnerUser'
  id: string
  email: string
  firstName?: string | null
  lastName?: string | null
}

export type PartnerListUserFragment = {
  __typename: 'PartnerUser'
  role: PartnerUserRole
  createdAt: string
  id: string
  email: string
  firstName?: string | null
  lastName?: string | null
}

export const ApiKeyFragmentDoc = /*#__PURE__*/ gql`
  fragment ApiKey on ApiKey {
    id
    clientID
    lastDigits
    keyName
    createdAt
    status
    revokedAt
    createdBy {
      id
      firstName
      lastName
    }
    revokedBy {
      id
      firstName
      lastName
    }
  }
`
export const TokenFragmentDoc = /*#__PURE__*/ gql`
  fragment Token on TokenExchange {
    access_token
    refresh_token
    expiry
    id_token
  }
`
export const AutopayExcludedListFragmentDoc = /*#__PURE__*/ gql`
  fragment AutopayExcludedList on AutopayExcludedCustomer {
    id
    customer {
      id
      name
      city
      state
      tagIDs
    }
    createdByCustomer
    createdAt
  }
`
export const BankAccountFragmentDoc = /*#__PURE__*/ gql`
  fragment BankAccount on Account {
    id
    mask
    name
    type
    subtype
    hasAchAccountNumber
    hasAchRoutingNumber
    hasWireRoutingNumber
    institution {
      name
      id
      logo
    }
    provider
    disconnectedAt
    systemDeactivatedAt
    companyName
  }
`
export const BankFragmentDoc = /*#__PURE__*/ gql`
  fragment Bank on Institution {
    id
    externalId
    name
    url
    logo
    accounts {
      ...BankAccount
    }
  }
  ${BankAccountFragmentDoc}
`
export const CreditCardFragmentDoc = /*#__PURE__*/ gql`
  fragment CreditCard on Card {
    id
    last4
    expirationDate
    cardNetWork
    fundingSource
  }
`
export const AutopayRulesWithBankingAndCardFragmentDoc = /*#__PURE__*/ gql`
  fragment AutopayRulesWithBankingAndCard on AutopayRule {
    id
    daysPastCreation
    daysPastDue
    daysBeforeDue
    amountOperator
    amount
    version
    customMethods {
      customerID
      methodID
      method
      institution {
        ...Bank
      }
      card {
        ...CreditCard
      }
      fallbackCharge
    }
    autotaskContractTypes {
      externalID
      partnerID
      name
    }
    connectwiseAgreementTypes {
      externalID
      partnerID
      name
    }
    haloPSAContractSubtypes {
      externalID
      partnerID
      name
    }
    quickbooksRecurringTransactions {
      externalID
      partnerID
      name
    }
    connectwiseBillingTerms {
      externalID
      partnerID
      name
    }
    rutterQbdPaymentTerms {
      externalID
      partnerID
      name
    }
    rutterNetsuitePaymentTerms {
      externalID
      partnerID
      name
    }
    halopsaRecurringInvoices
    customers {
      id
      name
    }
    connectWiseContractNames
    autotaskContractNames
    createdByCustomer
    createdAt
  }
  ${BankFragmentDoc}
  ${CreditCardFragmentDoc}
`
export const AutopayRulesFragmentDoc = /*#__PURE__*/ gql`
  fragment AutopayRules on AutopayRule {
    id
    daysPastCreation
    daysPastDue
    daysBeforeDue
    amountOperator
    amount
    version
    customMethods {
      customerID
      methodID
      method
    }
    autotaskContractTypes {
      externalID
      partnerID
      name
    }
    connectwiseAgreementTypes {
      externalID
      partnerID
      name
    }
    haloPSAContractSubtypes {
      externalID
      partnerID
      name
    }
    quickbooksRecurringTransactions {
      externalID
      partnerID
      name
    }
    connectwiseBillingTerms {
      externalID
      partnerID
      name
    }
    rutterQbdPaymentTerms {
      externalID
      partnerID
      name
    }
    rutterNetsuitePaymentTerms {
      externalID
      partnerID
      name
    }
    halopsaRecurringInvoices
    customers {
      id
      name
    }
    connectWiseContractNames
    autotaskContractNames
    createdByCustomer
    createdAt
  }
`
export const AutopayRulesWithCustomerTagsFragmentDoc = /*#__PURE__*/ gql`
  fragment AutopayRulesWithCustomerTags on AutopayRule {
    ...AutopayRules
    tagIDs
  }
  ${AutopayRulesFragmentDoc}
`
export const CustomerAutopayConfigFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerAutopayConfig on GetCustomerAutopayConfigReply {
    customerAutopayConfig {
      customerID
      partnerID
      chargeDefaultFallback
    }
  }
`
export const InvoiceCoveredFragmentDoc = /*#__PURE__*/ gql`
  fragment InvoiceCovered on Invoice {
    id
    invoiceNumber
    createdAt
    dueDate
    amount
    status
    recurringpayment
    externalId
    externalInvoiceNumber
    autopaidAt
    customer {
      id
      name
      tagIDs
    }
  }
`
export const PartnerCustomerSearchFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCustomerSearch on Customer {
    id
    name
  }
`
export const PartnerCustomerAddressFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCustomerAddress on Customer {
    streetAddress
    subPremise
    city
    postalCode
    state
    country
  }
`
export const PartnerCustomerListFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCustomerList on Customer {
    ...PartnerCustomerSearch
    legalName
    ein
    createdAt
    isOnboarded
    tagIDs
    ...PartnerCustomerAddress
    partner {
      id
      paymentsPortalUrl
    }
  }
  ${PartnerCustomerSearchFragmentDoc}
  ${PartnerCustomerAddressFragmentDoc}
`
export const PartnerCustomerListWithInvoicesDataFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCustomerListWithInvoicesData on Customer {
    ...PartnerCustomerList
    outstandingInvoicesData {
      outstandingInvoicesCount
      outstandingInvoicesTotal
      longestDaysOverdue
    }
    defaultPaymentMethod {
      methodID
      method
      institution {
        ...Bank
      }
      card {
        ...CreditCard
      }
    }
    tagIDs
  }
  ${PartnerCustomerListFragmentDoc}
  ${BankFragmentDoc}
  ${CreditCardFragmentDoc}
`
export const FindAutopayRuleFragmentDoc = /*#__PURE__*/ gql`
  fragment FindAutopayRule on AutopayRule {
    ...AutopayRules
    customers {
      ...PartnerCustomerListWithInvoicesData
    }
    tagIDs
  }
  ${AutopayRulesFragmentDoc}
  ${PartnerCustomerListWithInvoicesDataFragmentDoc}
`
export const PartnerInvoiceBasicFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerInvoiceBasic on Invoice {
    id
    invoiceNumber
    productName
    status
    statuses {
      status
      createdAt
    }
    amount
    dueDate
    outstandingAmount
    platformName
    totalDiscountAmount
    payments {
      id
      status
      payoutCreationForecastDate
    }
  }
`
export const PartnerCustomerBasicFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCustomerBasic on Customer {
    createdAt
    id
    name
    legalName
    isOnboarded
    ...PartnerCustomerAddress
  }
  ${PartnerCustomerAddressFragmentDoc}
`
export const PartnerBaseFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerBase on Partner {
    id
    name
    legalName
    isOnboarded
    adyenOnboardingStatus
    insightsEnabled
  }
`
export const PartnerSubscriptionPaymentBasicFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerSubscriptionPaymentBasic on SubscriptionPayment {
    id
    subscription {
      id
      type
      frequency
    }
    paymentDate
    subscriptionStatus: status
    amount
  }
`
export const PartnerPaymentFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerPayment on Payment {
    id
    paymentFees {
      forwarded
      type
      amount
      name
    }
    amount
    netAmount
    creationDate
    currentPaymentMethod
    currentPaymentMethodEntity {
      ... on Account {
        id
        name
        mask
        type
      }
      ... on Card {
        id
        cardNetWork
        last4
      }
    }
    customer {
      id
      name
      ...PartnerCustomerAddress
    }
    dueDate
    paymentCompletionForecastDate
    product {
      ... on Invoice {
        ...PartnerInvoiceBasic
      }
      ... on SubscriptionPayment {
        ...PartnerSubscriptionPaymentBasic
      }
    }
    transaction {
      failureReason
      status
    }
    statuses {
      status
      createdAt
    }
    originService
    executorType
    refunds {
      amount
      status {
        id
        status
        createdAt
      }
      createdAt
      lastStatus
    }
    payoutEstimation {
      estimatedPayoutCreationDate
    }
  }
  ${PartnerCustomerAddressFragmentDoc}
  ${PartnerInvoiceBasicFragmentDoc}
  ${PartnerSubscriptionPaymentBasicFragmentDoc}
`
export const PartnerCustomerInstallmentFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCustomerInstallment on Installment {
    id
    amount
    dueDate
    netAmount
    status
    payments {
      ... on Payment {
        ...PartnerPayment
      }
    }
  }
  ${PartnerPaymentFragmentDoc}
`
export const PartnerCustomerScheduleFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCustomerSchedule on Lending {
    id
    amount
    netAmount
    installments {
      ... on Installment {
        ...PartnerCustomerInstallment
      }
    }
  }
  ${PartnerCustomerInstallmentFragmentDoc}
`
export const PartnerCustomerOfferFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCustomerOffer on BNPLOffer {
    createdAt
    status
    amount
    fees
    netAmount
    lending {
      ...PartnerCustomerSchedule
    }
    remainingBalance
    terms
  }
  ${PartnerCustomerScheduleFragmentDoc}
`
export const PartnerCustomerBnplFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCustomerBNPL on Invoice {
    ...PartnerInvoiceBasic
    amount
    createdAt
    dueDate
    customer {
      ...PartnerCustomerBasic
    }
    partner {
      ...PartnerBase
    }
    offer {
      ...PartnerCustomerOffer
    }
  }
  ${PartnerInvoiceBasicFragmentDoc}
  ${PartnerCustomerBasicFragmentDoc}
  ${PartnerBaseFragmentDoc}
  ${PartnerCustomerOfferFragmentDoc}
`
export const PaymentRequestFragmentDoc = /*#__PURE__*/ gql`
  fragment PaymentRequest on PaymentRequest {
    id
    lastStatus
    paymentDate
    payment {
      paymentFees {
        forwarded
        amount
      }
      amount
      netAmount
      paymentCompletionForecastDate
      transaction {
        failureReason
      }
    }
    product {
      ... on Invoice {
        id
        invoiceNumber
        productName
        amount
        customer {
          id
          name
        }
        status
        amount
      }
    }
  }
`
export const PartnerInvoiceBulkChargeFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerInvoiceBulkCharge on PartnerInvoiceBulkCharge {
    id
    partner {
      id
      name
    }
    requester {
      id
      email
    }
    bulkChargeRequestStatus
    invoiceCount
    paymentDate
    createdAt
    paymentRequests {
      ...PaymentRequest
    }
  }
  ${PaymentRequestFragmentDoc}
`
export const PartnerCollectionInvoiceFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCollectionInvoice on Invoice {
    id
    amount
    outstandingAmount
    collection {
      id
      status {
        status
        createdAt
      }
    }
    createdAt
    customer {
      ...PartnerCustomerBasic
    }
    dueDate
    invoiceNumber
    status
  }
  ${PartnerCustomerBasicFragmentDoc}
`
export const UpfrontFeePaymentFragmentDoc = /*#__PURE__*/ gql`
  fragment UpfrontFeePayment on Payment {
    id
    amount
    netAmount
    dueDate
    currentPaymentMethodEntity {
      ... on Account {
        id
        name
      }
      ... on Card {
        id
        cardNetWork
      }
    }
    paymentFees {
      amount
      forwarded
      name
    }
    paymentCompletionForecastDate
    statuses {
      status
      createdAt
    }
  }
`
export const PartnerCollectionListingFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCollectionListing on Collection {
    id
    createdAt
    collectionOutstandingAmount
    collectionFeePaymentAmount
    interest
    collectionPayment {
      id
      amount
      creationDate
    }
    invoice {
      id
      amount
      dueDate
      invoiceNumber
      productName
    }
    customerInfo {
      customer {
        ...PartnerCustomerBasic
      }
    }
    upfrontFeePayment {
      ...UpfrontFeePayment
    }
    status {
      status
      createdAt
    }
  }
  ${PartnerCustomerBasicFragmentDoc}
  ${UpfrontFeePaymentFragmentDoc}
`
export const PartnerCollectionDetailFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCollectionDetail on Collection {
    id
    collectionInstruction
    collectionOutstandingAmount
    collectionFeePaymentAmount
    interest
    lastContactDate
    customerType
    collectionPayment {
      id
      amount
      netAmount
      currentPaymentMethodEntity {
        ... on Account {
          id
          name
        }
        ... on Card {
          id
          cardNetWork
        }
      }
      paymentFees {
        amount
        forwarded
        name
      }
      statuses {
        status
        createdAt
      }
      paymentCompletionForecastDate
    }
    customerInfo {
      customer {
        name
        id
      }
      name
      phone
      email
      streetAddress
      subPremise
      city
      state
      postalCode
      country
    }
    invoice {
      id
      amount
      dueDate
      invoiceNumber
      productName
    }
    notes {
      note
      createdAt
    }
    status {
      status
      createdAt
    }
    createdAt
    updatedAt
    upfrontFeePayment {
      ...UpfrontFeePayment
    }
  }
  ${UpfrontFeePaymentFragmentDoc}
`
export const PartnerOverdueInvoiceFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerOverdueInvoice on Invoice {
    id
    amount
    outstandingAmount
    createdAt
    customer {
      ...PartnerCustomerBasic
    }
    dueDate
    invoiceNumber
    status
    collection {
      id
      status {
        status
        createdAt
      }
    }
  }
  ${PartnerCustomerBasicFragmentDoc}
`
export const PartnerCustomerFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCustomer on Customer {
    ...PartnerCustomerBasic
    ein
    companyType
    industry
    description
    isArchived
    archivedBy
  }
  ${PartnerCustomerBasicFragmentDoc}
`
export const PartnerListCustomerUsersFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerListCustomerUsers on CustomerUser {
    id
    email
    firstName
    lastName
    approvedBy
    createdAt
    customer {
      id
      name
    }
  }
`
export const PartnerCustomerUserCreationFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCustomerUserCreation on CustomerUser {
    id
    email
    firstName
    lastName
  }
`
export const PartnerInvoiceEmailActivityFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerInvoiceEmailActivity on Invoice {
    id
    invoiceNumber
  }
`
export const PartnerEmailActivityFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerEmailActivity on EmailActivity {
    sentAt
    user
    subject
    invoice {
      ...PartnerInvoiceEmailActivity
    }
    customer {
      ...PartnerCustomerList
    }
    status
  }
  ${PartnerInvoiceEmailActivityFragmentDoc}
  ${PartnerCustomerListFragmentDoc}
`
export const PartnerCustomerFeeConfigFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerCustomerFeeConfig on CustomerFeeConfig {
    id
    customer {
      id
      name
    }
    feeType
  }
`
export const BucketCountDataFragmentDoc = /*#__PURE__*/ gql`
  fragment BucketCountData on BucketCountData {
    bucket
    value
  }
`
export const BucketAmountDataFragmentDoc = /*#__PURE__*/ gql`
  fragment BucketAmountData on BucketAmountData {
    bucket
    value
  }
`
export const DataPointFragmentDoc = /*#__PURE__*/ gql`
  fragment DataPoint on DataPoint {
    month
    value
  }
`
export const InvoiceCountMonthFragmentDoc = /*#__PURE__*/ gql`
  fragment InvoiceCountMonth on InvoiceCountMonth {
    month
    data {
      status
      count
    }
  }
`
export const InvoiceAmountMonthFragmentDoc = /*#__PURE__*/ gql`
  fragment InvoiceAmountMonth on InvoiceAmountMonth {
    month
    data {
      status
      value
    }
  }
`
export const CwQueryFiltersFragmentDoc = /*#__PURE__*/ gql`
  fragment CWQueryFilters on ConnectWiseQueryFilters {
    invoiceFilters {
      locations {
        id
        name
      }
      status {
        id
        name
      }
      createdSince
    }
    customerFilters {
      status {
        id
        name
      }
      territories {
        id
        name
      }
      types {
        id
        name
      }
    }
  }
`
export const PartnerIntegrationFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerIntegration on IntegrationInterface {
    __typename
    id
    partnerID
    platformName
    createdAt
    integrationType
    ... on AutotaskIntegration {
      status
    }
    ... on ConnectwiseIntegration {
      status
    }
    ... on HaloPSAIntegration {
      status
    }
    ... on QuickbooksIntegration {
      status
    }
    ... on RutterIntegration {
      status
    }
    ... on SuperOpsIntegration {
      status
    }
    ... on DatagateIntegration {
      status
    }
  }
`
export const PartnerUnsyncedInvoiceFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerUnsyncedInvoice on InvoiceRelation {
    id
    invoiceNumber
    createdAt
    dueDate
    amount
    customer {
      id
      name
    }
    invoiceID
  }
`
export const AccountingSyncBatchFragmentDoc = /*#__PURE__*/ gql`
  fragment AccountingSyncBatch on AccountingSyncBatch {
    id
    createdAt
    externalID
    status
    platform
    numberOfInvoices
  }
`
export const QuickbooksAccountFragmentDoc = /*#__PURE__*/ gql`
  fragment QuickbooksAccount on QuickbooksAccount {
    id
    type
    name
    fullyQualifiedName
  }
`
export const RutterAccountListFragmentDoc = /*#__PURE__*/ gql`
  fragment RutterAccountList on RutterAccount {
    id
    type
    name
    nominalCode
  }
`
export const PartnerInvoiceSearchFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerInvoiceSearch on Invoice {
    id
    invoiceNumber
    productName
  }
`
export const PartnerInvoiceOfferFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerInvoiceOffer on BNPLOffer {
    id
    partnerConfirmed
    status
    createdAt
    terms
    amount
    netAmount
    lending {
      ...PartnerCustomerSchedule
    }
  }
  ${PartnerCustomerScheduleFragmentDoc}
`
export const PartnerInvoiceListingFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerInvoiceListing on Invoice {
    id
    amount
    outstandingAmount
    createdAt
    createdByCustomer
    customer {
      name
      id
    }
    dueDate
    invoiceNumber
    lastRemindedAt
    productName
    status
    recurringpayment
    offer {
      ...PartnerInvoiceOffer
    }
    payments {
      id
      status
      payoutCreationForecastDate
    }
    transferPayments {
      id
      statuses {
        status
      }
      transaction {
        failureReason
      }
    }
    externalId
    externalInvoiceNumber
    autopaidAt
  }
  ${PartnerInvoiceOfferFragmentDoc}
`
export const PartnerConfigFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerConfig on Partner {
    paymentsPortalEnabled
    paymentsPortalUrl
    paymentsPortalCustomUrl
    paymentsPortalUseCustomUrl
    paymentsPortalDefaultUrl
    paymentsPortalMethods
    paymentsPortalCustomization {
      color
      logoUrl
    }
  }
`
export const PartnerAddressDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerAddressDetails on Partner {
    city
    state
    stateCode
    country
    countryCode
    postalCode
    streetAddress
    subPremise
  }
`
export const PartnerInvoiceFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerInvoice on Invoice {
    ...PartnerInvoiceBasic
    amount
    outstandingAmount
    createdAt
    createdByCustomer
    customer {
      ...PartnerCustomerBasic
    }
    partner {
      ...PartnerBase
      ...PartnerConfig
      ...PartnerAddressDetails
    }
    offer {
      ...PartnerInvoiceOffer
    }
    dueDate
    recurringpayment
    recurringpaymentID
    lastRemindedAt
    transferPayments {
      id
      statuses {
        status
      }
      transaction {
        failureReason
      }
    }
    externalId
    externalInvoiceNumber
    totalTaxAmount
    purchaseOrder
    lineItems {
      code
      category
      description
      quantity
      extendedAmountPerItem
    }
  }
  ${PartnerInvoiceBasicFragmentDoc}
  ${PartnerCustomerBasicFragmentDoc}
  ${PartnerBaseFragmentDoc}
  ${PartnerConfigFragmentDoc}
  ${PartnerAddressDetailsFragmentDoc}
  ${PartnerInvoiceOfferFragmentDoc}
`
export const EmailTemplateFragmentDoc = /*#__PURE__*/ gql`
  fragment EmailTemplate on EmailTemplate {
    id
    partnerID
    name
    subject
    section1
    section2
    section3
    type
    favorite
  }
`
export const PartnerInvoiceReminderFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerInvoiceReminder on InvoiceReminder {
    id
    daysOffset
    type
    createdAt
    template {
      ...EmailTemplate
    }
  }
  ${EmailTemplateFragmentDoc}
`
export const PartnerInvoiceReminderExcludedCustomerFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerInvoiceReminderExcludedCustomer on InvoiceReminderExcludedCustomer {
    id
    customer {
      ...PartnerCustomerList
    }
    createdAt
  }
  ${PartnerCustomerListFragmentDoc}
`
export const PartnerInvoiceSummaryFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerInvoiceSummary on InvoiceSummary {
    id
    frequency
    customDay
    startAt
    createdAt
    template {
      ...EmailTemplate
    }
  }
  ${EmailTemplateFragmentDoc}
`
export const PartnerInvoiceSummaryExcludedCustomerFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerInvoiceSummaryExcludedCustomer on InvoiceSummaryExcludedCustomer {
    id
    customer {
      ...PartnerCustomerList
    }
    createdAt
  }
  ${PartnerCustomerListFragmentDoc}
`
export const CompanyIndividualFragmentDoc = /*#__PURE__*/ gql`
  fragment CompanyIndividual on CompanyIndividual {
    id
    partnerID
    firstName
    lastName
    email
    phone
    dateOfBirth
    jobTitle
    country
    countryCode
    streetAddress
    subPremise
    postalCode
    state
    stateCode
    city
    hasSSN
    owner
    signatory
    controllingPerson
  }
`
export const PartnerDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerDetails on Partner {
    ein
    companyType
    industry
    description
  }
`
export const SupportPreferencesFragmentDoc = /*#__PURE__*/ gql`
  fragment SupportPreferences on SupportPreferences {
    partnerID
    name
    email
    phone
    firstLine
    secondLine
  }
`
export const PaymentConfigFragmentDoc = /*#__PURE__*/ gql`
  fragment PaymentConfig on PaymentCompanyConfig {
    id
    paymentMethodEntity {
      __typename
      ... on Account {
        id
        mask
        name
        institution {
          id
          logo
        }
      }
      ... on Card {
        id
        last4
        expirationDate
        cardNetWork
      }
    }
    paymentMethod
  }
`
export const CustomerPaymentMethodFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomerPaymentMethod on PaymentCompanyConfig {
    id
    company {
      __typename
      ... on Customer {
        id
        name
      }
    }
    paymentMethodEntity {
      __typename
      ... on Account {
        ...BankAccount
      }
      ... on Card {
        ...CreditCard
      }
    }
    paymentMethod
  }
  ${BankAccountFragmentDoc}
  ${CreditCardFragmentDoc}
`
export const CustomersPaymentMethodFragmentDoc = /*#__PURE__*/ gql`
  fragment CustomersPaymentMethod on PaymentCompanyConfig {
    id
    company {
      __typename
      ... on Customer {
        id
        name
      }
    }
    paymentMethod
  }
`
export const PayoutBreakdownTotalsFragmentDoc = /*#__PURE__*/ gql`
  fragment PayoutBreakdownTotals on PayoutBreakdownTotals {
    productType
    productTypeCount
    sumFees
    sumGrossAmount
    feesGreaterThanZeroCount
  }
`
export const TransactionFragmentDoc = /*#__PURE__*/ gql`
  fragment Transaction on Transaction {
    failureReason
    transactionMethod
    status
  }
`
export const PartnerPayoutDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerPayoutDetails on PayoutDetails {
    id
    amount
    netAmount
    publicNumber
    payoutType
    statuses {
      status
      createdAt
    }
    creationDate
    payoutCompletionForecastDate
    payoutBreakdownTotals {
      ...PayoutBreakdownTotals
    }
    product {
      ... on Invoice {
        ...PartnerInvoiceBasic
      }
    }
    account {
      name
      mask
      institution {
        name
      }
    }
    transactions {
      ...Transaction
    }
    fees {
      name
      amount
    }
  }
  ${PayoutBreakdownTotalsFragmentDoc}
  ${PartnerInvoiceBasicFragmentDoc}
  ${TransactionFragmentDoc}
`
export const PartnerPayoutFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerPayout on Payout {
    id
    amount
    netAmount
    publicNumber
    fees {
      forwarded
      type
      amount
      name
    }
    creationDate
    payoutCompletionForecastDate
    customer {
      id
      name
      ...PartnerCustomerAddress
    }
    product {
      ... on Invoice {
        ...PartnerInvoiceBasic
      }
    }
    statuses {
      status
      createdAt
    }
    transactions {
      failureReason
      transactionMethod
      status
    }
    account {
      name
      mask
      institution {
        name
      }
    }
    payoutBreakdownTotals {
      ...PayoutBreakdownTotals
    }
  }
  ${PartnerCustomerAddressFragmentDoc}
  ${PartnerInvoiceBasicFragmentDoc}
  ${PayoutBreakdownTotalsFragmentDoc}
`
export const ReferralBonusFragmentDoc = /*#__PURE__*/ gql`
  fragment ReferralBonus on ReferralBonus {
    id
    description
    referralPayoutID
    amount
  }
`
export const PartnerBreakdownListItemFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerBreakdownListItem on BreakdownListItem {
    id
    createdAt
    transactionDate
    transactionType
    fee
    grossAmount
    companyType
    transaction {
      id
    }
    product {
      ... on Invoice {
        id
        invoiceNumber
        productName
        status
        statuses {
          status
          createdAt
        }
        customer {
          id
          name
        }
        amount
        dueDate
        outstandingAmount
        payments {
          payoutCreationForecastDate
        }
      }
      ... on Referral {
        id
        referralDate
        referredPartner {
          id
          name
        }
      }
      ... on ReferralBonus {
        ...ReferralBonus
      }
    }
    customer {
      id
      name
      ...PartnerCustomerAddress
    }
    partner {
      id
      name
    }
    paymentMethod {
      ... on Account {
        id
        name
      }
      ... on Card {
        id
        cardNetWork
      }
    }
  }
  ${ReferralBonusFragmentDoc}
  ${PartnerCustomerAddressFragmentDoc}
`
export const PartnerListPendingCustomerFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerListPendingCustomer on Customer {
    id
    name
  }
`
export const PartnerListPendingCustomerUserFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerListPendingCustomerUser on PendingCustomerUser {
    id
    email
    partnerId
    customer {
      ...PartnerListPendingCustomer
    }
    createdAt
  }
  ${PartnerListPendingCustomerFragmentDoc}
`
export const PartnerRecurringPaymentFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerRecurringPayment on RecurringPayment {
    id
    customer {
      id
      name
    }
    productName
    amount
    frequency
    status
    dateFirstCharge
    dateLastCharge
    autoCharge
  }
`
export const GetReferralDataReplyFragmentDoc = /*#__PURE__*/ gql`
  fragment GetReferralDataReply on GetReferralDataReply {
    total
    previous
  }
`
export const ReferralFragmentDoc = /*#__PURE__*/ gql`
  fragment Referral on Referral {
    id
    companyName
    referralDate
    processingVolume
    referralFees
    avgQuarterlyFees
    status
    email
    customerID
    referredPartner {
      id
      name
    }
  }
`
export const ReferralPayoutFragmentDoc = /*#__PURE__*/ gql`
  fragment ReferralPayout on ReferralPayout {
    id
    payoutID
    referralCount
    amount
    period
    partnerID
    status
    payoutDate
    referredPartnersRevenue {
      referredPartnerID
      lastQuarterRevenue
    }
  }
`
export const SubscriptionPaymentFragmentDoc = /*#__PURE__*/ gql`
  fragment SubscriptionPayment on SubscriptionPayment {
    id
    subscription {
      id
      type
      frequency
      billingCyclesCovered
      billingCyclesUnit
    }
    paymentDate
    payment {
      id
      paymentFees {
        amount
      }
    }
    amount
    status
  }
`
export const PartnerSubscriptionFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerSubscription on PartnerSubscription {
    id
    type
    amount
    frequency
    nextBillingDate
    billingCyclesCovered
    billingCyclesUnit
  }
`
export const PartnerUserListFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerUserList on PartnerUser {
    createdAt
    id
    email
    firstName
    lastName
    role
    hasMFA
  }
`
export const BasicUserInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment BasicUserInfo on PartnerUserInfo {
    createdAt
    id
    email
    firstName
    lastName
    phone
    jobTitle
    role
    permissions
  }
`
export const BasicPartnerUserInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment BasicPartnerUserInfo on PartnerUserInfo {
    partner {
      createdAt
      id
      isOnboarded
      isDeactivated
      adyenOnboardingStatus
      name
      ein
      paymentsPortalEnabled
      insightsEnabled
      hasBankStatementUploaded
      country
      countryCode
      tosAndPciAccepted
      isValidToOnboarding
      adyenBusinessSetup
    }
  }
`
export const PartnerUserConfigDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerUserConfigDetails on PartnerUserInfo {
    partner {
      paymentsPortalEnabled
      paymentsPortalMethods
      paymentsPortalUrl
      paymentsPortalCustomization {
        color
        logoUrl
      }
      paymentsPortalCustomInvoices
      requiresMFA
    }
  }
`
export const UserInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment UserInfo on PartnerUserInfo {
    ...BasicUserInfo
    ...BasicPartnerUserInfo
    ...PartnerUserConfigDetails
  }
  ${BasicUserInfoFragmentDoc}
  ${BasicPartnerUserInfoFragmentDoc}
  ${PartnerUserConfigDetailsFragmentDoc}
`
export const UserPartnerConfigFragmentDoc = /*#__PURE__*/ gql`
  fragment UserPartnerConfig on PartnerUserInfo {
    ...BasicUserInfo
    ...BasicPartnerUserInfo
    ...PartnerUserConfigDetails
  }
  ${BasicUserInfoFragmentDoc}
  ${BasicPartnerUserInfoFragmentDoc}
  ${PartnerUserConfigDetailsFragmentDoc}
`
export const PartnerAddressInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerAddressInfo on PartnerUserInfo {
    partner {
      id
      streetAddress
      subPremise
      city
      country
      countryCode
      postalCode
      state
      stateCode
    }
  }
`
export const PartnerUserInfoDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerUserInfoDetails on PartnerUserInfo {
    partner {
      legalName
      ein
      companyType
      industry
      description
      website
      phone
      adyenCompanyType
      adyenIndustryCode
      adyenBusinessSetup
    }
  }
`
export const UserInfoDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment UserInfoDetails on PartnerUserInfo {
    ...BasicUserInfo
    ...BasicPartnerUserInfo
    ...PartnerAddressInfo
    ...PartnerUserInfoDetails
    ...PartnerUserConfigDetails
  }
  ${BasicUserInfoFragmentDoc}
  ${BasicPartnerUserInfoFragmentDoc}
  ${PartnerAddressInfoFragmentDoc}
  ${PartnerUserInfoDetailsFragmentDoc}
  ${PartnerUserConfigDetailsFragmentDoc}
`
export const PartnerBaseUserFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerBaseUser on PartnerUser {
    id
    email
    firstName
    lastName
  }
`
export const PartnerListUserFragmentDoc = /*#__PURE__*/ gql`
  fragment PartnerListUser on PartnerUser {
    ...PartnerBaseUser
    __typename
    role
    createdAt
  }
  ${PartnerBaseUserFragmentDoc}
`
export const SolveRemediationActionsByIDsDocument = /*#__PURE__*/ gql`
  mutation SolveRemediationActionsByIDs($actionIDs: [String!]!) {
    SolveRemediationActionsByIDs(actionIDs: $actionIDs)
  }
`
export type SolveRemediationActionsByIDsMutationFn = Apollo.MutationFunction<
  SolveRemediationActionsByIDsMutation,
  SolveRemediationActionsByIDsMutationVariables
>

/**
 * __useSolveRemediationActionsByIDsMutation__
 *
 * To run a mutation, you first call `useSolveRemediationActionsByIDsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSolveRemediationActionsByIDsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [solveRemediationActionsByIDsMutation, { data, loading, error }] = useSolveRemediationActionsByIDsMutation({
 *   variables: {
 *      actionIDs: // value for 'actionIDs'
 *   },
 * });
 */
export function useSolveRemediationActionsByIDsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SolveRemediationActionsByIDsMutation,
    SolveRemediationActionsByIDsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SolveRemediationActionsByIDsMutation,
    SolveRemediationActionsByIDsMutationVariables
  >(SolveRemediationActionsByIDsDocument, options)
}
export type SolveRemediationActionsByIDsMutationHookResult = ReturnType<
  typeof useSolveRemediationActionsByIDsMutation
>
export type SolveRemediationActionsByIDsMutationResult =
  Apollo.MutationResult<SolveRemediationActionsByIDsMutation>
export type SolveRemediationActionsByIDsMutationOptions =
  Apollo.BaseMutationOptions<
    SolveRemediationActionsByIDsMutation,
    SolveRemediationActionsByIDsMutationVariables
  >
export const GetAdyenDocumentTypesDocument = /*#__PURE__*/ gql`
  query GetAdyenDocumentTypes($ownerType: AdyenOwnerType!) {
    GetAdyenDocumentTypes(ownerType: $ownerType)
  }
`

/**
 * __useGetAdyenDocumentTypesQuery__
 *
 * To run a query within a React component, call `useGetAdyenDocumentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdyenDocumentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdyenDocumentTypesQuery({
 *   variables: {
 *      ownerType: // value for 'ownerType'
 *   },
 * });
 */
export function useGetAdyenDocumentTypesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAdyenDocumentTypesQuery,
    GetAdyenDocumentTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetAdyenDocumentTypesQuery,
    GetAdyenDocumentTypesQueryVariables
  >(GetAdyenDocumentTypesDocument, options)
}
export function useGetAdyenDocumentTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdyenDocumentTypesQuery,
    GetAdyenDocumentTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAdyenDocumentTypesQuery,
    GetAdyenDocumentTypesQueryVariables
  >(GetAdyenDocumentTypesDocument, options)
}
export type GetAdyenDocumentTypesQueryHookResult = ReturnType<
  typeof useGetAdyenDocumentTypesQuery
>
export type GetAdyenDocumentTypesLazyQueryHookResult = ReturnType<
  typeof useGetAdyenDocumentTypesLazyQuery
>
export type GetAdyenDocumentTypesQueryResult = Apollo.QueryResult<
  GetAdyenDocumentTypesQuery,
  GetAdyenDocumentTypesQueryVariables
>
export const SolveAdyenRemediationActionsDocument = /*#__PURE__*/ gql`
  mutation SolveAdyenRemediationActions {
    SolveAdyenRemediationActions
  }
`
export type SolveAdyenRemediationActionsMutationFn = Apollo.MutationFunction<
  SolveAdyenRemediationActionsMutation,
  SolveAdyenRemediationActionsMutationVariables
>

/**
 * __useSolveAdyenRemediationActionsMutation__
 *
 * To run a mutation, you first call `useSolveAdyenRemediationActionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSolveAdyenRemediationActionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [solveAdyenRemediationActionsMutation, { data, loading, error }] = useSolveAdyenRemediationActionsMutation({
 *   variables: {
 *   },
 * });
 */
export function useSolveAdyenRemediationActionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SolveAdyenRemediationActionsMutation,
    SolveAdyenRemediationActionsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SolveAdyenRemediationActionsMutation,
    SolveAdyenRemediationActionsMutationVariables
  >(SolveAdyenRemediationActionsDocument, options)
}
export type SolveAdyenRemediationActionsMutationHookResult = ReturnType<
  typeof useSolveAdyenRemediationActionsMutation
>
export type SolveAdyenRemediationActionsMutationResult =
  Apollo.MutationResult<SolveAdyenRemediationActionsMutation>
export type SolveAdyenRemediationActionsMutationOptions =
  Apollo.BaseMutationOptions<
    SolveAdyenRemediationActionsMutation,
    SolveAdyenRemediationActionsMutationVariables
  >
export const UploadAdyenDocumentDocument = /*#__PURE__*/ gql`
  mutation UploadAdyenDocument($input: UploadAdyenDocumentInput!) {
    UploadAdyenDocument(document: $input) {
      failed
      details
    }
  }
`
export type UploadAdyenDocumentMutationFn = Apollo.MutationFunction<
  UploadAdyenDocumentMutation,
  UploadAdyenDocumentMutationVariables
>

/**
 * __useUploadAdyenDocumentMutation__
 *
 * To run a mutation, you first call `useUploadAdyenDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAdyenDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAdyenDocumentMutation, { data, loading, error }] = useUploadAdyenDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadAdyenDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadAdyenDocumentMutation,
    UploadAdyenDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UploadAdyenDocumentMutation,
    UploadAdyenDocumentMutationVariables
  >(UploadAdyenDocumentDocument, options)
}
export type UploadAdyenDocumentMutationHookResult = ReturnType<
  typeof useUploadAdyenDocumentMutation
>
export type UploadAdyenDocumentMutationResult =
  Apollo.MutationResult<UploadAdyenDocumentMutation>
export type UploadAdyenDocumentMutationOptions = Apollo.BaseMutationOptions<
  UploadAdyenDocumentMutation,
  UploadAdyenDocumentMutationVariables
>
export const GetAdyenRemediationActionsDocument = /*#__PURE__*/ gql`
  query GetAdyenRemediationActions {
    GetAdyenRemediationActions {
      groupings {
        errorCode
        errorMessage
        ownerID
        ownerType
        actions {
          actionID
          actionType
          unmappedRemediationActionCode
        }
      }
    }
  }
`

/**
 * __useGetAdyenRemediationActionsQuery__
 *
 * To run a query within a React component, call `useGetAdyenRemediationActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdyenRemediationActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdyenRemediationActionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdyenRemediationActionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAdyenRemediationActionsQuery,
    GetAdyenRemediationActionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetAdyenRemediationActionsQuery,
    GetAdyenRemediationActionsQueryVariables
  >(GetAdyenRemediationActionsDocument, options)
}
export function useGetAdyenRemediationActionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdyenRemediationActionsQuery,
    GetAdyenRemediationActionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAdyenRemediationActionsQuery,
    GetAdyenRemediationActionsQueryVariables
  >(GetAdyenRemediationActionsDocument, options)
}
export type GetAdyenRemediationActionsQueryHookResult = ReturnType<
  typeof useGetAdyenRemediationActionsQuery
>
export type GetAdyenRemediationActionsLazyQueryHookResult = ReturnType<
  typeof useGetAdyenRemediationActionsLazyQuery
>
export type GetAdyenRemediationActionsQueryResult = Apollo.QueryResult<
  GetAdyenRemediationActionsQuery,
  GetAdyenRemediationActionsQueryVariables
>
export const GetAdyenHostedOnboardingLinkDocument = /*#__PURE__*/ gql`
  query GetAdyenHostedOnboardingLink {
    GetAdyenHostedOnboardingLink {
      url
    }
  }
`

/**
 * __useGetAdyenHostedOnboardingLinkQuery__
 *
 * To run a query within a React component, call `useGetAdyenHostedOnboardingLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdyenHostedOnboardingLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdyenHostedOnboardingLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdyenHostedOnboardingLinkQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAdyenHostedOnboardingLinkQuery,
    GetAdyenHostedOnboardingLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetAdyenHostedOnboardingLinkQuery,
    GetAdyenHostedOnboardingLinkQueryVariables
  >(GetAdyenHostedOnboardingLinkDocument, options)
}
export function useGetAdyenHostedOnboardingLinkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdyenHostedOnboardingLinkQuery,
    GetAdyenHostedOnboardingLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAdyenHostedOnboardingLinkQuery,
    GetAdyenHostedOnboardingLinkQueryVariables
  >(GetAdyenHostedOnboardingLinkDocument, options)
}
export type GetAdyenHostedOnboardingLinkQueryHookResult = ReturnType<
  typeof useGetAdyenHostedOnboardingLinkQuery
>
export type GetAdyenHostedOnboardingLinkLazyQueryHookResult = ReturnType<
  typeof useGetAdyenHostedOnboardingLinkLazyQuery
>
export type GetAdyenHostedOnboardingLinkQueryResult = Apollo.QueryResult<
  GetAdyenHostedOnboardingLinkQuery,
  GetAdyenHostedOnboardingLinkQueryVariables
>
export const StagingStartAdyenOnboardingDocument = /*#__PURE__*/ gql`
  mutation StagingStartAdyenOnboarding {
    StagingStartAdyenOnboarding {
      validations
    }
  }
`
export type StagingStartAdyenOnboardingMutationFn = Apollo.MutationFunction<
  StagingStartAdyenOnboardingMutation,
  StagingStartAdyenOnboardingMutationVariables
>

/**
 * __useStagingStartAdyenOnboardingMutation__
 *
 * To run a mutation, you first call `useStagingStartAdyenOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStagingStartAdyenOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stagingStartAdyenOnboardingMutation, { data, loading, error }] = useStagingStartAdyenOnboardingMutation({
 *   variables: {
 *   },
 * });
 */
export function useStagingStartAdyenOnboardingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StagingStartAdyenOnboardingMutation,
    StagingStartAdyenOnboardingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    StagingStartAdyenOnboardingMutation,
    StagingStartAdyenOnboardingMutationVariables
  >(StagingStartAdyenOnboardingDocument, options)
}
export type StagingStartAdyenOnboardingMutationHookResult = ReturnType<
  typeof useStagingStartAdyenOnboardingMutation
>
export type StagingStartAdyenOnboardingMutationResult =
  Apollo.MutationResult<StagingStartAdyenOnboardingMutation>
export type StagingStartAdyenOnboardingMutationOptions =
  Apollo.BaseMutationOptions<
    StagingStartAdyenOnboardingMutation,
    StagingStartAdyenOnboardingMutationVariables
  >
export const GetAdyenPciFormsDocument = /*#__PURE__*/ gql`
  query GetAdyenPciForms {
    GetAdyenPciForms {
      pciIds
      document
    }
  }
`

/**
 * __useGetAdyenPciFormsQuery__
 *
 * To run a query within a React component, call `useGetAdyenPciFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdyenPciFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdyenPciFormsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdyenPciFormsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAdyenPciFormsQuery,
    GetAdyenPciFormsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdyenPciFormsQuery, GetAdyenPciFormsQueryVariables>(
    GetAdyenPciFormsDocument,
    options
  )
}
export function useGetAdyenPciFormsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdyenPciFormsQuery,
    GetAdyenPciFormsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAdyenPciFormsQuery,
    GetAdyenPciFormsQueryVariables
  >(GetAdyenPciFormsDocument, options)
}
export type GetAdyenPciFormsQueryHookResult = ReturnType<
  typeof useGetAdyenPciFormsQuery
>
export type GetAdyenPciFormsLazyQueryHookResult = ReturnType<
  typeof useGetAdyenPciFormsLazyQuery
>
export type GetAdyenPciFormsQueryResult = Apollo.QueryResult<
  GetAdyenPciFormsQuery,
  GetAdyenPciFormsQueryVariables
>
export const GetAdyenTermsOfServiceDocument = /*#__PURE__*/ gql`
  query GetAdyenTermsOfService {
    GetAdyenTermsOfService {
      tosID
      tosType
      document
    }
  }
`

/**
 * __useGetAdyenTermsOfServiceQuery__
 *
 * To run a query within a React component, call `useGetAdyenTermsOfServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdyenTermsOfServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdyenTermsOfServiceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdyenTermsOfServiceQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAdyenTermsOfServiceQuery,
    GetAdyenTermsOfServiceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetAdyenTermsOfServiceQuery,
    GetAdyenTermsOfServiceQueryVariables
  >(GetAdyenTermsOfServiceDocument, options)
}
export function useGetAdyenTermsOfServiceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdyenTermsOfServiceQuery,
    GetAdyenTermsOfServiceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAdyenTermsOfServiceQuery,
    GetAdyenTermsOfServiceQueryVariables
  >(GetAdyenTermsOfServiceDocument, options)
}
export type GetAdyenTermsOfServiceQueryHookResult = ReturnType<
  typeof useGetAdyenTermsOfServiceQuery
>
export type GetAdyenTermsOfServiceLazyQueryHookResult = ReturnType<
  typeof useGetAdyenTermsOfServiceLazyQuery
>
export type GetAdyenTermsOfServiceQueryResult = Apollo.QueryResult<
  GetAdyenTermsOfServiceQuery,
  GetAdyenTermsOfServiceQueryVariables
>
export const GetAdyenOnboardingStatusDocument = /*#__PURE__*/ gql`
  query GetAdyenOnboardingStatus {
    GetAdyenOnboardingStatus {
      termsOfServiceAccepted
      pciFormsSigned
      tosAndPciEntitiesCreated
    }
  }
`

/**
 * __useGetAdyenOnboardingStatusQuery__
 *
 * To run a query within a React component, call `useGetAdyenOnboardingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdyenOnboardingStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdyenOnboardingStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdyenOnboardingStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAdyenOnboardingStatusQuery,
    GetAdyenOnboardingStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetAdyenOnboardingStatusQuery,
    GetAdyenOnboardingStatusQueryVariables
  >(GetAdyenOnboardingStatusDocument, options)
}
export function useGetAdyenOnboardingStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdyenOnboardingStatusQuery,
    GetAdyenOnboardingStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAdyenOnboardingStatusQuery,
    GetAdyenOnboardingStatusQueryVariables
  >(GetAdyenOnboardingStatusDocument, options)
}
export type GetAdyenOnboardingStatusQueryHookResult = ReturnType<
  typeof useGetAdyenOnboardingStatusQuery
>
export type GetAdyenOnboardingStatusLazyQueryHookResult = ReturnType<
  typeof useGetAdyenOnboardingStatusLazyQuery
>
export type GetAdyenOnboardingStatusQueryResult = Apollo.QueryResult<
  GetAdyenOnboardingStatusQuery,
  GetAdyenOnboardingStatusQueryVariables
>
export const PartnerCreateApiKeyDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateApiKey($input: CreateApiKeyInput!) {
    PartnerCreateApiKey(input: $input) {
      key
    }
  }
`
export type PartnerCreateApiKeyMutationFn = Apollo.MutationFunction<
  PartnerCreateApiKeyMutation,
  PartnerCreateApiKeyMutationVariables
>

/**
 * __usePartnerCreateApiKeyMutation__
 *
 * To run a mutation, you first call `usePartnerCreateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateApiKeyMutation, { data, loading, error }] = usePartnerCreateApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCreateApiKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateApiKeyMutation,
    PartnerCreateApiKeyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateApiKeyMutation,
    PartnerCreateApiKeyMutationVariables
  >(PartnerCreateApiKeyDocument, options)
}
export type PartnerCreateApiKeyMutationHookResult = ReturnType<
  typeof usePartnerCreateApiKeyMutation
>
export type PartnerCreateApiKeyMutationResult =
  Apollo.MutationResult<PartnerCreateApiKeyMutation>
export type PartnerCreateApiKeyMutationOptions = Apollo.BaseMutationOptions<
  PartnerCreateApiKeyMutation,
  PartnerCreateApiKeyMutationVariables
>
export const PartnerUpdateApiKeyDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateApiKey($input: UpdateApiKeyInput!) {
    PartnerUpdateApiKey(input: $input)
  }
`
export type PartnerUpdateApiKeyMutationFn = Apollo.MutationFunction<
  PartnerUpdateApiKeyMutation,
  PartnerUpdateApiKeyMutationVariables
>

/**
 * __usePartnerUpdateApiKeyMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateApiKeyMutation, { data, loading, error }] = usePartnerUpdateApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateApiKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateApiKeyMutation,
    PartnerUpdateApiKeyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateApiKeyMutation,
    PartnerUpdateApiKeyMutationVariables
  >(PartnerUpdateApiKeyDocument, options)
}
export type PartnerUpdateApiKeyMutationHookResult = ReturnType<
  typeof usePartnerUpdateApiKeyMutation
>
export type PartnerUpdateApiKeyMutationResult =
  Apollo.MutationResult<PartnerUpdateApiKeyMutation>
export type PartnerUpdateApiKeyMutationOptions = Apollo.BaseMutationOptions<
  PartnerUpdateApiKeyMutation,
  PartnerUpdateApiKeyMutationVariables
>
export const PartnerRevokeApiKeyDocument = /*#__PURE__*/ gql`
  mutation PartnerRevokeApiKey($keyID: String!) {
    PartnerRevokeApiKey(keyID: $keyID)
  }
`
export type PartnerRevokeApiKeyMutationFn = Apollo.MutationFunction<
  PartnerRevokeApiKeyMutation,
  PartnerRevokeApiKeyMutationVariables
>

/**
 * __usePartnerRevokeApiKeyMutation__
 *
 * To run a mutation, you first call `usePartnerRevokeApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerRevokeApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerRevokeApiKeyMutation, { data, loading, error }] = usePartnerRevokeApiKeyMutation({
 *   variables: {
 *      keyID: // value for 'keyID'
 *   },
 * });
 */
export function usePartnerRevokeApiKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerRevokeApiKeyMutation,
    PartnerRevokeApiKeyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerRevokeApiKeyMutation,
    PartnerRevokeApiKeyMutationVariables
  >(PartnerRevokeApiKeyDocument, options)
}
export type PartnerRevokeApiKeyMutationHookResult = ReturnType<
  typeof usePartnerRevokeApiKeyMutation
>
export type PartnerRevokeApiKeyMutationResult =
  Apollo.MutationResult<PartnerRevokeApiKeyMutation>
export type PartnerRevokeApiKeyMutationOptions = Apollo.BaseMutationOptions<
  PartnerRevokeApiKeyMutation,
  PartnerRevokeApiKeyMutationVariables
>
export const PartnerApiKeyConnectionDocument = /*#__PURE__*/ gql`
  query PartnerApiKeyConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: ApiKeyFilter
    $orderBy: ApiKeyOrderBy
  ) {
    PartnerApiKeyConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        cursor
        node {
          ...ApiKey
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${ApiKeyFragmentDoc}
`

/**
 * __usePartnerApiKeyConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerApiKeyConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerApiKeyConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerApiKeyConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerApiKeyConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerApiKeyConnectionQuery,
    PartnerApiKeyConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerApiKeyConnectionQuery,
    PartnerApiKeyConnectionQueryVariables
  >(PartnerApiKeyConnectionDocument, options)
}
export function usePartnerApiKeyConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerApiKeyConnectionQuery,
    PartnerApiKeyConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerApiKeyConnectionQuery,
    PartnerApiKeyConnectionQueryVariables
  >(PartnerApiKeyConnectionDocument, options)
}
export type PartnerApiKeyConnectionQueryHookResult = ReturnType<
  typeof usePartnerApiKeyConnectionQuery
>
export type PartnerApiKeyConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerApiKeyConnectionLazyQuery
>
export type PartnerApiKeyConnectionQueryResult = Apollo.QueryResult<
  PartnerApiKeyConnectionQuery,
  PartnerApiKeyConnectionQueryVariables
>
export const OAuth2UrlDocument = /*#__PURE__*/ gql`
  query OAuth2Url($referralID: ID) {
    OAuth2Url(referralID: $referralID)
  }
`

/**
 * __useOAuth2UrlQuery__
 *
 * To run a query within a React component, call `useOAuth2UrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useOAuth2UrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOAuth2UrlQuery({
 *   variables: {
 *      referralID: // value for 'referralID'
 *   },
 * });
 */
export function useOAuth2UrlQuery(
  baseOptions?: Apollo.QueryHookOptions<OAuth2UrlQuery, OAuth2UrlQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OAuth2UrlQuery, OAuth2UrlQueryVariables>(
    OAuth2UrlDocument,
    options
  )
}
export function useOAuth2UrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OAuth2UrlQuery,
    OAuth2UrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OAuth2UrlQuery, OAuth2UrlQueryVariables>(
    OAuth2UrlDocument,
    options
  )
}
export type OAuth2UrlQueryHookResult = ReturnType<typeof useOAuth2UrlQuery>
export type OAuth2UrlLazyQueryHookResult = ReturnType<
  typeof useOAuth2UrlLazyQuery
>
export type OAuth2UrlQueryResult = Apollo.QueryResult<
  OAuth2UrlQuery,
  OAuth2UrlQueryVariables
>
export const OAuth2ExchangeDocument = /*#__PURE__*/ gql`
  mutation OAuth2Exchange($code: String!, $state: String!) {
    OAuth2Exchange(code: $code, state: $state) {
      ...Token
    }
  }
  ${TokenFragmentDoc}
`
export type OAuth2ExchangeMutationFn = Apollo.MutationFunction<
  OAuth2ExchangeMutation,
  OAuth2ExchangeMutationVariables
>

/**
 * __useOAuth2ExchangeMutation__
 *
 * To run a mutation, you first call `useOAuth2ExchangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOAuth2ExchangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oAuth2ExchangeMutation, { data, loading, error }] = useOAuth2ExchangeMutation({
 *   variables: {
 *      code: // value for 'code'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useOAuth2ExchangeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OAuth2ExchangeMutation,
    OAuth2ExchangeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    OAuth2ExchangeMutation,
    OAuth2ExchangeMutationVariables
  >(OAuth2ExchangeDocument, options)
}
export type OAuth2ExchangeMutationHookResult = ReturnType<
  typeof useOAuth2ExchangeMutation
>
export type OAuth2ExchangeMutationResult =
  Apollo.MutationResult<OAuth2ExchangeMutation>
export type OAuth2ExchangeMutationOptions = Apollo.BaseMutationOptions<
  OAuth2ExchangeMutation,
  OAuth2ExchangeMutationVariables
>
export const OAuth2RefreshDocument = /*#__PURE__*/ gql`
  mutation OAuth2Refresh($refreshToken: String!) {
    OAuth2Refresh(refreshToken: $refreshToken) {
      ...Token
    }
  }
  ${TokenFragmentDoc}
`
export type OAuth2RefreshMutationFn = Apollo.MutationFunction<
  OAuth2RefreshMutation,
  OAuth2RefreshMutationVariables
>

/**
 * __useOAuth2RefreshMutation__
 *
 * To run a mutation, you first call `useOAuth2RefreshMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOAuth2RefreshMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oAuth2RefreshMutation, { data, loading, error }] = useOAuth2RefreshMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useOAuth2RefreshMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OAuth2RefreshMutation,
    OAuth2RefreshMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    OAuth2RefreshMutation,
    OAuth2RefreshMutationVariables
  >(OAuth2RefreshDocument, options)
}
export type OAuth2RefreshMutationHookResult = ReturnType<
  typeof useOAuth2RefreshMutation
>
export type OAuth2RefreshMutationResult =
  Apollo.MutationResult<OAuth2RefreshMutation>
export type OAuth2RefreshMutationOptions = Apollo.BaseMutationOptions<
  OAuth2RefreshMutation,
  OAuth2RefreshMutationVariables
>
export const PartnerListAutopayExcludedInvoicesDocument = /*#__PURE__*/ gql`
  query PartnerListAutopayExcludedInvoices($invoiceIDs: [ID!]) {
    PartnerListAutopayExcludedInvoices(invoiceIDs: $invoiceIDs) {
      invoiceID
      excludedBy
    }
  }
`

/**
 * __usePartnerListAutopayExcludedInvoicesQuery__
 *
 * To run a query within a React component, call `usePartnerListAutopayExcludedInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListAutopayExcludedInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListAutopayExcludedInvoicesQuery({
 *   variables: {
 *      invoiceIDs: // value for 'invoiceIDs'
 *   },
 * });
 */
export function usePartnerListAutopayExcludedInvoicesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListAutopayExcludedInvoicesQuery,
    PartnerListAutopayExcludedInvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListAutopayExcludedInvoicesQuery,
    PartnerListAutopayExcludedInvoicesQueryVariables
  >(PartnerListAutopayExcludedInvoicesDocument, options)
}
export function usePartnerListAutopayExcludedInvoicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListAutopayExcludedInvoicesQuery,
    PartnerListAutopayExcludedInvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListAutopayExcludedInvoicesQuery,
    PartnerListAutopayExcludedInvoicesQueryVariables
  >(PartnerListAutopayExcludedInvoicesDocument, options)
}
export type PartnerListAutopayExcludedInvoicesQueryHookResult = ReturnType<
  typeof usePartnerListAutopayExcludedInvoicesQuery
>
export type PartnerListAutopayExcludedInvoicesLazyQueryHookResult = ReturnType<
  typeof usePartnerListAutopayExcludedInvoicesLazyQuery
>
export type PartnerListAutopayExcludedInvoicesQueryResult = Apollo.QueryResult<
  PartnerListAutopayExcludedInvoicesQuery,
  PartnerListAutopayExcludedInvoicesQueryVariables
>
export const FindAutopayRuleDocument = /*#__PURE__*/ gql`
  query FindAutopayRule($id: ID!) {
    FindAutopayRule(id: $id) {
      ...FindAutopayRule
    }
  }
  ${FindAutopayRuleFragmentDoc}
`

/**
 * __useFindAutopayRuleQuery__
 *
 * To run a query within a React component, call `useFindAutopayRuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAutopayRuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAutopayRuleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindAutopayRuleQuery(
  baseOptions: Apollo.QueryHookOptions<
    FindAutopayRuleQuery,
    FindAutopayRuleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FindAutopayRuleQuery, FindAutopayRuleQueryVariables>(
    FindAutopayRuleDocument,
    options
  )
}
export function useFindAutopayRuleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FindAutopayRuleQuery,
    FindAutopayRuleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    FindAutopayRuleQuery,
    FindAutopayRuleQueryVariables
  >(FindAutopayRuleDocument, options)
}
export type FindAutopayRuleQueryHookResult = ReturnType<
  typeof useFindAutopayRuleQuery
>
export type FindAutopayRuleLazyQueryHookResult = ReturnType<
  typeof useFindAutopayRuleLazyQuery
>
export type FindAutopayRuleQueryResult = Apollo.QueryResult<
  FindAutopayRuleQuery,
  FindAutopayRuleQueryVariables
>
export const PartnerAutopayExcludedInvoiceDeleteDocument = /*#__PURE__*/ gql`
  mutation PartnerAutopayExcludedInvoiceDelete($invoiceID: ID!) {
    PartnerAutopayExcludedInvoiceDelete(invoiceID: $invoiceID)
  }
`
export type PartnerAutopayExcludedInvoiceDeleteMutationFn =
  Apollo.MutationFunction<
    PartnerAutopayExcludedInvoiceDeleteMutation,
    PartnerAutopayExcludedInvoiceDeleteMutationVariables
  >

/**
 * __usePartnerAutopayExcludedInvoiceDeleteMutation__
 *
 * To run a mutation, you first call `usePartnerAutopayExcludedInvoiceDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAutopayExcludedInvoiceDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAutopayExcludedInvoiceDeleteMutation, { data, loading, error }] = usePartnerAutopayExcludedInvoiceDeleteMutation({
 *   variables: {
 *      invoiceID: // value for 'invoiceID'
 *   },
 * });
 */
export function usePartnerAutopayExcludedInvoiceDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAutopayExcludedInvoiceDeleteMutation,
    PartnerAutopayExcludedInvoiceDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAutopayExcludedInvoiceDeleteMutation,
    PartnerAutopayExcludedInvoiceDeleteMutationVariables
  >(PartnerAutopayExcludedInvoiceDeleteDocument, options)
}
export type PartnerAutopayExcludedInvoiceDeleteMutationHookResult = ReturnType<
  typeof usePartnerAutopayExcludedInvoiceDeleteMutation
>
export type PartnerAutopayExcludedInvoiceDeleteMutationResult =
  Apollo.MutationResult<PartnerAutopayExcludedInvoiceDeleteMutation>
export type PartnerAutopayExcludedInvoiceDeleteMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAutopayExcludedInvoiceDeleteMutation,
    PartnerAutopayExcludedInvoiceDeleteMutationVariables
  >
export const PartnerAutopayExcludedInvoiceCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerAutopayExcludedInvoiceCreate(
    $customerID: ID!
    $invoiceID: ID!
  ) {
    PartnerAutopayExcludedInvoiceCreate(
      customerID: $customerID
      invoiceID: $invoiceID
    )
  }
`
export type PartnerAutopayExcludedInvoiceCreateMutationFn =
  Apollo.MutationFunction<
    PartnerAutopayExcludedInvoiceCreateMutation,
    PartnerAutopayExcludedInvoiceCreateMutationVariables
  >

/**
 * __usePartnerAutopayExcludedInvoiceCreateMutation__
 *
 * To run a mutation, you first call `usePartnerAutopayExcludedInvoiceCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAutopayExcludedInvoiceCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAutopayExcludedInvoiceCreateMutation, { data, loading, error }] = usePartnerAutopayExcludedInvoiceCreateMutation({
 *   variables: {
 *      customerID: // value for 'customerID'
 *      invoiceID: // value for 'invoiceID'
 *   },
 * });
 */
export function usePartnerAutopayExcludedInvoiceCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAutopayExcludedInvoiceCreateMutation,
    PartnerAutopayExcludedInvoiceCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAutopayExcludedInvoiceCreateMutation,
    PartnerAutopayExcludedInvoiceCreateMutationVariables
  >(PartnerAutopayExcludedInvoiceCreateDocument, options)
}
export type PartnerAutopayExcludedInvoiceCreateMutationHookResult = ReturnType<
  typeof usePartnerAutopayExcludedInvoiceCreateMutation
>
export type PartnerAutopayExcludedInvoiceCreateMutationResult =
  Apollo.MutationResult<PartnerAutopayExcludedInvoiceCreateMutation>
export type PartnerAutopayExcludedInvoiceCreateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAutopayExcludedInvoiceCreateMutation,
    PartnerAutopayExcludedInvoiceCreateMutationVariables
  >
export const PartnerAutopayExcludedInvoiceBatchCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerAutopayExcludedInvoiceBatchCreate(
    $invoices: [AutopayExcludedInvoiceCreateInput!]!
  ) {
    PartnerAutopayExcludedInvoiceBatchCreate(excludeInvoices: $invoices)
  }
`
export type PartnerAutopayExcludedInvoiceBatchCreateMutationFn =
  Apollo.MutationFunction<
    PartnerAutopayExcludedInvoiceBatchCreateMutation,
    PartnerAutopayExcludedInvoiceBatchCreateMutationVariables
  >

/**
 * __usePartnerAutopayExcludedInvoiceBatchCreateMutation__
 *
 * To run a mutation, you first call `usePartnerAutopayExcludedInvoiceBatchCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAutopayExcludedInvoiceBatchCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAutopayExcludedInvoiceBatchCreateMutation, { data, loading, error }] = usePartnerAutopayExcludedInvoiceBatchCreateMutation({
 *   variables: {
 *      invoices: // value for 'invoices'
 *   },
 * });
 */
export function usePartnerAutopayExcludedInvoiceBatchCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAutopayExcludedInvoiceBatchCreateMutation,
    PartnerAutopayExcludedInvoiceBatchCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAutopayExcludedInvoiceBatchCreateMutation,
    PartnerAutopayExcludedInvoiceBatchCreateMutationVariables
  >(PartnerAutopayExcludedInvoiceBatchCreateDocument, options)
}
export type PartnerAutopayExcludedInvoiceBatchCreateMutationHookResult =
  ReturnType<typeof usePartnerAutopayExcludedInvoiceBatchCreateMutation>
export type PartnerAutopayExcludedInvoiceBatchCreateMutationResult =
  Apollo.MutationResult<PartnerAutopayExcludedInvoiceBatchCreateMutation>
export type PartnerAutopayExcludedInvoiceBatchCreateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAutopayExcludedInvoiceBatchCreateMutation,
    PartnerAutopayExcludedInvoiceBatchCreateMutationVariables
  >
export const PartnerGetCoveredInvoicesForRuleDocument = /*#__PURE__*/ gql`
  query PartnerGetCoveredInvoicesForRule(
    $input: PartnerGetCoveredInvoicesForRuleInput!
  ) {
    PartnerGetCoveredInvoicesForRule(input: $input) {
      ...InvoiceCovered
    }
  }
  ${InvoiceCoveredFragmentDoc}
`

/**
 * __usePartnerGetCoveredInvoicesForRuleQuery__
 *
 * To run a query within a React component, call `usePartnerGetCoveredInvoicesForRuleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetCoveredInvoicesForRuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetCoveredInvoicesForRuleQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerGetCoveredInvoicesForRuleQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetCoveredInvoicesForRuleQuery,
    PartnerGetCoveredInvoicesForRuleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetCoveredInvoicesForRuleQuery,
    PartnerGetCoveredInvoicesForRuleQueryVariables
  >(PartnerGetCoveredInvoicesForRuleDocument, options)
}
export function usePartnerGetCoveredInvoicesForRuleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetCoveredInvoicesForRuleQuery,
    PartnerGetCoveredInvoicesForRuleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetCoveredInvoicesForRuleQuery,
    PartnerGetCoveredInvoicesForRuleQueryVariables
  >(PartnerGetCoveredInvoicesForRuleDocument, options)
}
export type PartnerGetCoveredInvoicesForRuleQueryHookResult = ReturnType<
  typeof usePartnerGetCoveredInvoicesForRuleQuery
>
export type PartnerGetCoveredInvoicesForRuleLazyQueryHookResult = ReturnType<
  typeof usePartnerGetCoveredInvoicesForRuleLazyQuery
>
export type PartnerGetCoveredInvoicesForRuleQueryResult = Apollo.QueryResult<
  PartnerGetCoveredInvoicesForRuleQuery,
  PartnerGetCoveredInvoicesForRuleQueryVariables
>
export const PartnerGlobalAutopayRuleConnectionDocument = /*#__PURE__*/ gql`
  query PartnerGlobalAutopayRuleConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $orderBy: AutopayRuleOrderBy
  ) {
    PartnerGlobalAutopayRuleConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...AutopayRules
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${AutopayRulesFragmentDoc}
`

/**
 * __usePartnerGlobalAutopayRuleConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerGlobalAutopayRuleConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGlobalAutopayRuleConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGlobalAutopayRuleConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerGlobalAutopayRuleConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGlobalAutopayRuleConnectionQuery,
    PartnerGlobalAutopayRuleConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGlobalAutopayRuleConnectionQuery,
    PartnerGlobalAutopayRuleConnectionQueryVariables
  >(PartnerGlobalAutopayRuleConnectionDocument, options)
}
export function usePartnerGlobalAutopayRuleConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGlobalAutopayRuleConnectionQuery,
    PartnerGlobalAutopayRuleConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGlobalAutopayRuleConnectionQuery,
    PartnerGlobalAutopayRuleConnectionQueryVariables
  >(PartnerGlobalAutopayRuleConnectionDocument, options)
}
export type PartnerGlobalAutopayRuleConnectionQueryHookResult = ReturnType<
  typeof usePartnerGlobalAutopayRuleConnectionQuery
>
export type PartnerGlobalAutopayRuleConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerGlobalAutopayRuleConnectionLazyQuery
>
export type PartnerGlobalAutopayRuleConnectionQueryResult = Apollo.QueryResult<
  PartnerGlobalAutopayRuleConnectionQuery,
  PartnerGlobalAutopayRuleConnectionQueryVariables
>
export const PartnerCustomerAutopayRuleWithBankingAndCardConnectionDocument = /*#__PURE__*/ gql`
  query PartnerCustomerAutopayRuleWithBankingAndCardConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: AutopayRuleFilter
    $orderBy: AutopayRuleOrderBy
  ) {
    PartnerCustomerAutopayRuleConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...AutopayRulesWithBankingAndCard
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${AutopayRulesWithBankingAndCardFragmentDoc}
`

/**
 * __usePartnerCustomerAutopayRuleWithBankingAndCardConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerCustomerAutopayRuleWithBankingAndCardConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerAutopayRuleWithBankingAndCardConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCustomerAutopayRuleWithBankingAndCardConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerCustomerAutopayRuleWithBankingAndCardConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerCustomerAutopayRuleWithBankingAndCardConnectionQuery,
    PartnerCustomerAutopayRuleWithBankingAndCardConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerCustomerAutopayRuleWithBankingAndCardConnectionQuery,
    PartnerCustomerAutopayRuleWithBankingAndCardConnectionQueryVariables
  >(PartnerCustomerAutopayRuleWithBankingAndCardConnectionDocument, options)
}
export function usePartnerCustomerAutopayRuleWithBankingAndCardConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerCustomerAutopayRuleWithBankingAndCardConnectionQuery,
    PartnerCustomerAutopayRuleWithBankingAndCardConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerCustomerAutopayRuleWithBankingAndCardConnectionQuery,
    PartnerCustomerAutopayRuleWithBankingAndCardConnectionQueryVariables
  >(PartnerCustomerAutopayRuleWithBankingAndCardConnectionDocument, options)
}
export type PartnerCustomerAutopayRuleWithBankingAndCardConnectionQueryHookResult =
  ReturnType<
    typeof usePartnerCustomerAutopayRuleWithBankingAndCardConnectionQuery
  >
export type PartnerCustomerAutopayRuleWithBankingAndCardConnectionLazyQueryHookResult =
  ReturnType<
    typeof usePartnerCustomerAutopayRuleWithBankingAndCardConnectionLazyQuery
  >
export type PartnerCustomerAutopayRuleWithBankingAndCardConnectionQueryResult =
  Apollo.QueryResult<
    PartnerCustomerAutopayRuleWithBankingAndCardConnectionQuery,
    PartnerCustomerAutopayRuleWithBankingAndCardConnectionQueryVariables
  >
export const PartnerCustomerAutopayRuleConnectionDocument = /*#__PURE__*/ gql`
  query PartnerCustomerAutopayRuleConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: AutopayRuleFilter
    $orderBy: AutopayRuleOrderBy
  ) {
    PartnerCustomerAutopayRuleConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...AutopayRules
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${AutopayRulesFragmentDoc}
`

/**
 * __usePartnerCustomerAutopayRuleConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerCustomerAutopayRuleConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerAutopayRuleConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCustomerAutopayRuleConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerCustomerAutopayRuleConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerCustomerAutopayRuleConnectionQuery,
    PartnerCustomerAutopayRuleConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerCustomerAutopayRuleConnectionQuery,
    PartnerCustomerAutopayRuleConnectionQueryVariables
  >(PartnerCustomerAutopayRuleConnectionDocument, options)
}
export function usePartnerCustomerAutopayRuleConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerCustomerAutopayRuleConnectionQuery,
    PartnerCustomerAutopayRuleConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerCustomerAutopayRuleConnectionQuery,
    PartnerCustomerAutopayRuleConnectionQueryVariables
  >(PartnerCustomerAutopayRuleConnectionDocument, options)
}
export type PartnerCustomerAutopayRuleConnectionQueryHookResult = ReturnType<
  typeof usePartnerCustomerAutopayRuleConnectionQuery
>
export type PartnerCustomerAutopayRuleConnectionLazyQueryHookResult =
  ReturnType<typeof usePartnerCustomerAutopayRuleConnectionLazyQuery>
export type PartnerCustomerAutopayRuleConnectionQueryResult =
  Apollo.QueryResult<
    PartnerCustomerAutopayRuleConnectionQuery,
    PartnerCustomerAutopayRuleConnectionQueryVariables
  >
export const PartnerCustomerTagsAutopayRuleConnectionDocument = /*#__PURE__*/ gql`
  query PartnerCustomerTagsAutopayRuleConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: AutopayRuleFilter
    $orderBy: AutopayRuleOrderBy
  ) {
    PartnerCustomerTagsAutopayRuleConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...AutopayRules
          tagIDs
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${AutopayRulesFragmentDoc}
`

/**
 * __usePartnerCustomerTagsAutopayRuleConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerCustomerTagsAutopayRuleConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerTagsAutopayRuleConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCustomerTagsAutopayRuleConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerCustomerTagsAutopayRuleConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerCustomerTagsAutopayRuleConnectionQuery,
    PartnerCustomerTagsAutopayRuleConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerCustomerTagsAutopayRuleConnectionQuery,
    PartnerCustomerTagsAutopayRuleConnectionQueryVariables
  >(PartnerCustomerTagsAutopayRuleConnectionDocument, options)
}
export function usePartnerCustomerTagsAutopayRuleConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerCustomerTagsAutopayRuleConnectionQuery,
    PartnerCustomerTagsAutopayRuleConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerCustomerTagsAutopayRuleConnectionQuery,
    PartnerCustomerTagsAutopayRuleConnectionQueryVariables
  >(PartnerCustomerTagsAutopayRuleConnectionDocument, options)
}
export type PartnerCustomerTagsAutopayRuleConnectionQueryHookResult =
  ReturnType<typeof usePartnerCustomerTagsAutopayRuleConnectionQuery>
export type PartnerCustomerTagsAutopayRuleConnectionLazyQueryHookResult =
  ReturnType<typeof usePartnerCustomerTagsAutopayRuleConnectionLazyQuery>
export type PartnerCustomerTagsAutopayRuleConnectionQueryResult =
  Apollo.QueryResult<
    PartnerCustomerTagsAutopayRuleConnectionQuery,
    PartnerCustomerTagsAutopayRuleConnectionQueryVariables
  >
export const PartnerListCustomerRulesTotalsDocument = /*#__PURE__*/ gql`
  query PartnerListCustomerRulesTotals($customerID: ID) {
    PartnerListCustomerRulesTotals(customerID: $customerID) {
      count
    }
  }
`

/**
 * __usePartnerListCustomerRulesTotalsQuery__
 *
 * To run a query within a React component, call `usePartnerListCustomerRulesTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListCustomerRulesTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListCustomerRulesTotalsQuery({
 *   variables: {
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerListCustomerRulesTotalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListCustomerRulesTotalsQuery,
    PartnerListCustomerRulesTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListCustomerRulesTotalsQuery,
    PartnerListCustomerRulesTotalsQueryVariables
  >(PartnerListCustomerRulesTotalsDocument, options)
}
export function usePartnerListCustomerRulesTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListCustomerRulesTotalsQuery,
    PartnerListCustomerRulesTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListCustomerRulesTotalsQuery,
    PartnerListCustomerRulesTotalsQueryVariables
  >(PartnerListCustomerRulesTotalsDocument, options)
}
export type PartnerListCustomerRulesTotalsQueryHookResult = ReturnType<
  typeof usePartnerListCustomerRulesTotalsQuery
>
export type PartnerListCustomerRulesTotalsLazyQueryHookResult = ReturnType<
  typeof usePartnerListCustomerRulesTotalsLazyQuery
>
export type PartnerListCustomerRulesTotalsQueryResult = Apollo.QueryResult<
  PartnerListCustomerRulesTotalsQuery,
  PartnerListCustomerRulesTotalsQueryVariables
>
export const PartnerAutopayExcludedCustomerConnectionDocument = /*#__PURE__*/ gql`
  query PartnerAutopayExcludedCustomerConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: AutopayExcludedCustomerFilter
    $orderBy: AutopayExcludedCustomerOrderBy
  ) {
    PartnerAutopayExcludedCustomerConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...AutopayExcludedList
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${AutopayExcludedListFragmentDoc}
`

/**
 * __usePartnerAutopayExcludedCustomerConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerAutopayExcludedCustomerConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerAutopayExcludedCustomerConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerAutopayExcludedCustomerConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerAutopayExcludedCustomerConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerAutopayExcludedCustomerConnectionQuery,
    PartnerAutopayExcludedCustomerConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerAutopayExcludedCustomerConnectionQuery,
    PartnerAutopayExcludedCustomerConnectionQueryVariables
  >(PartnerAutopayExcludedCustomerConnectionDocument, options)
}
export function usePartnerAutopayExcludedCustomerConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerAutopayExcludedCustomerConnectionQuery,
    PartnerAutopayExcludedCustomerConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerAutopayExcludedCustomerConnectionQuery,
    PartnerAutopayExcludedCustomerConnectionQueryVariables
  >(PartnerAutopayExcludedCustomerConnectionDocument, options)
}
export type PartnerAutopayExcludedCustomerConnectionQueryHookResult =
  ReturnType<typeof usePartnerAutopayExcludedCustomerConnectionQuery>
export type PartnerAutopayExcludedCustomerConnectionLazyQueryHookResult =
  ReturnType<typeof usePartnerAutopayExcludedCustomerConnectionLazyQuery>
export type PartnerAutopayExcludedCustomerConnectionQueryResult =
  Apollo.QueryResult<
    PartnerAutopayExcludedCustomerConnectionQuery,
    PartnerAutopayExcludedCustomerConnectionQueryVariables
  >
export const PartnerAutopayExcludedCustomerListTotalsDocument = /*#__PURE__*/ gql`
  query PartnerAutopayExcludedCustomerListTotals(
    $filters: AutopayExcludedCustomerFilter
  ) {
    PartnerAutopayExcludedCustomerListTotals(filters: $filters) {
      count
    }
  }
`

/**
 * __usePartnerAutopayExcludedCustomerListTotalsQuery__
 *
 * To run a query within a React component, call `usePartnerAutopayExcludedCustomerListTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerAutopayExcludedCustomerListTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerAutopayExcludedCustomerListTotalsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePartnerAutopayExcludedCustomerListTotalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerAutopayExcludedCustomerListTotalsQuery,
    PartnerAutopayExcludedCustomerListTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerAutopayExcludedCustomerListTotalsQuery,
    PartnerAutopayExcludedCustomerListTotalsQueryVariables
  >(PartnerAutopayExcludedCustomerListTotalsDocument, options)
}
export function usePartnerAutopayExcludedCustomerListTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerAutopayExcludedCustomerListTotalsQuery,
    PartnerAutopayExcludedCustomerListTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerAutopayExcludedCustomerListTotalsQuery,
    PartnerAutopayExcludedCustomerListTotalsQueryVariables
  >(PartnerAutopayExcludedCustomerListTotalsDocument, options)
}
export type PartnerAutopayExcludedCustomerListTotalsQueryHookResult =
  ReturnType<typeof usePartnerAutopayExcludedCustomerListTotalsQuery>
export type PartnerAutopayExcludedCustomerListTotalsLazyQueryHookResult =
  ReturnType<typeof usePartnerAutopayExcludedCustomerListTotalsLazyQuery>
export type PartnerAutopayExcludedCustomerListTotalsQueryResult =
  Apollo.QueryResult<
    PartnerAutopayExcludedCustomerListTotalsQuery,
    PartnerAutopayExcludedCustomerListTotalsQueryVariables
  >
export const PartnerCreateAutopayRuleDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateAutopayRule($input: PartnerCreateAutopayRuleInput!) {
    PartnerCreateAutopayRule(input: $input) {
      ...AutopayRules
    }
  }
  ${AutopayRulesFragmentDoc}
`
export type PartnerCreateAutopayRuleMutationFn = Apollo.MutationFunction<
  PartnerCreateAutopayRuleMutation,
  PartnerCreateAutopayRuleMutationVariables
>

/**
 * __usePartnerCreateAutopayRuleMutation__
 *
 * To run a mutation, you first call `usePartnerCreateAutopayRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateAutopayRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateAutopayRuleMutation, { data, loading, error }] = usePartnerCreateAutopayRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCreateAutopayRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateAutopayRuleMutation,
    PartnerCreateAutopayRuleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateAutopayRuleMutation,
    PartnerCreateAutopayRuleMutationVariables
  >(PartnerCreateAutopayRuleDocument, options)
}
export type PartnerCreateAutopayRuleMutationHookResult = ReturnType<
  typeof usePartnerCreateAutopayRuleMutation
>
export type PartnerCreateAutopayRuleMutationResult =
  Apollo.MutationResult<PartnerCreateAutopayRuleMutation>
export type PartnerCreateAutopayRuleMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCreateAutopayRuleMutation,
    PartnerCreateAutopayRuleMutationVariables
  >
export const PartnerUpdateAutopayRuleDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateAutopayRule($input: PartnerUpdateAutopayRuleInput!) {
    PartnerUpdateAutopayRule(input: $input) {
      ...AutopayRules
    }
  }
  ${AutopayRulesFragmentDoc}
`
export type PartnerUpdateAutopayRuleMutationFn = Apollo.MutationFunction<
  PartnerUpdateAutopayRuleMutation,
  PartnerUpdateAutopayRuleMutationVariables
>

/**
 * __usePartnerUpdateAutopayRuleMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateAutopayRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateAutopayRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateAutopayRuleMutation, { data, loading, error }] = usePartnerUpdateAutopayRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateAutopayRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateAutopayRuleMutation,
    PartnerUpdateAutopayRuleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateAutopayRuleMutation,
    PartnerUpdateAutopayRuleMutationVariables
  >(PartnerUpdateAutopayRuleDocument, options)
}
export type PartnerUpdateAutopayRuleMutationHookResult = ReturnType<
  typeof usePartnerUpdateAutopayRuleMutation
>
export type PartnerUpdateAutopayRuleMutationResult =
  Apollo.MutationResult<PartnerUpdateAutopayRuleMutation>
export type PartnerUpdateAutopayRuleMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateAutopayRuleMutation,
    PartnerUpdateAutopayRuleMutationVariables
  >
export const PartnerDeleteAutopayRuleDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteAutopayRule($id: ID!) {
    PartnerDeleteAutopayRule(id: $id)
  }
`
export type PartnerDeleteAutopayRuleMutationFn = Apollo.MutationFunction<
  PartnerDeleteAutopayRuleMutation,
  PartnerDeleteAutopayRuleMutationVariables
>

/**
 * __usePartnerDeleteAutopayRuleMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteAutopayRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteAutopayRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteAutopayRuleMutation, { data, loading, error }] = usePartnerDeleteAutopayRuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerDeleteAutopayRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteAutopayRuleMutation,
    PartnerDeleteAutopayRuleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteAutopayRuleMutation,
    PartnerDeleteAutopayRuleMutationVariables
  >(PartnerDeleteAutopayRuleDocument, options)
}
export type PartnerDeleteAutopayRuleMutationHookResult = ReturnType<
  typeof usePartnerDeleteAutopayRuleMutation
>
export type PartnerDeleteAutopayRuleMutationResult =
  Apollo.MutationResult<PartnerDeleteAutopayRuleMutation>
export type PartnerDeleteAutopayRuleMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerDeleteAutopayRuleMutation,
    PartnerDeleteAutopayRuleMutationVariables
  >
export const PartnerAutopayExcludedCustomerCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerAutopayExcludedCustomerCreate($customerID: ID!) {
    PartnerAutopayExcludedCustomerCreate(customerID: $customerID) {
      id
      customer {
        id
        name
      }
    }
  }
`
export type PartnerAutopayExcludedCustomerCreateMutationFn =
  Apollo.MutationFunction<
    PartnerAutopayExcludedCustomerCreateMutation,
    PartnerAutopayExcludedCustomerCreateMutationVariables
  >

/**
 * __usePartnerAutopayExcludedCustomerCreateMutation__
 *
 * To run a mutation, you first call `usePartnerAutopayExcludedCustomerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAutopayExcludedCustomerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAutopayExcludedCustomerCreateMutation, { data, loading, error }] = usePartnerAutopayExcludedCustomerCreateMutation({
 *   variables: {
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerAutopayExcludedCustomerCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAutopayExcludedCustomerCreateMutation,
    PartnerAutopayExcludedCustomerCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAutopayExcludedCustomerCreateMutation,
    PartnerAutopayExcludedCustomerCreateMutationVariables
  >(PartnerAutopayExcludedCustomerCreateDocument, options)
}
export type PartnerAutopayExcludedCustomerCreateMutationHookResult = ReturnType<
  typeof usePartnerAutopayExcludedCustomerCreateMutation
>
export type PartnerAutopayExcludedCustomerCreateMutationResult =
  Apollo.MutationResult<PartnerAutopayExcludedCustomerCreateMutation>
export type PartnerAutopayExcludedCustomerCreateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAutopayExcludedCustomerCreateMutation,
    PartnerAutopayExcludedCustomerCreateMutationVariables
  >
export const PartnerAutopayExcludedCustomerUpdateDocument = /*#__PURE__*/ gql`
  mutation PartnerAutopayExcludedCustomerUpdate($customerIDs: [ID!]) {
    PartnerAutopayExcludedCustomerUpdate(customerIDs: $customerIDs) {
      id
      customer {
        id
        name
      }
    }
  }
`
export type PartnerAutopayExcludedCustomerUpdateMutationFn =
  Apollo.MutationFunction<
    PartnerAutopayExcludedCustomerUpdateMutation,
    PartnerAutopayExcludedCustomerUpdateMutationVariables
  >

/**
 * __usePartnerAutopayExcludedCustomerUpdateMutation__
 *
 * To run a mutation, you first call `usePartnerAutopayExcludedCustomerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAutopayExcludedCustomerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAutopayExcludedCustomerUpdateMutation, { data, loading, error }] = usePartnerAutopayExcludedCustomerUpdateMutation({
 *   variables: {
 *      customerIDs: // value for 'customerIDs'
 *   },
 * });
 */
export function usePartnerAutopayExcludedCustomerUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAutopayExcludedCustomerUpdateMutation,
    PartnerAutopayExcludedCustomerUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAutopayExcludedCustomerUpdateMutation,
    PartnerAutopayExcludedCustomerUpdateMutationVariables
  >(PartnerAutopayExcludedCustomerUpdateDocument, options)
}
export type PartnerAutopayExcludedCustomerUpdateMutationHookResult = ReturnType<
  typeof usePartnerAutopayExcludedCustomerUpdateMutation
>
export type PartnerAutopayExcludedCustomerUpdateMutationResult =
  Apollo.MutationResult<PartnerAutopayExcludedCustomerUpdateMutation>
export type PartnerAutopayExcludedCustomerUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAutopayExcludedCustomerUpdateMutation,
    PartnerAutopayExcludedCustomerUpdateMutationVariables
  >
export const PartnerAutopayExcludedCustomerDeleteDocument = /*#__PURE__*/ gql`
  mutation PartnerAutopayExcludedCustomerDelete($customerID: ID!) {
    PartnerAutopayExcludedCustomerDelete(customerID: $customerID)
  }
`
export type PartnerAutopayExcludedCustomerDeleteMutationFn =
  Apollo.MutationFunction<
    PartnerAutopayExcludedCustomerDeleteMutation,
    PartnerAutopayExcludedCustomerDeleteMutationVariables
  >

/**
 * __usePartnerAutopayExcludedCustomerDeleteMutation__
 *
 * To run a mutation, you first call `usePartnerAutopayExcludedCustomerDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAutopayExcludedCustomerDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAutopayExcludedCustomerDeleteMutation, { data, loading, error }] = usePartnerAutopayExcludedCustomerDeleteMutation({
 *   variables: {
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerAutopayExcludedCustomerDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAutopayExcludedCustomerDeleteMutation,
    PartnerAutopayExcludedCustomerDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAutopayExcludedCustomerDeleteMutation,
    PartnerAutopayExcludedCustomerDeleteMutationVariables
  >(PartnerAutopayExcludedCustomerDeleteDocument, options)
}
export type PartnerAutopayExcludedCustomerDeleteMutationHookResult = ReturnType<
  typeof usePartnerAutopayExcludedCustomerDeleteMutation
>
export type PartnerAutopayExcludedCustomerDeleteMutationResult =
  Apollo.MutationResult<PartnerAutopayExcludedCustomerDeleteMutation>
export type PartnerAutopayExcludedCustomerDeleteMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAutopayExcludedCustomerDeleteMutation,
    PartnerAutopayExcludedCustomerDeleteMutationVariables
  >
export const GetCustomerAutopayConfigDocument = /*#__PURE__*/ gql`
  query GetCustomerAutopayConfig($input: GetCustomerAutopayConfigInput!) {
    GetCustomerAutopayConfig(input: $input) {
      ...CustomerAutopayConfig
    }
  }
  ${CustomerAutopayConfigFragmentDoc}
`

/**
 * __useGetCustomerAutopayConfigQuery__
 *
 * To run a query within a React component, call `useGetCustomerAutopayConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerAutopayConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerAutopayConfigQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCustomerAutopayConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCustomerAutopayConfigQuery,
    GetCustomerAutopayConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetCustomerAutopayConfigQuery,
    GetCustomerAutopayConfigQueryVariables
  >(GetCustomerAutopayConfigDocument, options)
}
export function useGetCustomerAutopayConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerAutopayConfigQuery,
    GetCustomerAutopayConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetCustomerAutopayConfigQuery,
    GetCustomerAutopayConfigQueryVariables
  >(GetCustomerAutopayConfigDocument, options)
}
export type GetCustomerAutopayConfigQueryHookResult = ReturnType<
  typeof useGetCustomerAutopayConfigQuery
>
export type GetCustomerAutopayConfigLazyQueryHookResult = ReturnType<
  typeof useGetCustomerAutopayConfigLazyQuery
>
export type GetCustomerAutopayConfigQueryResult = Apollo.QueryResult<
  GetCustomerAutopayConfigQuery,
  GetCustomerAutopayConfigQueryVariables
>
export const SetCustomerAutopayConfigDocument = /*#__PURE__*/ gql`
  mutation SetCustomerAutopayConfig($input: UpsertCustomerAutopayConfigInput!) {
    SetCustomerAutopayConfig(input: $input)
  }
`
export type SetCustomerAutopayConfigMutationFn = Apollo.MutationFunction<
  SetCustomerAutopayConfigMutation,
  SetCustomerAutopayConfigMutationVariables
>

/**
 * __useSetCustomerAutopayConfigMutation__
 *
 * To run a mutation, you first call `useSetCustomerAutopayConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCustomerAutopayConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCustomerAutopayConfigMutation, { data, loading, error }] = useSetCustomerAutopayConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCustomerAutopayConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCustomerAutopayConfigMutation,
    SetCustomerAutopayConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SetCustomerAutopayConfigMutation,
    SetCustomerAutopayConfigMutationVariables
  >(SetCustomerAutopayConfigDocument, options)
}
export type SetCustomerAutopayConfigMutationHookResult = ReturnType<
  typeof useSetCustomerAutopayConfigMutation
>
export type SetCustomerAutopayConfigMutationResult =
  Apollo.MutationResult<SetCustomerAutopayConfigMutation>
export type SetCustomerAutopayConfigMutationOptions =
  Apollo.BaseMutationOptions<
    SetCustomerAutopayConfigMutation,
    SetCustomerAutopayConfigMutationVariables
  >
export const PartnerInvoiceBnplConnectionDocument = /*#__PURE__*/ gql`
  query PartnerInvoiceBnplConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: BnplFilter
  ) {
    PartnerInvoiceBnplConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
    ) {
      edges {
        cursor
        node {
          ...PartnerCustomerBNPL
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerCustomerBnplFragmentDoc}
`

/**
 * __usePartnerInvoiceBnplConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerInvoiceBnplConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerInvoiceBnplConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerInvoiceBnplConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePartnerInvoiceBnplConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerInvoiceBnplConnectionQuery,
    PartnerInvoiceBnplConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerInvoiceBnplConnectionQuery,
    PartnerInvoiceBnplConnectionQueryVariables
  >(PartnerInvoiceBnplConnectionDocument, options)
}
export function usePartnerInvoiceBnplConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerInvoiceBnplConnectionQuery,
    PartnerInvoiceBnplConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerInvoiceBnplConnectionQuery,
    PartnerInvoiceBnplConnectionQueryVariables
  >(PartnerInvoiceBnplConnectionDocument, options)
}
export type PartnerInvoiceBnplConnectionQueryHookResult = ReturnType<
  typeof usePartnerInvoiceBnplConnectionQuery
>
export type PartnerInvoiceBnplConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerInvoiceBnplConnectionLazyQuery
>
export type PartnerInvoiceBnplConnectionQueryResult = Apollo.QueryResult<
  PartnerInvoiceBnplConnectionQuery,
  PartnerInvoiceBnplConnectionQueryVariables
>
export const BnplOfferConfirmByTokenDocument = /*#__PURE__*/ gql`
  mutation BNPLOfferConfirmByToken($confirmationToken: String!) {
    BNPLOfferConfirmByToken(confirmationToken: $confirmationToken)
  }
`
export type BnplOfferConfirmByTokenMutationFn = Apollo.MutationFunction<
  BnplOfferConfirmByTokenMutation,
  BnplOfferConfirmByTokenMutationVariables
>

/**
 * __useBnplOfferConfirmByTokenMutation__
 *
 * To run a mutation, you first call `useBnplOfferConfirmByTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBnplOfferConfirmByTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bnplOfferConfirmByTokenMutation, { data, loading, error }] = useBnplOfferConfirmByTokenMutation({
 *   variables: {
 *      confirmationToken: // value for 'confirmationToken'
 *   },
 * });
 */
export function useBnplOfferConfirmByTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BnplOfferConfirmByTokenMutation,
    BnplOfferConfirmByTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BnplOfferConfirmByTokenMutation,
    BnplOfferConfirmByTokenMutationVariables
  >(BnplOfferConfirmByTokenDocument, options)
}
export type BnplOfferConfirmByTokenMutationHookResult = ReturnType<
  typeof useBnplOfferConfirmByTokenMutation
>
export type BnplOfferConfirmByTokenMutationResult =
  Apollo.MutationResult<BnplOfferConfirmByTokenMutation>
export type BnplOfferConfirmByTokenMutationOptions = Apollo.BaseMutationOptions<
  BnplOfferConfirmByTokenMutation,
  BnplOfferConfirmByTokenMutationVariables
>
export const PartnerBnplOfferConfirmDocument = /*#__PURE__*/ gql`
  mutation PartnerBNPLOfferConfirm($id: ID!) {
    PartnerBNPLOfferConfirm(id: $id)
  }
`
export type PartnerBnplOfferConfirmMutationFn = Apollo.MutationFunction<
  PartnerBnplOfferConfirmMutation,
  PartnerBnplOfferConfirmMutationVariables
>

/**
 * __usePartnerBnplOfferConfirmMutation__
 *
 * To run a mutation, you first call `usePartnerBnplOfferConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerBnplOfferConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerBnplOfferConfirmMutation, { data, loading, error }] = usePartnerBnplOfferConfirmMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerBnplOfferConfirmMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerBnplOfferConfirmMutation,
    PartnerBnplOfferConfirmMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerBnplOfferConfirmMutation,
    PartnerBnplOfferConfirmMutationVariables
  >(PartnerBnplOfferConfirmDocument, options)
}
export type PartnerBnplOfferConfirmMutationHookResult = ReturnType<
  typeof usePartnerBnplOfferConfirmMutation
>
export type PartnerBnplOfferConfirmMutationResult =
  Apollo.MutationResult<PartnerBnplOfferConfirmMutation>
export type PartnerBnplOfferConfirmMutationOptions = Apollo.BaseMutationOptions<
  PartnerBnplOfferConfirmMutation,
  PartnerBnplOfferConfirmMutationVariables
>
export const PartnerChangeReferralPayoutBankingAccountDocument = /*#__PURE__*/ gql`
  mutation PartnerChangeReferralPayoutBankingAccount(
    $input: PartnerDefaultPayoutBankingAccountUpdateInput!
  ) {
    PartnerChangeReferralPayoutBankingAccount(input: $input)
  }
`
export type PartnerChangeReferralPayoutBankingAccountMutationFn =
  Apollo.MutationFunction<
    PartnerChangeReferralPayoutBankingAccountMutation,
    PartnerChangeReferralPayoutBankingAccountMutationVariables
  >

/**
 * __usePartnerChangeReferralPayoutBankingAccountMutation__
 *
 * To run a mutation, you first call `usePartnerChangeReferralPayoutBankingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerChangeReferralPayoutBankingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerChangeReferralPayoutBankingAccountMutation, { data, loading, error }] = usePartnerChangeReferralPayoutBankingAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerChangeReferralPayoutBankingAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerChangeReferralPayoutBankingAccountMutation,
    PartnerChangeReferralPayoutBankingAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerChangeReferralPayoutBankingAccountMutation,
    PartnerChangeReferralPayoutBankingAccountMutationVariables
  >(PartnerChangeReferralPayoutBankingAccountDocument, options)
}
export type PartnerChangeReferralPayoutBankingAccountMutationHookResult =
  ReturnType<typeof usePartnerChangeReferralPayoutBankingAccountMutation>
export type PartnerChangeReferralPayoutBankingAccountMutationResult =
  Apollo.MutationResult<PartnerChangeReferralPayoutBankingAccountMutation>
export type PartnerChangeReferralPayoutBankingAccountMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerChangeReferralPayoutBankingAccountMutation,
    PartnerChangeReferralPayoutBankingAccountMutationVariables
  >
export const PartnerListBankingIntegrationsDocument = /*#__PURE__*/ gql`
  query PartnerListBankingIntegrations {
    PartnerListBankingIntegrations {
      ...Bank
    }
  }
  ${BankFragmentDoc}
`

/**
 * __usePartnerListBankingIntegrationsQuery__
 *
 * To run a query within a React component, call `usePartnerListBankingIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListBankingIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListBankingIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerListBankingIntegrationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListBankingIntegrationsQuery,
    PartnerListBankingIntegrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListBankingIntegrationsQuery,
    PartnerListBankingIntegrationsQueryVariables
  >(PartnerListBankingIntegrationsDocument, options)
}
export function usePartnerListBankingIntegrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListBankingIntegrationsQuery,
    PartnerListBankingIntegrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListBankingIntegrationsQuery,
    PartnerListBankingIntegrationsQueryVariables
  >(PartnerListBankingIntegrationsDocument, options)
}
export type PartnerListBankingIntegrationsQueryHookResult = ReturnType<
  typeof usePartnerListBankingIntegrationsQuery
>
export type PartnerListBankingIntegrationsLazyQueryHookResult = ReturnType<
  typeof usePartnerListBankingIntegrationsLazyQuery
>
export type PartnerListBankingIntegrationsQueryResult = Apollo.QueryResult<
  PartnerListBankingIntegrationsQuery,
  PartnerListBankingIntegrationsQueryVariables
>
export const PartnerListCustomerBankingIntegrationsDocument = /*#__PURE__*/ gql`
  query PartnerListCustomerBankingIntegrations($customerID: String!) {
    PartnerListCustomerBankingIntegrations(customerID: $customerID) {
      ...Bank
    }
  }
  ${BankFragmentDoc}
`

/**
 * __usePartnerListCustomerBankingIntegrationsQuery__
 *
 * To run a query within a React component, call `usePartnerListCustomerBankingIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListCustomerBankingIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListCustomerBankingIntegrationsQuery({
 *   variables: {
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerListCustomerBankingIntegrationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerListCustomerBankingIntegrationsQuery,
    PartnerListCustomerBankingIntegrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListCustomerBankingIntegrationsQuery,
    PartnerListCustomerBankingIntegrationsQueryVariables
  >(PartnerListCustomerBankingIntegrationsDocument, options)
}
export function usePartnerListCustomerBankingIntegrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListCustomerBankingIntegrationsQuery,
    PartnerListCustomerBankingIntegrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListCustomerBankingIntegrationsQuery,
    PartnerListCustomerBankingIntegrationsQueryVariables
  >(PartnerListCustomerBankingIntegrationsDocument, options)
}
export type PartnerListCustomerBankingIntegrationsQueryHookResult = ReturnType<
  typeof usePartnerListCustomerBankingIntegrationsQuery
>
export type PartnerListCustomerBankingIntegrationsLazyQueryHookResult =
  ReturnType<typeof usePartnerListCustomerBankingIntegrationsLazyQuery>
export type PartnerListCustomerBankingIntegrationsQueryResult =
  Apollo.QueryResult<
    PartnerListCustomerBankingIntegrationsQuery,
    PartnerListCustomerBankingIntegrationsQueryVariables
  >
export const PartnerArchiveAccountDocument = /*#__PURE__*/ gql`
  mutation PartnerArchiveAccount($accountID: ID!) {
    PartnerArchiveAccount(accountID: $accountID)
  }
`
export type PartnerArchiveAccountMutationFn = Apollo.MutationFunction<
  PartnerArchiveAccountMutation,
  PartnerArchiveAccountMutationVariables
>

/**
 * __usePartnerArchiveAccountMutation__
 *
 * To run a mutation, you first call `usePartnerArchiveAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerArchiveAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerArchiveAccountMutation, { data, loading, error }] = usePartnerArchiveAccountMutation({
 *   variables: {
 *      accountID: // value for 'accountID'
 *   },
 * });
 */
export function usePartnerArchiveAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerArchiveAccountMutation,
    PartnerArchiveAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerArchiveAccountMutation,
    PartnerArchiveAccountMutationVariables
  >(PartnerArchiveAccountDocument, options)
}
export type PartnerArchiveAccountMutationHookResult = ReturnType<
  typeof usePartnerArchiveAccountMutation
>
export type PartnerArchiveAccountMutationResult =
  Apollo.MutationResult<PartnerArchiveAccountMutation>
export type PartnerArchiveAccountMutationOptions = Apollo.BaseMutationOptions<
  PartnerArchiveAccountMutation,
  PartnerArchiveAccountMutationVariables
>
export const PartnerAddManualBankingConnectionDocument = /*#__PURE__*/ gql`
  mutation PartnerAddManualBankingConnection(
    $accountInformation: ManualBankingAccountInformationInput!
  ) {
    PartnerAddManualBankingConnection(accountInformation: $accountInformation)
  }
`
export type PartnerAddManualBankingConnectionMutationFn =
  Apollo.MutationFunction<
    PartnerAddManualBankingConnectionMutation,
    PartnerAddManualBankingConnectionMutationVariables
  >

/**
 * __usePartnerAddManualBankingConnectionMutation__
 *
 * To run a mutation, you first call `usePartnerAddManualBankingConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAddManualBankingConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAddManualBankingConnectionMutation, { data, loading, error }] = usePartnerAddManualBankingConnectionMutation({
 *   variables: {
 *      accountInformation: // value for 'accountInformation'
 *   },
 * });
 */
export function usePartnerAddManualBankingConnectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAddManualBankingConnectionMutation,
    PartnerAddManualBankingConnectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAddManualBankingConnectionMutation,
    PartnerAddManualBankingConnectionMutationVariables
  >(PartnerAddManualBankingConnectionDocument, options)
}
export type PartnerAddManualBankingConnectionMutationHookResult = ReturnType<
  typeof usePartnerAddManualBankingConnectionMutation
>
export type PartnerAddManualBankingConnectionMutationResult =
  Apollo.MutationResult<PartnerAddManualBankingConnectionMutation>
export type PartnerAddManualBankingConnectionMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAddManualBankingConnectionMutation,
    PartnerAddManualBankingConnectionMutationVariables
  >
export const PartnerAddCustomerBankingConnectionDocument = /*#__PURE__*/ gql`
  mutation PartnerAddCustomerBankingConnection(
    $customerID: String!
    $accountInformation: ManualBankingAccountInformationInput!
  ) {
    PartnerAddCustomerManualBankingConnection(
      customerID: $customerID
      accountInformation: $accountInformation
    )
  }
`
export type PartnerAddCustomerBankingConnectionMutationFn =
  Apollo.MutationFunction<
    PartnerAddCustomerBankingConnectionMutation,
    PartnerAddCustomerBankingConnectionMutationVariables
  >

/**
 * __usePartnerAddCustomerBankingConnectionMutation__
 *
 * To run a mutation, you first call `usePartnerAddCustomerBankingConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAddCustomerBankingConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAddCustomerBankingConnectionMutation, { data, loading, error }] = usePartnerAddCustomerBankingConnectionMutation({
 *   variables: {
 *      customerID: // value for 'customerID'
 *      accountInformation: // value for 'accountInformation'
 *   },
 * });
 */
export function usePartnerAddCustomerBankingConnectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAddCustomerBankingConnectionMutation,
    PartnerAddCustomerBankingConnectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAddCustomerBankingConnectionMutation,
    PartnerAddCustomerBankingConnectionMutationVariables
  >(PartnerAddCustomerBankingConnectionDocument, options)
}
export type PartnerAddCustomerBankingConnectionMutationHookResult = ReturnType<
  typeof usePartnerAddCustomerBankingConnectionMutation
>
export type PartnerAddCustomerBankingConnectionMutationResult =
  Apollo.MutationResult<PartnerAddCustomerBankingConnectionMutation>
export type PartnerAddCustomerBankingConnectionMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAddCustomerBankingConnectionMutation,
    PartnerAddCustomerBankingConnectionMutationVariables
  >
export const PartnerChangeDefaultPayoutBankingAccountDocument = /*#__PURE__*/ gql`
  mutation PartnerChangeDefaultPayoutBankingAccount(
    $input: PartnerDefaultPayoutBankingAccountUpdateInput!
  ) {
    PartnerChangeDefaultPayoutBankingAccount(input: $input)
  }
`
export type PartnerChangeDefaultPayoutBankingAccountMutationFn =
  Apollo.MutationFunction<
    PartnerChangeDefaultPayoutBankingAccountMutation,
    PartnerChangeDefaultPayoutBankingAccountMutationVariables
  >

/**
 * __usePartnerChangeDefaultPayoutBankingAccountMutation__
 *
 * To run a mutation, you first call `usePartnerChangeDefaultPayoutBankingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerChangeDefaultPayoutBankingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerChangeDefaultPayoutBankingAccountMutation, { data, loading, error }] = usePartnerChangeDefaultPayoutBankingAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerChangeDefaultPayoutBankingAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerChangeDefaultPayoutBankingAccountMutation,
    PartnerChangeDefaultPayoutBankingAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerChangeDefaultPayoutBankingAccountMutation,
    PartnerChangeDefaultPayoutBankingAccountMutationVariables
  >(PartnerChangeDefaultPayoutBankingAccountDocument, options)
}
export type PartnerChangeDefaultPayoutBankingAccountMutationHookResult =
  ReturnType<typeof usePartnerChangeDefaultPayoutBankingAccountMutation>
export type PartnerChangeDefaultPayoutBankingAccountMutationResult =
  Apollo.MutationResult<PartnerChangeDefaultPayoutBankingAccountMutation>
export type PartnerChangeDefaultPayoutBankingAccountMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerChangeDefaultPayoutBankingAccountMutation,
    PartnerChangeDefaultPayoutBankingAccountMutationVariables
  >
export const PartnerGetInvoiceBulkChargesDocument = /*#__PURE__*/ gql`
  query PartnerGetInvoiceBulkCharges(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $getPartnerInvoiceBulkChargesFilter: GetPartnerInvoiceBulkChargesFilter
    $getPartnerInvoiceBulkChargesOrderBy: GetPartnerInvoiceBulkChargesOrderBy
  ) {
    PartnerGetInvoiceBulkCharges(
      after: $after
      first: $first
      before: $before
      last: $last
      getPartnerInvoiceBulkChargesFilter: $getPartnerInvoiceBulkChargesFilter
      orderBy: $getPartnerInvoiceBulkChargesOrderBy
    ) {
      edges {
        cursor
        node {
          ...PartnerInvoiceBulkCharge
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerInvoiceBulkChargeFragmentDoc}
`

/**
 * __usePartnerGetInvoiceBulkChargesQuery__
 *
 * To run a query within a React component, call `usePartnerGetInvoiceBulkChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetInvoiceBulkChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetInvoiceBulkChargesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      getPartnerInvoiceBulkChargesFilter: // value for 'getPartnerInvoiceBulkChargesFilter'
 *      getPartnerInvoiceBulkChargesOrderBy: // value for 'getPartnerInvoiceBulkChargesOrderBy'
 *   },
 * });
 */
export function usePartnerGetInvoiceBulkChargesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetInvoiceBulkChargesQuery,
    PartnerGetInvoiceBulkChargesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetInvoiceBulkChargesQuery,
    PartnerGetInvoiceBulkChargesQueryVariables
  >(PartnerGetInvoiceBulkChargesDocument, options)
}
export function usePartnerGetInvoiceBulkChargesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetInvoiceBulkChargesQuery,
    PartnerGetInvoiceBulkChargesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetInvoiceBulkChargesQuery,
    PartnerGetInvoiceBulkChargesQueryVariables
  >(PartnerGetInvoiceBulkChargesDocument, options)
}
export type PartnerGetInvoiceBulkChargesQueryHookResult = ReturnType<
  typeof usePartnerGetInvoiceBulkChargesQuery
>
export type PartnerGetInvoiceBulkChargesLazyQueryHookResult = ReturnType<
  typeof usePartnerGetInvoiceBulkChargesLazyQuery
>
export type PartnerGetInvoiceBulkChargesQueryResult = Apollo.QueryResult<
  PartnerGetInvoiceBulkChargesQuery,
  PartnerGetInvoiceBulkChargesQueryVariables
>
export const PartnerInvoiceBulkChargeOnDateDocument = /*#__PURE__*/ gql`
  mutation PartnerInvoiceBulkChargeOnDate(
    $invoiceIds: [ID!]
    $paymentDate: String
  ) {
    PartnerInvoiceBulkChargeOnDate(
      invoiceIds: $invoiceIds
      paymentDate: $paymentDate
    )
  }
`
export type PartnerInvoiceBulkChargeOnDateMutationFn = Apollo.MutationFunction<
  PartnerInvoiceBulkChargeOnDateMutation,
  PartnerInvoiceBulkChargeOnDateMutationVariables
>

/**
 * __usePartnerInvoiceBulkChargeOnDateMutation__
 *
 * To run a mutation, you first call `usePartnerInvoiceBulkChargeOnDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerInvoiceBulkChargeOnDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerInvoiceBulkChargeOnDateMutation, { data, loading, error }] = usePartnerInvoiceBulkChargeOnDateMutation({
 *   variables: {
 *      invoiceIds: // value for 'invoiceIds'
 *      paymentDate: // value for 'paymentDate'
 *   },
 * });
 */
export function usePartnerInvoiceBulkChargeOnDateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerInvoiceBulkChargeOnDateMutation,
    PartnerInvoiceBulkChargeOnDateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerInvoiceBulkChargeOnDateMutation,
    PartnerInvoiceBulkChargeOnDateMutationVariables
  >(PartnerInvoiceBulkChargeOnDateDocument, options)
}
export type PartnerInvoiceBulkChargeOnDateMutationHookResult = ReturnType<
  typeof usePartnerInvoiceBulkChargeOnDateMutation
>
export type PartnerInvoiceBulkChargeOnDateMutationResult =
  Apollo.MutationResult<PartnerInvoiceBulkChargeOnDateMutation>
export type PartnerInvoiceBulkChargeOnDateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerInvoiceBulkChargeOnDateMutation,
    PartnerInvoiceBulkChargeOnDateMutationVariables
  >
export const PartnerInvoiceBulkChargeOnDueDateDocument = /*#__PURE__*/ gql`
  mutation PartnerInvoiceBulkChargeOnDueDate($invoiceIds: [ID!]) {
    PartnerInvoiceBulkChargeOnDueDate(invoiceIds: $invoiceIds)
  }
`
export type PartnerInvoiceBulkChargeOnDueDateMutationFn =
  Apollo.MutationFunction<
    PartnerInvoiceBulkChargeOnDueDateMutation,
    PartnerInvoiceBulkChargeOnDueDateMutationVariables
  >

/**
 * __usePartnerInvoiceBulkChargeOnDueDateMutation__
 *
 * To run a mutation, you first call `usePartnerInvoiceBulkChargeOnDueDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerInvoiceBulkChargeOnDueDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerInvoiceBulkChargeOnDueDateMutation, { data, loading, error }] = usePartnerInvoiceBulkChargeOnDueDateMutation({
 *   variables: {
 *      invoiceIds: // value for 'invoiceIds'
 *   },
 * });
 */
export function usePartnerInvoiceBulkChargeOnDueDateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerInvoiceBulkChargeOnDueDateMutation,
    PartnerInvoiceBulkChargeOnDueDateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerInvoiceBulkChargeOnDueDateMutation,
    PartnerInvoiceBulkChargeOnDueDateMutationVariables
  >(PartnerInvoiceBulkChargeOnDueDateDocument, options)
}
export type PartnerInvoiceBulkChargeOnDueDateMutationHookResult = ReturnType<
  typeof usePartnerInvoiceBulkChargeOnDueDateMutation
>
export type PartnerInvoiceBulkChargeOnDueDateMutationResult =
  Apollo.MutationResult<PartnerInvoiceBulkChargeOnDueDateMutation>
export type PartnerInvoiceBulkChargeOnDueDateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerInvoiceBulkChargeOnDueDateMutation,
    PartnerInvoiceBulkChargeOnDueDateMutationVariables
  >
export const FindOverdueInvoiceDetailDocument = /*#__PURE__*/ gql`
  query FindOverdueInvoiceDetail($id: String!) {
    FindInvoice(id: $id) {
      ...PartnerOverdueInvoice
    }
  }
  ${PartnerOverdueInvoiceFragmentDoc}
`

/**
 * __useFindOverdueInvoiceDetailQuery__
 *
 * To run a query within a React component, call `useFindOverdueInvoiceDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOverdueInvoiceDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOverdueInvoiceDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindOverdueInvoiceDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    FindOverdueInvoiceDetailQuery,
    FindOverdueInvoiceDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    FindOverdueInvoiceDetailQuery,
    FindOverdueInvoiceDetailQueryVariables
  >(FindOverdueInvoiceDetailDocument, options)
}
export function useFindOverdueInvoiceDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FindOverdueInvoiceDetailQuery,
    FindOverdueInvoiceDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    FindOverdueInvoiceDetailQuery,
    FindOverdueInvoiceDetailQueryVariables
  >(FindOverdueInvoiceDetailDocument, options)
}
export type FindOverdueInvoiceDetailQueryHookResult = ReturnType<
  typeof useFindOverdueInvoiceDetailQuery
>
export type FindOverdueInvoiceDetailLazyQueryHookResult = ReturnType<
  typeof useFindOverdueInvoiceDetailLazyQuery
>
export type FindOverdueInvoiceDetailQueryResult = Apollo.QueryResult<
  FindOverdueInvoiceDetailQuery,
  FindOverdueInvoiceDetailQueryVariables
>
export const FindOverdueInvoicesDocument = /*#__PURE__*/ gql`
  query FindOverdueInvoices(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: InvoiceFilter
    $orderBy: InvoiceOrderBy
  ) {
    PartnerInvoiceConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        cursor
        node {
          ...PartnerCollectionInvoice
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerCollectionInvoiceFragmentDoc}
`

/**
 * __useFindOverdueInvoicesQuery__
 *
 * To run a query within a React component, call `useFindOverdueInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOverdueInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOverdueInvoicesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindOverdueInvoicesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FindOverdueInvoicesQuery,
    FindOverdueInvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    FindOverdueInvoicesQuery,
    FindOverdueInvoicesQueryVariables
  >(FindOverdueInvoicesDocument, options)
}
export function useFindOverdueInvoicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FindOverdueInvoicesQuery,
    FindOverdueInvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    FindOverdueInvoicesQuery,
    FindOverdueInvoicesQueryVariables
  >(FindOverdueInvoicesDocument, options)
}
export type FindOverdueInvoicesQueryHookResult = ReturnType<
  typeof useFindOverdueInvoicesQuery
>
export type FindOverdueInvoicesLazyQueryHookResult = ReturnType<
  typeof useFindOverdueInvoicesLazyQuery
>
export type FindOverdueInvoicesQueryResult = Apollo.QueryResult<
  FindOverdueInvoicesQuery,
  FindOverdueInvoicesQueryVariables
>
export const PartnerCollectionConnectionDocument = /*#__PURE__*/ gql`
  query PartnerCollectionConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $collectionFilter: CollectionFilter
    $orderBy: CollectionOrder
  ) {
    PartnerCollectionConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      collectionFilter: $collectionFilter
      orderBy: $orderBy
    ) {
      edges {
        cursor
        node {
          ...PartnerCollectionListing
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerCollectionListingFragmentDoc}
`

/**
 * __usePartnerCollectionConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerCollectionConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCollectionConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCollectionConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      collectionFilter: // value for 'collectionFilter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerCollectionConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerCollectionConnectionQuery,
    PartnerCollectionConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerCollectionConnectionQuery,
    PartnerCollectionConnectionQueryVariables
  >(PartnerCollectionConnectionDocument, options)
}
export function usePartnerCollectionConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerCollectionConnectionQuery,
    PartnerCollectionConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerCollectionConnectionQuery,
    PartnerCollectionConnectionQueryVariables
  >(PartnerCollectionConnectionDocument, options)
}
export type PartnerCollectionConnectionQueryHookResult = ReturnType<
  typeof usePartnerCollectionConnectionQuery
>
export type PartnerCollectionConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerCollectionConnectionLazyQuery
>
export type PartnerCollectionConnectionQueryResult = Apollo.QueryResult<
  PartnerCollectionConnectionQuery,
  PartnerCollectionConnectionQueryVariables
>
export const FindCollectionDetailDocument = /*#__PURE__*/ gql`
  query FindCollectionDetail(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $collectionFilter: CollectionFilter
    $orderBy: CollectionOrder
  ) {
    PartnerCollectionConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      collectionFilter: $collectionFilter
      orderBy: $orderBy
    ) {
      edges {
        cursor
        node {
          ...PartnerCollectionDetail
        }
      }
    }
  }
  ${PartnerCollectionDetailFragmentDoc}
`

/**
 * __useFindCollectionDetailQuery__
 *
 * To run a query within a React component, call `useFindCollectionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCollectionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCollectionDetailQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      collectionFilter: // value for 'collectionFilter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindCollectionDetailQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FindCollectionDetailQuery,
    FindCollectionDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    FindCollectionDetailQuery,
    FindCollectionDetailQueryVariables
  >(FindCollectionDetailDocument, options)
}
export function useFindCollectionDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FindCollectionDetailQuery,
    FindCollectionDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    FindCollectionDetailQuery,
    FindCollectionDetailQueryVariables
  >(FindCollectionDetailDocument, options)
}
export type FindCollectionDetailQueryHookResult = ReturnType<
  typeof useFindCollectionDetailQuery
>
export type FindCollectionDetailLazyQueryHookResult = ReturnType<
  typeof useFindCollectionDetailLazyQuery
>
export type FindCollectionDetailQueryResult = Apollo.QueryResult<
  FindCollectionDetailQuery,
  FindCollectionDetailQueryVariables
>
export const PartnerCollectionTotalsDocument = /*#__PURE__*/ gql`
  query PartnerCollectionTotals($collectionFilter: CollectionFilter) {
    PartnerCollectionTotals(collectionFilter: $collectionFilter) {
      netAmount
      amount
      count
    }
  }
`

/**
 * __usePartnerCollectionTotalsQuery__
 *
 * To run a query within a React component, call `usePartnerCollectionTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCollectionTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCollectionTotalsQuery({
 *   variables: {
 *      collectionFilter: // value for 'collectionFilter'
 *   },
 * });
 */
export function usePartnerCollectionTotalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerCollectionTotalsQuery,
    PartnerCollectionTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerCollectionTotalsQuery,
    PartnerCollectionTotalsQueryVariables
  >(PartnerCollectionTotalsDocument, options)
}
export function usePartnerCollectionTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerCollectionTotalsQuery,
    PartnerCollectionTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerCollectionTotalsQuery,
    PartnerCollectionTotalsQueryVariables
  >(PartnerCollectionTotalsDocument, options)
}
export type PartnerCollectionTotalsQueryHookResult = ReturnType<
  typeof usePartnerCollectionTotalsQuery
>
export type PartnerCollectionTotalsLazyQueryHookResult = ReturnType<
  typeof usePartnerCollectionTotalsLazyQuery
>
export type PartnerCollectionTotalsQueryResult = Apollo.QueryResult<
  PartnerCollectionTotalsQuery,
  PartnerCollectionTotalsQueryVariables
>
export const PartnerGetFeeRatesDocument = /*#__PURE__*/ gql`
  query PartnerGetFeeRates($input: GetFeeRatesInput!) {
    PartnerGetFeeRates(input: $input) {
      upfrontFeeAmount
      collectionFeeAmount
    }
  }
`

/**
 * __usePartnerGetFeeRatesQuery__
 *
 * To run a query within a React component, call `usePartnerGetFeeRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetFeeRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetFeeRatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerGetFeeRatesQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetFeeRatesQuery,
    PartnerGetFeeRatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetFeeRatesQuery,
    PartnerGetFeeRatesQueryVariables
  >(PartnerGetFeeRatesDocument, options)
}
export function usePartnerGetFeeRatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetFeeRatesQuery,
    PartnerGetFeeRatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetFeeRatesQuery,
    PartnerGetFeeRatesQueryVariables
  >(PartnerGetFeeRatesDocument, options)
}
export type PartnerGetFeeRatesQueryHookResult = ReturnType<
  typeof usePartnerGetFeeRatesQuery
>
export type PartnerGetFeeRatesLazyQueryHookResult = ReturnType<
  typeof usePartnerGetFeeRatesLazyQuery
>
export type PartnerGetFeeRatesQueryResult = Apollo.QueryResult<
  PartnerGetFeeRatesQuery,
  PartnerGetFeeRatesQueryVariables
>
export const PartnerCreateCollectionDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateCollection($createInput: CollectionCreateInput!) {
    PartnerCreateCollection(createInput: $createInput)
  }
`
export type PartnerCreateCollectionMutationFn = Apollo.MutationFunction<
  PartnerCreateCollectionMutation,
  PartnerCreateCollectionMutationVariables
>

/**
 * __usePartnerCreateCollectionMutation__
 *
 * To run a mutation, you first call `usePartnerCreateCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateCollectionMutation, { data, loading, error }] = usePartnerCreateCollectionMutation({
 *   variables: {
 *      createInput: // value for 'createInput'
 *   },
 * });
 */
export function usePartnerCreateCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateCollectionMutation,
    PartnerCreateCollectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateCollectionMutation,
    PartnerCreateCollectionMutationVariables
  >(PartnerCreateCollectionDocument, options)
}
export type PartnerCreateCollectionMutationHookResult = ReturnType<
  typeof usePartnerCreateCollectionMutation
>
export type PartnerCreateCollectionMutationResult =
  Apollo.MutationResult<PartnerCreateCollectionMutation>
export type PartnerCreateCollectionMutationOptions = Apollo.BaseMutationOptions<
  PartnerCreateCollectionMutation,
  PartnerCreateCollectionMutationVariables
>
export const PartnerCancelCollectionDocument = /*#__PURE__*/ gql`
  mutation PartnerCancelCollection($collectionID: String!, $reason: String!) {
    PartnerCancelCollection(collectionID: $collectionID, reason: $reason)
  }
`
export type PartnerCancelCollectionMutationFn = Apollo.MutationFunction<
  PartnerCancelCollectionMutation,
  PartnerCancelCollectionMutationVariables
>

/**
 * __usePartnerCancelCollectionMutation__
 *
 * To run a mutation, you first call `usePartnerCancelCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCancelCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCancelCollectionMutation, { data, loading, error }] = usePartnerCancelCollectionMutation({
 *   variables: {
 *      collectionID: // value for 'collectionID'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function usePartnerCancelCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCancelCollectionMutation,
    PartnerCancelCollectionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCancelCollectionMutation,
    PartnerCancelCollectionMutationVariables
  >(PartnerCancelCollectionDocument, options)
}
export type PartnerCancelCollectionMutationHookResult = ReturnType<
  typeof usePartnerCancelCollectionMutation
>
export type PartnerCancelCollectionMutationResult =
  Apollo.MutationResult<PartnerCancelCollectionMutation>
export type PartnerCancelCollectionMutationOptions = Apollo.BaseMutationOptions<
  PartnerCancelCollectionMutation,
  PartnerCancelCollectionMutationVariables
>
export const PartnerListCardsDocument = /*#__PURE__*/ gql`
  query PartnerListCards($filter: ListCardsFilterInput) {
    PartnerListCards(filter: $filter) {
      ...CreditCard
    }
  }
  ${CreditCardFragmentDoc}
`

/**
 * __usePartnerListCardsQuery__
 *
 * To run a query within a React component, call `usePartnerListCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListCardsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePartnerListCardsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListCardsQuery,
    PartnerListCardsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PartnerListCardsQuery, PartnerListCardsQueryVariables>(
    PartnerListCardsDocument,
    options
  )
}
export function usePartnerListCardsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListCardsQuery,
    PartnerListCardsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListCardsQuery,
    PartnerListCardsQueryVariables
  >(PartnerListCardsDocument, options)
}
export type PartnerListCardsQueryHookResult = ReturnType<
  typeof usePartnerListCardsQuery
>
export type PartnerListCardsLazyQueryHookResult = ReturnType<
  typeof usePartnerListCardsLazyQuery
>
export type PartnerListCardsQueryResult = Apollo.QueryResult<
  PartnerListCardsQuery,
  PartnerListCardsQueryVariables
>
export const PartnerListCustomerCardsDocument = /*#__PURE__*/ gql`
  query PartnerListCustomerCards(
    $filter: ListCardsFilterInput
    $customerID: ID!
  ) {
    PartnerListCustomerCards(customerID: $customerID, filter: $filter) {
      ...CreditCard
    }
  }
  ${CreditCardFragmentDoc}
`

/**
 * __usePartnerListCustomerCardsQuery__
 *
 * To run a query within a React component, call `usePartnerListCustomerCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListCustomerCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListCustomerCardsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerListCustomerCardsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerListCustomerCardsQuery,
    PartnerListCustomerCardsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListCustomerCardsQuery,
    PartnerListCustomerCardsQueryVariables
  >(PartnerListCustomerCardsDocument, options)
}
export function usePartnerListCustomerCardsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListCustomerCardsQuery,
    PartnerListCustomerCardsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListCustomerCardsQuery,
    PartnerListCustomerCardsQueryVariables
  >(PartnerListCustomerCardsDocument, options)
}
export type PartnerListCustomerCardsQueryHookResult = ReturnType<
  typeof usePartnerListCustomerCardsQuery
>
export type PartnerListCustomerCardsLazyQueryHookResult = ReturnType<
  typeof usePartnerListCustomerCardsLazyQuery
>
export type PartnerListCustomerCardsQueryResult = Apollo.QueryResult<
  PartnerListCustomerCardsQuery,
  PartnerListCustomerCardsQueryVariables
>
export const PartnerGetCardFeeDocument = /*#__PURE__*/ gql`
  query PartnerGetCardFee($input: GetCardFeeInput!) {
    PartnerGetCardFee(input: $input) {
      percentage
      feeAmount
    }
  }
`

/**
 * __usePartnerGetCardFeeQuery__
 *
 * To run a query within a React component, call `usePartnerGetCardFeeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetCardFeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetCardFeeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerGetCardFeeQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetCardFeeQuery,
    PartnerGetCardFeeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetCardFeeQuery,
    PartnerGetCardFeeQueryVariables
  >(PartnerGetCardFeeDocument, options)
}
export function usePartnerGetCardFeeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetCardFeeQuery,
    PartnerGetCardFeeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetCardFeeQuery,
    PartnerGetCardFeeQueryVariables
  >(PartnerGetCardFeeDocument, options)
}
export type PartnerGetCardFeeQueryHookResult = ReturnType<
  typeof usePartnerGetCardFeeQuery
>
export type PartnerGetCardFeeLazyQueryHookResult = ReturnType<
  typeof usePartnerGetCardFeeLazyQuery
>
export type PartnerGetCardFeeQueryResult = Apollo.QueryResult<
  PartnerGetCardFeeQuery,
  PartnerGetCardFeeQueryVariables
>
export const PartnerGetCustomerCardFeeDocument = /*#__PURE__*/ gql`
  query PartnerGetCustomerCardFee($input: GetCustomerCardFeeInput!) {
    PartnerGetCustomerCardFee(input: $input) {
      percentage
      feeAmount
    }
  }
`

/**
 * __usePartnerGetCustomerCardFeeQuery__
 *
 * To run a query within a React component, call `usePartnerGetCustomerCardFeeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetCustomerCardFeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetCustomerCardFeeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerGetCustomerCardFeeQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetCustomerCardFeeQuery,
    PartnerGetCustomerCardFeeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetCustomerCardFeeQuery,
    PartnerGetCustomerCardFeeQueryVariables
  >(PartnerGetCustomerCardFeeDocument, options)
}
export function usePartnerGetCustomerCardFeeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetCustomerCardFeeQuery,
    PartnerGetCustomerCardFeeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetCustomerCardFeeQuery,
    PartnerGetCustomerCardFeeQueryVariables
  >(PartnerGetCustomerCardFeeDocument, options)
}
export type PartnerGetCustomerCardFeeQueryHookResult = ReturnType<
  typeof usePartnerGetCustomerCardFeeQuery
>
export type PartnerGetCustomerCardFeeLazyQueryHookResult = ReturnType<
  typeof usePartnerGetCustomerCardFeeLazyQuery
>
export type PartnerGetCustomerCardFeeQueryResult = Apollo.QueryResult<
  PartnerGetCustomerCardFeeQuery,
  PartnerGetCustomerCardFeeQueryVariables
>
export const PartnerCreateCardDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateCard($input: CardCreationInput!) {
    PartnerCreateCard(input: $input)
  }
`
export type PartnerCreateCardMutationFn = Apollo.MutationFunction<
  PartnerCreateCardMutation,
  PartnerCreateCardMutationVariables
>

/**
 * __usePartnerCreateCardMutation__
 *
 * To run a mutation, you first call `usePartnerCreateCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateCardMutation, { data, loading, error }] = usePartnerCreateCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCreateCardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateCardMutation,
    PartnerCreateCardMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateCardMutation,
    PartnerCreateCardMutationVariables
  >(PartnerCreateCardDocument, options)
}
export type PartnerCreateCardMutationHookResult = ReturnType<
  typeof usePartnerCreateCardMutation
>
export type PartnerCreateCardMutationResult =
  Apollo.MutationResult<PartnerCreateCardMutation>
export type PartnerCreateCardMutationOptions = Apollo.BaseMutationOptions<
  PartnerCreateCardMutation,
  PartnerCreateCardMutationVariables
>
export const PartnerCreateCustomerCardDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateCustomerCard(
    $input: CardCreationInput!
    $customerID: ID!
  ) {
    PartnerCreateCustomerCard(input: $input, customerID: $customerID)
  }
`
export type PartnerCreateCustomerCardMutationFn = Apollo.MutationFunction<
  PartnerCreateCustomerCardMutation,
  PartnerCreateCustomerCardMutationVariables
>

/**
 * __usePartnerCreateCustomerCardMutation__
 *
 * To run a mutation, you first call `usePartnerCreateCustomerCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateCustomerCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateCustomerCardMutation, { data, loading, error }] = usePartnerCreateCustomerCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerCreateCustomerCardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateCustomerCardMutation,
    PartnerCreateCustomerCardMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateCustomerCardMutation,
    PartnerCreateCustomerCardMutationVariables
  >(PartnerCreateCustomerCardDocument, options)
}
export type PartnerCreateCustomerCardMutationHookResult = ReturnType<
  typeof usePartnerCreateCustomerCardMutation
>
export type PartnerCreateCustomerCardMutationResult =
  Apollo.MutationResult<PartnerCreateCustomerCardMutation>
export type PartnerCreateCustomerCardMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCreateCustomerCardMutation,
    PartnerCreateCustomerCardMutationVariables
  >
export const PartnerDeleteCardDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteCard($input: CardDeletionInput!) {
    PartnerDeleteCard(input: $input)
  }
`
export type PartnerDeleteCardMutationFn = Apollo.MutationFunction<
  PartnerDeleteCardMutation,
  PartnerDeleteCardMutationVariables
>

/**
 * __usePartnerDeleteCardMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteCardMutation, { data, loading, error }] = usePartnerDeleteCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerDeleteCardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteCardMutation,
    PartnerDeleteCardMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteCardMutation,
    PartnerDeleteCardMutationVariables
  >(PartnerDeleteCardDocument, options)
}
export type PartnerDeleteCardMutationHookResult = ReturnType<
  typeof usePartnerDeleteCardMutation
>
export type PartnerDeleteCardMutationResult =
  Apollo.MutationResult<PartnerDeleteCardMutation>
export type PartnerDeleteCardMutationOptions = Apollo.BaseMutationOptions<
  PartnerDeleteCardMutation,
  PartnerDeleteCardMutationVariables
>
export const PartnerDeleteCustomerCardDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteCustomerCard(
    $input: CardDeletionInput!
    $customerID: ID!
  ) {
    PartnerDeleteCustomerCard(input: $input, customerID: $customerID)
  }
`
export type PartnerDeleteCustomerCardMutationFn = Apollo.MutationFunction<
  PartnerDeleteCustomerCardMutation,
  PartnerDeleteCustomerCardMutationVariables
>

/**
 * __usePartnerDeleteCustomerCardMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteCustomerCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteCustomerCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteCustomerCardMutation, { data, loading, error }] = usePartnerDeleteCustomerCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerDeleteCustomerCardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteCustomerCardMutation,
    PartnerDeleteCustomerCardMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteCustomerCardMutation,
    PartnerDeleteCustomerCardMutationVariables
  >(PartnerDeleteCustomerCardDocument, options)
}
export type PartnerDeleteCustomerCardMutationHookResult = ReturnType<
  typeof usePartnerDeleteCustomerCardMutation
>
export type PartnerDeleteCustomerCardMutationResult =
  Apollo.MutationResult<PartnerDeleteCustomerCardMutation>
export type PartnerDeleteCustomerCardMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerDeleteCustomerCardMutation,
    PartnerDeleteCustomerCardMutationVariables
  >
export const PartnerModernBancGenerateSerializedTokenDocument = /*#__PURE__*/ gql`
  mutation PartnerModernBancGenerateSerializedToken(
    $input: CardSerializationInput!
  ) {
    PartnerModernBancGenerateSerializedToken(input: $input)
  }
`
export type PartnerModernBancGenerateSerializedTokenMutationFn =
  Apollo.MutationFunction<
    PartnerModernBancGenerateSerializedTokenMutation,
    PartnerModernBancGenerateSerializedTokenMutationVariables
  >

/**
 * __usePartnerModernBancGenerateSerializedTokenMutation__
 *
 * To run a mutation, you first call `usePartnerModernBancGenerateSerializedTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerModernBancGenerateSerializedTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerModernBancGenerateSerializedTokenMutation, { data, loading, error }] = usePartnerModernBancGenerateSerializedTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerModernBancGenerateSerializedTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerModernBancGenerateSerializedTokenMutation,
    PartnerModernBancGenerateSerializedTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerModernBancGenerateSerializedTokenMutation,
    PartnerModernBancGenerateSerializedTokenMutationVariables
  >(PartnerModernBancGenerateSerializedTokenDocument, options)
}
export type PartnerModernBancGenerateSerializedTokenMutationHookResult =
  ReturnType<typeof usePartnerModernBancGenerateSerializedTokenMutation>
export type PartnerModernBancGenerateSerializedTokenMutationResult =
  Apollo.MutationResult<PartnerModernBancGenerateSerializedTokenMutation>
export type PartnerModernBancGenerateSerializedTokenMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerModernBancGenerateSerializedTokenMutation,
    PartnerModernBancGenerateSerializedTokenMutationVariables
  >
export const PartnerBatchTagCustomersDocument = /*#__PURE__*/ gql`
  mutation PartnerBatchTagCustomers($customerIDs: [ID!]!, $tagID: ID!) {
    PartnerBatchTagCustomers(customerIDs: $customerIDs, tagID: $tagID)
  }
`
export type PartnerBatchTagCustomersMutationFn = Apollo.MutationFunction<
  PartnerBatchTagCustomersMutation,
  PartnerBatchTagCustomersMutationVariables
>

/**
 * __usePartnerBatchTagCustomersMutation__
 *
 * To run a mutation, you first call `usePartnerBatchTagCustomersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerBatchTagCustomersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerBatchTagCustomersMutation, { data, loading, error }] = usePartnerBatchTagCustomersMutation({
 *   variables: {
 *      customerIDs: // value for 'customerIDs'
 *      tagID: // value for 'tagID'
 *   },
 * });
 */
export function usePartnerBatchTagCustomersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerBatchTagCustomersMutation,
    PartnerBatchTagCustomersMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerBatchTagCustomersMutation,
    PartnerBatchTagCustomersMutationVariables
  >(PartnerBatchTagCustomersDocument, options)
}
export type PartnerBatchTagCustomersMutationHookResult = ReturnType<
  typeof usePartnerBatchTagCustomersMutation
>
export type PartnerBatchTagCustomersMutationResult =
  Apollo.MutationResult<PartnerBatchTagCustomersMutation>
export type PartnerBatchTagCustomersMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerBatchTagCustomersMutation,
    PartnerBatchTagCustomersMutationVariables
  >
export const PartnerDeleteCustomerTagDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteCustomerTag($ID: ID!) {
    PartnerDeleteCustomerTag(ID: $ID)
  }
`
export type PartnerDeleteCustomerTagMutationFn = Apollo.MutationFunction<
  PartnerDeleteCustomerTagMutation,
  PartnerDeleteCustomerTagMutationVariables
>

/**
 * __usePartnerDeleteCustomerTagMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteCustomerTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteCustomerTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteCustomerTagMutation, { data, loading, error }] = usePartnerDeleteCustomerTagMutation({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function usePartnerDeleteCustomerTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteCustomerTagMutation,
    PartnerDeleteCustomerTagMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteCustomerTagMutation,
    PartnerDeleteCustomerTagMutationVariables
  >(PartnerDeleteCustomerTagDocument, options)
}
export type PartnerDeleteCustomerTagMutationHookResult = ReturnType<
  typeof usePartnerDeleteCustomerTagMutation
>
export type PartnerDeleteCustomerTagMutationResult =
  Apollo.MutationResult<PartnerDeleteCustomerTagMutation>
export type PartnerDeleteCustomerTagMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerDeleteCustomerTagMutation,
    PartnerDeleteCustomerTagMutationVariables
  >
export const PartnerUpdateCustomerTagDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateCustomerTag($input: PartnerUpdateCustomerTagInput!) {
    PartnerUpdateCustomerTag(input: $input)
  }
`
export type PartnerUpdateCustomerTagMutationFn = Apollo.MutationFunction<
  PartnerUpdateCustomerTagMutation,
  PartnerUpdateCustomerTagMutationVariables
>

/**
 * __usePartnerUpdateCustomerTagMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateCustomerTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateCustomerTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateCustomerTagMutation, { data, loading, error }] = usePartnerUpdateCustomerTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateCustomerTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateCustomerTagMutation,
    PartnerUpdateCustomerTagMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateCustomerTagMutation,
    PartnerUpdateCustomerTagMutationVariables
  >(PartnerUpdateCustomerTagDocument, options)
}
export type PartnerUpdateCustomerTagMutationHookResult = ReturnType<
  typeof usePartnerUpdateCustomerTagMutation
>
export type PartnerUpdateCustomerTagMutationResult =
  Apollo.MutationResult<PartnerUpdateCustomerTagMutation>
export type PartnerUpdateCustomerTagMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateCustomerTagMutation,
    PartnerUpdateCustomerTagMutationVariables
  >
export const PartnerTagCustomerDocument = /*#__PURE__*/ gql`
  mutation PartnerTagCustomer($customerID: ID!, $tagID: ID!) {
    PartnerTagCustomer(customerID: $customerID, tagID: $tagID)
  }
`
export type PartnerTagCustomerMutationFn = Apollo.MutationFunction<
  PartnerTagCustomerMutation,
  PartnerTagCustomerMutationVariables
>

/**
 * __usePartnerTagCustomerMutation__
 *
 * To run a mutation, you first call `usePartnerTagCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerTagCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerTagCustomerMutation, { data, loading, error }] = usePartnerTagCustomerMutation({
 *   variables: {
 *      customerID: // value for 'customerID'
 *      tagID: // value for 'tagID'
 *   },
 * });
 */
export function usePartnerTagCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerTagCustomerMutation,
    PartnerTagCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerTagCustomerMutation,
    PartnerTagCustomerMutationVariables
  >(PartnerTagCustomerDocument, options)
}
export type PartnerTagCustomerMutationHookResult = ReturnType<
  typeof usePartnerTagCustomerMutation
>
export type PartnerTagCustomerMutationResult =
  Apollo.MutationResult<PartnerTagCustomerMutation>
export type PartnerTagCustomerMutationOptions = Apollo.BaseMutationOptions<
  PartnerTagCustomerMutation,
  PartnerTagCustomerMutationVariables
>
export const PartnerUntagCustomerDocument = /*#__PURE__*/ gql`
  mutation PartnerUntagCustomer($customerID: ID!, $tagID: ID!) {
    PartnerUntagCustomer(customerID: $customerID, tagID: $tagID)
  }
`
export type PartnerUntagCustomerMutationFn = Apollo.MutationFunction<
  PartnerUntagCustomerMutation,
  PartnerUntagCustomerMutationVariables
>

/**
 * __usePartnerUntagCustomerMutation__
 *
 * To run a mutation, you first call `usePartnerUntagCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUntagCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUntagCustomerMutation, { data, loading, error }] = usePartnerUntagCustomerMutation({
 *   variables: {
 *      customerID: // value for 'customerID'
 *      tagID: // value for 'tagID'
 *   },
 * });
 */
export function usePartnerUntagCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUntagCustomerMutation,
    PartnerUntagCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUntagCustomerMutation,
    PartnerUntagCustomerMutationVariables
  >(PartnerUntagCustomerDocument, options)
}
export type PartnerUntagCustomerMutationHookResult = ReturnType<
  typeof usePartnerUntagCustomerMutation
>
export type PartnerUntagCustomerMutationResult =
  Apollo.MutationResult<PartnerUntagCustomerMutation>
export type PartnerUntagCustomerMutationOptions = Apollo.BaseMutationOptions<
  PartnerUntagCustomerMutation,
  PartnerUntagCustomerMutationVariables
>
export const PartnerListCustomerTagsDocument = /*#__PURE__*/ gql`
  query PartnerListCustomerTags($filter: TagFilter) {
    PartnerListCustomerTags(filter: $filter) {
      ID
      name
      description
      color
      customerIDs
      type
    }
  }
`

/**
 * __usePartnerListCustomerTagsQuery__
 *
 * To run a query within a React component, call `usePartnerListCustomerTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListCustomerTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListCustomerTagsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePartnerListCustomerTagsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListCustomerTagsQuery,
    PartnerListCustomerTagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListCustomerTagsQuery,
    PartnerListCustomerTagsQueryVariables
  >(PartnerListCustomerTagsDocument, options)
}
export function usePartnerListCustomerTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListCustomerTagsQuery,
    PartnerListCustomerTagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListCustomerTagsQuery,
    PartnerListCustomerTagsQueryVariables
  >(PartnerListCustomerTagsDocument, options)
}
export type PartnerListCustomerTagsQueryHookResult = ReturnType<
  typeof usePartnerListCustomerTagsQuery
>
export type PartnerListCustomerTagsLazyQueryHookResult = ReturnType<
  typeof usePartnerListCustomerTagsLazyQuery
>
export type PartnerListCustomerTagsQueryResult = Apollo.QueryResult<
  PartnerListCustomerTagsQuery,
  PartnerListCustomerTagsQueryVariables
>
export const PartnerCreateCustomerTagDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateCustomerTag($input: PartnerCreateCustomerTagInput!) {
    PartnerCreateCustomerTag(input: $input)
  }
`
export type PartnerCreateCustomerTagMutationFn = Apollo.MutationFunction<
  PartnerCreateCustomerTagMutation,
  PartnerCreateCustomerTagMutationVariables
>

/**
 * __usePartnerCreateCustomerTagMutation__
 *
 * To run a mutation, you first call `usePartnerCreateCustomerTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateCustomerTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateCustomerTagMutation, { data, loading, error }] = usePartnerCreateCustomerTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCreateCustomerTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateCustomerTagMutation,
    PartnerCreateCustomerTagMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateCustomerTagMutation,
    PartnerCreateCustomerTagMutationVariables
  >(PartnerCreateCustomerTagDocument, options)
}
export type PartnerCreateCustomerTagMutationHookResult = ReturnType<
  typeof usePartnerCreateCustomerTagMutation
>
export type PartnerCreateCustomerTagMutationResult =
  Apollo.MutationResult<PartnerCreateCustomerTagMutation>
export type PartnerCreateCustomerTagMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCreateCustomerTagMutation,
    PartnerCreateCustomerTagMutationVariables
  >
export const PartnerCustomerWithInvoicesDataConnectionDocument = /*#__PURE__*/ gql`
  query PartnerCustomerWithInvoicesDataConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: CustomerFilter
    $orderBy: CustomerOrderBy
  ) {
    PartnerCustomerConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...PartnerCustomerListWithInvoicesData
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerCustomerListWithInvoicesDataFragmentDoc}
`

/**
 * __usePartnerCustomerWithInvoicesDataConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerCustomerWithInvoicesDataConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerWithInvoicesDataConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCustomerWithInvoicesDataConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerCustomerWithInvoicesDataConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerCustomerWithInvoicesDataConnectionQuery,
    PartnerCustomerWithInvoicesDataConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerCustomerWithInvoicesDataConnectionQuery,
    PartnerCustomerWithInvoicesDataConnectionQueryVariables
  >(PartnerCustomerWithInvoicesDataConnectionDocument, options)
}
export function usePartnerCustomerWithInvoicesDataConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerCustomerWithInvoicesDataConnectionQuery,
    PartnerCustomerWithInvoicesDataConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerCustomerWithInvoicesDataConnectionQuery,
    PartnerCustomerWithInvoicesDataConnectionQueryVariables
  >(PartnerCustomerWithInvoicesDataConnectionDocument, options)
}
export type PartnerCustomerWithInvoicesDataConnectionQueryHookResult =
  ReturnType<typeof usePartnerCustomerWithInvoicesDataConnectionQuery>
export type PartnerCustomerWithInvoicesDataConnectionLazyQueryHookResult =
  ReturnType<typeof usePartnerCustomerWithInvoicesDataConnectionLazyQuery>
export type PartnerCustomerWithInvoicesDataConnectionQueryResult =
  Apollo.QueryResult<
    PartnerCustomerWithInvoicesDataConnectionQuery,
    PartnerCustomerWithInvoicesDataConnectionQueryVariables
  >
export const PartnerCustomerConnectionDocument = /*#__PURE__*/ gql`
  query PartnerCustomerConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: CustomerFilter
    $orderBy: CustomerOrderBy
  ) {
    PartnerCustomerConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...PartnerCustomerList
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerCustomerListFragmentDoc}
`

/**
 * __usePartnerCustomerConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerCustomerConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCustomerConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerCustomerConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerCustomerConnectionQuery,
    PartnerCustomerConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerCustomerConnectionQuery,
    PartnerCustomerConnectionQueryVariables
  >(PartnerCustomerConnectionDocument, options)
}
export function usePartnerCustomerConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerCustomerConnectionQuery,
    PartnerCustomerConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerCustomerConnectionQuery,
    PartnerCustomerConnectionQueryVariables
  >(PartnerCustomerConnectionDocument, options)
}
export type PartnerCustomerConnectionQueryHookResult = ReturnType<
  typeof usePartnerCustomerConnectionQuery
>
export type PartnerCustomerConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerCustomerConnectionLazyQuery
>
export type PartnerCustomerConnectionQueryResult = Apollo.QueryResult<
  PartnerCustomerConnectionQuery,
  PartnerCustomerConnectionQueryVariables
>
export const PartnerListCustomersTotalsDocument = /*#__PURE__*/ gql`
  query PartnerListCustomersTotals($filter: CustomerFilter) {
    PartnerListCustomersTotals(filter: $filter) {
      count
    }
  }
`

/**
 * __usePartnerListCustomersTotalsQuery__
 *
 * To run a query within a React component, call `usePartnerListCustomersTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListCustomersTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListCustomersTotalsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePartnerListCustomersTotalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListCustomersTotalsQuery,
    PartnerListCustomersTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListCustomersTotalsQuery,
    PartnerListCustomersTotalsQueryVariables
  >(PartnerListCustomersTotalsDocument, options)
}
export function usePartnerListCustomersTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListCustomersTotalsQuery,
    PartnerListCustomersTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListCustomersTotalsQuery,
    PartnerListCustomersTotalsQueryVariables
  >(PartnerListCustomersTotalsDocument, options)
}
export type PartnerListCustomersTotalsQueryHookResult = ReturnType<
  typeof usePartnerListCustomersTotalsQuery
>
export type PartnerListCustomersTotalsLazyQueryHookResult = ReturnType<
  typeof usePartnerListCustomersTotalsLazyQuery
>
export type PartnerListCustomersTotalsQueryResult = Apollo.QueryResult<
  PartnerListCustomersTotalsQuery,
  PartnerListCustomersTotalsQueryVariables
>
export const PartnerCustomerSearchDocument = /*#__PURE__*/ gql`
  query PartnerCustomerSearch($name: String) {
    PartnerCustomerConnection(first: 10, filters: { name: $name }) {
      edges {
        node {
          ...PartnerCustomerSearch
        }
      }
    }
  }
  ${PartnerCustomerSearchFragmentDoc}
`

/**
 * __usePartnerCustomerSearchQuery__
 *
 * To run a query within a React component, call `usePartnerCustomerSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCustomerSearchQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function usePartnerCustomerSearchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerCustomerSearchQuery,
    PartnerCustomerSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerCustomerSearchQuery,
    PartnerCustomerSearchQueryVariables
  >(PartnerCustomerSearchDocument, options)
}
export function usePartnerCustomerSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerCustomerSearchQuery,
    PartnerCustomerSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerCustomerSearchQuery,
    PartnerCustomerSearchQueryVariables
  >(PartnerCustomerSearchDocument, options)
}
export type PartnerCustomerSearchQueryHookResult = ReturnType<
  typeof usePartnerCustomerSearchQuery
>
export type PartnerCustomerSearchLazyQueryHookResult = ReturnType<
  typeof usePartnerCustomerSearchLazyQuery
>
export type PartnerCustomerSearchQueryResult = Apollo.QueryResult<
  PartnerCustomerSearchQuery,
  PartnerCustomerSearchQueryVariables
>
export const PartnerArchiveCustomerDocument = /*#__PURE__*/ gql`
  mutation PartnerArchiveCustomer($input: PartnerArchiveCustomerInput!) {
    PartnerArchiveCustomer(input: $input) {
      ...PartnerCustomerList
    }
  }
  ${PartnerCustomerListFragmentDoc}
`
export type PartnerArchiveCustomerMutationFn = Apollo.MutationFunction<
  PartnerArchiveCustomerMutation,
  PartnerArchiveCustomerMutationVariables
>

/**
 * __usePartnerArchiveCustomerMutation__
 *
 * To run a mutation, you first call `usePartnerArchiveCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerArchiveCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerArchiveCustomerMutation, { data, loading, error }] = usePartnerArchiveCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerArchiveCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerArchiveCustomerMutation,
    PartnerArchiveCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerArchiveCustomerMutation,
    PartnerArchiveCustomerMutationVariables
  >(PartnerArchiveCustomerDocument, options)
}
export type PartnerArchiveCustomerMutationHookResult = ReturnType<
  typeof usePartnerArchiveCustomerMutation
>
export type PartnerArchiveCustomerMutationResult =
  Apollo.MutationResult<PartnerArchiveCustomerMutation>
export type PartnerArchiveCustomerMutationOptions = Apollo.BaseMutationOptions<
  PartnerArchiveCustomerMutation,
  PartnerArchiveCustomerMutationVariables
>
export const PartnerUnarchiveCustomerDocument = /*#__PURE__*/ gql`
  mutation PartnerUnarchiveCustomer($input: PartnerUnarchiveCustomerInput!) {
    PartnerUnarchiveCustomer(input: $input) {
      ...PartnerCustomerList
    }
  }
  ${PartnerCustomerListFragmentDoc}
`
export type PartnerUnarchiveCustomerMutationFn = Apollo.MutationFunction<
  PartnerUnarchiveCustomerMutation,
  PartnerUnarchiveCustomerMutationVariables
>

/**
 * __usePartnerUnarchiveCustomerMutation__
 *
 * To run a mutation, you first call `usePartnerUnarchiveCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUnarchiveCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUnarchiveCustomerMutation, { data, loading, error }] = usePartnerUnarchiveCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUnarchiveCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUnarchiveCustomerMutation,
    PartnerUnarchiveCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUnarchiveCustomerMutation,
    PartnerUnarchiveCustomerMutationVariables
  >(PartnerUnarchiveCustomerDocument, options)
}
export type PartnerUnarchiveCustomerMutationHookResult = ReturnType<
  typeof usePartnerUnarchiveCustomerMutation
>
export type PartnerUnarchiveCustomerMutationResult =
  Apollo.MutationResult<PartnerUnarchiveCustomerMutation>
export type PartnerUnarchiveCustomerMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUnarchiveCustomerMutation,
    PartnerUnarchiveCustomerMutationVariables
  >
export const PartnerCreateCustomerDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateCustomer($input: PartnerCreateCustomerInput) {
    PartnerCreateCustomer(input: $input) {
      ...PartnerCustomerList
    }
  }
  ${PartnerCustomerListFragmentDoc}
`
export type PartnerCreateCustomerMutationFn = Apollo.MutationFunction<
  PartnerCreateCustomerMutation,
  PartnerCreateCustomerMutationVariables
>

/**
 * __usePartnerCreateCustomerMutation__
 *
 * To run a mutation, you first call `usePartnerCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateCustomerMutation, { data, loading, error }] = usePartnerCreateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCreateCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateCustomerMutation,
    PartnerCreateCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateCustomerMutation,
    PartnerCreateCustomerMutationVariables
  >(PartnerCreateCustomerDocument, options)
}
export type PartnerCreateCustomerMutationHookResult = ReturnType<
  typeof usePartnerCreateCustomerMutation
>
export type PartnerCreateCustomerMutationResult =
  Apollo.MutationResult<PartnerCreateCustomerMutation>
export type PartnerCreateCustomerMutationOptions = Apollo.BaseMutationOptions<
  PartnerCreateCustomerMutation,
  PartnerCreateCustomerMutationVariables
>
export const UpdateCustomerDocument = /*#__PURE__*/ gql`
  mutation UpdateCustomer($input: PartnerUpdateCustomerInput) {
    PartnerUpdateCustomer(input: $input) {
      ...PartnerCustomerList
    }
  }
  ${PartnerCustomerListFragmentDoc}
`
export type UpdateCustomerMutationFn = Apollo.MutationFunction<
  UpdateCustomerMutation,
  UpdateCustomerMutationVariables
>

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCustomerMutation,
    UpdateCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateCustomerMutation,
    UpdateCustomerMutationVariables
  >(UpdateCustomerDocument, options)
}
export type UpdateCustomerMutationHookResult = ReturnType<
  typeof useUpdateCustomerMutation
>
export type UpdateCustomerMutationResult =
  Apollo.MutationResult<UpdateCustomerMutation>
export type UpdateCustomerMutationOptions = Apollo.BaseMutationOptions<
  UpdateCustomerMutation,
  UpdateCustomerMutationVariables
>
export const PartnerBulkToggleArchiveCustomersDocument = /*#__PURE__*/ gql`
  mutation PartnerBulkToggleArchiveCustomers(
    $input: BulkToggleArchiveCustomersInput!
  ) {
    PartnerBulkToggleArchiveCustomers(input: $input)
  }
`
export type PartnerBulkToggleArchiveCustomersMutationFn =
  Apollo.MutationFunction<
    PartnerBulkToggleArchiveCustomersMutation,
    PartnerBulkToggleArchiveCustomersMutationVariables
  >

/**
 * __usePartnerBulkToggleArchiveCustomersMutation__
 *
 * To run a mutation, you first call `usePartnerBulkToggleArchiveCustomersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerBulkToggleArchiveCustomersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerBulkToggleArchiveCustomersMutation, { data, loading, error }] = usePartnerBulkToggleArchiveCustomersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerBulkToggleArchiveCustomersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerBulkToggleArchiveCustomersMutation,
    PartnerBulkToggleArchiveCustomersMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerBulkToggleArchiveCustomersMutation,
    PartnerBulkToggleArchiveCustomersMutationVariables
  >(PartnerBulkToggleArchiveCustomersDocument, options)
}
export type PartnerBulkToggleArchiveCustomersMutationHookResult = ReturnType<
  typeof usePartnerBulkToggleArchiveCustomersMutation
>
export type PartnerBulkToggleArchiveCustomersMutationResult =
  Apollo.MutationResult<PartnerBulkToggleArchiveCustomersMutation>
export type PartnerBulkToggleArchiveCustomersMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerBulkToggleArchiveCustomersMutation,
    PartnerBulkToggleArchiveCustomersMutationVariables
  >
export const PartnerCustomerUserConnectionDocument = /*#__PURE__*/ gql`
  query PartnerCustomerUserConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: CustomerUserFilter
    $orderBy: CustomerUserOrderBy
  ) {
    PartnerCustomerUserConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...PartnerListCustomerUsers
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerListCustomerUsersFragmentDoc}
`

/**
 * __usePartnerCustomerUserConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerCustomerUserConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerUserConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCustomerUserConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerCustomerUserConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerCustomerUserConnectionQuery,
    PartnerCustomerUserConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerCustomerUserConnectionQuery,
    PartnerCustomerUserConnectionQueryVariables
  >(PartnerCustomerUserConnectionDocument, options)
}
export function usePartnerCustomerUserConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerCustomerUserConnectionQuery,
    PartnerCustomerUserConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerCustomerUserConnectionQuery,
    PartnerCustomerUserConnectionQueryVariables
  >(PartnerCustomerUserConnectionDocument, options)
}
export type PartnerCustomerUserConnectionQueryHookResult = ReturnType<
  typeof usePartnerCustomerUserConnectionQuery
>
export type PartnerCustomerUserConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerCustomerUserConnectionLazyQuery
>
export type PartnerCustomerUserConnectionQueryResult = Apollo.QueryResult<
  PartnerCustomerUserConnectionQuery,
  PartnerCustomerUserConnectionQueryVariables
>
export const PartnerArchiveCustomerAccountDocument = /*#__PURE__*/ gql`
  mutation PartnerArchiveCustomerAccount($accountID: ID!, $customerID: ID!) {
    PartnerArchiveCustomerAccount(
      accountID: $accountID
      customerID: $customerID
    )
  }
`
export type PartnerArchiveCustomerAccountMutationFn = Apollo.MutationFunction<
  PartnerArchiveCustomerAccountMutation,
  PartnerArchiveCustomerAccountMutationVariables
>

/**
 * __usePartnerArchiveCustomerAccountMutation__
 *
 * To run a mutation, you first call `usePartnerArchiveCustomerAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerArchiveCustomerAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerArchiveCustomerAccountMutation, { data, loading, error }] = usePartnerArchiveCustomerAccountMutation({
 *   variables: {
 *      accountID: // value for 'accountID'
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerArchiveCustomerAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerArchiveCustomerAccountMutation,
    PartnerArchiveCustomerAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerArchiveCustomerAccountMutation,
    PartnerArchiveCustomerAccountMutationVariables
  >(PartnerArchiveCustomerAccountDocument, options)
}
export type PartnerArchiveCustomerAccountMutationHookResult = ReturnType<
  typeof usePartnerArchiveCustomerAccountMutation
>
export type PartnerArchiveCustomerAccountMutationResult =
  Apollo.MutationResult<PartnerArchiveCustomerAccountMutation>
export type PartnerArchiveCustomerAccountMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerArchiveCustomerAccountMutation,
    PartnerArchiveCustomerAccountMutationVariables
  >
export const PartnerCreateCustomerUserDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateCustomerUser($input: PartnerCreateCustomerUserInput) {
    PartnerCreateCustomerUser(input: $input) {
      ...PartnerCustomerUserCreation
    }
  }
  ${PartnerCustomerUserCreationFragmentDoc}
`
export type PartnerCreateCustomerUserMutationFn = Apollo.MutationFunction<
  PartnerCreateCustomerUserMutation,
  PartnerCreateCustomerUserMutationVariables
>

/**
 * __usePartnerCreateCustomerUserMutation__
 *
 * To run a mutation, you first call `usePartnerCreateCustomerUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateCustomerUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateCustomerUserMutation, { data, loading, error }] = usePartnerCreateCustomerUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCreateCustomerUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateCustomerUserMutation,
    PartnerCreateCustomerUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateCustomerUserMutation,
    PartnerCreateCustomerUserMutationVariables
  >(PartnerCreateCustomerUserDocument, options)
}
export type PartnerCreateCustomerUserMutationHookResult = ReturnType<
  typeof usePartnerCreateCustomerUserMutation
>
export type PartnerCreateCustomerUserMutationResult =
  Apollo.MutationResult<PartnerCreateCustomerUserMutation>
export type PartnerCreateCustomerUserMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCreateCustomerUserMutation,
    PartnerCreateCustomerUserMutationVariables
  >
export const PartnerDeleteCustomerUserDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteCustomerUser($id: String!) {
    PartnerDeleteCustomerUser(id: $id)
  }
`
export type PartnerDeleteCustomerUserMutationFn = Apollo.MutationFunction<
  PartnerDeleteCustomerUserMutation,
  PartnerDeleteCustomerUserMutationVariables
>

/**
 * __usePartnerDeleteCustomerUserMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteCustomerUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteCustomerUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteCustomerUserMutation, { data, loading, error }] = usePartnerDeleteCustomerUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerDeleteCustomerUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteCustomerUserMutation,
    PartnerDeleteCustomerUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteCustomerUserMutation,
    PartnerDeleteCustomerUserMutationVariables
  >(PartnerDeleteCustomerUserDocument, options)
}
export type PartnerDeleteCustomerUserMutationHookResult = ReturnType<
  typeof usePartnerDeleteCustomerUserMutation
>
export type PartnerDeleteCustomerUserMutationResult =
  Apollo.MutationResult<PartnerDeleteCustomerUserMutation>
export type PartnerDeleteCustomerUserMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerDeleteCustomerUserMutation,
    PartnerDeleteCustomerUserMutationVariables
  >
export const UpdateCustomerUserDocument = /*#__PURE__*/ gql`
  mutation UpdateCustomerUser($input: PartnerUpdateCustomerUserInput) {
    PartnerUpdateCustomerUser(input: $input) {
      ...PartnerListCustomerUsers
    }
  }
  ${PartnerListCustomerUsersFragmentDoc}
`
export type UpdateCustomerUserMutationFn = Apollo.MutationFunction<
  UpdateCustomerUserMutation,
  UpdateCustomerUserMutationVariables
>

/**
 * __useUpdateCustomerUserMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerUserMutation, { data, loading, error }] = useUpdateCustomerUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCustomerUserMutation,
    UpdateCustomerUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateCustomerUserMutation,
    UpdateCustomerUserMutationVariables
  >(UpdateCustomerUserDocument, options)
}
export type UpdateCustomerUserMutationHookResult = ReturnType<
  typeof useUpdateCustomerUserMutation
>
export type UpdateCustomerUserMutationResult =
  Apollo.MutationResult<UpdateCustomerUserMutation>
export type UpdateCustomerUserMutationOptions = Apollo.BaseMutationOptions<
  UpdateCustomerUserMutation,
  UpdateCustomerUserMutationVariables
>
export const PartnerCreateEmailTemplateDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateEmailTemplate($input: CreateEmailTemplateInput!) {
    PartnerCreateEmailTemplate(input: $input) {
      ...EmailTemplate
    }
  }
  ${EmailTemplateFragmentDoc}
`
export type PartnerCreateEmailTemplateMutationFn = Apollo.MutationFunction<
  PartnerCreateEmailTemplateMutation,
  PartnerCreateEmailTemplateMutationVariables
>

/**
 * __usePartnerCreateEmailTemplateMutation__
 *
 * To run a mutation, you first call `usePartnerCreateEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateEmailTemplateMutation, { data, loading, error }] = usePartnerCreateEmailTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCreateEmailTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateEmailTemplateMutation,
    PartnerCreateEmailTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateEmailTemplateMutation,
    PartnerCreateEmailTemplateMutationVariables
  >(PartnerCreateEmailTemplateDocument, options)
}
export type PartnerCreateEmailTemplateMutationHookResult = ReturnType<
  typeof usePartnerCreateEmailTemplateMutation
>
export type PartnerCreateEmailTemplateMutationResult =
  Apollo.MutationResult<PartnerCreateEmailTemplateMutation>
export type PartnerCreateEmailTemplateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCreateEmailTemplateMutation,
    PartnerCreateEmailTemplateMutationVariables
  >
export const PartnerUpdateEmailTemplateDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateEmailTemplate($input: UpdateEmailTemplateInput!) {
    PartnerUpdateEmailTemplate(input: $input)
  }
`
export type PartnerUpdateEmailTemplateMutationFn = Apollo.MutationFunction<
  PartnerUpdateEmailTemplateMutation,
  PartnerUpdateEmailTemplateMutationVariables
>

/**
 * __usePartnerUpdateEmailTemplateMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateEmailTemplateMutation, { data, loading, error }] = usePartnerUpdateEmailTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateEmailTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateEmailTemplateMutation,
    PartnerUpdateEmailTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateEmailTemplateMutation,
    PartnerUpdateEmailTemplateMutationVariables
  >(PartnerUpdateEmailTemplateDocument, options)
}
export type PartnerUpdateEmailTemplateMutationHookResult = ReturnType<
  typeof usePartnerUpdateEmailTemplateMutation
>
export type PartnerUpdateEmailTemplateMutationResult =
  Apollo.MutationResult<PartnerUpdateEmailTemplateMutation>
export type PartnerUpdateEmailTemplateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateEmailTemplateMutation,
    PartnerUpdateEmailTemplateMutationVariables
  >
export const PartnerDeleteEmailTemplateDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteEmailTemplate($input: DeleteEmailTemplateInput!) {
    PartnerDeleteEmailTemplate(input: $input)
  }
`
export type PartnerDeleteEmailTemplateMutationFn = Apollo.MutationFunction<
  PartnerDeleteEmailTemplateMutation,
  PartnerDeleteEmailTemplateMutationVariables
>

/**
 * __usePartnerDeleteEmailTemplateMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteEmailTemplateMutation, { data, loading, error }] = usePartnerDeleteEmailTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerDeleteEmailTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteEmailTemplateMutation,
    PartnerDeleteEmailTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteEmailTemplateMutation,
    PartnerDeleteEmailTemplateMutationVariables
  >(PartnerDeleteEmailTemplateDocument, options)
}
export type PartnerDeleteEmailTemplateMutationHookResult = ReturnType<
  typeof usePartnerDeleteEmailTemplateMutation
>
export type PartnerDeleteEmailTemplateMutationResult =
  Apollo.MutationResult<PartnerDeleteEmailTemplateMutation>
export type PartnerDeleteEmailTemplateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerDeleteEmailTemplateMutation,
    PartnerDeleteEmailTemplateMutationVariables
  >
export const PartnerToggleEmailTemplateFavoriteDocument = /*#__PURE__*/ gql`
  mutation PartnerToggleEmailTemplateFavorite($templateID: ID!) {
    PartnerToggleEmailTemplateFavorite(templateID: $templateID)
  }
`
export type PartnerToggleEmailTemplateFavoriteMutationFn =
  Apollo.MutationFunction<
    PartnerToggleEmailTemplateFavoriteMutation,
    PartnerToggleEmailTemplateFavoriteMutationVariables
  >

/**
 * __usePartnerToggleEmailTemplateFavoriteMutation__
 *
 * To run a mutation, you first call `usePartnerToggleEmailTemplateFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerToggleEmailTemplateFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerToggleEmailTemplateFavoriteMutation, { data, loading, error }] = usePartnerToggleEmailTemplateFavoriteMutation({
 *   variables: {
 *      templateID: // value for 'templateID'
 *   },
 * });
 */
export function usePartnerToggleEmailTemplateFavoriteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerToggleEmailTemplateFavoriteMutation,
    PartnerToggleEmailTemplateFavoriteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerToggleEmailTemplateFavoriteMutation,
    PartnerToggleEmailTemplateFavoriteMutationVariables
  >(PartnerToggleEmailTemplateFavoriteDocument, options)
}
export type PartnerToggleEmailTemplateFavoriteMutationHookResult = ReturnType<
  typeof usePartnerToggleEmailTemplateFavoriteMutation
>
export type PartnerToggleEmailTemplateFavoriteMutationResult =
  Apollo.MutationResult<PartnerToggleEmailTemplateFavoriteMutation>
export type PartnerToggleEmailTemplateFavoriteMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerToggleEmailTemplateFavoriteMutation,
    PartnerToggleEmailTemplateFavoriteMutationVariables
  >
export const PartnerEmailActivityConnectionDocument = /*#__PURE__*/ gql`
  query PartnerEmailActivityConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: EmailActivityFilter
  ) {
    PartnerEmailActivityConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
    ) {
      edges {
        node {
          ...PartnerEmailActivity
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  ${PartnerEmailActivityFragmentDoc}
`

/**
 * __usePartnerEmailActivityConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerEmailActivityConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerEmailActivityConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerEmailActivityConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePartnerEmailActivityConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerEmailActivityConnectionQuery,
    PartnerEmailActivityConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerEmailActivityConnectionQuery,
    PartnerEmailActivityConnectionQueryVariables
  >(PartnerEmailActivityConnectionDocument, options)
}
export function usePartnerEmailActivityConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerEmailActivityConnectionQuery,
    PartnerEmailActivityConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerEmailActivityConnectionQuery,
    PartnerEmailActivityConnectionQueryVariables
  >(PartnerEmailActivityConnectionDocument, options)
}
export type PartnerEmailActivityConnectionQueryHookResult = ReturnType<
  typeof usePartnerEmailActivityConnectionQuery
>
export type PartnerEmailActivityConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerEmailActivityConnectionLazyQuery
>
export type PartnerEmailActivityConnectionQueryResult = Apollo.QueryResult<
  PartnerEmailActivityConnectionQuery,
  PartnerEmailActivityConnectionQueryVariables
>
export const PartnerListEmailTemplatesDocument = /*#__PURE__*/ gql`
  query PartnerListEmailTemplates(
    $templateType: TemplateType!
    $favoritesOnly: Boolean
    $templateID: ID
  ) {
    PartnerListEmailTemplates(
      templateType: $templateType
      favoritesOnly: $favoritesOnly
      templateID: $templateID
    ) {
      ...EmailTemplate
    }
  }
  ${EmailTemplateFragmentDoc}
`

/**
 * __usePartnerListEmailTemplatesQuery__
 *
 * To run a query within a React component, call `usePartnerListEmailTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListEmailTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListEmailTemplatesQuery({
 *   variables: {
 *      templateType: // value for 'templateType'
 *      favoritesOnly: // value for 'favoritesOnly'
 *      templateID: // value for 'templateID'
 *   },
 * });
 */
export function usePartnerListEmailTemplatesQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerListEmailTemplatesQuery,
    PartnerListEmailTemplatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListEmailTemplatesQuery,
    PartnerListEmailTemplatesQueryVariables
  >(PartnerListEmailTemplatesDocument, options)
}
export function usePartnerListEmailTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListEmailTemplatesQuery,
    PartnerListEmailTemplatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListEmailTemplatesQuery,
    PartnerListEmailTemplatesQueryVariables
  >(PartnerListEmailTemplatesDocument, options)
}
export type PartnerListEmailTemplatesQueryHookResult = ReturnType<
  typeof usePartnerListEmailTemplatesQuery
>
export type PartnerListEmailTemplatesLazyQueryHookResult = ReturnType<
  typeof usePartnerListEmailTemplatesLazyQuery
>
export type PartnerListEmailTemplatesQueryResult = Apollo.QueryResult<
  PartnerListEmailTemplatesQuery,
  PartnerListEmailTemplatesQueryVariables
>
export const PartnerGetPartnerFeeConfigDocument = /*#__PURE__*/ gql`
  query PartnerGetPartnerFeeConfig {
    PartnerGetPartnerFeeConfig {
      coverDirectPaymentFees
      coverFeeConfig {
        coverCardMethodFee
      }
    }
  }
`

/**
 * __usePartnerGetPartnerFeeConfigQuery__
 *
 * To run a query within a React component, call `usePartnerGetPartnerFeeConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetPartnerFeeConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetPartnerFeeConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerGetPartnerFeeConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetPartnerFeeConfigQuery,
    PartnerGetPartnerFeeConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetPartnerFeeConfigQuery,
    PartnerGetPartnerFeeConfigQueryVariables
  >(PartnerGetPartnerFeeConfigDocument, options)
}
export function usePartnerGetPartnerFeeConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetPartnerFeeConfigQuery,
    PartnerGetPartnerFeeConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetPartnerFeeConfigQuery,
    PartnerGetPartnerFeeConfigQueryVariables
  >(PartnerGetPartnerFeeConfigDocument, options)
}
export type PartnerGetPartnerFeeConfigQueryHookResult = ReturnType<
  typeof usePartnerGetPartnerFeeConfigQuery
>
export type PartnerGetPartnerFeeConfigLazyQueryHookResult = ReturnType<
  typeof usePartnerGetPartnerFeeConfigLazyQuery
>
export type PartnerGetPartnerFeeConfigQueryResult = Apollo.QueryResult<
  PartnerGetPartnerFeeConfigQuery,
  PartnerGetPartnerFeeConfigQueryVariables
>
export const PartnerGetCustomPartnerFeeConfigsDocument = /*#__PURE__*/ gql`
  query PartnerGetCustomPartnerFeeConfigs(
    $customPartnerFeeConfigsFilter: CustomPartnerFeeConfigsFilter
  ) {
    PartnerGetCustomPartnerFeeConfigs(
      customPartnerFeeConfigsFilter: $customPartnerFeeConfigsFilter
    ) {
      customPartnerFeeConfigs {
        paymentOriginService
        paymentExecutorType
        coverFeeConfig {
          coverACHMethodFee
          coverCardMethodFee
          coverWireMethodFee
          coverOtherMethodFee
        }
      }
    }
  }
`

/**
 * __usePartnerGetCustomPartnerFeeConfigsQuery__
 *
 * To run a query within a React component, call `usePartnerGetCustomPartnerFeeConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetCustomPartnerFeeConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetCustomPartnerFeeConfigsQuery({
 *   variables: {
 *      customPartnerFeeConfigsFilter: // value for 'customPartnerFeeConfigsFilter'
 *   },
 * });
 */
export function usePartnerGetCustomPartnerFeeConfigsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetCustomPartnerFeeConfigsQuery,
    PartnerGetCustomPartnerFeeConfigsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetCustomPartnerFeeConfigsQuery,
    PartnerGetCustomPartnerFeeConfigsQueryVariables
  >(PartnerGetCustomPartnerFeeConfigsDocument, options)
}
export function usePartnerGetCustomPartnerFeeConfigsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetCustomPartnerFeeConfigsQuery,
    PartnerGetCustomPartnerFeeConfigsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetCustomPartnerFeeConfigsQuery,
    PartnerGetCustomPartnerFeeConfigsQueryVariables
  >(PartnerGetCustomPartnerFeeConfigsDocument, options)
}
export type PartnerGetCustomPartnerFeeConfigsQueryHookResult = ReturnType<
  typeof usePartnerGetCustomPartnerFeeConfigsQuery
>
export type PartnerGetCustomPartnerFeeConfigsLazyQueryHookResult = ReturnType<
  typeof usePartnerGetCustomPartnerFeeConfigsLazyQuery
>
export type PartnerGetCustomPartnerFeeConfigsQueryResult = Apollo.QueryResult<
  PartnerGetCustomPartnerFeeConfigsQuery,
  PartnerGetCustomPartnerFeeConfigsQueryVariables
>
export const PartnerListCustomerFeeExceptionsDocument = /*#__PURE__*/ gql`
  query PartnerListCustomerFeeExceptions(
    $input: PartnerListCustomerFeeExceptionsInput
  ) {
    PartnerListCustomerFeeExceptions(input: $input) {
      ...PartnerCustomerFeeConfig
    }
  }
  ${PartnerCustomerFeeConfigFragmentDoc}
`

/**
 * __usePartnerListCustomerFeeExceptionsQuery__
 *
 * To run a query within a React component, call `usePartnerListCustomerFeeExceptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListCustomerFeeExceptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListCustomerFeeExceptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerListCustomerFeeExceptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListCustomerFeeExceptionsQuery,
    PartnerListCustomerFeeExceptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListCustomerFeeExceptionsQuery,
    PartnerListCustomerFeeExceptionsQueryVariables
  >(PartnerListCustomerFeeExceptionsDocument, options)
}
export function usePartnerListCustomerFeeExceptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListCustomerFeeExceptionsQuery,
    PartnerListCustomerFeeExceptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListCustomerFeeExceptionsQuery,
    PartnerListCustomerFeeExceptionsQueryVariables
  >(PartnerListCustomerFeeExceptionsDocument, options)
}
export type PartnerListCustomerFeeExceptionsQueryHookResult = ReturnType<
  typeof usePartnerListCustomerFeeExceptionsQuery
>
export type PartnerListCustomerFeeExceptionsLazyQueryHookResult = ReturnType<
  typeof usePartnerListCustomerFeeExceptionsLazyQuery
>
export type PartnerListCustomerFeeExceptionsQueryResult = Apollo.QueryResult<
  PartnerListCustomerFeeExceptionsQuery,
  PartnerListCustomerFeeExceptionsQueryVariables
>
export const PartnerChangeCustomPartnerFeeConfigDocument = /*#__PURE__*/ gql`
  mutation PartnerChangeCustomPartnerFeeConfig(
    $customPartnerFeeConfig: CustomPartnerFeeConfigUpsertInput!
  ) {
    PartnerChangeCustomPartnerFeeConfig(
      customPartnerFeeConfig: $customPartnerFeeConfig
    )
  }
`
export type PartnerChangeCustomPartnerFeeConfigMutationFn =
  Apollo.MutationFunction<
    PartnerChangeCustomPartnerFeeConfigMutation,
    PartnerChangeCustomPartnerFeeConfigMutationVariables
  >

/**
 * __usePartnerChangeCustomPartnerFeeConfigMutation__
 *
 * To run a mutation, you first call `usePartnerChangeCustomPartnerFeeConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerChangeCustomPartnerFeeConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerChangeCustomPartnerFeeConfigMutation, { data, loading, error }] = usePartnerChangeCustomPartnerFeeConfigMutation({
 *   variables: {
 *      customPartnerFeeConfig: // value for 'customPartnerFeeConfig'
 *   },
 * });
 */
export function usePartnerChangeCustomPartnerFeeConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerChangeCustomPartnerFeeConfigMutation,
    PartnerChangeCustomPartnerFeeConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerChangeCustomPartnerFeeConfigMutation,
    PartnerChangeCustomPartnerFeeConfigMutationVariables
  >(PartnerChangeCustomPartnerFeeConfigDocument, options)
}
export type PartnerChangeCustomPartnerFeeConfigMutationHookResult = ReturnType<
  typeof usePartnerChangeCustomPartnerFeeConfigMutation
>
export type PartnerChangeCustomPartnerFeeConfigMutationResult =
  Apollo.MutationResult<PartnerChangeCustomPartnerFeeConfigMutation>
export type PartnerChangeCustomPartnerFeeConfigMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerChangeCustomPartnerFeeConfigMutation,
    PartnerChangeCustomPartnerFeeConfigMutationVariables
  >
export const PartnerChangeCustomerFeeConfigDocument = /*#__PURE__*/ gql`
  mutation PartnerChangeCustomerFeeConfig(
    $customerFeeConfig: PartnerChangeCustomerFeeConfigInput!
  ) {
    PartnerChangeCustomerFeeConfig(customerFeeConfig: $customerFeeConfig)
  }
`
export type PartnerChangeCustomerFeeConfigMutationFn = Apollo.MutationFunction<
  PartnerChangeCustomerFeeConfigMutation,
  PartnerChangeCustomerFeeConfigMutationVariables
>

/**
 * __usePartnerChangeCustomerFeeConfigMutation__
 *
 * To run a mutation, you first call `usePartnerChangeCustomerFeeConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerChangeCustomerFeeConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerChangeCustomerFeeConfigMutation, { data, loading, error }] = usePartnerChangeCustomerFeeConfigMutation({
 *   variables: {
 *      customerFeeConfig: // value for 'customerFeeConfig'
 *   },
 * });
 */
export function usePartnerChangeCustomerFeeConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerChangeCustomerFeeConfigMutation,
    PartnerChangeCustomerFeeConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerChangeCustomerFeeConfigMutation,
    PartnerChangeCustomerFeeConfigMutationVariables
  >(PartnerChangeCustomerFeeConfigDocument, options)
}
export type PartnerChangeCustomerFeeConfigMutationHookResult = ReturnType<
  typeof usePartnerChangeCustomerFeeConfigMutation
>
export type PartnerChangeCustomerFeeConfigMutationResult =
  Apollo.MutationResult<PartnerChangeCustomerFeeConfigMutation>
export type PartnerChangeCustomerFeeConfigMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerChangeCustomerFeeConfigMutation,
    PartnerChangeCustomerFeeConfigMutationVariables
  >
export const PartnerChangePartnerFeeConfigDocument = /*#__PURE__*/ gql`
  mutation PartnerChangePartnerFeeConfig(
    $partnerFeeConfig: PartnerFeeConfigUpdateInput!
  ) {
    PartnerChangePartnerFeeConfig(partnerFeeConfig: $partnerFeeConfig)
  }
`
export type PartnerChangePartnerFeeConfigMutationFn = Apollo.MutationFunction<
  PartnerChangePartnerFeeConfigMutation,
  PartnerChangePartnerFeeConfigMutationVariables
>

/**
 * __usePartnerChangePartnerFeeConfigMutation__
 *
 * To run a mutation, you first call `usePartnerChangePartnerFeeConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerChangePartnerFeeConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerChangePartnerFeeConfigMutation, { data, loading, error }] = usePartnerChangePartnerFeeConfigMutation({
 *   variables: {
 *      partnerFeeConfig: // value for 'partnerFeeConfig'
 *   },
 * });
 */
export function usePartnerChangePartnerFeeConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerChangePartnerFeeConfigMutation,
    PartnerChangePartnerFeeConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerChangePartnerFeeConfigMutation,
    PartnerChangePartnerFeeConfigMutationVariables
  >(PartnerChangePartnerFeeConfigDocument, options)
}
export type PartnerChangePartnerFeeConfigMutationHookResult = ReturnType<
  typeof usePartnerChangePartnerFeeConfigMutation
>
export type PartnerChangePartnerFeeConfigMutationResult =
  Apollo.MutationResult<PartnerChangePartnerFeeConfigMutation>
export type PartnerChangePartnerFeeConfigMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerChangePartnerFeeConfigMutation,
    PartnerChangePartnerFeeConfigMutationVariables
  >
export const PartnerChangeBulkCustomerFeeConfigDocument = /*#__PURE__*/ gql`
  mutation PartnerChangeBulkCustomerFeeConfig(
    $customerFeeConfig: PartnerChangeBulkCustomerFeeConfigInput!
  ) {
    PartnerChangeBulkCustomerFeeConfig(customerFeeConfig: $customerFeeConfig)
  }
`
export type PartnerChangeBulkCustomerFeeConfigMutationFn =
  Apollo.MutationFunction<
    PartnerChangeBulkCustomerFeeConfigMutation,
    PartnerChangeBulkCustomerFeeConfigMutationVariables
  >

/**
 * __usePartnerChangeBulkCustomerFeeConfigMutation__
 *
 * To run a mutation, you first call `usePartnerChangeBulkCustomerFeeConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerChangeBulkCustomerFeeConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerChangeBulkCustomerFeeConfigMutation, { data, loading, error }] = usePartnerChangeBulkCustomerFeeConfigMutation({
 *   variables: {
 *      customerFeeConfig: // value for 'customerFeeConfig'
 *   },
 * });
 */
export function usePartnerChangeBulkCustomerFeeConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerChangeBulkCustomerFeeConfigMutation,
    PartnerChangeBulkCustomerFeeConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerChangeBulkCustomerFeeConfigMutation,
    PartnerChangeBulkCustomerFeeConfigMutationVariables
  >(PartnerChangeBulkCustomerFeeConfigDocument, options)
}
export type PartnerChangeBulkCustomerFeeConfigMutationHookResult = ReturnType<
  typeof usePartnerChangeBulkCustomerFeeConfigMutation
>
export type PartnerChangeBulkCustomerFeeConfigMutationResult =
  Apollo.MutationResult<PartnerChangeBulkCustomerFeeConfigMutation>
export type PartnerChangeBulkCustomerFeeConfigMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerChangeBulkCustomerFeeConfigMutation,
    PartnerChangeBulkCustomerFeeConfigMutationVariables
  >
export const GetCustomerInsightsGraphsDocument = /*#__PURE__*/ gql`
  query GetCustomerInsightsGraphs(
    $dateFrom: String!
    $dateTo: String!
    $customerID: String!
  ) {
    PartnerGetInvoiceAmountByStatusMonthCustomerInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
      customerID: $customerID
    ) {
      data {
        ...InvoiceAmountMonth
      }
      average
    }
    PartnerGetAverageTimeToPayByMonthCustomerInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
      customerID: $customerID
    ) {
      data {
        ...DataPoint
      }
      average
    }
    PartnerGetPaymentVolumeByMonthCustomerInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
      customerID: $customerID
    ) {
      data {
        ...DataPoint
      }
      average
    }
    PartnerGetAutomatedPaymentVolumePercentByMonthCustomerInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
      customerID: $customerID
    ) {
      data {
        month
        percent
      }
      average
    }
  }
  ${InvoiceAmountMonthFragmentDoc}
  ${DataPointFragmentDoc}
`

/**
 * __useGetCustomerInsightsGraphsQuery__
 *
 * To run a query within a React component, call `useGetCustomerInsightsGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerInsightsGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerInsightsGraphsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function useGetCustomerInsightsGraphsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCustomerInsightsGraphsQuery,
    GetCustomerInsightsGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetCustomerInsightsGraphsQuery,
    GetCustomerInsightsGraphsQueryVariables
  >(GetCustomerInsightsGraphsDocument, options)
}
export function useGetCustomerInsightsGraphsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerInsightsGraphsQuery,
    GetCustomerInsightsGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetCustomerInsightsGraphsQuery,
    GetCustomerInsightsGraphsQueryVariables
  >(GetCustomerInsightsGraphsDocument, options)
}
export type GetCustomerInsightsGraphsQueryHookResult = ReturnType<
  typeof useGetCustomerInsightsGraphsQuery
>
export type GetCustomerInsightsGraphsLazyQueryHookResult = ReturnType<
  typeof useGetCustomerInsightsGraphsLazyQuery
>
export type GetCustomerInsightsGraphsQueryResult = Apollo.QueryResult<
  GetCustomerInsightsGraphsQuery,
  GetCustomerInsightsGraphsQueryVariables
>
export const GetCustomerInsightsMetricsDocument = /*#__PURE__*/ gql`
  query GetCustomerInsightsMetrics(
    $dateFrom: String!
    $dateTo: String!
    $customerID: String!
  ) {
    PartnerGetPaymentVolumeCustomerInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
      customerID: $customerID
    ) {
      value
    }
    PartnerGetNumberOfPaymentsCustomerInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
      customerID: $customerID
    ) {
      value
    }
    PartnerGetAverageTimeToPayCustomerInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
      customerID: $customerID
    ) {
      value
    }
    PartnerGetAutomatedPaymentsCustomerInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
      customerID: $customerID
    ) {
      value
    }
    PartnerGetInvoiceVolumeCustomerInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
      customerID: $customerID
    ) {
      value
    }
    PartnerGetOverdueInvoicesVolumeThirtyDaysCustomerInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
      customerID: $customerID
    ) {
      value
    }
  }
`

/**
 * __useGetCustomerInsightsMetricsQuery__
 *
 * To run a query within a React component, call `useGetCustomerInsightsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerInsightsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerInsightsMetricsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function useGetCustomerInsightsMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCustomerInsightsMetricsQuery,
    GetCustomerInsightsMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetCustomerInsightsMetricsQuery,
    GetCustomerInsightsMetricsQueryVariables
  >(GetCustomerInsightsMetricsDocument, options)
}
export function useGetCustomerInsightsMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerInsightsMetricsQuery,
    GetCustomerInsightsMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetCustomerInsightsMetricsQuery,
    GetCustomerInsightsMetricsQueryVariables
  >(GetCustomerInsightsMetricsDocument, options)
}
export type GetCustomerInsightsMetricsQueryHookResult = ReturnType<
  typeof useGetCustomerInsightsMetricsQuery
>
export type GetCustomerInsightsMetricsLazyQueryHookResult = ReturnType<
  typeof useGetCustomerInsightsMetricsLazyQuery
>
export type GetCustomerInsightsMetricsQueryResult = Apollo.QueryResult<
  GetCustomerInsightsMetricsQuery,
  GetCustomerInsightsMetricsQueryVariables
>
export const GetInsightOverviewMetricsDocument = /*#__PURE__*/ gql`
  query GetInsightOverviewMetrics($dateFrom: String!, $dateTo: String!) {
    PartnerGetNumberOfOverdueInvoicesThirtyDaysInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      value
    }
    PartnerGetNumberOfPaymentsInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
    PartnerGetPaymentVolumeInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
    PartnerGetAverageTimeToPayInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
    PartnerGetAutomatedPaymentsInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
    PartnerGetOverdueInvoicesVolumeThirtyDaysInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      value
    }
  }
`

/**
 * __useGetInsightOverviewMetricsQuery__
 *
 * To run a query within a React component, call `useGetInsightOverviewMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightOverviewMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightOverviewMetricsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetInsightOverviewMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInsightOverviewMetricsQuery,
    GetInsightOverviewMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetInsightOverviewMetricsQuery,
    GetInsightOverviewMetricsQueryVariables
  >(GetInsightOverviewMetricsDocument, options)
}
export function useGetInsightOverviewMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInsightOverviewMetricsQuery,
    GetInsightOverviewMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetInsightOverviewMetricsQuery,
    GetInsightOverviewMetricsQueryVariables
  >(GetInsightOverviewMetricsDocument, options)
}
export type GetInsightOverviewMetricsQueryHookResult = ReturnType<
  typeof useGetInsightOverviewMetricsQuery
>
export type GetInsightOverviewMetricsLazyQueryHookResult = ReturnType<
  typeof useGetInsightOverviewMetricsLazyQuery
>
export type GetInsightOverviewMetricsQueryResult = Apollo.QueryResult<
  GetInsightOverviewMetricsQuery,
  GetInsightOverviewMetricsQueryVariables
>
export const GetInsightOverviewGraphsDocument = /*#__PURE__*/ gql`
  query GetInsightOverviewGraphs($dateFrom: String!, $dateTo: String!) {
    PartnerGetPaymentVolumeByMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        ...DataPoint
      }
      average
    }
    PartnerGetAverageTimeToPayByMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        ...DataPoint
      }
      average
    }
    PartnerGetAutomatedPaymentsByMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        ...DataPoint
      }
      average
    }
    PartnerGetActivationRatesByMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        ...DataPoint
      }
      average
    }
  }
  ${DataPointFragmentDoc}
`

/**
 * __useGetInsightOverviewGraphsQuery__
 *
 * To run a query within a React component, call `useGetInsightOverviewGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightOverviewGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightOverviewGraphsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetInsightOverviewGraphsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInsightOverviewGraphsQuery,
    GetInsightOverviewGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetInsightOverviewGraphsQuery,
    GetInsightOverviewGraphsQueryVariables
  >(GetInsightOverviewGraphsDocument, options)
}
export function useGetInsightOverviewGraphsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInsightOverviewGraphsQuery,
    GetInsightOverviewGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetInsightOverviewGraphsQuery,
    GetInsightOverviewGraphsQueryVariables
  >(GetInsightOverviewGraphsDocument, options)
}
export type GetInsightOverviewGraphsQueryHookResult = ReturnType<
  typeof useGetInsightOverviewGraphsQuery
>
export type GetInsightOverviewGraphsLazyQueryHookResult = ReturnType<
  typeof useGetInsightOverviewGraphsLazyQuery
>
export type GetInsightOverviewGraphsQueryResult = Apollo.QueryResult<
  GetInsightOverviewGraphsQuery,
  GetInsightOverviewGraphsQueryVariables
>
export const GetInvoicesInsightsMetricsDocument = /*#__PURE__*/ gql`
  query GetInvoicesInsightsMetrics($dateFrom: String!, $dateTo: String!) {
    PartnerGetInvoiceVolumeInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
    PartnerGetInvoiceCountInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
    PartnerGetAverageInvoiceAmountInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      value
    }
    PartnerGetOverdueInvoicePercentageInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      value
    }
  }
`

/**
 * __useGetInvoicesInsightsMetricsQuery__
 *
 * To run a query within a React component, call `useGetInvoicesInsightsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesInsightsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesInsightsMetricsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetInvoicesInsightsMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInvoicesInsightsMetricsQuery,
    GetInvoicesInsightsMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetInvoicesInsightsMetricsQuery,
    GetInvoicesInsightsMetricsQueryVariables
  >(GetInvoicesInsightsMetricsDocument, options)
}
export function useGetInvoicesInsightsMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInvoicesInsightsMetricsQuery,
    GetInvoicesInsightsMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetInvoicesInsightsMetricsQuery,
    GetInvoicesInsightsMetricsQueryVariables
  >(GetInvoicesInsightsMetricsDocument, options)
}
export type GetInvoicesInsightsMetricsQueryHookResult = ReturnType<
  typeof useGetInvoicesInsightsMetricsQuery
>
export type GetInvoicesInsightsMetricsLazyQueryHookResult = ReturnType<
  typeof useGetInvoicesInsightsMetricsLazyQuery
>
export type GetInvoicesInsightsMetricsQueryResult = Apollo.QueryResult<
  GetInvoicesInsightsMetricsQuery,
  GetInvoicesInsightsMetricsQueryVariables
>
export const GetInvoicesInsightsArMetricsDocument = /*#__PURE__*/ gql`
  query GetInvoicesInsightsARMetrics($dateFrom: String!, $dateTo: String!) {
    PartnerGetOverdueInvoiceVolumeInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      value
    }
    PartnerGetOverdueInvoiceCountInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
    PartnerGetAverageOverdueAmountInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      value
    }
    PartnerGetAverageDaysOverdueInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
  }
`

/**
 * __useGetInvoicesInsightsArMetricsQuery__
 *
 * To run a query within a React component, call `useGetInvoicesInsightsArMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesInsightsArMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesInsightsArMetricsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetInvoicesInsightsArMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInvoicesInsightsArMetricsQuery,
    GetInvoicesInsightsArMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetInvoicesInsightsArMetricsQuery,
    GetInvoicesInsightsArMetricsQueryVariables
  >(GetInvoicesInsightsArMetricsDocument, options)
}
export function useGetInvoicesInsightsArMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInvoicesInsightsArMetricsQuery,
    GetInvoicesInsightsArMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetInvoicesInsightsArMetricsQuery,
    GetInvoicesInsightsArMetricsQueryVariables
  >(GetInvoicesInsightsArMetricsDocument, options)
}
export type GetInvoicesInsightsArMetricsQueryHookResult = ReturnType<
  typeof useGetInvoicesInsightsArMetricsQuery
>
export type GetInvoicesInsightsArMetricsLazyQueryHookResult = ReturnType<
  typeof useGetInvoicesInsightsArMetricsLazyQuery
>
export type GetInvoicesInsightsArMetricsQueryResult = Apollo.QueryResult<
  GetInvoicesInsightsArMetricsQuery,
  GetInvoicesInsightsArMetricsQueryVariables
>
export const GetInvoicesInsightsGraphsDocument = /*#__PURE__*/ gql`
  query GetInvoicesInsightsGraphs($dateFrom: String!, $dateTo: String!) {
    PartnerGetInvoiceAmountByStatusMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        ...InvoiceAmountMonth
      }
      average
    }
    PartnerGetInvoiceCountByStatusMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        ...InvoiceCountMonth
      }
      average
    }
  }
  ${InvoiceAmountMonthFragmentDoc}
  ${InvoiceCountMonthFragmentDoc}
`

/**
 * __useGetInvoicesInsightsGraphsQuery__
 *
 * To run a query within a React component, call `useGetInvoicesInsightsGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesInsightsGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesInsightsGraphsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetInvoicesInsightsGraphsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInvoicesInsightsGraphsQuery,
    GetInvoicesInsightsGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetInvoicesInsightsGraphsQuery,
    GetInvoicesInsightsGraphsQueryVariables
  >(GetInvoicesInsightsGraphsDocument, options)
}
export function useGetInvoicesInsightsGraphsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInvoicesInsightsGraphsQuery,
    GetInvoicesInsightsGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetInvoicesInsightsGraphsQuery,
    GetInvoicesInsightsGraphsQueryVariables
  >(GetInvoicesInsightsGraphsDocument, options)
}
export type GetInvoicesInsightsGraphsQueryHookResult = ReturnType<
  typeof useGetInvoicesInsightsGraphsQuery
>
export type GetInvoicesInsightsGraphsLazyQueryHookResult = ReturnType<
  typeof useGetInvoicesInsightsGraphsLazyQuery
>
export type GetInvoicesInsightsGraphsQueryResult = Apollo.QueryResult<
  GetInvoicesInsightsGraphsQuery,
  GetInvoicesInsightsGraphsQueryVariables
>
export const GetInvoicesInsightsArGraphsDocument = /*#__PURE__*/ gql`
  query GetInvoicesInsightsARGraphs($dateFrom: String!, $dateTo: String!) {
    PartnerGetARAgingBucketsAmountInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        ...BucketAmountData
      }
    }
    PartnerGetARAgingBucketsCountInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      data {
        ...BucketCountData
      }
    }
  }
  ${BucketAmountDataFragmentDoc}
  ${BucketCountDataFragmentDoc}
`

/**
 * __useGetInvoicesInsightsArGraphsQuery__
 *
 * To run a query within a React component, call `useGetInvoicesInsightsArGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesInsightsArGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesInsightsArGraphsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetInvoicesInsightsArGraphsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInvoicesInsightsArGraphsQuery,
    GetInvoicesInsightsArGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetInvoicesInsightsArGraphsQuery,
    GetInvoicesInsightsArGraphsQueryVariables
  >(GetInvoicesInsightsArGraphsDocument, options)
}
export function useGetInvoicesInsightsArGraphsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInvoicesInsightsArGraphsQuery,
    GetInvoicesInsightsArGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetInvoicesInsightsArGraphsQuery,
    GetInvoicesInsightsArGraphsQueryVariables
  >(GetInvoicesInsightsArGraphsDocument, options)
}
export type GetInvoicesInsightsArGraphsQueryHookResult = ReturnType<
  typeof useGetInvoicesInsightsArGraphsQuery
>
export type GetInvoicesInsightsArGraphsLazyQueryHookResult = ReturnType<
  typeof useGetInvoicesInsightsArGraphsLazyQuery
>
export type GetInvoicesInsightsArGraphsQueryResult = Apollo.QueryResult<
  GetInvoicesInsightsArGraphsQuery,
  GetInvoicesInsightsArGraphsQueryVariables
>
export const GetPaymentsInsightsMetricsDocument = /*#__PURE__*/ gql`
  query GetPaymentsInsightsMetrics($dateFrom: String!, $dateTo: String!) {
    PartnerGetPaymentVolumeInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
    PartnerGetNumberOfPaymentsInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
    PartnerGetAveragePaymentSizeInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
  }
`

/**
 * __useGetPaymentsInsightsMetricsQuery__
 *
 * To run a query within a React component, call `useGetPaymentsInsightsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentsInsightsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentsInsightsMetricsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetPaymentsInsightsMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPaymentsInsightsMetricsQuery,
    GetPaymentsInsightsMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetPaymentsInsightsMetricsQuery,
    GetPaymentsInsightsMetricsQueryVariables
  >(GetPaymentsInsightsMetricsDocument, options)
}
export function useGetPaymentsInsightsMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPaymentsInsightsMetricsQuery,
    GetPaymentsInsightsMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetPaymentsInsightsMetricsQuery,
    GetPaymentsInsightsMetricsQueryVariables
  >(GetPaymentsInsightsMetricsDocument, options)
}
export type GetPaymentsInsightsMetricsQueryHookResult = ReturnType<
  typeof useGetPaymentsInsightsMetricsQuery
>
export type GetPaymentsInsightsMetricsLazyQueryHookResult = ReturnType<
  typeof useGetPaymentsInsightsMetricsLazyQuery
>
export type GetPaymentsInsightsMetricsQueryResult = Apollo.QueryResult<
  GetPaymentsInsightsMetricsQuery,
  GetPaymentsInsightsMetricsQueryVariables
>
export const GetPaymentsInsightsGraphsDocument = /*#__PURE__*/ gql`
  query GetPaymentsInsightsGraphs($dateFrom: String!, $dateTo: String!) {
    PartnerGetPaymentsCountByMethodMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        month
        method
        count
      }
      average
    }
    PartnerGetPaymentsVolumeByMethodMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        month
        method
        volume
      }
      average
    }
    PartnerGetActivationRatesByMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        ...DataPoint
      }
      average
    }
    PartnerGetActivationRateInvoiceVolumeByMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        month
        value
      }
      average
    }
  }
  ${DataPointFragmentDoc}
`

/**
 * __useGetPaymentsInsightsGraphsQuery__
 *
 * To run a query within a React component, call `useGetPaymentsInsightsGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentsInsightsGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentsInsightsGraphsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetPaymentsInsightsGraphsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPaymentsInsightsGraphsQuery,
    GetPaymentsInsightsGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetPaymentsInsightsGraphsQuery,
    GetPaymentsInsightsGraphsQueryVariables
  >(GetPaymentsInsightsGraphsDocument, options)
}
export function useGetPaymentsInsightsGraphsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPaymentsInsightsGraphsQuery,
    GetPaymentsInsightsGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetPaymentsInsightsGraphsQuery,
    GetPaymentsInsightsGraphsQueryVariables
  >(GetPaymentsInsightsGraphsDocument, options)
}
export type GetPaymentsInsightsGraphsQueryHookResult = ReturnType<
  typeof useGetPaymentsInsightsGraphsQuery
>
export type GetPaymentsInsightsGraphsLazyQueryHookResult = ReturnType<
  typeof useGetPaymentsInsightsGraphsLazyQuery
>
export type GetPaymentsInsightsGraphsQueryResult = Apollo.QueryResult<
  GetPaymentsInsightsGraphsQuery,
  GetPaymentsInsightsGraphsQueryVariables
>
export const GetCollectionsInsightsMetricsDocument = /*#__PURE__*/ gql`
  query GetCollectionsInsightsMetrics($dateFrom: String!, $dateTo: String!) {
    PartnerGetAverageTimeToPayExternalInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      value
    }
    PartnerGetAverageTimeToPayInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
    PartnerGetAverageTimeToPayAutopayInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      value
    }
  }
`

/**
 * __useGetCollectionsInsightsMetricsQuery__
 *
 * To run a query within a React component, call `useGetCollectionsInsightsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsInsightsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsInsightsMetricsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetCollectionsInsightsMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCollectionsInsightsMetricsQuery,
    GetCollectionsInsightsMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetCollectionsInsightsMetricsQuery,
    GetCollectionsInsightsMetricsQueryVariables
  >(GetCollectionsInsightsMetricsDocument, options)
}
export function useGetCollectionsInsightsMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCollectionsInsightsMetricsQuery,
    GetCollectionsInsightsMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetCollectionsInsightsMetricsQuery,
    GetCollectionsInsightsMetricsQueryVariables
  >(GetCollectionsInsightsMetricsDocument, options)
}
export type GetCollectionsInsightsMetricsQueryHookResult = ReturnType<
  typeof useGetCollectionsInsightsMetricsQuery
>
export type GetCollectionsInsightsMetricsLazyQueryHookResult = ReturnType<
  typeof useGetCollectionsInsightsMetricsLazyQuery
>
export type GetCollectionsInsightsMetricsQueryResult = Apollo.QueryResult<
  GetCollectionsInsightsMetricsQuery,
  GetCollectionsInsightsMetricsQueryVariables
>
export const GetCollectionsInsightsGraphsDocument = /*#__PURE__*/ gql`
  query GetCollectionsInsightsGraphs($dateFrom: String!, $dateTo: String!) {
    PartnerGetCashFlowDistributionLastThirtyDaysInsight {
      data {
        date
        value
        isInternal
      }
    }
    PartnerGetAverageTimeToPayExternalVsInternalByMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      internalAvg
      externalAvg
      data {
        month
        average
        isInternal
      }
    }
  }
`

/**
 * __useGetCollectionsInsightsGraphsQuery__
 *
 * To run a query within a React component, call `useGetCollectionsInsightsGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsInsightsGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsInsightsGraphsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetCollectionsInsightsGraphsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCollectionsInsightsGraphsQuery,
    GetCollectionsInsightsGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetCollectionsInsightsGraphsQuery,
    GetCollectionsInsightsGraphsQueryVariables
  >(GetCollectionsInsightsGraphsDocument, options)
}
export function useGetCollectionsInsightsGraphsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCollectionsInsightsGraphsQuery,
    GetCollectionsInsightsGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetCollectionsInsightsGraphsQuery,
    GetCollectionsInsightsGraphsQueryVariables
  >(GetCollectionsInsightsGraphsDocument, options)
}
export type GetCollectionsInsightsGraphsQueryHookResult = ReturnType<
  typeof useGetCollectionsInsightsGraphsQuery
>
export type GetCollectionsInsightsGraphsLazyQueryHookResult = ReturnType<
  typeof useGetCollectionsInsightsGraphsLazyQuery
>
export type GetCollectionsInsightsGraphsQueryResult = Apollo.QueryResult<
  GetCollectionsInsightsGraphsQuery,
  GetCollectionsInsightsGraphsQueryVariables
>
export const GetAutomationsInsightsMetricsDocument = /*#__PURE__*/ gql`
  query GetAutomationsInsightsMetrics($dateFrom: String!, $dateTo: String!) {
    PartnerGetAutomatedPaymentsInsight(dateFrom: $dateFrom, dateTo: $dateTo) {
      value
    }
    PartnerGetAutomatedPaymentVolumePercentageInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      value
    }
    PartnerGetAutomatedTransactionCountInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      count
    }
    PartnerGetPaymentVolumeAutomatedInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      value
    }
  }
`

/**
 * __useGetAutomationsInsightsMetricsQuery__
 *
 * To run a query within a React component, call `useGetAutomationsInsightsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutomationsInsightsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutomationsInsightsMetricsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetAutomationsInsightsMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAutomationsInsightsMetricsQuery,
    GetAutomationsInsightsMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetAutomationsInsightsMetricsQuery,
    GetAutomationsInsightsMetricsQueryVariables
  >(GetAutomationsInsightsMetricsDocument, options)
}
export function useGetAutomationsInsightsMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAutomationsInsightsMetricsQuery,
    GetAutomationsInsightsMetricsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAutomationsInsightsMetricsQuery,
    GetAutomationsInsightsMetricsQueryVariables
  >(GetAutomationsInsightsMetricsDocument, options)
}
export type GetAutomationsInsightsMetricsQueryHookResult = ReturnType<
  typeof useGetAutomationsInsightsMetricsQuery
>
export type GetAutomationsInsightsMetricsLazyQueryHookResult = ReturnType<
  typeof useGetAutomationsInsightsMetricsLazyQuery
>
export type GetAutomationsInsightsMetricsQueryResult = Apollo.QueryResult<
  GetAutomationsInsightsMetricsQuery,
  GetAutomationsInsightsMetricsQueryVariables
>
export const GetAutomationsInsightsGraphsDocument = /*#__PURE__*/ gql`
  query GetAutomationsInsightsGraphs($dateFrom: String!, $dateTo: String!) {
    PartnerGetAutomatedPaymentsByMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        ...DataPoint
      }
      average
    }
    PartnerGetAutomatedPaymentVolumePercentByMonthInsight(
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data {
        month
        percent
      }
      average
    }
  }
  ${DataPointFragmentDoc}
`

/**
 * __useGetAutomationsInsightsGraphsQuery__
 *
 * To run a query within a React component, call `useGetAutomationsInsightsGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutomationsInsightsGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutomationsInsightsGraphsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetAutomationsInsightsGraphsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAutomationsInsightsGraphsQuery,
    GetAutomationsInsightsGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetAutomationsInsightsGraphsQuery,
    GetAutomationsInsightsGraphsQueryVariables
  >(GetAutomationsInsightsGraphsDocument, options)
}
export function useGetAutomationsInsightsGraphsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAutomationsInsightsGraphsQuery,
    GetAutomationsInsightsGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAutomationsInsightsGraphsQuery,
    GetAutomationsInsightsGraphsQueryVariables
  >(GetAutomationsInsightsGraphsDocument, options)
}
export type GetAutomationsInsightsGraphsQueryHookResult = ReturnType<
  typeof useGetAutomationsInsightsGraphsQuery
>
export type GetAutomationsInsightsGraphsLazyQueryHookResult = ReturnType<
  typeof useGetAutomationsInsightsGraphsLazyQuery
>
export type GetAutomationsInsightsGraphsQueryResult = Apollo.QueryResult<
  GetAutomationsInsightsGraphsQuery,
  GetAutomationsInsightsGraphsQueryVariables
>
export const GetAutomationsLastMonthInsightsGraphsDocument = /*#__PURE__*/ gql`
  query GetAutomationsLastMonthInsightsGraphs {
    PartnerGetPaymentCountByTriggerLastMonthInsight {
      data {
        trigger
        count
      }
    }
    PartnerGetPaymentVolumeByTriggerLastMonthInsight {
      data {
        trigger
        volume
      }
    }
  }
`

/**
 * __useGetAutomationsLastMonthInsightsGraphsQuery__
 *
 * To run a query within a React component, call `useGetAutomationsLastMonthInsightsGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutomationsLastMonthInsightsGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutomationsLastMonthInsightsGraphsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAutomationsLastMonthInsightsGraphsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAutomationsLastMonthInsightsGraphsQuery,
    GetAutomationsLastMonthInsightsGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetAutomationsLastMonthInsightsGraphsQuery,
    GetAutomationsLastMonthInsightsGraphsQueryVariables
  >(GetAutomationsLastMonthInsightsGraphsDocument, options)
}
export function useGetAutomationsLastMonthInsightsGraphsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAutomationsLastMonthInsightsGraphsQuery,
    GetAutomationsLastMonthInsightsGraphsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAutomationsLastMonthInsightsGraphsQuery,
    GetAutomationsLastMonthInsightsGraphsQueryVariables
  >(GetAutomationsLastMonthInsightsGraphsDocument, options)
}
export type GetAutomationsLastMonthInsightsGraphsQueryHookResult = ReturnType<
  typeof useGetAutomationsLastMonthInsightsGraphsQuery
>
export type GetAutomationsLastMonthInsightsGraphsLazyQueryHookResult =
  ReturnType<typeof useGetAutomationsLastMonthInsightsGraphsLazyQuery>
export type GetAutomationsLastMonthInsightsGraphsQueryResult =
  Apollo.QueryResult<
    GetAutomationsLastMonthInsightsGraphsQuery,
    GetAutomationsLastMonthInsightsGraphsQueryVariables
  >
export const PartnerAutotaskConnectionCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerAutotaskConnectionCreate(
    $input: PartnerAutotaskConnectionCreateInput
  ) {
    PartnerAutotaskConnectionCreate(input: $input) {
      companyTypes {
        id
        name
      }
      companyClassifications {
        id
        name
      }
      companyTerritoryIDs {
        id
        name
      }
      companyUserDefinedFields {
        name
        type
        isPickList
        picklistValues {
          id
          name
        }
      }
      contactUserDefinedFields {
        name
        type
        isPickList
        picklistValues {
          id
          name
        }
      }
    }
  }
`
export type PartnerAutotaskConnectionCreateMutationFn = Apollo.MutationFunction<
  PartnerAutotaskConnectionCreateMutation,
  PartnerAutotaskConnectionCreateMutationVariables
>

/**
 * __usePartnerAutotaskConnectionCreateMutation__
 *
 * To run a mutation, you first call `usePartnerAutotaskConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAutotaskConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAutotaskConnectionCreateMutation, { data, loading, error }] = usePartnerAutotaskConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerAutotaskConnectionCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAutotaskConnectionCreateMutation,
    PartnerAutotaskConnectionCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAutotaskConnectionCreateMutation,
    PartnerAutotaskConnectionCreateMutationVariables
  >(PartnerAutotaskConnectionCreateDocument, options)
}
export type PartnerAutotaskConnectionCreateMutationHookResult = ReturnType<
  typeof usePartnerAutotaskConnectionCreateMutation
>
export type PartnerAutotaskConnectionCreateMutationResult =
  Apollo.MutationResult<PartnerAutotaskConnectionCreateMutation>
export type PartnerAutotaskConnectionCreateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAutotaskConnectionCreateMutation,
    PartnerAutotaskConnectionCreateMutationVariables
  >
export const PartnerAutotaskConnectionUpdateDocument = /*#__PURE__*/ gql`
  mutation PartnerAutotaskConnectionUpdate(
    $input: PartnerAutotaskConnectionUpdateInput
  ) {
    PartnerAutotaskConnectionUpdate(input: $input)
  }
`
export type PartnerAutotaskConnectionUpdateMutationFn = Apollo.MutationFunction<
  PartnerAutotaskConnectionUpdateMutation,
  PartnerAutotaskConnectionUpdateMutationVariables
>

/**
 * __usePartnerAutotaskConnectionUpdateMutation__
 *
 * To run a mutation, you first call `usePartnerAutotaskConnectionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAutotaskConnectionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAutotaskConnectionUpdateMutation, { data, loading, error }] = usePartnerAutotaskConnectionUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerAutotaskConnectionUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAutotaskConnectionUpdateMutation,
    PartnerAutotaskConnectionUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAutotaskConnectionUpdateMutation,
    PartnerAutotaskConnectionUpdateMutationVariables
  >(PartnerAutotaskConnectionUpdateDocument, options)
}
export type PartnerAutotaskConnectionUpdateMutationHookResult = ReturnType<
  typeof usePartnerAutotaskConnectionUpdateMutation
>
export type PartnerAutotaskConnectionUpdateMutationResult =
  Apollo.MutationResult<PartnerAutotaskConnectionUpdateMutation>
export type PartnerAutotaskConnectionUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAutotaskConnectionUpdateMutation,
    PartnerAutotaskConnectionUpdateMutationVariables
  >
export const PartnerAutotaskGetFiltersDocument = /*#__PURE__*/ gql`
  query PartnerAutotaskGetFilters {
    PartnerAutotaskGetFilters {
      companyTypes {
        id
        name
      }
      companyClassifications {
        id
        name
      }
      companyTerritoryIDs {
        id
        name
      }
      companyUserDefinedFields {
        name
        type
        isPickList
        picklistValues {
          id
          name
        }
      }
      contactUserDefinedFields {
        name
        type
        isPickList
        picklistValues {
          id
          name
        }
      }
    }
  }
`

/**
 * __usePartnerAutotaskGetFiltersQuery__
 *
 * To run a query within a React component, call `usePartnerAutotaskGetFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerAutotaskGetFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerAutotaskGetFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerAutotaskGetFiltersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerAutotaskGetFiltersQuery,
    PartnerAutotaskGetFiltersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerAutotaskGetFiltersQuery,
    PartnerAutotaskGetFiltersQueryVariables
  >(PartnerAutotaskGetFiltersDocument, options)
}
export function usePartnerAutotaskGetFiltersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerAutotaskGetFiltersQuery,
    PartnerAutotaskGetFiltersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerAutotaskGetFiltersQuery,
    PartnerAutotaskGetFiltersQueryVariables
  >(PartnerAutotaskGetFiltersDocument, options)
}
export type PartnerAutotaskGetFiltersQueryHookResult = ReturnType<
  typeof usePartnerAutotaskGetFiltersQuery
>
export type PartnerAutotaskGetFiltersLazyQueryHookResult = ReturnType<
  typeof usePartnerAutotaskGetFiltersLazyQuery
>
export type PartnerAutotaskGetFiltersQueryResult = Apollo.QueryResult<
  PartnerAutotaskGetFiltersQuery,
  PartnerAutotaskGetFiltersQueryVariables
>
export const PartnerContractTypeConnectionDocument = /*#__PURE__*/ gql`
  query PartnerContractTypeConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $orderBy: ContractTypeOrderBy
    $filter: ContractTypeFilter
  ) {
    PartnerContractTypeConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      orderBy: $orderBy
      filter: $filter
    ) {
      edges {
        node {
          externalID
          name
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`

/**
 * __usePartnerContractTypeConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerContractTypeConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerContractTypeConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerContractTypeConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePartnerContractTypeConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerContractTypeConnectionQuery,
    PartnerContractTypeConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerContractTypeConnectionQuery,
    PartnerContractTypeConnectionQueryVariables
  >(PartnerContractTypeConnectionDocument, options)
}
export function usePartnerContractTypeConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerContractTypeConnectionQuery,
    PartnerContractTypeConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerContractTypeConnectionQuery,
    PartnerContractTypeConnectionQueryVariables
  >(PartnerContractTypeConnectionDocument, options)
}
export type PartnerContractTypeConnectionQueryHookResult = ReturnType<
  typeof usePartnerContractTypeConnectionQuery
>
export type PartnerContractTypeConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerContractTypeConnectionLazyQuery
>
export type PartnerContractTypeConnectionQueryResult = Apollo.QueryResult<
  PartnerContractTypeConnectionQuery,
  PartnerContractTypeConnectionQueryVariables
>
export const PartnerAutotaskContractConnectionDocument = /*#__PURE__*/ gql`
  query PartnerAutotaskContractConnection($filter: AutotaskContractFilter) {
    PartnerAutotaskContractConnection(filter: $filter) {
      contracts
    }
  }
`

/**
 * __usePartnerAutotaskContractConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerAutotaskContractConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerAutotaskContractConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerAutotaskContractConnectionQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePartnerAutotaskContractConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerAutotaskContractConnectionQuery,
    PartnerAutotaskContractConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerAutotaskContractConnectionQuery,
    PartnerAutotaskContractConnectionQueryVariables
  >(PartnerAutotaskContractConnectionDocument, options)
}
export function usePartnerAutotaskContractConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerAutotaskContractConnectionQuery,
    PartnerAutotaskContractConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerAutotaskContractConnectionQuery,
    PartnerAutotaskContractConnectionQueryVariables
  >(PartnerAutotaskContractConnectionDocument, options)
}
export type PartnerAutotaskContractConnectionQueryHookResult = ReturnType<
  typeof usePartnerAutotaskContractConnectionQuery
>
export type PartnerAutotaskContractConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerAutotaskContractConnectionLazyQuery
>
export type PartnerAutotaskContractConnectionQueryResult = Apollo.QueryResult<
  PartnerAutotaskContractConnectionQuery,
  PartnerAutotaskContractConnectionQueryVariables
>
export const PartnerConnectWiseConnectionCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerConnectWiseConnectionCreate(
    $input: PartnerConnectWiseConnectionCreateInput
  ) {
    PartnerConnectWiseConnectionCreate(input: $input) {
      ...CWQueryFilters
    }
  }
  ${CwQueryFiltersFragmentDoc}
`
export type PartnerConnectWiseConnectionCreateMutationFn =
  Apollo.MutationFunction<
    PartnerConnectWiseConnectionCreateMutation,
    PartnerConnectWiseConnectionCreateMutationVariables
  >

/**
 * __usePartnerConnectWiseConnectionCreateMutation__
 *
 * To run a mutation, you first call `usePartnerConnectWiseConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerConnectWiseConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerConnectWiseConnectionCreateMutation, { data, loading, error }] = usePartnerConnectWiseConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerConnectWiseConnectionCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerConnectWiseConnectionCreateMutation,
    PartnerConnectWiseConnectionCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerConnectWiseConnectionCreateMutation,
    PartnerConnectWiseConnectionCreateMutationVariables
  >(PartnerConnectWiseConnectionCreateDocument, options)
}
export type PartnerConnectWiseConnectionCreateMutationHookResult = ReturnType<
  typeof usePartnerConnectWiseConnectionCreateMutation
>
export type PartnerConnectWiseConnectionCreateMutationResult =
  Apollo.MutationResult<PartnerConnectWiseConnectionCreateMutation>
export type PartnerConnectWiseConnectionCreateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerConnectWiseConnectionCreateMutation,
    PartnerConnectWiseConnectionCreateMutationVariables
  >
export const PartnerConnectWiseConnectionUpdateDocument = /*#__PURE__*/ gql`
  mutation PartnerConnectWiseConnectionUpdate(
    $input: ConnectWiseQueryFiltersInput
  ) {
    PartnerConnectWiseConnectionUpdate(input: $input)
  }
`
export type PartnerConnectWiseConnectionUpdateMutationFn =
  Apollo.MutationFunction<
    PartnerConnectWiseConnectionUpdateMutation,
    PartnerConnectWiseConnectionUpdateMutationVariables
  >

/**
 * __usePartnerConnectWiseConnectionUpdateMutation__
 *
 * To run a mutation, you first call `usePartnerConnectWiseConnectionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerConnectWiseConnectionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerConnectWiseConnectionUpdateMutation, { data, loading, error }] = usePartnerConnectWiseConnectionUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerConnectWiseConnectionUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerConnectWiseConnectionUpdateMutation,
    PartnerConnectWiseConnectionUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerConnectWiseConnectionUpdateMutation,
    PartnerConnectWiseConnectionUpdateMutationVariables
  >(PartnerConnectWiseConnectionUpdateDocument, options)
}
export type PartnerConnectWiseConnectionUpdateMutationHookResult = ReturnType<
  typeof usePartnerConnectWiseConnectionUpdateMutation
>
export type PartnerConnectWiseConnectionUpdateMutationResult =
  Apollo.MutationResult<PartnerConnectWiseConnectionUpdateMutation>
export type PartnerConnectWiseConnectionUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerConnectWiseConnectionUpdateMutation,
    PartnerConnectWiseConnectionUpdateMutationVariables
  >
export const PartnerConnectWiseGetConnectionDocument = /*#__PURE__*/ gql`
  query PartnerConnectWiseGetConnection {
    PartnerConnectWiseGetConnection {
      partnerID
      queryFilters {
        ...CWQueryFilters
      }
    }
  }
  ${CwQueryFiltersFragmentDoc}
`

/**
 * __usePartnerConnectWiseGetConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerConnectWiseGetConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerConnectWiseGetConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerConnectWiseGetConnectionQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerConnectWiseGetConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerConnectWiseGetConnectionQuery,
    PartnerConnectWiseGetConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerConnectWiseGetConnectionQuery,
    PartnerConnectWiseGetConnectionQueryVariables
  >(PartnerConnectWiseGetConnectionDocument, options)
}
export function usePartnerConnectWiseGetConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerConnectWiseGetConnectionQuery,
    PartnerConnectWiseGetConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerConnectWiseGetConnectionQuery,
    PartnerConnectWiseGetConnectionQueryVariables
  >(PartnerConnectWiseGetConnectionDocument, options)
}
export type PartnerConnectWiseGetConnectionQueryHookResult = ReturnType<
  typeof usePartnerConnectWiseGetConnectionQuery
>
export type PartnerConnectWiseGetConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerConnectWiseGetConnectionLazyQuery
>
export type PartnerConnectWiseGetConnectionQueryResult = Apollo.QueryResult<
  PartnerConnectWiseGetConnectionQuery,
  PartnerConnectWiseGetConnectionQueryVariables
>
export const PartnerConnectWiseGetFiltersDocument = /*#__PURE__*/ gql`
  query PartnerConnectWiseGetFilters {
    PartnerConnectWiseGetFilters {
      ...CWQueryFilters
    }
  }
  ${CwQueryFiltersFragmentDoc}
`

/**
 * __usePartnerConnectWiseGetFiltersQuery__
 *
 * To run a query within a React component, call `usePartnerConnectWiseGetFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerConnectWiseGetFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerConnectWiseGetFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerConnectWiseGetFiltersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerConnectWiseGetFiltersQuery,
    PartnerConnectWiseGetFiltersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerConnectWiseGetFiltersQuery,
    PartnerConnectWiseGetFiltersQueryVariables
  >(PartnerConnectWiseGetFiltersDocument, options)
}
export function usePartnerConnectWiseGetFiltersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerConnectWiseGetFiltersQuery,
    PartnerConnectWiseGetFiltersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerConnectWiseGetFiltersQuery,
    PartnerConnectWiseGetFiltersQueryVariables
  >(PartnerConnectWiseGetFiltersDocument, options)
}
export type PartnerConnectWiseGetFiltersQueryHookResult = ReturnType<
  typeof usePartnerConnectWiseGetFiltersQuery
>
export type PartnerConnectWiseGetFiltersLazyQueryHookResult = ReturnType<
  typeof usePartnerConnectWiseGetFiltersLazyQuery
>
export type PartnerConnectWiseGetFiltersQueryResult = Apollo.QueryResult<
  PartnerConnectWiseGetFiltersQuery,
  PartnerConnectWiseGetFiltersQueryVariables
>
export const PartnerAgreementTypeConnectionDocument = /*#__PURE__*/ gql`
  query PartnerAgreementTypeConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $orderBy: AgreementTypeOrderBy
    $filter: AgreementTypeFilter
  ) {
    PartnerAgreementTypeConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      orderBy: $orderBy
      filter: $filter
    ) {
      edges {
        node {
          externalID
          name
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`

/**
 * __usePartnerAgreementTypeConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerAgreementTypeConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerAgreementTypeConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerAgreementTypeConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePartnerAgreementTypeConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerAgreementTypeConnectionQuery,
    PartnerAgreementTypeConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerAgreementTypeConnectionQuery,
    PartnerAgreementTypeConnectionQueryVariables
  >(PartnerAgreementTypeConnectionDocument, options)
}
export function usePartnerAgreementTypeConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerAgreementTypeConnectionQuery,
    PartnerAgreementTypeConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerAgreementTypeConnectionQuery,
    PartnerAgreementTypeConnectionQueryVariables
  >(PartnerAgreementTypeConnectionDocument, options)
}
export type PartnerAgreementTypeConnectionQueryHookResult = ReturnType<
  typeof usePartnerAgreementTypeConnectionQuery
>
export type PartnerAgreementTypeConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerAgreementTypeConnectionLazyQuery
>
export type PartnerAgreementTypeConnectionQueryResult = Apollo.QueryResult<
  PartnerAgreementTypeConnectionQuery,
  PartnerAgreementTypeConnectionQueryVariables
>
export const PartnerConnectWiseBillingTermsConnectionDocument = /*#__PURE__*/ gql`
  query PartnerConnectWiseBillingTermsConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $orderBy: CWBillingTermsOrderBy
    $filter: CWBillingTermsFilter
  ) {
    PartnerConnectWiseBillingTermsConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      orderBy: $orderBy
      filter: $filter
    ) {
      edges {
        node {
          externalID
          name
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`

/**
 * __usePartnerConnectWiseBillingTermsConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerConnectWiseBillingTermsConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerConnectWiseBillingTermsConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerConnectWiseBillingTermsConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePartnerConnectWiseBillingTermsConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerConnectWiseBillingTermsConnectionQuery,
    PartnerConnectWiseBillingTermsConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerConnectWiseBillingTermsConnectionQuery,
    PartnerConnectWiseBillingTermsConnectionQueryVariables
  >(PartnerConnectWiseBillingTermsConnectionDocument, options)
}
export function usePartnerConnectWiseBillingTermsConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerConnectWiseBillingTermsConnectionQuery,
    PartnerConnectWiseBillingTermsConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerConnectWiseBillingTermsConnectionQuery,
    PartnerConnectWiseBillingTermsConnectionQueryVariables
  >(PartnerConnectWiseBillingTermsConnectionDocument, options)
}
export type PartnerConnectWiseBillingTermsConnectionQueryHookResult =
  ReturnType<typeof usePartnerConnectWiseBillingTermsConnectionQuery>
export type PartnerConnectWiseBillingTermsConnectionLazyQueryHookResult =
  ReturnType<typeof usePartnerConnectWiseBillingTermsConnectionLazyQuery>
export type PartnerConnectWiseBillingTermsConnectionQueryResult =
  Apollo.QueryResult<
    PartnerConnectWiseBillingTermsConnectionQuery,
    PartnerConnectWiseBillingTermsConnectionQueryVariables
  >
export const PartnerConnectWiseAgreementConnectionDocument = /*#__PURE__*/ gql`
  query PartnerConnectWiseAgreementConnection(
    $filter: ConnectWiseAgreementFilter
  ) {
    PartnerConnectWiseAgreementConnection(filter: $filter) {
      agreements
    }
  }
`

/**
 * __usePartnerConnectWiseAgreementConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerConnectWiseAgreementConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerConnectWiseAgreementConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerConnectWiseAgreementConnectionQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePartnerConnectWiseAgreementConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerConnectWiseAgreementConnectionQuery,
    PartnerConnectWiseAgreementConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerConnectWiseAgreementConnectionQuery,
    PartnerConnectWiseAgreementConnectionQueryVariables
  >(PartnerConnectWiseAgreementConnectionDocument, options)
}
export function usePartnerConnectWiseAgreementConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerConnectWiseAgreementConnectionQuery,
    PartnerConnectWiseAgreementConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerConnectWiseAgreementConnectionQuery,
    PartnerConnectWiseAgreementConnectionQueryVariables
  >(PartnerConnectWiseAgreementConnectionDocument, options)
}
export type PartnerConnectWiseAgreementConnectionQueryHookResult = ReturnType<
  typeof usePartnerConnectWiseAgreementConnectionQuery
>
export type PartnerConnectWiseAgreementConnectionLazyQueryHookResult =
  ReturnType<typeof usePartnerConnectWiseAgreementConnectionLazyQuery>
export type PartnerConnectWiseAgreementConnectionQueryResult =
  Apollo.QueryResult<
    PartnerConnectWiseAgreementConnectionQuery,
    PartnerConnectWiseAgreementConnectionQueryVariables
  >
export const PartnerDatagateConnectionCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerDatagateConnectionCreate(
    $input: DatagateConnectionCreateInput
  ) {
    PartnerDatagateConnectionCreate(input: $input)
  }
`
export type PartnerDatagateConnectionCreateMutationFn = Apollo.MutationFunction<
  PartnerDatagateConnectionCreateMutation,
  PartnerDatagateConnectionCreateMutationVariables
>

/**
 * __usePartnerDatagateConnectionCreateMutation__
 *
 * To run a mutation, you first call `usePartnerDatagateConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDatagateConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDatagateConnectionCreateMutation, { data, loading, error }] = usePartnerDatagateConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerDatagateConnectionCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDatagateConnectionCreateMutation,
    PartnerDatagateConnectionCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDatagateConnectionCreateMutation,
    PartnerDatagateConnectionCreateMutationVariables
  >(PartnerDatagateConnectionCreateDocument, options)
}
export type PartnerDatagateConnectionCreateMutationHookResult = ReturnType<
  typeof usePartnerDatagateConnectionCreateMutation
>
export type PartnerDatagateConnectionCreateMutationResult =
  Apollo.MutationResult<PartnerDatagateConnectionCreateMutation>
export type PartnerDatagateConnectionCreateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerDatagateConnectionCreateMutation,
    PartnerDatagateConnectionCreateMutationVariables
  >
export const PartnerHaloPsaConnectionCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerHaloPSAConnectionCreate(
    $input: PartnerHaloPSAConnectionCreateInput
  ) {
    PartnerHaloPSAConnectionCreate(input: $input) {
      success
      errorMessage
    }
  }
`
export type PartnerHaloPsaConnectionCreateMutationFn = Apollo.MutationFunction<
  PartnerHaloPsaConnectionCreateMutation,
  PartnerHaloPsaConnectionCreateMutationVariables
>

/**
 * __usePartnerHaloPsaConnectionCreateMutation__
 *
 * To run a mutation, you first call `usePartnerHaloPsaConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerHaloPsaConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerHaloPsaConnectionCreateMutation, { data, loading, error }] = usePartnerHaloPsaConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerHaloPsaConnectionCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerHaloPsaConnectionCreateMutation,
    PartnerHaloPsaConnectionCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerHaloPsaConnectionCreateMutation,
    PartnerHaloPsaConnectionCreateMutationVariables
  >(PartnerHaloPsaConnectionCreateDocument, options)
}
export type PartnerHaloPsaConnectionCreateMutationHookResult = ReturnType<
  typeof usePartnerHaloPsaConnectionCreateMutation
>
export type PartnerHaloPsaConnectionCreateMutationResult =
  Apollo.MutationResult<PartnerHaloPsaConnectionCreateMutation>
export type PartnerHaloPsaConnectionCreateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerHaloPsaConnectionCreateMutation,
    PartnerHaloPsaConnectionCreateMutationVariables
  >
export const PartnerContractSubtypeConnectionDocument = /*#__PURE__*/ gql`
  query PartnerContractSubtypeConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $orderBy: ContractSubtypeOrderBy
    $filter: ContractSubtypeFilter
  ) {
    PartnerContractSubtypeConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      orderBy: $orderBy
      filter: $filter
    ) {
      edges {
        node {
          externalID
          name
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`

/**
 * __usePartnerContractSubtypeConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerContractSubtypeConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerContractSubtypeConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerContractSubtypeConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePartnerContractSubtypeConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerContractSubtypeConnectionQuery,
    PartnerContractSubtypeConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerContractSubtypeConnectionQuery,
    PartnerContractSubtypeConnectionQueryVariables
  >(PartnerContractSubtypeConnectionDocument, options)
}
export function usePartnerContractSubtypeConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerContractSubtypeConnectionQuery,
    PartnerContractSubtypeConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerContractSubtypeConnectionQuery,
    PartnerContractSubtypeConnectionQueryVariables
  >(PartnerContractSubtypeConnectionDocument, options)
}
export type PartnerContractSubtypeConnectionQueryHookResult = ReturnType<
  typeof usePartnerContractSubtypeConnectionQuery
>
export type PartnerContractSubtypeConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerContractSubtypeConnectionLazyQuery
>
export type PartnerContractSubtypeConnectionQueryResult = Apollo.QueryResult<
  PartnerContractSubtypeConnectionQuery,
  PartnerContractSubtypeConnectionQueryVariables
>
export const PartnerListIntegrationsDocument = /*#__PURE__*/ gql`
  query PartnerListIntegrations {
    PartnerListIntegrations {
      __typename
      id
      partnerID
      platformName
      createdAt
      integrationType
      ... on AutotaskIntegration {
        status
      }
      ... on ConnectwiseIntegration {
        status
      }
      ... on HaloPSAIntegration {
        status
      }
      ... on QuickbooksIntegration {
        status
      }
      ... on RutterIntegration {
        status
      }
      ... on SuperOpsIntegration {
        status
      }
      ... on DatagateIntegration {
        status
      }
    }
  }
`

/**
 * __usePartnerListIntegrationsQuery__
 *
 * To run a query within a React component, call `usePartnerListIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerListIntegrationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListIntegrationsQuery,
    PartnerListIntegrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListIntegrationsQuery,
    PartnerListIntegrationsQueryVariables
  >(PartnerListIntegrationsDocument, options)
}
export function usePartnerListIntegrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListIntegrationsQuery,
    PartnerListIntegrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListIntegrationsQuery,
    PartnerListIntegrationsQueryVariables
  >(PartnerListIntegrationsDocument, options)
}
export type PartnerListIntegrationsQueryHookResult = ReturnType<
  typeof usePartnerListIntegrationsQuery
>
export type PartnerListIntegrationsLazyQueryHookResult = ReturnType<
  typeof usePartnerListIntegrationsLazyQuery
>
export type PartnerListIntegrationsQueryResult = Apollo.QueryResult<
  PartnerListIntegrationsQuery,
  PartnerListIntegrationsQueryVariables
>
export const PartnerIntegrationDisconnectDocument = /*#__PURE__*/ gql`
  mutation PartnerIntegrationDisconnect($input: IntegrationDisconnectInput) {
    PartnerIntegrationDisconnect(input: $input)
  }
`
export type PartnerIntegrationDisconnectMutationFn = Apollo.MutationFunction<
  PartnerIntegrationDisconnectMutation,
  PartnerIntegrationDisconnectMutationVariables
>

/**
 * __usePartnerIntegrationDisconnectMutation__
 *
 * To run a mutation, you first call `usePartnerIntegrationDisconnectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerIntegrationDisconnectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerIntegrationDisconnectMutation, { data, loading, error }] = usePartnerIntegrationDisconnectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerIntegrationDisconnectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerIntegrationDisconnectMutation,
    PartnerIntegrationDisconnectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerIntegrationDisconnectMutation,
    PartnerIntegrationDisconnectMutationVariables
  >(PartnerIntegrationDisconnectDocument, options)
}
export type PartnerIntegrationDisconnectMutationHookResult = ReturnType<
  typeof usePartnerIntegrationDisconnectMutation
>
export type PartnerIntegrationDisconnectMutationResult =
  Apollo.MutationResult<PartnerIntegrationDisconnectMutation>
export type PartnerIntegrationDisconnectMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerIntegrationDisconnectMutation,
    PartnerIntegrationDisconnectMutationVariables
  >
export const PartnerIntegrationSyncDocument = /*#__PURE__*/ gql`
  mutation PartnerIntegrationSync($input: IntegrationSyncInput) {
    PartnerIntegrationSync(input: $input) {
      success
      message
    }
  }
`
export type PartnerIntegrationSyncMutationFn = Apollo.MutationFunction<
  PartnerIntegrationSyncMutation,
  PartnerIntegrationSyncMutationVariables
>

/**
 * __usePartnerIntegrationSyncMutation__
 *
 * To run a mutation, you first call `usePartnerIntegrationSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerIntegrationSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerIntegrationSyncMutation, { data, loading, error }] = usePartnerIntegrationSyncMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerIntegrationSyncMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerIntegrationSyncMutation,
    PartnerIntegrationSyncMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerIntegrationSyncMutation,
    PartnerIntegrationSyncMutationVariables
  >(PartnerIntegrationSyncDocument, options)
}
export type PartnerIntegrationSyncMutationHookResult = ReturnType<
  typeof usePartnerIntegrationSyncMutation
>
export type PartnerIntegrationSyncMutationResult =
  Apollo.MutationResult<PartnerIntegrationSyncMutation>
export type PartnerIntegrationSyncMutationOptions = Apollo.BaseMutationOptions<
  PartnerIntegrationSyncMutation,
  PartnerIntegrationSyncMutationVariables
>
export const PartnerListUnsyncedInvoicesDocument = /*#__PURE__*/ gql`
  query PartnerListUnsyncedInvoices(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $orderBy: UnsyncedInvoicesOrderBy
    $filters: UnsyncedInvoicesFilter
  ) {
    PartnerListUnsyncedInvoices(
      after: $after
      first: $first
      before: $before
      last: $last
      orderBy: $orderBy
      filters: $filters
    ) {
      edges {
        cursor
        node {
          ...PartnerUnsyncedInvoice
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
  ${PartnerUnsyncedInvoiceFragmentDoc}
`

/**
 * __usePartnerListUnsyncedInvoicesQuery__
 *
 * To run a query within a React component, call `usePartnerListUnsyncedInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListUnsyncedInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListUnsyncedInvoicesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePartnerListUnsyncedInvoicesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListUnsyncedInvoicesQuery,
    PartnerListUnsyncedInvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListUnsyncedInvoicesQuery,
    PartnerListUnsyncedInvoicesQueryVariables
  >(PartnerListUnsyncedInvoicesDocument, options)
}
export function usePartnerListUnsyncedInvoicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListUnsyncedInvoicesQuery,
    PartnerListUnsyncedInvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListUnsyncedInvoicesQuery,
    PartnerListUnsyncedInvoicesQueryVariables
  >(PartnerListUnsyncedInvoicesDocument, options)
}
export type PartnerListUnsyncedInvoicesQueryHookResult = ReturnType<
  typeof usePartnerListUnsyncedInvoicesQuery
>
export type PartnerListUnsyncedInvoicesLazyQueryHookResult = ReturnType<
  typeof usePartnerListUnsyncedInvoicesLazyQuery
>
export type PartnerListUnsyncedInvoicesQueryResult = Apollo.QueryResult<
  PartnerListUnsyncedInvoicesQuery,
  PartnerListUnsyncedInvoicesQueryVariables
>
export const PartnerGetUnsyncedInvoiceTotalsDocument = /*#__PURE__*/ gql`
  query PartnerGetUnsyncedInvoiceTotals($filters: UnsyncedInvoicesFilter) {
    PartnerGetUnsyncedInvoiceTotals(filters: $filters) {
      count
      amount
    }
  }
`

/**
 * __usePartnerGetUnsyncedInvoiceTotalsQuery__
 *
 * To run a query within a React component, call `usePartnerGetUnsyncedInvoiceTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetUnsyncedInvoiceTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetUnsyncedInvoiceTotalsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePartnerGetUnsyncedInvoiceTotalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetUnsyncedInvoiceTotalsQuery,
    PartnerGetUnsyncedInvoiceTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetUnsyncedInvoiceTotalsQuery,
    PartnerGetUnsyncedInvoiceTotalsQueryVariables
  >(PartnerGetUnsyncedInvoiceTotalsDocument, options)
}
export function usePartnerGetUnsyncedInvoiceTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetUnsyncedInvoiceTotalsQuery,
    PartnerGetUnsyncedInvoiceTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetUnsyncedInvoiceTotalsQuery,
    PartnerGetUnsyncedInvoiceTotalsQueryVariables
  >(PartnerGetUnsyncedInvoiceTotalsDocument, options)
}
export type PartnerGetUnsyncedInvoiceTotalsQueryHookResult = ReturnType<
  typeof usePartnerGetUnsyncedInvoiceTotalsQuery
>
export type PartnerGetUnsyncedInvoiceTotalsLazyQueryHookResult = ReturnType<
  typeof usePartnerGetUnsyncedInvoiceTotalsLazyQuery
>
export type PartnerGetUnsyncedInvoiceTotalsQueryResult = Apollo.QueryResult<
  PartnerGetUnsyncedInvoiceTotalsQuery,
  PartnerGetUnsyncedInvoiceTotalsQueryVariables
>
export const PartnerAccountingSyncBatchCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerAccountingSyncBatchCreate(
    $input: AccountingSyncBatchCreateInput
  ) {
    PartnerAccountingSyncBatchCreate(input: $input) {
      batch {
        id
      }
      notSyncedInvoiceNumbers
    }
  }
`
export type PartnerAccountingSyncBatchCreateMutationFn =
  Apollo.MutationFunction<
    PartnerAccountingSyncBatchCreateMutation,
    PartnerAccountingSyncBatchCreateMutationVariables
  >

/**
 * __usePartnerAccountingSyncBatchCreateMutation__
 *
 * To run a mutation, you first call `usePartnerAccountingSyncBatchCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAccountingSyncBatchCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAccountingSyncBatchCreateMutation, { data, loading, error }] = usePartnerAccountingSyncBatchCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerAccountingSyncBatchCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAccountingSyncBatchCreateMutation,
    PartnerAccountingSyncBatchCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAccountingSyncBatchCreateMutation,
    PartnerAccountingSyncBatchCreateMutationVariables
  >(PartnerAccountingSyncBatchCreateDocument, options)
}
export type PartnerAccountingSyncBatchCreateMutationHookResult = ReturnType<
  typeof usePartnerAccountingSyncBatchCreateMutation
>
export type PartnerAccountingSyncBatchCreateMutationResult =
  Apollo.MutationResult<PartnerAccountingSyncBatchCreateMutation>
export type PartnerAccountingSyncBatchCreateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAccountingSyncBatchCreateMutation,
    PartnerAccountingSyncBatchCreateMutationVariables
  >
export const PartnerGetAccountingSyncBatchDocument = /*#__PURE__*/ gql`
  query PartnerGetAccountingSyncBatch($batchID: ID!) {
    PartnerGetAccountingSyncBatch(batchID: $batchID) {
      batch {
        ...AccountingSyncBatch
      }
      invoiceJobs {
        internalEntityID
        type
        status
        invoiceData {
          invoiceNumber
          invoiceDate
          dueDate
          amount
          customerName
        }
      }
    }
  }
  ${AccountingSyncBatchFragmentDoc}
`

/**
 * __usePartnerGetAccountingSyncBatchQuery__
 *
 * To run a query within a React component, call `usePartnerGetAccountingSyncBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetAccountingSyncBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetAccountingSyncBatchQuery({
 *   variables: {
 *      batchID: // value for 'batchID'
 *   },
 * });
 */
export function usePartnerGetAccountingSyncBatchQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetAccountingSyncBatchQuery,
    PartnerGetAccountingSyncBatchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetAccountingSyncBatchQuery,
    PartnerGetAccountingSyncBatchQueryVariables
  >(PartnerGetAccountingSyncBatchDocument, options)
}
export function usePartnerGetAccountingSyncBatchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetAccountingSyncBatchQuery,
    PartnerGetAccountingSyncBatchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetAccountingSyncBatchQuery,
    PartnerGetAccountingSyncBatchQueryVariables
  >(PartnerGetAccountingSyncBatchDocument, options)
}
export type PartnerGetAccountingSyncBatchQueryHookResult = ReturnType<
  typeof usePartnerGetAccountingSyncBatchQuery
>
export type PartnerGetAccountingSyncBatchLazyQueryHookResult = ReturnType<
  typeof usePartnerGetAccountingSyncBatchLazyQuery
>
export type PartnerGetAccountingSyncBatchQueryResult = Apollo.QueryResult<
  PartnerGetAccountingSyncBatchQuery,
  PartnerGetAccountingSyncBatchQueryVariables
>
export const PartnerListAccountingSyncBatchesDocument = /*#__PURE__*/ gql`
  query PartnerListAccountingSyncBatches(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: ListAccountingSyncBatchesFilter
  ) {
    PartnerListAccountingSyncBatches(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
    ) {
      edges {
        cursor
        node {
          ...AccountingSyncBatch
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
  ${AccountingSyncBatchFragmentDoc}
`

/**
 * __usePartnerListAccountingSyncBatchesQuery__
 *
 * To run a query within a React component, call `usePartnerListAccountingSyncBatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListAccountingSyncBatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListAccountingSyncBatchesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePartnerListAccountingSyncBatchesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListAccountingSyncBatchesQuery,
    PartnerListAccountingSyncBatchesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListAccountingSyncBatchesQuery,
    PartnerListAccountingSyncBatchesQueryVariables
  >(PartnerListAccountingSyncBatchesDocument, options)
}
export function usePartnerListAccountingSyncBatchesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListAccountingSyncBatchesQuery,
    PartnerListAccountingSyncBatchesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListAccountingSyncBatchesQuery,
    PartnerListAccountingSyncBatchesQueryVariables
  >(PartnerListAccountingSyncBatchesDocument, options)
}
export type PartnerListAccountingSyncBatchesQueryHookResult = ReturnType<
  typeof usePartnerListAccountingSyncBatchesQuery
>
export type PartnerListAccountingSyncBatchesLazyQueryHookResult = ReturnType<
  typeof usePartnerListAccountingSyncBatchesLazyQuery
>
export type PartnerListAccountingSyncBatchesQueryResult = Apollo.QueryResult<
  PartnerListAccountingSyncBatchesQuery,
  PartnerListAccountingSyncBatchesQueryVariables
>
export const PartnerListAccountingSyncJobsDocument = /*#__PURE__*/ gql`
  query PartnerListAccountingSyncJobs($batchID: ID!, $parentID: ID!) {
    PartnerListAccountingSyncJobs(batchID: $batchID, parentID: $parentID) {
      jobs {
        status
        type
        invoiceData {
          invoiceNumber
          invoiceDate
          dueDate
          amount
          customerName
        }
        customerData {
          customerName
        }
        lineItemData {
          lineItemName
        }
        billingTermData {
          billingTermName
        }
        paymentData {
          amount
        }
      }
    }
  }
`

/**
 * __usePartnerListAccountingSyncJobsQuery__
 *
 * To run a query within a React component, call `usePartnerListAccountingSyncJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListAccountingSyncJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListAccountingSyncJobsQuery({
 *   variables: {
 *      batchID: // value for 'batchID'
 *      parentID: // value for 'parentID'
 *   },
 * });
 */
export function usePartnerListAccountingSyncJobsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerListAccountingSyncJobsQuery,
    PartnerListAccountingSyncJobsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListAccountingSyncJobsQuery,
    PartnerListAccountingSyncJobsQueryVariables
  >(PartnerListAccountingSyncJobsDocument, options)
}
export function usePartnerListAccountingSyncJobsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListAccountingSyncJobsQuery,
    PartnerListAccountingSyncJobsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListAccountingSyncJobsQuery,
    PartnerListAccountingSyncJobsQueryVariables
  >(PartnerListAccountingSyncJobsDocument, options)
}
export type PartnerListAccountingSyncJobsQueryHookResult = ReturnType<
  typeof usePartnerListAccountingSyncJobsQuery
>
export type PartnerListAccountingSyncJobsLazyQueryHookResult = ReturnType<
  typeof usePartnerListAccountingSyncJobsLazyQuery
>
export type PartnerListAccountingSyncJobsQueryResult = Apollo.QueryResult<
  PartnerListAccountingSyncJobsQuery,
  PartnerListAccountingSyncJobsQueryVariables
>
export const PartnerSecondaryIntegrationDeleteDocument = /*#__PURE__*/ gql`
  mutation PartnerSecondaryIntegrationDelete(
    $input: SecondaryIntegrationDeleteInput!
  ) {
    PartnerSecondaryIntegrationDelete(input: $input)
  }
`
export type PartnerSecondaryIntegrationDeleteMutationFn =
  Apollo.MutationFunction<
    PartnerSecondaryIntegrationDeleteMutation,
    PartnerSecondaryIntegrationDeleteMutationVariables
  >

/**
 * __usePartnerSecondaryIntegrationDeleteMutation__
 *
 * To run a mutation, you first call `usePartnerSecondaryIntegrationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerSecondaryIntegrationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerSecondaryIntegrationDeleteMutation, { data, loading, error }] = usePartnerSecondaryIntegrationDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerSecondaryIntegrationDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerSecondaryIntegrationDeleteMutation,
    PartnerSecondaryIntegrationDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerSecondaryIntegrationDeleteMutation,
    PartnerSecondaryIntegrationDeleteMutationVariables
  >(PartnerSecondaryIntegrationDeleteDocument, options)
}
export type PartnerSecondaryIntegrationDeleteMutationHookResult = ReturnType<
  typeof usePartnerSecondaryIntegrationDeleteMutation
>
export type PartnerSecondaryIntegrationDeleteMutationResult =
  Apollo.MutationResult<PartnerSecondaryIntegrationDeleteMutation>
export type PartnerSecondaryIntegrationDeleteMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerSecondaryIntegrationDeleteMutation,
    PartnerSecondaryIntegrationDeleteMutationVariables
  >
export const PartnerGetAccountingPreferencesDocument = /*#__PURE__*/ gql`
  query PartnerGetAccountingPreferences {
    PartnerGetAccountingPreferences {
      pdfFromPrimary
      pushPaymentsTo
      contactsFromPrimary
      archiveZeroedInvoices
      useIntegrationPDF
    }
  }
`

/**
 * __usePartnerGetAccountingPreferencesQuery__
 *
 * To run a query within a React component, call `usePartnerGetAccountingPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetAccountingPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetAccountingPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerGetAccountingPreferencesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetAccountingPreferencesQuery,
    PartnerGetAccountingPreferencesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetAccountingPreferencesQuery,
    PartnerGetAccountingPreferencesQueryVariables
  >(PartnerGetAccountingPreferencesDocument, options)
}
export function usePartnerGetAccountingPreferencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetAccountingPreferencesQuery,
    PartnerGetAccountingPreferencesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetAccountingPreferencesQuery,
    PartnerGetAccountingPreferencesQueryVariables
  >(PartnerGetAccountingPreferencesDocument, options)
}
export type PartnerGetAccountingPreferencesQueryHookResult = ReturnType<
  typeof usePartnerGetAccountingPreferencesQuery
>
export type PartnerGetAccountingPreferencesLazyQueryHookResult = ReturnType<
  typeof usePartnerGetAccountingPreferencesLazyQuery
>
export type PartnerGetAccountingPreferencesQueryResult = Apollo.QueryResult<
  PartnerGetAccountingPreferencesQuery,
  PartnerGetAccountingPreferencesQueryVariables
>
export const PartnerAccountingPreferencesUpdateDocument = /*#__PURE__*/ gql`
  mutation PartnerAccountingPreferencesUpdate(
    $input: AccountingPreferencesUpdateInput
  ) {
    PartnerAccountingPreferencesUpdate(input: $input) {
      pdfFromPrimary
      pushPaymentsTo
      contactsFromPrimary
    }
  }
`
export type PartnerAccountingPreferencesUpdateMutationFn =
  Apollo.MutationFunction<
    PartnerAccountingPreferencesUpdateMutation,
    PartnerAccountingPreferencesUpdateMutationVariables
  >

/**
 * __usePartnerAccountingPreferencesUpdateMutation__
 *
 * To run a mutation, you first call `usePartnerAccountingPreferencesUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAccountingPreferencesUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAccountingPreferencesUpdateMutation, { data, loading, error }] = usePartnerAccountingPreferencesUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerAccountingPreferencesUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAccountingPreferencesUpdateMutation,
    PartnerAccountingPreferencesUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAccountingPreferencesUpdateMutation,
    PartnerAccountingPreferencesUpdateMutationVariables
  >(PartnerAccountingPreferencesUpdateDocument, options)
}
export type PartnerAccountingPreferencesUpdateMutationHookResult = ReturnType<
  typeof usePartnerAccountingPreferencesUpdateMutation
>
export type PartnerAccountingPreferencesUpdateMutationResult =
  Apollo.MutationResult<PartnerAccountingPreferencesUpdateMutation>
export type PartnerAccountingPreferencesUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAccountingPreferencesUpdateMutation,
    PartnerAccountingPreferencesUpdateMutationVariables
  >
export const PartnerQuickbooksConnectionUrlDocument = /*#__PURE__*/ gql`
  query PartnerQuickbooksConnectionURL($redirectURI: String!) {
    PartnerQuickbooksConnectionURL(redirectURI: $redirectURI)
  }
`

/**
 * __usePartnerQuickbooksConnectionUrlQuery__
 *
 * To run a query within a React component, call `usePartnerQuickbooksConnectionUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerQuickbooksConnectionUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerQuickbooksConnectionUrlQuery({
 *   variables: {
 *      redirectURI: // value for 'redirectURI'
 *   },
 * });
 */
export function usePartnerQuickbooksConnectionUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerQuickbooksConnectionUrlQuery,
    PartnerQuickbooksConnectionUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerQuickbooksConnectionUrlQuery,
    PartnerQuickbooksConnectionUrlQueryVariables
  >(PartnerQuickbooksConnectionUrlDocument, options)
}
export function usePartnerQuickbooksConnectionUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerQuickbooksConnectionUrlQuery,
    PartnerQuickbooksConnectionUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerQuickbooksConnectionUrlQuery,
    PartnerQuickbooksConnectionUrlQueryVariables
  >(PartnerQuickbooksConnectionUrlDocument, options)
}
export type PartnerQuickbooksConnectionUrlQueryHookResult = ReturnType<
  typeof usePartnerQuickbooksConnectionUrlQuery
>
export type PartnerQuickbooksConnectionUrlLazyQueryHookResult = ReturnType<
  typeof usePartnerQuickbooksConnectionUrlLazyQuery
>
export type PartnerQuickbooksConnectionUrlQueryResult = Apollo.QueryResult<
  PartnerQuickbooksConnectionUrlQuery,
  PartnerQuickbooksConnectionUrlQueryVariables
>
export const PartnerQuickbooksAccountListDocument = /*#__PURE__*/ gql`
  query PartnerQuickbooksAccountList {
    PartnerQuickbooksAccountList {
      ...QuickbooksAccount
    }
  }
  ${QuickbooksAccountFragmentDoc}
`

/**
 * __usePartnerQuickbooksAccountListQuery__
 *
 * To run a query within a React component, call `usePartnerQuickbooksAccountListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerQuickbooksAccountListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerQuickbooksAccountListQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerQuickbooksAccountListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerQuickbooksAccountListQuery,
    PartnerQuickbooksAccountListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerQuickbooksAccountListQuery,
    PartnerQuickbooksAccountListQueryVariables
  >(PartnerQuickbooksAccountListDocument, options)
}
export function usePartnerQuickbooksAccountListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerQuickbooksAccountListQuery,
    PartnerQuickbooksAccountListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerQuickbooksAccountListQuery,
    PartnerQuickbooksAccountListQueryVariables
  >(PartnerQuickbooksAccountListDocument, options)
}
export type PartnerQuickbooksAccountListQueryHookResult = ReturnType<
  typeof usePartnerQuickbooksAccountListQuery
>
export type PartnerQuickbooksAccountListLazyQueryHookResult = ReturnType<
  typeof usePartnerQuickbooksAccountListLazyQuery
>
export type PartnerQuickbooksAccountListQueryResult = Apollo.QueryResult<
  PartnerQuickbooksAccountListQuery,
  PartnerQuickbooksAccountListQueryVariables
>
export const PartnerQuickbooksAccountRetrieveDocument = /*#__PURE__*/ gql`
  query PartnerQuickbooksAccountRetrieve {
    PartnerQuickbooksAccountRetrieve {
      ...QuickbooksAccount
    }
  }
  ${QuickbooksAccountFragmentDoc}
`

/**
 * __usePartnerQuickbooksAccountRetrieveQuery__
 *
 * To run a query within a React component, call `usePartnerQuickbooksAccountRetrieveQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerQuickbooksAccountRetrieveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerQuickbooksAccountRetrieveQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerQuickbooksAccountRetrieveQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerQuickbooksAccountRetrieveQuery,
    PartnerQuickbooksAccountRetrieveQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerQuickbooksAccountRetrieveQuery,
    PartnerQuickbooksAccountRetrieveQueryVariables
  >(PartnerQuickbooksAccountRetrieveDocument, options)
}
export function usePartnerQuickbooksAccountRetrieveLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerQuickbooksAccountRetrieveQuery,
    PartnerQuickbooksAccountRetrieveQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerQuickbooksAccountRetrieveQuery,
    PartnerQuickbooksAccountRetrieveQueryVariables
  >(PartnerQuickbooksAccountRetrieveDocument, options)
}
export type PartnerQuickbooksAccountRetrieveQueryHookResult = ReturnType<
  typeof usePartnerQuickbooksAccountRetrieveQuery
>
export type PartnerQuickbooksAccountRetrieveLazyQueryHookResult = ReturnType<
  typeof usePartnerQuickbooksAccountRetrieveLazyQuery
>
export type PartnerQuickbooksAccountRetrieveQueryResult = Apollo.QueryResult<
  PartnerQuickbooksAccountRetrieveQuery,
  PartnerQuickbooksAccountRetrieveQueryVariables
>
export const PartnerQuickbooksAccountUpdateDocument = /*#__PURE__*/ gql`
  mutation PartnerQuickbooksAccountUpdate(
    $input: QuickbooksAccountUpdateInput
  ) {
    PartnerQuickbooksAccountUpdate(input: $input)
  }
`
export type PartnerQuickbooksAccountUpdateMutationFn = Apollo.MutationFunction<
  PartnerQuickbooksAccountUpdateMutation,
  PartnerQuickbooksAccountUpdateMutationVariables
>

/**
 * __usePartnerQuickbooksAccountUpdateMutation__
 *
 * To run a mutation, you first call `usePartnerQuickbooksAccountUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerQuickbooksAccountUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerQuickbooksAccountUpdateMutation, { data, loading, error }] = usePartnerQuickbooksAccountUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerQuickbooksAccountUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerQuickbooksAccountUpdateMutation,
    PartnerQuickbooksAccountUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerQuickbooksAccountUpdateMutation,
    PartnerQuickbooksAccountUpdateMutationVariables
  >(PartnerQuickbooksAccountUpdateDocument, options)
}
export type PartnerQuickbooksAccountUpdateMutationHookResult = ReturnType<
  typeof usePartnerQuickbooksAccountUpdateMutation
>
export type PartnerQuickbooksAccountUpdateMutationResult =
  Apollo.MutationResult<PartnerQuickbooksAccountUpdateMutation>
export type PartnerQuickbooksAccountUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerQuickbooksAccountUpdateMutation,
    PartnerQuickbooksAccountUpdateMutationVariables
  >
export const PartnerQuickbooksConnectionCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerQuickbooksConnectionCreate(
    $code: String!
    $state: String!
    $realmId: String!
    $integrationType: IntegrationType!
  ) {
    PartnerQuickbooksConnectionCreate(
      code: $code
      state: $state
      realmId: $realmId
      integrationType: $integrationType
    )
  }
`
export type PartnerQuickbooksConnectionCreateMutationFn =
  Apollo.MutationFunction<
    PartnerQuickbooksConnectionCreateMutation,
    PartnerQuickbooksConnectionCreateMutationVariables
  >

/**
 * __usePartnerQuickbooksConnectionCreateMutation__
 *
 * To run a mutation, you first call `usePartnerQuickbooksConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerQuickbooksConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerQuickbooksConnectionCreateMutation, { data, loading, error }] = usePartnerQuickbooksConnectionCreateMutation({
 *   variables: {
 *      code: // value for 'code'
 *      state: // value for 'state'
 *      realmId: // value for 'realmId'
 *      integrationType: // value for 'integrationType'
 *   },
 * });
 */
export function usePartnerQuickbooksConnectionCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerQuickbooksConnectionCreateMutation,
    PartnerQuickbooksConnectionCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerQuickbooksConnectionCreateMutation,
    PartnerQuickbooksConnectionCreateMutationVariables
  >(PartnerQuickbooksConnectionCreateDocument, options)
}
export type PartnerQuickbooksConnectionCreateMutationHookResult = ReturnType<
  typeof usePartnerQuickbooksConnectionCreateMutation
>
export type PartnerQuickbooksConnectionCreateMutationResult =
  Apollo.MutationResult<PartnerQuickbooksConnectionCreateMutation>
export type PartnerQuickbooksConnectionCreateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerQuickbooksConnectionCreateMutation,
    PartnerQuickbooksConnectionCreateMutationVariables
  >
export const PartnerQuickbooksConnectionUpdateDocument = /*#__PURE__*/ gql`
  mutation PartnerQuickbooksConnectionUpdate($createDeposits: Boolean) {
    PartnerQuickbooksConnectionUpdate(createDeposits: $createDeposits)
  }
`
export type PartnerQuickbooksConnectionUpdateMutationFn =
  Apollo.MutationFunction<
    PartnerQuickbooksConnectionUpdateMutation,
    PartnerQuickbooksConnectionUpdateMutationVariables
  >

/**
 * __usePartnerQuickbooksConnectionUpdateMutation__
 *
 * To run a mutation, you first call `usePartnerQuickbooksConnectionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerQuickbooksConnectionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerQuickbooksConnectionUpdateMutation, { data, loading, error }] = usePartnerQuickbooksConnectionUpdateMutation({
 *   variables: {
 *      createDeposits: // value for 'createDeposits'
 *   },
 * });
 */
export function usePartnerQuickbooksConnectionUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerQuickbooksConnectionUpdateMutation,
    PartnerQuickbooksConnectionUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerQuickbooksConnectionUpdateMutation,
    PartnerQuickbooksConnectionUpdateMutationVariables
  >(PartnerQuickbooksConnectionUpdateDocument, options)
}
export type PartnerQuickbooksConnectionUpdateMutationHookResult = ReturnType<
  typeof usePartnerQuickbooksConnectionUpdateMutation
>
export type PartnerQuickbooksConnectionUpdateMutationResult =
  Apollo.MutationResult<PartnerQuickbooksConnectionUpdateMutation>
export type PartnerQuickbooksConnectionUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerQuickbooksConnectionUpdateMutation,
    PartnerQuickbooksConnectionUpdateMutationVariables
  >
export const PartnerQuickbooksConnectionReadDocument = /*#__PURE__*/ gql`
  query PartnerQuickbooksConnectionRead {
    PartnerQuickbooksConnectionRead {
      createDeposits
    }
  }
`

/**
 * __usePartnerQuickbooksConnectionReadQuery__
 *
 * To run a query within a React component, call `usePartnerQuickbooksConnectionReadQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerQuickbooksConnectionReadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerQuickbooksConnectionReadQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerQuickbooksConnectionReadQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerQuickbooksConnectionReadQuery,
    PartnerQuickbooksConnectionReadQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerQuickbooksConnectionReadQuery,
    PartnerQuickbooksConnectionReadQueryVariables
  >(PartnerQuickbooksConnectionReadDocument, options)
}
export function usePartnerQuickbooksConnectionReadLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerQuickbooksConnectionReadQuery,
    PartnerQuickbooksConnectionReadQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerQuickbooksConnectionReadQuery,
    PartnerQuickbooksConnectionReadQueryVariables
  >(PartnerQuickbooksConnectionReadDocument, options)
}
export type PartnerQuickbooksConnectionReadQueryHookResult = ReturnType<
  typeof usePartnerQuickbooksConnectionReadQuery
>
export type PartnerQuickbooksConnectionReadLazyQueryHookResult = ReturnType<
  typeof usePartnerQuickbooksConnectionReadLazyQuery
>
export type PartnerQuickbooksConnectionReadQueryResult = Apollo.QueryResult<
  PartnerQuickbooksConnectionReadQuery,
  PartnerQuickbooksConnectionReadQueryVariables
>
export const PartnerRecurringTransactionConnectionDocument = /*#__PURE__*/ gql`
  query PartnerRecurringTransactionConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $orderBy: RecurringTransactionOrderBy
    $filter: RecurringTransactionFilter
  ) {
    PartnerRecurringTransactionConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      orderBy: $orderBy
      filter: $filter
    ) {
      edges {
        node {
          externalID
          name
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`

/**
 * __usePartnerRecurringTransactionConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerRecurringTransactionConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerRecurringTransactionConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerRecurringTransactionConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePartnerRecurringTransactionConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerRecurringTransactionConnectionQuery,
    PartnerRecurringTransactionConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerRecurringTransactionConnectionQuery,
    PartnerRecurringTransactionConnectionQueryVariables
  >(PartnerRecurringTransactionConnectionDocument, options)
}
export function usePartnerRecurringTransactionConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerRecurringTransactionConnectionQuery,
    PartnerRecurringTransactionConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerRecurringTransactionConnectionQuery,
    PartnerRecurringTransactionConnectionQueryVariables
  >(PartnerRecurringTransactionConnectionDocument, options)
}
export type PartnerRecurringTransactionConnectionQueryHookResult = ReturnType<
  typeof usePartnerRecurringTransactionConnectionQuery
>
export type PartnerRecurringTransactionConnectionLazyQueryHookResult =
  ReturnType<typeof usePartnerRecurringTransactionConnectionLazyQuery>
export type PartnerRecurringTransactionConnectionQueryResult =
  Apollo.QueryResult<
    PartnerRecurringTransactionConnectionQuery,
    PartnerRecurringTransactionConnectionQueryVariables
  >
export const PartnerRutterConnectionCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerRutterConnectionCreate($input: ConnectionCreateInput) {
    PartnerRutterConnectionCreate(input: $input) {
      platform
      status
    }
  }
`
export type PartnerRutterConnectionCreateMutationFn = Apollo.MutationFunction<
  PartnerRutterConnectionCreateMutation,
  PartnerRutterConnectionCreateMutationVariables
>

/**
 * __usePartnerRutterConnectionCreateMutation__
 *
 * To run a mutation, you first call `usePartnerRutterConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerRutterConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerRutterConnectionCreateMutation, { data, loading, error }] = usePartnerRutterConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerRutterConnectionCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerRutterConnectionCreateMutation,
    PartnerRutterConnectionCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerRutterConnectionCreateMutation,
    PartnerRutterConnectionCreateMutationVariables
  >(PartnerRutterConnectionCreateDocument, options)
}
export type PartnerRutterConnectionCreateMutationHookResult = ReturnType<
  typeof usePartnerRutterConnectionCreateMutation
>
export type PartnerRutterConnectionCreateMutationResult =
  Apollo.MutationResult<PartnerRutterConnectionCreateMutation>
export type PartnerRutterConnectionCreateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerRutterConnectionCreateMutation,
    PartnerRutterConnectionCreateMutationVariables
  >
export const PartnerRutterAccountListDocument = /*#__PURE__*/ gql`
  query PartnerRutterAccountList($input: RutterAccountListInput) {
    PartnerRutterAccountList(input: $input) {
      ...RutterAccountList
    }
  }
  ${RutterAccountListFragmentDoc}
`

/**
 * __usePartnerRutterAccountListQuery__
 *
 * To run a query within a React component, call `usePartnerRutterAccountListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerRutterAccountListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerRutterAccountListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerRutterAccountListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerRutterAccountListQuery,
    PartnerRutterAccountListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerRutterAccountListQuery,
    PartnerRutterAccountListQueryVariables
  >(PartnerRutterAccountListDocument, options)
}
export function usePartnerRutterAccountListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerRutterAccountListQuery,
    PartnerRutterAccountListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerRutterAccountListQuery,
    PartnerRutterAccountListQueryVariables
  >(PartnerRutterAccountListDocument, options)
}
export type PartnerRutterAccountListQueryHookResult = ReturnType<
  typeof usePartnerRutterAccountListQuery
>
export type PartnerRutterAccountListLazyQueryHookResult = ReturnType<
  typeof usePartnerRutterAccountListLazyQuery
>
export type PartnerRutterAccountListQueryResult = Apollo.QueryResult<
  PartnerRutterAccountListQuery,
  PartnerRutterAccountListQueryVariables
>
export const PartnerRutterAccountUpsertDocument = /*#__PURE__*/ gql`
  mutation PartnerRutterAccountUpsert($input: RutterAccountUpsertInput) {
    PartnerRutterAccountUpsert(input: $input)
  }
`
export type PartnerRutterAccountUpsertMutationFn = Apollo.MutationFunction<
  PartnerRutterAccountUpsertMutation,
  PartnerRutterAccountUpsertMutationVariables
>

/**
 * __usePartnerRutterAccountUpsertMutation__
 *
 * To run a mutation, you first call `usePartnerRutterAccountUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerRutterAccountUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerRutterAccountUpsertMutation, { data, loading, error }] = usePartnerRutterAccountUpsertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerRutterAccountUpsertMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerRutterAccountUpsertMutation,
    PartnerRutterAccountUpsertMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerRutterAccountUpsertMutation,
    PartnerRutterAccountUpsertMutationVariables
  >(PartnerRutterAccountUpsertDocument, options)
}
export type PartnerRutterAccountUpsertMutationHookResult = ReturnType<
  typeof usePartnerRutterAccountUpsertMutation
>
export type PartnerRutterAccountUpsertMutationResult =
  Apollo.MutationResult<PartnerRutterAccountUpsertMutation>
export type PartnerRutterAccountUpsertMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerRutterAccountUpsertMutation,
    PartnerRutterAccountUpsertMutationVariables
  >
export const PartnerRutterAccountReadDocument = /*#__PURE__*/ gql`
  query PartnerRutterAccountRead($platform: RutterPlatform) {
    PartnerRutterAccountRead(platform: $platform) {
      AccountForDeposits {
        id
      }
      AccountForPayments {
        id
      }
      AccountForFunds {
        id
      }
      AccountForFees {
        id
      }
    }
  }
`

/**
 * __usePartnerRutterAccountReadQuery__
 *
 * To run a query within a React component, call `usePartnerRutterAccountReadQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerRutterAccountReadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerRutterAccountReadQuery({
 *   variables: {
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function usePartnerRutterAccountReadQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerRutterAccountReadQuery,
    PartnerRutterAccountReadQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerRutterAccountReadQuery,
    PartnerRutterAccountReadQueryVariables
  >(PartnerRutterAccountReadDocument, options)
}
export function usePartnerRutterAccountReadLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerRutterAccountReadQuery,
    PartnerRutterAccountReadQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerRutterAccountReadQuery,
    PartnerRutterAccountReadQueryVariables
  >(PartnerRutterAccountReadDocument, options)
}
export type PartnerRutterAccountReadQueryHookResult = ReturnType<
  typeof usePartnerRutterAccountReadQuery
>
export type PartnerRutterAccountReadLazyQueryHookResult = ReturnType<
  typeof usePartnerRutterAccountReadLazyQuery
>
export type PartnerRutterAccountReadQueryResult = Apollo.QueryResult<
  PartnerRutterAccountReadQuery,
  PartnerRutterAccountReadQueryVariables
>
export const PartnerRutterConnectionReadDocument = /*#__PURE__*/ gql`
  query PartnerRutterConnectionRead($platform: RutterPlatform) {
    PartnerRutterConnectionRead(platform: $platform) {
      rutterConnectionID
    }
  }
`

/**
 * __usePartnerRutterConnectionReadQuery__
 *
 * To run a query within a React component, call `usePartnerRutterConnectionReadQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerRutterConnectionReadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerRutterConnectionReadQuery({
 *   variables: {
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function usePartnerRutterConnectionReadQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerRutterConnectionReadQuery,
    PartnerRutterConnectionReadQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerRutterConnectionReadQuery,
    PartnerRutterConnectionReadQueryVariables
  >(PartnerRutterConnectionReadDocument, options)
}
export function usePartnerRutterConnectionReadLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerRutterConnectionReadQuery,
    PartnerRutterConnectionReadQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerRutterConnectionReadQuery,
    PartnerRutterConnectionReadQueryVariables
  >(PartnerRutterConnectionReadDocument, options)
}
export type PartnerRutterConnectionReadQueryHookResult = ReturnType<
  typeof usePartnerRutterConnectionReadQuery
>
export type PartnerRutterConnectionReadLazyQueryHookResult = ReturnType<
  typeof usePartnerRutterConnectionReadLazyQuery
>
export type PartnerRutterConnectionReadQueryResult = Apollo.QueryResult<
  PartnerRutterConnectionReadQuery,
  PartnerRutterConnectionReadQueryVariables
>
export const PartnerRutterConnectionUpdateDocument = /*#__PURE__*/ gql`
  mutation PartnerRutterConnectionUpdate($input: ConnectionUpdateInput) {
    PartnerRutterConnectionUpdate(input: $input) {
      status
    }
  }
`
export type PartnerRutterConnectionUpdateMutationFn = Apollo.MutationFunction<
  PartnerRutterConnectionUpdateMutation,
  PartnerRutterConnectionUpdateMutationVariables
>

/**
 * __usePartnerRutterConnectionUpdateMutation__
 *
 * To run a mutation, you first call `usePartnerRutterConnectionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerRutterConnectionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerRutterConnectionUpdateMutation, { data, loading, error }] = usePartnerRutterConnectionUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerRutterConnectionUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerRutterConnectionUpdateMutation,
    PartnerRutterConnectionUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerRutterConnectionUpdateMutation,
    PartnerRutterConnectionUpdateMutationVariables
  >(PartnerRutterConnectionUpdateDocument, options)
}
export type PartnerRutterConnectionUpdateMutationHookResult = ReturnType<
  typeof usePartnerRutterConnectionUpdateMutation
>
export type PartnerRutterConnectionUpdateMutationResult =
  Apollo.MutationResult<PartnerRutterConnectionUpdateMutation>
export type PartnerRutterConnectionUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerRutterConnectionUpdateMutation,
    PartnerRutterConnectionUpdateMutationVariables
  >
export const PartnerRutterAccountUnsetDocument = /*#__PURE__*/ gql`
  mutation PartnerRutterAccountUnset($input: RutterAccountUnsetInput) {
    PartnerRutterAccountUnset(input: $input)
  }
`
export type PartnerRutterAccountUnsetMutationFn = Apollo.MutationFunction<
  PartnerRutterAccountUnsetMutation,
  PartnerRutterAccountUnsetMutationVariables
>

/**
 * __usePartnerRutterAccountUnsetMutation__
 *
 * To run a mutation, you first call `usePartnerRutterAccountUnsetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerRutterAccountUnsetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerRutterAccountUnsetMutation, { data, loading, error }] = usePartnerRutterAccountUnsetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerRutterAccountUnsetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerRutterAccountUnsetMutation,
    PartnerRutterAccountUnsetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerRutterAccountUnsetMutation,
    PartnerRutterAccountUnsetMutationVariables
  >(PartnerRutterAccountUnsetDocument, options)
}
export type PartnerRutterAccountUnsetMutationHookResult = ReturnType<
  typeof usePartnerRutterAccountUnsetMutation
>
export type PartnerRutterAccountUnsetMutationResult =
  Apollo.MutationResult<PartnerRutterAccountUnsetMutation>
export type PartnerRutterAccountUnsetMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerRutterAccountUnsetMutation,
    PartnerRutterAccountUnsetMutationVariables
  >
export const PartnerRutterAccountUpsertManyDocument = /*#__PURE__*/ gql`
  mutation PartnerRutterAccountUpsertMany(
    $input: RutterAccountUpsertManyInput
  ) {
    PartnerRutterAccountUpsertMany(input: $input)
  }
`
export type PartnerRutterAccountUpsertManyMutationFn = Apollo.MutationFunction<
  PartnerRutterAccountUpsertManyMutation,
  PartnerRutterAccountUpsertManyMutationVariables
>

/**
 * __usePartnerRutterAccountUpsertManyMutation__
 *
 * To run a mutation, you first call `usePartnerRutterAccountUpsertManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerRutterAccountUpsertManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerRutterAccountUpsertManyMutation, { data, loading, error }] = usePartnerRutterAccountUpsertManyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerRutterAccountUpsertManyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerRutterAccountUpsertManyMutation,
    PartnerRutterAccountUpsertManyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerRutterAccountUpsertManyMutation,
    PartnerRutterAccountUpsertManyMutationVariables
  >(PartnerRutterAccountUpsertManyDocument, options)
}
export type PartnerRutterAccountUpsertManyMutationHookResult = ReturnType<
  typeof usePartnerRutterAccountUpsertManyMutation
>
export type PartnerRutterAccountUpsertManyMutationResult =
  Apollo.MutationResult<PartnerRutterAccountUpsertManyMutation>
export type PartnerRutterAccountUpsertManyMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerRutterAccountUpsertManyMutation,
    PartnerRutterAccountUpsertManyMutationVariables
  >
export const PartnerRutterPaymentTermsConnectionDocument = /*#__PURE__*/ gql`
  query PartnerRutterPaymentTermsConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $orderBy: RutterPaymentTermsOrderBy
    $filter: RutterPaymentTermsFilter
  ) {
    PartnerRutterPaymentTermsConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      orderBy: $orderBy
      filter: $filter
    ) {
      edges {
        node {
          externalID
          name
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`

/**
 * __usePartnerRutterPaymentTermsConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerRutterPaymentTermsConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerRutterPaymentTermsConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerRutterPaymentTermsConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePartnerRutterPaymentTermsConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerRutterPaymentTermsConnectionQuery,
    PartnerRutterPaymentTermsConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerRutterPaymentTermsConnectionQuery,
    PartnerRutterPaymentTermsConnectionQueryVariables
  >(PartnerRutterPaymentTermsConnectionDocument, options)
}
export function usePartnerRutterPaymentTermsConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerRutterPaymentTermsConnectionQuery,
    PartnerRutterPaymentTermsConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerRutterPaymentTermsConnectionQuery,
    PartnerRutterPaymentTermsConnectionQueryVariables
  >(PartnerRutterPaymentTermsConnectionDocument, options)
}
export type PartnerRutterPaymentTermsConnectionQueryHookResult = ReturnType<
  typeof usePartnerRutterPaymentTermsConnectionQuery
>
export type PartnerRutterPaymentTermsConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerRutterPaymentTermsConnectionLazyQuery
>
export type PartnerRutterPaymentTermsConnectionQueryResult = Apollo.QueryResult<
  PartnerRutterPaymentTermsConnectionQuery,
  PartnerRutterPaymentTermsConnectionQueryVariables
>
export const PartnerSuperopsConnectionCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerSuperopsConnectionCreate(
    $input: SuperopsConnectionCreateInput
  ) {
    PartnerSuperopsConnectionCreate(input: $input)
  }
`
export type PartnerSuperopsConnectionCreateMutationFn = Apollo.MutationFunction<
  PartnerSuperopsConnectionCreateMutation,
  PartnerSuperopsConnectionCreateMutationVariables
>

/**
 * __usePartnerSuperopsConnectionCreateMutation__
 *
 * To run a mutation, you first call `usePartnerSuperopsConnectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerSuperopsConnectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerSuperopsConnectionCreateMutation, { data, loading, error }] = usePartnerSuperopsConnectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerSuperopsConnectionCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerSuperopsConnectionCreateMutation,
    PartnerSuperopsConnectionCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerSuperopsConnectionCreateMutation,
    PartnerSuperopsConnectionCreateMutationVariables
  >(PartnerSuperopsConnectionCreateDocument, options)
}
export type PartnerSuperopsConnectionCreateMutationHookResult = ReturnType<
  typeof usePartnerSuperopsConnectionCreateMutation
>
export type PartnerSuperopsConnectionCreateMutationResult =
  Apollo.MutationResult<PartnerSuperopsConnectionCreateMutation>
export type PartnerSuperopsConnectionCreateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerSuperopsConnectionCreateMutation,
    PartnerSuperopsConnectionCreateMutationVariables
  >
export const PartnerGetInvoiceLedgerMovementsDocument = /*#__PURE__*/ gql`
  query PartnerGetInvoiceLedgerMovements($invoiceID: String!) {
    PartnerGetInvoiceLedgerMovements(invoiceID: $invoiceID) {
      ledgerBalance
      movements {
        movementType
        movements
        balance
      }
    }
  }
`

/**
 * __usePartnerGetInvoiceLedgerMovementsQuery__
 *
 * To run a query within a React component, call `usePartnerGetInvoiceLedgerMovementsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetInvoiceLedgerMovementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetInvoiceLedgerMovementsQuery({
 *   variables: {
 *      invoiceID: // value for 'invoiceID'
 *   },
 * });
 */
export function usePartnerGetInvoiceLedgerMovementsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetInvoiceLedgerMovementsQuery,
    PartnerGetInvoiceLedgerMovementsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetInvoiceLedgerMovementsQuery,
    PartnerGetInvoiceLedgerMovementsQueryVariables
  >(PartnerGetInvoiceLedgerMovementsDocument, options)
}
export function usePartnerGetInvoiceLedgerMovementsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetInvoiceLedgerMovementsQuery,
    PartnerGetInvoiceLedgerMovementsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetInvoiceLedgerMovementsQuery,
    PartnerGetInvoiceLedgerMovementsQueryVariables
  >(PartnerGetInvoiceLedgerMovementsDocument, options)
}
export type PartnerGetInvoiceLedgerMovementsQueryHookResult = ReturnType<
  typeof usePartnerGetInvoiceLedgerMovementsQuery
>
export type PartnerGetInvoiceLedgerMovementsLazyQueryHookResult = ReturnType<
  typeof usePartnerGetInvoiceLedgerMovementsLazyQuery
>
export type PartnerGetInvoiceLedgerMovementsQueryResult = Apollo.QueryResult<
  PartnerGetInvoiceLedgerMovementsQuery,
  PartnerGetInvoiceLedgerMovementsQueryVariables
>
export const PartnerFindInvoiceDocument = /*#__PURE__*/ gql`
  query PartnerFindInvoice($id: String!) {
    FindInvoice(id: $id) {
      ...PartnerInvoice
    }
  }
  ${PartnerInvoiceFragmentDoc}
`

/**
 * __usePartnerFindInvoiceQuery__
 *
 * To run a query within a React component, call `usePartnerFindInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerFindInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerFindInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerFindInvoiceQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerFindInvoiceQuery,
    PartnerFindInvoiceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerFindInvoiceQuery,
    PartnerFindInvoiceQueryVariables
  >(PartnerFindInvoiceDocument, options)
}
export function usePartnerFindInvoiceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerFindInvoiceQuery,
    PartnerFindInvoiceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerFindInvoiceQuery,
    PartnerFindInvoiceQueryVariables
  >(PartnerFindInvoiceDocument, options)
}
export type PartnerFindInvoiceQueryHookResult = ReturnType<
  typeof usePartnerFindInvoiceQuery
>
export type PartnerFindInvoiceLazyQueryHookResult = ReturnType<
  typeof usePartnerFindInvoiceLazyQuery
>
export type PartnerFindInvoiceQueryResult = Apollo.QueryResult<
  PartnerFindInvoiceQuery,
  PartnerFindInvoiceQueryVariables
>
export const PartnerGetInvoicePdfLinkDocument = /*#__PURE__*/ gql`
  query PartnerGetInvoicePdfLink($invoiceID: String!) {
    PartnerGetInvoicePdfLink(invoiceID: $invoiceID) {
      url
      expiresAt
      status
    }
  }
`

/**
 * __usePartnerGetInvoicePdfLinkQuery__
 *
 * To run a query within a React component, call `usePartnerGetInvoicePdfLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetInvoicePdfLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetInvoicePdfLinkQuery({
 *   variables: {
 *      invoiceID: // value for 'invoiceID'
 *   },
 * });
 */
export function usePartnerGetInvoicePdfLinkQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetInvoicePdfLinkQuery,
    PartnerGetInvoicePdfLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetInvoicePdfLinkQuery,
    PartnerGetInvoicePdfLinkQueryVariables
  >(PartnerGetInvoicePdfLinkDocument, options)
}
export function usePartnerGetInvoicePdfLinkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetInvoicePdfLinkQuery,
    PartnerGetInvoicePdfLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetInvoicePdfLinkQuery,
    PartnerGetInvoicePdfLinkQueryVariables
  >(PartnerGetInvoicePdfLinkDocument, options)
}
export type PartnerGetInvoicePdfLinkQueryHookResult = ReturnType<
  typeof usePartnerGetInvoicePdfLinkQuery
>
export type PartnerGetInvoicePdfLinkLazyQueryHookResult = ReturnType<
  typeof usePartnerGetInvoicePdfLinkLazyQuery
>
export type PartnerGetInvoicePdfLinkQueryResult = Apollo.QueryResult<
  PartnerGetInvoicePdfLinkQuery,
  PartnerGetInvoicePdfLinkQueryVariables
>
export const PartnerInvoiceListTotalsDocument = /*#__PURE__*/ gql`
  query PartnerInvoiceListTotals($filters: InvoiceFilter) {
    PartnerInvoiceListTotals(filters: $filters) {
      count
      amount
      outstandingAmount
    }
  }
`

/**
 * __usePartnerInvoiceListTotalsQuery__
 *
 * To run a query within a React component, call `usePartnerInvoiceListTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerInvoiceListTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerInvoiceListTotalsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePartnerInvoiceListTotalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerInvoiceListTotalsQuery,
    PartnerInvoiceListTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerInvoiceListTotalsQuery,
    PartnerInvoiceListTotalsQueryVariables
  >(PartnerInvoiceListTotalsDocument, options)
}
export function usePartnerInvoiceListTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerInvoiceListTotalsQuery,
    PartnerInvoiceListTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerInvoiceListTotalsQuery,
    PartnerInvoiceListTotalsQueryVariables
  >(PartnerInvoiceListTotalsDocument, options)
}
export type PartnerInvoiceListTotalsQueryHookResult = ReturnType<
  typeof usePartnerInvoiceListTotalsQuery
>
export type PartnerInvoiceListTotalsLazyQueryHookResult = ReturnType<
  typeof usePartnerInvoiceListTotalsLazyQuery
>
export type PartnerInvoiceListTotalsQueryResult = Apollo.QueryResult<
  PartnerInvoiceListTotalsQuery,
  PartnerInvoiceListTotalsQueryVariables
>
export const PartnerInvoiceSearchDocument = /*#__PURE__*/ gql`
  query PartnerInvoiceSearch($invoiceNumber: String) {
    PartnerInvoiceConnection(
      first: 5
      filters: { invoiceNumber: $invoiceNumber }
    ) {
      edges {
        cursor
        node {
          ...PartnerInvoiceSearch
        }
      }
    }
  }
  ${PartnerInvoiceSearchFragmentDoc}
`

/**
 * __usePartnerInvoiceSearchQuery__
 *
 * To run a query within a React component, call `usePartnerInvoiceSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerInvoiceSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerInvoiceSearchQuery({
 *   variables: {
 *      invoiceNumber: // value for 'invoiceNumber'
 *   },
 * });
 */
export function usePartnerInvoiceSearchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerInvoiceSearchQuery,
    PartnerInvoiceSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerInvoiceSearchQuery,
    PartnerInvoiceSearchQueryVariables
  >(PartnerInvoiceSearchDocument, options)
}
export function usePartnerInvoiceSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerInvoiceSearchQuery,
    PartnerInvoiceSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerInvoiceSearchQuery,
    PartnerInvoiceSearchQueryVariables
  >(PartnerInvoiceSearchDocument, options)
}
export type PartnerInvoiceSearchQueryHookResult = ReturnType<
  typeof usePartnerInvoiceSearchQuery
>
export type PartnerInvoiceSearchLazyQueryHookResult = ReturnType<
  typeof usePartnerInvoiceSearchLazyQuery
>
export type PartnerInvoiceSearchQueryResult = Apollo.QueryResult<
  PartnerInvoiceSearchQuery,
  PartnerInvoiceSearchQueryVariables
>
export const PartnerInvoiceConnectionDocument = /*#__PURE__*/ gql`
  query PartnerInvoiceConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: InvoiceFilter
    $orderBy: InvoiceOrderBy
  ) {
    PartnerInvoiceConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        cursor
        node {
          ...PartnerInvoiceListing
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerInvoiceListingFragmentDoc}
`

/**
 * __usePartnerInvoiceConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerInvoiceConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerInvoiceConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerInvoiceConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerInvoiceConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerInvoiceConnectionQuery,
    PartnerInvoiceConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerInvoiceConnectionQuery,
    PartnerInvoiceConnectionQueryVariables
  >(PartnerInvoiceConnectionDocument, options)
}
export function usePartnerInvoiceConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerInvoiceConnectionQuery,
    PartnerInvoiceConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerInvoiceConnectionQuery,
    PartnerInvoiceConnectionQueryVariables
  >(PartnerInvoiceConnectionDocument, options)
}
export type PartnerInvoiceConnectionQueryHookResult = ReturnType<
  typeof usePartnerInvoiceConnectionQuery
>
export type PartnerInvoiceConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerInvoiceConnectionLazyQuery
>
export type PartnerInvoiceConnectionQueryResult = Apollo.QueryResult<
  PartnerInvoiceConnectionQuery,
  PartnerInvoiceConnectionQueryVariables
>
export const PartnerGetInvoicePreferencesDocument = /*#__PURE__*/ gql`
  query PartnerGetInvoicePreferences {
    PartnerGetInvoicePreferences {
      invoiceNumberField
    }
  }
`

/**
 * __usePartnerGetInvoicePreferencesQuery__
 *
 * To run a query within a React component, call `usePartnerGetInvoicePreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetInvoicePreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetInvoicePreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerGetInvoicePreferencesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetInvoicePreferencesQuery,
    PartnerGetInvoicePreferencesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetInvoicePreferencesQuery,
    PartnerGetInvoicePreferencesQueryVariables
  >(PartnerGetInvoicePreferencesDocument, options)
}
export function usePartnerGetInvoicePreferencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetInvoicePreferencesQuery,
    PartnerGetInvoicePreferencesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetInvoicePreferencesQuery,
    PartnerGetInvoicePreferencesQueryVariables
  >(PartnerGetInvoicePreferencesDocument, options)
}
export type PartnerGetInvoicePreferencesQueryHookResult = ReturnType<
  typeof usePartnerGetInvoicePreferencesQuery
>
export type PartnerGetInvoicePreferencesLazyQueryHookResult = ReturnType<
  typeof usePartnerGetInvoicePreferencesLazyQuery
>
export type PartnerGetInvoicePreferencesQueryResult = Apollo.QueryResult<
  PartnerGetInvoicePreferencesQuery,
  PartnerGetInvoicePreferencesQueryVariables
>
export const PartnerInvoiceArchiveDocument = /*#__PURE__*/ gql`
  mutation PartnerInvoiceArchive($archiveInvoiceId: ID!) {
    PartnerInvoiceArchive(id: $archiveInvoiceId) {
      ...PartnerInvoiceListing
    }
  }
  ${PartnerInvoiceListingFragmentDoc}
`
export type PartnerInvoiceArchiveMutationFn = Apollo.MutationFunction<
  PartnerInvoiceArchiveMutation,
  PartnerInvoiceArchiveMutationVariables
>

/**
 * __usePartnerInvoiceArchiveMutation__
 *
 * To run a mutation, you first call `usePartnerInvoiceArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerInvoiceArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerInvoiceArchiveMutation, { data, loading, error }] = usePartnerInvoiceArchiveMutation({
 *   variables: {
 *      archiveInvoiceId: // value for 'archiveInvoiceId'
 *   },
 * });
 */
export function usePartnerInvoiceArchiveMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerInvoiceArchiveMutation,
    PartnerInvoiceArchiveMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerInvoiceArchiveMutation,
    PartnerInvoiceArchiveMutationVariables
  >(PartnerInvoiceArchiveDocument, options)
}
export type PartnerInvoiceArchiveMutationHookResult = ReturnType<
  typeof usePartnerInvoiceArchiveMutation
>
export type PartnerInvoiceArchiveMutationResult =
  Apollo.MutationResult<PartnerInvoiceArchiveMutation>
export type PartnerInvoiceArchiveMutationOptions = Apollo.BaseMutationOptions<
  PartnerInvoiceArchiveMutation,
  PartnerInvoiceArchiveMutationVariables
>
export const PartnerInvoiceUnarchiveDocument = /*#__PURE__*/ gql`
  mutation PartnerInvoiceUnarchive($archivedInvoiceId: ID!) {
    PartnerInvoiceUnarchive(id: $archivedInvoiceId) {
      ...PartnerInvoiceListing
    }
  }
  ${PartnerInvoiceListingFragmentDoc}
`
export type PartnerInvoiceUnarchiveMutationFn = Apollo.MutationFunction<
  PartnerInvoiceUnarchiveMutation,
  PartnerInvoiceUnarchiveMutationVariables
>

/**
 * __usePartnerInvoiceUnarchiveMutation__
 *
 * To run a mutation, you first call `usePartnerInvoiceUnarchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerInvoiceUnarchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerInvoiceUnarchiveMutation, { data, loading, error }] = usePartnerInvoiceUnarchiveMutation({
 *   variables: {
 *      archivedInvoiceId: // value for 'archivedInvoiceId'
 *   },
 * });
 */
export function usePartnerInvoiceUnarchiveMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerInvoiceUnarchiveMutation,
    PartnerInvoiceUnarchiveMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerInvoiceUnarchiveMutation,
    PartnerInvoiceUnarchiveMutationVariables
  >(PartnerInvoiceUnarchiveDocument, options)
}
export type PartnerInvoiceUnarchiveMutationHookResult = ReturnType<
  typeof usePartnerInvoiceUnarchiveMutation
>
export type PartnerInvoiceUnarchiveMutationResult =
  Apollo.MutationResult<PartnerInvoiceUnarchiveMutation>
export type PartnerInvoiceUnarchiveMutationOptions = Apollo.BaseMutationOptions<
  PartnerInvoiceUnarchiveMutation,
  PartnerInvoiceUnarchiveMutationVariables
>
export const PartnerInvoiceCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerInvoiceCreate($input: InvoiceInput) {
    PartnerInvoiceCreate(input: $input) {
      ...PartnerInvoiceListing
    }
  }
  ${PartnerInvoiceListingFragmentDoc}
`
export type PartnerInvoiceCreateMutationFn = Apollo.MutationFunction<
  PartnerInvoiceCreateMutation,
  PartnerInvoiceCreateMutationVariables
>

/**
 * __usePartnerInvoiceCreateMutation__
 *
 * To run a mutation, you first call `usePartnerInvoiceCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerInvoiceCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerInvoiceCreateMutation, { data, loading, error }] = usePartnerInvoiceCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerInvoiceCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerInvoiceCreateMutation,
    PartnerInvoiceCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerInvoiceCreateMutation,
    PartnerInvoiceCreateMutationVariables
  >(PartnerInvoiceCreateDocument, options)
}
export type PartnerInvoiceCreateMutationHookResult = ReturnType<
  typeof usePartnerInvoiceCreateMutation
>
export type PartnerInvoiceCreateMutationResult =
  Apollo.MutationResult<PartnerInvoiceCreateMutation>
export type PartnerInvoiceCreateMutationOptions = Apollo.BaseMutationOptions<
  PartnerInvoiceCreateMutation,
  PartnerInvoiceCreateMutationVariables
>
export const PartnerInvoicePaidUpdateDocument = /*#__PURE__*/ gql`
  mutation PartnerInvoicePaidUpdate($input: PartnerInvoicePaidUpdateInput) {
    PartnerInvoicePaidUpdate(input: $input) {
      ...PartnerInvoiceListing
    }
  }
  ${PartnerInvoiceListingFragmentDoc}
`
export type PartnerInvoicePaidUpdateMutationFn = Apollo.MutationFunction<
  PartnerInvoicePaidUpdateMutation,
  PartnerInvoicePaidUpdateMutationVariables
>

/**
 * __usePartnerInvoicePaidUpdateMutation__
 *
 * To run a mutation, you first call `usePartnerInvoicePaidUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerInvoicePaidUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerInvoicePaidUpdateMutation, { data, loading, error }] = usePartnerInvoicePaidUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerInvoicePaidUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerInvoicePaidUpdateMutation,
    PartnerInvoicePaidUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerInvoicePaidUpdateMutation,
    PartnerInvoicePaidUpdateMutationVariables
  >(PartnerInvoicePaidUpdateDocument, options)
}
export type PartnerInvoicePaidUpdateMutationHookResult = ReturnType<
  typeof usePartnerInvoicePaidUpdateMutation
>
export type PartnerInvoicePaidUpdateMutationResult =
  Apollo.MutationResult<PartnerInvoicePaidUpdateMutation>
export type PartnerInvoicePaidUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerInvoicePaidUpdateMutation,
    PartnerInvoicePaidUpdateMutationVariables
  >
export const PartnerInvoiceRemindDocument = /*#__PURE__*/ gql`
  mutation PartnerInvoiceRemind($invoiceID: String!) {
    PartnerInvoiceRemind(invoiceID: $invoiceID)
  }
`
export type PartnerInvoiceRemindMutationFn = Apollo.MutationFunction<
  PartnerInvoiceRemindMutation,
  PartnerInvoiceRemindMutationVariables
>

/**
 * __usePartnerInvoiceRemindMutation__
 *
 * To run a mutation, you first call `usePartnerInvoiceRemindMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerInvoiceRemindMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerInvoiceRemindMutation, { data, loading, error }] = usePartnerInvoiceRemindMutation({
 *   variables: {
 *      invoiceID: // value for 'invoiceID'
 *   },
 * });
 */
export function usePartnerInvoiceRemindMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerInvoiceRemindMutation,
    PartnerInvoiceRemindMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerInvoiceRemindMutation,
    PartnerInvoiceRemindMutationVariables
  >(PartnerInvoiceRemindDocument, options)
}
export type PartnerInvoiceRemindMutationHookResult = ReturnType<
  typeof usePartnerInvoiceRemindMutation
>
export type PartnerInvoiceRemindMutationResult =
  Apollo.MutationResult<PartnerInvoiceRemindMutation>
export type PartnerInvoiceRemindMutationOptions = Apollo.BaseMutationOptions<
  PartnerInvoiceRemindMutation,
  PartnerInvoiceRemindMutationVariables
>
export const PartnerPayInvoiceDocument = /*#__PURE__*/ gql`
  mutation PartnerPayInvoice(
    $invoiceID: String!
    $customerID: String!
    $paymentDate: String
    $paymentMethod: PayInvoicePaymentMethodInput!
    $amount: Float!
    $idempotencyKey: String
  ) {
    PartnerPayInvoice(
      invoiceID: $invoiceID
      customerID: $customerID
      paymentDate: $paymentDate
      paymentMethod: $paymentMethod
      amount: $amount
      idempotencyKey: $idempotencyKey
    )
  }
`
export type PartnerPayInvoiceMutationFn = Apollo.MutationFunction<
  PartnerPayInvoiceMutation,
  PartnerPayInvoiceMutationVariables
>

/**
 * __usePartnerPayInvoiceMutation__
 *
 * To run a mutation, you first call `usePartnerPayInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerPayInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerPayInvoiceMutation, { data, loading, error }] = usePartnerPayInvoiceMutation({
 *   variables: {
 *      invoiceID: // value for 'invoiceID'
 *      customerID: // value for 'customerID'
 *      paymentDate: // value for 'paymentDate'
 *      paymentMethod: // value for 'paymentMethod'
 *      amount: // value for 'amount'
 *      idempotencyKey: // value for 'idempotencyKey'
 *   },
 * });
 */
export function usePartnerPayInvoiceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerPayInvoiceMutation,
    PartnerPayInvoiceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerPayInvoiceMutation,
    PartnerPayInvoiceMutationVariables
  >(PartnerPayInvoiceDocument, options)
}
export type PartnerPayInvoiceMutationHookResult = ReturnType<
  typeof usePartnerPayInvoiceMutation
>
export type PartnerPayInvoiceMutationResult =
  Apollo.MutationResult<PartnerPayInvoiceMutation>
export type PartnerPayInvoiceMutationOptions = Apollo.BaseMutationOptions<
  PartnerPayInvoiceMutation,
  PartnerPayInvoiceMutationVariables
>
export const PartnerUpsertInvoicePreferencesDocument = /*#__PURE__*/ gql`
  mutation PartnerUpsertInvoicePreferences(
    $input: UpsertInvoicePreferencesInput
  ) {
    PartnerUpsertInvoicePreferences(input: $input)
  }
`
export type PartnerUpsertInvoicePreferencesMutationFn = Apollo.MutationFunction<
  PartnerUpsertInvoicePreferencesMutation,
  PartnerUpsertInvoicePreferencesMutationVariables
>

/**
 * __usePartnerUpsertInvoicePreferencesMutation__
 *
 * To run a mutation, you first call `usePartnerUpsertInvoicePreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpsertInvoicePreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpsertInvoicePreferencesMutation, { data, loading, error }] = usePartnerUpsertInvoicePreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpsertInvoicePreferencesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpsertInvoicePreferencesMutation,
    PartnerUpsertInvoicePreferencesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpsertInvoicePreferencesMutation,
    PartnerUpsertInvoicePreferencesMutationVariables
  >(PartnerUpsertInvoicePreferencesDocument, options)
}
export type PartnerUpsertInvoicePreferencesMutationHookResult = ReturnType<
  typeof usePartnerUpsertInvoicePreferencesMutation
>
export type PartnerUpsertInvoicePreferencesMutationResult =
  Apollo.MutationResult<PartnerUpsertInvoicePreferencesMutation>
export type PartnerUpsertInvoicePreferencesMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpsertInvoicePreferencesMutation,
    PartnerUpsertInvoicePreferencesMutationVariables
  >
export const PartnerUpdateReminderTemplateDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateReminderTemplate($id: ID!, $templateID: ID) {
    PartnerUpdateReminderTemplate(id: $id, templateID: $templateID)
  }
`
export type PartnerUpdateReminderTemplateMutationFn = Apollo.MutationFunction<
  PartnerUpdateReminderTemplateMutation,
  PartnerUpdateReminderTemplateMutationVariables
>

/**
 * __usePartnerUpdateReminderTemplateMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateReminderTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateReminderTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateReminderTemplateMutation, { data, loading, error }] = usePartnerUpdateReminderTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      templateID: // value for 'templateID'
 *   },
 * });
 */
export function usePartnerUpdateReminderTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateReminderTemplateMutation,
    PartnerUpdateReminderTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateReminderTemplateMutation,
    PartnerUpdateReminderTemplateMutationVariables
  >(PartnerUpdateReminderTemplateDocument, options)
}
export type PartnerUpdateReminderTemplateMutationHookResult = ReturnType<
  typeof usePartnerUpdateReminderTemplateMutation
>
export type PartnerUpdateReminderTemplateMutationResult =
  Apollo.MutationResult<PartnerUpdateReminderTemplateMutation>
export type PartnerUpdateReminderTemplateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateReminderTemplateMutation,
    PartnerUpdateReminderTemplateMutationVariables
  >
export const PartnerListInvoiceRemindersDocument = /*#__PURE__*/ gql`
  query PartnerListInvoiceReminders {
    PartnerListInvoiceReminders {
      ...PartnerInvoiceReminder
    }
  }
  ${PartnerInvoiceReminderFragmentDoc}
`

/**
 * __usePartnerListInvoiceRemindersQuery__
 *
 * To run a query within a React component, call `usePartnerListInvoiceRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListInvoiceRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListInvoiceRemindersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerListInvoiceRemindersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListInvoiceRemindersQuery,
    PartnerListInvoiceRemindersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListInvoiceRemindersQuery,
    PartnerListInvoiceRemindersQueryVariables
  >(PartnerListInvoiceRemindersDocument, options)
}
export function usePartnerListInvoiceRemindersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListInvoiceRemindersQuery,
    PartnerListInvoiceRemindersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListInvoiceRemindersQuery,
    PartnerListInvoiceRemindersQueryVariables
  >(PartnerListInvoiceRemindersDocument, options)
}
export type PartnerListInvoiceRemindersQueryHookResult = ReturnType<
  typeof usePartnerListInvoiceRemindersQuery
>
export type PartnerListInvoiceRemindersLazyQueryHookResult = ReturnType<
  typeof usePartnerListInvoiceRemindersLazyQuery
>
export type PartnerListInvoiceRemindersQueryResult = Apollo.QueryResult<
  PartnerListInvoiceRemindersQuery,
  PartnerListInvoiceRemindersQueryVariables
>
export const PartnerListInvoiceReminderExcludedCustomersDocument = /*#__PURE__*/ gql`
  query PartnerListInvoiceReminderExcludedCustomers {
    PartnerListInvoiceReminderExcludedCustomers {
      ...PartnerInvoiceReminderExcludedCustomer
    }
  }
  ${PartnerInvoiceReminderExcludedCustomerFragmentDoc}
`

/**
 * __usePartnerListInvoiceReminderExcludedCustomersQuery__
 *
 * To run a query within a React component, call `usePartnerListInvoiceReminderExcludedCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListInvoiceReminderExcludedCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListInvoiceReminderExcludedCustomersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerListInvoiceReminderExcludedCustomersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListInvoiceReminderExcludedCustomersQuery,
    PartnerListInvoiceReminderExcludedCustomersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListInvoiceReminderExcludedCustomersQuery,
    PartnerListInvoiceReminderExcludedCustomersQueryVariables
  >(PartnerListInvoiceReminderExcludedCustomersDocument, options)
}
export function usePartnerListInvoiceReminderExcludedCustomersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListInvoiceReminderExcludedCustomersQuery,
    PartnerListInvoiceReminderExcludedCustomersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListInvoiceReminderExcludedCustomersQuery,
    PartnerListInvoiceReminderExcludedCustomersQueryVariables
  >(PartnerListInvoiceReminderExcludedCustomersDocument, options)
}
export type PartnerListInvoiceReminderExcludedCustomersQueryHookResult =
  ReturnType<typeof usePartnerListInvoiceReminderExcludedCustomersQuery>
export type PartnerListInvoiceReminderExcludedCustomersLazyQueryHookResult =
  ReturnType<typeof usePartnerListInvoiceReminderExcludedCustomersLazyQuery>
export type PartnerListInvoiceReminderExcludedCustomersQueryResult =
  Apollo.QueryResult<
    PartnerListInvoiceReminderExcludedCustomersQuery,
    PartnerListInvoiceReminderExcludedCustomersQueryVariables
  >
export const PartnerCreateInvoiceReminderDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateInvoiceReminder(
    $daysOffset: Int!
    $type: InvoiceReminderType!
    $templateID: ID
  ) {
    PartnerCreateInvoiceReminder(
      daysOffset: $daysOffset
      type: $type
      templateID: $templateID
    ) {
      ...PartnerInvoiceReminder
    }
  }
  ${PartnerInvoiceReminderFragmentDoc}
`
export type PartnerCreateInvoiceReminderMutationFn = Apollo.MutationFunction<
  PartnerCreateInvoiceReminderMutation,
  PartnerCreateInvoiceReminderMutationVariables
>

/**
 * __usePartnerCreateInvoiceReminderMutation__
 *
 * To run a mutation, you first call `usePartnerCreateInvoiceReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateInvoiceReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateInvoiceReminderMutation, { data, loading, error }] = usePartnerCreateInvoiceReminderMutation({
 *   variables: {
 *      daysOffset: // value for 'daysOffset'
 *      type: // value for 'type'
 *      templateID: // value for 'templateID'
 *   },
 * });
 */
export function usePartnerCreateInvoiceReminderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateInvoiceReminderMutation,
    PartnerCreateInvoiceReminderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateInvoiceReminderMutation,
    PartnerCreateInvoiceReminderMutationVariables
  >(PartnerCreateInvoiceReminderDocument, options)
}
export type PartnerCreateInvoiceReminderMutationHookResult = ReturnType<
  typeof usePartnerCreateInvoiceReminderMutation
>
export type PartnerCreateInvoiceReminderMutationResult =
  Apollo.MutationResult<PartnerCreateInvoiceReminderMutation>
export type PartnerCreateInvoiceReminderMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCreateInvoiceReminderMutation,
    PartnerCreateInvoiceReminderMutationVariables
  >
export const PartnerDeleteInvoiceReminderDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteInvoiceReminder($id: ID!) {
    PartnerDeleteInvoiceReminder(id: $id)
  }
`
export type PartnerDeleteInvoiceReminderMutationFn = Apollo.MutationFunction<
  PartnerDeleteInvoiceReminderMutation,
  PartnerDeleteInvoiceReminderMutationVariables
>

/**
 * __usePartnerDeleteInvoiceReminderMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteInvoiceReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteInvoiceReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteInvoiceReminderMutation, { data, loading, error }] = usePartnerDeleteInvoiceReminderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerDeleteInvoiceReminderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteInvoiceReminderMutation,
    PartnerDeleteInvoiceReminderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteInvoiceReminderMutation,
    PartnerDeleteInvoiceReminderMutationVariables
  >(PartnerDeleteInvoiceReminderDocument, options)
}
export type PartnerDeleteInvoiceReminderMutationHookResult = ReturnType<
  typeof usePartnerDeleteInvoiceReminderMutation
>
export type PartnerDeleteInvoiceReminderMutationResult =
  Apollo.MutationResult<PartnerDeleteInvoiceReminderMutation>
export type PartnerDeleteInvoiceReminderMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerDeleteInvoiceReminderMutation,
    PartnerDeleteInvoiceReminderMutationVariables
  >
export const PartnerCreateInvoiceReminderExcludedCustomerDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateInvoiceReminderExcludedCustomer($customerID: ID!) {
    PartnerCreateInvoiceReminderExcludedCustomer(customerID: $customerID) {
      ...PartnerInvoiceReminderExcludedCustomer
    }
  }
  ${PartnerInvoiceReminderExcludedCustomerFragmentDoc}
`
export type PartnerCreateInvoiceReminderExcludedCustomerMutationFn =
  Apollo.MutationFunction<
    PartnerCreateInvoiceReminderExcludedCustomerMutation,
    PartnerCreateInvoiceReminderExcludedCustomerMutationVariables
  >

/**
 * __usePartnerCreateInvoiceReminderExcludedCustomerMutation__
 *
 * To run a mutation, you first call `usePartnerCreateInvoiceReminderExcludedCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateInvoiceReminderExcludedCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateInvoiceReminderExcludedCustomerMutation, { data, loading, error }] = usePartnerCreateInvoiceReminderExcludedCustomerMutation({
 *   variables: {
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerCreateInvoiceReminderExcludedCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateInvoiceReminderExcludedCustomerMutation,
    PartnerCreateInvoiceReminderExcludedCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateInvoiceReminderExcludedCustomerMutation,
    PartnerCreateInvoiceReminderExcludedCustomerMutationVariables
  >(PartnerCreateInvoiceReminderExcludedCustomerDocument, options)
}
export type PartnerCreateInvoiceReminderExcludedCustomerMutationHookResult =
  ReturnType<typeof usePartnerCreateInvoiceReminderExcludedCustomerMutation>
export type PartnerCreateInvoiceReminderExcludedCustomerMutationResult =
  Apollo.MutationResult<PartnerCreateInvoiceReminderExcludedCustomerMutation>
export type PartnerCreateInvoiceReminderExcludedCustomerMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCreateInvoiceReminderExcludedCustomerMutation,
    PartnerCreateInvoiceReminderExcludedCustomerMutationVariables
  >
export const PartnerUpdateInvoiceReminderExcludedCustomerDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateInvoiceReminderExcludedCustomer($customerIDs: [ID!]) {
    PartnerUpdateInvoiceReminderExcludedCustomer(customerIDs: $customerIDs) {
      ...PartnerInvoiceReminderExcludedCustomer
    }
  }
  ${PartnerInvoiceReminderExcludedCustomerFragmentDoc}
`
export type PartnerUpdateInvoiceReminderExcludedCustomerMutationFn =
  Apollo.MutationFunction<
    PartnerUpdateInvoiceReminderExcludedCustomerMutation,
    PartnerUpdateInvoiceReminderExcludedCustomerMutationVariables
  >

/**
 * __usePartnerUpdateInvoiceReminderExcludedCustomerMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateInvoiceReminderExcludedCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateInvoiceReminderExcludedCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateInvoiceReminderExcludedCustomerMutation, { data, loading, error }] = usePartnerUpdateInvoiceReminderExcludedCustomerMutation({
 *   variables: {
 *      customerIDs: // value for 'customerIDs'
 *   },
 * });
 */
export function usePartnerUpdateInvoiceReminderExcludedCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateInvoiceReminderExcludedCustomerMutation,
    PartnerUpdateInvoiceReminderExcludedCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateInvoiceReminderExcludedCustomerMutation,
    PartnerUpdateInvoiceReminderExcludedCustomerMutationVariables
  >(PartnerUpdateInvoiceReminderExcludedCustomerDocument, options)
}
export type PartnerUpdateInvoiceReminderExcludedCustomerMutationHookResult =
  ReturnType<typeof usePartnerUpdateInvoiceReminderExcludedCustomerMutation>
export type PartnerUpdateInvoiceReminderExcludedCustomerMutationResult =
  Apollo.MutationResult<PartnerUpdateInvoiceReminderExcludedCustomerMutation>
export type PartnerUpdateInvoiceReminderExcludedCustomerMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateInvoiceReminderExcludedCustomerMutation,
    PartnerUpdateInvoiceReminderExcludedCustomerMutationVariables
  >
export const PartnerDeleteInvoiceReminderExcludedCustomerDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteInvoiceReminderExcludedCustomer($id: ID!) {
    PartnerDeleteInvoiceReminderExcludedCustomer(id: $id)
  }
`
export type PartnerDeleteInvoiceReminderExcludedCustomerMutationFn =
  Apollo.MutationFunction<
    PartnerDeleteInvoiceReminderExcludedCustomerMutation,
    PartnerDeleteInvoiceReminderExcludedCustomerMutationVariables
  >

/**
 * __usePartnerDeleteInvoiceReminderExcludedCustomerMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteInvoiceReminderExcludedCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteInvoiceReminderExcludedCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteInvoiceReminderExcludedCustomerMutation, { data, loading, error }] = usePartnerDeleteInvoiceReminderExcludedCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerDeleteInvoiceReminderExcludedCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteInvoiceReminderExcludedCustomerMutation,
    PartnerDeleteInvoiceReminderExcludedCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteInvoiceReminderExcludedCustomerMutation,
    PartnerDeleteInvoiceReminderExcludedCustomerMutationVariables
  >(PartnerDeleteInvoiceReminderExcludedCustomerDocument, options)
}
export type PartnerDeleteInvoiceReminderExcludedCustomerMutationHookResult =
  ReturnType<typeof usePartnerDeleteInvoiceReminderExcludedCustomerMutation>
export type PartnerDeleteInvoiceReminderExcludedCustomerMutationResult =
  Apollo.MutationResult<PartnerDeleteInvoiceReminderExcludedCustomerMutation>
export type PartnerDeleteInvoiceReminderExcludedCustomerMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerDeleteInvoiceReminderExcludedCustomerMutation,
    PartnerDeleteInvoiceReminderExcludedCustomerMutationVariables
  >
export const PartnerSendInvoiceReminderPreviewDocument = /*#__PURE__*/ gql`
  mutation PartnerSendInvoiceReminderPreview(
    $input: InvoiceReminderPreviewInput
  ) {
    PartnerSendInvoiceReminderPreview(input: $input)
  }
`
export type PartnerSendInvoiceReminderPreviewMutationFn =
  Apollo.MutationFunction<
    PartnerSendInvoiceReminderPreviewMutation,
    PartnerSendInvoiceReminderPreviewMutationVariables
  >

/**
 * __usePartnerSendInvoiceReminderPreviewMutation__
 *
 * To run a mutation, you first call `usePartnerSendInvoiceReminderPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerSendInvoiceReminderPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerSendInvoiceReminderPreviewMutation, { data, loading, error }] = usePartnerSendInvoiceReminderPreviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerSendInvoiceReminderPreviewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerSendInvoiceReminderPreviewMutation,
    PartnerSendInvoiceReminderPreviewMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerSendInvoiceReminderPreviewMutation,
    PartnerSendInvoiceReminderPreviewMutationVariables
  >(PartnerSendInvoiceReminderPreviewDocument, options)
}
export type PartnerSendInvoiceReminderPreviewMutationHookResult = ReturnType<
  typeof usePartnerSendInvoiceReminderPreviewMutation
>
export type PartnerSendInvoiceReminderPreviewMutationResult =
  Apollo.MutationResult<PartnerSendInvoiceReminderPreviewMutation>
export type PartnerSendInvoiceReminderPreviewMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerSendInvoiceReminderPreviewMutation,
    PartnerSendInvoiceReminderPreviewMutationVariables
  >
export const PartnerUpdateSummaryTemplateDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateSummaryTemplate($id: ID!, $templateID: ID) {
    PartnerUpdateSummaryTemplate(id: $id, templateID: $templateID)
  }
`
export type PartnerUpdateSummaryTemplateMutationFn = Apollo.MutationFunction<
  PartnerUpdateSummaryTemplateMutation,
  PartnerUpdateSummaryTemplateMutationVariables
>

/**
 * __usePartnerUpdateSummaryTemplateMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateSummaryTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateSummaryTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateSummaryTemplateMutation, { data, loading, error }] = usePartnerUpdateSummaryTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      templateID: // value for 'templateID'
 *   },
 * });
 */
export function usePartnerUpdateSummaryTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateSummaryTemplateMutation,
    PartnerUpdateSummaryTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateSummaryTemplateMutation,
    PartnerUpdateSummaryTemplateMutationVariables
  >(PartnerUpdateSummaryTemplateDocument, options)
}
export type PartnerUpdateSummaryTemplateMutationHookResult = ReturnType<
  typeof usePartnerUpdateSummaryTemplateMutation
>
export type PartnerUpdateSummaryTemplateMutationResult =
  Apollo.MutationResult<PartnerUpdateSummaryTemplateMutation>
export type PartnerUpdateSummaryTemplateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateSummaryTemplateMutation,
    PartnerUpdateSummaryTemplateMutationVariables
  >
export const PartnerListInvoiceSummariesDocument = /*#__PURE__*/ gql`
  query PartnerListInvoiceSummaries {
    PartnerListInvoiceSummaries {
      ...PartnerInvoiceSummary
    }
  }
  ${PartnerInvoiceSummaryFragmentDoc}
`

/**
 * __usePartnerListInvoiceSummariesQuery__
 *
 * To run a query within a React component, call `usePartnerListInvoiceSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListInvoiceSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListInvoiceSummariesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerListInvoiceSummariesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListInvoiceSummariesQuery,
    PartnerListInvoiceSummariesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListInvoiceSummariesQuery,
    PartnerListInvoiceSummariesQueryVariables
  >(PartnerListInvoiceSummariesDocument, options)
}
export function usePartnerListInvoiceSummariesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListInvoiceSummariesQuery,
    PartnerListInvoiceSummariesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListInvoiceSummariesQuery,
    PartnerListInvoiceSummariesQueryVariables
  >(PartnerListInvoiceSummariesDocument, options)
}
export type PartnerListInvoiceSummariesQueryHookResult = ReturnType<
  typeof usePartnerListInvoiceSummariesQuery
>
export type PartnerListInvoiceSummariesLazyQueryHookResult = ReturnType<
  typeof usePartnerListInvoiceSummariesLazyQuery
>
export type PartnerListInvoiceSummariesQueryResult = Apollo.QueryResult<
  PartnerListInvoiceSummariesQuery,
  PartnerListInvoiceSummariesQueryVariables
>
export const PartnerListInvoiceSummaryExcludedCustomersDocument = /*#__PURE__*/ gql`
  query PartnerListInvoiceSummaryExcludedCustomers {
    PartnerListInvoiceSummaryExcludedCustomers {
      ...PartnerInvoiceSummaryExcludedCustomer
    }
  }
  ${PartnerInvoiceSummaryExcludedCustomerFragmentDoc}
`

/**
 * __usePartnerListInvoiceSummaryExcludedCustomersQuery__
 *
 * To run a query within a React component, call `usePartnerListInvoiceSummaryExcludedCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListInvoiceSummaryExcludedCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListInvoiceSummaryExcludedCustomersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerListInvoiceSummaryExcludedCustomersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListInvoiceSummaryExcludedCustomersQuery,
    PartnerListInvoiceSummaryExcludedCustomersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListInvoiceSummaryExcludedCustomersQuery,
    PartnerListInvoiceSummaryExcludedCustomersQueryVariables
  >(PartnerListInvoiceSummaryExcludedCustomersDocument, options)
}
export function usePartnerListInvoiceSummaryExcludedCustomersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListInvoiceSummaryExcludedCustomersQuery,
    PartnerListInvoiceSummaryExcludedCustomersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListInvoiceSummaryExcludedCustomersQuery,
    PartnerListInvoiceSummaryExcludedCustomersQueryVariables
  >(PartnerListInvoiceSummaryExcludedCustomersDocument, options)
}
export type PartnerListInvoiceSummaryExcludedCustomersQueryHookResult =
  ReturnType<typeof usePartnerListInvoiceSummaryExcludedCustomersQuery>
export type PartnerListInvoiceSummaryExcludedCustomersLazyQueryHookResult =
  ReturnType<typeof usePartnerListInvoiceSummaryExcludedCustomersLazyQuery>
export type PartnerListInvoiceSummaryExcludedCustomersQueryResult =
  Apollo.QueryResult<
    PartnerListInvoiceSummaryExcludedCustomersQuery,
    PartnerListInvoiceSummaryExcludedCustomersQueryVariables
  >
export const PartnerCreateInvoiceSummaryDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateInvoiceSummary(
    $input: PartnerCreateInvoiceSummaryInput
  ) {
    PartnerCreateInvoiceSummary(input: $input) {
      ...PartnerInvoiceSummary
    }
  }
  ${PartnerInvoiceSummaryFragmentDoc}
`
export type PartnerCreateInvoiceSummaryMutationFn = Apollo.MutationFunction<
  PartnerCreateInvoiceSummaryMutation,
  PartnerCreateInvoiceSummaryMutationVariables
>

/**
 * __usePartnerCreateInvoiceSummaryMutation__
 *
 * To run a mutation, you first call `usePartnerCreateInvoiceSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateInvoiceSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateInvoiceSummaryMutation, { data, loading, error }] = usePartnerCreateInvoiceSummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCreateInvoiceSummaryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateInvoiceSummaryMutation,
    PartnerCreateInvoiceSummaryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateInvoiceSummaryMutation,
    PartnerCreateInvoiceSummaryMutationVariables
  >(PartnerCreateInvoiceSummaryDocument, options)
}
export type PartnerCreateInvoiceSummaryMutationHookResult = ReturnType<
  typeof usePartnerCreateInvoiceSummaryMutation
>
export type PartnerCreateInvoiceSummaryMutationResult =
  Apollo.MutationResult<PartnerCreateInvoiceSummaryMutation>
export type PartnerCreateInvoiceSummaryMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCreateInvoiceSummaryMutation,
    PartnerCreateInvoiceSummaryMutationVariables
  >
export const PartnerDeleteInvoiceSummaryDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteInvoiceSummary($id: ID!) {
    PartnerDeleteInvoiceSummary(id: $id)
  }
`
export type PartnerDeleteInvoiceSummaryMutationFn = Apollo.MutationFunction<
  PartnerDeleteInvoiceSummaryMutation,
  PartnerDeleteInvoiceSummaryMutationVariables
>

/**
 * __usePartnerDeleteInvoiceSummaryMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteInvoiceSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteInvoiceSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteInvoiceSummaryMutation, { data, loading, error }] = usePartnerDeleteInvoiceSummaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerDeleteInvoiceSummaryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteInvoiceSummaryMutation,
    PartnerDeleteInvoiceSummaryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteInvoiceSummaryMutation,
    PartnerDeleteInvoiceSummaryMutationVariables
  >(PartnerDeleteInvoiceSummaryDocument, options)
}
export type PartnerDeleteInvoiceSummaryMutationHookResult = ReturnType<
  typeof usePartnerDeleteInvoiceSummaryMutation
>
export type PartnerDeleteInvoiceSummaryMutationResult =
  Apollo.MutationResult<PartnerDeleteInvoiceSummaryMutation>
export type PartnerDeleteInvoiceSummaryMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerDeleteInvoiceSummaryMutation,
    PartnerDeleteInvoiceSummaryMutationVariables
  >
export const PartnerCreateInvoiceSummaryExcludedCustomerDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateInvoiceSummaryExcludedCustomer($customerID: ID!) {
    PartnerCreateInvoiceSummaryExcludedCustomer(customerID: $customerID) {
      ...PartnerInvoiceSummaryExcludedCustomer
    }
  }
  ${PartnerInvoiceSummaryExcludedCustomerFragmentDoc}
`
export type PartnerCreateInvoiceSummaryExcludedCustomerMutationFn =
  Apollo.MutationFunction<
    PartnerCreateInvoiceSummaryExcludedCustomerMutation,
    PartnerCreateInvoiceSummaryExcludedCustomerMutationVariables
  >

/**
 * __usePartnerCreateInvoiceSummaryExcludedCustomerMutation__
 *
 * To run a mutation, you first call `usePartnerCreateInvoiceSummaryExcludedCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateInvoiceSummaryExcludedCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateInvoiceSummaryExcludedCustomerMutation, { data, loading, error }] = usePartnerCreateInvoiceSummaryExcludedCustomerMutation({
 *   variables: {
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerCreateInvoiceSummaryExcludedCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateInvoiceSummaryExcludedCustomerMutation,
    PartnerCreateInvoiceSummaryExcludedCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateInvoiceSummaryExcludedCustomerMutation,
    PartnerCreateInvoiceSummaryExcludedCustomerMutationVariables
  >(PartnerCreateInvoiceSummaryExcludedCustomerDocument, options)
}
export type PartnerCreateInvoiceSummaryExcludedCustomerMutationHookResult =
  ReturnType<typeof usePartnerCreateInvoiceSummaryExcludedCustomerMutation>
export type PartnerCreateInvoiceSummaryExcludedCustomerMutationResult =
  Apollo.MutationResult<PartnerCreateInvoiceSummaryExcludedCustomerMutation>
export type PartnerCreateInvoiceSummaryExcludedCustomerMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCreateInvoiceSummaryExcludedCustomerMutation,
    PartnerCreateInvoiceSummaryExcludedCustomerMutationVariables
  >
export const PartnerUpdateInvoiceSummaryExcludedCustomerDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateInvoiceSummaryExcludedCustomer($customerIDs: [ID!]) {
    PartnerUpdateInvoiceSummaryExcludedCustomer(customerIDs: $customerIDs) {
      ...PartnerInvoiceSummaryExcludedCustomer
    }
  }
  ${PartnerInvoiceSummaryExcludedCustomerFragmentDoc}
`
export type PartnerUpdateInvoiceSummaryExcludedCustomerMutationFn =
  Apollo.MutationFunction<
    PartnerUpdateInvoiceSummaryExcludedCustomerMutation,
    PartnerUpdateInvoiceSummaryExcludedCustomerMutationVariables
  >

/**
 * __usePartnerUpdateInvoiceSummaryExcludedCustomerMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateInvoiceSummaryExcludedCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateInvoiceSummaryExcludedCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateInvoiceSummaryExcludedCustomerMutation, { data, loading, error }] = usePartnerUpdateInvoiceSummaryExcludedCustomerMutation({
 *   variables: {
 *      customerIDs: // value for 'customerIDs'
 *   },
 * });
 */
export function usePartnerUpdateInvoiceSummaryExcludedCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateInvoiceSummaryExcludedCustomerMutation,
    PartnerUpdateInvoiceSummaryExcludedCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateInvoiceSummaryExcludedCustomerMutation,
    PartnerUpdateInvoiceSummaryExcludedCustomerMutationVariables
  >(PartnerUpdateInvoiceSummaryExcludedCustomerDocument, options)
}
export type PartnerUpdateInvoiceSummaryExcludedCustomerMutationHookResult =
  ReturnType<typeof usePartnerUpdateInvoiceSummaryExcludedCustomerMutation>
export type PartnerUpdateInvoiceSummaryExcludedCustomerMutationResult =
  Apollo.MutationResult<PartnerUpdateInvoiceSummaryExcludedCustomerMutation>
export type PartnerUpdateInvoiceSummaryExcludedCustomerMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateInvoiceSummaryExcludedCustomerMutation,
    PartnerUpdateInvoiceSummaryExcludedCustomerMutationVariables
  >
export const PartnerDeleteInvoiceSummaryExcludedCustomerDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteInvoiceSummaryExcludedCustomer($id: ID!) {
    PartnerDeleteInvoiceSummaryExcludedCustomer(id: $id)
  }
`
export type PartnerDeleteInvoiceSummaryExcludedCustomerMutationFn =
  Apollo.MutationFunction<
    PartnerDeleteInvoiceSummaryExcludedCustomerMutation,
    PartnerDeleteInvoiceSummaryExcludedCustomerMutationVariables
  >

/**
 * __usePartnerDeleteInvoiceSummaryExcludedCustomerMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteInvoiceSummaryExcludedCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteInvoiceSummaryExcludedCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteInvoiceSummaryExcludedCustomerMutation, { data, loading, error }] = usePartnerDeleteInvoiceSummaryExcludedCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerDeleteInvoiceSummaryExcludedCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteInvoiceSummaryExcludedCustomerMutation,
    PartnerDeleteInvoiceSummaryExcludedCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteInvoiceSummaryExcludedCustomerMutation,
    PartnerDeleteInvoiceSummaryExcludedCustomerMutationVariables
  >(PartnerDeleteInvoiceSummaryExcludedCustomerDocument, options)
}
export type PartnerDeleteInvoiceSummaryExcludedCustomerMutationHookResult =
  ReturnType<typeof usePartnerDeleteInvoiceSummaryExcludedCustomerMutation>
export type PartnerDeleteInvoiceSummaryExcludedCustomerMutationResult =
  Apollo.MutationResult<PartnerDeleteInvoiceSummaryExcludedCustomerMutation>
export type PartnerDeleteInvoiceSummaryExcludedCustomerMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerDeleteInvoiceSummaryExcludedCustomerMutation,
    PartnerDeleteInvoiceSummaryExcludedCustomerMutationVariables
  >
export const PartnerSendInvoiceSummaryPreviewDocument = /*#__PURE__*/ gql`
  mutation PartnerSendInvoiceSummaryPreview(
    $input: InvoiceSummaryPreviewInput!
  ) {
    PartnerSendInvoiceSummaryPreview(input: $input)
  }
`
export type PartnerSendInvoiceSummaryPreviewMutationFn =
  Apollo.MutationFunction<
    PartnerSendInvoiceSummaryPreviewMutation,
    PartnerSendInvoiceSummaryPreviewMutationVariables
  >

/**
 * __usePartnerSendInvoiceSummaryPreviewMutation__
 *
 * To run a mutation, you first call `usePartnerSendInvoiceSummaryPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerSendInvoiceSummaryPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerSendInvoiceSummaryPreviewMutation, { data, loading, error }] = usePartnerSendInvoiceSummaryPreviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerSendInvoiceSummaryPreviewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerSendInvoiceSummaryPreviewMutation,
    PartnerSendInvoiceSummaryPreviewMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerSendInvoiceSummaryPreviewMutation,
    PartnerSendInvoiceSummaryPreviewMutationVariables
  >(PartnerSendInvoiceSummaryPreviewDocument, options)
}
export type PartnerSendInvoiceSummaryPreviewMutationHookResult = ReturnType<
  typeof usePartnerSendInvoiceSummaryPreviewMutation
>
export type PartnerSendInvoiceSummaryPreviewMutationResult =
  Apollo.MutationResult<PartnerSendInvoiceSummaryPreviewMutation>
export type PartnerSendInvoiceSummaryPreviewMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerSendInvoiceSummaryPreviewMutation,
    PartnerSendInvoiceSummaryPreviewMutationVariables
  >
export const PartnerGetNotificationsEnabledDocument = /*#__PURE__*/ gql`
  query PartnerGetNotificationsEnabled {
    PartnerGetNotificationsEnabled {
      id
      notificationsEnabled
    }
  }
`

/**
 * __usePartnerGetNotificationsEnabledQuery__
 *
 * To run a query within a React component, call `usePartnerGetNotificationsEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetNotificationsEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetNotificationsEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerGetNotificationsEnabledQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetNotificationsEnabledQuery,
    PartnerGetNotificationsEnabledQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetNotificationsEnabledQuery,
    PartnerGetNotificationsEnabledQueryVariables
  >(PartnerGetNotificationsEnabledDocument, options)
}
export function usePartnerGetNotificationsEnabledLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetNotificationsEnabledQuery,
    PartnerGetNotificationsEnabledQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetNotificationsEnabledQuery,
    PartnerGetNotificationsEnabledQueryVariables
  >(PartnerGetNotificationsEnabledDocument, options)
}
export type PartnerGetNotificationsEnabledQueryHookResult = ReturnType<
  typeof usePartnerGetNotificationsEnabledQuery
>
export type PartnerGetNotificationsEnabledLazyQueryHookResult = ReturnType<
  typeof usePartnerGetNotificationsEnabledLazyQuery
>
export type PartnerGetNotificationsEnabledQueryResult = Apollo.QueryResult<
  PartnerGetNotificationsEnabledQuery,
  PartnerGetNotificationsEnabledQueryVariables
>
export const PartnerUpdateNotificationsEnabledDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateNotificationsEnabled($notificationsEnabled: Boolean!) {
    PartnerUpdateNotificationsEnabled(
      notificationsEnabled: $notificationsEnabled
    ) {
      id
      notificationsEnabled
    }
  }
`
export type PartnerUpdateNotificationsEnabledMutationFn =
  Apollo.MutationFunction<
    PartnerUpdateNotificationsEnabledMutation,
    PartnerUpdateNotificationsEnabledMutationVariables
  >

/**
 * __usePartnerUpdateNotificationsEnabledMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateNotificationsEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateNotificationsEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateNotificationsEnabledMutation, { data, loading, error }] = usePartnerUpdateNotificationsEnabledMutation({
 *   variables: {
 *      notificationsEnabled: // value for 'notificationsEnabled'
 *   },
 * });
 */
export function usePartnerUpdateNotificationsEnabledMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateNotificationsEnabledMutation,
    PartnerUpdateNotificationsEnabledMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateNotificationsEnabledMutation,
    PartnerUpdateNotificationsEnabledMutationVariables
  >(PartnerUpdateNotificationsEnabledDocument, options)
}
export type PartnerUpdateNotificationsEnabledMutationHookResult = ReturnType<
  typeof usePartnerUpdateNotificationsEnabledMutation
>
export type PartnerUpdateNotificationsEnabledMutationResult =
  Apollo.MutationResult<PartnerUpdateNotificationsEnabledMutation>
export type PartnerUpdateNotificationsEnabledMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateNotificationsEnabledMutation,
    PartnerUpdateNotificationsEnabledMutationVariables
  >
export const GetPartnerDocumentsDocument = /*#__PURE__*/ gql`
  query GetPartnerDocuments {
    GetPartnerDocuments {
      id
      partnerID
      type
      filename
      createdAt
    }
  }
`

/**
 * __useGetPartnerDocumentsQuery__
 *
 * To run a query within a React component, call `useGetPartnerDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPartnerDocumentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPartnerDocumentsQuery,
    GetPartnerDocumentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetPartnerDocumentsQuery,
    GetPartnerDocumentsQueryVariables
  >(GetPartnerDocumentsDocument, options)
}
export function useGetPartnerDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPartnerDocumentsQuery,
    GetPartnerDocumentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetPartnerDocumentsQuery,
    GetPartnerDocumentsQueryVariables
  >(GetPartnerDocumentsDocument, options)
}
export type GetPartnerDocumentsQueryHookResult = ReturnType<
  typeof useGetPartnerDocumentsQuery
>
export type GetPartnerDocumentsLazyQueryHookResult = ReturnType<
  typeof useGetPartnerDocumentsLazyQuery
>
export type GetPartnerDocumentsQueryResult = Apollo.QueryResult<
  GetPartnerDocumentsQuery,
  GetPartnerDocumentsQueryVariables
>
export const PartnerUpdateInformationDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateInformation(
    $detailsInput: PartnerUpdateDetailsInput
    $addressInput: PartnerUpdateAddressInput
  ) {
    PartnerUpdateAddress(input: $addressInput) {
      id
      ...PartnerAddressDetails
    }
    PartnerUpdateDetails(input: $detailsInput) {
      ...PartnerBase
      ...PartnerDetails
    }
  }
  ${PartnerAddressDetailsFragmentDoc}
  ${PartnerBaseFragmentDoc}
  ${PartnerDetailsFragmentDoc}
`
export type PartnerUpdateInformationMutationFn = Apollo.MutationFunction<
  PartnerUpdateInformationMutation,
  PartnerUpdateInformationMutationVariables
>

/**
 * __usePartnerUpdateInformationMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateInformationMutation, { data, loading, error }] = usePartnerUpdateInformationMutation({
 *   variables: {
 *      detailsInput: // value for 'detailsInput'
 *      addressInput: // value for 'addressInput'
 *   },
 * });
 */
export function usePartnerUpdateInformationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateInformationMutation,
    PartnerUpdateInformationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateInformationMutation,
    PartnerUpdateInformationMutationVariables
  >(PartnerUpdateInformationDocument, options)
}
export type PartnerUpdateInformationMutationHookResult = ReturnType<
  typeof usePartnerUpdateInformationMutation
>
export type PartnerUpdateInformationMutationResult =
  Apollo.MutationResult<PartnerUpdateInformationMutation>
export type PartnerUpdateInformationMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdateInformationMutation,
    PartnerUpdateInformationMutationVariables
  >
export const ActivatePartnerPaymentsPortalDocument = /*#__PURE__*/ gql`
  mutation ActivatePartnerPaymentsPortal {
    ActivatePartnerPaymentsPortal {
      id
      name
      paymentsPortalEnabled
      paymentsPortalUrl
    }
  }
`
export type ActivatePartnerPaymentsPortalMutationFn = Apollo.MutationFunction<
  ActivatePartnerPaymentsPortalMutation,
  ActivatePartnerPaymentsPortalMutationVariables
>

/**
 * __useActivatePartnerPaymentsPortalMutation__
 *
 * To run a mutation, you first call `useActivatePartnerPaymentsPortalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivatePartnerPaymentsPortalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activatePartnerPaymentsPortalMutation, { data, loading, error }] = useActivatePartnerPaymentsPortalMutation({
 *   variables: {
 *   },
 * });
 */
export function useActivatePartnerPaymentsPortalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ActivatePartnerPaymentsPortalMutation,
    ActivatePartnerPaymentsPortalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ActivatePartnerPaymentsPortalMutation,
    ActivatePartnerPaymentsPortalMutationVariables
  >(ActivatePartnerPaymentsPortalDocument, options)
}
export type ActivatePartnerPaymentsPortalMutationHookResult = ReturnType<
  typeof useActivatePartnerPaymentsPortalMutation
>
export type ActivatePartnerPaymentsPortalMutationResult =
  Apollo.MutationResult<ActivatePartnerPaymentsPortalMutation>
export type ActivatePartnerPaymentsPortalMutationOptions =
  Apollo.BaseMutationOptions<
    ActivatePartnerPaymentsPortalMutation,
    ActivatePartnerPaymentsPortalMutationVariables
  >
export const GetCompanyIndividualsDocument = /*#__PURE__*/ gql`
  query GetCompanyIndividuals {
    GetCompanyIndividuals {
      ...CompanyIndividual
    }
  }
  ${CompanyIndividualFragmentDoc}
`

/**
 * __useGetCompanyIndividualsQuery__
 *
 * To run a query within a React component, call `useGetCompanyIndividualsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyIndividualsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyIndividualsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyIndividualsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCompanyIndividualsQuery,
    GetCompanyIndividualsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetCompanyIndividualsQuery,
    GetCompanyIndividualsQueryVariables
  >(GetCompanyIndividualsDocument, options)
}
export function useGetCompanyIndividualsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCompanyIndividualsQuery,
    GetCompanyIndividualsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetCompanyIndividualsQuery,
    GetCompanyIndividualsQueryVariables
  >(GetCompanyIndividualsDocument, options)
}
export type GetCompanyIndividualsQueryHookResult = ReturnType<
  typeof useGetCompanyIndividualsQuery
>
export type GetCompanyIndividualsLazyQueryHookResult = ReturnType<
  typeof useGetCompanyIndividualsLazyQuery
>
export type GetCompanyIndividualsQueryResult = Apollo.QueryResult<
  GetCompanyIndividualsQuery,
  GetCompanyIndividualsQueryVariables
>
export const CreateCompanyIndividualDocument = /*#__PURE__*/ gql`
  mutation CreateCompanyIndividual($input: CreateCompanyIndividualInput!) {
    CreateCompanyIndividual(input: $input) {
      ...CompanyIndividual
    }
  }
  ${CompanyIndividualFragmentDoc}
`
export type CreateCompanyIndividualMutationFn = Apollo.MutationFunction<
  CreateCompanyIndividualMutation,
  CreateCompanyIndividualMutationVariables
>

/**
 * __useCreateCompanyIndividualMutation__
 *
 * To run a mutation, you first call `useCreateCompanyIndividualMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyIndividualMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyIndividualMutation, { data, loading, error }] = useCreateCompanyIndividualMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyIndividualMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCompanyIndividualMutation,
    CreateCompanyIndividualMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateCompanyIndividualMutation,
    CreateCompanyIndividualMutationVariables
  >(CreateCompanyIndividualDocument, options)
}
export type CreateCompanyIndividualMutationHookResult = ReturnType<
  typeof useCreateCompanyIndividualMutation
>
export type CreateCompanyIndividualMutationResult =
  Apollo.MutationResult<CreateCompanyIndividualMutation>
export type CreateCompanyIndividualMutationOptions = Apollo.BaseMutationOptions<
  CreateCompanyIndividualMutation,
  CreateCompanyIndividualMutationVariables
>
export const UpdateCompanyIndividualDocument = /*#__PURE__*/ gql`
  mutation UpdateCompanyIndividual($input: UpdateCompanyIndividualInput!) {
    UpdateCompanyIndividual(input: $input)
  }
`
export type UpdateCompanyIndividualMutationFn = Apollo.MutationFunction<
  UpdateCompanyIndividualMutation,
  UpdateCompanyIndividualMutationVariables
>

/**
 * __useUpdateCompanyIndividualMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyIndividualMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyIndividualMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyIndividualMutation, { data, loading, error }] = useUpdateCompanyIndividualMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyIndividualMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCompanyIndividualMutation,
    UpdateCompanyIndividualMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateCompanyIndividualMutation,
    UpdateCompanyIndividualMutationVariables
  >(UpdateCompanyIndividualDocument, options)
}
export type UpdateCompanyIndividualMutationHookResult = ReturnType<
  typeof useUpdateCompanyIndividualMutation
>
export type UpdateCompanyIndividualMutationResult =
  Apollo.MutationResult<UpdateCompanyIndividualMutation>
export type UpdateCompanyIndividualMutationOptions = Apollo.BaseMutationOptions<
  UpdateCompanyIndividualMutation,
  UpdateCompanyIndividualMutationVariables
>
export const DeleteCompanyIndividualDocument = /*#__PURE__*/ gql`
  mutation DeleteCompanyIndividual($id: ID!) {
    DeleteCompanyIndividual(id: $id)
  }
`
export type DeleteCompanyIndividualMutationFn = Apollo.MutationFunction<
  DeleteCompanyIndividualMutation,
  DeleteCompanyIndividualMutationVariables
>

/**
 * __useDeleteCompanyIndividualMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyIndividualMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyIndividualMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyIndividualMutation, { data, loading, error }] = useDeleteCompanyIndividualMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCompanyIndividualMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCompanyIndividualMutation,
    DeleteCompanyIndividualMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteCompanyIndividualMutation,
    DeleteCompanyIndividualMutationVariables
  >(DeleteCompanyIndividualDocument, options)
}
export type DeleteCompanyIndividualMutationHookResult = ReturnType<
  typeof useDeleteCompanyIndividualMutation
>
export type DeleteCompanyIndividualMutationResult =
  Apollo.MutationResult<DeleteCompanyIndividualMutation>
export type DeleteCompanyIndividualMutationOptions = Apollo.BaseMutationOptions<
  DeleteCompanyIndividualMutation,
  DeleteCompanyIndividualMutationVariables
>
export const UploadPartnerDocumentDocument = /*#__PURE__*/ gql`
  mutation UploadPartnerDocument($input: UploadPartnerDocumentInput!) {
    UploadPartnerDocument(input: $input)
  }
`
export type UploadPartnerDocumentMutationFn = Apollo.MutationFunction<
  UploadPartnerDocumentMutation,
  UploadPartnerDocumentMutationVariables
>

/**
 * __useUploadPartnerDocumentMutation__
 *
 * To run a mutation, you first call `useUploadPartnerDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadPartnerDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadPartnerDocumentMutation, { data, loading, error }] = useUploadPartnerDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadPartnerDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadPartnerDocumentMutation,
    UploadPartnerDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UploadPartnerDocumentMutation,
    UploadPartnerDocumentMutationVariables
  >(UploadPartnerDocumentDocument, options)
}
export type UploadPartnerDocumentMutationHookResult = ReturnType<
  typeof useUploadPartnerDocumentMutation
>
export type UploadPartnerDocumentMutationResult =
  Apollo.MutationResult<UploadPartnerDocumentMutation>
export type UploadPartnerDocumentMutationOptions = Apollo.BaseMutationOptions<
  UploadPartnerDocumentMutation,
  UploadPartnerDocumentMutationVariables
>
export const UpsertSupportPreferencesDocument = /*#__PURE__*/ gql`
  mutation UpsertSupportPreferences($input: UpsertSupportPreferencesInput!) {
    UpsertSupportPreferences(input: $input) {
      ...SupportPreferences
    }
  }
  ${SupportPreferencesFragmentDoc}
`
export type UpsertSupportPreferencesMutationFn = Apollo.MutationFunction<
  UpsertSupportPreferencesMutation,
  UpsertSupportPreferencesMutationVariables
>

/**
 * __useUpsertSupportPreferencesMutation__
 *
 * To run a mutation, you first call `useUpsertSupportPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSupportPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSupportPreferencesMutation, { data, loading, error }] = useUpsertSupportPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertSupportPreferencesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertSupportPreferencesMutation,
    UpsertSupportPreferencesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpsertSupportPreferencesMutation,
    UpsertSupportPreferencesMutationVariables
  >(UpsertSupportPreferencesDocument, options)
}
export type UpsertSupportPreferencesMutationHookResult = ReturnType<
  typeof useUpsertSupportPreferencesMutation
>
export type UpsertSupportPreferencesMutationResult =
  Apollo.MutationResult<UpsertSupportPreferencesMutation>
export type UpsertSupportPreferencesMutationOptions =
  Apollo.BaseMutationOptions<
    UpsertSupportPreferencesMutation,
    UpsertSupportPreferencesMutationVariables
  >
export const GetSupportPreferencesDocument = /*#__PURE__*/ gql`
  query GetSupportPreferences {
    GetSupportPreferences {
      ...SupportPreferences
    }
  }
  ${SupportPreferencesFragmentDoc}
`

/**
 * __useGetSupportPreferencesQuery__
 *
 * To run a query within a React component, call `useGetSupportPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSupportPreferencesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSupportPreferencesQuery,
    GetSupportPreferencesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetSupportPreferencesQuery,
    GetSupportPreferencesQueryVariables
  >(GetSupportPreferencesDocument, options)
}
export function useGetSupportPreferencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSupportPreferencesQuery,
    GetSupportPreferencesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetSupportPreferencesQuery,
    GetSupportPreferencesQueryVariables
  >(GetSupportPreferencesDocument, options)
}
export type GetSupportPreferencesQueryHookResult = ReturnType<
  typeof useGetSupportPreferencesQuery
>
export type GetSupportPreferencesLazyQueryHookResult = ReturnType<
  typeof useGetSupportPreferencesLazyQuery
>
export type GetSupportPreferencesQueryResult = Apollo.QueryResult<
  GetSupportPreferencesQuery,
  GetSupportPreferencesQueryVariables
>
export const GetUserPartnersDocument = /*#__PURE__*/ gql`
  query GetUserPartners {
    GetUserPartners {
      ...PartnerBase
    }
  }
  ${PartnerBaseFragmentDoc}
`

/**
 * __useGetUserPartnersQuery__
 *
 * To run a query within a React component, call `useGetUserPartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPartnersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserPartnersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserPartnersQuery,
    GetUserPartnersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetUserPartnersQuery, GetUserPartnersQueryVariables>(
    GetUserPartnersDocument,
    options
  )
}
export function useGetUserPartnersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserPartnersQuery,
    GetUserPartnersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetUserPartnersQuery,
    GetUserPartnersQueryVariables
  >(GetUserPartnersDocument, options)
}
export type GetUserPartnersQueryHookResult = ReturnType<
  typeof useGetUserPartnersQuery
>
export type GetUserPartnersLazyQueryHookResult = ReturnType<
  typeof useGetUserPartnersLazyQuery
>
export type GetUserPartnersQueryResult = Apollo.QueryResult<
  GetUserPartnersQuery,
  GetUserPartnersQueryVariables
>
export const PartnerFinishOnboardingDocument = /*#__PURE__*/ gql`
  mutation PartnerFinishOnboarding {
    PartnerFinishOnboarding {
      id
      isOnboarded
    }
  }
`
export type PartnerFinishOnboardingMutationFn = Apollo.MutationFunction<
  PartnerFinishOnboardingMutation,
  PartnerFinishOnboardingMutationVariables
>

/**
 * __usePartnerFinishOnboardingMutation__
 *
 * To run a mutation, you first call `usePartnerFinishOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerFinishOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerFinishOnboardingMutation, { data, loading, error }] = usePartnerFinishOnboardingMutation({
 *   variables: {
 *   },
 * });
 */
export function usePartnerFinishOnboardingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerFinishOnboardingMutation,
    PartnerFinishOnboardingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerFinishOnboardingMutation,
    PartnerFinishOnboardingMutationVariables
  >(PartnerFinishOnboardingDocument, options)
}
export type PartnerFinishOnboardingMutationHookResult = ReturnType<
  typeof usePartnerFinishOnboardingMutation
>
export type PartnerFinishOnboardingMutationResult =
  Apollo.MutationResult<PartnerFinishOnboardingMutation>
export type PartnerFinishOnboardingMutationOptions = Apollo.BaseMutationOptions<
  PartnerFinishOnboardingMutation,
  PartnerFinishOnboardingMutationVariables
>
export const PartnerUpdateDetailsDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateDetails($input: PartnerUpdateDetailsInput) {
    PartnerUpdateDetails(input: $input) {
      ...PartnerBase
      ...PartnerDetails
    }
  }
  ${PartnerBaseFragmentDoc}
  ${PartnerDetailsFragmentDoc}
`
export type PartnerUpdateDetailsMutationFn = Apollo.MutationFunction<
  PartnerUpdateDetailsMutation,
  PartnerUpdateDetailsMutationVariables
>

/**
 * __usePartnerUpdateDetailsMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateDetailsMutation, { data, loading, error }] = usePartnerUpdateDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateDetailsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateDetailsMutation,
    PartnerUpdateDetailsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateDetailsMutation,
    PartnerUpdateDetailsMutationVariables
  >(PartnerUpdateDetailsDocument, options)
}
export type PartnerUpdateDetailsMutationHookResult = ReturnType<
  typeof usePartnerUpdateDetailsMutation
>
export type PartnerUpdateDetailsMutationResult =
  Apollo.MutationResult<PartnerUpdateDetailsMutation>
export type PartnerUpdateDetailsMutationOptions = Apollo.BaseMutationOptions<
  PartnerUpdateDetailsMutation,
  PartnerUpdateDetailsMutationVariables
>
export const PartnerUpdateAddressDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateAddress($input: PartnerUpdateAddressInput) {
    PartnerUpdateAddress(input: $input) {
      id
      ...PartnerAddressDetails
    }
  }
  ${PartnerAddressDetailsFragmentDoc}
`
export type PartnerUpdateAddressMutationFn = Apollo.MutationFunction<
  PartnerUpdateAddressMutation,
  PartnerUpdateAddressMutationVariables
>

/**
 * __usePartnerUpdateAddressMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateAddressMutation, { data, loading, error }] = usePartnerUpdateAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateAddressMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateAddressMutation,
    PartnerUpdateAddressMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateAddressMutation,
    PartnerUpdateAddressMutationVariables
  >(PartnerUpdateAddressDocument, options)
}
export type PartnerUpdateAddressMutationHookResult = ReturnType<
  typeof usePartnerUpdateAddressMutation
>
export type PartnerUpdateAddressMutationResult =
  Apollo.MutationResult<PartnerUpdateAddressMutation>
export type PartnerUpdateAddressMutationOptions = Apollo.BaseMutationOptions<
  PartnerUpdateAddressMutation,
  PartnerUpdateAddressMutationVariables
>
export const PartnerTogglePaymentsPortalCustomInvoicesDocument = /*#__PURE__*/ gql`
  mutation PartnerTogglePaymentsPortalCustomInvoices(
    $paymentsPortalCustomInvoices: Boolean!
  ) {
    PartnerTogglePaymentsPortalCustomInvoices(
      paymentsPortalCustomInvoices: $paymentsPortalCustomInvoices
    ) {
      paymentsPortalCustomInvoices
    }
  }
`
export type PartnerTogglePaymentsPortalCustomInvoicesMutationFn =
  Apollo.MutationFunction<
    PartnerTogglePaymentsPortalCustomInvoicesMutation,
    PartnerTogglePaymentsPortalCustomInvoicesMutationVariables
  >

/**
 * __usePartnerTogglePaymentsPortalCustomInvoicesMutation__
 *
 * To run a mutation, you first call `usePartnerTogglePaymentsPortalCustomInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerTogglePaymentsPortalCustomInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerTogglePaymentsPortalCustomInvoicesMutation, { data, loading, error }] = usePartnerTogglePaymentsPortalCustomInvoicesMutation({
 *   variables: {
 *      paymentsPortalCustomInvoices: // value for 'paymentsPortalCustomInvoices'
 *   },
 * });
 */
export function usePartnerTogglePaymentsPortalCustomInvoicesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerTogglePaymentsPortalCustomInvoicesMutation,
    PartnerTogglePaymentsPortalCustomInvoicesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerTogglePaymentsPortalCustomInvoicesMutation,
    PartnerTogglePaymentsPortalCustomInvoicesMutationVariables
  >(PartnerTogglePaymentsPortalCustomInvoicesDocument, options)
}
export type PartnerTogglePaymentsPortalCustomInvoicesMutationHookResult =
  ReturnType<typeof usePartnerTogglePaymentsPortalCustomInvoicesMutation>
export type PartnerTogglePaymentsPortalCustomInvoicesMutationResult =
  Apollo.MutationResult<PartnerTogglePaymentsPortalCustomInvoicesMutation>
export type PartnerTogglePaymentsPortalCustomInvoicesMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerTogglePaymentsPortalCustomInvoicesMutation,
    PartnerTogglePaymentsPortalCustomInvoicesMutationVariables
  >
export const PartnerToggleRequiresMfaDocument = /*#__PURE__*/ gql`
  mutation PartnerToggleRequiresMFA($requiresMFA: Boolean!) {
    PartnerToggleRequiresMFA(requiresMFA: $requiresMFA) {
      id
      requiresMFA
    }
  }
`
export type PartnerToggleRequiresMfaMutationFn = Apollo.MutationFunction<
  PartnerToggleRequiresMfaMutation,
  PartnerToggleRequiresMfaMutationVariables
>

/**
 * __usePartnerToggleRequiresMfaMutation__
 *
 * To run a mutation, you first call `usePartnerToggleRequiresMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerToggleRequiresMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerToggleRequiresMfaMutation, { data, loading, error }] = usePartnerToggleRequiresMfaMutation({
 *   variables: {
 *      requiresMFA: // value for 'requiresMFA'
 *   },
 * });
 */
export function usePartnerToggleRequiresMfaMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerToggleRequiresMfaMutation,
    PartnerToggleRequiresMfaMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerToggleRequiresMfaMutation,
    PartnerToggleRequiresMfaMutationVariables
  >(PartnerToggleRequiresMfaDocument, options)
}
export type PartnerToggleRequiresMfaMutationHookResult = ReturnType<
  typeof usePartnerToggleRequiresMfaMutation
>
export type PartnerToggleRequiresMfaMutationResult =
  Apollo.MutationResult<PartnerToggleRequiresMfaMutation>
export type PartnerToggleRequiresMfaMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerToggleRequiresMfaMutation,
    PartnerToggleRequiresMfaMutationVariables
  >
export const PartnerUpdateNameDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateName($input: UpdatePartnerNameInput!) {
    PartnerUpdateName(input: $input) {
      ...PartnerBase
      ...PartnerDetails
    }
  }
  ${PartnerBaseFragmentDoc}
  ${PartnerDetailsFragmentDoc}
`
export type PartnerUpdateNameMutationFn = Apollo.MutationFunction<
  PartnerUpdateNameMutation,
  PartnerUpdateNameMutationVariables
>

/**
 * __usePartnerUpdateNameMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateNameMutation, { data, loading, error }] = usePartnerUpdateNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateNameMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateNameMutation,
    PartnerUpdateNameMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateNameMutation,
    PartnerUpdateNameMutationVariables
  >(PartnerUpdateNameDocument, options)
}
export type PartnerUpdateNameMutationHookResult = ReturnType<
  typeof usePartnerUpdateNameMutation
>
export type PartnerUpdateNameMutationResult =
  Apollo.MutationResult<PartnerUpdateNameMutation>
export type PartnerUpdateNameMutationOptions = Apollo.BaseMutationOptions<
  PartnerUpdateNameMutation,
  PartnerUpdateNameMutationVariables
>
export const PartnerGetPartnerAutopayConfigDocument = /*#__PURE__*/ gql`
  query PartnerGetPartnerAutopayConfig {
    PartnerGetPartnerAutopayConfig {
      id
      allowCustomerEdit
    }
  }
`

/**
 * __usePartnerGetPartnerAutopayConfigQuery__
 *
 * To run a query within a React component, call `usePartnerGetPartnerAutopayConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetPartnerAutopayConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetPartnerAutopayConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerGetPartnerAutopayConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetPartnerAutopayConfigQuery,
    PartnerGetPartnerAutopayConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetPartnerAutopayConfigQuery,
    PartnerGetPartnerAutopayConfigQueryVariables
  >(PartnerGetPartnerAutopayConfigDocument, options)
}
export function usePartnerGetPartnerAutopayConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetPartnerAutopayConfigQuery,
    PartnerGetPartnerAutopayConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetPartnerAutopayConfigQuery,
    PartnerGetPartnerAutopayConfigQueryVariables
  >(PartnerGetPartnerAutopayConfigDocument, options)
}
export type PartnerGetPartnerAutopayConfigQueryHookResult = ReturnType<
  typeof usePartnerGetPartnerAutopayConfigQuery
>
export type PartnerGetPartnerAutopayConfigLazyQueryHookResult = ReturnType<
  typeof usePartnerGetPartnerAutopayConfigLazyQuery
>
export type PartnerGetPartnerAutopayConfigQueryResult = Apollo.QueryResult<
  PartnerGetPartnerAutopayConfigQuery,
  PartnerGetPartnerAutopayConfigQueryVariables
>
export const PartnerChangePartnerAutopayConfigDocument = /*#__PURE__*/ gql`
  mutation PartnerChangePartnerAutopayConfig(
    $partnerAutopayConfig: PartnerAutopayConfigUpdateInput!
  ) {
    PartnerChangePartnerAutopayConfig(
      partnerAutopayConfig: $partnerAutopayConfig
    )
  }
`
export type PartnerChangePartnerAutopayConfigMutationFn =
  Apollo.MutationFunction<
    PartnerChangePartnerAutopayConfigMutation,
    PartnerChangePartnerAutopayConfigMutationVariables
  >

/**
 * __usePartnerChangePartnerAutopayConfigMutation__
 *
 * To run a mutation, you first call `usePartnerChangePartnerAutopayConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerChangePartnerAutopayConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerChangePartnerAutopayConfigMutation, { data, loading, error }] = usePartnerChangePartnerAutopayConfigMutation({
 *   variables: {
 *      partnerAutopayConfig: // value for 'partnerAutopayConfig'
 *   },
 * });
 */
export function usePartnerChangePartnerAutopayConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerChangePartnerAutopayConfigMutation,
    PartnerChangePartnerAutopayConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerChangePartnerAutopayConfigMutation,
    PartnerChangePartnerAutopayConfigMutationVariables
  >(PartnerChangePartnerAutopayConfigDocument, options)
}
export type PartnerChangePartnerAutopayConfigMutationHookResult = ReturnType<
  typeof usePartnerChangePartnerAutopayConfigMutation
>
export type PartnerChangePartnerAutopayConfigMutationResult =
  Apollo.MutationResult<PartnerChangePartnerAutopayConfigMutation>
export type PartnerChangePartnerAutopayConfigMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerChangePartnerAutopayConfigMutation,
    PartnerChangePartnerAutopayConfigMutationVariables
  >
export const PartnerCancelScheduledPaymentDocument = /*#__PURE__*/ gql`
  mutation PartnerCancelScheduledPayment($paymentID: UUID!) {
    PartnerCancelScheduledPayment(paymentID: $paymentID)
  }
`
export type PartnerCancelScheduledPaymentMutationFn = Apollo.MutationFunction<
  PartnerCancelScheduledPaymentMutation,
  PartnerCancelScheduledPaymentMutationVariables
>

/**
 * __usePartnerCancelScheduledPaymentMutation__
 *
 * To run a mutation, you first call `usePartnerCancelScheduledPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCancelScheduledPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCancelScheduledPaymentMutation, { data, loading, error }] = usePartnerCancelScheduledPaymentMutation({
 *   variables: {
 *      paymentID: // value for 'paymentID'
 *   },
 * });
 */
export function usePartnerCancelScheduledPaymentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCancelScheduledPaymentMutation,
    PartnerCancelScheduledPaymentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCancelScheduledPaymentMutation,
    PartnerCancelScheduledPaymentMutationVariables
  >(PartnerCancelScheduledPaymentDocument, options)
}
export type PartnerCancelScheduledPaymentMutationHookResult = ReturnType<
  typeof usePartnerCancelScheduledPaymentMutation
>
export type PartnerCancelScheduledPaymentMutationResult =
  Apollo.MutationResult<PartnerCancelScheduledPaymentMutation>
export type PartnerCancelScheduledPaymentMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCancelScheduledPaymentMutation,
    PartnerCancelScheduledPaymentMutationVariables
  >
export const PartnerReschedulePaymentDocument = /*#__PURE__*/ gql`
  mutation PartnerReschedulePayment($paymentID: UUID!, $newDueDate: Time!) {
    PartnerReschedulePayment(paymentID: $paymentID, newDueDate: $newDueDate)
  }
`
export type PartnerReschedulePaymentMutationFn = Apollo.MutationFunction<
  PartnerReschedulePaymentMutation,
  PartnerReschedulePaymentMutationVariables
>

/**
 * __usePartnerReschedulePaymentMutation__
 *
 * To run a mutation, you first call `usePartnerReschedulePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerReschedulePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerReschedulePaymentMutation, { data, loading, error }] = usePartnerReschedulePaymentMutation({
 *   variables: {
 *      paymentID: // value for 'paymentID'
 *      newDueDate: // value for 'newDueDate'
 *   },
 * });
 */
export function usePartnerReschedulePaymentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerReschedulePaymentMutation,
    PartnerReschedulePaymentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerReschedulePaymentMutation,
    PartnerReschedulePaymentMutationVariables
  >(PartnerReschedulePaymentDocument, options)
}
export type PartnerReschedulePaymentMutationHookResult = ReturnType<
  typeof usePartnerReschedulePaymentMutation
>
export type PartnerReschedulePaymentMutationResult =
  Apollo.MutationResult<PartnerReschedulePaymentMutation>
export type PartnerReschedulePaymentMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerReschedulePaymentMutation,
    PartnerReschedulePaymentMutationVariables
  >
export const PartnerPaymentConnectionDocument = /*#__PURE__*/ gql`
  query PartnerPaymentConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $paymentFilter: PaymentFilter
    $orderBy: PaymentOrder
  ) {
    PartnerPaymentConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      paymentFilter: $paymentFilter
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...PartnerPayment
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
  ${PartnerPaymentFragmentDoc}
`

/**
 * __usePartnerPaymentConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerPaymentConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerPaymentConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerPaymentConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      paymentFilter: // value for 'paymentFilter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerPaymentConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerPaymentConnectionQuery,
    PartnerPaymentConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerPaymentConnectionQuery,
    PartnerPaymentConnectionQueryVariables
  >(PartnerPaymentConnectionDocument, options)
}
export function usePartnerPaymentConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerPaymentConnectionQuery,
    PartnerPaymentConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerPaymentConnectionQuery,
    PartnerPaymentConnectionQueryVariables
  >(PartnerPaymentConnectionDocument, options)
}
export type PartnerPaymentConnectionQueryHookResult = ReturnType<
  typeof usePartnerPaymentConnectionQuery
>
export type PartnerPaymentConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerPaymentConnectionLazyQuery
>
export type PartnerPaymentConnectionQueryResult = Apollo.QueryResult<
  PartnerPaymentConnectionQuery,
  PartnerPaymentConnectionQueryVariables
>
export const PartnerPaymentTotalsDocument = /*#__PURE__*/ gql`
  query PartnerPaymentTotals($paymentFilter: PaymentFilter) {
    PartnerPaymentTotals(paymentFilter: $paymentFilter) {
      count
      amount
      netAmount
    }
  }
`

/**
 * __usePartnerPaymentTotalsQuery__
 *
 * To run a query within a React component, call `usePartnerPaymentTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerPaymentTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerPaymentTotalsQuery({
 *   variables: {
 *      paymentFilter: // value for 'paymentFilter'
 *   },
 * });
 */
export function usePartnerPaymentTotalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerPaymentTotalsQuery,
    PartnerPaymentTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerPaymentTotalsQuery,
    PartnerPaymentTotalsQueryVariables
  >(PartnerPaymentTotalsDocument, options)
}
export function usePartnerPaymentTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerPaymentTotalsQuery,
    PartnerPaymentTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerPaymentTotalsQuery,
    PartnerPaymentTotalsQueryVariables
  >(PartnerPaymentTotalsDocument, options)
}
export type PartnerPaymentTotalsQueryHookResult = ReturnType<
  typeof usePartnerPaymentTotalsQuery
>
export type PartnerPaymentTotalsLazyQueryHookResult = ReturnType<
  typeof usePartnerPaymentTotalsLazyQuery
>
export type PartnerPaymentTotalsQueryResult = Apollo.QueryResult<
  PartnerPaymentTotalsQuery,
  PartnerPaymentTotalsQueryVariables
>
export const PartnerGetCustomerPaymentConfigDocument = /*#__PURE__*/ gql`
  query PartnerGetCustomerPaymentConfig($customerID: ID!) {
    PartnerGetCustomerPaymentConfig(customerID: $customerID) {
      ...CustomerPaymentMethod
    }
  }
  ${CustomerPaymentMethodFragmentDoc}
`

/**
 * __usePartnerGetCustomerPaymentConfigQuery__
 *
 * To run a query within a React component, call `usePartnerGetCustomerPaymentConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetCustomerPaymentConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetCustomerPaymentConfigQuery({
 *   variables: {
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerGetCustomerPaymentConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetCustomerPaymentConfigQuery,
    PartnerGetCustomerPaymentConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetCustomerPaymentConfigQuery,
    PartnerGetCustomerPaymentConfigQueryVariables
  >(PartnerGetCustomerPaymentConfigDocument, options)
}
export function usePartnerGetCustomerPaymentConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetCustomerPaymentConfigQuery,
    PartnerGetCustomerPaymentConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetCustomerPaymentConfigQuery,
    PartnerGetCustomerPaymentConfigQueryVariables
  >(PartnerGetCustomerPaymentConfigDocument, options)
}
export type PartnerGetCustomerPaymentConfigQueryHookResult = ReturnType<
  typeof usePartnerGetCustomerPaymentConfigQuery
>
export type PartnerGetCustomerPaymentConfigLazyQueryHookResult = ReturnType<
  typeof usePartnerGetCustomerPaymentConfigLazyQuery
>
export type PartnerGetCustomerPaymentConfigQueryResult = Apollo.QueryResult<
  PartnerGetCustomerPaymentConfigQuery,
  PartnerGetCustomerPaymentConfigQueryVariables
>
export const PartnerGetCustomersPaymentConfigDocument = /*#__PURE__*/ gql`
  query PartnerGetCustomersPaymentConfig($customerIDs: [ID!]) {
    PartnerGetCustomersPaymentConfig(customerIDs: $customerIDs) {
      ...CustomersPaymentMethod
    }
  }
  ${CustomersPaymentMethodFragmentDoc}
`

/**
 * __usePartnerGetCustomersPaymentConfigQuery__
 *
 * To run a query within a React component, call `usePartnerGetCustomersPaymentConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetCustomersPaymentConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetCustomersPaymentConfigQuery({
 *   variables: {
 *      customerIDs: // value for 'customerIDs'
 *   },
 * });
 */
export function usePartnerGetCustomersPaymentConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetCustomersPaymentConfigQuery,
    PartnerGetCustomersPaymentConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetCustomersPaymentConfigQuery,
    PartnerGetCustomersPaymentConfigQueryVariables
  >(PartnerGetCustomersPaymentConfigDocument, options)
}
export function usePartnerGetCustomersPaymentConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetCustomersPaymentConfigQuery,
    PartnerGetCustomersPaymentConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetCustomersPaymentConfigQuery,
    PartnerGetCustomersPaymentConfigQueryVariables
  >(PartnerGetCustomersPaymentConfigDocument, options)
}
export type PartnerGetCustomersPaymentConfigQueryHookResult = ReturnType<
  typeof usePartnerGetCustomersPaymentConfigQuery
>
export type PartnerGetCustomersPaymentConfigLazyQueryHookResult = ReturnType<
  typeof usePartnerGetCustomersPaymentConfigLazyQuery
>
export type PartnerGetCustomersPaymentConfigQueryResult = Apollo.QueryResult<
  PartnerGetCustomersPaymentConfigQuery,
  PartnerGetCustomersPaymentConfigQueryVariables
>
export const PartnerGetPaymentConfigDocument = /*#__PURE__*/ gql`
  query PartnerGetPaymentConfig {
    PartnerGetPaymentConfig {
      ...PaymentConfig
    }
  }
  ${PaymentConfigFragmentDoc}
`

/**
 * __usePartnerGetPaymentConfigQuery__
 *
 * To run a query within a React component, call `usePartnerGetPaymentConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetPaymentConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetPaymentConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerGetPaymentConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetPaymentConfigQuery,
    PartnerGetPaymentConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetPaymentConfigQuery,
    PartnerGetPaymentConfigQueryVariables
  >(PartnerGetPaymentConfigDocument, options)
}
export function usePartnerGetPaymentConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetPaymentConfigQuery,
    PartnerGetPaymentConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetPaymentConfigQuery,
    PartnerGetPaymentConfigQueryVariables
  >(PartnerGetPaymentConfigDocument, options)
}
export type PartnerGetPaymentConfigQueryHookResult = ReturnType<
  typeof usePartnerGetPaymentConfigQuery
>
export type PartnerGetPaymentConfigLazyQueryHookResult = ReturnType<
  typeof usePartnerGetPaymentConfigLazyQuery
>
export type PartnerGetPaymentConfigQueryResult = Apollo.QueryResult<
  PartnerGetPaymentConfigQuery,
  PartnerGetPaymentConfigQueryVariables
>
export const PartnerChangePaymentConfigDocument = /*#__PURE__*/ gql`
  mutation PartnerChangePaymentConfig(
    $paymentConfig: PaymentCompanyConfigUpdateInput!
  ) {
    PartnerChangePaymentConfig(paymentConfig: $paymentConfig)
  }
`
export type PartnerChangePaymentConfigMutationFn = Apollo.MutationFunction<
  PartnerChangePaymentConfigMutation,
  PartnerChangePaymentConfigMutationVariables
>

/**
 * __usePartnerChangePaymentConfigMutation__
 *
 * To run a mutation, you first call `usePartnerChangePaymentConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerChangePaymentConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerChangePaymentConfigMutation, { data, loading, error }] = usePartnerChangePaymentConfigMutation({
 *   variables: {
 *      paymentConfig: // value for 'paymentConfig'
 *   },
 * });
 */
export function usePartnerChangePaymentConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerChangePaymentConfigMutation,
    PartnerChangePaymentConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerChangePaymentConfigMutation,
    PartnerChangePaymentConfigMutationVariables
  >(PartnerChangePaymentConfigDocument, options)
}
export type PartnerChangePaymentConfigMutationHookResult = ReturnType<
  typeof usePartnerChangePaymentConfigMutation
>
export type PartnerChangePaymentConfigMutationResult =
  Apollo.MutationResult<PartnerChangePaymentConfigMutation>
export type PartnerChangePaymentConfigMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerChangePaymentConfigMutation,
    PartnerChangePaymentConfigMutationVariables
  >
export const PartnerChangeCustomerPaymentConfigDocument = /*#__PURE__*/ gql`
  mutation PartnerChangeCustomerPaymentConfig(
    $paymentConfig: PaymentCompanyConfigUpdateInput!
    $customerID: ID!
  ) {
    PartnerChangeCustomerPaymentConfig(
      paymentConfig: $paymentConfig
      customerID: $customerID
    )
  }
`
export type PartnerChangeCustomerPaymentConfigMutationFn =
  Apollo.MutationFunction<
    PartnerChangeCustomerPaymentConfigMutation,
    PartnerChangeCustomerPaymentConfigMutationVariables
  >

/**
 * __usePartnerChangeCustomerPaymentConfigMutation__
 *
 * To run a mutation, you first call `usePartnerChangeCustomerPaymentConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerChangeCustomerPaymentConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerChangeCustomerPaymentConfigMutation, { data, loading, error }] = usePartnerChangeCustomerPaymentConfigMutation({
 *   variables: {
 *      paymentConfig: // value for 'paymentConfig'
 *      customerID: // value for 'customerID'
 *   },
 * });
 */
export function usePartnerChangeCustomerPaymentConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerChangeCustomerPaymentConfigMutation,
    PartnerChangeCustomerPaymentConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerChangeCustomerPaymentConfigMutation,
    PartnerChangeCustomerPaymentConfigMutationVariables
  >(PartnerChangeCustomerPaymentConfigDocument, options)
}
export type PartnerChangeCustomerPaymentConfigMutationHookResult = ReturnType<
  typeof usePartnerChangeCustomerPaymentConfigMutation
>
export type PartnerChangeCustomerPaymentConfigMutationResult =
  Apollo.MutationResult<PartnerChangeCustomerPaymentConfigMutation>
export type PartnerChangeCustomerPaymentConfigMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerChangeCustomerPaymentConfigMutation,
    PartnerChangeCustomerPaymentConfigMutationVariables
  >
export const GetLogoUploadUrlDocument = /*#__PURE__*/ gql`
  query GetLogoUploadURL {
    PartnerLogoUploadURL {
      uploadURL
      uploadCDNURL
      uploadURLExpirationUTC
    }
  }
`

/**
 * __useGetLogoUploadUrlQuery__
 *
 * To run a query within a React component, call `useGetLogoUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLogoUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLogoUploadUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLogoUploadUrlQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetLogoUploadUrlQuery,
    GetLogoUploadUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetLogoUploadUrlQuery, GetLogoUploadUrlQueryVariables>(
    GetLogoUploadUrlDocument,
    options
  )
}
export function useGetLogoUploadUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLogoUploadUrlQuery,
    GetLogoUploadUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetLogoUploadUrlQuery,
    GetLogoUploadUrlQueryVariables
  >(GetLogoUploadUrlDocument, options)
}
export type GetLogoUploadUrlQueryHookResult = ReturnType<
  typeof useGetLogoUploadUrlQuery
>
export type GetLogoUploadUrlLazyQueryHookResult = ReturnType<
  typeof useGetLogoUploadUrlLazyQuery
>
export type GetLogoUploadUrlQueryResult = Apollo.QueryResult<
  GetLogoUploadUrlQuery,
  GetLogoUploadUrlQueryVariables
>
export const PartnerUpdatePaymentsPortalMethodsDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdatePaymentsPortalMethods(
    $methods: [PartnerPaymentsPortalMethod!]!
  ) {
    PartnerUpdatePaymentsPortalMethods(methods: $methods) {
      id
      paymentsPortalMethods
    }
  }
`
export type PartnerUpdatePaymentsPortalMethodsMutationFn =
  Apollo.MutationFunction<
    PartnerUpdatePaymentsPortalMethodsMutation,
    PartnerUpdatePaymentsPortalMethodsMutationVariables
  >

/**
 * __usePartnerUpdatePaymentsPortalMethodsMutation__
 *
 * To run a mutation, you first call `usePartnerUpdatePaymentsPortalMethodsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdatePaymentsPortalMethodsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdatePaymentsPortalMethodsMutation, { data, loading, error }] = usePartnerUpdatePaymentsPortalMethodsMutation({
 *   variables: {
 *      methods: // value for 'methods'
 *   },
 * });
 */
export function usePartnerUpdatePaymentsPortalMethodsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdatePaymentsPortalMethodsMutation,
    PartnerUpdatePaymentsPortalMethodsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdatePaymentsPortalMethodsMutation,
    PartnerUpdatePaymentsPortalMethodsMutationVariables
  >(PartnerUpdatePaymentsPortalMethodsDocument, options)
}
export type PartnerUpdatePaymentsPortalMethodsMutationHookResult = ReturnType<
  typeof usePartnerUpdatePaymentsPortalMethodsMutation
>
export type PartnerUpdatePaymentsPortalMethodsMutationResult =
  Apollo.MutationResult<PartnerUpdatePaymentsPortalMethodsMutation>
export type PartnerUpdatePaymentsPortalMethodsMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdatePaymentsPortalMethodsMutation,
    PartnerUpdatePaymentsPortalMethodsMutationVariables
  >
export const PartnerUpdatePaymentsPortalCustomizationDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdatePaymentsPortalCustomization(
    $input: PartnerPaymentsPortalCustomizationInput
  ) {
    PartnerUpdatePaymentsPortalCustomization(input: $input) {
      id
      paymentsPortalCustomization {
        color
        logoUrl
      }
    }
  }
`
export type PartnerUpdatePaymentsPortalCustomizationMutationFn =
  Apollo.MutationFunction<
    PartnerUpdatePaymentsPortalCustomizationMutation,
    PartnerUpdatePaymentsPortalCustomizationMutationVariables
  >

/**
 * __usePartnerUpdatePaymentsPortalCustomizationMutation__
 *
 * To run a mutation, you first call `usePartnerUpdatePaymentsPortalCustomizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdatePaymentsPortalCustomizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdatePaymentsPortalCustomizationMutation, { data, loading, error }] = usePartnerUpdatePaymentsPortalCustomizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdatePaymentsPortalCustomizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdatePaymentsPortalCustomizationMutation,
    PartnerUpdatePaymentsPortalCustomizationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdatePaymentsPortalCustomizationMutation,
    PartnerUpdatePaymentsPortalCustomizationMutationVariables
  >(PartnerUpdatePaymentsPortalCustomizationDocument, options)
}
export type PartnerUpdatePaymentsPortalCustomizationMutationHookResult =
  ReturnType<typeof usePartnerUpdatePaymentsPortalCustomizationMutation>
export type PartnerUpdatePaymentsPortalCustomizationMutationResult =
  Apollo.MutationResult<PartnerUpdatePaymentsPortalCustomizationMutation>
export type PartnerUpdatePaymentsPortalCustomizationMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUpdatePaymentsPortalCustomizationMutation,
    PartnerUpdatePaymentsPortalCustomizationMutationVariables
  >
export const StagingEnablePartnerPaymentsPortalDocument = /*#__PURE__*/ gql`
  mutation StagingEnablePartnerPaymentsPortal($url: String!) {
    StagingEnablePartnerPaymentsPortal(url: $url) {
      id
      name
      paymentsPortalEnabled
      paymentsPortalUrl
    }
  }
`
export type StagingEnablePartnerPaymentsPortalMutationFn =
  Apollo.MutationFunction<
    StagingEnablePartnerPaymentsPortalMutation,
    StagingEnablePartnerPaymentsPortalMutationVariables
  >

/**
 * __useStagingEnablePartnerPaymentsPortalMutation__
 *
 * To run a mutation, you first call `useStagingEnablePartnerPaymentsPortalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStagingEnablePartnerPaymentsPortalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stagingEnablePartnerPaymentsPortalMutation, { data, loading, error }] = useStagingEnablePartnerPaymentsPortalMutation({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useStagingEnablePartnerPaymentsPortalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StagingEnablePartnerPaymentsPortalMutation,
    StagingEnablePartnerPaymentsPortalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    StagingEnablePartnerPaymentsPortalMutation,
    StagingEnablePartnerPaymentsPortalMutationVariables
  >(StagingEnablePartnerPaymentsPortalDocument, options)
}
export type StagingEnablePartnerPaymentsPortalMutationHookResult = ReturnType<
  typeof useStagingEnablePartnerPaymentsPortalMutation
>
export type StagingEnablePartnerPaymentsPortalMutationResult =
  Apollo.MutationResult<StagingEnablePartnerPaymentsPortalMutation>
export type StagingEnablePartnerPaymentsPortalMutationOptions =
  Apollo.BaseMutationOptions<
    StagingEnablePartnerPaymentsPortalMutation,
    StagingEnablePartnerPaymentsPortalMutationVariables
  >
export const PartnerPayoutConnectionDocument = /*#__PURE__*/ gql`
  query PartnerPayoutConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $payoutFilter: PayoutFilter
    $orderBy: PayoutOrder
  ) {
    PartnerPayoutConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      payoutFilter: $payoutFilter
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...PartnerPayout
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerPayoutFragmentDoc}
`

/**
 * __usePartnerPayoutConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerPayoutConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerPayoutConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerPayoutConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      payoutFilter: // value for 'payoutFilter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerPayoutConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerPayoutConnectionQuery,
    PartnerPayoutConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerPayoutConnectionQuery,
    PartnerPayoutConnectionQueryVariables
  >(PartnerPayoutConnectionDocument, options)
}
export function usePartnerPayoutConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerPayoutConnectionQuery,
    PartnerPayoutConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerPayoutConnectionQuery,
    PartnerPayoutConnectionQueryVariables
  >(PartnerPayoutConnectionDocument, options)
}
export type PartnerPayoutConnectionQueryHookResult = ReturnType<
  typeof usePartnerPayoutConnectionQuery
>
export type PartnerPayoutConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerPayoutConnectionLazyQuery
>
export type PartnerPayoutConnectionQueryResult = Apollo.QueryResult<
  PartnerPayoutConnectionQuery,
  PartnerPayoutConnectionQueryVariables
>
export const PartnerPayoutTotalsDocument = /*#__PURE__*/ gql`
  query PartnerPayoutTotals($payoutFilter: PayoutFilter) {
    PartnerPayoutTotals(payoutFilter: $payoutFilter) {
      count
      amount
    }
  }
`

/**
 * __usePartnerPayoutTotalsQuery__
 *
 * To run a query within a React component, call `usePartnerPayoutTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerPayoutTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerPayoutTotalsQuery({
 *   variables: {
 *      payoutFilter: // value for 'payoutFilter'
 *   },
 * });
 */
export function usePartnerPayoutTotalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerPayoutTotalsQuery,
    PartnerPayoutTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerPayoutTotalsQuery,
    PartnerPayoutTotalsQueryVariables
  >(PartnerPayoutTotalsDocument, options)
}
export function usePartnerPayoutTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerPayoutTotalsQuery,
    PartnerPayoutTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerPayoutTotalsQuery,
    PartnerPayoutTotalsQueryVariables
  >(PartnerPayoutTotalsDocument, options)
}
export type PartnerPayoutTotalsQueryHookResult = ReturnType<
  typeof usePartnerPayoutTotalsQuery
>
export type PartnerPayoutTotalsLazyQueryHookResult = ReturnType<
  typeof usePartnerPayoutTotalsLazyQuery
>
export type PartnerPayoutTotalsQueryResult = Apollo.QueryResult<
  PartnerPayoutTotalsQuery,
  PartnerPayoutTotalsQueryVariables
>
export const PartnerPayoutDetailsDocument = /*#__PURE__*/ gql`
  query PartnerPayoutDetails($payoutID: ID!) {
    PartnerPayoutDetails(payoutID: $payoutID) {
      ...PartnerPayoutDetails
    }
  }
  ${PartnerPayoutDetailsFragmentDoc}
`

/**
 * __usePartnerPayoutDetailsQuery__
 *
 * To run a query within a React component, call `usePartnerPayoutDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerPayoutDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerPayoutDetailsQuery({
 *   variables: {
 *      payoutID: // value for 'payoutID'
 *   },
 * });
 */
export function usePartnerPayoutDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerPayoutDetailsQuery,
    PartnerPayoutDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerPayoutDetailsQuery,
    PartnerPayoutDetailsQueryVariables
  >(PartnerPayoutDetailsDocument, options)
}
export function usePartnerPayoutDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerPayoutDetailsQuery,
    PartnerPayoutDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerPayoutDetailsQuery,
    PartnerPayoutDetailsQueryVariables
  >(PartnerPayoutDetailsDocument, options)
}
export type PartnerPayoutDetailsQueryHookResult = ReturnType<
  typeof usePartnerPayoutDetailsQuery
>
export type PartnerPayoutDetailsLazyQueryHookResult = ReturnType<
  typeof usePartnerPayoutDetailsLazyQuery
>
export type PartnerPayoutDetailsQueryResult = Apollo.QueryResult<
  PartnerPayoutDetailsQuery,
  PartnerPayoutDetailsQueryVariables
>
export const PartnerBreakdownListItemConnectionDocument = /*#__PURE__*/ gql`
  query PartnerBreakdownListItemConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $breakdownFilter: BreakdownFilter
  ) {
    PartnerPayoutBreakdownListItemConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      breakdownFilter: $breakdownFilter
    ) {
      edges {
        node {
          ...PartnerBreakdownListItem
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerBreakdownListItemFragmentDoc}
`

/**
 * __usePartnerBreakdownListItemConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerBreakdownListItemConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerBreakdownListItemConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerBreakdownListItemConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      breakdownFilter: // value for 'breakdownFilter'
 *   },
 * });
 */
export function usePartnerBreakdownListItemConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerBreakdownListItemConnectionQuery,
    PartnerBreakdownListItemConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerBreakdownListItemConnectionQuery,
    PartnerBreakdownListItemConnectionQueryVariables
  >(PartnerBreakdownListItemConnectionDocument, options)
}
export function usePartnerBreakdownListItemConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerBreakdownListItemConnectionQuery,
    PartnerBreakdownListItemConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerBreakdownListItemConnectionQuery,
    PartnerBreakdownListItemConnectionQueryVariables
  >(PartnerBreakdownListItemConnectionDocument, options)
}
export type PartnerBreakdownListItemConnectionQueryHookResult = ReturnType<
  typeof usePartnerBreakdownListItemConnectionQuery
>
export type PartnerBreakdownListItemConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerBreakdownListItemConnectionLazyQuery
>
export type PartnerBreakdownListItemConnectionQueryResult = Apollo.QueryResult<
  PartnerBreakdownListItemConnectionQuery,
  PartnerBreakdownListItemConnectionQueryVariables
>
export const GetPayoutConfigDocument = /*#__PURE__*/ gql`
  query GetPayoutConfig {
    PartnerGetPayoutConfig {
      id
      defaultBankingAccount {
        id
      }
    }
  }
`

/**
 * __useGetPayoutConfigQuery__
 *
 * To run a query within a React component, call `useGetPayoutConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPayoutConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPayoutConfigQuery,
    GetPayoutConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPayoutConfigQuery, GetPayoutConfigQueryVariables>(
    GetPayoutConfigDocument,
    options
  )
}
export function useGetPayoutConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPayoutConfigQuery,
    GetPayoutConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetPayoutConfigQuery,
    GetPayoutConfigQueryVariables
  >(GetPayoutConfigDocument, options)
}
export type GetPayoutConfigQueryHookResult = ReturnType<
  typeof useGetPayoutConfigQuery
>
export type GetPayoutConfigLazyQueryHookResult = ReturnType<
  typeof useGetPayoutConfigLazyQuery
>
export type GetPayoutConfigQueryResult = Apollo.QueryResult<
  GetPayoutConfigQuery,
  GetPayoutConfigQueryVariables
>
export const GetReferralPayoutConfigDocument = /*#__PURE__*/ gql`
  query GetReferralPayoutConfig {
    PartnerGetPayoutConfig {
      id
      referralBankingAccount {
        id
      }
      defaultBankingAccount {
        id
      }
    }
  }
`

/**
 * __useGetReferralPayoutConfigQuery__
 *
 * To run a query within a React component, call `useGetReferralPayoutConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferralPayoutConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferralPayoutConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReferralPayoutConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetReferralPayoutConfigQuery,
    GetReferralPayoutConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetReferralPayoutConfigQuery,
    GetReferralPayoutConfigQueryVariables
  >(GetReferralPayoutConfigDocument, options)
}
export function useGetReferralPayoutConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReferralPayoutConfigQuery,
    GetReferralPayoutConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetReferralPayoutConfigQuery,
    GetReferralPayoutConfigQueryVariables
  >(GetReferralPayoutConfigDocument, options)
}
export type GetReferralPayoutConfigQueryHookResult = ReturnType<
  typeof useGetReferralPayoutConfigQuery
>
export type GetReferralPayoutConfigLazyQueryHookResult = ReturnType<
  typeof useGetReferralPayoutConfigLazyQuery
>
export type GetReferralPayoutConfigQueryResult = Apollo.QueryResult<
  GetReferralPayoutConfigQuery,
  GetReferralPayoutConfigQueryVariables
>
export const GetPayoutTimingConfigDocument = /*#__PURE__*/ gql`
  query GetPayoutTimingConfig {
    PartnerGetPayoutTimingCompanyConfig {
      activeConfig {
        canCompanyChange
        effectiveAt
        activatedAt
        payoutTimingPlanID
        businessDaysToHold
        payoutTimingFee {
          fixedFee
          percentageFee
          capFee
        }
      }
      upcomingConfig {
        canCompanyChange
        effectiveAt
        activatedAt
        payoutTimingPlanID
        businessDaysToHold
        payoutTimingFee {
          fixedFee
          percentageFee
          capFee
        }
      }
    }
    PartnerGetPayoutTimingPlans {
      id
      businessDaysToHold
      payoutTimingFee {
        fixedFee
        percentageFee
        capFee
      }
    }
  }
`

/**
 * __useGetPayoutTimingConfigQuery__
 *
 * To run a query within a React component, call `useGetPayoutTimingConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutTimingConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutTimingConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPayoutTimingConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPayoutTimingConfigQuery,
    GetPayoutTimingConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetPayoutTimingConfigQuery,
    GetPayoutTimingConfigQueryVariables
  >(GetPayoutTimingConfigDocument, options)
}
export function useGetPayoutTimingConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPayoutTimingConfigQuery,
    GetPayoutTimingConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetPayoutTimingConfigQuery,
    GetPayoutTimingConfigQueryVariables
  >(GetPayoutTimingConfigDocument, options)
}
export type GetPayoutTimingConfigQueryHookResult = ReturnType<
  typeof useGetPayoutTimingConfigQuery
>
export type GetPayoutTimingConfigLazyQueryHookResult = ReturnType<
  typeof useGetPayoutTimingConfigLazyQuery
>
export type GetPayoutTimingConfigQueryResult = Apollo.QueryResult<
  GetPayoutTimingConfigQuery,
  GetPayoutTimingConfigQueryVariables
>
export const UpdatePayoutTimingConfigDocument = /*#__PURE__*/ gql`
  mutation UpdatePayoutTimingConfig($planID: ID!) {
    PartnerPayoutTimingUpsertCompanyConfig(planId: $planID)
  }
`
export type UpdatePayoutTimingConfigMutationFn = Apollo.MutationFunction<
  UpdatePayoutTimingConfigMutation,
  UpdatePayoutTimingConfigMutationVariables
>

/**
 * __useUpdatePayoutTimingConfigMutation__
 *
 * To run a mutation, you first call `useUpdatePayoutTimingConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePayoutTimingConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePayoutTimingConfigMutation, { data, loading, error }] = useUpdatePayoutTimingConfigMutation({
 *   variables: {
 *      planID: // value for 'planID'
 *   },
 * });
 */
export function useUpdatePayoutTimingConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePayoutTimingConfigMutation,
    UpdatePayoutTimingConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdatePayoutTimingConfigMutation,
    UpdatePayoutTimingConfigMutationVariables
  >(UpdatePayoutTimingConfigDocument, options)
}
export type UpdatePayoutTimingConfigMutationHookResult = ReturnType<
  typeof useUpdatePayoutTimingConfigMutation
>
export type UpdatePayoutTimingConfigMutationResult =
  Apollo.MutationResult<UpdatePayoutTimingConfigMutation>
export type UpdatePayoutTimingConfigMutationOptions =
  Apollo.BaseMutationOptions<
    UpdatePayoutTimingConfigMutation,
    UpdatePayoutTimingConfigMutationVariables
  >
export const PartnerListPendingCustomerUsersTotalsDocument = /*#__PURE__*/ gql`
  query PartnerListPendingCustomerUsersTotals {
    PartnerListPendingCustomerUsersTotals {
      count
    }
  }
`

/**
 * __usePartnerListPendingCustomerUsersTotalsQuery__
 *
 * To run a query within a React component, call `usePartnerListPendingCustomerUsersTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListPendingCustomerUsersTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListPendingCustomerUsersTotalsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerListPendingCustomerUsersTotalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListPendingCustomerUsersTotalsQuery,
    PartnerListPendingCustomerUsersTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListPendingCustomerUsersTotalsQuery,
    PartnerListPendingCustomerUsersTotalsQueryVariables
  >(PartnerListPendingCustomerUsersTotalsDocument, options)
}
export function usePartnerListPendingCustomerUsersTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListPendingCustomerUsersTotalsQuery,
    PartnerListPendingCustomerUsersTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListPendingCustomerUsersTotalsQuery,
    PartnerListPendingCustomerUsersTotalsQueryVariables
  >(PartnerListPendingCustomerUsersTotalsDocument, options)
}
export type PartnerListPendingCustomerUsersTotalsQueryHookResult = ReturnType<
  typeof usePartnerListPendingCustomerUsersTotalsQuery
>
export type PartnerListPendingCustomerUsersTotalsLazyQueryHookResult =
  ReturnType<typeof usePartnerListPendingCustomerUsersTotalsLazyQuery>
export type PartnerListPendingCustomerUsersTotalsQueryResult =
  Apollo.QueryResult<
    PartnerListPendingCustomerUsersTotalsQuery,
    PartnerListPendingCustomerUsersTotalsQueryVariables
  >
export const PartnerPendingCustomerUserConnectionDocument = /*#__PURE__*/ gql`
  query PartnerPendingCustomerUserConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: PendingCustomerUserFilters
    $orderBy: PendingCustomerUserOrderBy
  ) {
    PartnerPendingCustomerUserConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...PartnerListPendingCustomerUser
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerListPendingCustomerUserFragmentDoc}
`

/**
 * __usePartnerPendingCustomerUserConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerPendingCustomerUserConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerPendingCustomerUserConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerPendingCustomerUserConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerPendingCustomerUserConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerPendingCustomerUserConnectionQuery,
    PartnerPendingCustomerUserConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerPendingCustomerUserConnectionQuery,
    PartnerPendingCustomerUserConnectionQueryVariables
  >(PartnerPendingCustomerUserConnectionDocument, options)
}
export function usePartnerPendingCustomerUserConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerPendingCustomerUserConnectionQuery,
    PartnerPendingCustomerUserConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerPendingCustomerUserConnectionQuery,
    PartnerPendingCustomerUserConnectionQueryVariables
  >(PartnerPendingCustomerUserConnectionDocument, options)
}
export type PartnerPendingCustomerUserConnectionQueryHookResult = ReturnType<
  typeof usePartnerPendingCustomerUserConnectionQuery
>
export type PartnerPendingCustomerUserConnectionLazyQueryHookResult =
  ReturnType<typeof usePartnerPendingCustomerUserConnectionLazyQuery>
export type PartnerPendingCustomerUserConnectionQueryResult =
  Apollo.QueryResult<
    PartnerPendingCustomerUserConnectionQuery,
    PartnerPendingCustomerUserConnectionQueryVariables
  >
export const PartnerRejectPendingCustomerUserDocument = /*#__PURE__*/ gql`
  mutation PartnerRejectPendingCustomerUser($id: ID!) {
    PartnerRejectPendingCustomerUser(id: $id) {
      ...PartnerListPendingCustomerUser
    }
  }
  ${PartnerListPendingCustomerUserFragmentDoc}
`
export type PartnerRejectPendingCustomerUserMutationFn =
  Apollo.MutationFunction<
    PartnerRejectPendingCustomerUserMutation,
    PartnerRejectPendingCustomerUserMutationVariables
  >

/**
 * __usePartnerRejectPendingCustomerUserMutation__
 *
 * To run a mutation, you first call `usePartnerRejectPendingCustomerUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerRejectPendingCustomerUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerRejectPendingCustomerUserMutation, { data, loading, error }] = usePartnerRejectPendingCustomerUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerRejectPendingCustomerUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerRejectPendingCustomerUserMutation,
    PartnerRejectPendingCustomerUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerRejectPendingCustomerUserMutation,
    PartnerRejectPendingCustomerUserMutationVariables
  >(PartnerRejectPendingCustomerUserDocument, options)
}
export type PartnerRejectPendingCustomerUserMutationHookResult = ReturnType<
  typeof usePartnerRejectPendingCustomerUserMutation
>
export type PartnerRejectPendingCustomerUserMutationResult =
  Apollo.MutationResult<PartnerRejectPendingCustomerUserMutation>
export type PartnerRejectPendingCustomerUserMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerRejectPendingCustomerUserMutation,
    PartnerRejectPendingCustomerUserMutationVariables
  >
export const PartnerApprovePendingCustomerUserDocument = /*#__PURE__*/ gql`
  mutation PartnerApprovePendingCustomerUser($id: ID!) {
    PartnerApprovePendingCustomerUser(id: $id) {
      id
    }
  }
`
export type PartnerApprovePendingCustomerUserMutationFn =
  Apollo.MutationFunction<
    PartnerApprovePendingCustomerUserMutation,
    PartnerApprovePendingCustomerUserMutationVariables
  >

/**
 * __usePartnerApprovePendingCustomerUserMutation__
 *
 * To run a mutation, you first call `usePartnerApprovePendingCustomerUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerApprovePendingCustomerUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerApprovePendingCustomerUserMutation, { data, loading, error }] = usePartnerApprovePendingCustomerUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerApprovePendingCustomerUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerApprovePendingCustomerUserMutation,
    PartnerApprovePendingCustomerUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerApprovePendingCustomerUserMutation,
    PartnerApprovePendingCustomerUserMutationVariables
  >(PartnerApprovePendingCustomerUserDocument, options)
}
export type PartnerApprovePendingCustomerUserMutationHookResult = ReturnType<
  typeof usePartnerApprovePendingCustomerUserMutation
>
export type PartnerApprovePendingCustomerUserMutationResult =
  Apollo.MutationResult<PartnerApprovePendingCustomerUserMutation>
export type PartnerApprovePendingCustomerUserMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerApprovePendingCustomerUserMutation,
    PartnerApprovePendingCustomerUserMutationVariables
  >
export const PartnerLinkPendingCustomerUserDocument = /*#__PURE__*/ gql`
  mutation PartnerLinkPendingCustomerUser($id: ID!, $customerId: ID!) {
    PartnerLinkPendingCustomerUser(id: $id, customerId: $customerId) {
      ...PartnerListPendingCustomerUser
    }
  }
  ${PartnerListPendingCustomerUserFragmentDoc}
`
export type PartnerLinkPendingCustomerUserMutationFn = Apollo.MutationFunction<
  PartnerLinkPendingCustomerUserMutation,
  PartnerLinkPendingCustomerUserMutationVariables
>

/**
 * __usePartnerLinkPendingCustomerUserMutation__
 *
 * To run a mutation, you first call `usePartnerLinkPendingCustomerUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerLinkPendingCustomerUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerLinkPendingCustomerUserMutation, { data, loading, error }] = usePartnerLinkPendingCustomerUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function usePartnerLinkPendingCustomerUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerLinkPendingCustomerUserMutation,
    PartnerLinkPendingCustomerUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerLinkPendingCustomerUserMutation,
    PartnerLinkPendingCustomerUserMutationVariables
  >(PartnerLinkPendingCustomerUserDocument, options)
}
export type PartnerLinkPendingCustomerUserMutationHookResult = ReturnType<
  typeof usePartnerLinkPendingCustomerUserMutation
>
export type PartnerLinkPendingCustomerUserMutationResult =
  Apollo.MutationResult<PartnerLinkPendingCustomerUserMutation>
export type PartnerLinkPendingCustomerUserMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerLinkPendingCustomerUserMutation,
    PartnerLinkPendingCustomerUserMutationVariables
  >
export const PartnerUnlinkPendingCustomerUserDocument = /*#__PURE__*/ gql`
  mutation PartnerUnlinkPendingCustomerUser($id: ID!, $customerId: ID!) {
    PartnerUnlinkPendingCustomerUser(id: $id, customerId: $customerId) {
      ...PartnerListPendingCustomerUser
    }
  }
  ${PartnerListPendingCustomerUserFragmentDoc}
`
export type PartnerUnlinkPendingCustomerUserMutationFn =
  Apollo.MutationFunction<
    PartnerUnlinkPendingCustomerUserMutation,
    PartnerUnlinkPendingCustomerUserMutationVariables
  >

/**
 * __usePartnerUnlinkPendingCustomerUserMutation__
 *
 * To run a mutation, you first call `usePartnerUnlinkPendingCustomerUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUnlinkPendingCustomerUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUnlinkPendingCustomerUserMutation, { data, loading, error }] = usePartnerUnlinkPendingCustomerUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function usePartnerUnlinkPendingCustomerUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUnlinkPendingCustomerUserMutation,
    PartnerUnlinkPendingCustomerUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUnlinkPendingCustomerUserMutation,
    PartnerUnlinkPendingCustomerUserMutationVariables
  >(PartnerUnlinkPendingCustomerUserDocument, options)
}
export type PartnerUnlinkPendingCustomerUserMutationHookResult = ReturnType<
  typeof usePartnerUnlinkPendingCustomerUserMutation
>
export type PartnerUnlinkPendingCustomerUserMutationResult =
  Apollo.MutationResult<PartnerUnlinkPendingCustomerUserMutation>
export type PartnerUnlinkPendingCustomerUserMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerUnlinkPendingCustomerUserMutation,
    PartnerUnlinkPendingCustomerUserMutationVariables
  >
export const PartnerRecurringPaymentConnectionDocument = /*#__PURE__*/ gql`
  query PartnerRecurringPaymentConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: RecurringPaymentFilter
    $orderBy: RecurringPaymentOrderBy
  ) {
    PartnerRecurringPaymentConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...PartnerRecurringPayment
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerRecurringPaymentFragmentDoc}
`

/**
 * __usePartnerRecurringPaymentConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerRecurringPaymentConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerRecurringPaymentConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerRecurringPaymentConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerRecurringPaymentConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerRecurringPaymentConnectionQuery,
    PartnerRecurringPaymentConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerRecurringPaymentConnectionQuery,
    PartnerRecurringPaymentConnectionQueryVariables
  >(PartnerRecurringPaymentConnectionDocument, options)
}
export function usePartnerRecurringPaymentConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerRecurringPaymentConnectionQuery,
    PartnerRecurringPaymentConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerRecurringPaymentConnectionQuery,
    PartnerRecurringPaymentConnectionQueryVariables
  >(PartnerRecurringPaymentConnectionDocument, options)
}
export type PartnerRecurringPaymentConnectionQueryHookResult = ReturnType<
  typeof usePartnerRecurringPaymentConnectionQuery
>
export type PartnerRecurringPaymentConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerRecurringPaymentConnectionLazyQuery
>
export type PartnerRecurringPaymentConnectionQueryResult = Apollo.QueryResult<
  PartnerRecurringPaymentConnectionQuery,
  PartnerRecurringPaymentConnectionQueryVariables
>
export const PartnerRecurringPaymentTotalsDocument = /*#__PURE__*/ gql`
  query PartnerRecurringPaymentTotals($filters: RecurringPaymentFilter) {
    PartnerRecurringPaymentTotals(filters: $filters) {
      count
      amount
    }
  }
`

/**
 * __usePartnerRecurringPaymentTotalsQuery__
 *
 * To run a query within a React component, call `usePartnerRecurringPaymentTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerRecurringPaymentTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerRecurringPaymentTotalsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePartnerRecurringPaymentTotalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerRecurringPaymentTotalsQuery,
    PartnerRecurringPaymentTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerRecurringPaymentTotalsQuery,
    PartnerRecurringPaymentTotalsQueryVariables
  >(PartnerRecurringPaymentTotalsDocument, options)
}
export function usePartnerRecurringPaymentTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerRecurringPaymentTotalsQuery,
    PartnerRecurringPaymentTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerRecurringPaymentTotalsQuery,
    PartnerRecurringPaymentTotalsQueryVariables
  >(PartnerRecurringPaymentTotalsDocument, options)
}
export type PartnerRecurringPaymentTotalsQueryHookResult = ReturnType<
  typeof usePartnerRecurringPaymentTotalsQuery
>
export type PartnerRecurringPaymentTotalsLazyQueryHookResult = ReturnType<
  typeof usePartnerRecurringPaymentTotalsLazyQuery
>
export type PartnerRecurringPaymentTotalsQueryResult = Apollo.QueryResult<
  PartnerRecurringPaymentTotalsQuery,
  PartnerRecurringPaymentTotalsQueryVariables
>
export const RecurringPaymentCreateDocument = /*#__PURE__*/ gql`
  mutation RecurringPaymentCreate($input: RecurringPaymentCreateInput!) {
    PartnerRecurringPaymentCreate(input: $input) {
      ...PartnerRecurringPayment
    }
  }
  ${PartnerRecurringPaymentFragmentDoc}
`
export type RecurringPaymentCreateMutationFn = Apollo.MutationFunction<
  RecurringPaymentCreateMutation,
  RecurringPaymentCreateMutationVariables
>

/**
 * __useRecurringPaymentCreateMutation__
 *
 * To run a mutation, you first call `useRecurringPaymentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringPaymentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringPaymentCreateMutation, { data, loading, error }] = useRecurringPaymentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecurringPaymentCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecurringPaymentCreateMutation,
    RecurringPaymentCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RecurringPaymentCreateMutation,
    RecurringPaymentCreateMutationVariables
  >(RecurringPaymentCreateDocument, options)
}
export type RecurringPaymentCreateMutationHookResult = ReturnType<
  typeof useRecurringPaymentCreateMutation
>
export type RecurringPaymentCreateMutationResult =
  Apollo.MutationResult<RecurringPaymentCreateMutation>
export type RecurringPaymentCreateMutationOptions = Apollo.BaseMutationOptions<
  RecurringPaymentCreateMutation,
  RecurringPaymentCreateMutationVariables
>
export const RecurringPaymentDeactivateDocument = /*#__PURE__*/ gql`
  mutation RecurringPaymentDeactivate(
    $input: RecurringPaymentDeactivateInput!
  ) {
    PartnerRecurringPaymentDeactivate(input: $input)
  }
`
export type RecurringPaymentDeactivateMutationFn = Apollo.MutationFunction<
  RecurringPaymentDeactivateMutation,
  RecurringPaymentDeactivateMutationVariables
>

/**
 * __useRecurringPaymentDeactivateMutation__
 *
 * To run a mutation, you first call `useRecurringPaymentDeactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringPaymentDeactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringPaymentDeactivateMutation, { data, loading, error }] = useRecurringPaymentDeactivateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecurringPaymentDeactivateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecurringPaymentDeactivateMutation,
    RecurringPaymentDeactivateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RecurringPaymentDeactivateMutation,
    RecurringPaymentDeactivateMutationVariables
  >(RecurringPaymentDeactivateDocument, options)
}
export type RecurringPaymentDeactivateMutationHookResult = ReturnType<
  typeof useRecurringPaymentDeactivateMutation
>
export type RecurringPaymentDeactivateMutationResult =
  Apollo.MutationResult<RecurringPaymentDeactivateMutation>
export type RecurringPaymentDeactivateMutationOptions =
  Apollo.BaseMutationOptions<
    RecurringPaymentDeactivateMutation,
    RecurringPaymentDeactivateMutationVariables
  >
export const RecurringPaymentUpdateDocument = /*#__PURE__*/ gql`
  mutation RecurringPaymentUpdate($input: RecurringPaymentUpdateInput!) {
    PartnerRecurringPaymentUpdate(input: $input)
  }
`
export type RecurringPaymentUpdateMutationFn = Apollo.MutationFunction<
  RecurringPaymentUpdateMutation,
  RecurringPaymentUpdateMutationVariables
>

/**
 * __useRecurringPaymentUpdateMutation__
 *
 * To run a mutation, you first call `useRecurringPaymentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringPaymentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringPaymentUpdateMutation, { data, loading, error }] = useRecurringPaymentUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecurringPaymentUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecurringPaymentUpdateMutation,
    RecurringPaymentUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RecurringPaymentUpdateMutation,
    RecurringPaymentUpdateMutationVariables
  >(RecurringPaymentUpdateDocument, options)
}
export type RecurringPaymentUpdateMutationHookResult = ReturnType<
  typeof useRecurringPaymentUpdateMutation
>
export type RecurringPaymentUpdateMutationResult =
  Apollo.MutationResult<RecurringPaymentUpdateMutation>
export type RecurringPaymentUpdateMutationOptions = Apollo.BaseMutationOptions<
  RecurringPaymentUpdateMutation,
  RecurringPaymentUpdateMutationVariables
>
export const PartnerReferralGetQuarterlyEarningsDataDocument = /*#__PURE__*/ gql`
  query PartnerReferralGetQuarterlyEarningsData($input: GetReferralDataInput!) {
    PartnerReferralGetQuarterlyEarningsData(input: $input) {
      ...GetReferralDataReply
    }
  }
  ${GetReferralDataReplyFragmentDoc}
`

/**
 * __usePartnerReferralGetQuarterlyEarningsDataQuery__
 *
 * To run a query within a React component, call `usePartnerReferralGetQuarterlyEarningsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerReferralGetQuarterlyEarningsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerReferralGetQuarterlyEarningsDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerReferralGetQuarterlyEarningsDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerReferralGetQuarterlyEarningsDataQuery,
    PartnerReferralGetQuarterlyEarningsDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerReferralGetQuarterlyEarningsDataQuery,
    PartnerReferralGetQuarterlyEarningsDataQueryVariables
  >(PartnerReferralGetQuarterlyEarningsDataDocument, options)
}
export function usePartnerReferralGetQuarterlyEarningsDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerReferralGetQuarterlyEarningsDataQuery,
    PartnerReferralGetQuarterlyEarningsDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerReferralGetQuarterlyEarningsDataQuery,
    PartnerReferralGetQuarterlyEarningsDataQueryVariables
  >(PartnerReferralGetQuarterlyEarningsDataDocument, options)
}
export type PartnerReferralGetQuarterlyEarningsDataQueryHookResult = ReturnType<
  typeof usePartnerReferralGetQuarterlyEarningsDataQuery
>
export type PartnerReferralGetQuarterlyEarningsDataLazyQueryHookResult =
  ReturnType<typeof usePartnerReferralGetQuarterlyEarningsDataLazyQuery>
export type PartnerReferralGetQuarterlyEarningsDataQueryResult =
  Apollo.QueryResult<
    PartnerReferralGetQuarterlyEarningsDataQuery,
    PartnerReferralGetQuarterlyEarningsDataQueryVariables
  >
export const PartnerReferralGetAvailableForPayoutDataDocument = /*#__PURE__*/ gql`
  query PartnerReferralGetAvailableForPayoutData(
    $input: GetReferralDataInput!
  ) {
    PartnerReferralGetAvailableForPayoutData(input: $input) {
      ...GetReferralDataReply
    }
  }
  ${GetReferralDataReplyFragmentDoc}
`

/**
 * __usePartnerReferralGetAvailableForPayoutDataQuery__
 *
 * To run a query within a React component, call `usePartnerReferralGetAvailableForPayoutDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerReferralGetAvailableForPayoutDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerReferralGetAvailableForPayoutDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerReferralGetAvailableForPayoutDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerReferralGetAvailableForPayoutDataQuery,
    PartnerReferralGetAvailableForPayoutDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerReferralGetAvailableForPayoutDataQuery,
    PartnerReferralGetAvailableForPayoutDataQueryVariables
  >(PartnerReferralGetAvailableForPayoutDataDocument, options)
}
export function usePartnerReferralGetAvailableForPayoutDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerReferralGetAvailableForPayoutDataQuery,
    PartnerReferralGetAvailableForPayoutDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerReferralGetAvailableForPayoutDataQuery,
    PartnerReferralGetAvailableForPayoutDataQueryVariables
  >(PartnerReferralGetAvailableForPayoutDataDocument, options)
}
export type PartnerReferralGetAvailableForPayoutDataQueryHookResult =
  ReturnType<typeof usePartnerReferralGetAvailableForPayoutDataQuery>
export type PartnerReferralGetAvailableForPayoutDataLazyQueryHookResult =
  ReturnType<typeof usePartnerReferralGetAvailableForPayoutDataLazyQuery>
export type PartnerReferralGetAvailableForPayoutDataQueryResult =
  Apollo.QueryResult<
    PartnerReferralGetAvailableForPayoutDataQuery,
    PartnerReferralGetAvailableForPayoutDataQueryVariables
  >
export const PartnerReferralGetTotalReferralFeesDataDocument = /*#__PURE__*/ gql`
  query PartnerReferralGetTotalReferralFeesData($input: GetReferralDataInput!) {
    PartnerReferralGetTotalReferralFeesData(input: $input) {
      ...GetReferralDataReply
    }
  }
  ${GetReferralDataReplyFragmentDoc}
`

/**
 * __usePartnerReferralGetTotalReferralFeesDataQuery__
 *
 * To run a query within a React component, call `usePartnerReferralGetTotalReferralFeesDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerReferralGetTotalReferralFeesDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerReferralGetTotalReferralFeesDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerReferralGetTotalReferralFeesDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerReferralGetTotalReferralFeesDataQuery,
    PartnerReferralGetTotalReferralFeesDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerReferralGetTotalReferralFeesDataQuery,
    PartnerReferralGetTotalReferralFeesDataQueryVariables
  >(PartnerReferralGetTotalReferralFeesDataDocument, options)
}
export function usePartnerReferralGetTotalReferralFeesDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerReferralGetTotalReferralFeesDataQuery,
    PartnerReferralGetTotalReferralFeesDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerReferralGetTotalReferralFeesDataQuery,
    PartnerReferralGetTotalReferralFeesDataQueryVariables
  >(PartnerReferralGetTotalReferralFeesDataDocument, options)
}
export type PartnerReferralGetTotalReferralFeesDataQueryHookResult = ReturnType<
  typeof usePartnerReferralGetTotalReferralFeesDataQuery
>
export type PartnerReferralGetTotalReferralFeesDataLazyQueryHookResult =
  ReturnType<typeof usePartnerReferralGetTotalReferralFeesDataLazyQuery>
export type PartnerReferralGetTotalReferralFeesDataQueryResult =
  Apollo.QueryResult<
    PartnerReferralGetTotalReferralFeesDataQuery,
    PartnerReferralGetTotalReferralFeesDataQueryVariables
  >
export const PartnerReferralGetAvgQuarterlyFeesDataDocument = /*#__PURE__*/ gql`
  query PartnerReferralGetAvgQuarterlyFeesData($input: GetReferralDataInput!) {
    PartnerReferralGetAvgQuarterlyFeesData(input: $input) {
      ...GetReferralDataReply
    }
  }
  ${GetReferralDataReplyFragmentDoc}
`

/**
 * __usePartnerReferralGetAvgQuarterlyFeesDataQuery__
 *
 * To run a query within a React component, call `usePartnerReferralGetAvgQuarterlyFeesDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerReferralGetAvgQuarterlyFeesDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerReferralGetAvgQuarterlyFeesDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerReferralGetAvgQuarterlyFeesDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerReferralGetAvgQuarterlyFeesDataQuery,
    PartnerReferralGetAvgQuarterlyFeesDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerReferralGetAvgQuarterlyFeesDataQuery,
    PartnerReferralGetAvgQuarterlyFeesDataQueryVariables
  >(PartnerReferralGetAvgQuarterlyFeesDataDocument, options)
}
export function usePartnerReferralGetAvgQuarterlyFeesDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerReferralGetAvgQuarterlyFeesDataQuery,
    PartnerReferralGetAvgQuarterlyFeesDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerReferralGetAvgQuarterlyFeesDataQuery,
    PartnerReferralGetAvgQuarterlyFeesDataQueryVariables
  >(PartnerReferralGetAvgQuarterlyFeesDataDocument, options)
}
export type PartnerReferralGetAvgQuarterlyFeesDataQueryHookResult = ReturnType<
  typeof usePartnerReferralGetAvgQuarterlyFeesDataQuery
>
export type PartnerReferralGetAvgQuarterlyFeesDataLazyQueryHookResult =
  ReturnType<typeof usePartnerReferralGetAvgQuarterlyFeesDataLazyQuery>
export type PartnerReferralGetAvgQuarterlyFeesDataQueryResult =
  Apollo.QueryResult<
    PartnerReferralGetAvgQuarterlyFeesDataQuery,
    PartnerReferralGetAvgQuarterlyFeesDataQueryVariables
  >
export const PartnerGetReferralLinkDocument = /*#__PURE__*/ gql`
  query PartnerGetReferralLink {
    PartnerGetReferralLink
  }
`

/**
 * __usePartnerGetReferralLinkQuery__
 *
 * To run a query within a React component, call `usePartnerGetReferralLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetReferralLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetReferralLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerGetReferralLinkQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerGetReferralLinkQuery,
    PartnerGetReferralLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetReferralLinkQuery,
    PartnerGetReferralLinkQueryVariables
  >(PartnerGetReferralLinkDocument, options)
}
export function usePartnerGetReferralLinkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetReferralLinkQuery,
    PartnerGetReferralLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetReferralLinkQuery,
    PartnerGetReferralLinkQueryVariables
  >(PartnerGetReferralLinkDocument, options)
}
export type PartnerGetReferralLinkQueryHookResult = ReturnType<
  typeof usePartnerGetReferralLinkQuery
>
export type PartnerGetReferralLinkLazyQueryHookResult = ReturnType<
  typeof usePartnerGetReferralLinkLazyQuery
>
export type PartnerGetReferralLinkQueryResult = Apollo.QueryResult<
  PartnerGetReferralLinkQuery,
  PartnerGetReferralLinkQueryVariables
>
export const PartnerGetReferralPayoutByPayoutIdDocument = /*#__PURE__*/ gql`
  query PartnerGetReferralPayoutByPayoutID($payoutID: ID!) {
    PartnerGetReferralPayoutByPayoutID(payoutID: $payoutID) {
      ...ReferralPayout
    }
  }
  ${ReferralPayoutFragmentDoc}
`

/**
 * __usePartnerGetReferralPayoutByPayoutIdQuery__
 *
 * To run a query within a React component, call `usePartnerGetReferralPayoutByPayoutIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerGetReferralPayoutByPayoutIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerGetReferralPayoutByPayoutIdQuery({
 *   variables: {
 *      payoutID: // value for 'payoutID'
 *   },
 * });
 */
export function usePartnerGetReferralPayoutByPayoutIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerGetReferralPayoutByPayoutIdQuery,
    PartnerGetReferralPayoutByPayoutIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerGetReferralPayoutByPayoutIdQuery,
    PartnerGetReferralPayoutByPayoutIdQueryVariables
  >(PartnerGetReferralPayoutByPayoutIdDocument, options)
}
export function usePartnerGetReferralPayoutByPayoutIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerGetReferralPayoutByPayoutIdQuery,
    PartnerGetReferralPayoutByPayoutIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerGetReferralPayoutByPayoutIdQuery,
    PartnerGetReferralPayoutByPayoutIdQueryVariables
  >(PartnerGetReferralPayoutByPayoutIdDocument, options)
}
export type PartnerGetReferralPayoutByPayoutIdQueryHookResult = ReturnType<
  typeof usePartnerGetReferralPayoutByPayoutIdQuery
>
export type PartnerGetReferralPayoutByPayoutIdLazyQueryHookResult = ReturnType<
  typeof usePartnerGetReferralPayoutByPayoutIdLazyQuery
>
export type PartnerGetReferralPayoutByPayoutIdQueryResult = Apollo.QueryResult<
  PartnerGetReferralPayoutByPayoutIdQuery,
  PartnerGetReferralPayoutByPayoutIdQueryVariables
>
export const PartnerReferralConnectionDocument = /*#__PURE__*/ gql`
  query PartnerReferralConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: ReferralFilter
    $orderBy: ReferralOrderBy
  ) {
    PartnerReferralConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        cursor
        node {
          ...Referral
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${ReferralFragmentDoc}
`

/**
 * __usePartnerReferralConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerReferralConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerReferralConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerReferralConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerReferralConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerReferralConnectionQuery,
    PartnerReferralConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerReferralConnectionQuery,
    PartnerReferralConnectionQueryVariables
  >(PartnerReferralConnectionDocument, options)
}
export function usePartnerReferralConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerReferralConnectionQuery,
    PartnerReferralConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerReferralConnectionQuery,
    PartnerReferralConnectionQueryVariables
  >(PartnerReferralConnectionDocument, options)
}
export type PartnerReferralConnectionQueryHookResult = ReturnType<
  typeof usePartnerReferralConnectionQuery
>
export type PartnerReferralConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerReferralConnectionLazyQuery
>
export type PartnerReferralConnectionQueryResult = Apollo.QueryResult<
  PartnerReferralConnectionQuery,
  PartnerReferralConnectionQueryVariables
>
export const PartnerCreateReferralDocument = /*#__PURE__*/ gql`
  mutation PartnerCreateReferral($input: CreateReferralInput!) {
    PartnerCreateReferral(input: $input)
  }
`
export type PartnerCreateReferralMutationFn = Apollo.MutationFunction<
  PartnerCreateReferralMutation,
  PartnerCreateReferralMutationVariables
>

/**
 * __usePartnerCreateReferralMutation__
 *
 * To run a mutation, you first call `usePartnerCreateReferralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCreateReferralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCreateReferralMutation, { data, loading, error }] = usePartnerCreateReferralMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCreateReferralMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCreateReferralMutation,
    PartnerCreateReferralMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCreateReferralMutation,
    PartnerCreateReferralMutationVariables
  >(PartnerCreateReferralDocument, options)
}
export type PartnerCreateReferralMutationHookResult = ReturnType<
  typeof usePartnerCreateReferralMutation
>
export type PartnerCreateReferralMutationResult =
  Apollo.MutationResult<PartnerCreateReferralMutation>
export type PartnerCreateReferralMutationOptions = Apollo.BaseMutationOptions<
  PartnerCreateReferralMutation,
  PartnerCreateReferralMutationVariables
>
export const PartnerUpdateReferralDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateReferral($input: UpdateReferralInput!) {
    PartnerUpdateReferral(input: $input)
  }
`
export type PartnerUpdateReferralMutationFn = Apollo.MutationFunction<
  PartnerUpdateReferralMutation,
  PartnerUpdateReferralMutationVariables
>

/**
 * __usePartnerUpdateReferralMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateReferralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateReferralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateReferralMutation, { data, loading, error }] = usePartnerUpdateReferralMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateReferralMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateReferralMutation,
    PartnerUpdateReferralMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateReferralMutation,
    PartnerUpdateReferralMutationVariables
  >(PartnerUpdateReferralDocument, options)
}
export type PartnerUpdateReferralMutationHookResult = ReturnType<
  typeof usePartnerUpdateReferralMutation
>
export type PartnerUpdateReferralMutationResult =
  Apollo.MutationResult<PartnerUpdateReferralMutation>
export type PartnerUpdateReferralMutationOptions = Apollo.BaseMutationOptions<
  PartnerUpdateReferralMutation,
  PartnerUpdateReferralMutationVariables
>
export const PartnerSendReferralDocument = /*#__PURE__*/ gql`
  mutation PartnerSendReferral($input: SendPartnerReferralInput!) {
    PartnerSendReferral(input: $input)
  }
`
export type PartnerSendReferralMutationFn = Apollo.MutationFunction<
  PartnerSendReferralMutation,
  PartnerSendReferralMutationVariables
>

/**
 * __usePartnerSendReferralMutation__
 *
 * To run a mutation, you first call `usePartnerSendReferralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerSendReferralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerSendReferralMutation, { data, loading, error }] = usePartnerSendReferralMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerSendReferralMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerSendReferralMutation,
    PartnerSendReferralMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerSendReferralMutation,
    PartnerSendReferralMutationVariables
  >(PartnerSendReferralDocument, options)
}
export type PartnerSendReferralMutationHookResult = ReturnType<
  typeof usePartnerSendReferralMutation
>
export type PartnerSendReferralMutationResult =
  Apollo.MutationResult<PartnerSendReferralMutation>
export type PartnerSendReferralMutationOptions = Apollo.BaseMutationOptions<
  PartnerSendReferralMutation,
  PartnerSendReferralMutationVariables
>
export const CreateRefundDocument = /*#__PURE__*/ gql`
  mutation CreateRefund($input: RefundCreateInput!) {
    createRefund(input: $input)
  }
`
export type CreateRefundMutationFn = Apollo.MutationFunction<
  CreateRefundMutation,
  CreateRefundMutationVariables
>

/**
 * __useCreateRefundMutation__
 *
 * To run a mutation, you first call `useCreateRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRefundMutation, { data, loading, error }] = useCreateRefundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRefundMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateRefundMutation,
    CreateRefundMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateRefundMutation,
    CreateRefundMutationVariables
  >(CreateRefundDocument, options)
}
export type CreateRefundMutationHookResult = ReturnType<
  typeof useCreateRefundMutation
>
export type CreateRefundMutationResult =
  Apollo.MutationResult<CreateRefundMutation>
export type CreateRefundMutationOptions = Apollo.BaseMutationOptions<
  CreateRefundMutation,
  CreateRefundMutationVariables
>
export const PartnerSendReportDocument = /*#__PURE__*/ gql`
  mutation PartnerSendReport(
    $reportType: ReportType!
    $dateFrom: String
    $dateTo: String
    $timezone: String
  ) {
    PartnerSendReport(
      reportType: $reportType
      dateFrom: $dateFrom
      dateTo: $dateTo
      timezone: $timezone
    )
  }
`
export type PartnerSendReportMutationFn = Apollo.MutationFunction<
  PartnerSendReportMutation,
  PartnerSendReportMutationVariables
>

/**
 * __usePartnerSendReportMutation__
 *
 * To run a mutation, you first call `usePartnerSendReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerSendReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerSendReportMutation, { data, loading, error }] = usePartnerSendReportMutation({
 *   variables: {
 *      reportType: // value for 'reportType'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function usePartnerSendReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerSendReportMutation,
    PartnerSendReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerSendReportMutation,
    PartnerSendReportMutationVariables
  >(PartnerSendReportDocument, options)
}
export type PartnerSendReportMutationHookResult = ReturnType<
  typeof usePartnerSendReportMutation
>
export type PartnerSendReportMutationResult =
  Apollo.MutationResult<PartnerSendReportMutation>
export type PartnerSendReportMutationOptions = Apollo.BaseMutationOptions<
  PartnerSendReportMutation,
  PartnerSendReportMutationVariables
>
export const PartnerListActiveSubscriptionsDocument = /*#__PURE__*/ gql`
  query PartnerListActiveSubscriptions {
    PartnerListActiveSubscriptions {
      ...PartnerSubscription
    }
  }
  ${PartnerSubscriptionFragmentDoc}
`

/**
 * __usePartnerListActiveSubscriptionsQuery__
 *
 * To run a query within a React component, call `usePartnerListActiveSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListActiveSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListActiveSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerListActiveSubscriptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListActiveSubscriptionsQuery,
    PartnerListActiveSubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListActiveSubscriptionsQuery,
    PartnerListActiveSubscriptionsQueryVariables
  >(PartnerListActiveSubscriptionsDocument, options)
}
export function usePartnerListActiveSubscriptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListActiveSubscriptionsQuery,
    PartnerListActiveSubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListActiveSubscriptionsQuery,
    PartnerListActiveSubscriptionsQueryVariables
  >(PartnerListActiveSubscriptionsDocument, options)
}
export type PartnerListActiveSubscriptionsQueryHookResult = ReturnType<
  typeof usePartnerListActiveSubscriptionsQuery
>
export type PartnerListActiveSubscriptionsLazyQueryHookResult = ReturnType<
  typeof usePartnerListActiveSubscriptionsLazyQuery
>
export type PartnerListActiveSubscriptionsQueryResult = Apollo.QueryResult<
  PartnerListActiveSubscriptionsQuery,
  PartnerListActiveSubscriptionsQueryVariables
>
export const PartnerSubscriptionsPaymentsConnectionDocument = /*#__PURE__*/ gql`
  query PartnerSubscriptionsPaymentsConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $filters: SubscriptionPaymentFilter
    $orderBy: SubscriptionPaymentOrderBy
  ) {
    PartnerSubscriptionsPaymentsConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      filters: $filters
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...SubscriptionPayment
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${SubscriptionPaymentFragmentDoc}
`

/**
 * __usePartnerSubscriptionsPaymentsConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerSubscriptionsPaymentsConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerSubscriptionsPaymentsConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerSubscriptionsPaymentsConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerSubscriptionsPaymentsConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerSubscriptionsPaymentsConnectionQuery,
    PartnerSubscriptionsPaymentsConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerSubscriptionsPaymentsConnectionQuery,
    PartnerSubscriptionsPaymentsConnectionQueryVariables
  >(PartnerSubscriptionsPaymentsConnectionDocument, options)
}
export function usePartnerSubscriptionsPaymentsConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerSubscriptionsPaymentsConnectionQuery,
    PartnerSubscriptionsPaymentsConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerSubscriptionsPaymentsConnectionQuery,
    PartnerSubscriptionsPaymentsConnectionQueryVariables
  >(PartnerSubscriptionsPaymentsConnectionDocument, options)
}
export type PartnerSubscriptionsPaymentsConnectionQueryHookResult = ReturnType<
  typeof usePartnerSubscriptionsPaymentsConnectionQuery
>
export type PartnerSubscriptionsPaymentsConnectionLazyQueryHookResult =
  ReturnType<typeof usePartnerSubscriptionsPaymentsConnectionLazyQuery>
export type PartnerSubscriptionsPaymentsConnectionQueryResult =
  Apollo.QueryResult<
    PartnerSubscriptionsPaymentsConnectionQuery,
    PartnerSubscriptionsPaymentsConnectionQueryVariables
  >
export const PartnerListSubscriptionPaymentsTotalsDocument = /*#__PURE__*/ gql`
  query PartnerListSubscriptionPaymentsTotals {
    PartnerListSubscriptionPaymentsTotals {
      count
    }
  }
`

/**
 * __usePartnerListSubscriptionPaymentsTotalsQuery__
 *
 * To run a query within a React component, call `usePartnerListSubscriptionPaymentsTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerListSubscriptionPaymentsTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerListSubscriptionPaymentsTotalsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerListSubscriptionPaymentsTotalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerListSubscriptionPaymentsTotalsQuery,
    PartnerListSubscriptionPaymentsTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerListSubscriptionPaymentsTotalsQuery,
    PartnerListSubscriptionPaymentsTotalsQueryVariables
  >(PartnerListSubscriptionPaymentsTotalsDocument, options)
}
export function usePartnerListSubscriptionPaymentsTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerListSubscriptionPaymentsTotalsQuery,
    PartnerListSubscriptionPaymentsTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerListSubscriptionPaymentsTotalsQuery,
    PartnerListSubscriptionPaymentsTotalsQueryVariables
  >(PartnerListSubscriptionPaymentsTotalsDocument, options)
}
export type PartnerListSubscriptionPaymentsTotalsQueryHookResult = ReturnType<
  typeof usePartnerListSubscriptionPaymentsTotalsQuery
>
export type PartnerListSubscriptionPaymentsTotalsLazyQueryHookResult =
  ReturnType<typeof usePartnerListSubscriptionPaymentsTotalsLazyQuery>
export type PartnerListSubscriptionPaymentsTotalsQueryResult =
  Apollo.QueryResult<
    PartnerListSubscriptionPaymentsTotalsQuery,
    PartnerListSubscriptionPaymentsTotalsQueryVariables
  >
export const PartnerCancelSubscriptionDocument = /*#__PURE__*/ gql`
  mutation PartnerCancelSubscription($input: CancelSubscriptionInput!) {
    PartnerCancelSubscription(input: $input) {
      ...PartnerSubscription
    }
  }
  ${PartnerSubscriptionFragmentDoc}
`
export type PartnerCancelSubscriptionMutationFn = Apollo.MutationFunction<
  PartnerCancelSubscriptionMutation,
  PartnerCancelSubscriptionMutationVariables
>

/**
 * __usePartnerCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `usePartnerCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCancelSubscriptionMutation, { data, loading, error }] = usePartnerCancelSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerCancelSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerCancelSubscriptionMutation,
    PartnerCancelSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerCancelSubscriptionMutation,
    PartnerCancelSubscriptionMutationVariables
  >(PartnerCancelSubscriptionDocument, options)
}
export type PartnerCancelSubscriptionMutationHookResult = ReturnType<
  typeof usePartnerCancelSubscriptionMutation
>
export type PartnerCancelSubscriptionMutationResult =
  Apollo.MutationResult<PartnerCancelSubscriptionMutation>
export type PartnerCancelSubscriptionMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerCancelSubscriptionMutation,
    PartnerCancelSubscriptionMutationVariables
  >
export const PartnerAccountingSyncConfigGetDocument = /*#__PURE__*/ gql`
  query PartnerAccountingSyncConfigGet($input: SyncConfigGetInput!) {
    PartnerAccountingSyncConfigGet(input: $input) {
      partnerID
      sourcePlatformName
      targetPlatformName
      lastAutomaticSync
      options {
        optionKey
        optionType
        enumValue
        customValue
      }
      mappings {
        sourceID
        sourceName
        targetID
        targetName
        mappingType
      }
    }
  }
`

/**
 * __usePartnerAccountingSyncConfigGetQuery__
 *
 * To run a query within a React component, call `usePartnerAccountingSyncConfigGetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerAccountingSyncConfigGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerAccountingSyncConfigGetQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerAccountingSyncConfigGetQuery(
  baseOptions: Apollo.QueryHookOptions<
    PartnerAccountingSyncConfigGetQuery,
    PartnerAccountingSyncConfigGetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerAccountingSyncConfigGetQuery,
    PartnerAccountingSyncConfigGetQueryVariables
  >(PartnerAccountingSyncConfigGetDocument, options)
}
export function usePartnerAccountingSyncConfigGetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerAccountingSyncConfigGetQuery,
    PartnerAccountingSyncConfigGetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerAccountingSyncConfigGetQuery,
    PartnerAccountingSyncConfigGetQueryVariables
  >(PartnerAccountingSyncConfigGetDocument, options)
}
export type PartnerAccountingSyncConfigGetQueryHookResult = ReturnType<
  typeof usePartnerAccountingSyncConfigGetQuery
>
export type PartnerAccountingSyncConfigGetLazyQueryHookResult = ReturnType<
  typeof usePartnerAccountingSyncConfigGetLazyQuery
>
export type PartnerAccountingSyncConfigGetQueryResult = Apollo.QueryResult<
  PartnerAccountingSyncConfigGetQuery,
  PartnerAccountingSyncConfigGetQueryVariables
>
export const PartnerAccountingSyncConfigCreateDocument = /*#__PURE__*/ gql`
  mutation PartnerAccountingSyncConfigCreate($input: SyncConfigCreateInput!) {
    PartnerAccountingSyncConfigCreate(input: $input) {
      lastAutomaticSync
    }
  }
`
export type PartnerAccountingSyncConfigCreateMutationFn =
  Apollo.MutationFunction<
    PartnerAccountingSyncConfigCreateMutation,
    PartnerAccountingSyncConfigCreateMutationVariables
  >

/**
 * __usePartnerAccountingSyncConfigCreateMutation__
 *
 * To run a mutation, you first call `usePartnerAccountingSyncConfigCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAccountingSyncConfigCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAccountingSyncConfigCreateMutation, { data, loading, error }] = usePartnerAccountingSyncConfigCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerAccountingSyncConfigCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAccountingSyncConfigCreateMutation,
    PartnerAccountingSyncConfigCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAccountingSyncConfigCreateMutation,
    PartnerAccountingSyncConfigCreateMutationVariables
  >(PartnerAccountingSyncConfigCreateDocument, options)
}
export type PartnerAccountingSyncConfigCreateMutationHookResult = ReturnType<
  typeof usePartnerAccountingSyncConfigCreateMutation
>
export type PartnerAccountingSyncConfigCreateMutationResult =
  Apollo.MutationResult<PartnerAccountingSyncConfigCreateMutation>
export type PartnerAccountingSyncConfigCreateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAccountingSyncConfigCreateMutation,
    PartnerAccountingSyncConfigCreateMutationVariables
  >
export const PartnerAccountingSyncConfigUpdateDocument = /*#__PURE__*/ gql`
  mutation PartnerAccountingSyncConfigUpdate($input: SyncConfigUpdateInput!) {
    PartnerAccountingSyncConfigUpdate(input: $input) {
      lastAutomaticSync
    }
  }
`
export type PartnerAccountingSyncConfigUpdateMutationFn =
  Apollo.MutationFunction<
    PartnerAccountingSyncConfigUpdateMutation,
    PartnerAccountingSyncConfigUpdateMutationVariables
  >

/**
 * __usePartnerAccountingSyncConfigUpdateMutation__
 *
 * To run a mutation, you first call `usePartnerAccountingSyncConfigUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerAccountingSyncConfigUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerAccountingSyncConfigUpdateMutation, { data, loading, error }] = usePartnerAccountingSyncConfigUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerAccountingSyncConfigUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerAccountingSyncConfigUpdateMutation,
    PartnerAccountingSyncConfigUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerAccountingSyncConfigUpdateMutation,
    PartnerAccountingSyncConfigUpdateMutationVariables
  >(PartnerAccountingSyncConfigUpdateDocument, options)
}
export type PartnerAccountingSyncConfigUpdateMutationHookResult = ReturnType<
  typeof usePartnerAccountingSyncConfigUpdateMutation
>
export type PartnerAccountingSyncConfigUpdateMutationResult =
  Apollo.MutationResult<PartnerAccountingSyncConfigUpdateMutation>
export type PartnerAccountingSyncConfigUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    PartnerAccountingSyncConfigUpdateMutation,
    PartnerAccountingSyncConfigUpdateMutationVariables
  >
export const GetUserInfoDocument = /*#__PURE__*/ gql`
  query GetUserInfo {
    GetUserInfo {
      id
      userType
      users {
        ...UserInfo
      }
    }
  }
  ${UserInfoFragmentDoc}
`

/**
 * __useGetUserInfoQuery__
 *
 * To run a query within a React component, call `useGetUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserInfoQuery,
    GetUserInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(
    GetUserInfoDocument,
    options
  )
}
export function useGetUserInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserInfoQuery,
    GetUserInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(
    GetUserInfoDocument,
    options
  )
}
export type GetUserInfoQueryHookResult = ReturnType<typeof useGetUserInfoQuery>
export type GetUserInfoLazyQueryHookResult = ReturnType<
  typeof useGetUserInfoLazyQuery
>
export type GetUserInfoQueryResult = Apollo.QueryResult<
  GetUserInfoQuery,
  GetUserInfoQueryVariables
>
export const GetUserInfoDetailsDocument = /*#__PURE__*/ gql`
  query GetUserInfoDetails {
    GetUserInfo {
      id
      users {
        ...UserInfoDetails
      }
    }
  }
  ${UserInfoDetailsFragmentDoc}
`

/**
 * __useGetUserInfoDetailsQuery__
 *
 * To run a query within a React component, call `useGetUserInfoDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInfoDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInfoDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserInfoDetailsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserInfoDetailsQuery,
    GetUserInfoDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetUserInfoDetailsQuery,
    GetUserInfoDetailsQueryVariables
  >(GetUserInfoDetailsDocument, options)
}
export function useGetUserInfoDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserInfoDetailsQuery,
    GetUserInfoDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetUserInfoDetailsQuery,
    GetUserInfoDetailsQueryVariables
  >(GetUserInfoDetailsDocument, options)
}
export type GetUserInfoDetailsQueryHookResult = ReturnType<
  typeof useGetUserInfoDetailsQuery
>
export type GetUserInfoDetailsLazyQueryHookResult = ReturnType<
  typeof useGetUserInfoDetailsLazyQuery
>
export type GetUserInfoDetailsQueryResult = Apollo.QueryResult<
  GetUserInfoDetailsQuery,
  GetUserInfoDetailsQueryVariables
>
export const GetUserPartnerConfigDocument = /*#__PURE__*/ gql`
  query GetUserPartnerConfig {
    GetUserInfo {
      id
      users {
        ...UserPartnerConfig
      }
    }
  }
  ${UserPartnerConfigFragmentDoc}
`

/**
 * __useGetUserPartnerConfigQuery__
 *
 * To run a query within a React component, call `useGetUserPartnerConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPartnerConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPartnerConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserPartnerConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserPartnerConfigQuery,
    GetUserPartnerConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetUserPartnerConfigQuery,
    GetUserPartnerConfigQueryVariables
  >(GetUserPartnerConfigDocument, options)
}
export function useGetUserPartnerConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserPartnerConfigQuery,
    GetUserPartnerConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetUserPartnerConfigQuery,
    GetUserPartnerConfigQueryVariables
  >(GetUserPartnerConfigDocument, options)
}
export type GetUserPartnerConfigQueryHookResult = ReturnType<
  typeof useGetUserPartnerConfigQuery
>
export type GetUserPartnerConfigLazyQueryHookResult = ReturnType<
  typeof useGetUserPartnerConfigLazyQuery
>
export type GetUserPartnerConfigQueryResult = Apollo.QueryResult<
  GetUserPartnerConfigQuery,
  GetUserPartnerConfigQueryVariables
>
export const CreateUserAndPartnerDocument = /*#__PURE__*/ gql`
  query CreateUserAndPartner {
    CreateUserAndPartner {
      userId
      partnerId
    }
  }
`

/**
 * __useCreateUserAndPartnerQuery__
 *
 * To run a query within a React component, call `useCreateUserAndPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateUserAndPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateUserAndPartnerQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateUserAndPartnerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CreateUserAndPartnerQuery,
    CreateUserAndPartnerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CreateUserAndPartnerQuery,
    CreateUserAndPartnerQueryVariables
  >(CreateUserAndPartnerDocument, options)
}
export function useCreateUserAndPartnerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CreateUserAndPartnerQuery,
    CreateUserAndPartnerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CreateUserAndPartnerQuery,
    CreateUserAndPartnerQueryVariables
  >(CreateUserAndPartnerDocument, options)
}
export type CreateUserAndPartnerQueryHookResult = ReturnType<
  typeof useCreateUserAndPartnerQuery
>
export type CreateUserAndPartnerLazyQueryHookResult = ReturnType<
  typeof useCreateUserAndPartnerLazyQuery
>
export type CreateUserAndPartnerQueryResult = Apollo.QueryResult<
  CreateUserAndPartnerQuery,
  CreateUserAndPartnerQueryVariables
>
export const PartnerUserConnectionDocument = /*#__PURE__*/ gql`
  query PartnerUserConnection(
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $orderBy: PartnerUserOrderBy
  ) {
    PartnerUserConnection(
      after: $after
      first: $first
      before: $before
      last: $last
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...PartnerUserList
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PartnerUserListFragmentDoc}
`

/**
 * __usePartnerUserConnectionQuery__
 *
 * To run a query within a React component, call `usePartnerUserConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerUserConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerUserConnectionQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePartnerUserConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PartnerUserConnectionQuery,
    PartnerUserConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PartnerUserConnectionQuery,
    PartnerUserConnectionQueryVariables
  >(PartnerUserConnectionDocument, options)
}
export function usePartnerUserConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PartnerUserConnectionQuery,
    PartnerUserConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PartnerUserConnectionQuery,
    PartnerUserConnectionQueryVariables
  >(PartnerUserConnectionDocument, options)
}
export type PartnerUserConnectionQueryHookResult = ReturnType<
  typeof usePartnerUserConnectionQuery
>
export type PartnerUserConnectionLazyQueryHookResult = ReturnType<
  typeof usePartnerUserConnectionLazyQuery
>
export type PartnerUserConnectionQueryResult = Apollo.QueryResult<
  PartnerUserConnectionQuery,
  PartnerUserConnectionQueryVariables
>
export const PartnerUpdateMyUserDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateMyUser($input: PartnerUpdateMyUserInput) {
    PartnerUpdateMyUser(input: $input) {
      id
      firstName
      lastName
      phone
      jobTitle
    }
  }
`
export type PartnerUpdateMyUserMutationFn = Apollo.MutationFunction<
  PartnerUpdateMyUserMutation,
  PartnerUpdateMyUserMutationVariables
>

/**
 * __usePartnerUpdateMyUserMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateMyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateMyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateMyUserMutation, { data, loading, error }] = usePartnerUpdateMyUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateMyUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateMyUserMutation,
    PartnerUpdateMyUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateMyUserMutation,
    PartnerUpdateMyUserMutationVariables
  >(PartnerUpdateMyUserDocument, options)
}
export type PartnerUpdateMyUserMutationHookResult = ReturnType<
  typeof usePartnerUpdateMyUserMutation
>
export type PartnerUpdateMyUserMutationResult =
  Apollo.MutationResult<PartnerUpdateMyUserMutation>
export type PartnerUpdateMyUserMutationOptions = Apollo.BaseMutationOptions<
  PartnerUpdateMyUserMutation,
  PartnerUpdateMyUserMutationVariables
>
export const PartnerInviteUserDocument = /*#__PURE__*/ gql`
  mutation PartnerInviteUser($input: PartnerInviteUserInput!) {
    PartnerInviteUser(input: $input) {
      ...PartnerUserList
    }
  }
  ${PartnerUserListFragmentDoc}
`
export type PartnerInviteUserMutationFn = Apollo.MutationFunction<
  PartnerInviteUserMutation,
  PartnerInviteUserMutationVariables
>

/**
 * __usePartnerInviteUserMutation__
 *
 * To run a mutation, you first call `usePartnerInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerInviteUserMutation, { data, loading, error }] = usePartnerInviteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerInviteUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerInviteUserMutation,
    PartnerInviteUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerInviteUserMutation,
    PartnerInviteUserMutationVariables
  >(PartnerInviteUserDocument, options)
}
export type PartnerInviteUserMutationHookResult = ReturnType<
  typeof usePartnerInviteUserMutation
>
export type PartnerInviteUserMutationResult =
  Apollo.MutationResult<PartnerInviteUserMutation>
export type PartnerInviteUserMutationOptions = Apollo.BaseMutationOptions<
  PartnerInviteUserMutation,
  PartnerInviteUserMutationVariables
>
export const PartnerUpdateUserDocument = /*#__PURE__*/ gql`
  mutation PartnerUpdateUser($input: PartnerUpdateUserInput) {
    PartnerUpdateUser(input: $input) {
      ...PartnerUserList
    }
  }
  ${PartnerUserListFragmentDoc}
`
export type PartnerUpdateUserMutationFn = Apollo.MutationFunction<
  PartnerUpdateUserMutation,
  PartnerUpdateUserMutationVariables
>

/**
 * __usePartnerUpdateUserMutation__
 *
 * To run a mutation, you first call `usePartnerUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerUpdateUserMutation, { data, loading, error }] = usePartnerUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnerUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerUpdateUserMutation,
    PartnerUpdateUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerUpdateUserMutation,
    PartnerUpdateUserMutationVariables
  >(PartnerUpdateUserDocument, options)
}
export type PartnerUpdateUserMutationHookResult = ReturnType<
  typeof usePartnerUpdateUserMutation
>
export type PartnerUpdateUserMutationResult =
  Apollo.MutationResult<PartnerUpdateUserMutation>
export type PartnerUpdateUserMutationOptions = Apollo.BaseMutationOptions<
  PartnerUpdateUserMutation,
  PartnerUpdateUserMutationVariables
>
export const PartnerDeleteUserDocument = /*#__PURE__*/ gql`
  mutation PartnerDeleteUser($id: ID!) {
    PartnerDeleteUser(id: $id)
  }
`
export type PartnerDeleteUserMutationFn = Apollo.MutationFunction<
  PartnerDeleteUserMutation,
  PartnerDeleteUserMutationVariables
>

/**
 * __usePartnerDeleteUserMutation__
 *
 * To run a mutation, you first call `usePartnerDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerDeleteUserMutation, { data, loading, error }] = usePartnerDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerDeleteUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PartnerDeleteUserMutation,
    PartnerDeleteUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PartnerDeleteUserMutation,
    PartnerDeleteUserMutationVariables
  >(PartnerDeleteUserDocument, options)
}
export type PartnerDeleteUserMutationHookResult = ReturnType<
  typeof usePartnerDeleteUserMutation
>
export type PartnerDeleteUserMutationResult =
  Apollo.MutationResult<PartnerDeleteUserMutation>
export type PartnerDeleteUserMutationOptions = Apollo.BaseMutationOptions<
  PartnerDeleteUserMutation,
  PartnerDeleteUserMutationVariables
>
export const GraphQLOperations = {
  Query: {
    GetAdyenDocumentTypes: 'GetAdyenDocumentTypes',
    GetAdyenRemediationActions: 'GetAdyenRemediationActions',
    GetAdyenHostedOnboardingLink: 'GetAdyenHostedOnboardingLink',
    GetAdyenPciForms: 'GetAdyenPciForms',
    GetAdyenTermsOfService: 'GetAdyenTermsOfService',
    GetAdyenOnboardingStatus: 'GetAdyenOnboardingStatus',
    PartnerApiKeyConnection: 'PartnerApiKeyConnection',
    OAuth2Url: 'OAuth2Url',
    PartnerListAutopayExcludedInvoices: 'PartnerListAutopayExcludedInvoices',
    FindAutopayRule: 'FindAutopayRule',
    PartnerGetCoveredInvoicesForRule: 'PartnerGetCoveredInvoicesForRule',
    PartnerGlobalAutopayRuleConnection: 'PartnerGlobalAutopayRuleConnection',
    PartnerCustomerAutopayRuleWithBankingAndCardConnection:
      'PartnerCustomerAutopayRuleWithBankingAndCardConnection',
    PartnerCustomerAutopayRuleConnection:
      'PartnerCustomerAutopayRuleConnection',
    PartnerCustomerTagsAutopayRuleConnection:
      'PartnerCustomerTagsAutopayRuleConnection',
    PartnerListCustomerRulesTotals: 'PartnerListCustomerRulesTotals',
    PartnerAutopayExcludedCustomerConnection:
      'PartnerAutopayExcludedCustomerConnection',
    PartnerAutopayExcludedCustomerListTotals:
      'PartnerAutopayExcludedCustomerListTotals',
    GetCustomerAutopayConfig: 'GetCustomerAutopayConfig',
    PartnerInvoiceBnplConnection: 'PartnerInvoiceBnplConnection',
    PartnerListBankingIntegrations: 'PartnerListBankingIntegrations',
    PartnerListCustomerBankingIntegrations:
      'PartnerListCustomerBankingIntegrations',
    PartnerGetInvoiceBulkCharges: 'PartnerGetInvoiceBulkCharges',
    FindOverdueInvoiceDetail: 'FindOverdueInvoiceDetail',
    FindOverdueInvoices: 'FindOverdueInvoices',
    PartnerCollectionConnection: 'PartnerCollectionConnection',
    FindCollectionDetail: 'FindCollectionDetail',
    PartnerCollectionTotals: 'PartnerCollectionTotals',
    PartnerGetFeeRates: 'PartnerGetFeeRates',
    PartnerListCards: 'PartnerListCards',
    PartnerListCustomerCards: 'PartnerListCustomerCards',
    PartnerGetCardFee: 'PartnerGetCardFee',
    PartnerGetCustomerCardFee: 'PartnerGetCustomerCardFee',
    PartnerListCustomerTags: 'PartnerListCustomerTags',
    PartnerCustomerWithInvoicesDataConnection:
      'PartnerCustomerWithInvoicesDataConnection',
    PartnerCustomerConnection: 'PartnerCustomerConnection',
    PartnerListCustomersTotals: 'PartnerListCustomersTotals',
    PartnerCustomerSearch: 'PartnerCustomerSearch',
    PartnerCustomerUserConnection: 'PartnerCustomerUserConnection',
    PartnerEmailActivityConnection: 'PartnerEmailActivityConnection',
    PartnerListEmailTemplates: 'PartnerListEmailTemplates',
    PartnerGetPartnerFeeConfig: 'PartnerGetPartnerFeeConfig',
    PartnerGetCustomPartnerFeeConfigs: 'PartnerGetCustomPartnerFeeConfigs',
    PartnerListCustomerFeeExceptions: 'PartnerListCustomerFeeExceptions',
    GetCustomerInsightsGraphs: 'GetCustomerInsightsGraphs',
    GetCustomerInsightsMetrics: 'GetCustomerInsightsMetrics',
    GetInsightOverviewMetrics: 'GetInsightOverviewMetrics',
    GetInsightOverviewGraphs: 'GetInsightOverviewGraphs',
    GetInvoicesInsightsMetrics: 'GetInvoicesInsightsMetrics',
    GetInvoicesInsightsARMetrics: 'GetInvoicesInsightsARMetrics',
    GetInvoicesInsightsGraphs: 'GetInvoicesInsightsGraphs',
    GetInvoicesInsightsARGraphs: 'GetInvoicesInsightsARGraphs',
    GetPaymentsInsightsMetrics: 'GetPaymentsInsightsMetrics',
    GetPaymentsInsightsGraphs: 'GetPaymentsInsightsGraphs',
    GetCollectionsInsightsMetrics: 'GetCollectionsInsightsMetrics',
    GetCollectionsInsightsGraphs: 'GetCollectionsInsightsGraphs',
    GetAutomationsInsightsMetrics: 'GetAutomationsInsightsMetrics',
    GetAutomationsInsightsGraphs: 'GetAutomationsInsightsGraphs',
    GetAutomationsLastMonthInsightsGraphs:
      'GetAutomationsLastMonthInsightsGraphs',
    PartnerAutotaskGetFilters: 'PartnerAutotaskGetFilters',
    PartnerContractTypeConnection: 'PartnerContractTypeConnection',
    PartnerAutotaskContractConnection: 'PartnerAutotaskContractConnection',
    PartnerConnectWiseGetConnection: 'PartnerConnectWiseGetConnection',
    PartnerConnectWiseGetFilters: 'PartnerConnectWiseGetFilters',
    PartnerAgreementTypeConnection: 'PartnerAgreementTypeConnection',
    PartnerConnectWiseBillingTermsConnection:
      'PartnerConnectWiseBillingTermsConnection',
    PartnerConnectWiseAgreementConnection:
      'PartnerConnectWiseAgreementConnection',
    PartnerContractSubtypeConnection: 'PartnerContractSubtypeConnection',
    PartnerListIntegrations: 'PartnerListIntegrations',
    PartnerListUnsyncedInvoices: 'PartnerListUnsyncedInvoices',
    PartnerGetUnsyncedInvoiceTotals: 'PartnerGetUnsyncedInvoiceTotals',
    PartnerGetAccountingSyncBatch: 'PartnerGetAccountingSyncBatch',
    PartnerListAccountingSyncBatches: 'PartnerListAccountingSyncBatches',
    PartnerListAccountingSyncJobs: 'PartnerListAccountingSyncJobs',
    PartnerGetAccountingPreferences: 'PartnerGetAccountingPreferences',
    PartnerQuickbooksConnectionURL: 'PartnerQuickbooksConnectionURL',
    PartnerQuickbooksAccountList: 'PartnerQuickbooksAccountList',
    PartnerQuickbooksAccountRetrieve: 'PartnerQuickbooksAccountRetrieve',
    PartnerQuickbooksConnectionRead: 'PartnerQuickbooksConnectionRead',
    PartnerRecurringTransactionConnection:
      'PartnerRecurringTransactionConnection',
    PartnerRutterAccountList: 'PartnerRutterAccountList',
    PartnerRutterAccountRead: 'PartnerRutterAccountRead',
    PartnerRutterConnectionRead: 'PartnerRutterConnectionRead',
    PartnerRutterPaymentTermsConnection: 'PartnerRutterPaymentTermsConnection',
    PartnerGetInvoiceLedgerMovements: 'PartnerGetInvoiceLedgerMovements',
    PartnerFindInvoice: 'PartnerFindInvoice',
    PartnerGetInvoicePdfLink: 'PartnerGetInvoicePdfLink',
    PartnerInvoiceListTotals: 'PartnerInvoiceListTotals',
    PartnerInvoiceSearch: 'PartnerInvoiceSearch',
    PartnerInvoiceConnection: 'PartnerInvoiceConnection',
    PartnerGetInvoicePreferences: 'PartnerGetInvoicePreferences',
    PartnerListInvoiceReminders: 'PartnerListInvoiceReminders',
    PartnerListInvoiceReminderExcludedCustomers:
      'PartnerListInvoiceReminderExcludedCustomers',
    PartnerListInvoiceSummaries: 'PartnerListInvoiceSummaries',
    PartnerListInvoiceSummaryExcludedCustomers:
      'PartnerListInvoiceSummaryExcludedCustomers',
    PartnerGetNotificationsEnabled: 'PartnerGetNotificationsEnabled',
    GetPartnerDocuments: 'GetPartnerDocuments',
    GetCompanyIndividuals: 'GetCompanyIndividuals',
    GetSupportPreferences: 'GetSupportPreferences',
    GetUserPartners: 'GetUserPartners',
    PartnerGetPartnerAutopayConfig: 'PartnerGetPartnerAutopayConfig',
    PartnerPaymentConnection: 'PartnerPaymentConnection',
    PartnerPaymentTotals: 'PartnerPaymentTotals',
    PartnerGetCustomerPaymentConfig: 'PartnerGetCustomerPaymentConfig',
    PartnerGetCustomersPaymentConfig: 'PartnerGetCustomersPaymentConfig',
    PartnerGetPaymentConfig: 'PartnerGetPaymentConfig',
    GetLogoUploadURL: 'GetLogoUploadURL',
    PartnerPayoutConnection: 'PartnerPayoutConnection',
    PartnerPayoutTotals: 'PartnerPayoutTotals',
    PartnerPayoutDetails: 'PartnerPayoutDetails',
    PartnerBreakdownListItemConnection: 'PartnerBreakdownListItemConnection',
    GetPayoutConfig: 'GetPayoutConfig',
    GetReferralPayoutConfig: 'GetReferralPayoutConfig',
    GetPayoutTimingConfig: 'GetPayoutTimingConfig',
    PartnerListPendingCustomerUsersTotals:
      'PartnerListPendingCustomerUsersTotals',
    PartnerPendingCustomerUserConnection:
      'PartnerPendingCustomerUserConnection',
    PartnerRecurringPaymentConnection: 'PartnerRecurringPaymentConnection',
    PartnerRecurringPaymentTotals: 'PartnerRecurringPaymentTotals',
    PartnerReferralGetQuarterlyEarningsData:
      'PartnerReferralGetQuarterlyEarningsData',
    PartnerReferralGetAvailableForPayoutData:
      'PartnerReferralGetAvailableForPayoutData',
    PartnerReferralGetTotalReferralFeesData:
      'PartnerReferralGetTotalReferralFeesData',
    PartnerReferralGetAvgQuarterlyFeesData:
      'PartnerReferralGetAvgQuarterlyFeesData',
    PartnerGetReferralLink: 'PartnerGetReferralLink',
    PartnerGetReferralPayoutByPayoutID: 'PartnerGetReferralPayoutByPayoutID',
    PartnerReferralConnection: 'PartnerReferralConnection',
    PartnerListActiveSubscriptions: 'PartnerListActiveSubscriptions',
    PartnerSubscriptionsPaymentsConnection:
      'PartnerSubscriptionsPaymentsConnection',
    PartnerListSubscriptionPaymentsTotals:
      'PartnerListSubscriptionPaymentsTotals',
    PartnerAccountingSyncConfigGet: 'PartnerAccountingSyncConfigGet',
    GetUserInfo: 'GetUserInfo',
    GetUserInfoDetails: 'GetUserInfoDetails',
    GetUserPartnerConfig: 'GetUserPartnerConfig',
    CreateUserAndPartner: 'CreateUserAndPartner',
    PartnerUserConnection: 'PartnerUserConnection'
  },
  Mutation: {
    SolveRemediationActionsByIDs: 'SolveRemediationActionsByIDs',
    SolveAdyenRemediationActions: 'SolveAdyenRemediationActions',
    UploadAdyenDocument: 'UploadAdyenDocument',
    StagingStartAdyenOnboarding: 'StagingStartAdyenOnboarding',
    PartnerCreateApiKey: 'PartnerCreateApiKey',
    PartnerUpdateApiKey: 'PartnerUpdateApiKey',
    PartnerRevokeApiKey: 'PartnerRevokeApiKey',
    OAuth2Exchange: 'OAuth2Exchange',
    OAuth2Refresh: 'OAuth2Refresh',
    PartnerAutopayExcludedInvoiceDelete: 'PartnerAutopayExcludedInvoiceDelete',
    PartnerAutopayExcludedInvoiceCreate: 'PartnerAutopayExcludedInvoiceCreate',
    PartnerAutopayExcludedInvoiceBatchCreate:
      'PartnerAutopayExcludedInvoiceBatchCreate',
    PartnerCreateAutopayRule: 'PartnerCreateAutopayRule',
    PartnerUpdateAutopayRule: 'PartnerUpdateAutopayRule',
    PartnerDeleteAutopayRule: 'PartnerDeleteAutopayRule',
    PartnerAutopayExcludedCustomerCreate:
      'PartnerAutopayExcludedCustomerCreate',
    PartnerAutopayExcludedCustomerUpdate:
      'PartnerAutopayExcludedCustomerUpdate',
    PartnerAutopayExcludedCustomerDelete:
      'PartnerAutopayExcludedCustomerDelete',
    SetCustomerAutopayConfig: 'SetCustomerAutopayConfig',
    BNPLOfferConfirmByToken: 'BNPLOfferConfirmByToken',
    PartnerBNPLOfferConfirm: 'PartnerBNPLOfferConfirm',
    PartnerChangeReferralPayoutBankingAccount:
      'PartnerChangeReferralPayoutBankingAccount',
    PartnerArchiveAccount: 'PartnerArchiveAccount',
    PartnerAddManualBankingConnection: 'PartnerAddManualBankingConnection',
    PartnerAddCustomerBankingConnection: 'PartnerAddCustomerBankingConnection',
    PartnerChangeDefaultPayoutBankingAccount:
      'PartnerChangeDefaultPayoutBankingAccount',
    PartnerInvoiceBulkChargeOnDate: 'PartnerInvoiceBulkChargeOnDate',
    PartnerInvoiceBulkChargeOnDueDate: 'PartnerInvoiceBulkChargeOnDueDate',
    PartnerCreateCollection: 'PartnerCreateCollection',
    PartnerCancelCollection: 'PartnerCancelCollection',
    PartnerCreateCard: 'PartnerCreateCard',
    PartnerCreateCustomerCard: 'PartnerCreateCustomerCard',
    PartnerDeleteCard: 'PartnerDeleteCard',
    PartnerDeleteCustomerCard: 'PartnerDeleteCustomerCard',
    PartnerModernBancGenerateSerializedToken:
      'PartnerModernBancGenerateSerializedToken',
    PartnerBatchTagCustomers: 'PartnerBatchTagCustomers',
    PartnerDeleteCustomerTag: 'PartnerDeleteCustomerTag',
    PartnerUpdateCustomerTag: 'PartnerUpdateCustomerTag',
    PartnerTagCustomer: 'PartnerTagCustomer',
    PartnerUntagCustomer: 'PartnerUntagCustomer',
    PartnerCreateCustomerTag: 'PartnerCreateCustomerTag',
    PartnerArchiveCustomer: 'PartnerArchiveCustomer',
    PartnerUnarchiveCustomer: 'PartnerUnarchiveCustomer',
    PartnerCreateCustomer: 'PartnerCreateCustomer',
    UpdateCustomer: 'UpdateCustomer',
    PartnerBulkToggleArchiveCustomers: 'PartnerBulkToggleArchiveCustomers',
    PartnerArchiveCustomerAccount: 'PartnerArchiveCustomerAccount',
    PartnerCreateCustomerUser: 'PartnerCreateCustomerUser',
    PartnerDeleteCustomerUser: 'PartnerDeleteCustomerUser',
    UpdateCustomerUser: 'UpdateCustomerUser',
    PartnerCreateEmailTemplate: 'PartnerCreateEmailTemplate',
    PartnerUpdateEmailTemplate: 'PartnerUpdateEmailTemplate',
    PartnerDeleteEmailTemplate: 'PartnerDeleteEmailTemplate',
    PartnerToggleEmailTemplateFavorite: 'PartnerToggleEmailTemplateFavorite',
    PartnerChangeCustomPartnerFeeConfig: 'PartnerChangeCustomPartnerFeeConfig',
    PartnerChangeCustomerFeeConfig: 'PartnerChangeCustomerFeeConfig',
    PartnerChangePartnerFeeConfig: 'PartnerChangePartnerFeeConfig',
    PartnerChangeBulkCustomerFeeConfig: 'PartnerChangeBulkCustomerFeeConfig',
    PartnerAutotaskConnectionCreate: 'PartnerAutotaskConnectionCreate',
    PartnerAutotaskConnectionUpdate: 'PartnerAutotaskConnectionUpdate',
    PartnerConnectWiseConnectionCreate: 'PartnerConnectWiseConnectionCreate',
    PartnerConnectWiseConnectionUpdate: 'PartnerConnectWiseConnectionUpdate',
    PartnerDatagateConnectionCreate: 'PartnerDatagateConnectionCreate',
    PartnerHaloPSAConnectionCreate: 'PartnerHaloPSAConnectionCreate',
    PartnerIntegrationDisconnect: 'PartnerIntegrationDisconnect',
    PartnerIntegrationSync: 'PartnerIntegrationSync',
    PartnerAccountingSyncBatchCreate: 'PartnerAccountingSyncBatchCreate',
    PartnerSecondaryIntegrationDelete: 'PartnerSecondaryIntegrationDelete',
    PartnerAccountingPreferencesUpdate: 'PartnerAccountingPreferencesUpdate',
    PartnerQuickbooksAccountUpdate: 'PartnerQuickbooksAccountUpdate',
    PartnerQuickbooksConnectionCreate: 'PartnerQuickbooksConnectionCreate',
    PartnerQuickbooksConnectionUpdate: 'PartnerQuickbooksConnectionUpdate',
    PartnerRutterConnectionCreate: 'PartnerRutterConnectionCreate',
    PartnerRutterAccountUpsert: 'PartnerRutterAccountUpsert',
    PartnerRutterConnectionUpdate: 'PartnerRutterConnectionUpdate',
    PartnerRutterAccountUnset: 'PartnerRutterAccountUnset',
    PartnerRutterAccountUpsertMany: 'PartnerRutterAccountUpsertMany',
    PartnerSuperopsConnectionCreate: 'PartnerSuperopsConnectionCreate',
    PartnerInvoiceArchive: 'PartnerInvoiceArchive',
    PartnerInvoiceUnarchive: 'PartnerInvoiceUnarchive',
    PartnerInvoiceCreate: 'PartnerInvoiceCreate',
    PartnerInvoicePaidUpdate: 'PartnerInvoicePaidUpdate',
    PartnerInvoiceRemind: 'PartnerInvoiceRemind',
    PartnerPayInvoice: 'PartnerPayInvoice',
    PartnerUpsertInvoicePreferences: 'PartnerUpsertInvoicePreferences',
    PartnerUpdateReminderTemplate: 'PartnerUpdateReminderTemplate',
    PartnerCreateInvoiceReminder: 'PartnerCreateInvoiceReminder',
    PartnerDeleteInvoiceReminder: 'PartnerDeleteInvoiceReminder',
    PartnerCreateInvoiceReminderExcludedCustomer:
      'PartnerCreateInvoiceReminderExcludedCustomer',
    PartnerUpdateInvoiceReminderExcludedCustomer:
      'PartnerUpdateInvoiceReminderExcludedCustomer',
    PartnerDeleteInvoiceReminderExcludedCustomer:
      'PartnerDeleteInvoiceReminderExcludedCustomer',
    PartnerSendInvoiceReminderPreview: 'PartnerSendInvoiceReminderPreview',
    PartnerUpdateSummaryTemplate: 'PartnerUpdateSummaryTemplate',
    PartnerCreateInvoiceSummary: 'PartnerCreateInvoiceSummary',
    PartnerDeleteInvoiceSummary: 'PartnerDeleteInvoiceSummary',
    PartnerCreateInvoiceSummaryExcludedCustomer:
      'PartnerCreateInvoiceSummaryExcludedCustomer',
    PartnerUpdateInvoiceSummaryExcludedCustomer:
      'PartnerUpdateInvoiceSummaryExcludedCustomer',
    PartnerDeleteInvoiceSummaryExcludedCustomer:
      'PartnerDeleteInvoiceSummaryExcludedCustomer',
    PartnerSendInvoiceSummaryPreview: 'PartnerSendInvoiceSummaryPreview',
    PartnerUpdateNotificationsEnabled: 'PartnerUpdateNotificationsEnabled',
    PartnerUpdateInformation: 'PartnerUpdateInformation',
    ActivatePartnerPaymentsPortal: 'ActivatePartnerPaymentsPortal',
    CreateCompanyIndividual: 'CreateCompanyIndividual',
    UpdateCompanyIndividual: 'UpdateCompanyIndividual',
    DeleteCompanyIndividual: 'DeleteCompanyIndividual',
    UploadPartnerDocument: 'UploadPartnerDocument',
    UpsertSupportPreferences: 'UpsertSupportPreferences',
    PartnerFinishOnboarding: 'PartnerFinishOnboarding',
    PartnerUpdateDetails: 'PartnerUpdateDetails',
    PartnerUpdateAddress: 'PartnerUpdateAddress',
    PartnerTogglePaymentsPortalCustomInvoices:
      'PartnerTogglePaymentsPortalCustomInvoices',
    PartnerToggleRequiresMFA: 'PartnerToggleRequiresMFA',
    PartnerUpdateName: 'PartnerUpdateName',
    PartnerChangePartnerAutopayConfig: 'PartnerChangePartnerAutopayConfig',
    PartnerCancelScheduledPayment: 'PartnerCancelScheduledPayment',
    PartnerReschedulePayment: 'PartnerReschedulePayment',
    PartnerChangePaymentConfig: 'PartnerChangePaymentConfig',
    PartnerChangeCustomerPaymentConfig: 'PartnerChangeCustomerPaymentConfig',
    PartnerUpdatePaymentsPortalMethods: 'PartnerUpdatePaymentsPortalMethods',
    PartnerUpdatePaymentsPortalCustomization:
      'PartnerUpdatePaymentsPortalCustomization',
    StagingEnablePartnerPaymentsPortal: 'StagingEnablePartnerPaymentsPortal',
    UpdatePayoutTimingConfig: 'UpdatePayoutTimingConfig',
    PartnerRejectPendingCustomerUser: 'PartnerRejectPendingCustomerUser',
    PartnerApprovePendingCustomerUser: 'PartnerApprovePendingCustomerUser',
    PartnerLinkPendingCustomerUser: 'PartnerLinkPendingCustomerUser',
    PartnerUnlinkPendingCustomerUser: 'PartnerUnlinkPendingCustomerUser',
    RecurringPaymentCreate: 'RecurringPaymentCreate',
    RecurringPaymentDeactivate: 'RecurringPaymentDeactivate',
    RecurringPaymentUpdate: 'RecurringPaymentUpdate',
    PartnerCreateReferral: 'PartnerCreateReferral',
    PartnerUpdateReferral: 'PartnerUpdateReferral',
    PartnerSendReferral: 'PartnerSendReferral',
    CreateRefund: 'CreateRefund',
    PartnerSendReport: 'PartnerSendReport',
    PartnerCancelSubscription: 'PartnerCancelSubscription',
    PartnerAccountingSyncConfigCreate: 'PartnerAccountingSyncConfigCreate',
    PartnerAccountingSyncConfigUpdate: 'PartnerAccountingSyncConfigUpdate',
    PartnerUpdateMyUser: 'PartnerUpdateMyUser',
    PartnerInviteUser: 'PartnerInviteUser',
    PartnerUpdateUser: 'PartnerUpdateUser',
    PartnerDeleteUser: 'PartnerDeleteUser'
  },
  Fragment: {
    ApiKey: 'ApiKey',
    Token: 'Token',
    AutopayExcludedList: 'AutopayExcludedList',
    AutopayRulesWithBankingAndCard: 'AutopayRulesWithBankingAndCard',
    AutopayRulesWithCustomerTags: 'AutopayRulesWithCustomerTags',
    AutopayRules: 'AutopayRules',
    CustomerAutopayConfig: 'CustomerAutopayConfig',
    InvoiceCovered: 'InvoiceCovered',
    FindAutopayRule: 'FindAutopayRule',
    PartnerCustomerBNPL: 'PartnerCustomerBNPL',
    PartnerCustomerOffer: 'PartnerCustomerOffer',
    PartnerCustomerSchedule: 'PartnerCustomerSchedule',
    PartnerCustomerInstallment: 'PartnerCustomerInstallment',
    Bank: 'Bank',
    BankAccount: 'BankAccount',
    PartnerInvoiceBulkCharge: 'PartnerInvoiceBulkCharge',
    PaymentRequest: 'PaymentRequest',
    PartnerCollectionInvoice: 'PartnerCollectionInvoice',
    UpfrontFeePayment: 'UpfrontFeePayment',
    PartnerCollectionListing: 'PartnerCollectionListing',
    PartnerCollectionDetail: 'PartnerCollectionDetail',
    PartnerOverdueInvoice: 'PartnerOverdueInvoice',
    CreditCard: 'CreditCard',
    PartnerCustomerAddress: 'PartnerCustomerAddress',
    PartnerCustomerBasic: 'PartnerCustomerBasic',
    PartnerCustomer: 'PartnerCustomer',
    PartnerCustomerListWithInvoicesData: 'PartnerCustomerListWithInvoicesData',
    PartnerCustomerList: 'PartnerCustomerList',
    PartnerCustomerSearch: 'PartnerCustomerSearch',
    PartnerListCustomerUsers: 'PartnerListCustomerUsers',
    PartnerCustomerUserCreation: 'PartnerCustomerUserCreation',
    PartnerEmailActivity: 'PartnerEmailActivity',
    EmailTemplate: 'EmailTemplate',
    PartnerCustomerFeeConfig: 'PartnerCustomerFeeConfig',
    BucketCountData: 'BucketCountData',
    BucketAmountData: 'BucketAmountData',
    DataPoint: 'DataPoint',
    InvoiceCountMonth: 'InvoiceCountMonth',
    InvoiceAmountMonth: 'InvoiceAmountMonth',
    CWQueryFilters: 'CWQueryFilters',
    PartnerIntegration: 'PartnerIntegration',
    PartnerUnsyncedInvoice: 'PartnerUnsyncedInvoice',
    AccountingSyncBatch: 'AccountingSyncBatch',
    QuickbooksAccount: 'QuickbooksAccount',
    RutterAccountList: 'RutterAccountList',
    PartnerInvoiceSearch: 'PartnerInvoiceSearch',
    PartnerInvoiceEmailActivity: 'PartnerInvoiceEmailActivity',
    PartnerInvoiceBasic: 'PartnerInvoiceBasic',
    PartnerInvoiceListing: 'PartnerInvoiceListing',
    PartnerInvoice: 'PartnerInvoice',
    PartnerInvoiceOffer: 'PartnerInvoiceOffer',
    PartnerInvoiceReminder: 'PartnerInvoiceReminder',
    PartnerInvoiceReminderExcludedCustomer:
      'PartnerInvoiceReminderExcludedCustomer',
    PartnerInvoiceSummary: 'PartnerInvoiceSummary',
    PartnerInvoiceSummaryExcludedCustomer:
      'PartnerInvoiceSummaryExcludedCustomer',
    CompanyIndividual: 'CompanyIndividual',
    PartnerBase: 'PartnerBase',
    PartnerDetails: 'PartnerDetails',
    PartnerConfig: 'PartnerConfig',
    PartnerAddressDetails: 'PartnerAddressDetails',
    SupportPreferences: 'SupportPreferences',
    PartnerPayment: 'PartnerPayment',
    PaymentConfig: 'PaymentConfig',
    CustomerPaymentMethod: 'CustomerPaymentMethod',
    CustomersPaymentMethod: 'CustomersPaymentMethod',
    PayoutBreakdownTotals: 'PayoutBreakdownTotals',
    PartnerPayoutDetails: 'PartnerPayoutDetails',
    Transaction: 'Transaction',
    PartnerPayout: 'PartnerPayout',
    PartnerBreakdownListItem: 'PartnerBreakdownListItem',
    PartnerListPendingCustomerUser: 'PartnerListPendingCustomerUser',
    PartnerListPendingCustomer: 'PartnerListPendingCustomer',
    PartnerRecurringPayment: 'PartnerRecurringPayment',
    GetReferralDataReply: 'GetReferralDataReply',
    Referral: 'Referral',
    ReferralPayout: 'ReferralPayout',
    ReferralBonus: 'ReferralBonus',
    SubscriptionPayment: 'SubscriptionPayment',
    PartnerSubscription: 'PartnerSubscription',
    PartnerSubscriptionPaymentBasic: 'PartnerSubscriptionPaymentBasic',
    PartnerUserList: 'PartnerUserList',
    BasicUserInfo: 'BasicUserInfo',
    BasicPartnerUserInfo: 'BasicPartnerUserInfo',
    PartnerUserConfigDetails: 'PartnerUserConfigDetails',
    PartnerUserInfoDetails: 'PartnerUserInfoDetails',
    PartnerAddressInfo: 'PartnerAddressInfo',
    UserInfo: 'UserInfo',
    UserPartnerConfig: 'UserPartnerConfig',
    UserInfoDetails: 'UserInfoDetails',
    PartnerBaseUser: 'PartnerBaseUser',
    PartnerListUser: 'PartnerListUser'
  }
}
